var CustomDataChart_WSJ_0_8_18 =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(23);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAX_4U_WIDTH = exports.MAX_4U_WIDTH = 359;
	var MAX_NARROW_WIDTH_PRINT = exports.MAX_NARROW_WIDTH_PRINT = 114;
	
	var LONG = exports.LONG = 'long';
	var SHORT = exports.SHORT = 'short';
	
	var REGEXP_QUARTER = exports.REGEXP_QUARTER = /^([1-4]Q|[1-2]H)?\s*(FY)?['|\u2019]?(\d{2,4})/i;
	var REGEXP_Q_ONLY = exports.REGEXP_Q_ONLY = /^([1-4]Q|[1-2]H)/i;
	
	var REGEXP_MDY = exports.REGEXP_MDY = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})\b/;
	var REGEXP_MDY_FRED = exports.REGEXP_MDY_FRED = /^(\d{4})-(\d{2})-(\d{2})\b/;
	var REGEXP_MD = exports.REGEXP_MD = /^(\d{1,2})\/(\d{1,2})\b/;
	var REGEXP_MY = exports.REGEXP_MY = /^(\d{1,2})\/(\d{3,4})\b/;
	var REGEXP_Y = exports.REGEXP_Y = /^(\d{4})\b/;
	var REGEXP_TIME = exports.REGEXP_TIME = /\b(\d{1,2}):(\d{1,2})(:\d{1,2})?(\s?[a|p]\.+m\.+?)?(\s[a-z]{2,3})?$/i;
	
	var MONTHS = exports.MONTHS = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
	var MONTHS_SHORT = exports.MONTHS_SHORT = 'JFMAMJJASOND';
	
	// Because &nbsp; does not work inside SVG.
	var NBSP = exports.NBSP = '<span style="color: rgba(255,255,255,0);" class="space">.</span>';
	
	var APOSTROPHE = exports.APOSTROPHE = '’';
	
	var ANNOTATIONS_SPACE = exports.ANNOTATIONS_SPACE = 4;
	var ANNOTATIONS_SPACE_PRINT = exports.ANNOTATIONS_SPACE_PRINT = 2;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeChild = removeChild;
	function removeChild(el, parentEl) {
	  parentEl = parentEl || el.parentElement;
	  if (parentEl) {
	    parentEl.removeChild(el);
	  }
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.decimals = decimals;
	exports.commas = commas;
	exports.getDivisor = getDivisor;
	exports.applyFull = applyFull;
	function decimals(value, props) {
	  var skipZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var fd = getMaxDecimalValue(props.forceDecimals);
	  var md = getMaxDecimalValue(props.maxDecimals);
	  value = +value;
	  if (fd > -1) {
	    value = value.toFixed(fd);
	    if (md > -1 && md < fd) {
	      var fDotIndex = value.indexOf('.');
	      value = (+value).toFixed(md);
	    }
	    return value;
	  } else if (md > -1) {
	    value = (+value).toFixed(md);
	    while (value.substring(value.length - 1) === '0') {
	      value = value.substr(0, value.length - 1);
	      if (value.substring(value.length - 1) === '.') {
	        value = value.substr(0, value.length - 1);
	        break;
	      }
	    }
	  }
	  return value + '';
	}
	
	function getMaxDecimalValue(value) {
	  if (typeof value === 'string' && value) {
	    return +value;
	  } else if (typeof value === 'number' && !isNaN(value)) {
	    return value;
	  }
	  return -1;
	}
	
	function applyMaxDecimals(value, md) {
	  var dotIndex = value.indexOf('.');
	  if (dotIndex !== -1) {
	    var decs = value.length - dotIndex - 1;
	    value = (+value).toFixed(md);
	  }
	  return value;
	}
	
	function commas(value) {
	  var commas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  value += '';
	  if (commas) {
	    var dotIndex = value.indexOf('.');
	    if (dotIndex === -1) {
	      dotIndex = value.length;
	    }
	    value = [value.substr(0, dotIndex).replace(/\B(?=(\d{3})+(?!\d))/g, ','), value.substr(dotIndex)].join('');
	  }
	  return value;
	}
	
	// Returns a useful number that corresponds to a divisor string.
	function getDivisor(unit) {
	  switch (unit) {
	    case 'hundreds':
	      return 100;
	    case 'thousands':
	      return 1000;
	    case 'millions':
	      return 1000000;
	    case 'billions':
	      return 1000000000;
	    case 'trillions':
	      return 1000000000000;
	  }
	  return 1;
	}
	
	function applyFull(value, props) {
	  var isPie = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var skipZero = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var tooltipOrAnnotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  if (tooltipOrAnnotation) {
	    var splitDecimals = value.toString().split('.');
	    splitDecimals = splitDecimals.length > 1 ? splitDecimals[1].length : 0;
	    if (Number(splitDecimals) >= 3 && props.prefix === '') {
	      props.forceDecimals = '3';
	    }
	    if (props.prefix !== '') {
	      props.forceDecimals = splitDecimals > 0 ? '2' : '0';
	    } else {
	      props.forceDecimals = splitDecimals;
	    }
	    props.maxDecimals = '3';
	  }
	  value = decimals(value, props);
	  value = commas(value, props.commas);
	  if (isPie) {
	    value += '%';
	  } else {
	    if (value.charAt(0) === '-') {
	      value = props.prefix !== undefined ? '-' + props.prefix + value.substr(1) : '' + value.substr(1);
	    } else {
	      value = props.prefix !== undefined ? '' + props.prefix + value : '' + value;
	    }
	    value += props.suffix;
	  }
	  return value;
	}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.read = read;
	exports.write = write;
	var regExpD = /(M|L|(\-?\d+\.?\d*))/gi;
	var regExpTranslate = /(.*)(translate\()(\-?\d+\.?\d*),(\-?\d+\.?\d*)(.*)/;
	var regExpScale = /(.*)(scale\()(\-?\d+\.?\d*),(\-?\d+\.?\d*)(.*)/;
	
	function read(el, prop, value) {
	  var match = null;
	  switch (prop) {
	    case 'd':
	      match = (value || getD(el)).match(regExpD);
	      return match ? formatDMatch(match) : null;
	    case 'translate':
	      match = (value || getTransform(el)).match(regExpTranslate);
	      return match ? [+match[3], +match[4]] : null;
	    case 'scale':
	      match = (value || getTransform(el)).match(regExpScale);
	      return match ? [+match[3], +match[4]] : null;
	    default:
	      return el;
	  }
	}
	
	function write(el, prop) {
	  switch (prop) {
	    case 'd':
	      writeD.apply(this, arguments);
	      break;
	    case 'translate':
	      writeTranslate.apply(this, arguments);
	      break;
	    case 'scale':
	      writeScale.apply(this, arguments);
	      break;
	  }
	  return el;
	}
	
	function writeD(el) {
	  var d = [];
	  for (var i = 2; i < arguments.length; i++) {
	    d.push(i === 2 ? 'M' : 'L');
	    d.push(arguments[i][0]);
	    d.push(arguments[i][1]);
	  }
	  el.setAttribute('d', d.join(' '));
	}
	
	function writeTranslate(el) {
	  var oldTransform = el.getAttribute('transform');
	  var newTransform = null;
	  var match = oldTransform ? oldTransform.match(regExpTranslate) : null;
	  if (match) {
	    newTransform = [match[1], match[2], Math.round(typeof arguments[2] === 'number' ? arguments[2] : +match[3]), ',', Math.round(typeof arguments[3] === 'number' ? arguments[3] : +match[4]), match[5]].join('');
	  } else {
	    newTransform = [oldTransform ? oldTransform + ' ' : '', 'translate(', Math.round(typeof arguments[2] === 'number' ? arguments[2] : 0), ',', Math.round(typeof arguments[3] === 'number' ? arguments[3] : 0), ')'].join('');
	  }
	  setTimeout(function () {
	    // Firefox bug(?). This was not setting without this timeout.
	    el.setAttribute('transform', newTransform);
	  }, 1);
	  el.setAttribute('transform', newTransform);
	}
	
	function writeScale(el) {
	  var oldTransform = el.getAttribute('transform');
	  var newTransform = null;
	  var match = oldTransform ? oldTransform.match(regExpScale) : null;
	  if (match) {
	    newTransform = [match[1], match[2], typeof arguments[2] === 'number' ? arguments[2] : match[3], ',', typeof arguments[3] === 'number' ? arguments[3] : match[4], match[5]].join('');
	  } else {
	    newTransform = [oldTransform ? oldTransform + ' ' : '', 'scale(', typeof arguments[2] === 'number' ? arguments[2] : 0, ',', typeof arguments[3] === 'number' ? arguments[3] : 0, ')'].join('');
	  }
	  el.setAttribute('transform', newTransform);
	}
	
	function formatDMatch(match) {
	  var points = [];
	  var pt = [];
	  match.forEach(function (m) {
	    if (m !== 'M' && m !== 'L') {
	      pt.push(+m);
	      if (pt.length >= 2) {
	        points.push([pt[0], pt[1]]);
	        pt = [];
	      }
	    }
	  });
	  return points;
	}
	
	function getD(el) {
	  return el.getAttribute('d') || '';
	}
	
	function getTransform(el) {
	  return el.getAttribute('transform') || '';
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripZeroes = stripZeroes;
	exports.addZeroes = addZeroes;
	// Utility to transform '002' to '2'.
	function stripZeroes(value) {
	  value += '';
	  while (value[0] === '0') {
	    value = value.substr(1);
	  }
	  return value;
	}
	
	// Utility to transform '2' to '002'.
	function addZeroes(value, len) {
	  value += '';
	  while (value.length > len) {
	    if (value.charAt(0) === '0') {
	      value = value.substr(1);
	    } else {
	      break;
	    }
	  }
	  while (value.length < len) {
	    value = '0' + value;
	  }
	  return value;
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderInvalidatedColors = renderInvalidatedColors;
	// TODO: Check if this can be re-enabled with newer version of Highcharts.
	function renderInvalidatedColors(rendered, invalidated) {
	  // This is no longer applied because of issues with hover states not being
	  // updated. Instead, on color change, entire chart is re-rendered.
	  if (false) {
	    // const colors = (function (invalidated) {
	    //   return invalidated.filter(item => {
	    //     return item.indexOf('chart/colors') === 0;
	    //   });
	    // })(invalidated);
	    //
	    // const updatePointColor = function (dataPoint, color) {
	    //   const el = (dataPoint && dataPoint.graphic) ? dataPoint.graphic.element : null;
	    //   if (el) {
	    //     el.setAttribute('fill', color);
	    //   }
	    // };
	    //
	    // const updateLegendColor = function (render, index, color) {
	    //   const items = render.container.querySelectorAll('.highcharts-legend-item');
	    //   if (items && items.length) {
	    //     const text = items[index].querySelector('text');
	    //     text.style.color = text.style.fill = color;
	    //   }
	    // }
	    //
	    // if (colors.length) {
	    //   colors.forEach(item => {
	    //     const bits = item.split('/');
	    //     const series = +bits[2];
	    //     const point = bits[3];
	    //     const color = bits[4];
	    //     const chartSeries = rendered.inner.series[series];
	    //     let dataPoint = null;
	    //     let el = null;
	    //
	    //     if (chartSeries) {
	    //       // if (point.indexOf('#') === 0) {
	    //         // updateLegendColor(rendered.inner, series, point);
	    //         // Color for entire series.
	    //         // chartSeries.color = point;
	    //         // Setting render to true re-renders *everything* while false makes
	    //         // the lines and legend vanish (if it supposedly does not re-render,
	    //         // then like wtf?).
	    //         // chartSeries.update({ color: point }, true);
	    //
	    //       if (chartSeries.graph) {
	    //         // Line charts.
	    //         chartSeries.graph.element.setAttribute('stroke', color);
	    //       } else {
	    //         // Bar, column, pie charts.
	    //         if (point === '*') {
	    //           chartSeries.data.forEach(dataPoint => {
	    //             updatePointColor(dataPoint, color);
	    //           });
	    //         } else {
	    //           //originalIndex
	    //           let ptIndex = +point;
	    //           if (rendered.inner.options.chart.type === 'pie') {
	    //             // Find the correct index if the data has been optimized.
	    //             for (let i = 0; i < chartSeries.data.length; i++) {
	    //               if (!chartSeries.data[i].hasOwnProperty('originalIndex')) {
	    //                 break;
	    //               }
	    //               if (chartSeries.data[i].originalIndex === ptIndex) {
	    //                 ptIndex = i;
	    //                 break;
	    //               }
	    //             }
	    //           }
	    //           dataPoint = chartSeries ? chartSeries.data[ptIndex] : null;
	    //           updatePointColor(dataPoint, color);
	    //         }
	    //       }
	    //     }
	    //   });
	    // }
	  }
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _zero = __webpack_require__(5);
	
	var _constants = __webpack_require__(1);
	
	var _dateutils = __webpack_require__(10);
	
	var _quarterly = __webpack_require__(22);
	
	var quarterly = _interopRequireWildcard(_quarterly);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// let DEBUG = false;
	
	/**
	 * Converts/parses an array of category strings into objects with date and
	 * time properties.
	 * TODO: explains @params
	 * @returns {datetimeTemplate[]}
	 */
	function parse(categories, options) {
	  var dates = [];
	  var timezone = null;
	  var category0 = categories[0] + '';
	  var isQuarterlyString = !!category0.match(_constants.REGEXP_Q_ONLY);
	  categories.forEach(function (category, index) {
	    dates[index] = components(category, timezone, options, isQuarterlyString);
	    timezone = dates[index].z;
	  });
	
	  if (options) {
	    dates = options.fiscalYears ? quarterly.makeFiscalYears(dates) : quarterly.removeFiscalYears(dates);
	    dates = options.quarterlyResults ? quarterly.makeQuarterly(dates) : quarterly.removeQuarterly(dates);
	  }
	
	  dates = quarterly.normalize(dates);
	  dates = generateValues(dates);
	  // dates = sortDates(dates);
	  dates = removeExtraneousComponents(dates);
	  return dates;
	}
	
	/**
	 * Breaks a single category value into an object with date/time components.
	 */
	/**
	 * Datetime is a module with methods that parse date strings into discrete
	 * components (years, months, hours, etc).
	 * TODO: Write unit tests.
	 */
	function components(value, timezone, options, isQuarterlyString) {
	  value += '';
	  var result = datetimeTemplate();
	  result = componentsDate(value, result, options, isQuarterlyString);
	  result = componentsTime(value, result, timezone);
	  return result;
	}
	
	/**
	 * @private
	 * For use with components().
	 */
	function componentsDate(value, result, options) {
	  var isQuarterlyString = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  var match = null;
	  if (isQuarterlyString) {
	    match = value.match(_constants.REGEXP_QUARTER);
	    match = match || value.match(_constants.REGEXP_Q_ONLY) || [];
	    result.quarter = (0, _dateutils.getQuarter)(match[1]);
	    result.half = (0, _dateutils.getHalf)(match[1]);
	    result.month = (0, _dateutils.quarterToMonth)(match[1]);
	    result.date = (0, _dateutils.quarterToDate)(result.month);
	    result.fiscalYear = !!match[2];
	    result.year = match[3] ? +match[3] : undefined;
	  } else if (match = value.match(_constants.REGEXP_MDY)) {
	    writeDateMonth(result, match, options.reverseDateMonth);
	    result.year = +(0, _dateutils.fullYear)(match[3]);
	  } else if (match = value.match(_constants.REGEXP_MDY_FRED)) {
	    result.year = +match[1];
	    result.month = Math.max(0, +match[2] - 1);
	    result.date = +match[3];
	  } else if (match = value.match(_constants.REGEXP_MD)) {
	    writeDateMonth(result, match, options.reverseDateMonth);
	  } else if (match = value.match(_constants.REGEXP_MY)) {
	    result.month = +match[1] - 1;
	    result.year = +(0, _dateutils.fullYear)(match[2]);
	  } else if (match = value.match(_constants.REGEXP_Y)) {
	    result.year = +(0, _dateutils.fullYear)(match[1]);
	  }
	  return result;
	}
	
	function writeDateMonth(result, match, reverseDateMonth) {
	  if (reverseDateMonth) {
	    result.month = +match[2] - 1;
	    result.date = +match[1];
	  } else {
	    result.month = +match[1] - 1;
	    result.date = +match[2];
	  }
	}
	
	/**
	 * @private
	 * For use with components().
	 */
	function componentsTime(value, result) {
	  var timezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	  var match = value.match(_constants.REGEXP_TIME);
	  if (match) {
	    // Capture time values.
	    result.hour = +match[1];
	    result.minute = +match[2];
	    result.second = match[3] ? +match[3].substr(1) : undefined;
	    result.a = match[4] ? match[4].replace(/^\s+/, '').substr(0, 1).toLowerCase() : undefined;
	    result.z = match[5] ? match[5].substr(1) : timezone;
	    // Convert to 24-hour clock.
	    if (!result.a) {
	      result.a = result.hour < 12 ? 'a' : 'p';
	    }
	    result.hour %= 12;
	    if (result.a === 'p') {
	      result.hour += 12;
	    }
	  }
	  return result;
	}
	
	/**
	 * @param {datetimeTemplate[]} dates
	 * @param {string} prop
	 * @return {boolean} true if all dates have a value for prop.
	 */
	function allHave(dates, prop) {
	  return dates.length !== 0 && !dates.some(function (date) {
	    return prop === 'fiscalYear' && !date.fiscalYear || date[prop] === undefined;
	  });
	}
	
	/**
	 * @param {datetimeTemplate[]} dates
	 * @returns {boolea} true if all date objects represent valid dates.
	 */
	function allValidDates(dates) {
	  return !dates.some(function (d) {
	    return d.second === undefined && d.minute === undefined && d.hour === undefined && d.date === undefined && d.month === undefined && d.year === undefined;
	  });
	}
	
	/**
	 * @param {datetimeTemplate[]} dates
	 * @returns {object} with true/false for each date/time property depending
	 *   on whether all dates have a value for each property.
	 */
	function all(dates) {
	  var obj = datetimeTemplate();
	  Object.keys(obj).forEach(function (key) {
	    obj[key] = allHave(dates, key);
	  });
	  return obj;
	}
	
	/**
	 * @param {datetimeTemplate[]} dates
	 * @returns {boolean} true if all dates have a value for `quarter` or `half`.
	 */
	function allQuarterly(dates) {
	  return dates.every(function (item) {
	    return item.quarter || item.half;
	  });
	}
	
	/**
	 * @returns {object} with keys for all the properties useful in the charts
	 *   tool, each set to undefined or false.
	 */
	function datetimeTemplate() {
	  return {
	    z: undefined,
	    a: undefined,
	    second: undefined,
	    minute: undefined,
	    hour: undefined,
	    date: undefined,
	    month: undefined,
	    year: undefined,
	    value: undefined,
	    fiscalYear: false,
	    quarter: undefined,
	    half: undefined
	  };
	}
	
	/**
	 * Remove values that repeat for all dates and therefore are superfluous.
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]} Copy of dates if altered; original dates if
	 *    unaltered.
	 */
	function removeExtraneousComponents(dates) {
	  var common = all(dates);
	  if (common.month && common.date) {
	    // && !common.year) {
	    dates = removeExtraneous(dates, 'date');
	  }
	  if (common.month && common.year) {
	    dates = removeExtraneousMD(dates);
	  }
	  if (common.hour && common.minute) {
	    dates = removeExtraneous(dates, 'minute');
	  }
	  if (common.minute && common.second) {
	    dates = removeExtraneous(dates, 'seconds');
	  }
	  return dates;
	}
	
	/**
	 * Often dates are in the format Jan 1 YYYY, where Jan 1 repeats for *all*
	 * rows but the years increment. In this special case, the month and date
	 * should be disregarded. Also works if months but no dates are specificed;
	 * e.g. 1/2000, 1/2001, etc.
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]} Copy of dates if altered; original dates if
	 *    unaltered.
	 */
	function removeExtraneousMD(dates) {
	  var datesCopy = [];
	  var month = undefined;
	  var date = undefined;
	  var year = undefined;
	  for (var i = 0; i < dates.length; i++) {
	    var d = (0, _lodash2.default)({}, dates[i]);
	    if (i === 0) {
	      month = d.month;
	      date = d.date;
	      year = d.year;
	    } else if (d.month !== month || d.date !== date) {
	      return dates;
	    } else if (d.year <= year) {
	      return dates;
	    }
	    year = d.year;
	    d.month = d.date = undefined;
	    datesCopy[i] = d;
	  }
	  return datesCopy;
	}
	
	/**
	 * Removes values (such as seconds, minutes, or dates) when the values are the
	 * same for each and every date.
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]} Copy of dates if altered; original dates if
	 *    unaltered.
	 */
	function removeExtraneous(dates, prop) {
	  var datesCopy = [];
	  var propVal = undefined;
	  var value = undefined;
	  var genericVal = (0, _dateutils.genericTimeValue)(prop);
	  for (var i = 0; i < dates.length; i++) {
	    var d = (0, _lodash2.default)({}, dates[i]);
	    if (i === 0) {
	      // Set initial values to compare to.
	      propVal = d[prop];
	      value = d.value;
	    } else if (Math.abs(d.value - value) < genericVal) {
	      // Values do not increment.
	      return dates;
	    } else if (d[prop] !== propVal) {
	      // Values are not all the same and therefor not extraneous.
	      return dates;
	    }
	    value = d.value;
	    d[prop] = undefined;
	    datesCopy[i] = d;
	  }
	  return datesCopy;
	}
	
	/**
	 * Sets a value in milliseconds for each datetime object.
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]}
	 */
	function generateValues(dates) {
	  dates.forEach(function (date) {
	    date.value = getValue(date);
	  });
	  return dates;
	}
	
	/**
	 * @private
	 * @param {datetimeTemplate}
	 * @returns {number} value in milliseconds
	 */
	function getValue(date) {
	  var d = new Date(new Date().getUTCFullYear(), 0, 1, 0, 0, 0, 0);
	  if (isDef(date.year) && isDef(date.month) && isDef(date.date)) {
	    d.setUTCFullYear(date.year, date.month, date.date);
	  } else if (isDef(date.year) && isDef(date.month)) {
	    d.setUTCFullYear(date.year, date.month);
	  } else if (isDef(date.year)) {
	    d.setUTCFullYear(date.year);
	  } else if (isDef(date.month) && isDef(date.date)) {
	    d.setUTCMonth(date.month, date.date);
	  } else if (isDef(date.month)) {
	    d.setUTCMonth(date.month);
	  } else if (isDef(date.date)) {
	    d.setUTCDate(date.date);
	  }
	
	  if (isDef(date.hour) && isDef(date.minute) && isDef(date.second)) {
	    d.setUTCHours(date.hour, date.minute, date.second);
	  } else if (isDef(date.hour) && isDef(date.minute)) {
	    d.setUTCHours(date.hour, date.minute);
	  } else if (isDef(date.hour)) {
	    d.setUTCHours(date.hour);
	  } else if (isDef(date.minute) && isDef(date.second)) {
	    d.setUTCMinutes(date.minute, date.second);
	  } else if (isDef(date.minute)) {
	    d.setUTCMinutes(date.minute);
	  } else if (isDef(date.second)) {
	    d.setUTCSeconds(date.second);
	  }
	
	  return d.valueOf();
	}
	
	function isDef(value) {
	  return value !== undefined;
	}
	
	/**
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]} dates sorted by value
	 */
	// function sortDates(dates) {
	//   return dates.sort((a, b) => {
	//     if (a.value === undefined || b.value === undefined) {
	//       return 0;
	//     }
	//     return a.value - b.value;
	//   });
	// }
	
	
	// Not used in this module but is used by the app/client.
	// @returns {boolean} true is @param str is a quartlery date value.
	function isQuarterlyString(str) {
	  return _constants.REGEXP_Q_ONLY.test(str);
	}
	
	exports.default = {
	  parse: parse,
	  components: components,
	  allHave: allHave,
	  all: all,
	  allQuarterly: allQuarterly,
	  stripZeroes: _zero.stripZeroes,
	  addZeroes: _zero.addZeroes,
	  allValidDates: allValidDates,
	  datetimeTemplate: datetimeTemplate,
	  isQuarterlyString: isQuarterlyString
	};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isVerticalType = isVerticalType;
	exports.forAxisTicks = forAxisTicks;
	exports.forAxisTicksReverse = forAxisTicksReverse;
	// Returns true if the chart type has axes in the style of a column chart.
	function isVerticalType(type) {
	  return type === 'line' || type === 'column' || type === 'area';
	}
	
	// Convenience utility function for looping through the ticks on an axis,
	// which is necessary a million times in this module.
	function forAxisTicks(axis, callback) {
	  for (var i = 0; i < axis.tickPositions.length; i++) {
	    var tick = axis.ticks[axis.tickPositions[i]];
	    if (callback(tick, axis.tickPositions[i], i) === false) {
	      break;
	    }
	  }
	}
	
	// Like forAxisTicks() but runs in reverse (index high to low).
	function forAxisTicksReverse(axis, callback) {
	  for (var i = axis.tickPositions.length - 1; i >= 0; i--) {
	    var tick = axis.ticks[axis.tickPositions[i]];
	    if (callback(tick, axis.tickPositions[i], i) === false) {
	      break;
	    }
	  }
	}

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = assign;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fullYear = fullYear;
	exports.abbrYear = abbrYear;
	exports.isSameCentury = isSameCentury;
	exports.getQuarter = getQuarter;
	exports.getHalf = getHalf;
	exports.quarterToMonth = quarterToMonth;
	exports.quarterToDate = quarterToDate;
	exports.genericTimeValue = genericTimeValue;
	
	var _zero = __webpack_require__(5);
	
	/**
	 * Transform a partial year value (84) into a full year value (1984)
	 * according to a formula agreed upon at WSJ.
	 * @param {number|string} value
	 * @returns {number}
	 */
	
	function fullYear(value) {
	  value = +value;
	  if (value < 100) {
	    if (value + 2000 > new Date().getUTCFullYear() + 15) {
	      value += 1900;
	    } else {
	      value += 2000;
	    }
	  }
	  return value;
	}
	
	/**
	 * Transforms a year value into 2-digit number: 1984 to 84.
	 * @param {number|string} value
	 * @returns {string} of length 2
	 */
	/**
	 * Bring addZeroes and stripZeroes function directly into dateutils to 
	 * expose for testing
	 */
	
	function abbrYear(value) {
	  value = (0, _zero.addZeroes)((0, _zero.stripZeroes)(value), 2);
	  return value.substr(-2, 2);
	}
	
	/**
	 * @param {number|string} year1
	 * @param {number|string} year2
	 * @returns {boolean} true if y1 and y2 represent years in the same century.
	 */
	function isSameCentury(year1, year2) {
	  var y1 = (0, _zero.addZeroes)(fullYear(year1), 4);
	  var y2 = (0, _zero.addZeroes)(fullYear(year2), 4);
	  return y1.substr(0, 2) === y2.substr(0, 2);
	}
	
	/**
	 * @private
	 * @param {string} str
	 * @returns {string|undefined} if str is a Quartar ("2Q") or else undefined.
	 */
	function getQuarter(str) {
	  if (typeof str === 'string') {
	    str = str.toUpperCase();
	    return str.indexOf('Q') !== -1 ? str : undefined;
	  }
	  return undefined;
	}
	
	/**
	 * @private
	 * @param {string} str
	 * @returns {string|undefined} if str is a Half ("2H") or else undefined.
	 */
	function getHalf(str) {
	  if (typeof str === 'string') {
	    str = str.toUpperCase();
	    return str.indexOf('H') !== -1 ? str : undefined;
	  }
	  return undefined;
	}
	
	/**
	 * For a given quarter, returns the index of the month that represents the end
	 * of that quarter.
	 * @private
	 * @param {number} q Index of a quarter, 0 to 3.
	 * @returns {number} Index of month, 2, 4, 8, or 11.
	 */
	function quarterToMonth(q) {
	  q = typeof q === 'string' ? q.toUpperCase() : null;
	  switch (q) {
	    case '1Q':
	      return 2;
	    case '2Q':
	    case '1H':
	      return 5;
	    case '3Q':
	      return 8;
	    case '4Q':
	    case '2H':
	      return 11;
	  }
	  return undefined;
	}
	
	/**
	 * For a given month that represents the end of a quarter, returns the date
	 * that represents the end of that quarter.
	 * @private
	 * @param {number} month Index of a month, 0 to 11.
	 * @returns {number} Date of the month, 1 to 31.
	 */
	function quarterToDate(month) {
	  switch (month) {
	    case undefined:
	    case null:
	      return undefined;
	    case 1:
	      return 28;
	    case 3:
	    case 5:
	    case 8:
	    case 10:
	      return 30;
	    default:
	      return 31;
	  }
	}
	
	/**
	 * For use with removeExtraneous().
	 * @private
	 * @param {string} prop 'second', 'minute', etc.
	 * @returns {number} in milliseconds
	 */
	function genericTimeValue(prop) {
	  switch (prop) {
	    case 'second':
	      return 1000 * 60;
	    case 'minute':
	      return 1000 * 60 * 60;
	    case 'hour':
	      return 1000 * 60 * 60 * 60;
	    case 'date':
	      return 1000 * 60 * 60 * 24;
	  }
	  return 0;
	}

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPoint;
	
	// Returns a point by its original index, before sorting by date.
	function getPoint(series, index) {
	  var point = series.data[index];
	  series.data.some(function (item, i) {
	    if (item.index === index) {
	      point = item;
	      return true;
	    }
	  });
	  return point;
	}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processSeries;
	exports.truncateData = truncateData;
	/**
	 * Processes and build the chart series data.
	 */
	function processSeries(options) {
	  // Prepare series for Highcharts.
	  options.originalSeries = options.series;
	  var data = options.series.map(function (item) {
	    var series = {
	      data: item.data,
	      name: item.name,
	      animation: false,
	      color: item.color || options.defaults.colors[0],
	      events: {
	        legendItemClick: function legendItemClick() {
	          return false;
	        }
	      },
	      turboThreshold: 0,
	      states: {
	        hover: {
	          enabled: options.type === 'line'
	        }
	      }
	    };
	    return series;
	  });
	
	  // Customize the data for the particular chart type.
	  switch (options.type) {
	    case 'pie':
	      data = data.slice(0, 1);
	      break;
	    case 'bar':
	      // Save data to do this later, when options.styles.lineHeight is known.
	      // return truncateData(options, data);
	      options.series = data; //sortData(data, options);
	      return options;
	    case 'line':
	      data = reverseDataOrder(data);
	      break;
	  }
	
	  options.series = data; //sortData(data, options);
	  for (var i = 0; i < options.series.length; i++) {
	    var seriesData = options.series[i].data;
	    for (var z = 0; z < seriesData.length; z++) {
	      seriesData[z].index = z;
	    }
	  }
	  return options;
	}
	
	// For line charts, first column should be top layer. This also reverses the
	// legend items, so that must be fixed separately.
	function reverseDataOrder(data) {
	  var dataLen = data.length;
	  data.forEach(function (item, index) {
	    item.index = dataLen - index - 1;
	    item.legendIndex = index;
	  });
	  return data;
	}
	
	// For horizontal bar charts, removes data to improve visual appearance.
	function truncateData(options, data) {
	  // Guestimate the maximum data rows that will fit.
	  var maxRows = Math.floor(options.height / (parseFloat(options.styles.lineHeight.large) * 1.5));
	  // Remove data so rows does not exceed maxRows.
	  var overflow = Math.ceil(data[0].data.length / maxRows);
	  var originalCategories = options.categories ? options.categories.slice() : null;
	  var categories = [];
	  if (overflow > 1) {
	    data.forEach(function (item, index) {
	      var items = [];
	      var n = 0;
	      while (n < item.data.length) {
	        if (index === 0 && options.categories) {
	          categories.push(originalCategories[n]);
	          options.categories = categories;
	        }
	        items.push(item.data[n]);
	        n += overflow;
	      }
	      item.data = items;
	    });
	  }
	  options.series = data;
	  return options;
	}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Functions and vars shared between axes-prerender and axes-postrender.
	 */
	var YEAR_MILLISECONDS = exports.YEAR_MILLISECONDS = 1000 * 60 * 60 * 24 * 365;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBestRule = getBestRule;
	var TEXT_RULES = {
	  thumb: {
	    title: false,
	    dek: false,
	    subdek: false,
	    note: false,
	    source: false,
	    tagline: false,
	    thumb: false
	  }
	};
	
	if (true) {
	  TEXT_RULES.E = {
	    title: false,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.D = {
	    title: false,
	    dek: true,
	    subdek: false,
	    note: false,
	    source: false,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.G = {
	    title: false,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.top = {
	    title: false,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: 'right',
	    thumb: false
	  };
	  TEXT_RULES.soc = {
	    title: false,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: 'right',
	    thumb: false
	  };
	  TEXT_RULES.tab = {
	    title: false,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.fon = {
	    title: false,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['4u'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: 'left',
	    thumb: false
	  };
	  TEXT_RULES['8u'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: 'right',
	    thumb: false
	  };
	  TEXT_RULES['12u'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: 'right',
	    thumb: false
	  };
	  TEXT_RULES['16u'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: 'right',
	    thumb: false
	  };
	}
	
	if (false) {
	  TEXT_RULES['barrons-4col-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: false,
	    source: false,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['barrons-8col-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['barrons-10col-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  }, TEXT_RULES['barrons-fullscreen-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['barrons-4col-inset'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['barrons-8col-inset'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['barrons-10col-inset'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  }, TEXT_RULES['barrons-fullscreen-inset'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	}
	
	if (false) {
	  TEXT_RULES['fn-small-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: false,
	    source: false,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['fn-medium-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['fn-large-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['fn-small-inset'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['fn-medium-inset'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['fn-large-inset'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['print-fn'] = {
	    title: false,
	    dek: false,
	    subdek: false,
	    note: false,
	    source: false,
	    tagline: false,
	    thumb: false
	  };
	}
	
	if (false) {
	  TEXT_RULES['marketwatch-ZT'] = {
	    title: false,
	    dek: false,
	    subdek: false,
	    legend: false,
	    note: false,
	    source: false,
	    tagline: false
	  };
	  TEXT_RULES['marketwatch-ZR'] = {
	    title: false,
	    dek: false,
	    subdek: false,
	    legend: false,
	    note: false,
	    source: false,
	    tagline: false
	  };
	}
	
	function getBestRule(id) {
	  // If a rule for @param id is found, return it.
	  if (TEXT_RULES[id] !== undefined) {
	    return TEXT_RULES[id];
	  }
	  // If a rules that begins with @param id is found, return it. This is useful
	  // for example with any id that starts with "thumb".
	  for (var i = 0, keys = Object.keys(TEXT_RULES); i < keys.length; i++) {
	    var key = keys[i];
	    if (id.indexOf(key) === 0) {
	      return TEXT_RULES[key];
	    }
	  }
	  // Default:
	  return {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: 'right'
	  };
	}
	
	exports.default = TEXT_RULES;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeEl = removeEl;
	
	var _element = __webpack_require__(2);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function removeEl(item) {
	  if (item && item.el) {
	    element.removeChild(item.el.element);
	    item.el = null;
	  }
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = baseKeysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(51)(module)))

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filterOptionsForSize;
	
	/**
	 * Options passed to the renderer include options for multiple sizes. This
	 * function narrows down all those options to those relevant to the current
	 * size only.
	 */
	function filterOptionsForSize(options) {
	  var size = getSize(options);
	  var sizeObj = options.sizes[size.id];
	  options.interactive = size.interactive;
	  options.target = size.target;
	  options.size = size.id;
	  options.height = options.useContainerSize ? options.height : sizeObj.height || size.height;
	  options.headings = sizeObj.headings;
	  options.legend = sizeObj.legend;
	  options.stacking = sizeObj.stacking;
	  options.axes = sizeObj.axes;
	  options.xAxis = sizeObj.xAxis;
	  options.yAxis = sizeObj.yAxis;
	  options.annotations = writeAnnotations(sizeObj.annotations);
	  options.tooltips = sizeObj.tooltips.sameAsAxes ? sizeObj.axes.units : sizeObj.tooltips;
	  return options;
	}
	
	function getSize(options) {
	  var index = indexOfSize(options);
	  if (index !== -1) {
	    return options.defaults.sizes[index];
	  }
	  options.defaults.sizes.sort(function (a, b) {
	    if (a.hasOwnProperty('minWidth') && b.hasOwnProperty('minWidth')) {
	      return a.minWidth - b.minWidth;
	    }
	    return 1;
	  });
	  var size = options.defaults.sizes[0];
	  options.defaults.sizes.forEach(function (item, index) {
	    if (item.hasOwnProperty('minWidth') && Math.ceil(options.width) >= item.minWidth) {
	      size = options.defaults.sizes[index];
	    }
	  });
	  return size;
	}
	
	function indexOfSize(options) {
	  if (options.size) {
	    for (var i = 0; i < options.defaults.sizes.length; i++) {
	      if (options.size === options.defaults.sizes[i].id) {
	        return i;
	      }
	    }
	  }
	  return -1;
	}
	
	function writeAnnotations(annotations) {
	  annotations.items.forEach(function (item) {
	    item.textAlign = item.textAlign || annotations.textAlign || 'left';
	    item.flushAlign = item.flushAlign || annotations.flushAlign || 'flush';
	  });
	  return annotations;
	}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = highchartsVersion;
	function highchartsVersion() {
	  var localHighcharts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	  var parts = (localHighcharts || Highcharts).version.split(' ');
	  for (var i = 0; i < parts.length; i++) {
	    var n = parseFloat(parts[i]);
	    if (!isNaN(n)) {
	      return n;
	    }
	  }
	  return 0;
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processCategories;
	
	var _constants = __webpack_require__(1);
	
	var _datetime = __webpack_require__(7);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _zero = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Processes and builds the chart categories.
	 */
	function processCategories(options) {
	  if (Array.isArray(options.categories)) {
	    options.maxDataLength = getMaxDataLength(options);
	    options.originalCategories = options.categories.slice();
	    if (options.categoriesAreDates) {
	      return formatAsDates(options);
	    } else {
	      return formatAsCategories(options);
	    }
	  } else {
	    options = writeDefaultCategories(options);
	  }
	  return options;
	}
	
	function getMaxDataLength(options) {
	  var maxLen = 0;
	  options.series.forEach(function (series) {
	    maxLen = Math.max(maxLen, series.data.length);
	  });
	  return maxLen;
	}
	
	// Makes the index of each row into a default category value.
	function writeDefaultCategories(options) {
	  options.categories = [[]];
	  for (var i = 0; i < options.maxDataLength; i++) {
	    options.categories[0][i] = i;
	  }
	  options.originalCategories = options.categories[0].slice();
	  return options;
	}
	
	// Returns the categories as is, but wrapped in an array as the axes module needs.
	function formatAsCategories(options, altCategories) {
	  options.longCategories = options.originalCategories.slice(0);
	  options.categories = [options.categories];
	  return options;
	}
	
	// Casts the categories from strings into dates.
	function formatAsDates(options) {
	  options.fiscalYears = !!options.datesAll.fiscalYear;
	  options.quarterlyResults = _datetime2.default.allQuarterly(options.dates);
	  if (options.quarterlyResults || options.fiscalYears) {
	    options.longCategories = formatQLong(options);
	  } else {
	    options.longCategories = formatLong(options.dates);
	  }
	  options.categories = [options.quarterlyResults ? formatQ(options) : options.longCategories];
	  return options;
	}
	
	// For tooltips: standard dates/times.
	function formatLong(dates) {
	  return dates.map(function (date) {
	    var str = formatDateLong(date);
	    return formatTimeLong(date, str);
	  });
	}
	
	function formatDateLong(date) {
	  if (date.month !== undefined && date.date && date.year) {
	    return [_constants.MONTHS[date.month], date.date + ',', date.year].join(' ');
	  } else if (date.month !== undefined && date.date) {
	    return [_constants.MONTHS[date.month], date.date].join(' ');
	  } else if (date.month !== undefined && date.year) {
	    return [_constants.MONTHS[date.month], date.year].join(' ');
	  } else if (date.month !== undefined) {
	    return _constants.MONTHS[date.month];
	  } else if (date.year) {
	    return date.year + '';
	  }
	  return null;
	}
	
	function formatTimeLong(date, str) {
	  if (date.hour !== undefined) {
	    var h = '';
	    var a = '';
	    str = str ? str + ' ' : '';
	    if (date.a === 'a' || date.a === 'p') {
	      h = date.hour % 12 + '';
	      h = h === '0' ? '12' : h;
	      a = date.a;
	    } else {
	      if (date.hour === 0) {
	        h = '12';
	        a = 'a';
	      } else if (date.hour === 12) {
	        h = '12';
	        a = 'p';
	      } else if (date.hour > 12) {
	        h = date.hour % 12 + '';
	        a = 'p';
	      } else {
	        // same as: if (date.hour < 12) {
	        h = date.hour + '';
	        a = 'a';
	      }
	    }
	    str += h;
	    if (date.minute !== undefined) {
	      str += ':' + (0, _zero.addZeroes)(date.minute, 2);
	    }
	    if (date.second !== undefined) {
	      str += ':' + (0, _zero.addZeroes)(date.second, 2);
	    }
	    if (a) {
	      str += ' ' + (date.a === 'a' ? 'a.m.' : 'p.m.');
	    }
	    if (isNoon(str, date)) {
	      str = 'noon';
	    }
	    if (date.z) {
	      str += ' ' + date.z;
	    }
	  }
	  return str;
	}
	
	function isNoon(str, date) {
	  return date.minute === undefined && /^12/.test(str) || date.second === undefined && /^12:00/.test(str) || /^12:00:00/.test(str);
	}
	
	// Returns array of quarterly/half year categories.
	function formatQ(options, long) {
	  return options.dates.map(function (item, index) {
	    var str = '';
	    str += item.quarter || '';
	    str += item.half || '';
	    str += item.year !== undefined ? ' ' : '';
	    str += (index === 0 || long) && item.fiscalYear ? 'FY' : '';
	    str += item.year || '';
	    return str;
	  });
	}
	
	// For tooltips: quarterly results.
	function formatQLong(options) {
	  return formatQ(options, true);
	}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processData;
	
	var _format = __webpack_require__(3);
	
	var format = _interopRequireWildcard(_format);
	
	var _datetime = __webpack_require__(7);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Processes and optimizes the chart data before building categories and series.
	 */
	function processData(options) {
	  if (options.categoriesAreDates) {
	    options.dates = _datetime2.default.parse(options.categories, options);
	    options.datesAll = _datetime2.default.all(options.dates);
	    if (!options.quarterlyResults && options.type !== 'bar') {
	      options.series = insertDates(options.series, options);
	    }
	  }
	  if (options.type === 'pie' && options.optimizeDataOrder) {
	    options = optimizePieData(options);
	  } else if (options.categoriesAreDates && !options.quarterlyResults) {
	    options = sortDataByDate(options);
	  }
	  if (options.axes && options.axes.units && options.axes.units.divisor !== "none") {
	    options = divideYAxisValues(options);
	  }
	  return options;
	}
	
	// Insert date values into all data.
	function insertDates(data, options) {
	  var proxyYears = getProxyYears(options);
	  data.forEach(function (series) {
	    series.data.forEach(function (item, index) {
	      var dateObj = options.dates[index];
	      var date = new Date(dateObj.value);
	      if (dateObj.year === undefined && proxyYears[index] !== undefined) {
	        dateObj.yearIsProxy = true;
	        date.setUTCFullYear(proxyYears[index]);
	      }
	      item.x = date.valueOf();
	    });
	  });
	  return data;
	}
	
	// For data with dates with months but not years, create proxy years so the
	// dates can be sorted correctly.
	function getProxyYears(options) {
	  var proxyYears = [];
	  if (options.datesAll.month && !options.datesAll.year) {
	    var year = new Date().getUTCFullYear();
	    var month = undefined;
	    for (var i = options.dates.length - 1; i >= 0; i--) {
	      if (month !== undefined && month <= options.dates[i].month) {
	        year -= 1;
	      }
	      proxyYears[i] = year;
	      month = options.dates[i].month;
	    }
	  }
	  return proxyYears;
	}
	
	function sortDataByDate(options) {
	  options.series.forEach(function (item) {
	    item.data.forEach(function (pt, index) {
	      pt.index = index;
	    });
	    item.data.sort(function (a, b) {
	      if (a.x === undefined || b.x === undefined) {
	        return 0;
	      }
	      return a.x - b.x;
	    });
	    // item.data.forEach((pt, index) => {
	    // if (options.size === '8u') console.log(pt.index, index);
	    // pt.index = index;
	    // });
	  });
	  return options;
	}
	
	// Data should be ordered like so:
	//      2 1
	//    3     10
	//  4         9
	//    5     8
	//      6 7
	// Also, category names get attached to points.
	function optimizePieData(options) {
	  if (Array.isArray(options.categories)) {
	    // Link each point to a category.
	    options.series[0].data.forEach(function (point, index) {
	      point.name = options.categories[index];
	      point.originalIndex = index;
	    });
	  }
	  // Sort the data smallest to largest.
	  options.series[0].data.sort(function (a, b) {
	    if (a.y > b.y) {
	      return 1;
	    } else if (a.y < b.y) {
	      return -1;
	    }
	    return 0;
	  });
	  // Take the largest data at the end and make it first.
	  options.series[0].data.unshift(options.series[0].data.pop());
	  return options;
	}
	
	function divideYAxisValues(options) {
	  var divisor = format.getDivisor(options.axes.units.divisor);
	  for (var i = 0; i < options.series.length; i++) {
	    var yAxisValue = options.series[i].data;
	    yAxisValue.forEach(function (value) {
	      value.y = value.y / divisor;
	    });
	  }
	  return options;
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processOptions;
	
	var _highchartsVersion = __webpack_require__(18);
	
	var _highchartsVersion2 = _interopRequireDefault(_highchartsVersion);
	
	var _filterOptionsForSize = __webpack_require__(17);
	
	var _filterOptionsForSize2 = _interopRequireDefault(_filterOptionsForSize);
	
	var _processData = __webpack_require__(20);
	
	var _processData2 = _interopRequireDefault(_processData);
	
	var _processCategories = __webpack_require__(19);
	
	var _processCategories2 = _interopRequireDefault(_processCategories);
	
	var _processSeries = __webpack_require__(12);
	
	var _processSeries2 = _interopRequireDefault(_processSeries);
	
	var _style = __webpack_require__(45);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(49);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function processOptions(options, Highcharts) {
	  options = copyOptions(options, Highcharts);
	  options = (0, _filterOptionsForSize2.default)(options);
	  options = (0, _processData2.default)(options);
	  options = (0, _processCategories2.default)(options);
	  options.styles = (0, _style.processStyles)(options);
	  options = (0, _processSeries2.default)(options);
	  options.el = containerElement(options.el);
	  return options;
	}
	
	function copyOptions(options, Highcharts) {
	  return (0, _lodash2.default)({}, {
	    HIGHCHARTS_VERSION: (0, _highchartsVersion2.default)(Highcharts),
	    id: options.el.getAttribute('id') || options.size
	  }, options);
	}
	
	// Prepares the container DOM element.
	function containerElement(el) {
	  el = typeof el === 'string' ? document.querySelector(el) : el;
	  if (!el.querySelector('div.dj-chart-container')) {
	    var divA = document.createElement('div');
	    var divB = document.createElement('div');
	    divA.className = 'dj-chart-container';
	    divB.className = 'dj-chart-inner';
	    el.appendChild(divA);
	    el.appendChild(divB);
	  }
	  return el;
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.normalize = normalize;
	exports.makeFiscalYears = makeFiscalYears;
	exports.removeFiscalYears = removeFiscalYears;
	exports.makeQuarterly = makeQuarterly;
	exports.removeQuarterly = removeQuarterly;
	exports.getQuarter = getQuarter;
	exports.getHalf = getHalf;
	
	var _dateutils = __webpack_require__(10);
	
	/**
	 * For quarterly data, fills in missing quarters, years, etc.
	 */
	function normalize(items) {
	  // Quarters, halves, years must be declared/set in first item of a year.
	  var hasQ = items[0].quarter !== undefined;
	  var hasH = items[0].half !== undefined;
	  var hasY = items[0].year !== undefined;
	  var FY = hasY && items[0].fiscalYear;
	
	  // Dates are neither quarterly, halves, or fiscal years, so just return.
	  if (!(hasQ || hasH || FY)) {
	    return items;
	  }
	
	  var quarter = undefined;
	  var half = undefined;
	  var year = undefined;
	  var currYear = undefined;
	  items.forEach(function (item) {
	    var prevQ = hasQ ? quarter : hasH ? half : null;
	    item.fiscalYear = FY;
	
	    if (hasQ) {
	      if (!item.quarter) {
	        if (item.hasOwnProperty('month')) {
	          // - 1 because getQuarter starts months from 0:
	          item.quarter = getQuarter(item.month - 1);
	        } else {
	          quarter += 1;
	          quarter %= 4;
	          quarter = quarter === 0 ? 4 : quarter;
	          item.quarter = quarter + 'Q';
	        }
	      }
	      quarter = +item.quarter.substring(0, 1);
	    } else {
	      item.quarter = undefined;
	    }
	
	    if (hasH) {
	      if (!item.half) {
	        half += 1;
	        half %= 2;
	        half = half === 0 ? 2 : half;
	        item.half = half + 'H';
	      }
	      half = +item.half.substring(0, 1);
	    } else {
	      item.half = undefined;
	    }
	
	    if (hasY) {
	      if (item.year === undefined) {
	        item.year = year;
	        if (hasQ && quarter <= prevQ || hasH && half <= prevQ) {
	          item.year += 1;
	        }
	      }
	      item.year = year = (0, _dateutils.fullYear)(item.year);
	
	      if (currYear !== year) {
	        currYear = year;
	        hasQ = item.quarter !== undefined;
	        hasH = item.half !== undefined;
	      }
	    }
	  });
	
	  return items;
	}
	
	/**
	 * Transforms items into a fiscal years by declaring fiscalYear to be true for
	 * first item. Assumes normalize() will be called subsequently.
	 */
	function makeFiscalYears(items) {
	  items[0].fiscalYear = items[0].year !== undefined;
	  return items;
	}
	
	function removeFiscalYears(items) {
	  items.forEach(function (item) {
	    item.fiscalYear = false;
	  });
	  return items;
	}
	
	function makeQuarterly(items) {
	  items.forEach(function (item) {
	    if (item.quarter === undefined && item.half === undefined && item.month !== undefined) {
	      item.quarter = getQuarter(item.month);
	    }
	  });
	  return makeHalves(items);
	}
	
	function makeHalves(items) {
	  var isHalf = false;
	  var yearBlocks = {};
	
	  // Separate dates into blocks of years.
	  items.forEach(function (item) {
	    if (item.quarter && item.year !== undefined) {
	      yearBlocks[item.year] = yearBlocks[item.year] || [];
	      if (item.month !== undefined) {
	        yearBlocks[item.year].push(item);
	      }
	    }
	  });
	
	  // Transform any year blocks with 2 dates 6 months or more apart into halves.
	  Object.keys(yearBlocks).forEach(function (key) {
	    var block = yearBlocks[key];
	    if (block.length === 2) {
	      if (block[1].month - block[0].month >= 6) {
	        isHalf = true;
	        block[0].quarter = block[1].quarter = undefined;
	        block[0].half = '1H';
	        block[1].half = '2H';
	      }
	    }
	  });
	
	  if (isHalf) {
	    // Data if halves, not quarters, so convert quarters in years with only
	    // one quarter to a half.
	    Object.keys(yearBlocks).forEach(function (key) {
	      block = yearBlocks[key];
	      if (block.length === 1) {
	        block[0].quarter = undefined;
	        block[0].half = getHalf(block[0].month);
	      }
	    });
	  }
	  return items;
	}
	
	function removeQuarterly(items) {
	  items.forEach(function (item) {
	    item.quarter = item.half = undefined;
	  });
	  return items;
	}
	
	/**
	 * Converts a month index to a quarterly string value.
	 * @private
	 */
	function getQuarter(month) {
	  if (month < 3) {
	    return '1Q';
	  } else if (month < 6) {
	    return '2Q';
	  } else if (month < 9) {
	    return '3Q';
	  } else {
	    return '4Q';
	  }
	}
	
	/**
	 * Converts a month index to a half year string value.
	 * @private
	 */
	function getHalf(month) {
	  return month < 6 ? '1H' : '2H';
	}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datetime = __webpack_require__(7);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _processOptions = __webpack_require__(21);
	
	var _processOptions2 = _interopRequireDefault(_processOptions);
	
	var _processSeries = __webpack_require__(12);
	
	var _preload = __webpack_require__(46);
	
	var preload = _interopRequireWildcard(_preload);
	
	var _outer = __webpack_require__(42);
	
	var OuterChart = _interopRequireWildcard(_outer);
	
	var _inner = __webpack_require__(35);
	
	var InnerChart = _interopRequireWildcard(_inner);
	
	var _element = __webpack_require__(2);
	
	var element = _interopRequireWildcard(_element);
	
	var _highchartsSrc = __webpack_require__(47);
	
	var _highchartsSrc2 = _interopRequireDefault(_highchartsSrc);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Store charts so they can be destroyed as needed.
	var charts = [];
	
	/**
	 * Public API functions.
	 */
	
	
	// Highcharts source code must be updated to prevent writing window global and
	// throwing Error #16:
	function render(options, done) {
	  done = typeof done === 'function' ? done : function () {};
	  options = (0, _processOptions2.default)(options, _highchartsSrc2.default);
	  var invalidated = options.invalidated && options.invalidated[options.size];
	  if (!!invalidated) {
	    var existChart = getExistChart(options.el).chart;
	    if (existChart && existChart.outer && existChart.inner) {
	      renderInvalidated(existChart, options, done);
	      return;
	    }
	  }
	  resetRender(options, done);
	}
	
	function resetRender(options, done) {
	  destroy(options.el);
	  // console.log(`CHART.${options.id}.fonts.START`);
	  preload.fonts(options, function () {
	    // console.log(`CHART.${options.id}.fonts.COMPLETE`);
	    renderChart(options, done);
	  });
	}
	
	// Instead of re-rendering the entirety of both inner and outer charts, only
	// the invalidate parts of re-rendered.
	// TODO: Create preview/editing views and get this working again.
	function renderInvalidated(rendered, options, done) {
	  if (false) {
	    var invalidated = options.invalidated[options.size] || [];
	
	    var invalidAll = ['chart/targets', 'chart/height', 'chart/annotations',
	    // ];
	    // const invalidChart = [
	    'chart/data', 'chart/type', 'chart/series-names', 'chart/axis', 'chart/legend', 'chart/stacking', 'chart/height', 'chart/colors', 'headings/title'];
	    var invalidChart = [];
	
	    // Some changes require a full chart re-render while others can force a
	    // more limited re-render.
	    var mustRender = function mustRender(invalidated, renderItems) {
	      return true;
	      // return renderItems.some(item => {
	      //   return invalidated.indexOf(item) !== -1 || invalidated.some(invItem => {
	      //     return invItem.indexOf(item) === 0;
	      //   });
	      // });
	    };
	
	    if (mustRender(invalidated, invalidAll)) {
	      window.__charts_fonts_loaded__ = undefined;
	      resetRender(options, done);
	      return;
	    }
	
	    // Some items only force a re-render under specific conditions. For example,
	    // changes to series name should only trigger a re-render if the legend is
	    // enabled since that is the only place where series names appear.
	    invalidated = invalidated.filter(function (item) {
	      switch (item) {
	        case 'chart/series-names':
	          return options.legend.enabled;
	        default:
	          return true;
	      }
	    });
	
	    var outerHeight = rendered.outerInfo.height;
	    OuterChart.renderInvalidated(rendered, options, invalidated);
	
	    if (outerHeight !== rendered.outerInfo.height || mustRender(invalidated, invalidChart)) {
	      // mustRenderColor(invalidated)) {
	      destroyInner(rendered.inner);
	      setTimeout(function () {
	        renderInnerChart(options, rendered, rendered.outerInfo, done);
	      }, 1);
	    } else {
	      InnerChart.renderInvalidated(rendered, options, invalidated);
	      done(rendered.inner);
	    }
	  }
	}
	
	// The outer chart containers headlines and notes.
	function renderChart(options, done) {
	  if (options.type === 'bar') {
	    // options = truncateData(options, options.series);
	  }
	  var renderObj = { el: options.el, outer: null, inner: null, options: options };
	  var chartObj = OuterChart.preRender(options);
	  charts.push(renderObj);
	  renderObj.outer = renderHighchart(chartObj, function (highchart) {
	    var outer = OuterChart.postRender(highchart, options);
	    renderObj.outerInfo = outer;
	    if (outer.innerEl) {
	      renderInnerChart(options, renderObj, outer, done);
	    } else {
	      done(null);
	    }
	  });
	}
	
	// The inner charts contains the actual chart.
	function renderInnerChart(options, renderObj, outer, done) {
	  var outerY = outer.y;
	  options.width = outer.width;
	  options.annotations = outer.info ? outer.info.annotations.items : [];
	  var fontSize = parseFloat(options.styles.normal.fontSize);
	  if (options.size.indexOf('thumb') !== 0) {
	    options.height = outer.height - (options.type === 'pie' || options.size === 'marketwatch-ZT' ? 0 : 16);
	  }
	  options.height += 8;
	  options.spacing = createInnerSpacing(options, outer.spacing);
	  var chartObj = InnerChart.preRender(options);
	  return renderObj.inner = renderHighchart(chartObj, function (highchart) {
	    InnerChart.postRender(highchart, options);
	    var hc = chartObj.chart.renderTo.querySelector('.highcharts-container');
	    if (hc) {
	      hc.style.position = 'absolute';
	      hc.style.left = outer.x + 'px';
	      hc.style.top = outerY + 'px';
	      hc.style.overflow = 'visible';
	
	      var svg = hc.querySelector('svg');
	      svg.setAttribute('x', outer.x);
	      svg.setAttribute('y', outerY);
	      svg.setAttribute('height', Math.max(0, options.height + fontSize));
	
	      if (options.size.indexOf('print') === 0) {
	        // This causes tooltip issues, but needs to be done (at the time) for
	        // image export and svg download:
	        outer.innerEl.appendChild(svg);
	        element.removeChild(hc);
	      }
	    }
	    done(highchart);
	  });
	}
	
	function createInnerSpacing(options, spacing) {
	  var inner = spacing ? spacing.map(function (n) {
	    return n;
	  }) : [0, 0, 0, 0];
	  if (inner[0] > 0 && options.axes.units.suffix.length > 2 || options.axes.units.showRecessions) {
	    inner[0] += parseFloat(options.styles.normal.lineHeight);
	    inner[0] = Math.max(0, inner[0]);
	  }
	  return inner;
	}
	
	// Render a Highcharts chart via either the standalone Highcharts adapter or
	// jQuery, depending on the environment.
	function renderHighchart(data, postRender) {
	  return new _highchartsSrc2.default.Chart(data, postRender);
	}
	
	function destroy(el) {
	  if (el) {
	    var obj = getExistChart(el);
	    if (obj.chart) {
	      destroyOuter(obj.chart.outer, obj.chart.inner);
	    }
	    if (obj.index !== -1) {
	      charts.splice(obj.index, 1);
	    }
	  } else {
	    // charts.forEach(c => {
	    //   if (c.el) {
	    //     destroy(c.el);
	    //   }
	    // });
	    while (charts.length) {
	      destroy(charts[0].el);
	    }
	  }
	}
	
	function destroyOuter(outer, inner) {
	  destroyInner(inner);
	  if (outer) {
	    try {
	      destroyCommon(outer);
	      outer.destroy();
	    } catch (e) {
	      // Highcharts error.... because older version?
	      // console.warn(e);
	    }
	  }
	}
	
	function destroyInner(inner) {
	  if (inner) {
	    try {
	      destroyCommon(inner);
	      inner.destroy();
	    } catch (e) {
	      // Usually exception caused by no innerEl !?!
	      // console.warn(e);
	    }
	  }
	}
	
	// The version of Highcharts used at DJ does not do this automatically.
	function destroyCommon(chart) {
	  if (chart.series) {
	    chart.series.forEach(function (s) {
	      try {
	        s.update({
	          enableMouseTracking: false
	        });
	      } catch (e) {
	        //
	      }
	    });
	  }
	}
	
	function getExistChart(el) {
	  var existChartIndex = chartIndexOf(el);
	  return {
	    index: existChartIndex,
	    chart: existChartIndex !== -1 ? charts[existChartIndex] : null
	  };
	}
	
	function chartIndexOf(el) {
	  for (var i = 0; i < charts.length; i++) {
	    if (charts[i].el === el) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	exports.default = { render: render, destroy: destroy, datetime: _datetime2.default, chart: getExistChart };

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.postRender = postRender;
	
	var _getPoint = __webpack_require__(11);
	
	var _getPoint2 = _interopRequireDefault(_getPoint);
	
	var _element = __webpack_require__(2);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MARGIN_ONLINE = 16;
	var MARGIN_PRINT = 8;
	var COLOR = '#333';
	
	function postRender(highchart, options) {
	  if (options.annotations && options.annotations.length) {
	    // Get values used for positioning.
	    var suffix = options.axes.units.suffix;
	    var liftUp = options.axes.showRecessions || suffix && options.axes.units.suffix.length > 2;
	
	    var styleLH = parseFloat(options.annotations[0].element.style.lineHeight);
	    if (styleLH) {
	      options.annotations[0].element.style.lineHeight = styleLH + 'px';
	    }
	    var lineHeight = parseFloat(window.getComputedStyle(options.annotations[0].element, null).getPropertyValue('line-height')) || 16;
	    var xy = getStartXY(highchart, options, suffix, liftUp);
	    // Position and append items.
	    var g = highchart.renderer.g('annotations').add();
	    g.element.parentElement.appendChild(g.element);
	    writeIdealPositions(highchart, options);
	    spaceOutPositions(highchart, options, xy, suffix, liftUp);
	    appendItems(highchart, options, g, xy, lineHeight);
	
	    // Make it crisp.
	    g.element.setAttribute('transform', 'translate(0.5, 0)');
	    setStyles(g.element, options);
	  }
	}
	
	function setStyles(element, options) {
	  if (true) {
	    if (options.product === 'wsj') {
	      var text = element.childNodes[0];
	      text.style.fontSize = options.styles.annotations.fontSize;
	      text.style.lineHeight = options.styles.annotations.lineHeight;
	    }
	  }
	}
	
	// Finds the X position for each annotation without regard to the other
	// annotations that it overlaps or the edges of the chart.
	function writeIdealPositions(highchart, options) {
	  options.annotations.forEach(function (item, index) {
	    var rect = item.element.getBoundingClientRect();
	    var xy = getGraphicXY(highchart, options, item);
	    item.position = {
	      gx: xy.x,
	      gy: xy.y,
	      tx: xy.x,
	      ty: 0,
	      width: rect.width,
	      height: rect.height,
	      show: true
	    };
	  });
	}
	
	function spaceOutPositions(highchart, options, xy, suffix, liftUp) {
	  var MARGIN = options.print ? MARGIN_PRINT : MARGIN_ONLINE;
	  var hardLeft = Math.round(xy.x);
	  var hardRight = highchart.plotLeft + highchart.plotWidth;
	  var hardWidth = hardRight - hardLeft;
	  var sortedA = options.sortedAnnotations = getSortedAnnotations(options);
	
	  // Hide annotations that are too wide to fit, even all by themselves.
	  sortedA.forEach(function (item) {
	    var pos = item.position;
	    pos.tx = Math.max(pos.tx, hardLeft);
	    if (pos.tx + pos.width > hardRight) {
	      pos.tx = hardRight - pos.width;
	      if (pos.tx < hardLeft) {
	        pos.show = false;
	      }
	    }
	  });
	
	  // Hide annotations for which the width of the entire chart will not
	  // accomodate them.
	  var accumWidth = 0;
	  options.annotations.forEach(function (item) {
	    if (item.position.show) {
	      accumWidth += item.position.width + MARGIN;
	      if (accumWidth > hardWidth) {
	        item.position.show = false;
	      }
	    }
	  });
	
	  var softPx = hardLeft;
	  // Shift items left to right.
	  sortedA.forEach(function (item) {
	    if (item.position.show) {
	      item.position.tx = Math.max(item.position.tx, softPx);
	      softPx = item.position.tx + item.position.width + MARGIN;
	    }
	  });
	  // Shift items right to left.
	  softPx = hardRight + MARGIN;
	  for (var i = sortedA.length - 1; i >= 0; i--) {
	    var item = sortedA[i];
	    if (item.position.show) {
	      item.position.tx = Math.min(item.position.tx, softPx - item.position.width - MARGIN);
	      softPx = item.position.tx;
	    }
	  }
	}
	
	function appendItems(highchart, options, g, xy, lineHeight) {
	  // Append and position.
	  options.annotations.forEach(function (item, index) {
	    var el = item.element;
	    if (item.position.show) {
	      var x = Math.round(item.position.tx + item.position.width / 2);
	      var y = xy.y;
	      var textX = item.position.tx;
	      var textAnchor = 'start';
	
	      if (item.flushAlign === 'flush') {
	        if (x >= textX && textX <= Math.round(xy.x)) {
	          item.textAlign = 'left';
	        } else if (textX <= x && textX + item.position.width >= highchart.plotLeft + highchart.plotWidth) {
	          item.textAlign = 'right';
	        }
	      }
	
	      if (item.textAlign === 'right') {
	        textAnchor = 'end';
	        textX += item.position.width;
	      } else if (item.textAlign === 'center') {
	        textAnchor = 'middle';
	        textX += item.position.width / 2;
	      }
	
	      var tspanLen = writeTspanX(el.children, textX);
	      var offsetY = -lineHeight * tspanLen;
	      item.position.tx = x;
	      item.position.ty = y;
	      el.setAttribute('text-anchor', textAnchor);
	      el.setAttribute('x', textX);
	      el.setAttribute('y', y + offsetY);
	      g.element.appendChild(el);
	    } else {
	      element.removeChild(el);
	    }
	  });
	  drawItemLines(highchart, options, g, xy);
	}
	
	// Get x, y where an annotation connector should attached to a chart graphic.
	function getGraphicXY(highchart, options, item) {
	  var p = item.attach.point;
	  var c = item.attach.category;
	  var xy = { x: 0, y: 0 };
	  if (p.enabled) {
	    var sIndex = options.series[p.series].hasOwnProperty('index') ? options.series[p.series].index : p.series;
	    var pIndex = getPointIndex(options.series[sIndex].data, p.index);
	    var point = highchart.series[sIndex].data[pIndex];
	    if (options.type === 'column') {
	      var shape = point.shapeArgs;
	      xy.x = shape.x + Math.floor(shape.width / 2);
	      xy.y = shape.y;
	    } else if (options.type === 'area' || options.type === 'line') {
	      xy.x = point.plotX;
	      xy.y = point.plotY;
	    }
	  } else {
	    var cIndex = getPointIndex(options.series[0].data, c.index);
	    xy.x = cIndex / highchart.series[0].data.length * highchart.plotWidth;
	    xy.y = highchart.plotHeight;
	  }
	  return xy;
	}
	
	function getPointIndex(data, index) {
	  var pointIndex = 0;
	  data.some(function (item, i) {
	    if (item.index === index) {
	      pointIndex = i;
	      return true;
	    }
	  });
	  return pointIndex;
	}
	
	function writeTspanX(tspan, x) {
	  var tspanLen = 0;
	  for (var i = 0; i < tspan.length; i++) {
	    if (tspan[i].nodeName === 'tspan') {
	      tspanLen++;
	      tspan[i].setAttribute('x', x);
	    }
	  }
	  return tspanLen - 1;
	}
	
	function getStartXY(highchart, options, suffix, liftUp) {
	  if (highchart.axes[1].opposite) {
	    return { x: 0, y: highchart.plotTop - 7 };
	  }
	  var MARGIN = options.print ? MARGIN_PRINT : MARGIN_ONLINE;
	  var suffixEl = suffix ? highchart.container.querySelector('.y-axis-suffix') : null;
	  if (suffixEl && !liftUp) {
	    // To the right of the suffix.
	    return {
	      x: +suffixEl.getAttribute('x') + suffixEl.getBoundingClientRect().width + MARGIN,
	      y: +suffixEl.getAttribute('y')
	    };
	  } else if (suffixEl && liftUp) {
	    // Above the suffix but aligned left with it, but we also need to find out
	    // if the suffix starts with a space to get the alignment right.
	    var suffixClassName = suffixEl.children[0].getAttribute('class');
	    var offsetX = suffixClassName === 'space' ? 4 : 0;
	    return {
	      x: +suffixEl.getAttribute('x') + offsetX,
	      y: +suffixEl.getAttribute('y') - suffixEl.getBoundingClientRect().height
	    };
	  } else {
	    // To the right of the y-axis label.
	    var xy = getTopAxisLabelXY(highchart, options);
	    xy.x += MARGIN;
	    return xy;
	  }
	}
	
	function getTopAxisLabelXY(highchart, options) {
	  var axis = highchart.axes[1];
	  var tickPos = axis.tickPositions[options.axes.reversed ? 0 : axis.tickPositions.length - 1];
	  return axis.ticks[tickPos].label.xy;
	}
	
	function drawItemLines(highchart, options, g, xy) {
	  var MARGIN = options.print ? MARGIN_PRINT : MARGIN_ONLINE;
	  var line = { x1: 0, x2: 0, y: xy.y + MARGIN };
	  options.sortedAnnotations.forEach(function (item) {
	    if (item.position.show) {
	      writePathPoints(highchart, item, MARGIN);
	    }
	  });
	
	  // Bump jointed lines down when overlapping to left.
	  var prevItem = null;
	  options.sortedAnnotations.forEach(function (item) {
	    if (item.position.show) {
	      if (item.path.length > 4) {
	        if (prevItem && prevItem.position.gx < prevItem.position.tx && prevItem.pathRect.x + prevItem.pathRect.width + MARGIN >= item.pathRect.x) {
	          var addPx = MARGIN / 2;
	          item.path[3] += addPx;
	          item.path[5] += addPx;
	        }
	        prevItem = item;
	      }
	    }
	  });
	
	  // Bump jointed lines down when overlapping to right.
	  prevItem = null;
	  options.sortedAnnotations.reverse().forEach(function (item) {
	    if (item.position.show) {
	      if (item.path.length > 4) {
	        if (prevItem && prevItem.position.gx > prevItem.position.tx && prevItem.pathRect.x <= item.pathRect.x + item.pathRect.width + MARGIN) {
	          var addPx = MARGIN / 2;
	          item.path[3] += addPx;
	          item.path[5] += addPx;
	        }
	        prevItem = item;
	      }
	    }
	  });
	
	  options.sortedAnnotations.reverse().forEach(function (item) {
	    if (item.position.show) {
	      drawLine(highchart, options, item, g);
	    }
	  });
	}
	
	function drawLine(highchart, options, item, g) {
	  var p = item.attach.point;
	  var c = item.attach.category;
	  var lineEnd = item.lineEnd || options.defaults.annotations.lineEnd;
	  var path = item.path.slice(0);
	  var lineOffset = getOffsetLineEnd(lineEnd, options);
	  if (lineEnd === 'nothing' && (options.type === 'column' && c.enabled || options.type !== 'column')) {
	    lineOffset = 0;
	  } else if (path.length > 4 && path[path.length - 1] + lineOffset < path[path.length - 3]) {
	    lineOffset = 0;
	  }
	  path.splice(0, 0, 'M');
	  path.splice(3, 0, 'L');
	  path[path.length - 1] += lineOffset;
	  if (!(item.showLine === false)) {
	    highchart.renderer.path(path).attr({ 'stroke': COLOR, 'stroke-width': options.print ? 0.5 : 1 }).add(g);
	  }
	  drawLineEnd(highchart, g, path, lineEnd, options.print);
	}
	
	function drawLineEnd(highchart, g, path, lineEnd, isPrint) {
	  var endPt = {
	    x: path[path.length - 2],
	    y: Math.ceil(path[path.length - 1])
	  };
	  if (lineEnd === 'arrow') {
	    drawLineEndArrow(highchart, g, endPt, isPrint);
	  } else if (lineEnd === 'dot') {
	    drawLineEndDot(highchart, g, endPt, isPrint);
	  } else if (lineEnd === 'circle') {
	    drawLineEndCircle(highchart, g, endPt, isPrint);
	  }
	}
	
	function drawLineEndArrow(highchart, g, endPt, isPrint) {
	  var size = isPrint ? 3.5 : 6.5;
	  var side = Math.sqrt(size * size - size / 2 * (size / 2));
	  var path = ['M', endPt.x - size * 0.5, endPt.y, 'L', endPt.x + size * 0.5, endPt.y, endPt.x, endPt.y + side];
	  highchart.renderer.path(path).attr({
	    fill: COLOR
	  }).add(g);
	}
	
	function drawLineEndDot(highchart, g, endPt, isPrint) {
	  var radius = isPrint ? 1.5 : 3;
	  highchart.renderer.circle(endPt.x, endPt.y, radius).attr({
	    fill: COLOR
	  }).add(g);
	}
	
	function drawLineEndCircle(highchart, g, endPt, isPrint) {
	  var radius = isPrint ? 4 : 8;
	  highchart.renderer.circle(endPt.x, endPt.y + radius, radius).attr({
	    stroke: COLOR,
	    'stroke-width': isPrint ? 0.5 : 1,
	    fill: 'transparent'
	  }).add(g);
	}
	
	function writePathPoints(highchart, item, MARGIN) {
	  item.position.gx += highchart.plotLeft;
	  item.position.gy += highchart.plotTop;
	  item.position.gx = Math.round(item.position.gx);
	  item.position.gy = Math.round(item.position.gy);
	
	  var deltaX = item.position.gx - item.position.tx;
	  var tx = Math.abs(deltaX) <= item.position.width / 2 ? item.position.gx : item.position.tx;
	  var ty = item.position.ty + 4;
	  var jointY = Math.max(highchart.plotTop + MARGIN / 2, Math.min(ty + MARGIN, item.position.gy));
	
	  var points = [tx, ty];
	  if (item.position.gx !== tx) {
	    // Line is not straight.
	    points.push(tx, jointY);
	    points.push(item.position.gx, jointY);
	  } else {
	    // Line descends straight from text to graphic.
	    points.push(item.position.gx, item.position.gy);
	  }
	  if (item.position.gy > points[points.length - 1]) {
	    // Descend from top of line/break to graphic.
	    points.push(item.position.gx, Math.max(item.position.gy, jointY));
	  }
	  item.path = points;
	  item.pathRect = getPathRect(points);
	}
	
	function getPathRect(points) {
	  var x1 = Number.MAX_VALUE;
	  var x2 = Number.MIN_VALUE;
	  var y1 = Number.MAX_VALUE;
	  var y2 = Number.MIN_VALUE;
	  points.forEach(function (pt, index) {
	    if (index % 2 === 0) {
	      x1 = pt < x1 ? pt : x1;
	      x2 = pt > x2 ? pt : x2;
	    } else {
	      y1 = pt < y1 ? pt : y1;
	      y2 = pt > y2 ? pt : y2;
	    }
	  });
	  return {
	    x: x1,
	    y: y2,
	    width: x2 - x1,
	    height: y2 - y1
	  };
	}
	
	// The pointer line/connector must be adjusted per lineEnd type.
	function getOffsetLineEnd(lineEnd, options) {
	  switch (lineEnd) {
	    case 'dot':
	      return 0;
	    case 'circle':
	      return options.print ? -4 : -8;
	    case 'arrow':
	      return options.print ? -4.25 : -8.5;
	    // case 'nothing':
	    default:
	      return options.print ? -1 : -2;
	  }
	}
	
	function getSortedAnnotations(options) {
	  return options.annotations.slice(0).sort(function (a, b) {
	    return sortOnPointIndex(a, b, options);
	  });
	}
	
	// Sort so that annotations go left to right (smallest index to highest).
	function sortOnPointIndex(a, b, options) {
	  return getItemIndex(a, options) - getItemIndex(b, options);
	}
	
	// Return index either of point or of category for sorting.
	function getItemIndex(annotation, options) {
	  for (var i = 0, keys = Object.keys(annotation.attach); i < keys.length; i++) {
	    if (annotation.attach[keys[i]].enabled) {
	      var index = getPointIndex(options.series[0].data, annotation.attach[keys[i]].index);
	      return index;
	      // return annotation.attach[keys[i]].index;
	    }
	  }
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = axesPostRenderXAxis;
	
	var _util = __webpack_require__(8);
	
	var _transform = __webpack_require__(4);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _axesCommon = __webpack_require__(13);
	
	var _constants = __webpack_require__(1);
	
	var _element = __webpack_require__(2);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function axesPostRenderXAxis(highchart, options, style) {
	  if (options.type === 'bar') {
	    formatBarChartLabels(highchart, options);
	  } else {
	    if (options.categoriesAreDates) {
	      updateDateLabels(highchart, options, style);
	    } else {
	      updateCategoryLabels(highchart, options);
	      if (false) {
	        if (options.product === 'marketwatch' && options.type === 'line') {
	          adjustFirstXAxisTick(highchart.axes[0], false, false);
	        }
	      }
	      if (false) {
	        if (options.product === 'financialnews' && options.type === 'line') {
	          adjustFirstXAxisTick(highchart.axes[0], false, false);
	        }
	      }
	    }
	  }
	  updateForMW(highchart, options);
	}
	
	function updateForMW(highchart, options) {
	  if (false) {
	    if (options.product === 'marketwatch' && options.type === 'line') {
	      var xAxisTicks = highchart.xAxis[0].ticks;
	      var xAxisTicksAsArr = Object.keys(xAxisTicks);
	      var firstTick = xAxisTicksAsArr[0];
	      var lastTick = xAxisTicksAsArr[xAxisTicksAsArr.length - 1];
	      for (var x in xAxisTicks) {
	        var highchartXAxisGrid = highchart.container.getElementsByClassName('highcharts-xaxis-grid')[0];
	        var highchartXAxisGridFirstEl = highchartXAxisGrid.firstElementChild.getAttribute('class');
	        var highchartXAxisGridLastEl = highchartXAxisGrid.lastElementChild.getAttribute('class');
	        var hasFirstAddedVerticalGridline = highchartXAxisGridFirstEl === 'add-vertical-gridline';
	        var hasLastAddedVerticalGridline = highchartXAxisGridLastEl === 'add-vertical-gridline';
	        var evalBoth = hasLastAddedVerticalGridline && hasFirstAddedVerticalGridline;
	        if (evalBoth) {
	          if (xAxisTicks[x].label.element.parentElement) {} else {
	            xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
	          }
	        } else {
	          if (!hasFirstAddedVerticalGridline && !hasLastAddedVerticalGridline) {
	            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isFirst || xAxisTicks[x].isLast) {} else {
	              if (!xAxisTicks[x].isFirst || !xAxisTicks[x].isLast) {
	                xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
	              }
	            }
	          }
	          if (!hasFirstAddedVerticalGridline && hasLastAddedVerticalGridline) {
	            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isFirst) {} else {
	              xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
	            }
	          }
	          if (!hasLastAddedVerticalGridline && hasFirstAddedVerticalGridline) {
	
	            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isLast) {} else {
	              xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function formatBarChartLabels(highchart, options) {
	  if (!options.allowCategoriesLinebreak) {
	    (0, _util.forAxisTicks)(highchart.xAxis[0], function (tick) {
	      var tspan = tick.label.element.querySelectorAll('tspan');
	      if (tspan.length > 1) {
	        // Move the top tspan down to center it vertically in its space:
	        var labelY = +tick.label.element.getAttribute('y');
	        var tspanY = +tspan[1].getAttribute('dy') / 2 * (tspan.length - 1);
	        tick.label.element.setAttribute('y', labelY + tspanY);
	
	        // Replace last 4 characters with an ellipsis (4 instead of 3 to be
	        // ensure nothing is cut off at left):
	        var textStr = tspan[0].textContent.substr(0, tspan[0].textContent.length - 4) + '...';
	        tspan[0].innerHTML = textStr;
	
	        // Remove the extra tspans:
	        for (var i = 1; i < tspan.length; i++) {
	          element.removeChild(tspan[i]);
	        }
	      }
	    });
	  }
	}
	
	// Remove category ticks and labels that are redudant or overlapping.
	function updateCategoryLabels(highchart, options) {
	  if (options.removeOverlappingCategories) {
	    var maxWidth = 0;
	    var ticksShown = [];
	    (0, _util.forAxisTicks)(highchart.xAxis[0], function (tick, index) {
	      if (tick.label.textStr === index) {
	        removeTick(tick);
	      } else {
	        maxWidth = Math.max(maxWidth, tick.labelLength);
	        ticksShown.push(tick);
	      }
	    });
	    var maxLabels = Math.floor(highchart.xAxis[0].width / maxWidth) || 0;
	    var skip = Math.ceil(ticksShown.length / maxLabels);
	    if (skip > 1) {
	      var removeNum = 0;
	      for (var i = 0; i < ticksShown.length; i++) {
	        if (removeNum > 0 && removeNum < skip) {
	          removeTick(ticksShown[i]);
	        }
	        if (++removeNum === skip) {
	          removeNum = 0;
	        }
	      }
	    }
	  }
	}
	
	// Remove date ticks and labels that are redudant or overlapping.
	function updateDateLabels(highchart, options, styles) {
	  var axis = highchart.axes[0];
	  if (options.type === 'column') {
	    var categoriesLen = options.categories[0].length;
	    if (options.quarterlyResults && categoriesLen > 9) {
	      centerCategoriesBetweenBars(axis, options);
	    } else {
	      if (axis.tickInterval < _axesCommon.YEAR_MILLISECONDS) {
	        // TODO: Re-enable this but with long ticks, better rules.
	        // centerCategoriesBetweenBars(axis, options);
	        // centerLabelsBetweenBars(highchart, options);
	      }
	    }
	  }
	  if (options.quarterlyResults) {
	    //   ensureMultipleLinesForQuarterlyResults(highchart, styles);
	    removeOverlappingQuarterlyResults(axis, options, styles);
	  } else {
	    var skipNum = getDatesSkipNum(axis, styles.MARGIN);
	    var startNum = formatDateLabels(axis, options, skipNum);
	    removeAmPm(axis, options);
	    var isMwOrFn = options.product === 'marketwatch' || options.product === 'financialnews' ? true : false;
	    var tickArray = Object.keys(axis.ticks);
	    if (options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
	      var isAnIntervalOfOne = options.xAxisInterval.split(' ')[0] === '1' && options.xAxisInterval !== '1 week' ? true : false;
	      if (isAnIntervalOfOne || options.xAxisInterval === 'auto') {
	        removeOverlappingDates(axis, options, skipNum, startNum, styles);
	        if (options.xAxisInterval === '1 day') {
	          styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	        }
	      } else {
	        if (options.type !== 'column' && !isMwOrFn && options.showMinorTicks) {
	          addMinorTick(axis, options, styles, highchart);
	        }
	        if (isMwOrFn) {
	          if (options.xAxisInterval === '1 week') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.xAxisInterval === '3 months') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	        if (!isMwOrFn && options.type === 'column') {
	          if (options.xAxisInterval === '1 week') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.xAxisInterval === '3 months') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	        if (!isMwOrFn && !options.showMinorTicks) {
	          if (options.xAxisInterval === '1 week') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.xAxisInterval === '3 months') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	      }
	    }
	
	    if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== undefined) {
	      var isAnIntervalOfOneMob = options.mobileXAxisInterval.split(' ')[0] === '1' && options.mobileXAxisInterval !== '1 week' ? true : false;
	      if (isAnIntervalOfOneMob || options.mobileXAxisInterval === 'auto') {
	        removeOverlappingDates(axis, options, skipNum, startNum, styles);
	        if (options.mobileXAxisInterval === '1 day') {
	          styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	        }
	      } else {
	        if (options.type !== 'column' && !isMwOrFn && options.showMinorTicks) {
	          addMinorTick(axis, options, styles, highchart);
	        }
	        if (isMwOrFn) {
	          if (options.mobileXAxisInterval === '1 week' && options.showMinorTicks) {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.mobileXAxisInterval === '3 months' && options.showMinorTicks) {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	        if (!isMwOrFn && options.type === 'column') {
	          if (options.mobileXAxisInterval === '1 week' && options.showMinorTicks) {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.mobileXAxisInterval === '3 months' && options.showMinorTicks) {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	        if (!isMwOrFn && !options.showMinorTicks) {
	          if (options.mobileXAxisInterval === '1 week') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.mobileXAxisInterval === '3 months') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	      }
	    }
	  }
	  if (options.fiscalYears && !options.quarterlyResults) {
	    addFY(axis);
	  }
	  replaceApostrophes(axis);
	  adjustLastXAxisTick(axis);
	  ensureTickSpacing(axis, options, styles);
	  if (false) {
	    if (options.product === 'marketwatch' && options.type === 'line') {
	      adjustFirstXAxisTick(axis, true, false);
	    }
	    if (options.product === 'marketwatch' && options.type === 'column' && options.quarterlyResults && options.size === 'marketwatch-4u-inset') {
	      adjustFirstXAxisTick(axis, false, true);
	    }
	  }
	  if (false) {
	    if (options.product === 'financialnews' && options.type === 'line') {
	      adjustFirstXAxisTick(axis, true, false);
	    }
	  }
	
	  if (true) {
	    if (!options.showMinorTicks && options.product === 'wsj') {
	      makeTickShorter(axis, options, styles, highchart);
	    }
	    var xGridTickGroup = highchart.container.getElementsByClassName('highcharts-xaxis')[0];
	    var xGridLabelGroup = highchart.container.getElementsByClassName('highcharts-xaxis-labels')[0];
	    if (xGridTickGroup.children.length - 1 === xGridLabelGroup.children.length && options.showMinorTicks && options.product === 'wsj') {
	      makeTickShorter(axis, options, styles, highchart);
	    }
	  }
	}
	
	// Moves ticks to between bars by shifting them to the left by half the space
	// between ticks. For use when x-axis date labels are categories and not actual
	// dates, such as quarterly data.
	function centerCategoriesBetweenBars(axis, options) {
	  var tickSpacing = Math.round(getTickSpacing(axis) * 0.5);
	  var x = [];
	  (0, _util.forAxisTicks)(axis, function (tick, tickPos, index) {
	    var markD = transform.read(tick.mark.element, 'd');
	    x[index] = markD[0][0] - tickSpacing; // + 0.5;
	  });
	  moveAxisLabels(axis, x);
	}
	
	// Move a series tick marks and labels to specific x positions.
	function moveAxisLabels(axis, x) {
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (x[index] !== null && x[index] !== undefined) {
	      var markD = transform.read(tick.mark.element, 'd');
	      markD[0][0] = markD[1][0] = Math.round(x[index]) + 0.5;
	      transform.write(tick.mark.element, 'd', markD[0], markD[1]);
	      tick.label.element.setAttribute('x', x[index]);
	      var tspan = tick.label.element.querySelectorAll('tspan');
	      for (var i = 0; i < tspan.length; i++) {
	        tspan[i].setAttribute('x', x[index]);
	      }
	    }
	  });
	}
	
	// Get number of x-axis date labels that overlap and therefore must be removed.
	function getDatesSkipNum(axis, margin) {
	  // At least 2 points are needed if one is to overlap another.
	  if (axis.tickPositions.length >= 2) {
	    var widest = 0;
	    var tickDistance = Math.max(2, getTickSpacing(axis) - margin);
	    (0, _util.forAxisTicks)(axis, function (tick) {
	      var width = tick.label.element.getBoundingClientRect().right + margin - tick.label.element.getBoundingClientRect().left;
	      widest = Math.max(widest, width);
	    });
	    var skipNum = normalizeSkipNumber(Math.ceil(widest / tickDistance));
	    var skipLabels = Math.floor(axis.tickPositions.length / skipNum);
	    var maxLabels = Math.floor(axis.width / widest);
	    while (skipLabels > maxLabels) {
	      skipNum = normalizeSkipNumber(Math.ceil(widest / --tickDistance));
	      skipLabels = Math.floor(axis.tickPositions.length / skipNum);
	    }
	    return skipNum;
	  }
	  return 0;
	}
	
	// When overlapping date labels are removed, this returns a number that is more
	// normal to skip over: 10 instead of 9 or 5 instead of 3.
	function normalizeSkipNumber(skip) {
	  if (skip > 2 && skip < 5) {
	    return 5;
	  } else if (skip > 5 && skip < 10) {
	    return 10;
	  } else if (skip > 10 && skip < 15) {
	    return 15;
	  } else if (skip > 15 && skip < 20) {
	    return 20;
	  } else if (skip > 20 && skip < 25) {
	    return 25;
	  } else if (skip > 25 && skip < 50) {
	    return 50;
	  } else if (skip > 50 && skip < 100) {
	    return 100;
	  }
	  return skip;
	}
	
	// Returns the distance/space between the first two ticks of an axis.
	function getTickSpacing(axis) {
	  var spacing = 0;
	  if (axis.tickPositions.length > 1) {
	    var t1 = axis.ticks[axis.tickPositions[0]];
	    var t2 = axis.ticks[axis.tickPositions[1]];
	    var d1 = transform.read(t1.mark.element, 'd');
	    var d2 = transform.read(t2.mark.element, 'd');
	    spacing = d2[0][0] - d1[0][0];
	  }
	  return spacing;
	}
	
	// Format x-axis dates that are not quarterly results nor fiscal years.
	function formatDateLabels(axis, options, skipNum) {
	  var dateType = null;
	  var startNum = 0;
	  skipNum = skipNum || 0;
	
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    var str = tick.label.textStr;
	
	    if (/^(\d{4})\b/.test(str)) {
	      dateType = 'year';
	    } else if (options.dateTimeLabelFormat === '%e. %b') {
	      dateType = 'month-date';
	    } else if (options.dateTimeLabelFormat === '%b \'%y') {
	      dateType = 'month-year';
	    }
	    if (skipNum >= 2) {
	      if (+str % skipNum === 0) {
	        startNum = index;
	        return false;
	      }
	    } else {
	      return false;
	    }
	  });
	
	  if (dateType === 'year') {
	    formatYears(axis, startNum);
	  } else if (dateType === 'month-year') {
	    // This just removes duplicated years; we don't actually want to do this yet.
	    // formatMonthYear(axis, startNum);
	  } else if (dateType === 'month-date') {
	    formatMonthDate(axis, startNum);
	  }
	  return startNum;
	}
	
	// Called from formatXAxisDates().
	function formatYears(axis, startNum) {
	  var century = void 0;
	  var tmpCentury = void 0;
	  var abbrYear = void 0;
	  var prevStr = void 0;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (index >= startNum) {
	      var str = tick.label.textStr + '';
	      if (str === prevStr) {
	        prevStr = str;
	        removeTick(tick);
	      } else {
	        prevStr = str;
	        // Format: 1980 '90 2000 '10
	        tmpCentury = str.substr(0, 2);
	        if (tmpCentury === century) {
	          str = tick.label.textStr = _constants.APOSTROPHE + str.substr(2);
	          tick.label.element.innerHTML = str;
	        } else {
	          century = tmpCentury;
	        }
	        var apostMatch = str.match(/\u2019(\d\d)/);
	        if (apostMatch) {
	          if (abbrYear === undefined || abbrYear !== apostMatch[1]) {
	            abbrYear = apostMatch[1];
	          } else if (abbrYear === apostMatch[1]) {
	            var apostIndex = str.indexOf(_constants.APOSTROPHE);
	            if (apostIndex > 0) {
	              str = str.substr(0, apostIndex - 1);
	              tick.label.element.innerHTML = str;
	            }
	          }
	        }
	      }
	    }
	  });
	}
	
	// Called from formatXAxisDates().
	function formatMonthYear(axis, startNum) {
	  var year = undefined;
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    if (tick.label.element.parentElement) {
	      var label = tick.label.element.innerHTML.split(' ');
	      if (label.length === 2) {
	        if (label[1] === year) {
	          tick.label.textStr = tick.label.element.innerHTML = label[0];
	        } else {
	          year = label[1];
	        }
	      }
	    }
	  });
	}
	
	// Called from formatXAxisDates().
	function formatMonthDate(axis, startNum) {
	  var month = undefined;
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    if (tick.label.element.parentElement) {
	      var label = tick.label.element.innerHTML.split(' ');
	      if (label.length === 2 && _constants.MONTHS.indexOf(label[0]) !== -1) {
	        if (label[0] === month) {
	          tick.label.textStr = tick.label.element.innerHTML = label[1];
	        } else {
	          month = label[0];
	        }
	      }
	    }
	  });
	}
	
	// Remove superflous am/pm.
	function removeAmPm(axis, options) {
	  var am = void 0;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (tick.label.element.parentElement) {
	      var str = tick.label.textStr + '';
	      if (index === 0) {
	        if (str.indexOf(' a.m.') !== -1) {
	          am = 'a';
	        } else if (str.indexOf(' p.m.') !== -1) {
	          am = 'p';
	        } else if (str === 'noon') {
	          am = null;
	        } else {
	          // Timescale is not hours.
	          return;
	        }
	      } else if (str !== 'noon') {
	        var amIndex = str.indexOf(' a.m.');
	        var tmpAm = amIndex !== -1 ? 'a' : 'p';
	        if (amIndex === -1) {
	          amIndex = str.indexOf(' p.m.');
	        }
	        if (amIndex !== -1) {
	          if (tmpAm === am) {
	            tick.label.element.innerHTML = str.substr(0, amIndex);
	          } else {
	            am = tmpAm;
	          }
	        }
	      }
	    }
	  });
	}
	
	// For overlapping quarterly results, remove labels that do not mention years.
	function removeOverlappingQuarterlyResults(axis, options, styles) {
	  var tick0 = axis.ticks[axis.tickPositions[0]];
	  var rect0 = tick0.label.element.getBoundingClientRect();
	  var totalSkips = 0;
	  var skips = 1;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (index > 0) {
	      if (rect0 === null && totalSkips > 0) {
	        if (tick.label.element.innerHTML) {
	          if (skips > 0 && totalSkips > 1 && options.xAxisInterval === 'auto') {
	            removeDateTick(tick, options, styles);
	          }
	          if (++skips >= totalSkips) {
	            skips = 0;
	          }
	        }
	      } else {
	        if (tick.label.element.innerHTML) {
	          var rect = tick.label.element.getBoundingClientRect();
	          if (rect0.right + styles.MARGIN >= rect.left && options.xAxisInterval === 'auto') {
	            removeDateTick(tick, options, styles);
	          } else {
	            rect0 = null;
	          }
	          ++totalSkips;
	        }
	      }
	    }
	  });
	}
	
	// Removes overlapping datetime labels, accounting for context of datetime
	// labels before and after.
	function removeOverlappingDates(axis, options, skipNum, startNum, styles) {
	  var prevStr = null;
	  var label = null;
	  var isMY = options.dateTimeLabelFormat === '%b \'%y';
	  var isHM = /^\%H\:\%M/.test(options.dateTimeLabelFormat);
	  var axisTickLen = axis.tickPositions.length;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (axisTickLen >= 2 && skipNum >= 2) {
	      if (!(skipNum < 2 || (index - startNum) % skipNum === 0)) {
	        removeDateTick(tick, options, styles);
	      }
	    }
	    if (tick.label.element.parentElement) {
	      if (isMY) {
	        label = tick.label.textStr.split(' ');
	        if (label[1] === prevStr) {
	          tick.label.element.innerHTML = label[0];
	        }
	        prevStr = label[1];
	      } else if (isHM) {
	        label = tick.label.textStr;
	        if (label === prevStr) {
	          removeDateTick(tick, options, styles);
	        }
	        prevStr = label;
	      }
	    }
	  });
	}
	
	// If fiscalYears, add 'FY' to first label and offset by width of 'FY'.
	function addFY(axis) {
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    if (tick.label.element.parentElement) {
	      var x = +tick.label.element.getAttribute('x');
	      var w1 = tick.label.element.getBoundingClientRect().width;
	      tick.label.element.innerHTML = 'FY' + tick.label.textStr;
	      var w2 = tick.label.element.getBoundingClientRect().width;
	      x -= (w2 - w1) / 2;
	      tick.label.element.setAttribute('x', x);
	      return false;
	    }
	  });
	}
	
	// Ensures curly apostrophes render correctly.
	function replaceApostrophes(axis) {
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    var str = tick.label.element.innerHTML + '';
	    tick.label.element.innerHTML = str.replace(_constants.APOSTROPHE, '&rsquo;');
	  });
	}
	
	function adjustLastXAxisTick(axis) {
	  var tick = axis.ticks[axis.tickPositions[axis.tickPositions.length - 1]];
	  var markX = transform.read(tick.mark.element, 'd')[0][0];
	  var labelWidth = tick.label.element.getBoundingClientRect().width;
	  var offset = axis.left + axis.width - (markX + labelWidth / 2);
	  tick.label.element.setAttribute('x', markX + Math.min(0, offset));
	  tick.label.element.setAttribute('text-anchor', 'middle');
	}
	
	function adjustFirstXAxisTick(axis, isDateTime, isColQuarterly) {
	  var tick = axis.ticks[axis.tickPositions[0]];
	  var markX = transform.read(tick.mark.element, 'd')[0][0];
	  var labelWidth = tick.label.element.getBoundingClientRect().width;
	  if (labelWidth / 2 > markX && !isColQuarterly) {
	    if (isDateTime) {
	      tick.label.element.setAttribute('x', labelWidth / 2);
	    } else {
	      tick.label.element.setAttribute('text-anchor', 'left');
	    }
	  } else {
	    tick.label.element.setAttribute('x', markX);
	  }
	  if (isColQuarterly) {
	    var barContainerX = axis.chart.container.getElementsByClassName('highcharts-series-0')[0].firstElementChild.getAttribute('x');
	    if (barContainerX <= 0) {
	      tick.label.element.setAttribute('text-anchor', 'left');
	      tick.label.element.setAttribute('x', 2);
	      tick.label.element.children[1].setAttribute('x', 2);
	    }
	  }
	}
	
	// Ensures ticks are spaced adequately apart by removing ticks that are too
	// close together.
	function ensureTickSpacing(axis, options, styles) {
	  var MIN = 4;
	  var longs = [];
	  var dx = void 0;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    var markEl = tick.mark.element;
	    if (markEl.parentElement && Math.round(markEl.getBoundingClientRect().height) >= styles.MEDIUM_TICK_LENGTH) {
	      longs.push(index);
	    }
	  });
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    var markEl = tick.mark.element;
	    if (markEl.parentElement) {
	      var d = transform.read(null, 'd', tick.mark.d);
	      if (dx === undefined) {
	        dx = d[0][0];
	      }
	      if (longs.indexOf(index) === -1) {
	        if (d[0][0] - dx <= MIN) {
	          element.removeChild(markEl);
	        } else {
	          var n = -1;
	          var longFwd = longs.some(function (longIndex) {
	            n = longIndex;
	            return longIndex > index;
	          });
	          if (longFwd) {
	            var longTickF = axis.ticks[axis.tickPositions[n]];
	            var dlf = transform.read(null, 'd', longTickF.mark.d);
	            if (dlf[0][0] - d[0][0] <= MIN) {
	              element.removeChild(markEl);
	            }
	          }
	          if (markEl.parentElement) {
	            var longBck = longs.some(function (longIndex) {
	              n = longIndex;
	              return longIndex < index;
	            });
	            if (longBck) {
	              var longTickB = axis.ticks[axis.tickPositions[n]];
	              var dlb = transform.read(null, 'd', longTickB.mark.d);
	              if (d[0][0] - dlb[0][0] <= MIN) {
	                element.removeChild(markEl);
	              }
	            }
	          }
	          dx = d[0][0];
	        }
	      } else {
	        dx = d[0][0];
	      }
	    }
	  });
	}
	
	// Removes a date tick and label or replaces it with a short tick depending
	// on the context.
	function removeDateTick(tick, options, styles) {
	  var labelEl = tick.label.element;
	  var markEl = tick.mark.element;
	  element.removeChild(labelEl);
	  if (!options.showMinorTicks) {
	    element.removeChild(markEl);
	  }
	  if (options.type === 'column') {
	    element.removeChild(markEl);
	  } else if (Math.round(markEl.getBoundingClientRect().height) >= styles.MEDIUM_TICK_LENGTH && options.showMinorTicks) {
	    var d = transform.read(null, 'd', tick.mark.d);
	    d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
	    transform.write(markEl, 'd', d);
	  }
	}
	
	function addMinorTick(axis, options, styles, highchart) {
	  var xAxisGridGroup = axis.chart.axes[0].gridGroup.element;
	  if (xAxisGridGroup.children.length > 1) {
	    var firstInGroupD = transform.read(null, 'd', xAxisGridGroup.children[0].getAttribute('d'));
	    var secondInGroupD = transform.read(null, 'd', xAxisGridGroup.children[1].getAttribute('d'));
	    var interval = void 0;
	    var unit = void 0;
	    if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
	      interval = options.mobileXAxisInterval.split(' ')[0];
	      unit = options.mobileXAxisInterval.split(' ')[1];
	    }
	    if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
	      interval = options.xAxisInterval.split(' ')[0];
	      unit = options.xAxisInterval.split(' ')[1];
	    }
	    interval = unit === 'week' ? 7 : interval;
	    var diff = (secondInGroupD[0][0] - firstInGroupD[0][0]) / parseInt(interval);
	    (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	      var labelEl = tick.label.element;
	      var markEl = tick.mark.element;
	      var d = transform.read(null, 'd', tick.mark.d);
	      if (options.dates[0].year % interval !== 0 && options.dates[0].month === 1 || unit === 'months' || unit === 'week') {
	        var backD = transform.read(null, 'd', tick.mark.d);
	        var firstTick = void 0;
	        if (unit === 'years') {
	          firstTick = index === 0 ? parseInt(tick.label.element.children[0].innerHTML) : firstTick;
	        }
	        if (unit === 'months') {
	          var label = tick.label.textStr.split(' ')[0];
	          var labelMonthValue = findMonthValue(label);
	          firstTick = index === 0 ? labelMonthValue : firstTick;
	        }
	        if (unit === 'week') {
	          firstTick = index === 0 ? parseInt(tick.label.textStr.split(' ')[1]) : firstTick;
	        }
	        var benchmark = void 0;
	        if (unit === 'years') {
	          benchmark = firstTick - options.dates[0].year;
	        }
	        if (unit === 'months') {
	          benchmark = firstTick - options.dates[0].month - 1;
	        }
	        if (unit === 'week') {
	          benchmark = options.dates[0].date > firstTick ? firstTick + 30 - options.dates[0].date : firstTick - options.dates[0].date;
	        }
	        for (var w = 0; w < benchmark; w++) {
	          appendToXGridGroup(highchart, diff, styles, backD, false);
	        }
	      }
	
	      var tickArray = Object.keys(tick.axis.ticks);
	      var lastTick = tickArray[tickArray.length - 1];
	      var isLastTick = tick.pos === tick.axis.ticks[lastTick].pos ? true : false;
	      if (!isLastTick) {
	        for (var i = 0; i < interval - 1; i++) {
	          appendToXGridGroup(highchart, diff, styles, d, true);
	        }
	      } else {
	        var lastBenchmark = void 0;
	        if (unit === 'years') {
	          lastBenchmark = options.dates[options.dates.length - 1].year - parseInt(tick.label.textCache.split(',')[0]);
	        }
	        if (unit === 'months') {
	          var _label = tick.label.textStr.split(' ')[0];
	          var _labelMonthValue = findMonthValue(_label);
	          lastBenchmark = options.dates[options.dates.length - 1].month - _labelMonthValue;
	        }
	        if (unit === 'week') {
	          lastBenchmark = options.dates[options.dates.length - 1].month.date - parseInt(tick.label.textStr.split(' ')[1]);
	        }
	        for (var _i = 0; _i < lastBenchmark; _i++) {
	          appendToXGridGroup(highchart, diff, styles, d, true);
	        }
	      }
	
	      var isMonth = unit === 'months' ? true : false;
	      if (unit === 'months' || unit === 'week') {
	        styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, isMonth);
	      }
	    });
	  }
	  // if (xAxisGridGroup.children.length === 1) {
	  //   const firstInGroupD = transform.read(null, 'd', xAxisGridGroup.children[0].getAttribute('d'));
	  //   let interval;
	  //   let unit;
	  //   if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
	  //     interval = options.mobileXAxisInterval.split(' ')[0];
	  //     unit = options.mobileXAxisInterval.split(' ')[1];
	  //   } 
	  //   if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
	  //     interval = options.xAxisInterval.split(' ')[0];
	  //     unit = options.xAxisInterval.split(' ')[1];
	  //   }
	  //   let firstDate;
	  //   let lastDate;
	  //   if (unit === 'years') {
	  //     firstDate = options.dates[0].year;
	  //     lastDate = options.dates[options.dates.length - 1].year;
	  //   }
	  //   if (unit === 'months') {
	  //     firstDate = options.dates[0].month;
	  //     lastDate = options.dates[options.dates.length - 1].month;
	  //   }
	  //   if (unit === 'week') {
	  //     firstDate = options.dates[0].date;
	  //     lastDate = options.dates[options.dates.length - 1].date;
	  //   }
	  //   const axisTicksKey = Object.keys(axis.ticks);
	  //   const xAxisGridLine = highchart.container.getElementsByClassName('highcharts-axis-line')[0];
	  //   const xAxisGridLineD = xAxisGridLine.getAttribute('d');
	  //   const gridLineD = transform.read(null, 'd', xAxisGridLineD);
	  //   const d = transform.read(null, 'd', axis.ticks[axisTicksKey[0]].mark.d);
	  //   const secD = transform.read(null, 'd', axis.ticks[axisTicksKey[0]].mark.d);
	  //   const isWeekOrYear = unit === 'years' ? axis.ticks[axisTicksKey[0]].label.textStr : axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[1];
	  //   let diff = unit !== 'months' ? parseInt(isWeekOrYear) - firstDate : 
	  //     findMonthValue(axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[0]) - firstDate;
	  //   let diffLast = unit !== 'months' ? lastDate - parseInt(isWeekOrYear) : 
	  //     lastDate - findMonthValue(axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[0]);
	  //   const diffBetweenFirstDataPoint = Math.round(d[0][0] / diff);
	  //   for (let u = 0; u < diff; u++) {
	  //     if (d[0][0] - diffBetweenFirstDataPoint >= gridLineD[0][0]) {
	  //       appendToXGridGroup(highchart, diffBetweenFirstDataPoint, styles, d, false);
	  //     }
	  //   }
	  //   for (let y = 0; y < diffLast; y++) {
	  //     if (secD[1][0] + diffBetweenFirstDataPoint <= gridLineD[1][0]) {
	  //       appendToXGridGroup(highchart, diffBetweenFirstDataPoint, styles, secD, true);
	  //     }
	  //   }
	  // }
	}
	
	function appendToXGridGroup(highchart, diff, styles, d, isAfterFirstTick) {
	  var newPath = highchart.renderer.path().attr({
	    'opacity': 1
	  });
	  if (isAfterFirstTick) {
	    d[0][0] = d[0][0] + diff;
	    d[1][0] = d[1][0] + diff;
	  } else {
	    d[0][0] = d[0][0] - diff;
	    d[1][0] = d[1][0] - diff;
	  }
	  d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
	  newPath = transform.write(newPath.element, 'd', d);
	  newPath.setAttribute('stroke-width', 1);
	  newPath.setAttribute('stroke', '#333333');
	  var gridGroup = highchart.container.getElementsByClassName('highcharts-xaxis')[0];
	  gridGroup.appendChild(newPath);
	}
	
	// Removes a tick label and grid line.
	function removeTick(tick) {
	  element.removeChild(tick.label.element);
	  element.removeChild((tick['gridLine'] || tick['mark']).element);
	}
	
	function styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, isMonth) {
	  var firstTick = tickArray[0];
	  var firstTickVal = isMonth ? axis.ticks[firstTick].label.element.children[0].innerHTML.split(' ')[1] : axis.ticks[firstTick].label.element.children[0].innerHTML.split(' ')[0];
	  var landMarkTicks = [firstTickVal];
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    var tickVal = tick.label.textStr;
	    var tickValUnit = isMonth ? tickVal.split(' ')[1] : tickVal.split(' ')[0];
	    if (landMarkTicks.indexOf(tickValUnit) !== -1 && index !== 0) {
	      var arrayVal = isMonth ? 0 : 1;
	      if (tick.label.element.children.length > 0) {
	        tick.label.element.children[0].innerHTML = tickVal.split(' ')[arrayVal];
	      } else {
	        tick.label.element.innerHTML = tickVal.split(' ')[arrayVal];
	      }
	    } else {
	      landMarkTicks.push(tickValUnit);
	    }
	  });
	}
	
	function findMonthValue(label) {
	  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  return months.indexOf(label);
	}
	
	function makeTickShorter(axis, options, styles, highchart) {
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    // const labelEl = tick.label.element;
	    var markEl = tick.mark.element;
	    var d = transform.read(null, 'd', tick.mark.d);
	    d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
	    transform.write(markEl, 'd', d);
	  });
	}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = axesPostRenderYAxis;
	
	var _transform = __webpack_require__(4);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _util = __webpack_require__(8);
	
	var _constants = __webpack_require__(1);
	
	var _element = __webpack_require__(2);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Manipulates the SVG drawn by Highcharts to update the scale (Y) axis.
	 */
	function axesPostRenderYAxis(highchart, options, styles) {
	  // The scale axis is always the Y axis, even on bar charts where the scale
	  // axis visually is the X axis:
	  var axis = highchart.axes[1];
	  if ((0, _util.isVerticalType)(options.type)) {
	    makeDecimalsConsistent(axis);
	    extendTicks(axis, options);
	  } else {
	    shiftLastHorizontalBarLine(highchart, options);
	  }
	  setZeroLineToBlack(axis, options);
	
	  insertZeroesForEmptyBars(highchart.renderer, axis, options);
	  if (options.type === 'column' || options.type === 'bar') {
	    moveZeroLineToTop(highchart.container, axis, options);
	  }
	  ensureLabelsFit(axis, options, highchart);
	
	  if (true) {
	    if (options.product === 'wsj') {
	      moveTopLabel(axis, options);
	    }
	  }
	
	  addSuffix(highchart.renderer, axis, options, styles, highchart);
	}
	
	// Set line representing the zero value to black.
	function setZeroLineToBlack(axis, options) {
	  var zeroTick = axis.ticks[0];
	  if (false) {
	    if (options.product === 'marketwatch' && options.type === 'column') {
	      return;
	    }
	  }
	  if (zeroTick) {
	    zeroTick.gridLine.element.setAttribute('stroke', '#000');
	
	    if (true) {
	      if (options.product === 'wsj') {
	        zeroTick.gridLine.element.setAttribute('stroke', options.styles.axes.zeroGridLine.color);
	      }
	    }
	  }
	}
	
	function makeDecimalsConsistent(axis) {
	  var zeroIndex = axis.tickPositions.indexOf(0);
	  var maxDecimals = getMaxTicksDecimals(axis);
	  if (maxDecimals > 0) {
	    (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	      var textStr = tick.label.textStr;
	      var indexDot = textStr.indexOf('.');
	      var decimals = indexDot === -1 ? 0 : textStr.length - indexDot - 1;
	      if (key === 0) {
	        textStr += '<tspan fill-opacity="0">';
	      }
	      if (indexDot === -1) {
	        indexDot = textStr.length;
	        textStr += '.';
	      }
	      while (decimals++ < maxDecimals) {
	        textStr += '0';
	      }
	      if (key === 0) {
	        textStr += '</tspan>';
	      }
	      tick.label.textStr = textStr;
	      tick.label.element.innerHTML = textStr;
	    });
	  }
	}
	
	// Extend grid lines under the label text on the y-axis (for "vertical" axes).
	function extendTicks(axis, options) {
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    var line = tick.gridLine.element;
	    if (line.hasAttribute('d')) {
	      var d = transform.read(line, 'd');
	      d[0][0] = 0;
	      if (options.spaceAddedForAnnotations) {
	        d[1][0] += options.print ? _constants.ANNOTATIONS_SPACE_PRINT : _constants.ANNOTATIONS_SPACE;
	      }
	      transform.write(line, 'd', d);
	      // const d = line.getAttribute('d').split(/\s/g);
	      // d[1] = 0;
	      // if (options.spaceAddedForAnnotations) {
	      //   console.log('???');
	      // }
	      // line.setAttribute('d', d.join(' '));
	    }
	  });
	}
	
	function getMaxTicksDecimals(axis) {
	  var maxDecimals = 0;
	  (0, _util.forAxisTicks)(axis, function (tick, pos) {
	    var decimal = tick.label.textStr.split('.')[1];
	    if (decimal !== undefined) {
	      maxDecimals = Math.max(decimal.length, maxDecimals);
	    }
	  });
	  return maxDecimals;
	}
	
	// Add units suffix string to the top tick label (`isLast`).
	function addSuffix(renderer, axis, options, styles, highchart) {
	  if (options.axes.units && (0, _util.isVerticalType)(options.type)) {
	    for (var key in axis.ticks) {
	      var ok1 = options.axes.reversed && axis.ticks[key].isFirst;
	      var ok2 = !options.axes.reversed && axis.ticks[key].isLast;
	      if (ok1 || ok2) {
	        var label = axis.ticks[key].label.element;
	
	        // To align the 0 properly with other labels without having
	        // decimals, the decimals are made inivisible. But this means
	        // any units suffix must be offset to not show up to the right
	        // of these invisible decimals but instead right next to the 0.
	        var tspan = label.querySelector('tspan');
	        var xOffset = 0;
	        if (tspan && tspan.getAttribute('opacity') === '0') {
	          var tspanInnerHTML = label.innerHTML + '';
	          var labelFullWidth = label.getBoundingClientRect().width;
	          label.innerHTML = '0';
	          var labelTmpWidth = label.getBoundingClientRect().width;
	          xOffset = labelTmpWidth - labelFullWidth;
	          label.innerHTML = tspanInnerHTML;
	        }
	
	        var unitStr = options.product === 'financialnews' ? options.axes.units.suffix : options.axes.units.suffix.replace(/^\s+/, _constants.NBSP);
	        if ((options.type === 'line' || options.type === 'column') && options.product === 'marketwatch') {
	          label.innerHTML = label.innerHTML + '<tspan>' + ' ' + unitStr + '</tspan>';
	          break;
	        }
	        if ((options.type === 'line' || options.type === 'column') && options.product === 'financialnews') {
	          if (options.axes.units.suffix !== "%") {
	            var labelYVal = label.getAttribute('y');
	            var highChartContainer = highchart.container;
	            var newLabelYVal = labelYVal - 7;
	            styles.NORMAL_STYLE.fontSize = 10;
	            styles.NORMAL_STYLE.color = '#555555';
	            var firstYAxisLabel = highChartContainer.getElementsByClassName('highcharts-yaxis-labels')[0].lastElementChild.getBoundingClientRect().right;
	            var suffix = renderer.text(unitStr, +label.getAttribute('x'), +newLabelYVal).css(styles.NORMAL_STYLE).add();
	            suffix.element.setAttribute('class', 'units y-axis-suffix');
	            var suffixRight = suffix.element.getBoundingClientRect().right;
	            var currentSuffX = suffix.element.getAttribute('x');
	            var diff = suffixRight - firstYAxisLabel;
	            suffix.element.setAttribute('x', currentSuffX - diff);
	
	            // suffix.element.setAttribute('x', currentSuffX - diff);
	            break;
	          } else {
	            label.innerHTML = label.innerHTML + '<tspan>' + unitStr + '</tspan>';
	            break;
	          }
	        } else {
	          var css = styles.NORMAL_STYLE;
	
	          if (true) {
	            if (options.product === 'wsj') {
	              css = Object.assign({}, css, {
	                fontSize: styles.AXES.label.fontSize,
	                color: styles.AXES.label.color,
	                fill: styles.AXES.label.color
	              });
	            }
	          }
	
	          var _suffix = renderer.text(unitStr, +label.getAttribute('x') + xOffset, +label.getAttribute('y')).css(css).add();
	          var currentY = _suffix.element.getAttribute('y');
	          _suffix.element.setAttribute('class', 'units y-axis-suffix');
	          // aligns the suffix with the label
	          _suffix.element.setAttribute('y', +currentY + .5);
	          break;
	        }
	      }
	    }
	  }
	}
	
	// On vertical bar / column charts, insert a small '0' in place of bars that
	// have a zero value, so that it does not look like an error.
	function insertZeroesForEmptyBars(renderer, axis, options) {
	  var typeOk = options.type === 'column';
	  var stackOk = !options.stacking || axis.series.length === 1;
	  if (typeOk && stackOk) {
	    var series = axis.series;
	    var allLessThanZero = allValuesLessThanZero(axis);
	    var g = [];
	    axis.series.forEach(function (series) {
	      series.data.forEach(function (item) {
	        if (item.y === 0) {
	          var el = item.graphic.element;
	          var translate = transform.read(el.parentElement, 'translate');
	          var x = +el.attributes.x.value + translate[0];
	          var y = +el.attributes.y.value + translate[1];
	          var smallStyle = options.styles.get('small');
	          if (options.product === 'wsj') {
	            smallStyle.color = '#555555';
	          } else {
	            smallStyle.color = item.color;
	          }
	          x += +el.attributes.width.value / 2;
	          y += allLessThanZero ? parseFloat(options.styles.get('small').fontSize) : -4;
	          var text = renderer.text('0', x, y).attr({ 'text-anchor': 'middle' }).css(smallStyle).add();
	          g.push({ type: '0', el: text.element });
	        } else if (item.graphic) {
	          g.push({ type: 'bar', el: item.graphic.element });
	        }
	      });
	    });
	
	    // Sort by `left` position.
	    g.sort(function (a, b) {
	      return a.el.getBoundingClientRect().left - b.el.getBoundingClientRect().left;
	    });
	
	    // Check if 0s overlap bars or other 0s and, if so, remove.
	    for (var i = 0; i < g.length - 1; i++) {
	      if (g[i].type === '0') {
	        var r1 = g[i].el.getBoundingClientRect();
	        var r2 = g[i + 1].el.getBoundingClientRect();
	        if (r1.right + 2 > r2.left) {
	          element.removeChild(g[i].el);
	        }
	      }
	    }
	  }
	}
	
	// Returns true if all values are <= 0.
	function allValuesLessThanZero(axis) {
	  return axis.series.every(function (series) {
	    return series.data.every(function (item) {
	      return item.y <= 0;
	    });
	  });
	}
	
	// In Highcharts, grid lines ares places under lines and columns, which is
	// fine. But we want the 0 line to be above (as in z or depth).
	function moveZeroLineToTop(container, axis, options) {
	  var zero = axis.ticks[0];
	  if (zero) {
	    var el = zero.gridLine.element;
	    if (true) {
	      if (options.size === 'print-wsj') {
	        var d = transform.read(el, 'd');
	        if (options.type === 'bar') {
	          d[0][0] = Math.floor(d[0][0]) - 0.5;
	          d[1][0] = d[0][0];
	        } else {
	          d[0][1] = Math.ceil(d[0][1]);
	          d[1][1] = d[0][1];
	        }
	        transform.write(el, 'd', d);
	      }
	    }
	    container.querySelector('.highcharts-series-group').appendChild(el);
	  }
	}
	
	// Sometimes Highcharts lets labels slip off the edge of chart, as if it
	// measured the label width using a short label. Push the labels over so they
	// all fit.
	function ensureLabelsFit(axis, options, highchart) {
	  // ensureHorizontalLabelsFit(axis);
	  if (options.type === 'bar') {
	    if (!options.axes.reversed) {
	      ensureHorizontalLabelsFit(axis);
	    }
	  } else {
	    ensureVerticalLabelsFit(axis, options, highchart);
	  }
	}
	
	function ensureHorizontalLabelsFit(axis) {
	  var key = axis.tickPositions[axis.tickPositions.length - 1];
	  var tick = axis.ticks[key];
	  var el = tick.label.element;
	  var x2 = tick.label.xy.x + el.getBoundingClientRect().width / 2;
	  var dif = axis.left + axis.width - x2;
	  tick.label.xy.x += dif;
	
	  el.setAttribute('x', +el.getAttribute('x') + dif);
	}
	
	function ensureVerticalLabelsFit(axis, options, highchart) {
	  var maxWidth = 0;
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    var width = tick.label.element.getBoundingClientRect().width;
	    maxWidth = Math.max(maxWidth, width);
	  });
	  maxWidth = Math.ceil(maxWidth);
	  if (options.product !== "marketwatch" && options.product !== 'financialnews') {
	    (0, _util.forAxisTicks)(axis, function (tick) {
	      tick.label.element.setAttribute('x', maxWidth);
	    });
	  } else {
	    if (false) {
	      if (options.product === 'financialnews') {
	        if (options.type === 'line' || options.type === 'column') {
	          var highChartContainer = highchart.container;
	          var labelsG = highChartContainer.getElementsByClassName('highcharts-yaxis-labels');
	          var translateValue = options.print === true ? 'translate(0, 5)' : 'translate(0, 6)';
	          labelsG[0].attributes.transform.nodeValue = translateValue;
	          var gElRectLabels = highChartContainer.getElementsByClassName('highcharts-yaxis-labels')[0];
	          var gElRectRightLabels = gElRectLabels.getBoundingClientRect().right;
	          var gElRectLabelsChildren = gElRectLabels.children;
	          var horizontalGridLineArr = highChartContainer.getElementsByClassName('highcharts-yaxis-grid')[0].children;
	          var gWidth = gElRectLabels.getBoundingClientRect().width;
	          if (options.type === 'line') {
	            // translate the yaxis labels to the right based on width of surround g element
	            gElRectLabels.setAttribute('transform', 'translate(' + gWidth + ',' + '6)');
	            for (var _i = 0; _i < gElRectLabelsChildren.length; _i++) {
	              gElRectLabelsChildren[_i].setAttribute('text-anchor', 'end');
	              // if there's a 0 in yaxis labels remove the extra space/zero
	              var hasZero = gElRectLabels.children[_i].innerHTML === '0' || gElRectLabels.children[_i].innerHTML[1] === '<' ? true : false;
	              if (hasZero) {
	                gElRectLabels.children[_i].children[0].innerHTML = '';
	              }
	              var currentXVal = Number(gElRectLabelsChildren[_i].getAttribute('x'));
	              var dValue = transform.read(horizontalGridLineArr[_i], 'd');
	              var lastHorizontalGridLineElD = horizontalGridLineArr[_i].getAttribute('d').split(' ');
	              var childWidth = gElRectLabelsChildren[_i].getBoundingClientRect().width;
	              // extend horizontal gridlines to match position of label, which is now right aligned. highcharts positions them to be left aligned and all horizontal gridlines end at some point, thereby having same length
	              lastHorizontalGridLineElD[3] = currentXVal + gWidth - childWidth - 2 + "," + dValue[1][1];
	              // if first yaxis label has a percentage sign, decrease length of horizontal gridline to account for extra space that % creates
	              lastHorizontalGridLineElD[3] = options.axes.units.suffix === '%' && _i === gElRectLabelsChildren.length - 1 ? currentXVal + gWidth - childWidth - 15 + "," + dValue[1][1] : lastHorizontalGridLineElD[3];
	              // make sure first gridline has proper length
	              lastHorizontalGridLineElD[3] = options.axes.units.prefix !== "" && _i === gElRectLabelsChildren.length - 1 ? currentXVal - gWidth * 0.125 + "," + dValue[1][1] : lastHorizontalGridLineElD[3];
	              lastHorizontalGridLineElD[2] = '';
	              lastHorizontalGridLineElD = lastHorizontalGridLineElD.join(' ');
	              horizontalGridLineArr[_i].setAttribute('d', lastHorizontalGridLineElD);
	            }
	          }
	        }
	        if (options.type !== 'line' && options.type !== 'column') {
	          (0, _util.forAxisTicks)(axis, function (tick) {
	            tick.label.element.setAttribute('x', maxWidth);
	          });
	        }
	      }
	    }
	    if (false) {
	      if (options.type === 'line' && options.product === 'marketwatch') {
	        var _highChartContainer = highchart.container;
	        var xAxisGrid = _highChartContainer.getElementsByClassName('highcharts-xaxis-grid')[0];
	        var lastVerticalGridLineEl = xAxisGrid.lastElementChild;
	        var firstVerticalGridLineEl = xAxisGrid.firstElementChild;
	        var _horizontalGridLineArr = _highChartContainer.getElementsByClassName('highcharts-yaxis-grid')[0].children;
	        // x value of last point
	        var lastPoint = highchart.xAxis[0].series[0].data[highchart.xAxis[0].series[0].data.length - 1].clientX;
	        // x value of first point
	        var firstPoint = highchart.xAxis[0].series[0].data[0].clientX;
	        var borderCoord = document.getElementsByClassName('highcharts-plot-background')[1].getBoundingClientRect();
	        // get first D values of first and last vertical grid lines
	        var splitVerticalGridLineElCheck = lastVerticalGridLineEl.getAttribute('d').split(/(?=[LMC])/);
	        var splitVerticalGridLineElFirstCheck = firstVerticalGridLineEl.getAttribute('d').split(/(?=[LMC])/);
	        splitVerticalGridLineElFirstCheck = Math.round(splitVerticalGridLineElFirstCheck[0].split(' ')[1]);
	        splitVerticalGridLineElCheck = Math.round(splitVerticalGridLineElCheck[1].split(' ')[1]);
	        var roundFirstPoint = Math.round(firstPoint);
	        var roundLastPoint = Math.round(lastPoint);
	        // find the difference between first/last x point and d values
	        var diffBetweenFirstAndGridEl = roundFirstPoint - splitVerticalGridLineElFirstCheck;
	        var diffBetweenLastAndGridEl = roundLastPoint - splitVerticalGridLineElCheck;
	        var splitVerticalGridLineElFirst = transform.read(firstVerticalGridLineEl, 'd')[0][0];
	
	        // if first vertical gridline diff between first x point and first vertical grid line d value is negative AND
	        // if diff between last vertical gridline x point and d value is greater than one, draw a border around chart and extend
	        // horizontal gridlines to that border
	        var comparisonValue = -5;
	        if (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'marketwatch-4u-inset') {
	          comparisonValue = 0;
	        }
	        if (diffBetweenFirstAndGridEl < comparisonValue && diffBetweenLastAndGridEl >= 0) {
	
	          for (var i = 0; i < _horizontalGridLineArr.length; i++) {
	            var _dValue = transform.read(_horizontalGridLineArr[i], 'd');
	            var _lastHorizontalGridLineElD = _horizontalGridLineArr[i].getAttribute('d').split(' ');
	            if (firstPoint < splitVerticalGridLineElFirstCheck) {
	              _lastHorizontalGridLineElD[1] = (firstPoint - 1).toString() + ',' + _dValue[0][1].toString();
	            } else {
	              _lastHorizontalGridLineElD[1] = (splitVerticalGridLineElFirst - 0.5).toString() + ',' + _dValue[0][1].toString();
	            }
	            _lastHorizontalGridLineElD[3] = (lastPoint + 1).toString() + "," + _dValue[1][1];
	            _lastHorizontalGridLineElD[2] = '';
	            _lastHorizontalGridLineElD = _lastHorizontalGridLineElD.join(' ');
	            _horizontalGridLineArr[i].setAttribute('d', _lastHorizontalGridLineElD);
	            if (i === 0 || i === _horizontalGridLineArr.length - 1) {
	              _horizontalGridLineArr[i].setAttribute('stroke-width', 2);
	            }
	          }
	          addLastVerticalGridline(lastVerticalGridLineEl, firstVerticalGridLineEl, firstPoint, lastPoint, highchart, xAxisGrid, false);
	          addFirstVerticalGridline(firstVerticalGridLineEl, lastVerticalGridLineEl, lastPoint, firstPoint, highchart, xAxisGrid, false);
	        }
	        // extend horizontal gridlines to first and last x value
	        else {
	            for (var i = 0; i < _horizontalGridLineArr.length; i++) {
	              var _dValue2 = transform.read(_horizontalGridLineArr[i], 'd');
	              var _lastHorizontalGridLineElD2 = _horizontalGridLineArr[i].getAttribute('d').split(' ');
	              if (firstPoint < splitVerticalGridLineElFirstCheck) {
	                _lastHorizontalGridLineElD2[1] = (firstPoint - 1).toString() + ',' + _dValue2[0][1].toString();
	              } else {
	                _lastHorizontalGridLineElD2[1] = firstPoint - splitVerticalGridLineElFirstCheck >= 5 ? firstPoint.toString() + ',' + _dValue2[0][1].toString() : splitVerticalGridLineElFirst.toString() + ',' + _dValue2[0][1].toString();
	              }
	              _lastHorizontalGridLineElD2[3] = (lastPoint + 1).toString() + "," + _dValue2[1][1];
	              _lastHorizontalGridLineElD2[2] = '';
	              _lastHorizontalGridLineElD2 = _lastHorizontalGridLineElD2.join(' ');
	              _horizontalGridLineArr[i].setAttribute('d', _lastHorizontalGridLineElD2);
	              if (i === 0 || i === _horizontalGridLineArr.length - 1) {
	                _horizontalGridLineArr[i].setAttribute('stroke-width', 2);
	              }
	            }
	            // if diff between first x point and first d value is less than or equal to one AND
	            // diff between last x point and last d value is greater one, then add a vertical gridline to end of chart
	            if (diffBetweenLastAndGridEl > 1 || !options.categoriesAreDates) {
	              addLastVerticalGridline(lastVerticalGridLineEl, firstVerticalGridLineEl, firstPoint, lastPoint, highchart, xAxisGrid, true);
	            }
	            if (diffBetweenLastAndGridEl < 1 && diffBetweenLastAndGridEl > 0) {
	              // if diff between first x and first d value is greater than one, draw vertical gridline at beginning of chart
	              if (firstPoint < splitVerticalGridLineElFirstCheck) {
	                addFirstVerticalGridline(firstVerticalGridLineEl, lastVerticalGridLineEl, lastPoint, firstPoint, highchart, xAxisGrid, true);
	              }
	            }
	            if (diffBetweenLastAndGridEl === 0 || diffBetweenFirstAndGridEl === 0) {
	              if (Math.round(firstPoint) > splitVerticalGridLineElFirstCheck) {
	
	                thickenFirstLine(firstVerticalGridLineEl, splitVerticalGridLineElFirstCheck, true);
	                thickenLastLine(lastVerticalGridLineEl, lastPoint, true);
	              } else {
	                thickenLastLine(lastVerticalGridLineEl, lastPoint, false);
	                thickenFirstLine(firstVerticalGridLineEl, firstPoint, false);
	              }
	            }
	          }
	
	        var _labelsG = _highChartContainer.getElementsByClassName('highcharts-yaxis-labels');
	        var _translateValue = 'translate(0, 6)';
	        _labelsG[0].attributes.transform.nodeValue = _translateValue;
	      }
	      if (options.type === 'column' && options.product === 'marketwatch') {
	        var _highChartContainer2 = highchart.container;
	        var _labelsG2 = _highChartContainer2.getElementsByClassName('highcharts-yaxis-labels');
	        var _translateValue2 = 'translate(0, 6)';
	        _labelsG2[0].attributes.transform.nodeValue = _translateValue2;
	      }
	
	      if (options.type !== "line" && options.type !== 'column') {
	        (0, _util.forAxisTicks)(axis, function (tick) {
	          tick.label.element.setAttribute('x', maxWidth);
	        });
	      }
	    }
	  }
	}
	
	function shiftLastHorizontalBarLine(highchart, options) {
	  var axis = highchart.axes[1];
	  (0, _util.forAxisTicksReverse)(axis, function (tick) {
	    if (tick.isLast) {
	      var d = transform.read(tick.gridLine.element, 'd');
	      d[0][0] -= 1;
	      d[1][0] = d[0][0];
	      transform.write(tick.gridLine.element, 'd', d);
	      // break:
	      return false;
	    }
	  });
	}
	
	function addFirstVerticalGridline(firstVerticalGridLineEl, lastVerticalGridLineEl, lastPoint, firstPoint, highchart, xAxisGrid, thickenOpposite) {
	  var newFirstPath = firstVerticalGridLineEl;
	  var newFirstPathD = newFirstPath.getAttribute('d').split(' ');
	  newFirstPathD[1] = firstPoint.toString();
	  newFirstPathD[4] = firstPoint.toString();
	  var newFirstPathStroke = newFirstPath.getAttribute('stroke');
	  var newFirstPathOpacity = newFirstPath.getAttribute('opacity');
	  var elementPathFirst = highchart.renderer.path(newFirstPathD).attr({
	    stroke: newFirstPathStroke,
	    fill: 'none',
	    'stroke-width': 2,
	    class: 'add-vertical-gridline',
	    opacity: newFirstPathOpacity
	  });
	  xAxisGrid.insertBefore(elementPathFirst.element, firstVerticalGridLineEl);
	  if (thickenOpposite) {
	    thickenLastLine(lastVerticalGridLineEl, lastPoint);
	  }
	}
	
	function addLastVerticalGridline(lastVerticalGridLineEl, firstVerticalGridLineEl, firstPoint, lastPoint, highchart, xAxisGrid, thickenOpposite) {
	  var newLastPath = lastVerticalGridLineEl;
	  var newLastPathD = newLastPath.getAttribute('d').split(' ');
	  var newLastPathStroke = newLastPath.getAttribute('stroke');
	  var newLastPathOpacity = newLastPath.getAttribute('opacity');
	  newLastPathD[4] = lastPoint.toString();
	  newLastPathD[1] = lastPoint.toString();
	  var elementPath = highchart.renderer.path(newLastPathD).attr({
	    stroke: newLastPathStroke,
	    fill: 'none',
	    'stroke-width': 2,
	    class: 'add-vertical-gridline',
	    opacity: newLastPathOpacity
	  });
	  xAxisGrid.appendChild(elementPath.element);
	  if (thickenOpposite) {
	    thickenFirstLine(firstVerticalGridLineEl, firstPoint);
	  }
	}
	
	function thickenFirstLine(firstVerticalGridLineEl, firstPoint) {
	  var newFirstPath = firstVerticalGridLineEl;
	  var newFirstPathD = newFirstPath.getAttribute('d').split(' ');
	  var newFirstPathDSecond = Number(newFirstPathD[2]);
	  var newFirstPathLast = Number(newFirstPathD[newFirstPathD.length - 1]);
	  newFirstPathD[1] = firstPoint.toString();
	  newFirstPathD[4] = firstPoint.toString();
	  newFirstPathD = newFirstPathD.join(' ');
	  firstVerticalGridLineEl.setAttribute('d', newFirstPathD);
	  firstVerticalGridLineEl.setAttribute('stroke-width', 2);
	}
	
	function thickenLastLine(lastVerticalGridLineEl, lastPoint) {
	  var newLastPath = lastVerticalGridLineEl;
	  var newLastPathD = newLastPath.getAttribute('d').split(' ');
	  var newLastPathStroke = newLastPath.getAttribute('stroke');
	  var newLastPathOpacity = newLastPath.getAttribute('opacity');
	  var newLastPathDSecond = Number(newLastPathD[2]);
	  var newLastPathLast = Number(newLastPathD[newLastPathD.length - 1]);
	  newLastPathD[4] = lastPoint.toString();
	  newLastPathD[1] = lastPoint.toString();
	  newLastPathD = newLastPathD.join(' ');
	  lastVerticalGridLineEl.setAttribute('d', newLastPathD);
	  lastVerticalGridLineEl.setAttribute('stroke-width', 2);
	}
	
	function moveTopLabel(axis, options) {
	  var isColumn = options.type === 'column';
	  var isPrint = options.size === 'print-wsj';
	  var is8u = options.size === '8u';
	
	  for (var tick in axis.ticks) {
	    if (axis.ticks[tick].isLast) {
	      var topTick = axis.ticks[tick];
	      var label = axis.ticks[tick].label.element;
	      var position = +label.getAttribute('y');
	      var offset = -2;
	
	      if (is8u) {
	        offset = -1;
	      }
	
	      if (isColumn) {
	        offset = -1;
	      }
	
	      if (isPrint) {
	        offset = -.5;
	      }
	
	      var newPostition = position + offset;
	      label.setAttribute('y', newPostition);
	    }
	  }
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = axesPostRender;
	
	var _axesPostrenderYAxis = __webpack_require__(26);
	
	var _axesPostrenderYAxis2 = _interopRequireDefault(_axesPostrenderYAxis);
	
	var _axesPostrenderXAxis = __webpack_require__(25);
	
	var _axesPostrenderXAxis2 = _interopRequireDefault(_axesPostrenderXAxis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function axesPostRender(highchart, options, styles) {
	  makeLinesCrisp(highchart, options);
	  if (options.type !== 'pie') {
	    (0, _axesPostrenderYAxis2.default)(highchart, options, styles);
	    (0, _axesPostrenderXAxis2.default)(highchart, options, styles);
	  }
	
	  if (options.print && options.type === 'bar') {
	    var barCont = highchart.container.getElementsByClassName('highcharts-bar-series');
	    for (var i = 0; i < barCont.length; i++) {
	      var highchartBarG = barCont[i];
	      var highchartBarGTransformVal = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(highchartBarG.getAttribute('transform'));
	      var xValTranslate = parseInt(highchartBarGTransformVal[1]) - 1.5;
	      highchartBarG.transform.baseVal.getItem(0).setTranslate(xValTranslate, parseInt(highchartBarGTransformVal[2]));
	    }
	  }
	  if (options.print && options.type === 'column') {
	    var colCont = highchart.container.getElementsByClassName('highcharts-column-series');
	    for (var _i = 0; _i < colCont.length; _i++) {
	      var highchartColumnG = colCont[_i];
	      var highchartColumnGTransformVal = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(highchartColumnG.getAttribute('transform'));
	      var yValTranslate = parseInt(highchartColumnGTransformVal[2]) + 1;
	      highchartColumnG.transform.baseVal.getItem(0).setTranslate(parseInt(highchartColumnGTransformVal[1]), yValTranslate);
	    }
	  }
	
	  if (true) {
	    if (options.product === 'wsj' && options.type === 'bar') {
	      var yAxis = highchart.container.getElementsByClassName('highcharts-yaxis-labels');
	      yAxis[0].setAttribute('transform', 'translate(0, 2)');
	
	      // align h-bar xAxis labels to the left
	      var xAxis = highchart.container.getElementsByClassName('highcharts-xaxis-labels');
	      var xLabels = xAxis[0].childNodes;
	
	      xLabels.forEach(function (label) {
	        label.setAttribute('x', '0');
	        label.setAttribute('text-anchor', 'start');
	
	        var tspans = label.childNodes;
	
	        tspans.forEach(function (tspan) {
	          tspan.setAttribute('x', '0');
	        });
	      });
	    }
	  }
	}
	
	// Ensures lines are offset by 0.5 to ensure crispness.
	// TODO: If ever combining inner and outer charts, revisit this function!
	function makeLinesCrisp(highchart, options) {
	  var g = highchart.container.querySelectorAll('svg > g');
	
	  for (var i = 0; i < g.length; i++) {
	    var list = g[i].classList;
	
	    if (!list.contains('highcharts-legend')) {
	      g[i].setAttribute('transform', 'translate(0, 0.5)');
	    }
	
	    if (true) {
	      if (options.product === 'wsj') {
	        if (list.contains('highcharts-xaxis')) {
	          g[i].setAttribute('transform', 'translate(0, ' + options.styles.tick.yOffset + ')');
	        }
	      }
	    }
	  }
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = axesPreRender;
	exports.formatterYAxisLabel = formatterYAxisLabel;
	
	var _format = __webpack_require__(3);
	
	var format = _interopRequireWildcard(_format);
	
	var _constants = __webpack_require__(1);
	
	var _axesCommon = __webpack_require__(13);
	
	var _zero = __webpack_require__(5);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var isPrint = void 0;
	
	function axesPreRender(data, options, styles) {
	  data = writeCommonOptions(data, options);
	  switch (options.type) {
	    case 'pie':
	      return data;
	    case 'bar':
	      data = writeHorizontalOptions(data, options, styles);
	      break;
	    default:
	      data = writeVerticalOptions(data, options, styles);
	      break;
	  }
	  if (options.product !== 'financialnews') {
	    data.xAxis.gridLineColor = data.yAxis.gridLineColor = options.print ? '#bfbfbf' : '#e6e6e6';
	  } else {
	    data.xAxis.gridLineColor = data.yAxis.gridLineColor = options.print ? '#000000' : '#e6e6e6';
	  }
	
	  data = writeMinMax(data, options);
	  if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
	    tickIntervalCalc(options, data, true);
	  }
	  if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
	    tickIntervalCalc(options, data, false);
	  }
	  return data;
	}
	
	function tickIntervalCalc(options, data, isMobile) {
	  var typeOfInterval = isMobile ? 'mobileXAxisInterval' : 'xAxisInterval';
	  var interval = options[typeOfInterval].split(' ')[0];
	  var unit = options[typeOfInterval].split(' ')[1];
	  if (unit === 'years' || unit === 'year') {
	    data.xAxis.tickInterval = 24 * 3600 * 1000 * 365 * parseInt(interval);
	  }
	  if (unit === 'months' || unit === 'month') {
	    data.xAxis.tickInterval = 24 * 3600 * 1000 * 30 * parseInt(interval);
	  }
	  if (unit === 'day') {
	    data.xAxis.tickInterval = 24 * 3600 * 1000;
	  }
	  if (unit === 'week') {
	    data.xAxis.tickInterval = 24 * 3600 * 1000 * 7;
	  }
	}
	
	// Options common to all charts with axes.
	function writeCommonOptions(data, options) {
	  var offsetVal = 0;
	  var oppositeVal = false;
	  var horizontalGridLineStyle = 'solid';
	  if (false) {
	    if (options.product === "marketwatch" && options.type === 'line') {
	      offsetVal = 4;
	      oppositeVal = true;
	    }
	    if (options.product === 'marketwatch' && options.type === 'column') {
	      horizontalGridLineStyle = 'dash';
	      oppositeVal = true;
	      offsetVal = 8;
	    }
	  }
	  if (false) {
	    if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
	      oppositeVal = true;
	      offsetVal = 4;
	    }
	  }
	  data.xAxis = {
	    title: { text: '' },
	    tickColor: '#000000'
	  };
	  data.yAxis = {
	    title: { text: '' },
	    tickColor: '#000000',
	    offset: offsetVal,
	    opposite: oppositeVal,
	    gridLineDashStyle: horizontalGridLineStyle
	  };
	
	  if (true) {
	    if (options.product === 'wsj') {
	      data.xAxis.tickColor = options.styles.tick.color;
	    }
	  }
	  // data.yAxis.opposite = true;
	  // if (options.stacking === 'normal') {
	  // data.yAxis.max = 100;
	  // }
	  return data;
	}
	
	// Writes chart options for bar charts (i.e., horizontal bars).
	function writeHorizontalOptions(data, options, styles) {
	  if (Array.isArray(options.categories)) {
	    data.xAxis.categories = getCategoryLabels(options.categories[0]);
	  }
	  data.xAxis.tickLength = 0;
	  data.xAxis.offset = -2;
	  data.xAxis.lineWidth = 0;
	  data.yAxis.gridLineWidth = 1;
	
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.yAxis.gridLineWidth = 0.5;
	    }
	  }
	
	  var lineHeight = styles.BOLD_STYLE.fontSize;
	  data.xAxis.labels = {
	    style: (0, _lodash2.default)({}, styles.BOLD_STYLE, {
	      whiteSpace: 'wrap', textOverflow: 'visible', lineHeight: lineHeight
	    }),
	    // step: 1,
	    x: -7,
	    y: options.print ? 3 : undefined
	    // format: '{value}',
	  };
	
	  if (options.axes.shown) {
	    data.yAxis.reversedStacks = false;
	    data.yAxis.opposite = true;
	    data.yAxis.reversed = !!options.axes.reversed;
	    data.yAxis.labels = {
	      y: -5,
	      style: (0, _lodash2.default)({}, styles.NORMAL_STYLE, { whiteSpace: 'nowrap', textOverflow: 'visible`' }),
	      autoRotation: false,
	      formatter: function formatter() {
	
	        var special = options.axes.reversed && this.isLast || !options.axes.reversed && this.isFirst;
	        return formatterBarYAxisLabel(options.axes.units, this.value, special);
	      }
	    };
	  }
	
	  if (true) {
	    if (options.product === 'wsj') {
	      data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
	        fontSize: options.styles.axes.label.bar.x.fontSize,
	        fontWeight: options.styles.axes.label.bar.x.fontWeight,
	        lineHeight: options.styles.axes.label.bar.x.lineHeight
	      });
	
	      data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
	        fontSize: options.styles.axes.label.bar.y.fontSize,
	        fontWeight: options.styles.axes.label.bar.y.fontWeight,
	        lineHeight: options.styles.axes.label.bar.y.lineHeight
	      });
	    }
	  }
	
	  return data;
	}
	
	function formatterBarYAxisLabel(units, value, special) {
	  value = format.decimals(value, units);
	  value = format.commas(value, units);
	  var prefix = units.prefix || '';
	  var suffix = units.suffix || '';
	  if (prefix && value.charAt(0) === '-') {
	    // If value is negative, put the negative sign *before* the prefix.
	    value = '-' + prefix + value.substr(1);
	  } else {
	    value = '' + prefix + value;
	  }
	  if (special && suffix) {
	    value += suffix;
	  }
	  return value;
	}
	
	// Writes chart options for column charts (i.e, vertical bars) and charts for
	// which the axes are the same as for column charts (i.e., line charts).
	function writeVerticalOptions(data, options, styles) {
	  var Q = options.quarterlyResults;
	  isPrint = options.print;
	  var defaultXGridWidth = 0;
	  if (false) {
	    if (options.type === 'line' && options.product === 'marketwatch') {
	      data.xAxis.tickColor = '#fffff';
	      defaultXGridWidth = 1;
	    }
	    if (options.type === 'column' && options.product === 'marketwatch') {
	      data.xAxis.tickColor = '#fffff';
	    }
	  }
	  if (false) {
	    if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
	      data.xAxis.tickColor = '#fffff';
	    }
	  }
	
	  data.xAxis.tickWidth = 1;
	  data.xAxis.lineWidth = 0;
	  data.xAxis.gridLineWidth = defaultXGridWidth;
	  data.xAxis.minorGridLineWidth = defaultXGridWidth;
	  data.yAxis.gridLineWidth = 1;
	  data.yAxis.tickPixelInterval = parseFloat(styles.NORMAL_STYLE.lineHeight) * 3;
	  data.yAxis.reversed = !!options.axes.reversed;
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.xAxis.tickWidth = 0.5;
	      data.yAxis.gridLineWidth = 0.5;
	    }
	  }
	  var alignYAxis = 'right';
	  var yAxisXVal = -10;
	  var yAxisYVal = -5;
	  if (false) {
	    if ((options.product === 'marketwatch' || options.product === 'financialnews') && (options.type === 'line' || options.type === 'column')) {
	      alignYAxis = 'left';
	      yAxisXVal = 0;
	      yAxisYVal = -2.5;
	    }
	  }
	  if (false) {
	    if (options.product === 'financialnews') {
	      if (options.print === true && options.sizes['print-fn'].columns <= 2) {
	        styles.LIGHT_STYLE.fontSize = 7.75;
	      }
	    }
	  }
	  if (options.print === true && options.product === 'financialnews') {
	    styles.LIGHT_STYLE.color = '#000000';
	  }
	
	  data.yAxis.labels = {
	    style: isPrint ? styles.LIGHT_STYLE : styles.NORMAL_STYLE,
	    autoRotation: false,
	    align: alignYAxis,
	    x: yAxisXVal,
	    y: calculateYAxesLabelY(options, yAxisYVal),
	    formatter: function formatter() {
	      var tp = this.axis.tickPositions;
	      var decimalsDelta = Math.abs(tp[0] - tp[1]);
	      var decimalIndex = (decimalsDelta + '').indexOf('.');
	      var decimals = decimalIndex !== -1 ? (decimalsDelta + '').length - decimalIndex - 1 : 0;
	      if (decimals > 1) {
	        // Sometimes decimals are 17 or something outrageous, but decimalsDelta
	        // is something like 0.20000000000000002 which should be just 0.2.
	        // This fixes the issue.
	        var getFixedValues = function getFixedValues(n) {
	          return [decimalsDelta.toFixed(n) + '0', decimalsDelta.toFixed(n + 1)];
	        };
	        var n = 1;
	
	        var _getFixedValues = getFixedValues(n),
	            _getFixedValues2 = _slicedToArray(_getFixedValues, 2),
	            a = _getFixedValues2[0],
	            b = _getFixedValues2[1];
	
	        while (a !== b && n < 19) {
	          n += 1;
	
	          var _getFixedValues3 = getFixedValues(n);
	
	          var _getFixedValues4 = _slicedToArray(_getFixedValues3, 2);
	
	          a = _getFixedValues4[0];
	          b = _getFixedValues4[1];
	        }
	        decimals = n;
	      }
	      // special = should have prefix and/or suffix:
	      var special = options.axes.reversed && this.isFirst || !options.axes.reversed && this.isLast;
	      return formatterYAxisLabel(options.axes.units, this.value, decimals, special);
	    }
	  };
	
	  options.axes.tickStyle = options.axes.tickStyle || 'center';
	  data.xAxis.labels = {
	    style: isPrint ? styles.LIGHT_STYLE : styles.NORMAL_STYLE,
	    autoRotation: false,
	    maxStaggerLines: 1
	  };
	  data.xAxis.labels.style.textOverflow = 'visible';
	  if (!options.allowCategoriesLinebreak) {
	    data.xAxis.labels.style.whiteSpace = 'nowrap';
	  }
	  data.xAxis.labels.align = 'center';
	  data.xAxis.labels.y = styles.FONT_SIZE + 7;
	  data.xAxis.tickLength = styles.MEDIUM_TICK_LENGTH;
	
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.xAxis.labels.y -= 4;
	    }
	  }
	
	  if (Array.isArray(options.categories) && (Q || !options.categoriesAreDates)) {
	    data.xAxis.type = 'category';
	    data.xAxis.categories = getCategoryLabels(options.categories[0]);
	    data.xAxis.tickmarkPlacement = 'on';
	    if (Q) {
	      data.xAxis.labels.formatter = formatterQuarterlyResults(options);
	    }
	  }
	
	  if (options.categoriesAreDates && !Q) {
	    data.xAxis.labels.style.whiteSpace = 'nowrap';
	
	    if (options.fiscalYears) {
	      data.xAxis.tickInterval = _axesCommon.YEAR_MILLISECONDS;
	    } else if (options.quarterlyResults) {
	      data.xAxis.tickInterval = Math.round(_axesCommon.YEAR_MILLISECONDS / 4);
	    } else {
	      data.xAxis.tickInterval = getDatetimeTickInterval(data, options);
	    }
	    if (data.xAxis.tickInterval) {
	      data.xAxis.tickInterval = Math.round(data.xAxis.tickInterval);
	    }
	
	    data.xAxis.labels.formatter = function () {
	      return formatterDate(this, options, data.xAxis.tickInterval);
	    };
	    data.xAxis.type = 'datetime';
	  }
	
	  if (true) {
	    if (options.product === 'wsj') {
	      data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
	        fontSize: options.styles.axes.label.fontSize,
	        color: options.styles.axes.label.color,
	        fill: options.styles.axes.label.color
	      });
	
	      data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
	        fontSize: options.styles.axes.label.fontSize,
	        color: options.styles.axes.label.color,
	        fill: options.styles.axes.label.color
	      });
	
	      if (options.type === 'column' && !options.categoriesAreDates) {
	        data.xAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
	          fontSize: options.styles.axes.label.seriesAreNotDates.fontSize,
	          fontWeight: options.styles.axes.label.seriesAreNotDates.fontWeight,
	          lineHeight: options.styles.axes.label.seriesAreNotDates.lineHeight
	        });
	      }
	    }
	  }
	
	  return data;
	}
	
	function calculateYAxesLabelY(options, initialValue) {
	  if (true) {
	    if (options.product === 'wsj') {
	      if (options.size === 'print-wsj') {
	        if (options.type === 'line') {
	          return -2.5;
	        }
	
	        if (options.type === 'column') {
	          return -1.5;
	        }
	      }
	      // non print
	      return -2;
	    }
	  }
	
	  return initialValue;
	}
	
	// Returns correct spacing between ticks on x-axis depending.
	function getDatetimeTickInterval(context, options) {
	  if (options.datesAll) {
	    var currYear = void 0;
	    var yearsTraversed = 0;
	    var yearRepeated = false;
	
	    var currMonth = void 0;
	    var monthsTraversed = 0;
	    var monthRepeated = false;
	
	    var currDate = void 0;
	    var datesTraversed = 0;
	    var dateRepeated = false;
	
	    if (options.datesAll.year && !options.datesAll.month) {
	      var isYears = true;
	      for (var i = 0; isYears && i < options.dates.length; i++) {
	        if (currYear === undefined || options.dates[i].year !== currYear) {
	          currYear = options.dates[i].year;
	        } else if (options.dates[i].year === currYear) {
	          isYears = false;
	        }
	      }
	      return _axesCommon.YEAR_MILLISECONDS;
	    }
	
	    for (var _i = 0; _i < options.dates.length; _i++) {
	      // If data passes through >= 3 years but data is spaced less than a year
	      // apart, ensure that ticks are spaced by years.
	      if (options.datesAll.year && options.datesAll.month) {
	        if (currYear === undefined || options.dates[_i].year !== currYear) {
	          currYear = options.dates[_i].year;
	          yearsTraversed += 1;
	        } else if (!yearRepeated && options.dates[_i].year === currYear) {
	          yearRepeated = true;
	        }
	        if (yearRepeated && yearsTraversed >= 3) {
	          return _axesCommon.YEAR_MILLISECONDS;
	        }
	      }
	    }
	
	    for (var _i2 = 0; _i2 < options.dates.length; _i2++) {
	      // If data passes through >= 3 months but data is spaced less than a
	      // month apart, ensure that ticks are spaced by months.
	      if (options.datesAll.month && options.datesAll.date) {
	        if (currMonth === undefined || options.dates[_i2].month !== currMonth) {
	          currMonth = options.dates[_i2].month;
	          monthsTraversed += 1;
	        } else if (!monthRepeated && options.dates[_i2].month === currMonth) {
	          monthRepeated = true;
	        }
	        if (monthRepeated && monthsTraversed >= 3) {
	          return 1000 * 60 * 60 * 24 * 30;
	        }
	      }
	    }
	
	    for (var _i3 = 0; _i3 < options.dates.length; _i3++) {
	      // If data passes through >= 3 dates but data is spaced less than a day
	      // apart, ensure that ticks are spaced by days.
	      if (options.datesAll.date) {
	        if (currDate === undefined || options.dates[_i3].date !== currDate) {
	          currDate = options.dates[_i3].date;
	          datesTraversed += 1;
	        } else if (!dateRepeated && options.dates[_i3].date === currDate) {
	          dateRepeated = true;
	        }
	        if (dateRepeated && datesTraversed >= 3) {
	          return 1000 * 60 * 60 * 24;
	        }
	      }
	    }
	
	    if (options.datesAll.hour && !options.datesAll.year && !options.datesAll.month) {
	      var fd = options.dates[0];
	      var ld = options.dates[options.dates.length - 1];
	      var d1 = new Date();
	      var d2 = new Date();
	      var hour = 1000 * 60 * 60;
	      d1.setUTCHours(fd.hour);
	      d1.setUTCMinutes(fd.minute);
	      d2.setUTCHours(ld.hour);
	      d2.setUTCMinutes(ld.minute);
	      if (d2.valueOf() - d1.valueOf() > hour) {
	        return hour;
	      }
	    }
	  }
	  return null;
	}
	
	// A Highcharts `formatter` function to formate x-axis dates.
	function formatterDate(context, options, interval) {
	  // INDEX = (INDEX >= options.series[0].data.length) ? 0 : INDEX;
	  // const index = INDEX++;
	  var index = getDataIndex(context.value, options.series[0].data, interval);
	
	  // This gives some whack results...
	  // const date = new Date(context.value);
	
	  // ...therefore, track the index of this tick:
	  // options.xAxisLabelIndex = options.xAxisLabelIndex || 0;
	  // options.xAxisLabelIndex %= options.series[0].data.length;
	  // const index = options.xAxisLabelIndex;
	  // const date = new Date(options.series[0].data[index].x);
	  var date = new Date(context.value);
	  // options.xAxisLabelIndex += 1;
	
	  options.dateTimeLabelFormat = context.dateTimeLabelFormat;
	  var dateObj = options.dates[index];
	
	  switch (context.dateTimeLabelFormat) {
	    case '%H:%M':
	    case '%H:%M:%S':
	      var incSecs = false; //context.dateTimeLabelFormat === '%H:%M:%S';
	      options.series[0].data[index].xAxisLabel = formatHM(date, incSecs);
	      return formatHM(date, incSecs);
	    case '%e. %b':
	      options.series[0].data[index].xAxisLabel = [_constants.MONTHS[date.getUTCMonth()], date.getUTCDate()].join(' ');
	      return [_constants.MONTHS[date.getUTCMonth()], date.getUTCDate()].join(' ');
	    case '%b \'%y':
	      if (options.dates[index].yearIsProxy) {
	        options.series[0].data[index].xAxisLabel = _constants.MONTHS[date.getUTCMonth()];
	        return _constants.MONTHS[date.getUTCMonth()];
	      } else {
	        options.series[0].data[index].xAxisLabel = [_constants.MONTHS[date.getUTCMonth()], '’' + (date.getUTCFullYear() + '').substr(2)].join(' ');
	        return [_constants.MONTHS[date.getUTCMonth()], '’' + (date.getUTCFullYear() + '').substr(2)].join(' ');
	      }
	    case '%Y':
	      // console.log(index, date.getUTCFullYear(), date.getFullYear(), realDate.getFullYear());
	      options.series[0].data[index].xAxisLabel = date.getUTCFullYear() + '';
	      //(dateObj.year || realDate.getUTCFullYear()) + '';
	      // return dateObj.year || (date.getFullYear() + '');
	      return date.getUTCFullYear() + '';
	  }
	  options.series[0].data[index].xAxisLabel = '0';
	  return '0';
	}
	
	function getDataIndex(value, data, interval) {
	  var index = 0;
	  for (var i = 0; i < data.length; i++) {
	    index = i;
	    if (value < data[i].x) {
	      break;
	    }
	  }
	  return index;
	}
	
	function formatHM(date, includeSeconds) {
	  var h = date.getUTCHours();
	  var a = h < 12 ? ' a.m.' : ' p.m.';
	  var m = (0, _zero.addZeroes)(date.getUTCMinutes(), 2);
	  var s = includeSeconds ? (0, _zero.addZeroes)(date.getUTCSeconds(), 2) : null;
	  if (h === 12 && m == '00') {
	    return 'noon';
	  }
	  if (h === 0) {
	    h = 12;
	  } else {
	    h %= 12;
	  }
	  m = m === '00' ? '' : ':' + m;
	  s = includeSeconds ? ':' + s : '';
	  return [h, m, s, a].join('');
	}
	
	// Used as Highcharts `formatter` function (not directly).
	function formatterYAxisLabel(units, value, minDecimals, special) {
	  value += '';
	  var decimalUnits = (0, _lodash2.default)({}, units);
	  if (units.forceDecimals !== undefined) {
	    decimalUnits.forceDecimals = Math.max(units.forceDecimals, minDecimals);
	  }
	  if (units.maxDecimals !== undefined) {
	    decimalUnits.maxDecimals = Math.max(units.maxDecimals, minDecimals);
	  }
	  value = format.decimals(value, decimalUnits);
	  value = format.commas(value, units.commas);
	  if (special) {
	    var neg = '';
	    if (units.prefix && value.charAt(0) === '-') {
	      neg = '-';
	      value = value.substr(1);
	    }
	    value = [neg, units.prefix, value].join('');
	  }
	  return value;
	}
	
	// A Highcharts `formatter` function that returns 'nQ<br/>YYYY'.
	function formatterQuarterlyResults(options) {
	  var rows = options.series[0].data.length;
	  var quarter = undefined;
	  var year = undefined;
	  return function () {
	    var value = '';
	    var parts = this.value.split(/\s/);
	    var tmpQ = parts[0] || null;
	    var tmpY = parts[1] || null;
	    var FY = tmpY ? tmpY.indexOf('FY') === 0 : false;
	    if (FY) {
	      tmpY = tmpY.substr(2);
	    }
	    if (this.isFirst) {
	      // Sometimes Highcharts runs through the date *twice*!
	      quarter = year = undefined;
	    }
	    if (tmpQ && rows <= 9 && options.interactive) {
	      value += tmpQ;
	    }
	    if (tmpY) {
	      if (value !== '') {
	        value += '<br>';
	      }
	      if (tmpY !== year) {
	        if (year === undefined) {
	          value += (FY ? 'FY' : '') + tmpY;
	        } else {
	          value += _constants.APOSTROPHE + tmpY.substr(2, 4);
	        }
	      }
	    }
	    quarter = tmpQ;
	    year = tmpY;
	    return value;
	  };
	}
	
	// Returns an array of category objects as an array of strings for use as the
	// value for `data[x|yAxis].categories`.
	function getCategoryLabels(categories) {
	  var strings = [];
	  // console.log(categories);
	  if (categories) {
	    categories.forEach(function (cat, index) {
	      if (typeof cat === 'string' || typeof cat === 'number') {
	        strings[index] = cat + '';
	      } else if (cat && (typeof cat === 'undefined' ? 'undefined' : _typeof(cat)) === 'object') {
	        strings[index] = cat.text;
	      } else {
	        strings[index] = null;
	      }
	    });
	  }
	  return strings;
	}
	
	// Attempts to allow manual tweaking of min and max axis values, but does not
	// quite do what is requested: Set an *absolute* max and min, whereas
	// Highcharts uses the values as a guide.
	function writeMinMax(data, options) {
	  if (options.type !== 'pie') {
	    if (options.axes.minYAxisValue !== undefined) {
	      data.yAxis.min = options.axes.minYAxisValue;
	    }
	    if (options.axes.maxYAxisValue !== undefined) {
	      data.yAxis.max = options.axes.maxYAxisValue;
	    }
	  }
	  return data;
	}
	
	// Finds if yAxis.min should be set automatically so as to ensure that
	// a zero line is included.
	function valuesBelowPositive2(options) {
	  var found = false;
	  for (var s = 0; s < options.series.length; s++) {
	    for (var d = 0; d < options.series[s].data.length; d++) {
	      if (options.series[s].data[d].y < 0) {
	        return false;
	      } else if (!found && options.series[s].data[d].y <= 2) {
	        found = true;
	      }
	    }
	  }
	  return found;
	}
	
	// Finds if yAxis.max should be set automatically so as to ensure that
	// a zero line is included.
	function valuesAboveNegative2(options) {
	  var found = false;
	  for (var s = 0; s < options.series.length; s++) {
	    for (var d = 0; d < options.series[s].data.length; d++) {
	      if (options.series[s].data[d].y > 0) {
	        return false;
	      } else if (!found && options.series[s].data[d].y <= -2) {
	        found = true;
	      }
	    }
	  }
	  return found;
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _axesPrerender = __webpack_require__(28);
	
	var _axesPrerender2 = _interopRequireDefault(_axesPrerender);
	
	var _axesPostrender = __webpack_require__(27);
	
	var _axesPostrender2 = _interopRequireDefault(_axesPostrender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = null;
	
	function preRender(data, options) {
	  styles = writeStyles(options);
	  return (0, _axesPrerender2.default)(data, options, styles);
	}
	
	function postRender(highchart, options) {
	  return (0, _axesPostrender2.default)(highchart, options, styles);
	}
	
	// Writes styles constants used throughout axes processing.
	function writeStyles(options) {
	  var defaultOptions = {
	    FONT_SIZE: parseFloat(options.styles.size.normal),
	    NORMAL_STYLE: options.styles.get('normal'),
	    LIGHT_STYLE: options.styles.get('normal', {
	      fontFamily: options.styles.font.light,
	      fontWeight: options.styles.weight.light
	    }),
	    BOLD_STYLE: options.styles.get('normal', {
	      fontFamily: options.styles.font.bold,
	      fontWeight: options.styles.weight.bold
	    }),
	    SHORT_TICK_LENGTH: 4,
	    MEDIUM_TICK_LENGTH: 7,
	    LONG_TICK_LENGTH: parseFloat(options.styles.size.normal) + 5,
	    MARGIN: 3
	  };
	
	  if (false) {
	    if (options.product === 'marketwatch') {
	      return Object.assign({}, defaultOptions, {
	        NORMAL_STYLE: options.styles.get('normal', {
	          fontFamily: options.styles.font.semibold,
	          fontWeight: options.styles.weight.semibold
	        })
	      });
	    }
	  }
	
	  if (true) {
	    if (options.product === 'wsj') {
	      var hideTicks = !options.categoriesAreDates && options.type === 'column';
	
	      return Object.assign({}, defaultOptions, {
	        SHORT_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.shortSize,
	        MEDIUM_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.mediumSize,
	        FONT_SIZE: options.styles.axes.label.fontSize,
	        LONG_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.longSize,
	        AXES: options.styles.axes
	      });
	    }
	  }
	
	  return defaultOptions;
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _chartUtil = __webpack_require__(6);
	
	/**
	 * Adds options for LINE charts.
	 */
	function preRender(data, options) {
	  data.plotOptions.area = {
	    lineWidth: options.series.length > 1 ? 1 : 0,
	    lineColor: '#fff',
	    linecap: 'square',
	    fillOpacity: 1.0,
	    enableMouseTracking: options.interactive,
	    stacking: options.stacking,
	    states: {
	      hover: {
	        halo: {
	          opacity: 1,
	          size: 4
	        },
	        lineWidthPlus: 0
	      }
	    }
	  };
	  data.plotOptions.series = {
	    marker: {
	      symbol: 'circle',
	      radius: 0,
	      lineWidth: 0,
	      lineColor: null
	    }
	  };
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.plotOptions.area.lineWidth = 1.5;
	      // data.plotOptions.area.linecap = 'butt';
	    }
	  }
	  return data;
	}
	
	function postRender(highchart, options) {
	  roundLineJoins(highchart, options);
	}
	
	function roundLineJoins(highchart, options) {
	  var selector = 'g.highcharts-series-group g.highcharts-series path';
	  var paths = highchart.container.querySelectorAll(selector);
	  for (var i = 0; i < paths.length; i++) {
	    paths[i].setAttribute('stroke-linejoin', 'bevel');
	    if (true) {
	      if (options.size === 'print-wsj') {
	        paths[i].setAttribute('stroke-linecap', 'butt');
	      }
	    }
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
	  }
	}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _chartUtil = __webpack_require__(6);
	
	/**
	 * Adds options for BAR and COLUMN charts.
	 */
	
	function preRender(data, options) {
	  var bar = data.plotOptions[options.type];
	  bar.stacking = options.stacking;
	  bar.marker = {
	    enabled: false
	  };
	  bar.borderWidth = 0;
	  // data = adjustBarsWidth(data, options);
	  data.plotOptions[options.type].pointPadding = 0.125;
	  data.plotOptions[options.type].groupPadding = options.series.length > 1 && options.stacking === null ? 0.2 : 0;
	  return data;
	}
	
	// For bar charts, tweaks the spacing between bars.
	// function adjustBarsWidth(data, options) {
	//   if (options.type === 'column') {
	//     const c = data.plotOptions[options.type];
	//     const seriesLen = options.stacking ? 1 : data.series.length;
	//     let maxDataLen = 0;
	//     data.series.forEach(item => {
	//       maxDataLen = Math.max(maxDataLen, item.data.length);
	//     });
	//     const yAxisEstimate = getYAxisEstimatedWidth(data, options);
	//     const xAxisWidth = options.width - yAxisEstimate;
	//     const bars = seriesLen * maxDataLen;
	//     const groupBars = (seriesLen > 1) ? (maxDataLen - 1) : 0;
	//     const pointBars = (seriesLen === 1) ? (maxDataLen - 1) :
	//       (maxDataLen * (seriesLen - 1));
	
	//     const adjustedGroupBars = groupBars * 2;
	//     // designed = 0.25 :
	//     const adjustedPointBars = pointBars * (0.35 + 0.2 * seriesLen);
	
	//     c.pointWidth = Math.max(2, xAxisWidth /
	//       (bars + adjustedGroupBars + adjustedPointBars));
	
	//     // if (options.legend.enabled && options.legend.layout === 'right') {
	//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.25);
	//     // } else {
	//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.5)
	//     // }
	
	
	//     // let factorToSubtractBy = 0;
	
	//     // if (data.series[0].data.length > 100) {
	//     //   if (options.width < 500) {
	//     //     factorToSubtractBy = 0.95;
	//     //   }
	//     //   if (options.width < 620 && options.width > 500) {
	//     //     factorToSubtractBy = 0.75;
	//     //   }
	//     //   if (options.width >= 620) {
	//     //     factorToSubtractBy = 0.25;
	//     //   }
	//     // }
	
	//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length > 100) {
	//     //   if (options.width < 500) {
	//     //     factorToSubtractBy = 0.95;
	//     //   }
	//     //   if (options.width < 620 && options.width > 500) {
	//     //     factorToSubtractBy = 0.9;
	//     //   }
	//     //   if (options.width === 620) {
	//     //     factorToSubtractBy = 0.7;
	//     //   }
	//     //   if (options.width > 620) {
	//     //     factorToSubtractBy = 0.25;
	//     //   }
	//     // }
	
	//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length < 100) {
	//     //   factorToSubtractBy = options.width < 420 ? 0.35 : 0.25;
	//     // }
	
	//     // c.pointWidth = c.pointWidth - (c.pointWidth * factorToSubtractBy);
	//     // c.pointPadding = 0.5;
	//     // c.groupPadding = 0;
	
	//   }
	//   return data;
	// }
	
	function getYAxisEstimatedWidth(data, options) {
	  var maxNum = 0;
	  data.series.forEach(function (series) {
	    for (var i = 0; i < series.data.length; i++) {
	      maxNum = Math.max(maxNum, series.data[i].y);
	    }
	  });
	  maxNum = (Math.round(maxNum) + '').length;
	  var units = options.axes.units;
	  var forceDecimals = units.forceDecimals !== undefined ? units.forceDecimals : 0;
	  var maxDecimals = units.maxDecimals !== undefined ? units.maxDecimals : Number.MAX_VALUE;
	  var len = maxNum + Math.min(forceDecimals, maxDecimals);
	  var fontSize = parseFloat(options.styles.normal.fontSize) * 0.5;
	  return len * fontSize;
	}
	
	function postRender(highchart, options) {
	  if (options.type === 'column') {
	    adjustBarSpacing(highchart, options);
	  }
	  stylizeStacks(highchart, options);
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
	  }
	}
	
	// Tweak spacing to improve rounding/pixel issues.
	function adjustBarSpacing(highchart, options) {
	  var axis = highchart.yAxis[0];
	  var delta = {
	    index1: -1,
	    index2: -1
	  };
	  // Set X for each bar to NOT rounded position. I thought this would look
	  // terrible, but it's fine.
	  var seriesLen = axis.series.length;
	  axis.series.forEach(function (series) {
	    for (var i = 0; i < series.data.length; i++) {
	      var point = series.data[i];
	      if (point.graphic) {
	        point.graphic.element.setAttribute('x', point.barX);
	        // Measure the distance between bars:
	        if (delta.index1 === -1) {
	          delta.index1 = i;
	          delta.bar1 = point.barX;
	        } else if (delta.index2 === -1) {
	          if (delta.index1 < i - 1) {
	            delta.index1 = -1;
	          } else {
	            delta.index2 = i;
	            delta.bar2 = point.barX - point.pointWidth;
	          }
	        }
	      }
	    }
	  });
	  // if (delta.index1 !== -1 && delta.index2 !== -1) {
	  //   // If bars are too close together, merge them:
	  //   const deltaPx = delta.bar2 - delta.bar1;
	  //   console.log(deltaPx);
	  //   const hasOverOneFiftyDataPoints = options.series[0].data.length > 150 ? 1.5 : 0.5;
	  //   console.log(deltaPx, options.size);
	  //   if (deltaPx < hasOverOneFiftyDataPoints) {
	  //     axis.series.forEach(series => {
	  //       for (let i = 0; i < series.data.length; i++) {
	  //         const point = series.data[i];
	  //         if (point.graphic) {
	  //           let isLegendRight = options.legend.enabled && options.legend.layout === 'right' ? 0.25 : 0.125;
	  //           isLegendRight = options.series[0].data.length > 150 ? isLegendRight + 0.05 : isLegendRight;
	  //           point.graphic.element.setAttribute('x', point.barX + (deltaPx / 2));
	  //           point.graphic.element.setAttribute('width', point.pointWidth - deltaPx);
	  //         }
	  //       }
	  //     });
	  //   }
	  // }
	}
	
	// If stacking is enabled, adjust the style of the stacks.
	function stylizeStacks(highchart, options) {
	  if (options.stacking) {
	    highchart.yAxis[0].series.forEach(function (series) {
	      series.data.forEach(function (item) {
	        if (item.graphic) {
	          var el = item.graphic.element;
	          var px = parseFloat(el.attributes.height.value);
	          if (px > 0) {
	            el.setAttribute('height', px - 1);
	          }
	        }
	      });
	    });
	  }
	}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _chartUtil = __webpack_require__(6);
	
	/**
	 * Adds options for LINE charts.
	 */
	function preRender(data, options) {
	  data.plotOptions.line = {
	    lineWidth: 3,
	    linecap: 'square',
	    enableMouseTracking: options.interactive,
	    states: {
	      hover: {
	        halo: {
	          opacity: 1,
	          size: 4
	        },
	        lineWidthPlus: 0
	      }
	    }
	  };
	  data.plotOptions.series = {
	    marker: {
	      symbol: 'circle',
	      radius: 0,
	      lineWidth: 0,
	      lineColor: null
	    }
	  };
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.plotOptions.line.lineWidth = 1.5;
	      data.plotOptions.line.linecap = 'round';
	    }
	  }
	  return data;
	}
	
	function postRender(highchart, options) {
	  roundLineJoins(highchart);
	}
	
	function roundLineJoins(highchart) {
	  var selector = 'g.highcharts-series-group g.highcharts-series path';
	  var paths = highchart.container.querySelectorAll(selector);
	  for (var i = 0; i < paths.length; i++) {
	    paths[i].setAttribute('stroke-linejoin', 'bevel');
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
	  }
	}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _transform = __webpack_require__(4);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _chartUtil = __webpack_require__(6);
	
	var _format = __webpack_require__(3);
	
	var format = _interopRequireWildcard(_format);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var TOP_LEFT = 0; /**
	                   * Adds options for PIE charts.
	                   */
	
	var TOP_RIGHT = 1;
	var BOTTOM_RIGHT = 2;
	var BOTTOM_LEFT = 3;
	
	var PERC_MARGIN = 4;
	var LABEL_MARGIN = 10;
	
	function preRender(data, options) {
	  options = writeDataNames(options);
	  var arrayofYValues = data.series[0].data;
	  var sumofYValues = 0;
	  arrayofYValues.forEach(function (data) {
	    sumofYValues += data.y;
	  });
	  arrayofYValues.forEach(function (data) {
	    data.y = data.y / sumofYValues;
	    data.y = format.decimals(data.y, options.axes.units);
	    data.y = parseFloat(data.y * 100);
	    if (data.y.toString().length > 4) {
	      data.y = Math.round(data.y);
	    }
	  });
	  data.plotOptions.pie = {
	    dataLabels: { enabled: false },
	    enableMouseTracking: options.interactive,
	    showInLegend: true,
	    minSize: minSize(data, options),
	    center: ['50%', '50%'],
	    states: {
	      hover: {
	        enabled: false
	      }
	    }
	  };
	  return data;
	}
	
	// Writes the categories into the series[0] data so that they are available
	// for data labels.
	function writeDataNames(options) {
	  options.series[0].data.forEach(function (item, index) {
	    if (options.type === 'pie' && options.optimizeDataOrder) {
	      item.name = options.longCategories[item.originalIndex];
	    } else {
	      item.name = options.longCategories[index];
	    }
	  });
	  return options;
	}
	
	// Set a minimum radius for the chart to render.
	function minSize(data, options) {
	  return Math.min(options.height - data.chart.spacing[0] - data.chart.spacing[2], options.width - data.chart.spacing[3] - data.chart.spacing[1]) * 0.5;
	}
	
	/**
	 * Draws the data labels using custom methods instead of Highcharts.
	 * 1) Draw labels into corners of quadrants.
	 * 2) Resize and move pie chart based on data labels locations.
	 * 3) Draw connectors.
	 */
	function postRender(highchart, options) {
	  if (options.legend.enabled && options.size.indexOf('thumb') !== 0) {
	    var g = drawLabelsGroup(highchart);
	    var rect = getPieRect(highchart);
	    if (rect) {
	      var labels = drawLabels(highchart, options, g, rect);
	      if (labels.length) {
	        var sorted = sortLabels(labels);
	        sorted = positionLabels(highchart, sorted, rect);
	        var resizedRect = resizeChart(highchart, rect, sorted, labels[0].lineHeight);
	        truncateLabels(highchart, labels, resizedRect);
	        improveLabelPositions(highchart, labels, resizedRect);
	        if (options.product === 'financialnews') {
	          makeDonutChart(highchart, options);
	        }
	      }
	    }
	  }
	}
	
	// Creates a `g` element to contain the data labels, translated to the same
	// position as the pie chart.
	function drawLabelsGroup(highchart) {
	  var gPieSelector = '.highcharts-series-group .highcharts-series';
	  var gPie = highchart.container.querySelector(gPieSelector);
	  var g = highchart.renderer.g().add();
	  g.element.setAttribute('transform', gPie.getAttribute('transform'));
	  g.element.setAttribute('class', 'pie-chart-data-labels');
	  return g;
	}
	
	function drawLabels(highchart, options, g, rect) {
	  var labels = [];
	  var data = highchart.series[0].data;
	  var smallSize = isSmall(options.size);
	  var styleLabel = options.styles.get(smallSize ? 'small' : 'normal', {
	    fontFamily: options.styles.font.bold,
	    fontWeight: options.styles.weight.bold
	  });
	  var stylePerc = options.styles.get(smallSize ? 'small' : 'normal');
	  var lineHeight = parseFloat(styleLabel.fontSize);
	  var pi2 = Math.PI * 2;
	
	  for (var i = 0; i < data.length; i++) {
	    var slice = data[i];
	    labels[i] = {};
	    labels[i].slice = slice;
	    labels[i].radians = (slice.angle + pi2) % pi2;
	    labels[i].styleLabel = options.styles.get(smallSize ? 'small' : 'normal', {
	      fontFamily: options.styles.font.bold,
	      fontWeight: options.styles.weight.bold
	    });
	    labels[i].stylePerc = options.styles.get(smallSize ? 'small' : 'normal', {});
	    labels[i].g = highchart.renderer.g().add(g);
	
	    // const labelName = getLabelName(slice, options);
	    labels[i].labelName = highchart.renderer.text(slice.name, 0, 0).css(labels[i].styleLabel).add(labels[i].g);
	    labels[i].labelPerc = highchart.renderer.text(slice.y + '%', labels[i].labelName.element.getBoundingClientRect().width + PERC_MARGIN, 0).css(labels[i].stylePerc).add(labels[i].g);
	    labels[i].lineHeight = smallSize ? 14 : parseFloat(styleLabel.lineHeight);
	    var isMW = options.product === 'marketwatch';
	    var isFN = options.product === 'financialnews';
	    var widthVal = isMW ? 12 : 9;
	    var heightVal = isMW ? 12 : 13;
	    if (!isFN) {
	      highchart.renderer.rect().attr({
	        width: widthVal,
	        height: heightVal,
	        fill: slice.color
	      }).add(labels[i].g);
	    } else {
	      highchart.renderer.circle(5, -4, widthVal / 2).attr({
	        fill: slice.color
	      }).add(labels[i].g);
	    }
	
	    var xVal = isMW ? 15 : 12;
	    var yVal = isMW ? -10 : -12;
	    labels[i].g.element.lastElementChild.setAttribute('x', 0);
	    labels[i].g.element.firstElementChild.setAttribute('x', xVal);
	    var percentageCurrentX = Number(labels[i].g.element.children[1].getAttribute('x'));
	    labels[i].g.element.children[1].setAttribute('x', percentageCurrentX + xVal);
	    labels[i].g.element.lastElementChild.setAttribute('y', yVal);
	  }
	
	  return labels;
	}
	
	// function getLabelName(slice, options) {
	//   if (options.optimizeDataOrder && Array.isArray(options.categories) &&
	//       options.categories.length) {
	//     return options.categories[0][slice.originalIndex] || slice.name;
	//   }
	//   return slice.name
	// }
	
	
	// Sorts labels intro quadrants.
	function sortLabels(labels, rect) {
	  var BR = [];
	  var BL = [];
	  var TL = [];
	  var TR = [];
	
	  labels = labels.sort(sortOnRadians);
	  for (var i = 0; i < labels.length; i++) {
	    var r = labels[i].radians;
	    if (r > 0 && r <= Math.PI * 0.5) {
	      BR.push(labels[i]);
	    } else if (r > Math.PI * 0.5 && r < Math.PI) {
	      BL.push(labels[i]);
	    } else if (r >= Math.PI && r < Math.PI * 1.5) {
	      TL.push(labels[i]);
	    } else {
	      TR.push(labels[i]);
	    }
	  }
	
	  if (TR.length === 0 && BR.length) {
	    TR.push(BR.shift());
	  }
	  BR.reverse();
	  TL.reverse();
	  return { BR: BR, BL: BL, TL: TL, TR: TR };
	}
	
	function positionLabels(highchart, sorted, rect) {
	  // Top right
	  var x = void 0;
	  var y = 0;
	  sorted.TR.forEach(function (label) {
	    label.x = getRightX(highchart, label);
	    label.y = y + label.lineHeight;
	    transform.write(label.g.element, 'translate', label.x, label.y);
	    y += label.lineHeight;
	  });
	
	  // Bottom right
	  y = getBottomY(highchart);
	  sorted.BR.forEach(function (label) {
	    label.x = getRightX(highchart, label);
	    label.y = y;
	    transform.write(label.g.element, 'translate', label.x, label.y);
	    y -= label.lineHeight;
	  });
	
	  // Bottom left
	  x = getLeftX(highchart);
	  y = getBottomY(highchart);
	  sorted.BL.forEach(function (label) {
	    label.x = x;
	    label.y = y;
	    transform.write(label.g.element, 'translate', label.x, label.y);
	    y -= label.lineHeight;
	  });
	
	  // Top left
	  y = 0;
	  sorted.TL.forEach(function (label) {
	    label.x = x;
	    label.y = y + label.lineHeight;
	    transform.write(label.g.element, 'translate', label.x, label.y);
	    y += label.lineHeight;
	  });
	  return sorted;
	}
	
	// Returns default label left x.
	function getLeftX(highchart) {
	  return 0; //highchart.plotLeft;
	}
	
	// Returns default label right x.
	function getRightX(highchart, label) {
	  return highchart.plotLeft + highchart.plotWidth - highchart.spacing[1] - label.g.element.getBoundingClientRect().width;
	}
	
	// Returns default label bottom y.
	function getBottomY(highchart) {
	  return highchart.plotHeight - LABEL_MARGIN; // - highchart.spacing[2];
	}
	
	// Scales the chart down to compensate for labels.
	function resizeChart(highchart, rect, sorted, lineHeight) {
	  var maxLabelsTop = Math.max(sorted.TL.length, sorted.TR.length);
	  var maxLabelsBot = Math.max(sorted.BL.length, sorted.BR.length);
	  var newHeight = rect.height - (maxLabelsTop + maxLabelsBot) * lineHeight;
	  newHeight = Math.max(newHeight, Math.min(highchart.plotWidth * 0.6, highchart.plotHeight * 0.6));
	
	  var scaleRatio = newHeight / rect.height;
	  var pieG = highchart.series[0].data[0].graphic.parentGroup;
	  var pieContainer = pieG.element.parentElement;
	  var translate = transform.read(pieG.element, 'translate');
	  var x = (highchart.chartWidth - highchart.chartWidth * scaleRatio) * 0.5;
	  var y = translate[1];
	  y += maxLabelsTop * lineHeight;
	  // y += (rect.height - newHeight) / 2;
	
	  transform.write(pieG.element, 'translate', translate[0], 0);
	  pieContainer.setAttribute('transform', ['matrix(', scaleRatio, ',0,0,', scaleRatio, ',', x, ',', y, ')'].join(''));
	
	  var r = {
	    width: rect.width * scaleRatio
	  };
	  r.height = r.width;
	  r.left = rect.center - r.width / 2 + highchart.spacing[3];
	  r.center = rect.center;
	  r.right = r.left + r.width;
	  r.top = y + 10 * scaleRatio;
	  r.middle = r.top + r.height / 2;
	  r.bottom = r.top + r.height;
	  // debugRect(highchart, r.left, r.top, r.width, r.height);
	  return r;
	}
	
	// Truncate any labels that overlap the pie chart with '…'.
	function truncateLabels(highchart, labels, rect) {
	  var labelsLen = labels.length;
	  if (labelsLen) {
	    var parentGroup = labels[0].g.element.parentElement;
	    var parentTop = transform.read(parentGroup, 'translate')[1];
	
	    for (var i = 0; i < labelsLen; i++) {
	      var label = labels[i];
	      parentGroup = parentGroup || label.g.element.parentElement;
	      var labelRect = label.g.element.getBoundingClientRect();
	      label.bounds = {
	        x: label.x + highchart.spacing[3],
	        y: label.y + parentTop - parseFloat(label.styleLabel.fontSize) + highchart.spacing[0],
	        width: labelRect.width,
	        height: labelRect.height
	      };
	      // debugRect(highchart, testRect.x, testRect.y, testRect.width, testRect.height);
	
	      var maxWidth;
	      if (label.bounds.y > rect.top && label.bounds.y < rect.bottom) {
	        // Label is next to pie chart.
	        if (label.x < rect.left) {
	          maxWidth = rect.left - label.x - LABEL_MARGIN;
	          truncateLabelLeft(labelRect, label, rect.left - label.x - LABEL_MARGIN);
	        } else {
	          maxWidth = highchart.chartWidth - highchart.spacing[1] - rect.right;
	          truncateLabelRight(labelRect, label, label.bounds.x + labelRect.width, maxWidth);
	        }
	      } else {
	        // Label is above or below the pie.
	        if (label.radians > Math.PI / 2 && label.radians < Math.PI * 1.5) {
	          maxWidth = rect.center - label.x - LABEL_MARGIN;
	          truncateLabelLeft(labelRect, label, maxWidth);
	        } else {
	          maxWidth = highchart.chartWidth - highchart.spacing[1] - rect.center;
	          truncateLabelRight(labelRect, label, label.bounds.x + labelRect.width, maxWidth);
	        }
	      }
	    }
	  }
	}
	
	function truncateLabelLeft(labelRect, label, maxWidth) {
	  var tspan = label.labelName.element.querySelector('tspan') || label.labelName.element;
	  var s = label.labelName.textStr;
	  var n = s.length - 2;
	  while (labelRect.width > maxWidth && n > 0) {
	    s = s.substr(0, n--);
	    tspan.innerHTML = s + '…';
	    label.labelPerc.element.setAttribute('x', label.labelName.element.getBoundingClientRect().width + PERC_MARGIN);
	    labelRect = label.g.element.getBoundingClientRect();
	  }
	}
	
	function truncateLabelRight(labelRect, label, rightX, maxWidth) {
	  var tspan = label.labelName.element.querySelector('tspan') || label.labelName.element;
	  var s = label.labelName.textStr;
	  var n = s.length - 2;
	  while (labelRect.width > maxWidth && n > 0) {
	    s = s.substr(0, n--);
	    tspan.innerHTML = s + '…';
	    label.labelPerc.element.setAttribute('x', label.labelName.element.getBoundingClientRect().width + PERC_MARGIN);
	    labelRect = label.g.element.getBoundingClientRect();
	  }
	  var translate = transform.read(label.g.element, 'translate');
	  transform.write(label.g.element, 'translate', rightX - labelRect.width, translate[1]);
	}
	
	// Moves labels closer to the chart, if possible.
	function improveLabelPositions(highchart, labels, rect) {
	  var L = [];
	  var R = [];
	  var maxL = 0;
	  var maxR = 0;
	  for (var i = 0; i < labels.length; i++) {
	    var label = labels[i];
	    if (label.radians > Math.PI * 0.5 && label.radians < Math.PI * 1.5) {
	      L.push(label);
	      maxL = Math.max(maxL, label.bounds.width);
	    } else {
	      R.push(label);
	      maxR = Math.max(maxR, label.bounds.width);
	    }
	  }
	  var delta = rect.left - LABEL_MARGIN - maxL;
	  if (delta > 0) {
	    L.forEach(function (item) {
	      var t = transform.read(item.g.element, 'translate');
	      transform.write(item.g.element, 'translate', t[0] + delta, t[1]);
	    });
	  }
	  delta = highchart.chartWidth - (rect.right + LABEL_MARGIN) - maxR;
	  if (delta > 0) {
	    R.forEach(function (item) {
	      var t = transform.read(item.g.element, 'translate');
	      transform.write(item.g.element, 'translate', t[0] - delta, t[1]);
	    });
	  }
	}
	
	// We decided, at least for the moment, not to do this.
	function connectLabels(highchart, rect, labels) {}
	//
	
	
	// For sorting the labels from top to bottom.
	function sortOnY(a, b) {
	  // var ta = transform.read(a.dataLabel.element, 'translate')[1];
	  // var tb = transform.read(b.dataLabel.element, 'translate')[1];
	  // return ta - tb;
	  return a.y - b.y;
	}
	
	// Sorts the labels clockwise around the pie, starting at 3 o'clock. The
	// radians should already have been normalized to a number >= 0 and
	// <= Math.PI * 2.
	function sortOnRadians(a, b) {
	  return a.radians - b.radians;
	}
	
	// Returns position and dimensions of the pie graphic.
	function getPieRect(highchart) {
	  var d = highchart.series[0].data[0];
	  var g = !!d ? d.graphic : null;
	  if (g) {
	    var r = {
	      left: g.x - g.r,
	      top: g.y - g.r
	    };
	    r.width = g.r * 2;
	    r.height = r.width;
	    r.right = r.left + r.width;
	    r.bottom = r.top + r.height;
	    r.center = r.left + r.width / 2;
	    r.middle = r.top + r.height / 2;
	    return r;
	  }
	  return null;
	}
	
	function debugRect(highchart, x, y, width, height) {
	  return highchart.renderer.rect(x, y, width, height).attr({
	    'stroke-width': 1,
	    'stroke': 'red',
	    'fill': 'rgba(255, 255, 255, 0)'
	  }).add();
	}
	
	// Used for determining whether to use 'small' or 'normal' font sizes.
	function isSmall(size) {
	  return size === 'D' || size === '4u' || size === 'fon';
	}
	
	function makeDonutChart(highchart, options) {
	  if (false) {
	    var highchartContainer = highchart.container;
	    var highchartContainerSVG = highchartContainer.firstElementChild;
	    var svgWidth = Number(highchartContainerSVG.getAttribute('width'));
	    var radius = !options.interactive ? highchart.plotWidth / 2 * .25 : highchart.plotWidth / 2 * .444;
	    radius = options.id === 'fn-large-inset' ? highchart.plotWidth / 2 * .333 : radius;
	    var svgHeight = highchartContainerSVG.getAttribute('height');
	    var groupOfPieValue = highchartContainer.getElementsByClassName('highcharts-pie-series')[0];
	    var lastPathOfPie = groupOfPieValue.lastElementChild.getAttribute('d').split(' ');
	    var lastPathOfPieYVal = Number(lastPathOfPie[lastPathOfPie.length - 2]);
	    var circle = highchart.renderer.circle(svgWidth / 2, lastPathOfPieYVal, radius).attr({
	      fill: 'white'
	    });
	    var text = highchart.renderer.text('%', svgWidth / 2 - radius / 2 * .85, lastPathOfPieYVal + radius / 2 * .75).attr({
	      'font-size': radius,
	      stroke: 'black',
	      text: '%'
	    }).add();
	    groupOfPieValue.append(circle.element);
	    groupOfPieValue.append(text.element);
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
	  }
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _chartLine = __webpack_require__(32);
	
	var line = _interopRequireWildcard(_chartLine);
	
	var _chartArea = __webpack_require__(30);
	
	var area = _interopRequireWildcard(_chartArea);
	
	var _chartBar = __webpack_require__(31);
	
	var bar = _interopRequireWildcard(_chartBar);
	
	var _chartPie = __webpack_require__(33);
	
	var pie = _interopRequireWildcard(_chartPie);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Updates options for specific chart types.
	 */
	function preRender(data, options) {
	  switch (options.type) {
	    case 'line':
	      return line.preRender(data, options);
	    case 'area':
	      return area.preRender(data, options);
	    case 'pie':
	      return pie.preRender(data, options);
	    case 'bar':
	    case 'column':
	      return bar.preRender(data, options);
	  }
	  return data;
	}
	
	function postRender(highchart, options) {
	  switch (options.type) {
	    case 'line':
	      line.postRender(highchart, options);
	      break;
	    case 'area':
	      area.postRender(highchart, options);
	      break;
	    case 'pie':
	      pie.postRender(highchart, options);
	      break;
	    case 'bar':
	    case 'column':
	      bar.postRender(highchart, options);
	      break;
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    switch (options.type) {
	      case 'line':
	        return line.renderInvalidated(rendered, options, invalidated);
	      case 'area':
	        return area.renderInvalidated(rendered, options, invalidated);
	      case 'pie':
	        return pie.renderInvalidated(rendered, options, invalidated);
	      case 'bar':
	      case 'column':
	        return bar.renderInvalidated(rendered, options, invalidated);
	    }
	    return false;
	  }
	}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _spacing = __webpack_require__(38);
	
	var _chart = __webpack_require__(34);
	
	var chart = _interopRequireWildcard(_chart);
	
	var _legend = __webpack_require__(36);
	
	var legend = _interopRequireWildcard(_legend);
	
	var _tooltips = __webpack_require__(39);
	
	var tooltips = _interopRequireWildcard(_tooltips);
	
	var _axes = __webpack_require__(29);
	
	var axes = _interopRequireWildcard(_axes);
	
	var _recessions = __webpack_require__(37);
	
	var recessions = _interopRequireWildcard(_recessions);
	
	var _annotations = __webpack_require__(24);
	
	var annotations = _interopRequireWildcard(_annotations);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * The Inner Chart renders the actual chart sans headlines or footnotes.
	 */
	function preRender(options) {
	  var data = {
	    exporting: {
	      enabled: false
	    },
	    series: options.series,
	    chart: {
	      reflow: false,
	      type: options.type,
	      width: options.width,
	      height: options.height,
	      style: options.styles.base,
	      renderTo: options.el.querySelector('.dj-chart-inner'),
	      backgroundColor: 'transparent'
	      // backgroundColor: 'rgba(255, 0, 0, 0.1)'
	    },
	    credits: { enabled: false },
	    title: { text: null },
	    legend: { enabled: false },
	    plotOptions: {},
	    xAxis: {},
	    yAxis: {}
	  };
	
	  data.chart.spacing = (0, _spacing.chartSpacing)(options);
	  var isSmallMW = options.product === 'marketwatch' && (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'thumb-marketwatch-MA');
	  // only invoke addSpaceForAnnotations for charts that can't be found in isSmallMW variable
	  if (!isSmallMW) {
	    data.chart.spacing = (0, _spacing.addSpaceForAnnotations)(data.chart.spacing, options);
	  }
	
	  data.plotOptions[options.type] = {};
	  data = chart.preRender(data, options);
	  var isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
	  if (options.size.indexOf('thumb') === 0 || isZR) {
	    data.plotOptions.series = data.plotOptions.series || {};
	    data.plotOptions.series.enableMouseTracking = false;
	    data.xAxis.visible = data.yAxis.visible = false;
	    data.yAxis.gridLineWidth = data.xAxis.gridLineWidth = 0;
	  } else {
	    data = legend.preRender(data, options);
	    data = tooltips.preRender(data, options);
	    data = axes.preRender(data, options);
	    data = recessions.preRender(data, options);
	  }
	
	  return data;
	}
	
	function postRender(highchart, options) {
	  chart.postRender(highchart, options);
	  var isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
	  if (options.size.indexOf('thumb') === 0 || isZR) {
	    if (false) {
	      if (options.type !== 'bar') {
	        var topEl = options.el.lastChild.lastChild.lastChild.lastChild;
	        var firstChildThumb = topEl.firstChild;
	        var secondChildThumb = topEl.lastChild;
	        firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
	        firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
	      }
	    }
	  } else {
	    legend.postRender(highchart, options);
	    tooltips.postRender(highchart, options);
	    axes.postRender(highchart, options);
	    recessions.postRender(highchart, options);
	    annotations.postRender(highchart, options);
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    chart.renderInvalidated(rendered, options, invalidated);
	  }
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _constants = __webpack_require__(1);
	
	var _transform = __webpack_require__(4);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _element = __webpack_require__(2);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var MIN_ITEM_CHARS = 16;
	var MAX_ITEM_CHARS = 32;
	var MIN_CHARS_RATIO = MIN_ITEM_CHARS / _constants.MAX_4U_WIDTH;
	
	function preRender(data, options) {
	  if (false) {
	    if (options.size === 'marketwatch-ZT') {
	      return data;
	    }
	  }
	  data.legend = {
	    enabled: options.legend.enabled && options.type !== 'pie' && options.size !== 'marketwatch-ZT',
	    navigation: { enabled: false }
	  };
	  if (data.legend.enabled) {
	    options.forceLegendTop = options.legend.layout === 'right' && (options.print && options.width <= _constants.MAX_NARROW_WIDTH_PRINT || !options.print && options.width <= _constants.MAX_4U_WIDTH);
	    data = styleLegend(data, options);
	    data = positionLegend(data, options);
	  }
	  return data;
	}
	
	function positionLegend(data, options) {
	  var LH = parseFloat(options.styles.normal.lineHeight);
	  if (options.forceLegendTop) {
	    options.legend.layout = 'top';
	  }
	  switch (options.legend.layout) {
	    case 'top':
	      data.legend.layout = 'horizontal';
	      data.legend.align = 'left';
	      data.legend.verticalAlign = 'top';
	      if (options.print) {
	        data.legend.margin = options.type === 'bar' ? 8 : 4;
	      }
	      break;
	    case 'bottom':
	      data.legend.layout = 'horizontal';
	      data.legend.verticalAlign = 'bottom';
	      data.legend.align = 'left';
	      if (options.print) {
	        if (options.type === 'bar') {
	          data.legend.margin = 4;
	          data.chart.spacing[2] += 6;
	        } else {
	          data.chart.spacing[2] += -2;
	        }
	      }
	      break;
	    // case 'right':
	    default:
	      data.legend.layout = 'vertical';
	      data.legend.align = 'right';
	      data.legend.verticalAlign = 'middle';
	      break;
	  }
	  return data;
	}
	
	function styleLegend(data, options) {
	  var fontFamilyStyle = options.product === 'financialnews' ? options.styles.font.normal : options.styles.font.semibold;
	  var fontFamilyWeight = options.product === 'financialnews' ? options.styles.weight.normal : options.styles.weight.semibold;
	  var fontSizePrint = 7.5;
	  if (false) {
	    if (options.product === 'financialnews') {
	      fontSizePrint = options.print && options.sizes['print-fn'].columns <= 2 ? '7.75px' : '12px';
	    }
	  }
	  var fontStyle = options.print ? {
	    fontFamily: options.styles.font.normal,
	    fontWeight: options.styles.weight.normal,
	    fontSize: fontSizePrint
	  } : {
	    fontFamily: fontFamilyStyle,
	    fontWeight: fontFamilyStyle
	  };
	  var styles = options.styles.get('normal', fontStyle);
	
	  if (true) {
	    if (options.product === 'wsj') {
	      styles = Object.assign({}, {
	        fontSize: options.styles.legend.fontSize,
	        fontWeight: options.styles.legend.fontWeight,
	        lineHeight: options.styles.legend.lineHeight
	      });
	    }
	  }
	
	  data.legend.itemStyle = styles;
	
	  if (options.legend.layout === 'right' && !options.forceLegendTop) {
	    var width = options.width * 0.25 - 20; //data.legend.margin;
	    data.legend.itemStyle.width = width; //`${width}px`;
	    if (options.print) {
	      data.legend.margin = 4;
	    }
	    data.legend.padding = 2;
	  } else {
	    data.legend.padding = options.print ? 0 : 2;
	  }
	  data.legend.itemDistance = options.print ? 6 : 12;
	  data.legend.itemMarginBottom = options.print ? 4 : 6;
	
	  // this doesnt do what you think it does.
	  // for some reason this helps space the series name and the series symbol
	  data.legend.symbolWidth = options.print ? 4 : 9;
	
	  if (true) {
	    if (options.product === 'wsj') {
	      data.legend.symbolWidth = options.print ? 4 : 7;
	    }
	  }
	
	  data.legend.symbolHeight = options.print ? 6 : 12;
	  data.legend.symbolRadius = 0;
	  for (var i = 0; i < data.series.length; i++) {
	    if (data.series[i].name.length > 55 && options.width < 480 && options.legend.layout === 'top') {
	      var splitLegendName = data.series[i].name.split(' ');
	      splitLegendName.splice(4, 0, '<br />');
	      data.series[i].name = splitLegendName.join(' ');
	    }
	    // if (data.series[i].name.length > 15 && options.legend.layout === 'right') {
	    //   let splitLegendName = data.series[i].name.split(' ');
	    //   splitLegendName.splice(4, 0, '<br />');
	    //   data.series[i].name = splitLegendName.join(' ');
	    // }
	  }
	
	  return data;
	}
	
	function postRender(highchart, options) {
	  if (highchart.legend.options.enabled) {
	    positionLegendContainer(highchart, options);
	    var items = highchart.container.querySelectorAll('.highcharts-legend-item');
	    disableItems(highchart, options, items);
	    formatItems(highchart, options, items);
	    if (options.legend.layout === 'right') {
	      positionRightAlignedItems(highchart, options, items);
	    }
	  }
	}
	
	// Resets the legend group Y as items will track data/item paths instead.
	// Note that `null` in Highcharts is not the same as `0`.
	function positionLegendContainer(highchart, options) {
	  var el = highchart.container.querySelector('.highcharts-legend');
	  var isBar = options.type === 'bar';
	  var x = null;
	  var y = null;
	  if (options.legend.layout === 'top') {
	    y = isBar ? 0 : 0;
	  } else if (options.legend.layout === 'bottom') {
	    // y = highchart.spacingBox.height + highchart.legend.itemHeight;
	    // y = options.height - parseFloat(options.styles.normal.lineHeight) * 2;
	  } else if (options.legend.layout === 'right') {
	    y = isBar ? null : 0;
	  }
	  transform.write(el, 'translate', x, y);
	}
	
	// Disable clicks on legend items since the Highcharts behavior is not
	// requested and also a bit strange.
	function disableItems(highchart, options, items) {
	  for (var i = 0; i < highchart.series.length; i++) {
	    highchart.series[i].legendGroup.element.onmouseover = null;
	    items[i].querySelector('text').style.cursor = 'default';
	  }
	}
	
	// Takes the color in the block and applies it to the text.
	function formatItems(highchart, options, items) {
	  var x = 0;
	  var initX = 0;
	  for (var i = 0; i < items.length; i++) {
	    var item = items[i];
	    // Draw the key with the correct dimensions:
	    var rect = null;
	    var path = null;
	
	    if (rect = item.querySelector('rect')) {
	      if (options.product !== 'marketwatch') {
	        rect.setAttribute('width', options.print ? 4 : 9);
	        rect.setAttribute('height', options.print ? 6 : 13);
	        rect.setAttribute('x', 0);
	        rect.setAttribute('y', options.print ? 9 : 5);
	      }
	      if (false) {
	        if (options.product === 'financialnews') {
	          var circleX = Number(items[i].children[0].getAttribute('x'));
	          var circleY = Number(items[i].children[0].getAttribute('y'));
	          var circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
	          var positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 11;
	          var positionX = options.print ? 0 : 7;
	          var circle = highchart.renderer.circle(positionX, positionY, circleRadius).attr({
	            fill: items[i].children[1].getAttribute('fill')
	          });
	          items[i].append(circle.element);
	          if (options.print) {
	            items[i].children[0].setAttribute('x', circleX + 10);
	          }
	          rect.setAttribute('opacity', 0);
	        }
	      }
	
	      if (false) {
	        if ((options.type === 'bar' || options.type === 'area' || options.type === 'column') && options.product === 'marketwatch') {
	          rect.setAttribute('width', 13);
	          rect.setAttribute('height', 13);
	          rect.setAttribute('x', -3);
	          rect.setAttribute('y', 5);
	        }
	      }
	    } else if (path = item.querySelector('path')) {
	      if (options.product !== 'marketwatch') {
	        path.setAttribute('stroke-width', options.print ? 6 : 13);
	        path.setAttribute('d', options.print ? 'M 0 12 L 4 12' : 'M 0 11 L 9 11');
	      }
	
	      if (true) {
	        if (options.product === 'wsj') {
	          path.setAttribute('stroke-width', options.styles.legend.rectHeight);
	          path.setAttribute('d', 'M 0 11 L ' + options.styles.legend.rectWidth + ' 11');
	        }
	      }
	
	      if (false) {
	        if (options.type === 'line' && options.product === 'marketwatch') {
	          path.setAttribute('stroke-width', 3);
	          path.setAttribute('d', 'M 0 11 L 9 11');
	        } else if (options.type !== 'line' && options.product === 'marketwatch') {
	          path.setAttribute('stroke-width', options.print ? 6 : 13);
	          path.setAttribute('d', options.print ? 'M 0 12 L 4 12' : 'M 0 11 L 9 11');
	        }
	      }
	      if (false) {
	        if (options.product === 'financialnews') {
	          var pathColor = items[i].children[1].getAttribute('fill');
	          var _circleX = Number(items[i].children[2].getAttribute('x'));
	          var _circleY = Number(items[i].children[2].getAttribute('y'));
	          var _circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
	          var _positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 4;
	          var _positionX = options.print ? 10 : 8;
	          var _circle = highchart.renderer.circle(_circleX - _positionX, _circleY - _positionY, _circleRadius).attr({
	            fill: pathColor
	          });
	          items[i].append(_circle.element);
	          path.setAttribute('opacity', 0);
	          if (options.print) {
	            var translateVal = items[i].getAttribute('transform');
	            var getLastVal = translateVal.split(',');
	            items[i].setAttribute('transform', 'translate(10,' + getLastVal[1]);
	          }
	        }
	      }
	    }
	
	    if (options.print) {
	      var text = item.querySelector('text');
	      text.setAttribute('x', 6);
	    }
	
	    // Space the items apart. TODO: Figure out how to make Highcharts do this!
	    // if (options.legend.layout !== 'right') {
	    //   const translate = transform.read(item, 'translate');
	    //   if (i === 0) {
	    //      initX = translate[0];
	    //   }
	    //   if (translate[0] <= initX) {
	    //     x = 0;
	    //   }
	    //   transform.write(item, 'translate', translate[0] + x);
	    //   x += options.print ? 6 : 12;
	    // }
	  }
	}
	
	function positionRightAlignedItems(highchart, options, items) {
	  switch (options.type) {
	    case 'area':
	    case 'line':
	      positionLineItems(highchart, items, options);
	      break;
	    case 'column':
	      positionColumnItems(highchart, items, options);
	      break;
	    case 'bar':
	      positionBarItems(highchart);
	      break;
	  }
	}
	
	function positionLineItems(highchart, items, options) {
	  var itemY = getLineItemsY(highchart.container, items, options);
	  var botY = highchart.plotTop + highchart.plotHeight;
	  positionLegendItems(itemY, items, options, botY);
	}
	
	function positionColumnItems(highchart, items, options) {
	  var itemY = getColumnItemsY(highchart.container, items, options);
	  var botY = highchart.plotTop + highchart.plotHeight;
	  positionLegendItems(itemY, items, options, botY);
	}
	
	// Necessary because Highcharts messes up "middle".
	function positionBarItems(highchart) {
	  var legendEl = highchart.container.querySelector('g.highcharts-legend');
	  var translate = transform.read(legendEl, 'translate');
	  var height = legendEl.getBoundingClientRect().height;
	  var newY = highchart.plotTop + (highchart.plotHeight - height) / 2;
	  transform.write(legendEl, 'translate', translate[0], newY);
	}
	
	// Positions the legend items to track data points but not overlap.
	function positionLegendItems(itemY, items, options, botY) {
	  var lineHeight = parseFloat(options.styles.lineHeight.normal);
	  var midIndex = Math.min(itemY.length - 1, Math.round(itemY.length / 2));
	  var margin = 8; //options.print ? 4 : 8;
	
	  var y = itemY[0].y;
	  // let y = itemY[midIndex].y;
	  // for (let i = midIndex - 1; i >= 0; i--) {
	  //   let h = items[itemY[i].index].getBoundingClientRect().height + margin;
	  //   itemY[i].y = Math.min(itemY[i].y, y - h);
	  //   y = itemY[i].y;
	  // }
	  // y = itemY[midIndex].y +
	  // items[itemY[midIndex].index].getBoundingClientRect().height + margin;
	  for (var i = 0; i < items.length; i++) {
	    itemY[i].y = Math.max(itemY[i].y, y);
	    y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
	  }
	
	  // y = 0;
	  // for (let i = 0; i < midIndex; i++) {
	  //   itemY[i].y = Math.max(y, itemY[i].y);
	  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
	  // }
	
	  // for (let i = midIndex; i < items.length; i++) {
	  //   // let h = y + items[itemY[i - 1].index].getBoundingClientRect().height;// + margin;
	  //   itemY[i].y = Math.max(itemY[i].y, y);
	  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
	  // }
	
	  // Finally, set the Y of the actual legend item element.
	  for (var _i = 0; _i < itemY.length; _i++) {
	    if (itemY[_i].y < botY) {
	      transform.write(items[itemY[_i].index], 'translate', null, itemY[_i].y);
	    } else {
	      element.removeChild(items[itemY[_i].index]);
	    }
	  }
	}
	
	// Returns array of Y positions for each legend item for column charts.
	function getColumnItemsY(container, items, options) {
	  var fontSize = parseFloat(options.styles.size.normal);
	  var seriesEl = container.querySelector('.highcharts-series-group');
	  var barsEl = seriesEl.querySelectorAll('.highcharts-series');
	  var printOffset = options.print ? -8 : 0;
	  var itemY = [];
	
	  for (var i = 0; i < items.length; i++) {
	    // Get the path's parent and path Y.
	    var g = barsEl[i];
	    var rects = g.querySelectorAll('rect');
	    var r = rects[rects.length - 1];
	    var rY = rects && rects.length ? transform.read(g, 'translate')[1] + (+r.getAttribute('y') + +r.getAttribute('height') / 2) : fontSize;
	
	    // Combine the results.
	    itemY[i] = {
	      index: i,
	      y: rY - fontSize + printOffset
	    };
	  }
	
	  return sortItemY(itemY);
	}
	
	// Returns array of Y positions for each legend item for line/area charts.
	function getLineItemsY(container, items, options) {
	  var fontSize = parseFloat(options.styles.size.normal);
	  var seriesEl = container.querySelector('.highcharts-series-group');
	  var linesEl = seriesEl.querySelectorAll('.highcharts-series');
	  var itemY = [];
	
	  for (var i = 0; i < items.length; i++) {
	    // Get the path's parent and path Y.
	    // var pathEl = seriesEl.querySelector('.highcharts-series.highcharts-series-' + i);
	    var lineIndex = options.type === 'area' ? i : items.length - i - 1;
	    var pathEl = linesEl[lineIndex];
	    var pathElY = transform.read(pathEl, 'translate')[1];
	    var paths = pathEl.querySelectorAll('path');
	    var d = transform.read(paths[0], 'd');
	    d.sort(function (a, b) {
	      return b[0] - a[0];
	    });
	
	    var pathY = void 0;
	    if (options.type === 'line') {
	      pathY = d[0][1];
	    } else {
	      (function () {
	        var dx = d[0][0];
	        var d0 = d.filter(function (item) {
	          return item[0] === dx;
	        }).sort(function (a, b) {
	          return a[1] - b[1];
	        });
	        if (d0.length >= 2) {
	          pathY = (d0[d0.length - 1][1] - d0[0][1]) / 2 + d0[0][1];
	        } else {
	          pathY = d0[0][1];
	        }
	      })();
	    }
	
	    // Combine the results.
	    itemY[i] = {
	      index: i,
	      y: pathY + fontSize / 2
	    };
	  }
	
	  return sortItemY(itemY);
	}
	
	// Sort on Y and return.
	function sortItemY(itemY) {
	  itemY.sort(function (a, b) {
	    return a.y - b.y;
	  });
	  return itemY;
	}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RECESSIONS = undefined;
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _transform = __webpack_require__(4);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _util = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var COLOR_BAND = '#E6E6E6';
	var COLOR_LABEL_VER = '#989898'; //'rgba(0, 0, 0, 0.2)';
	var COLOR_LABEL_HOR = '#989898'; //#727272
	var MARGIN_VER = 8;
	var MARGIN_HOR = 2;
	var OFFSET = 0; //-0.38;
	
	// Data from http://www.nber.org/cycles.html
	var RECESSIONS = exports.RECESSIONS = [{ start: { month: 5, year: 1857 }, end: { month: 11, year: 1858 } }, { start: { month: 9, year: 1860 }, end: { month: 5, year: 1861 } }, { start: { month: 3, year: 1865 }, end: { month: 11, year: 1867 } }, { start: { month: 5, year: 1869 }, end: { month: 11, year: 1870 } }, { start: { month: 9, year: 1873 }, end: { month: 2, year: 1879 } }, { start: { month: 2, year: 1882 }, end: { month: 4, year: 1885 } }, { start: { month: 2, year: 1887 }, end: { month: 3, year: 1888 } }, { start: { month: 6, year: 1890 }, end: { month: 4, year: 1891 } }, { start: { month: 0, year: 1893 }, end: { month: 5, year: 1894 } }, { start: { month: 11, year: 1895 }, end: { month: 5, year: 1897 } }, { start: { month: 5, year: 1899 }, end: { month: 11, year: 1900 } }, { start: { month: 8, year: 1902 }, end: { month: 7, year: 1904 } }, { start: { month: 4, year: 1907 }, end: { month: 5, year: 1908 } }, { start: { month: 0, year: 1910 }, end: { month: 0, year: 1912 } }, { start: { month: 0, year: 1913 }, end: { month: 11, year: 1914 } }, { start: { month: 7, year: 1918 }, end: { month: 2, year: 1919 } }, { start: { month: 0, year: 1920 }, end: { month: 6, year: 1921 } }, { start: { month: 4, year: 1923 }, end: { month: 6, year: 1924 } }, { start: { month: 9, year: 1926 }, end: { month: 10, year: 1927 } }, { start: { month: 7, year: 1929 }, end: { month: 2, year: 1933 } }, { start: { month: 4, year: 1937 }, end: { month: 5, year: 1938 } }, { start: { month: 1, year: 1945 }, end: { month: 9, year: 1945 } }, { start: { month: 10, year: 1948 }, end: { month: 9, year: 1949 } }, { start: { month: 6, year: 1953 }, end: { month: 4, year: 1954 } }, { start: { month: 7, year: 1957 }, end: { month: 3, year: 1958 } }, { start: { month: 3, year: 1960 }, end: { month: 1, year: 1961 } }, { start: { month: 11, year: 1969 }, end: { month: 10, year: 1970 } }, { start: { month: 10, year: 1973 }, end: { month: 2, year: 1975 } }, { start: { month: 0, year: 1980 }, end: { month: 6, year: 1980 } }, { start: { month: 6, year: 1981 }, end: { month: 10, year: 1982 } }, { start: { month: 6, year: 1990 }, end: { month: 2, year: 1991 } }, { start: { month: 2, year: 2001 }, end: { month: 10, year: 2001 } }, { start: { month: 11, year: 2007 }, end: { month: 5, year: 2009 } }];
	
	/**
	 * Pre Render
	 */
	function preRender(data, options) {
	  if (canShowRecessions(options)) {
	    var values = convertDataToValues();
	    var dateA = options.dates[0];
	    var dateB = options.dates[options.dates.length - 1];
	    var axisValueA = new Date(dateA.year, dateA.month || 0).valueOf();
	    var axisValueB = new Date(dateB.year, dateB.month || 0).valueOf();
	
	    var conditionalColorBand = void 0;
	    if (options.product === 'marketwatch') {
	      conditionalColorBand = '#eeeff0';
	    } else {
	      conditionalColorBand = COLOR_BAND;
	    }
	
	    var plotBands = values.map(function (v) {
	      if (v.start <= axisValueB && v.end >= axisValueA) {
	        return {
	          from: Math.max(axisValueA, v.start),
	          to: Math.min(axisValueB, v.end),
	          color: conditionalColorBand
	        };
	      }
	      return null;
	    }).filter(function (item) {
	      return item !== null;
	    });
	
	    if (plotBands.length) {
	      if (options.quarterlyResults) {
	        plotBands = convertDatetimeToLinear(plotBands, options.dates);
	      }
	      data.xAxis.plotBands = plotBands;
	    }
	  }
	  return data;
	}
	
	function canShowRecessions(options) {
	  return options.axes.showRecessions && options.dates && options.type !== 'pie' && options.type !== 'bar' && allHaveYears(options.dates);
	}
	
	function allHaveYears(dates) {
	  return !dates.some(function (date) {
	    return date.year === undefined;
	  });
	}
	
	function convertDataToValues() {
	  return RECESSIONS.map(function (r) {
	    return {
	      start: new Date(r.start.year, r.start.month).valueOf(),
	      end: new Date(r.end.year, r.end.month).valueOf()
	    };
	  });
	}
	
	// On datetime axes, values are milliseconds. On linear axes, values are
	// just indices. For quarterly results, the axis is actually linear and just
	// pretends to be datetime, so plotBands must be converted from datetime.
	function convertDatetimeToLinear(plotBands, dates) {
	  var datesLen = dates.length;
	  plotBands.forEach(function (pb) {
	    var newFrom = 0;
	    var newTo = datesLen - 1;
	    dates.forEach(function (date, index) {
	      if (pb.from >= date.value) {
	        newFrom = index;
	      }
	      if (pb.to >= date.value) {
	        newTo = index;
	      }
	    });
	    newFrom = getLinearPrecise(newFrom, pb.from, dates);
	    newTo = getLinearPrecise(newTo, pb.to, dates);
	    pb.from = newFrom;
	    pb.to = newTo;
	  });
	  return plotBands;
	}
	
	// For use with convertDatetimeToLinear().
	function getLinearPrecise(linear, datetime, dates) {
	  if (linear < dates.length - 1) {
	    linear += (datetime - dates[linear].value) / (dates[linear + 1].value - dates[linear].value);
	  }
	  return linear;
	}
	
	/**
	 * Post Render
	 */
	function postRender(highchart, options) {
	  var xAxis = highchart.xAxis[0];
	  var pb = xAxis.plotLinesAndBands;
	
	  if (pb.length) {
	    var pos = null;
	    var rtext = null;
	    var maxPx = 0;
	
	    if (options.type === 'bar') {
	      pos = {
	        x: highchart.plotLeft + highchart.plotWidth - MARGIN_HOR,
	        y: highchart.plotTop + parseFloat(options.styles.small.fontSize)
	      };
	      rtext = writeRecessionText(highchart, options, pos, COLOR_LABEL_HOR);
	      rtext.element.setAttribute('x', +rtext.element.getAttribute('x') - rtext.element.getBoundingClientRect().width);
	      maxPx = highchart.plotTop + highchart.plotHeight;
	
	      moveRecessionTextHorizontal(pb, rtext.element, maxPx);
	    } else {
	      if (options.ticksOffsetX) {
	        offsetPlotBands(pb, options.ticksOffsetX);
	      }
	      pos = topYAxisLabelPosition(highchart, options);
	      rtext = writeRecessionText(highchart, options, pos, COLOR_LABEL_VER);
	      maxPx = highchart.plotLeft + highchart.plotWidth;
	      moveRecessionTextVertical(pb, rtext.element, options.ticksOffsetX || 0, maxPx);
	    }
	  }
	}
	
	function offsetPlotBands(plotBands, offsetX) {
	  plotBands.forEach(function (pb) {
	    transform.write(pb.svgElem.element, 'translate', offsetX);
	  });
	}
	
	function moveRecessionTextHorizontal(pb, el, maxY) {
	  var y = +el.getAttribute('y');
	  var origY = y;
	  var elHeight = el.getBoundingClientRect().height + MARGIN_HOR;
	  for (var i = 0; i < pb.length; i++) {
	    if (!pb[i].svgElem) continue;
	    var d = transform.read(null, 'd', pb[i].svgElem.d);
	    if (d[2][1] - d[1][1] >= elHeight) {
	      y = d[2][1] - MARGIN_HOR;
	      break;
	    } else if (i === pb.length - 1) {
	      y = d[1][1] - MARGIN_HOR;
	    }
	  }
	  el.setAttribute('y', Math.max(origY, Math.min(y, maxY - elHeight)));
	}
	
	function moveRecessionTextVertical(pb, el, offsetX, maxX) {
	  var elWidth = el.getBoundingClientRect().width;
	  var x = +el.getAttribute('x');
	  for (var i = 0; i < pb.length; i++) {
	    if (!pb[i].svgElem) continue;
	    var d = transform.read(null, 'd', pb[i].svgElem.d);
	    if (d[0][0] >= x) {
	      x = d[0][0];
	      break;
	    } else if (d[2][0] >= x + elWidth) {
	      x = d[2][0] - elWidth;
	      break;
	    }
	  }
	  x += offsetX;
	  el.setAttribute('x', Math.min(x, maxX - elWidth));
	}
	
	function writeRecessionText(highchart, options, pos, color) {
	  if ((options.product === 'marketwatch' || options.product === 'financialnews') && options.type === 'line') {
	    var bandsX = highchart.container.getElementsByClassName('highcharts-plot-bands-0')[0].getBoundingClientRect();
	    bandsX = bandsX.left - bandsX.width;
	    pos.x = bandsX;
	  }
	
	  var css = options.styles.get('normal', { color: color });
	
	  if (true) {
	    if (options.product === 'wsj') {
	      css.fontSize = "10px";
	
	      if (options.print) {
	        css.fontSize = "7.5px";
	      }
	    }
	  }
	  return highchart.renderer.text('Recession', pos.x, pos.y).css(css).attr('class', 'label-recession').add();
	}
	
	// Finds the Y of the top label on the y-axis in order to align "recession"
	// on the same baseline. If units have been set, uses that as a shortcut.
	function topYAxisLabelPosition(highchart, options) {
	  var pos = { x: 0, y: 0 };
	  var textUnits = highchart.container.querySelector('text.units');
	  if (textUnits) {
	    pos.x = +textUnits.getAttribute('x') + textUnits.getBoundingClientRect().width;
	    pos.y = +textUnits.getAttribute('y') - 1;
	  } else {
	    (0, _util.forAxisTicks)(highchart.yAxis[0], function (tick) {
	      if (tick.isLast) {
	        pos.x = +tick.label.element.getAttribute('x') + tick.label.element.getBoundingClientRect().width;
	        pos.y = +tick.label.element.getAttribute('y');
	        return false;
	      }
	    });
	  }
	
	  if (true) {
	    if (options.product === 'wsj' && options.print) {
	      pos.y = pos.y + 1;
	    }
	  }
	
	  pos.x += MARGIN_VER;
	  return pos;
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.chartSpacing = chartSpacing;
	exports.chartMargin = chartMargin;
	exports.addSpaceForAnnotations = addSpaceForAnnotations;
	
	var _constants = __webpack_require__(1);
	
	function chartSpacing(options) {
	  var spacing = [16, 0, 0, 0]; // formerly 28 for index 2
	  if (options.type === 'bar') {
	    spacing[0] += options.print ? -28 : -40; // This makes no sense to me.
	    if (options.print) {
	      spacing[2] = 0;
	    }
	
	    if (true) {
	      if (options.product === 'wsj') {
	        if (options.print) {
	          spacing[0] = -12;
	          spacing[2] = 4;
	        } else {
	          spacing[0] = -20;
	          spacing[2] = 8;
	        }
	      }
	    }
	  } else {
	    if (false) {
	      if (options.product === 'marketwatch') {
	        var hasExtraLegendSpacingRight = options.legend.layout === 'right' && options.legend.enabled ? true : false;
	        var isLineOrColumn = options.type === 'line' || options.type === 'column';
	        var isThumb = options.size === 'thumb-marketwatch-MA' || options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT';
	        var hasSuffix = options.axes.units.suffix;
	        var hasPrefix = options.axes.units.prefix;
	        if (isThumb) {
	          return spacing;
	        }
	        if (isLineOrColumn && options.annotations !== null) {
	          // if no annotations spacing[0] should equal 6
	          spacing[0] = options.annotations.length === 0 ? 6 : 16;
	        }
	        if (isLineOrColumn && options.annotations === null) {
	          spacing[0] = 6;
	        }
	        if (isLineOrColumn && !hasExtraLegendSpacingRight) {
	          var givenSuffix = hasSuffix === " thousand" || hasSuffix === "%" || hasSuffix === " hundred" || hasSuffix === " billion" || hasSuffix === " trillion" || hasSuffix === " cents";
	          if (hasSuffix) {
	            if (hasSuffix === " thousand") {
	              spacing[1] = 70;
	            }
	            if (hasSuffix === "%") {
	              spacing[1] = 20;
	            }
	            if (hasSuffix === " hundred") {
	              spacing[1] = 60;
	            }
	            if (hasSuffix === " billion") {
	              spacing[1] = 45;
	            }
	            if (hasSuffix === " trillion") {
	              spacing[1] = 50;
	            }
	            if (hasSuffix === " cents") {
	              spacing[1] = 40;
	            }
	            if (!givenSuffix) {
	              var suffixLength = hasSuffix.length;
	              var thousand = " thousand";
	              var thousandLength = thousand.length;
	              var diff = suffixLength - thousandLength;
	              if (suffixLength === thousandLength) {
	                spacing[1] = 70;
	              }
	              if (suffixLength > thousandLength) {
	                spacing[1] = 70 + diff * 7;
	              } else {
	                spacing[1] = 70 + diff * 5;
	              }
	            }
	          } else {
	            spacing[1] = 6;
	          }
	          if (hasPrefix && !options.axes.units.formatDecimals && !hasExtraLegendSpacingRight) {
	            spacing[1] = spacing[1] + 5;
	          }
	        }
	      }
	    }
	    if (false) {
	      if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
	        spacing[1] = options.type === 'column' && options.axes.units.suffix === '%' ? 15 : 6;
	      }
	    }
	
	    if (true) {
	      if (options.product === 'wsj') {
	        spacing[0] = 15;
	        spacing[2] = 9;
	
	        if (options.print) {
	          spacing[0] = 14;
	          spacing[2] = 9;
	        }
	
	        if (options.id === '16u') {
	          spacing[0] = 16;
	          spacing[2] = 10;
	        }
	
	        if (options.id === '12u') {
	          spacing[0] = 14;
	          spacing[2] = 10;
	        }
	
	        if (options.id === '8u') {
	          spacing[0] = 13;
	          spacing[2] = 7;
	        }
	
	        if (options.id === '4u') {
	          spacing[0] = 12;
	          spacing[2] = 6;
	        }
	
	        if (options.annotations !== null && options.annotations.length !== 0) {
	          spacing[0] += -3;
	        }
	      }
	    }
	  }
	  if (Array.isArray(options.spacing)) {
	    spacing.forEach(function (n, i) {
	      spacing[i] += options.spacing[i] || 0;
	    });
	  }
	  return spacing;
	}
	
	// DO NOT USE! Interferes with legend spacing!!!
	function chartMargin(options) {
	  return [null, null, null, null];
	  // const lineHeight = parseFloat(options.styles.normal.lineHeight);
	  // const margin = [lineHeight, null, lineHeight * 2, null];
	  // if (options.type === 'bar') {
	  //   margin[0] += 4;
	  //   margin[2] -= lineHeight;
	  // }
	  // return margin;
	  // if (options.size.indexOf('thumb') === 0) {
	  //   return margin;
	  // }
	  // margin[0] = 16;
	  // margin[2] = 28;
	  // if (options.quarterlyResults && options.series[0].data.length <= 9) {
	  //   margin[2] += parseFloat(options.styles.normal.fontSize);
	  // }
	  // if (__WSJ__) {
	  //   if (options.size === 'print-wsj') {
	  //     if (options.type === 'bar') {
	  //       margin[0] = 14;
	  //       margin[2] = 0;
	  //     } else {
	  //       margin[0] = 12;
	  //       margin[2] = 8;
	  //     }
	  //   }
	  // }
	  // return margin;
	}
	
	function addSpaceForAnnotations(spacing, options) {
	  if (possibleAnnotationsSpacing(options) && needsAnnotationSpace(options)) {
	    spacing[1] += options.print ? _constants.ANNOTATIONS_SPACE_PRINT : _constants.ANNOTATIONS_SPACE;
	    options.spaceAddedForAnnotations = true;
	  }
	  return spacing;
	}
	
	function possibleAnnotationsSpacing(options) {
	  return !(options.product === 'marketwatch' || options.type === 'pie' || options.type === 'bar' || options.type === 'column' && options.stacking);
	}
	
	function needsAnnotationSpace(options) {
	  var endIndex = Math.floor((options.maxDataLength - 1) * 0.95);
	  for (var i = 0; i < options.annotations.length; i++) {
	    var a = options.annotations[i];
	    var attach = a.attach.point.enabled ? a.attach.point : a.attach.category;
	    var index = attach.index;
	    if (index >= endIndex) {
	      if (a.lineEnd === 'circle') {
	        return true;
	      }
	      if (options.print && a.lineEnd === 'dot') {
	        return true;
	      }
	    }
	  }
	  return false;
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _format = __webpack_require__(3);
	
	var format = _interopRequireWildcard(_format);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function preRender(data, options) {
	  var tooltip = data.tooltip = { enabled: options.interactive };
	  if (tooltip.enabled) {
	    tooltip.borderWidth = 1;
	    tooltip.borderColor = '#CCC';
	    tooltip.shared = false;
	    tooltip.style = getStyle(options);
	    tooltip.shadow = false;
	    tooltip.formatter = function () {
	      return formatter(data, options, this);
	    };
	  }
	
	  if (true) {
	    if (options.product === 'wsj') {
	      tooltip.borderRadius = 0;
	      tooltip.padding = 4;
	    }
	  }
	  return data;
	}
	
	function formatter(data, options, context) {
	  var value = format.applyFull(context.point.y, options.tooltips, options.type === 'pie', true, true);
	  var categories = options.longCategories || (options.categories ? options.categories[0] : null);
	  var dataPoint = getDataPoint(data.series, context);
	  var category = void 0;
	  if (options.type === 'pie' && options.optimizeDataOrder && dataPoint.point.hasOwnProperty('originalIndex')) {
	    category = context.point.name;
	  } else {
	    category = categories ? categories[dataPoint.index] : context.point.category || context.point.options.name;
	  }
	  // console.log(context.point);
	  // if (categories) {
	  //   if (options.type === 'pie' && options.optimizeDataOrder && dataPoint.point.hasOwnProperty('originalIndex')) {
	  //     category = categories[dataPoint.point.originalIndex];
	  //   } else {
	  //     category = categories[dataPoint.index];
	  //   }
	  // } else {
	  //   category = context.point.category || context.point.options.name;
	  // }
	  var formatter = { index: dataPoint.index, category: category, value: value };
	
	  if ((options.type === 'column' || options.type === 'area') && options.stacking === 'percent') {
	    return formatStackedPercent(data, options, context, formatter);
	  }
	  return formatStandard(options, context, formatter);
	}
	
	function getDataPoint(series, context) {
	  if (context.x !== undefined) {
	    for (var s = 0; s < series.length; s++) {
	      for (var d = 0; d < series[s].data.length; d++) {
	        if (series[s].data[d].x === context.x) {
	          return { point: series[s].data[d], index: series[s].data[d].index };
	        }
	      }
	    }
	  }
	  return {
	    point: context.point,
	    index: context.point.hasOwnProperty('index') ? context.point.index : context.point.x
	  };
	}
	
	function divideValue(value, divisorUnit) {
	  if (divisorUnit && divisorUnit !== 'none') {
	    var divisor = format.getDivisor(divisorUnit);
	    return +value / divisor;
	  }
	  return value;
	}
	
	function space() {
	  return '<span style="color: rgba(255, 255, 255, 0);">x</span>';
	}
	
	function formatStandard(options, context, formatter) {
	  return ['<span>', formatSeries(options, context), '<span>', formatter.category, '</span>', space(), '<span style="font-weight: 600;">', formatter.value, '</span>', '</span>'].join('');
	}
	
	function formatStackedPercent(data, options, context, formatter) {
	  var total = 0;
	  data.series.forEach(function (item) {
	    total += item.data[formatter.index].y;
	  });
	  return ['<span style="', formatter.style, '">', formatSeries(options, context), '<span style="padding: 0 6px 0 0;">', formatter.category, '</span>', space(), '<span style="font-weight: 600; margin: 0 0 0 24px">', formatter.value, ' (', Math.round(context.point.y / total * 100), '%)', '</span>', '</span>'].join('');
	}
	
	function formatSeries(options, context) {
	  if (options.legend.enabled && options.series.length > 1) {
	    var css = void 0;
	    var defaultCSS = ['padding: 0 6px 0 0;'];
	
	    if (options.product !== 'wsj') {
	      css = defaultCSS.concat(['font-weight: 600;', 'color: ' + context.series.color + ';']).join('');
	    }
	
	    if (options.product === 'wsj') {
	      css = defaultCSS.concat(['font-weight: 500;']).join('');
	    }
	
	    return ['<span style="' + css + '">', context.series.name, '</span>', space()].join('');
	  }
	}
	
	function getStyle(options) {
	  var data = {
	    padding: '8px',
	    width: '400px',
	    fontSize: '14px',
	    fontFamily: options.styles.font.normal,
	    fontWeight: options.styles.weight.normal,
	    fontStyle: 'normal',
	    color: '#000000'
	  };
	
	  if (true) {
	    if (options.product === 'wsj') {
	      data.fontSize = '12px';
	      data.lineHeight = '14px';
	    }
	  }
	
	  return data;
	}
	
	function postRender(highchart, options) {
	  //
	}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaults = undefined;
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _format = __webpack_require__(3);
	
	var format = _interopRequireWildcard(_format);
	
	var _getPoint = __webpack_require__(11);
	
	var _getPoint2 = _interopRequireDefault(_getPoint);
	
	var _lodash = __webpack_require__(48);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function preRender(data, options) {
	  return data;
	}
	
	function postRender(highchart, options) {
	  var result = {
	    yTop: 0,
	    yBot: 0,
	    items: null
	  };
	  if (chartTypeOk(options)) {
	    result.items = renderAnnotations(highchart, options, options.annotations.items);
	    if (result.items.length) {
	      updateYTop(result, options);
	      // updateYBot(result, options);
	    }
	  }
	  return result;
	}
	
	var defaults = exports.defaults = {
	  type: 'lines',
	  showLine: true,
	  lineEnd: null,
	  textAlign: 'left',
	  flushAlign: 'flush'
	};
	
	function updateYTop(result, options) {
	  var itemsLen = result.items.length;
	  var lineHeight = parseFloat(options.styles.normal.lineHeight);
	  var maxHeight = 0;
	  result.items.forEach(function (item, index) {
	    // This works because the only child nodes should be <tspan>s.
	    maxHeight = Math.max(lineHeight, (item.element.children.length - 1) * lineHeight);
	  });
	  result.yTop = maxHeight;
	}
	
	// function updateYBot(result) {
	//   const itemsLen = result.items.length;
	//   let maxHeight = 0;
	//   if (itemsLen > 3) {
	//     for (let i = 1; i < itemsLen; i += 2) {
	//       const itemHeight = result.items[i].element.getBoundingClientRect().height;
	//       maxHeight = Math.max(itemHeight, maxHeight);
	//     }
	//   }
	//   result.yBot = maxHeight;
	// }
	
	function renderAnnotations(highchart, options, items) {
	  var margin = 10;
	  var itemWidth = getItemWidth(options, items);
	  var css = options.styles.get('normal');
	  if (false) {
	    if (options.product === 'financialnews') {
	      if (options.print === true && options.sizes['print-fn'].columns <= 2) {
	        css.fontSize = 8.5;
	      }
	    }
	  }
	  css.width = itemWidth + 'px';
	  var lineHeight = parseFloat(css.lineHeight);
	  items.some(function (item, index) {
	    item.element = renderItemText(highchart, options, item, itemWidth, css);
	  });
	  return items;
	}
	
	function getItemWidth(options, items) {
	  var itemsLen = items.length;
	  if (itemsLen === 1) {
	    return options.width * 0.67;
	  } else if (itemsLen === 2) {
	    return options.width * 0.5;
	  } else if (itemsLen >= 3) {
	    return options.width * 0.33;
	  }
	  return 0;
	}
	
	function renderItemText(highchart, options, item, itemWidth, css) {
	  var text = compileText(item, options);
	  var B1 = '<tspan font-family=\'' + options.styles.font.bold + '\' font-weight="' + options.styles.weight.bold + '">';
	  var B2 = '</tspan>';
	  var textBr = text.replace(/[\n|\r|↵]/g, '<br>');
	  var render = highchart.renderer.text(textBr, 0, 0).css(css).add();
	  var tspan = render.element.querySelectorAll('tspan');
	  var b = true;
	  for (var i = 0; i < tspan.length; i++) {
	    var tspanStr = tspan[i].innerHTML + '';
	    var pIndex = 0;
	    var bIndex = void 0;
	    var str = !b ? B1 : '';
	    while ((bIndex = tspanStr.indexOf('**', pIndex)) !== -1) {
	      str += tspanStr.substring(pIndex, bIndex);
	      str += b ? B1 : B2;
	      b = !b;
	      pIndex = bIndex + 2;
	    }
	    str += tspanStr.substring(pIndex);
	    if (!b) {
	      str += B2;
	    }
	    tspan[i].innerHTML = str;
	
	    // move all tspans up except for the first one;
	    if (true) {
	      if (options.product === 'wsj') {
	        if (i !== 0) {
	          var offset = options.print ? 0 : -2;
	          var dy = tspan[i].getAttribute('dy');
	          tspan[i].setAttribute('dy', +dy + offset);
	        }
	      }
	    }
	  }
	  return render.element;
	}
	
	function compileText(item, options) {
	  return (item.text || '').replace(/\\{/g, '__LEFT_BRACKET__').replace(/\\}/g, '__RIGHT_BRACKET__').replace(/\{category\}/g, compiledCategory(item, options)).replace(/\{series\}/g, compiledSeries(item, options)).replace(/\{value\}/g, compiledValue(item, options)).replace(/\{point\}/g, compiledPoint(item, options)).replace(/__LEFT_BRACKET__/g, '{').replace(/__RIGHT_BRACKET__/g, '}');
	}
	
	function compiledCategory(item, options) {
	  if (item.attach.category.enabled) {
	    return options.longCategories[item.attach.category.index];
	  } else {
	    return options.longCategories[item.attach.point.index];
	  }
	}
	
	function compiledSeries(item, options) {
	  var p = item.attach.point;
	  if (p.enabled && options.series[p.series]) {
	    return options.series[p.series].name || 'n/a';
	  }
	  return '{series}';
	}
	
	function compiledValue(item, options) {
	  var p = item.attach.point;
	  if (p.enabled && options.series[p.series]) {
	    var point = (0, _getPoint2.default)(options.series[p.series], p.index);
	    return point ? point.y : 'n/a';
	  }
	  return '{value}';
	}
	
	function compiledPoint(item, options) {
	  var p = item.attach.point;
	  if (p.enabled && options.series[p.series]) {
	    var point = (0, _getPoint2.default)(options.series[p.series], p.index);
	    if (point && (0, _lodash2.default)(point.y)) {
	      return format.applyFull(point.y, options.tooltips, options.type === 'pie', true, true);
	    }
	    return 'n/a';
	  }
	  return '{point}';
	}
	
	function chartTypeOk(options) {
	  var type = options.type,
	      stacking = options.stacking;
	
	  return type === 'column' && !stacking || type === 'area' || type === 'line';
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _textRules = __webpack_require__(14);
	
	var _textRules2 = _interopRequireDefault(_textRules);
	
	var _util = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HED_AND_DEK_MARGIN = 8;
	var WSJ_PRINT_HED_MARGIN = 4;
	var PRINT_LINE = 9.6;
	
	function preRender(data, options) {
	  return data;
	}
	
	function postRender(highchart, options) {
	  var R = getRules(options);
	  var result = {
	    hed: null,
	    dek: null,
	    x: highchart.spacing[3],
	    y: highchart.spacing[0],
	    width: options.width - highchart.spacing[3] - highchart.spacing[1] + 'px'
	  };
	  if (R.HED) {
	    writeHed(options, highchart.renderer, R.HEADINGS.title.text, result);
	  }
	  if (R.HED && R.DEK) {
	    result.y += R.WSJ_PRINT ? WSJ_PRINT_HED_MARGIN : HED_AND_DEK_MARGIN;
	  }
	  if (R.DEK) {
	    writeDek(options, highchart.renderer, R.HEADINGS.dek.text, result, R.HED);
	  }
	  if (R.WSJ_PRINT) {
	    result.y = Math.max(result.y, PRINT_LINE);
	  }
	  return result;
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    if (!rendered.outerInfo.info) {
	      return false;
	    }
	    var R = getRules(options);
	    var result = rendered.outerInfo.info.headlines;
	    var invalidHed = invalidated.indexOf('headings/title') !== -1;
	    var invalidDek = invalidated.indexOf('headings/dek') !== -1 || R.DEK && invalidHed && !result.hed;
	
	    if ((invalidHed || invalidDek) && !!rendered.outer.spacing) {
	      result.y = rendered.outer.spacing[0];
	
	      // If previously there was no HED but now there is, rewrite the DEK to
	      // force the face to change from bold to normal.
	      var invalidDek2 = R.DEK && invalidHed && !result.hed;
	
	      if (invalidHed) {
	        (0, _util.removeEl)(result.hed);
	        if (R.HED) {
	          writeHed(options, rendered.outer.renderer, R.HEADINGS.title.text, result);
	        } else {
	          result.hed = null;
	        }
	      } else if (result.hed) {
	        result.y = result.hed.bottom;
	      }
	
	      if (R.HED && R.DEK) {
	        result.y += R.WSJ_PRINT ? WSJ_PRINT_HED_MARGIN : HED_AND_DEK_MARGIN;
	      }
	
	      if (invalidDek) {
	        (0, _util.removeEl)(result.dek);
	        if (R.DEK) {
	          writeDek(options, rendered.outer.renderer, R.HEADINGS.dek.text, result, R.HED);
	        } else {
	          result.dek = null;
	        }
	      } else if (result.dek) {
	        if (result.y !== result.dek.y) {
	          var delta = result.y - result.dek.y;
	          if (result.dek.el) {
	            var nowY = +result.dek.el.element.getAttribute('y');
	            result.dek.el.element.setAttribute('y', nowY + delta);
	          }
	          result.dek.y += delta;
	          result.dek.bottom += delta;
	        }
	        result.y = result.dek.bottom;
	      }
	
	      rendered.outerInfo.y = result.y;
	      if (R.WSJ_PRINT) {
	        rendered.outerInfo.y = Math.max(rendered.outerInfo.y, PRINT_LINE);
	      }
	      return true;
	    }
	    return false;
	  }
	}
	
	function getRules(options) {
	  var RULE = (0, _textRules.getBestRule)(options.size);
	  var HEADINGS = options.headings;
	  var HED = HEADINGS.title.text && HEADINGS.title.enabled && RULE.title;
	  var DEK = HEADINGS.dek.text && HEADINGS.dek.enabled && RULE.dek;
	  var WSJ_PRINT = options.size === 'print-wsj';
	  return { RULE: RULE, HEADINGS: HEADINGS, HED: HED, DEK: DEK, WSJ_PRINT: WSJ_PRINT };
	}
	
	function writeHed(options, renderer, text, result) {
	  var css = getCss(options, 'hed', result.width);
	  var wsjPrint = false;
	  if (true) {
	    if (wsjPrint = options.size === 'print-wsj') {
	      result.y = PRINT_LINE * 2;
	    }
	  }
	  var financialnewsFirstLetterJ = false;
	  if (false) {
	    if (text.charAt(0) === "J") {
	      financialnewsFirstLetterJ = true;
	    }
	  }
	  var obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, wsjPrint, 'charts-headline');
	  result.hed = {
	    x: result.x,
	    y: result.y,
	    width: result.width,
	    offsetY: obj.offsetY,
	    bottom: obj.bottom,
	    el: obj.el
	  };
	  result.y = obj.bottom;
	}
	
	function writeDek(options, renderer, text, result, hed) {
	  var financialnewsFirstLetterJ = false;
	  if (true) {
	    if (!hed && options.size === 'print-wsj') {
	      result.y = PRINT_LINE;
	    }
	  }
	  var css = getCss(options, 'dek', result.width, hed);
	  var obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, null, 'charts-dek');
	  result.dek = {
	    x: result.x,
	    y: result.y,
	    width: result.width,
	    offsetY: obj.offsetY,
	    bottom: obj.bottom,
	    el: obj.el
	  };
	  result.y = obj.bottom;
	}
	
	function getCss(options, headline, width, hed) {
	  var size = headline === 'hed' ? 'xlarge' : 'large';
	  var fontFamily = options.styles.font.normal;
	  var fontWeight = options.styles.weight.normal;
	  var color = options.styles.color[headline];
	  var isPrint = options.print;
	
	  // HED
	  if (headline === 'hed') {
	    if (options.product === 'financialnews') {
	      fontFamily = '"Publico Text","Publico"';
	      fontWeight = options.styles.weight.bold;
	    } else if (options.product === 'marketwatch') {
	      color = '#666F7D';
	      fontFamily = options.styles.font.bold;
	      fontWeight = options.styles.weight.bold;
	    } else if (options.product === 'mansionglobal') {
	      fontFamily = '"Chronicle SSm Semi-Bold","Chronicle Text G1 A"';
	      fontWeight = options.styles.weight.semibold;
	    } else if (options.product === 'heatstreet') {
	      fontFamily = options.styles.font.semibold;
	      fontWeight = options.styles.weight.semibold;
	    }
	  }
	
	  var css = options.styles.get(size, {
	    fontFamily: fontFamily,
	    fontWeight: fontWeight,
	    color: color,
	    width: width
	  });
	
	  if (true) {
	    if (options.product === 'wsj') {
	      if (headline === 'hed') {
	        css.color = options.styles.headline.color;
	        css.fontFamily = options.styles.headline.fontFamily;
	        css.fontSize = options.styles.headline.fontSize;
	        css.fontWeight = options.styles.headline.fontWeight;
	        css.lineHeight = options.styles.headline.lineHeight;
	      }
	
	      if (headline === 'dek') {
	        css.color = options.styles.description.color;
	        css.fontFamily = options.styles.description.fontFamily;
	        css.fontSize = options.styles.description.fontSize;
	        css.fontWeight = options.styles.description.fontWeight;
	        css.lineHeight = options.styles.description.lineHeight;
	      }
	    }
	  }
	
	  return css;
	}
	
	// Renders a generic block of text (either hed or dek) and returns the element
	// and its bottom y.
	function writeText(financialnewsFirstLetterJ, renderer, text, x, y, css) {
	  var skipOffsetY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	  var className = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
	
	  var offsetY = skipOffsetY ? 0 : parseInt(css.fontSize, 10);
	  if (financialnewsFirstLetterJ) {
	    x = 3;
	  };
	  var el = renderer.text(text).css(css).attr({ x: x, y: y + offsetY, class: className }).add();
	  var tspan = el.element.querySelectorAll('tspan');
	  var lines = tspan && tspan.length ? tspan.length : 1;
	  var lineHeight = parseInt(css.lineHeight, 10);
	  var bottom = y + offsetY + lineHeight * (lines - 1);
	  return { el: el, offsetY: offsetY, bottom: bottom };
	}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _spacing = __webpack_require__(44);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _headlines = __webpack_require__(41);
	
	var headlines = _interopRequireWildcard(_headlines);
	
	var _notes = __webpack_require__(43);
	
	var notes = _interopRequireWildcard(_notes);
	
	var _annotations = __webpack_require__(40);
	
	var annotations = _interopRequireWildcard(_annotations);
	
	var _element = __webpack_require__(2);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
	                                                                                                                                                                                                                   * The Outer Chart renders headlines, footnotes, and credits.
	                                                                                                                                                                                                                   */
	
	
	var MARGIN = 12;
	
	function preRender(options) {
	  var data = {
	    exporting: {
	      enabled: false
	    },
	    chart: _defineProperty({
	      renderTo: options.el.querySelector('.dj-chart-container'),
	      width: options.width,
	      height: options.height,
	      reflow: false,
	      backgroundColor: 'transparent'
	    }, 'backgroundColor', options.styles.color.background),
	    title: { text: null },
	    subtitle: { text: null },
	    credits: { enabled: false }
	  };
	  if (options.size.indexOf('thumb') !== 0) {
	    data.chart.spacing = (0, _spacing2.default)(options);
	    data = headlines.preRender(data, options);
	    data = notes.preRender(data, options);
	    data = annotations.preRender(data, options);
	  }
	  return data;
	}
	
	function postRender(highchart, options) {
	  if (options.size.indexOf('thumb') === 0) {
	    return {
	      innerEl: createInnerEl(highchart, options),
	      x: 0,
	      y: 0,
	      width: options.width,
	      height: options.height,
	      info: null
	    };
	  } else {
	    if (true) {
	      if (options.size === 'print-wsj') {
	        highchart.renderer.rect(0, 3.2, options.width, 0.5, 0).attr({
	          'fill': '#000'
	        }).add();
	        // let y = 0;
	        // while (y < options.height) {
	        //   highchart.renderer.rect(0, y, options.width, 0.5, 0)
	        //     .attr({
	        //       'fill': 'rgba(255, 0, 0, 0.25)',
	        //     })
	        //     .add();
	        //   y += 9.6;
	        // }
	      }
	    }
	    // we only want to call annotations.postRender() for charts that are large enough for annotations
	    var isSmallMW = options.product === 'marketwatch' && (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'thumb-marketwatch-MA');
	    var info = {
	      headlines: headlines.postRender(highchart, options),
	      notes: notes.postRender(highchart, options),
	      annotations: isSmallMW ? 'small' : annotations.postRender(highchart, options)
	    };
	
	    var margin = info.headlines.y > 0 ? MARGIN : 0;
	    if (true) {
	      margin = options.size === 'print-wsj' ? 0 : margin;
	    }
	    return {
	      innerEl: createInnerEl(highchart, options),
	      x: highchart.spacing[3],
	      y: info.headlines.y + margin,
	      width: options.width - highchart.spacing[1] - highchart.spacing[3],
	      height: info.notes.y - info.headlines.y - margin,
	      spacing: [info.annotations.yTop, 0, info.annotations.yBot, 0],
	      info: info
	    };
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    var updateH = headlines.renderInvalidated(rendered, options, invalidated);
	    var updateN = notes.renderInvalidated(rendered, options, invalidated);
	    var margin = rendered.outerInfo.info && rendered.outerInfo.info.headlines.y > 0 ? MARGIN : 0;
	    if (__WSJ__) {
	      margin = options.size === 'print-wsj' ? 0 : margin;
	    }
	    if (updateH) {
	      rendered.outerInfo.y += margin;
	    }
	    if (updateH || updateN) {
	      rendered.outerInfo.height = 0;
	      if (rendered.outerInfo.info) {
	        rendered.outerInfo.height = rendered.outerInfo.info.notes.y - rendered.outerInfo.info.headlines.y - margin;
	      }
	    }
	  }
	}
	
	function getTopHeight(highchart, options) {
	  var svg = options.el.querySelector('svg');
	  var svgY = svg.getBoundingClientRect().top;
	  if (highchart.subtitle) {
	    var srect = highchart.subtitle.element.getBoundingClientRect();
	    return srect.top - svgY + srect.height;
	  } else if (highchart.title) {
	    var trect = highchart.title.element.getBoundingClientRect();
	    return trect.top - svgY + trect.height;
	  }
	  return highchart.spacing[0];
	}
	
	function getBottomHeight(highchart, options) {
	  return highchart.spacing[2];
	}
	
	// Cleans up the outer SVG, removing unnecessary `g` elements, and creates a
	// `g` element specifically for the inner chart SVG.
	function createInnerEl(highchart, options) {
	  var svg = options.el.querySelector('svg');
	  if (svg) {
	    var gEls = svg.querySelectorAll('g');
	    for (var i = 0; i < gEls.length; i++) {
	      element.removeChild(gEls[i]);
	    }
	    return highchart.renderer.g('djchart').add().element;
	  }
	  return null;
	}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _textRules = __webpack_require__(14);
	
	var _textRules2 = _interopRequireDefault(_textRules);
	
	var _util = __webpack_require__(15);
	
	var _constants = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function preRender(data, options) {
	  return data;
	}
	
	function postRender(highchart, options) {
	  var R = getRules(options);
	  var renderer = highchart.renderer;
	  var result = {
	    tagline: null,
	    source: null,
	    note: null,
	    x: highchart.spacing[3],
	    y: getStartY(highchart, options),
	    width: options.width - highchart.spacing[3] - highchart.spacing[1] + 'px'
	  };
	  if (R.tagline) {
	    var wsjPrintTagline = isWsjPrintTagline(options.size, 'tagline');
	    var taglineAlign = getTaglineAlign(options);
	    if (wsjPrintTagline) {
	      result.y = options.height;
	    }
	    result = writeSection(options, 'tagline', renderer, R.headings.tagline.text, result, taglineAlign);
	    if (wsjPrintTagline) {
	      result.y = options.height - 9.2;
	    }
	  }
	  if (R.source) {
	    result = writeSection(options, 'source', renderer, R.headings.source.text, result, getSourceAlign(options));
	  }
	  if (R.note) {
	    result = writeSection(options, 'note', renderer, R.headings.note.text, result);
	  }
	
	  return result;
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    var invalidTagline = invalidated.indexOf('headings/tagline') !== -1;
	    var invalidSource = invalidated.indexOf('headings/source') !== -1;
	    var invalidNote = invalidated.indexOf('headings/note') !== -1;
	
	    if (invalidTagline || invalidSource || invalidNote) {
	      var R = getRules(options);
	      var renderer = rendered.outer.renderer;
	      var info = rendered.outerInfo.info;
	      if (!info) return true;
	      info = info.notes;
	      info.y = getStartY(rendered.outer, options);
	
	      var taglineAlign = getTaglineAlign(options);
	      if (invalidTagline) {
	        (0, _util.removeEl)(info.tagline);
	        if (R.tagline) {
	          info = writeSection(options, 'tagline', renderer, R.headings.tagline.text, info, taglineAlign);
	        } else {
	          info.tagline = null;
	        }
	      } else if (info.tagline) {
	        info.y = info.tagline.top;
	      }
	
	      if (invalidSource) {
	        (0, _util.removeEl)(info.source);
	        if (R.source) {
	          info = writeSection(options, 'source', renderer, R.headings.source.text, info);
	        } else {
	          info.source = null;
	        }
	      } else if (info.source) {
	        if (info.y !== info.source.y) {
	          var delta = info.y - info.source.y;
	          if (info.source.el) {
	            var nowY = +info.source.el.element.getAttribute('y');
	            info.source.el.element.setAttribute('y', nowY + delta);
	          }
	          info.source.y += delta;
	          info.source.top += delta;
	        }
	        info.y = info.source.top;
	      }
	
	      if (invalidNote) {
	        (0, _util.removeEl)(info.note);
	        if (R.note) {
	          info = writeSection(options, 'note', renderer, R.headings.note.text, info);
	        } else {
	          info.note = null;
	        }
	      } else if (info.note) {
	        if (info.y !== info.note.y) {
	          var _delta = info.y - info.note.y;
	          if (info.note.el) {
	            var _nowY = +info.note.el.element.getAttribute('y');
	            info.note.el.element.setAttribute('y', _nowY + _delta);
	          }
	          info.note.y += _delta;
	          info.note.top += _delta;
	        }
	        info.y = info.note.top;
	      }
	      return true;
	    }
	    return false;
	  }
	}
	
	function getRules(options) {
	  var rule = (0, _textRules.getBestRule)(options.size);
	  var headings = options.headings;
	  var tagline = headings.tagline.text && headings.tagline.enabled && rule.tagline;
	  var source = headings.source.text && headings.source.enabled && rule.source;
	  var note = headings.note.text && headings.note.enabled && rule.note;
	  return { rule: rule, headings: headings, tagline: tagline, source: source, note: note };
	}
	
	function writeSection(options, section, renderer, text, result) {
	  var align = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'left';
	
	  result[section] = {
	    x: result.x,
	    y: result.y,
	    width: result.width,
	    top: result.y,
	    el: null
	  };
	  var obj = writeText(options, renderer, text, result, align, section);
	  result[section].el = obj.el;
	  result[section].top = obj.top;
	  result.y = obj.top;
	  return result;
	}
	
	// Renders a generic block of text (tagline or source) and returns the element
	// and its top y.
	function writeText(options, renderer, text, result) {
	  var align = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'left';
	  var section = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	
	  var offsetTagline = options.print ? 1 : 0;
	  var css = options.styles.get('small', {
	    width: result.width
	  });
	  if (true) {
	    if (isWsjPrintTagline(options.size, section)) {
	      css.fontFamily = "'DJ5EscrowCond Semibold'";
	      css.fontSize = 6.6;
	    } else if (options.size === 'print-wsj') {
	      css.fontFamily = "'DJ5RetinaAgReg Medium'";
	    }
	  }
	  var el = renderer.text(text).css(css).attr({
	    x: align === 'left' ? result.x : parseFloat(result.width),
	    y: result.y - offsetTagline,
	    align: align
	  }).add();
	  var lines = el.element.querySelectorAll('tspan').length;
	  var lineHeight = parseFloat(css.lineHeight);
	  var height = lines * lineHeight;
	  var yPx = result.y;
	  if (lines > 1) {
	    yPx = +el.element.getAttribute('y');
	    yPx -= (lines - 1) * lineHeight;
	    el.element.setAttribute('y', yPx);
	  }
	  return {
	    el: el,
	    y: yPx,
	    top: yPx - lineHeight
	  };
	}
	
	function getSourceAlign(options) {
	  return options.product === 'marketwatch' ? 'right' : 'left';
	}
	
	function getTaglineAlign(options) {
	  if (true) {
	    if (options.size === 'print-wsj') {
	      return options.sizes['print-wsj'].columns >= 2 ? 'right' : 'left';
	    } else {
	      return options.width > _constants.MAX_4U_WIDTH ? 'right' : 'left';
	    }
	  }
	  if (false) {
	    return options.width > _constants.MAX_4U_WIDTH ? 'right' : 'left';
	  }
	}
	
	function getStartY(highchart, options) {
	  return options.height - highchart.spacing[2] - yOffset(options);
	}
	
	// Lifts text just enough so that bottom line shows tails.
	function yOffset(options) {
	  return Math.round((parseFloat(options.styles.lineHeight.small) - parseFloat(options.styles.size.small)) * 0.5);
	}
	
	function isWsjPrintTagline(size, section) {
	  if (true) {
	    return size === 'print-wsj' && section === 'tagline';
	  }
	  return false;
	}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function spacing(options) {
	  switch (options.size) {
	    case 'fon':
	      return [30, 15, 0, 15];
	    case 'soc':
	      return [10, 10, 10, 10];
	  }
	  return [0, 0, 0, 0];
	}
	
	exports.default = spacing;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processStyles = processStyles;
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(9);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Whitney SSm will be displayed in the SVG, but in the image export, the
	// fonts prepended below ('Whitney SSm Regular') will be used.
	var BASE_STYLE = {
	  color: {
	    background: '#fff',
	    normal: '#333',
	    light: '#666',
	    hed: '#333',
	    dek: '#666'
	  },
	  font: {
	    light: 'sans-serif',
	    normal: 'sans-serif',
	    semibold: 'sans-serif',
	    bold: 'sans-serif'
	  },
	  weight: {
	    light: 300,
	    normal: 400,
	    semibold: 600,
	    bold: 700
	  },
	  size: {
	    small: '11px',
	    normal: '13px',
	    large: '16px',
	    xlarge: '16px'
	  },
	  lineHeight: {
	    small: '16px',
	    normal: '16px',
	    large: '20px',
	    xlarge: '20px'
	  },
	  annotations: {},
	  headline: {},
	  description: {},
	  notes: {},
	  source: {},
	  tick: {},
	  axes: {
	    zeroGridLine: {},
	    label: {
	      seriesAreNotDates: {},
	      bar: {
	        x: {},
	        y: {}
	      }
	    }
	  },
	  legend: {}
	};
	
	function processStyles(options) {
	  var STYLE = (0, _lodash2.default)({}, BASE_STYLE);
	  var product = options.product,
	      print = options.print;
	
	  if (true) {
	    if (product === 'wsj') {
	      if (print) {
	        STYLE.annotations.fontSize = 7.5;
	        STYLE.annotations.lineHeight = 10;
	        STYLE.axes.label.bar.x.fontSize = 7.5;
	        STYLE.axes.label.bar.x.fontWeight = 'normal';
	        STYLE.axes.label.bar.x.lineHeight = 7.5;
	        STYLE.axes.label.bar.y.fontSize = 7.5;
	        STYLE.axes.label.bar.y.fontWeight = 'normal';
	        STYLE.axes.label.bar.y.lineHeight = 7.5;
	        STYLE.axes.label.color = '#666';
	        STYLE.axes.label.fontSize = 7.5;
	        STYLE.axes.label.fontWeight = 400;
	        STYLE.axes.label.lineHeight = 7.5;
	        STYLE.axes.label.seriesAreNotDates.fontSize = 7;
	        STYLE.axes.label.seriesAreNotDates.fontWeight = 'normal';
	        STYLE.axes.label.seriesAreNotDates.lineHeight = 8;
	        STYLE.axes.zeroGridLine.color = '#333';
	        STYLE.color.dek = '#000';
	        STYLE.color.hed = '#000';
	        STYLE.color.normal = '#000';
	        STYLE.description.color = '#000';
	        STYLE.description.fontFamily = '"DJ5RetinaNr Medium",sans-serif';
	        STYLE.description.fontSize = 8.4;
	        STYLE.description.fontWeight = 400;
	        STYLE.description.lineHeight = 10;
	        STYLE.font.bold = '"DJ5RetinaNr Bold",' + STYLE.font.bold;
	        STYLE.font.light = '"DJ5RetinaNr Light",' + STYLE.font.light;
	        STYLE.font.normal = '"DJ5RetinaNr Medium",' + STYLE.font.normal;
	        STYLE.font.semibold = '"DJ5RetinaNr Semibold",' + STYLE.font.bold;
	        STYLE.headline.color = '#000';
	        STYLE.headline.fontFamily = '"DJ5RetinaNr Bold",sans-serif';
	        STYLE.headline.fontSize = 12.6;
	        STYLE.headline.fontWeight = 'normal';
	        STYLE.headline.lineHeight = 14.4;
	        STYLE.legend.fontSize = 7.5;
	        STYLE.legend.fontWeight = 400;
	        STYLE.legend.lineHeight = 'inherit';
	        STYLE.legend.rectHeight = 6;
	        STYLE.legend.rectWidth = 4;
	        STYLE.lineHeight.large = 9.6;
	        STYLE.lineHeight.normal = 8;
	        STYLE.lineHeight.small = 7.2;
	        STYLE.lineHeight.xlarge = 14.4;
	        STYLE.size.large = 8.4;
	        STYLE.size.normal = 7.5;
	        STYLE.size.small = 6;
	        STYLE.size.xlarge = 12.6;
	        STYLE.tick.color = '#333';
	        STYLE.tick.longSize = 5;
	        STYLE.tick.mediumSize = 4;
	        STYLE.tick.shortSize = 2;
	        STYLE.tick.yOffset = 1;
	        STYLE.weight.bold = 'normal';
	        STYLE.weight.light = 'normal';
	        STYLE.weight.normal = 'normal';
	        STYLE.weight.semibold = 'normal';
	      } else {
	        STYLE.annotations.fontSize = 12;
	        STYLE.annotations.lineHeight = 14;
	        STYLE.axes.label.bar.x.fontSize = 12;
	        STYLE.axes.label.bar.x.fontWeight = 500;
	        STYLE.axes.label.bar.x.lineHeight = 14;
	        STYLE.axes.label.bar.y.fontSize = 10;
	        STYLE.axes.label.bar.y.fontWeight = 400;
	        STYLE.axes.label.bar.y.lineHeight = 16;
	        STYLE.axes.label.color = '#666';
	        STYLE.axes.label.fontSize = 10;
	        STYLE.axes.label.fontWeight = 400;
	        STYLE.axes.label.lineHeight = 16;
	        STYLE.axes.label.seriesAreNotDates.fontSize = 12;
	        STYLE.axes.label.seriesAreNotDates.fontWeight = 500;
	        STYLE.axes.label.seriesAreNotDates.lineHeight = 14;
	        STYLE.axes.zeroGridLine.color = '#333';
	        STYLE.description.color = '#666';
	        STYLE.description.fontFamily = '"Whitney SSm Regular", "Whitney SSm", Whitney, sans-serif';
	        STYLE.description.fontSize = 14;
	        STYLE.description.fontWeight = 400;
	        STYLE.description.lineHeight = 20;
	        STYLE.font.bold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.bold;
	        STYLE.font.light = '"Whitney SSm Light","Whitney SSm",Whitney,' + STYLE.font.light;
	        STYLE.font.normal = '"Whitney SSm Regular","Whitney SSm",Whitney,' + STYLE.font.normal;
	        STYLE.font.semibold = '"Whitney SSm Medium","Whitney SSm",Whitney,' + STYLE.font.bold;
	        STYLE.headline.color = '#333';
	        STYLE.headline.fontFamily = '"Whitney SSm Semi-Bold", "Whitney SSm", Whitney, sans-serif';
	        STYLE.headline.fontSize = 16;
	        STYLE.headline.fontWeight = 600;
	        STYLE.headline.lineHeight = 20;
	        STYLE.legend.fontSize = 12;
	        STYLE.legend.fontWeight = 500;
	        STYLE.legend.lineHeight = 14;
	        STYLE.legend.rectHeight = 12;
	        STYLE.legend.rectWidth = 8;
	        STYLE.notes.lineHeight = 13;
	        STYLE.source.lineHeight = 13;
	        STYLE.tick.color = '#333';
	        STYLE.tick.longSize = 7;
	        STYLE.tick.mediumSize = 5;
	        STYLE.tick.shortSize = 3;
	        STYLE.tick.yOffset = 1.5;
	        STYLE.weight.bold = 600;
	        STYLE.weight.semibold = 500;
	      }
	    }
	  }
	  if (false) {
	    if (product === 'barrons') {
	      STYLE.color.background = 'transparent';
	      STYLE.color.normal = '#8E99A2';
	      STYLE.color.light = '#8E99A2';
	      STYLE.color.hed = '#122225';
	      STYLE.color.dek = '#8E99A2';
	      STYLE.font.light = 'Theinhardt,TheinhardtRegular,' + STYLE.font.light;
	      STYLE.font.normal = 'Theinhardt,TheinhardtRegular,' + STYLE.font.normal;
	      STYLE.font.semibold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
	      STYLE.font.bold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
	      STYLE.size.small = '12px';
	      STYLE.size.normal = '12px';
	      STYLE.size.large = '18px';
	      STYLE.size.xlarge = '24px';
	      STYLE.lineHeight.xlarge = '25px';
	    }
	  }
	  if (false) {
	    if (product === 'financialnews') {
	      STYLE.color.background = 'transparent';
	      STYLE.color.normal = '#70808C';
	      STYLE.color.light = '#70808C';
	      STYLE.color.hed = '#005879';
	      STYLE.color.dek = '#4D6172';
	      STYLE.font.light = 'Theinhardt,TheinhardtRegular,' + STYLE.font.light;
	      STYLE.font.normal = 'Theinhardt,TheinhardtRegular,' + STYLE.font.normal;
	      STYLE.font.semibold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
	      STYLE.font.bold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
	      STYLE.size.small = '12px';
	      STYLE.size.normal = '12px';
	      STYLE.size.large = '16px';
	      STYLE.size.xlarge = '24px';
	      STYLE.lineHeight.small = '17px';
	      STYLE.lineHeight.normal = '17px';
	      STYLE.lineHeight.large = '22px';
	      STYLE.lineHeight.xlarge = '28px';
	    }
	  }
	  if (false) {
	    if (product === 'marketwatch') {
	      STYLE.font.light = '"Whitney SSm Light","Whitney SSm",Whitney,' + STYLE.font.light;
	      STYLE.font.normal = '"Whitney SSm Regular","Whitney SSm",Whitney,' + STYLE.font.normal;
	      STYLE.font.semibold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.semibold;
	      STYLE.font.bold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.bold;
	      STYLE.font.axes = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + 'sans-serif';
	      STYLE.weight.light = 300;
	      STYLE.weight.normal = 400;
	      STYLE.weight.semibold = 600;
	      STYLE.weight.bold = 600;
	      STYLE.weight.axes = 600;
	      STYLE.color.normal = '#555';
	      STYLE.color.dek = '#555';
	      STYLE.color.light = '#555';
	      STYLE.color.axes = '#555';
	      STYLE.size.small = '13px';
	      STYLE.size.axes = '13px';
	      STYLE.size.normal = '13px';
	      STYLE.size.large = '16px';
	      STYLE.size.xlarge = '28px';
	      STYLE.lineHeight.small = '19px';
	      STYLE.lineHeight.normal = '19px';
	      STYLE.lineHeight.large = '25px';
	      STYLE.lineHeight.xlarge = '34px';
	    }
	  }
	  if (false) {
	    if (product === 'mansionglobal') {
	      STYLE.font.light = '"Whitney SSm Light","Whitney SSm",Whitney,' + STYLE.font.light;
	      STYLE.font.normal = '"Whitney SSm Regular","Whitney SSm",Whitney,' + STYLE.font.normal;
	      STYLE.font.semibold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.semibold;
	      STYLE.font.bold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.bold;
	      STYLE.weight.light = 400;
	      STYLE.weight.normal = 400;
	      STYLE.weight.semibold = 600;
	      STYLE.weight.bold = 700;
	      STYLE.size.small = '14px';
	      STYLE.size.normal = '14px';
	      STYLE.size.large = '18px';
	      STYLE.size.xlarge = '24px';
	      STYLE.lineHeight.xlarge = '28px';
	    }
	  }
	  if (false) {
	    if (product === 'heatstreet') {
	      STYLE.font.light = '"Ideal Sans","Ideal Sans A",' + STYLE.font.light;
	      STYLE.font.normal = '"Ideal Sans","Ideal Sans A",' + STYLE.font.normal;
	      STYLE.font.semibold = '"Ideal Sans Semi-Bold","Ideal Sans A",' + STYLE.font.semibold;
	      STYLE.font.bold = '"Ideal Sans","Ideal Sans A",' + STYLE.font.bold;
	      STYLE.weight.light = 300;
	      STYLE.weight.normal = 300;
	      STYLE.weight.semibold = 600;
	      STYLE.weight.bold = 700;
	      STYLE.size.small = '14px';
	      STYLE.size.normal = '14px';
	      STYLE.size.large = '14px';
	      STYLE.size.xlarge = '22px';
	    }
	  }
	  STYLE.base = {
	    fontFamily: STYLE.font.normal,
	    fontSize: STYLE.size.normal,
	    fontWeight: STYLE.weight.normal,
	    lineHeight: STYLE.lineHeight.normal,
	    color: STYLE.color.normal
	  };
	  STYLE.get = function (size, options) {
	    var sizeStyle = STYLE[size];
	    return sizeStyle ? (0, _lodash4.default)({}, sizeStyle, options) : STYLE.base;
	  };
	  STYLE.small = STYLE.get('base', {
	    fontSize: STYLE.size.small,
	    lineHeight: STYLE.lineHeight.small
	  });
	  STYLE.normal = STYLE.get('base');
	  STYLE.large = STYLE.get('base', {
	    fontSize: STYLE.size.large,
	    lineHeight: STYLE.lineHeight.large
	  });
	  STYLE.xlarge = STYLE.get('base', {
	    fontSize: STYLE.size.xlarge,
	    lineHeight: STYLE.lineHeight.xlarge
	  });
	  return STYLE;
	}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.fonts = fonts;
	
	var _webfontloader = __webpack_require__(50);
	
	var _webfontloader2 = _interopRequireDefault(_webfontloader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var URL_WHITNEY = 'https://asset.wsj.net/fonts.wsj.net/fonts/pkg/whitney-ssm.css';
	
	/**
	 * Preload fonts depending on product. If fonts are *not* preloaded, then
	 * line breaks fail (because line breaks are determined with a fallback font).
	 */
	function fonts(options, complete) {
	  var product = options.product,
	      print = options.print;
	
	  var info = fontsInfo(product, print);
	  var interval = 0;
	  if (info === true) {
	    complete();
	  } else {
	    var status = window.__charts_fonts_status__ = _typeof(window.__charts_fonts_status__) === 'object' ? window.__charts_fonts_status__ : {};
	
	    var callbackComplete = function callbackComplete() {
	      status[info.product] = 'complete';
	      complete();
	    };
	
	    var checkComplete = function checkComplete() {
	      if (status[info.product] === 'complete') {
	        clearInterval(interval);
	        complete();
	      }
	    };
	
	    var checkQueued = function checkQueued() {
	      if (!areFontsLoading()) {
	        clearInterval(interval);
	        if (status[info.product] === 'complete') {
	          complete();
	        } else {
	          status[info.product] = 'loading';
	          _webfontloader2.default.load({
	            custom: info,
	            active: callbackComplete,
	            inactive: callbackComplete
	          });
	        }
	      }
	    };
	
	    if (status[info.product] === 'loading') {
	      interval = setInterval(checkComplete, 1);
	    } else if (status[info.product] === 'complete') {
	      complete();
	    } else {
	      interval = setInterval(checkQueued, 1);
	    }
	  }
	}
	
	function areFontsLoading() {
	  var status = window.__charts_fonts_status__;
	  if (status) {
	    var keys = Object.keys(status);
	    for (var i = 0; i < keys.length; i++) {
	      if (status[keys[i]] === 'loading') {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	function fontsInfo(product) {
	  var print = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (true) {
	    if (product === 'wsj') {
	      if (print) {
	        return {
	          product: 'wsj-print',
	          families: [
	          // 'Retina Standard Narrow:n3,n4,n6',
	          // 'DJ5EscrowCond:n6'
	          'DJ5RetinaNr Light', 'DJ5RetinaNr Medium', 'DJ5RetinaNr Semibold', 'DJ5RetinaNr Bold', 'DJ5RetinaAgReg Medium', 'DJ5EscrowCond'],
	          urls: ['/assets/css/wsj-print.css']
	        };
	      } else {
	        return {
	          product: product,
	          families: ['Whitney SSm:n3,n4,n5,n6'],
	          urls: [URL_WHITNEY]
	        };
	      }
	    }
	  }
	  if (false) {
	    if (product === 'barrons') {
	      return {
	        product: product,
	        families: ['Theinhardt:n4,n6'],
	        urls: ['https://s3.amazonaws.com/fonts.wsj.net/Theinhardt.css']
	      };
	    }
	  }
	  if (false) {
	    if (product === 'financialnews') {
	      return {
	        product: product,
	        families: ['Publico:n6', 'Theinhardt:n3,n4,n6'],
	        urls: ['https://fonts.wsj.net/PublicoMedium.css', 'https://s3.amazonaws.com/fonts.wsj.net/Theinhardt.css']
	      };
	    }
	  }
	  if (false) {
	    if (product === 'marketwatch') {
	      return {
	        product: product,
	        families: ['Whitney SSm:n4,n5,n6'],
	        urls: [URL_WHITNEY]
	      };
	    }
	  }
	  if (false) {
	    if (product === 'mansionglobal') {
	      return {
	        product: product,
	        families: ['Chronicle Text G1 A:n6', 'Whitney SSm A:n4,n6,n7'],
	        urls: ['https://www.mansionglobal.com/fonts/442807/457709E0582EC35B6.css']
	      };
	    }
	  }
	  if (false) {
	    if (product === 'heatstreet') {
	      return {
	        product: product,
	        families: ['Ideal Sans B:n3,n6,n7', 'Ideal Sans B:n3,n6,n7'],
	        urls: ['https://heatst.com/wp-content/themes/heatstreet/static/fonts/447427/CACC8AE198F1E0D08.css']
	      };
	    }
	  }
	  return true;
	}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	/**
	 * @license Highcharts JS v5.0.12 (2017-05-24)
	 *
	 * (c) 2009-2016 Torstein Honsi
	 *
	 * License: www.highcharts.com/license
	 */
	'use strict';
	(function(root, factory) {
	    if (typeof module === 'object' && module.exports) {
	        module.exports = root.document ?
	            factory(root) :
	            factory;
	    } else {
	        root.Highcharts = factory(root);
	    }
	}(typeof window !== 'undefined' ? window : this, function(win) {
	    var Highcharts = (function() {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /* global window */
	        var win = window,
	            doc = win.document;
	
	        var SVG_NS = 'http://www.w3.org/2000/svg',
	            userAgent = (win.navigator && win.navigator.userAgent) || '',
	            svg = doc && doc.createElementNS && !!doc.createElementNS(SVG_NS, 'svg').createSVGRect,
	            isMS = /(edge|msie|trident)/i.test(userAgent) && !window.opera,
	            vml = !svg,
	            isFirefox = /Firefox/.test(userAgent),
	            hasBidiBug = isFirefox && parseInt(userAgent.split('Firefox/')[1], 10) < 4; // issue #38
	
	        var Highcharts = win.Highcharts ? win.Highcharts.error(16, true) : {
	            product: 'Highcharts',
	            version: '5.0.12',
	            deg2rad: Math.PI * 2 / 360,
	            doc: doc,
	            hasBidiBug: hasBidiBug,
	            hasTouch: doc && doc.documentElement.ontouchstart !== undefined,
	            isMS: isMS,
	            isWebKit: /AppleWebKit/.test(userAgent),
	            isFirefox: isFirefox,
	            isTouchDevice: /(Mobile|Android|Windows Phone)/.test(userAgent),
	            SVG_NS: SVG_NS,
	            chartCount: 0,
	            seriesTypes: {},
	            symbolSizes: {},
	            svg: svg,
	            vml: vml,
	            win: win,
	            marginNames: ['plotTop', 'marginRight', 'marginBottom', 'plotLeft'],
	            noop: function() {
	                return undefined;
	            },
	            /**
	             * An array containing the current chart objects in the page. A chart's
	             * position in the array is preserved throughout the page's lifetime. When
	             * a chart is destroyed, the array item becomes `undefined`.
	             * @type {Array.<Highcharts.Chart>}
	             * @memberOf Highcharts
	             */
	            charts: []
	        };
	        return Highcharts;
	    }());
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /* eslint max-len: ["warn", 80, 4] */
	
	        /**
	         * The Highcharts object is the placeholder for all other members, and various
	         * utility functions. The most important member of the namespace would be the
	         * chart constructor.
	         *
	         * @example
	         * var chart = Highcharts.chart('container', { ... });
	         * 
	         * @namespace Highcharts
	         */
	
	        var timers = [];
	
	        var charts = H.charts,
	            doc = H.doc,
	            win = H.win;
	
	        /**
	         * Provide error messages for debugging, with links to online explanation. This
	         * function can be overridden to provide custom error handling.
	         *
	         * @function #error
	         * @memberOf Highcharts
	         * @param {Number|String} code - The error code. See [errors.xml]{@link 
	         *     https://github.com/highcharts/highcharts/blob/master/errors/errors.xml}
	         *     for available codes. If it is a string, the error message is printed
	         *     directly in the console.
	         * @param {Boolean} [stop=false] - Whether to throw an error or just log a 
	         *     warning in the console.
	         *
	         * @sample highcharts/chart/highcharts-error/ Custom error handler
	         */
	        H.error = function(code, stop) {
	            var msg = H.isNumber(code) ?
	                'Highcharts error #' + code + ': www.highcharts.com/errors/' + code :
	                code;
	            if (stop) {
	                throw new Error(msg);
	            }
	            // else ...
	            if (win.console) {
	                console.log(msg); // eslint-disable-line no-console
	            }
	        };
	
	        /**
	         * An animator object used internally. One instance applies to one property
	         * (attribute or style prop) on one element. Animation is always initiated
	         * through {@link SVGElement#animate}.
	         *
	         * @constructor Fx
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement|SVGElement} elem - The element to animate.
	         * @param {AnimationOptions} options - Animation options.
	         * @param {string} prop - The single attribute or CSS property to animate.
	         * @private
	         *
	         * @example
	         * var rect = renderer.rect(0, 0, 10, 10).add();
	         * rect.animate({ width: 100 });
	         */
	        H.Fx = function(elem, options, prop) {
	            this.options = options;
	            this.elem = elem;
	            this.prop = prop;
	        };
	        H.Fx.prototype = {
	
	            /**
	             * Set the current step of a path definition on SVGElement.
	             *
	             * @function #dSetter
	             * @memberOf Highcharts.Fx
	             */
	            dSetter: function() {
	                var start = this.paths[0],
	                    end = this.paths[1],
	                    ret = [],
	                    now = this.now,
	                    i = start.length,
	                    startVal;
	
	                // Land on the final path without adjustment points appended in the ends
	                if (now === 1) {
	                    ret = this.toD;
	
	                } else if (i === end.length && now < 1) {
	                    while (i--) {
	                        startVal = parseFloat(start[i]);
	                        ret[i] =
	                            isNaN(startVal) ? // a letter instruction like M or L
	                            start[i] :
	                            now * (parseFloat(end[i] - startVal)) + startVal;
	
	                    }
	                    // If animation is finished or length not matching, land on right value
	                } else {
	                    ret = end;
	                }
	                this.elem.attr('d', ret, null, true);
	            },
	
	            /**
	             * Update the element with the current animation step.
	             *
	             * @function #update
	             * @memberOf Highcharts.Fx
	             */
	            update: function() {
	                var elem = this.elem,
	                    prop = this.prop, // if destroyed, it is null
	                    now = this.now,
	                    step = this.options.step;
	
	                // Animation setter defined from outside
	                if (this[prop + 'Setter']) {
	                    this[prop + 'Setter']();
	
	                    // Other animations on SVGElement
	                } else if (elem.attr) {
	                    if (elem.element) {
	                        elem.attr(prop, now, null, true);
	                    }
	
	                    // HTML styles, raw HTML content like container size
	                } else {
	                    elem.style[prop] = now + this.unit;
	                }
	
	                if (step) {
	                    step.call(elem, now, this);
	                }
	
	            },
	
	            /**
	             * Run an animation.
	             *
	             * @function #run
	             * @memberOf Highcharts.Fx
	             * @param {Number} from - The current value, value to start from.
	             * @param {Number} to - The end value, value to land on.
	             * @param {String} [unit] - The property unit, for example `px`.
	             * @returns {void}
	             */
	            run: function(from, to, unit) {
	                var self = this,
	                    timer = function(gotoEnd) {
	                        return timer.stopped ? false : self.step(gotoEnd);
	                    },
	                    i;
	
	                this.startTime = +new Date();
	                this.start = from;
	                this.end = to;
	                this.unit = unit;
	                this.now = this.start;
	                this.pos = 0;
	
	                timer.elem = this.elem;
	                timer.prop = this.prop;
	
	                if (timer() && timers.push(timer) === 1) {
	                    timer.timerId = setInterval(function() {
	
	                        for (i = 0; i < timers.length; i++) {
	                            if (!timers[i]()) {
	                                timers.splice(i--, 1);
	                            }
	                        }
	
	                        if (!timers.length) {
	                            clearInterval(timer.timerId);
	                        }
	                    }, 13);
	                }
	            },
	
	            /**
	             * Run a single step in the animation.
	             *
	             * @function #step
	             * @memberOf Highcharts.Fx
	             * @param   {Boolean} [gotoEnd] - Whether to go to the endpoint of the
	             *     animation after abort.
	             * @returns {Boolean} Returns `true` if animation continues.
	             */
	            step: function(gotoEnd) {
	                var t = +new Date(),
	                    ret,
	                    done,
	                    options = this.options,
	                    elem = this.elem,
	                    complete = options.complete,
	                    duration = options.duration,
	                    curAnim = options.curAnim;
	
	                if (elem.attr && !elem.element) { // #2616, element is destroyed
	                    ret = false;
	
	                } else if (gotoEnd || t >= duration + this.startTime) {
	                    this.now = this.end;
	                    this.pos = 1;
	                    this.update();
	
	                    curAnim[this.prop] = true;
	
	                    done = true;
	
	                    H.objectEach(curAnim, function(val) {
	                        if (val !== true) {
	                            done = false;
	                        }
	                    });
	
	                    if (done && complete) {
	                        complete.call(elem);
	                    }
	                    ret = false;
	
	                } else {
	                    this.pos = options.easing((t - this.startTime) / duration);
	                    this.now = this.start + ((this.end - this.start) * this.pos);
	                    this.update();
	                    ret = true;
	                }
	                return ret;
	            },
	
	            /**
	             * Prepare start and end values so that the path can be animated one to one.
	             *
	             * @function #initPath
	             * @memberOf Highcharts.Fx
	             * @param {SVGElement} elem - The SVGElement item.
	             * @param {String} fromD - Starting path definition.
	             * @param {Array} toD - Ending path definition.
	             * @returns {Array} An array containing start and end paths in array form
	             * so that they can be animated in parallel.
	             */
	            initPath: function(elem, fromD, toD) {
	                fromD = fromD || '';
	                var shift,
	                    startX = elem.startX,
	                    endX = elem.endX,
	                    bezier = fromD.indexOf('C') > -1,
	                    numParams = bezier ? 7 : 3,
	                    fullLength,
	                    slice,
	                    i,
	                    start = fromD.split(' '),
	                    end = toD.slice(), // copy
	                    isArea = elem.isArea,
	                    positionFactor = isArea ? 2 : 1,
	                    reverse;
	
	                /**
	                 * In splines make moveTo and lineTo points have six parameters like
	                 * bezier curves, to allow animation one-to-one.
	                 */
	                function sixify(arr) {
	                    var isOperator,
	                        nextIsOperator;
	                    i = arr.length;
	                    while (i--) {
	
	                        // Fill in dummy coordinates only if the next operator comes
	                        // three places behind (#5788)
	                        isOperator = arr[i] === 'M' || arr[i] === 'L';
	                        nextIsOperator = /[a-zA-Z]/.test(arr[i + 3]);
	                        if (isOperator && nextIsOperator) {
	                            arr.splice(
	                                i + 1, 0,
	                                arr[i + 1], arr[i + 2],
	                                arr[i + 1], arr[i + 2]
	                            );
	                        }
	                    }
	                }
	
	                /**
	                 * Insert an array at the given position of another array
	                 */
	                function insertSlice(arr, subArr, index) {
	                    [].splice.apply(
	                        arr, [index, 0].concat(subArr)
	                    );
	                }
	
	                /**
	                 * If shifting points, prepend a dummy point to the end path. 
	                 */
	                function prepend(arr, other) {
	                    while (arr.length < fullLength) {
	
	                        // Move to, line to or curve to?
	                        arr[0] = other[fullLength - arr.length];
	
	                        // Prepend a copy of the first point
	                        insertSlice(arr, arr.slice(0, numParams), 0);
	
	                        // For areas, the bottom path goes back again to the left, so we
	                        // need to append a copy of the last point.
	                        if (isArea) {
	                            insertSlice(
	                                arr,
	                                arr.slice(arr.length - numParams), arr.length
	                            );
	                            i--;
	                        }
	                    }
	                    arr[0] = 'M';
	                }
	
	                /**
	                 * Copy and append last point until the length matches the end length
	                 */
	                function append(arr, other) {
	                    var i = (fullLength - arr.length) / numParams;
	                    while (i > 0 && i--) {
	
	                        // Pull out the slice that is going to be appended or inserted.
	                        // In a line graph, the positionFactor is 1, and the last point
	                        // is sliced out. In an area graph, the positionFactor is 2,
	                        // causing the middle two points to be sliced out, since an area
	                        // path starts at left, follows the upper path then turns and
	                        // follows the bottom back. 
	                        slice = arr.slice().splice(
	                            (arr.length / positionFactor) - numParams,
	                            numParams * positionFactor
	                        );
	
	                        // Move to, line to or curve to?
	                        slice[0] = other[fullLength - numParams - (i * numParams)];
	
	                        // Disable first control point
	                        if (bezier) {
	                            slice[numParams - 6] = slice[numParams - 2];
	                            slice[numParams - 5] = slice[numParams - 1];
	                        }
	
	                        // Now insert the slice, either in the middle (for areas) or at
	                        // the end (for lines)
	                        insertSlice(arr, slice, arr.length / positionFactor);
	
	                        if (isArea) {
	                            i--;
	                        }
	                    }
	                }
	
	                if (bezier) {
	                    sixify(start);
	                    sixify(end);
	                }
	
	                // For sideways animation, find out how much we need to shift to get the
	                // start path Xs to match the end path Xs.
	                if (startX && endX) {
	                    for (i = 0; i < startX.length; i++) {
	                        // Moving left, new points coming in on right
	                        if (startX[i] === endX[0]) {
	                            shift = i;
	                            break;
	                            // Moving right
	                        } else if (startX[0] ===
	                            endX[endX.length - startX.length + i]) {
	                            shift = i;
	                            reverse = true;
	                            break;
	                        }
	                    }
	                    if (shift === undefined) {
	                        start = [];
	                    }
	                }
	
	                if (start.length && H.isNumber(shift)) {
	
	                    // The common target length for the start and end array, where both 
	                    // arrays are padded in opposite ends
	                    fullLength = end.length + shift * positionFactor * numParams;
	
	                    if (!reverse) {
	                        prepend(end, start);
	                        append(start, end);
	                    } else {
	                        prepend(start, end);
	                        append(end, start);
	                    }
	                }
	
	                return [start, end];
	            }
	        }; // End of Fx prototype
	
	        /**
	         * Handle animation of the color attributes directly.
	         */
	        H.Fx.prototype.fillSetter =
	            H.Fx.prototype.strokeSetter = function() {
	                this.elem.attr(
	                    this.prop,
	                    H.color(this.start).tweenTo(H.color(this.end), this.pos),
	                    null,
	                    true
	                );
	            };
	
	
	        /**
	         * Utility function to extend an object with the members of another.
	         *
	         * @function #extend
	         * @memberOf Highcharts
	         * @param {Object} a - The object to be extended.
	         * @param {Object} b - The object to add to the first one.
	         * @returns {Object} Object a, the original object.
	         */
	        H.extend = function(a, b) {
	            var n;
	            if (!a) {
	                a = {};
	            }
	            for (n in b) {
	                a[n] = b[n];
	            }
	            return a;
	        };
	
	        /**
	         * Utility function to deep merge two or more objects and return a third object.
	         * If the first argument is true, the contents of the second object is copied
	         * into the first object. The merge function can also be used with a single 
	         * object argument to create a deep copy of an object.
	         *
	         * @function #merge
	         * @memberOf Highcharts
	         * @param {Boolean} [extend] - Whether to extend the left-side object (a) or
	                  return a whole new object.
	         * @param {Object} a - The first object to extend. When only this is given, the
	                  function returns a deep copy.
	         * @param {...Object} [n] - An object to merge into the previous one.
	         * @returns {Object} - The merged object. If the first argument is true, the 
	         * return is the same as the second argument.
	         */
	        H.merge = function() {
	            var i,
	                args = arguments,
	                len,
	                ret = {},
	                doCopy = function(copy, original) {
	                    // An object is replacing a primitive
	                    if (typeof copy !== 'object') {
	                        copy = {};
	                    }
	
	                    H.objectEach(original, function(value, key) {
	
	                        // Copy the contents of objects, but not arrays or DOM nodes
	                        if (
	                            H.isObject(value, true) &&
	                            !H.isClass(value) &&
	                            !H.isDOMElement(value)
	                        ) {
	                            copy[key] = doCopy(copy[key] || {}, value);
	
	                            // Primitives and arrays are copied over directly
	                        } else {
	                            copy[key] = original[key];
	                        }
	                    });
	                    return copy;
	                };
	
	            // If first argument is true, copy into the existing object. Used in
	            // setOptions.
	            if (args[0] === true) {
	                ret = args[1];
	                args = Array.prototype.slice.call(args, 2);
	            }
	
	            // For each argument, extend the return
	            len = args.length;
	            for (i = 0; i < len; i++) {
	                ret = doCopy(ret, args[i]);
	            }
	
	            return ret;
	        };
	
	        /**
	         * Shortcut for parseInt
	         * @ignore
	         * @param {Object} s
	         * @param {Number} mag Magnitude
	         */
	        H.pInt = function(s, mag) {
	            return parseInt(s, mag || 10);
	        };
	
	        /**
	         * Utility function to check for string type.
	         *
	         * @function #isString
	         * @memberOf Highcharts
	         * @param {Object} s - The item to check.
	         * @returns {Boolean} - True if the argument is a string.
	         */
	        H.isString = function(s) {
	            return typeof s === 'string';
	        };
	
	        /**
	         * Utility function to check if an item is an array.
	         *
	         * @function #isArray
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @returns {Boolean} - True if the argument is an array.
	         */
	        H.isArray = function(obj) {
	            var str = Object.prototype.toString.call(obj);
	            return str === '[object Array]' || str === '[object Array Iterator]';
	        };
	
	        /**
	         * Utility function to check if an item is of type object.
	         *
	         * @function #isObject
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @param {Boolean} [strict=false] - Also checks that the object is not an
	         *    array.
	         * @returns {Boolean} - True if the argument is an object.
	         */
	        H.isObject = function(obj, strict) {
	            return !!obj && typeof obj === 'object' && (!strict || !H.isArray(obj));
	        };
	
	        /**
	         * Utility function to check if an Object is a HTML Element.
	         *
	         * @function #isDOMElement
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @returns {Boolean} - True if the argument is a HTML Element.
	         */
	        H.isDOMElement = function(obj) {
	            return H.isObject(obj) && typeof obj.nodeType === 'number';
	        };
	
	        /**
	         * Utility function to check if an Object is an class.
	         *
	         * @function #isClass
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @returns {Boolean} - True if the argument is an class.
	         */
	        H.isClass = function(obj) {
	            var c = obj && obj.constructor;
	            return !!(
	                H.isObject(obj, true) &&
	                !H.isDOMElement(obj) &&
	                (c && c.name && c.name !== 'Object')
	            );
	        };
	
	        /**
	         * Utility function to check if an item is of type number.
	         *
	         * @function #isNumber
	         * @memberOf Highcharts
	         * @param {Object} n - The item to check.
	         * @returns {Boolean} - True if the item is a number and is not NaN.
	         */
	        H.isNumber = function(n) {
	            return typeof n === 'number' && !isNaN(n);
	        };
	
	        /**
	         * Remove the last occurence of an item from an array.
	         *
	         * @function #erase
	         * @memberOf Highcharts
	         * @param {Array} arr - The array.
	         * @param {*} item - The item to remove.
	         */
	        H.erase = function(arr, item) {
	            var i = arr.length;
	            while (i--) {
	                if (arr[i] === item) {
	                    arr.splice(i, 1);
	                    break;
	                }
	            }
	        };
	
	        /**
	         * Check if an object is null or undefined.
	         *
	         * @function #defined
	         * @memberOf Highcharts
	         * @param {Object} obj - The object to check.
	         * @returns {Boolean} - False if the object is null or undefined, otherwise
	         *        true.
	         */
	        H.defined = function(obj) {
	            return obj !== undefined && obj !== null;
	        };
	
	        /**
	         * Set or get an attribute or an object of attributes. To use as a setter, pass
	         * a key and a value, or let the second argument be a collection of keys and
	         * values. To use as a getter, pass only a string as the second argument.
	         *
	         * @function #attr
	         * @memberOf Highcharts
	         * @param {Object} elem - The DOM element to receive the attribute(s).
	         * @param {String|Object} [prop] - The property or an object of key-value pairs.
	         * @param {String} [value] - The value if a single property is set.
	         * @returns {*} When used as a getter, return the value.
	         */
	        H.attr = function(elem, prop, value) {
	            var ret;
	
	            // if the prop is a string
	            if (H.isString(prop)) {
	                // set the value
	                if (H.defined(value)) {
	                    elem.setAttribute(prop, value);
	
	                    // get the value
	                } else if (elem && elem.getAttribute) {
	                    ret = elem.getAttribute(prop);
	                }
	
	                // else if prop is defined, it is a hash of key/value pairs
	            } else if (H.defined(prop) && H.isObject(prop)) {
	                H.objectEach(prop, function(val, key) {
	                    elem.setAttribute(key, val);
	                });
	            }
	            return ret;
	        };
	
	        /**
	         * Check if an element is an array, and if not, make it into an array.
	         *
	         * @function #splat
	         * @memberOf Highcharts
	         * @param obj {*} - The object to splat.
	         * @returns {Array} The produced or original array.
	         */
	        H.splat = function(obj) {
	            return H.isArray(obj) ? obj : [obj];
	        };
	
	        /**
	         * Set a timeout if the delay is given, otherwise perform the function
	         * synchronously.
	         *
	         * @function #syncTimeout
	         * @memberOf Highcharts
	         * @param   {Function} fn - The function callback.
	         * @param   {Number}   delay - Delay in milliseconds.
	         * @param   {Object}   [context] - The context.
	         * @returns {Number} An identifier for the timeout that can later be cleared
	         * with clearTimeout.
	         */
	        H.syncTimeout = function(fn, delay, context) {
	            if (delay) {
	                return setTimeout(fn, delay, context);
	            }
	            fn.call(0, context);
	        };
	
	
	        /**
	         * Return the first value that is not null or undefined.
	         *
	         * @function #pick
	         * @memberOf Highcharts
	         * @param {...*} items - Variable number of arguments to inspect.
	         * @returns {*} The value of the first argument that is not null or undefined.
	         */
	        H.pick = function() {
	            var args = arguments,
	                i,
	                arg,
	                length = args.length;
	            for (i = 0; i < length; i++) {
	                arg = args[i];
	                if (arg !== undefined && arg !== null) {
	                    return arg;
	                }
	            }
	        };
	
	        /**
	         * @typedef {Object} CSSObject - A style object with camel case property names.
	         * The properties can be whatever styles are supported on the given SVG or HTML
	         * element.
	         * @example
	         * {
	         *    fontFamily: 'monospace',
	         *    fontSize: '1.2em'
	         * }
	         */
	        /**
	         * Set CSS on a given element.
	         *
	         * @function #css
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} el - A HTML DOM element.
	         * @param {CSSObject} styles - Style object with camel case property names.
	         * @returns {void}
	         */
	        H.css = function(el, styles) {
	            if (H.isMS && !H.svg) { // #2686
	                if (styles && styles.opacity !== undefined) {
	                    styles.filter = 'alpha(opacity=' + (styles.opacity * 100) + ')';
	                }
	            }
	            H.extend(el.style, styles);
	        };
	
	        /**
	         * A HTML DOM element.
	         * @typedef {Object} HTMLDOMElement
	         */
	
	        /**
	         * Utility function to create an HTML element with attributes and styles.
	         *
	         * @function #createElement
	         * @memberOf Highcharts
	         * @param {String} tag - The HTML tag.
	         * @param {Object} [attribs] - Attributes as an object of key-value pairs.
	         * @param {CSSObject} [styles] - Styles as an object of key-value pairs.
	         * @param {Object} [parent] - The parent HTML object.
	         * @param {Boolean} [nopad=false] - If true, remove all padding, border and
	         *    margin.
	         * @returns {HTMLDOMElement} The created DOM element.
	         */
	        H.createElement = function(tag, attribs, styles, parent, nopad) {
	            var el = doc.createElement(tag),
	                css = H.css;
	            if (attribs) {
	                H.extend(el, attribs);
	            }
	            if (nopad) {
	                css(el, {
	                    padding: 0,
	                    border: 'none',
	                    margin: 0
	                });
	            }
	            if (styles) {
	                css(el, styles);
	            }
	            if (parent) {
	                parent.appendChild(el);
	            }
	            return el;
	        };
	
	        /**
	         * Extend a prototyped class by new members.
	         *
	         * @function #extendClass
	         * @memberOf Highcharts
	         * @param {Object} parent - The parent prototype to inherit.
	         * @param {Object} members - A collection of prototype members to add or
	         *        override compared to the parent prototype.
	         * @returns {Object} A new prototype.
	         */
	        H.extendClass = function(parent, members) {
	            var object = function() {};
	            object.prototype = new parent(); // eslint-disable-line new-cap
	            H.extend(object.prototype, members);
	            return object;
	        };
	
	        /**
	         * Left-pad a string to a given length by adding a character repetetively.
	         *
	         * @function #pad
	         * @memberOf Highcharts
	         * @param {Number} number - The input string or number.
	         * @param {Number} length - The desired string length.
	         * @param {String} [padder=0] - The character to pad with.
	         * @returns {String} The padded string.
	         */
	        H.pad = function(number, length, padder) {
	            return new Array((length || 2) + 1 -
	                String(number).length).join(padder || 0) + number;
	        };
	
	        /**
	         * @typedef {Number|String} RelativeSize - If a number is given, it defines the
	         *    pixel length. If a percentage string is given, like for example `'50%'`,
	         *    the setting defines a length relative to a base size, for example the size
	         *    of a container.
	         */
	        /**
	         * Return a length based on either the integer value, or a percentage of a base.
	         *
	         * @function #relativeLength
	         * @memberOf Highcharts
	         * @param {RelativeSize} value - A percentage string or a number.
	         * @param {Number} base - The full length that represents 100%.
	         * @returns {Number} The computed length.
	         */
	        H.relativeLength = function(value, base) {
	            return (/%$/).test(value) ?
	                base * parseFloat(value) / 100 :
	                parseFloat(value);
	        };
	
	        /**
	         * Wrap a method with extended functionality, preserving the original function.
	         *
	         * @function #wrap
	         * @memberOf Highcharts
	         * @param {Object} obj - The context object that the method belongs to. In real
	         *        cases, this is often a prototype.
	         * @param {String} method - The name of the method to extend.
	         * @param {Function} func - A wrapper function callback. This function is called
	         *        with the same arguments as the original function, except that the
	         *        original function is unshifted and passed as the first argument.
	         * @returns {void}
	         */
	        H.wrap = function(obj, method, func) {
	            var proceed = obj[method];
	            obj[method] = function() {
	                var args = Array.prototype.slice.call(arguments),
	                    outerArgs = arguments,
	                    ctx = this,
	                    ret;
	                ctx.proceed = function() {
	                    proceed.apply(ctx, arguments.length ? arguments : outerArgs);
	                };
	                args.unshift(proceed);
	                ret = func.apply(this, args);
	                ctx.proceed = null;
	                return ret;
	            };
	        };
	
	        /**
	         * Get the time zone offset based on the current timezone information as set in
	         * the global options.
	         *
	         * @function #getTZOffset
	         * @memberOf Highcharts
	         * @param  {Number} timestamp - The JavaScript timestamp to inspect.
	         * @return {Number} - The timezone offset in minutes compared to UTC.
	         */
	        H.getTZOffset = function(timestamp) {
	            var d = H.Date;
	            return ((d.hcGetTimezoneOffset && d.hcGetTimezoneOffset(timestamp)) ||
	                d.hcTimezoneOffset || 0) * 60000;
	        };
	
	        /**
	         * Formats a JavaScript date timestamp (milliseconds since Jan 1st 1970) into a
	         * human readable date string. The format is a subset of the formats for PHP's
	         * [strftime]{@link
	         * http://www.php.net/manual/en/function.strftime.php} function. Additional
	         * formats can be given in the {@link Highcharts.dateFormats} hook.
	         *
	         * @function #dateFormat
	         * @memberOf Highcharts
	         * @param {String} format - The desired format where various time
	         *        representations are prefixed with %.
	         * @param {Number} timestamp - The JavaScript timestamp.
	         * @param {Boolean} [capitalize=false] - Upper case first letter in the return.
	         * @returns {String} The formatted date.
	         */
	        H.dateFormat = function(format, timestamp, capitalize) {
	            if (!H.defined(timestamp) || isNaN(timestamp)) {
	                return H.defaultOptions.lang.invalidDate || '';
	            }
	            format = H.pick(format, '%Y-%m-%d %H:%M:%S');
	
	            var D = H.Date,
	                date = new D(timestamp - H.getTZOffset(timestamp)),
	                // get the basic time values
	                hours = date[D.hcGetHours](),
	                day = date[D.hcGetDay](),
	                dayOfMonth = date[D.hcGetDate](),
	                month = date[D.hcGetMonth](),
	                fullYear = date[D.hcGetFullYear](),
	                lang = H.defaultOptions.lang,
	                langWeekdays = lang.weekdays,
	                shortWeekdays = lang.shortWeekdays,
	                pad = H.pad,
	
	                // List all format keys. Custom formats can be added from the outside. 
	                replacements = H.extend({
	
	                        //-- Day
	                        // Short weekday, like 'Mon'
	                        'a': shortWeekdays ?
	                            shortWeekdays[day] : langWeekdays[day].substr(0, 3),
	                        // Long weekday, like 'Monday'
	                        'A': langWeekdays[day],
	                        // Two digit day of the month, 01 to 31
	                        'd': pad(dayOfMonth),
	                        // Day of the month, 1 through 31
	                        'e': pad(dayOfMonth, 2, ' '),
	                        'w': day,
	
	                        // Week (none implemented)
	                        //'W': weekNumber(),
	
	                        //-- Month
	                        // Short month, like 'Jan'
	                        'b': lang.shortMonths[month],
	                        // Long month, like 'January'
	                        'B': lang.months[month],
	                        // Two digit month number, 01 through 12
	                        'm': pad(month + 1),
	
	                        //-- Year
	                        // Two digits year, like 09 for 2009
	                        'y': fullYear.toString().substr(2, 2),
	                        // Four digits year, like 2009
	                        'Y': fullYear,
	
	                        //-- Time
	                        // Two digits hours in 24h format, 00 through 23
	                        'H': pad(hours),
	                        // Hours in 24h format, 0 through 23
	                        'k': hours,
	                        // Two digits hours in 12h format, 00 through 11
	                        'I': pad((hours % 12) || 12),
	                        // Hours in 12h format, 1 through 12
	                        'l': (hours % 12) || 12,
	                        // Two digits minutes, 00 through 59
	                        'M': pad(date[D.hcGetMinutes]()),
	                        // Upper case AM or PM
	                        'p': hours < 12 ? 'AM' : 'PM',
	                        // Lower case AM or PM
	                        'P': hours < 12 ? 'am' : 'pm',
	                        // Two digits seconds, 00 through  59
	                        'S': pad(date.getSeconds()),
	                        // Milliseconds (naming from Ruby)
	                        'L': pad(Math.round(timestamp % 1000), 3)
	                    },
	
	                    /**
	                     * A hook for defining additional date format specifiers. New
	                     * specifiers are defined as key-value pairs by using the specifier
	                     * as key, and a function which takes the timestamp as value. This
	                     * function returns the formatted portion of the date.
	                     *
	                     * @type {Object}
	                     * @name dateFormats
	                     * @memberOf Highcharts
	                     * @sample highcharts/global/dateformats/ Adding support for week
	                     * number
	                     */
	                    H.dateFormats
	                );
	
	
	            // Do the replaces
	            H.objectEach(replacements, function(val, key) {
	                // Regex would do it in one line, but this is faster
	                while (format.indexOf('%' + key) !== -1) {
	                    format = format.replace(
	                        '%' + key,
	                        typeof val === 'function' ? val(timestamp) : val
	                    );
	                }
	
	            });
	
	            // Optionally capitalize the string and return
	            return capitalize ?
	                format.substr(0, 1).toUpperCase() + format.substr(1) :
	                format;
	        };
	
	        /**
	         * Format a single variable. Similar to sprintf, without the % prefix.
	         *
	         * @example
	         * formatSingle('.2f', 5); // => '5.00'.
	         *
	         * @function #formatSingle
	         * @memberOf Highcharts
	         * @param {String} format The format string.
	         * @param {*} val The value.
	         * @returns {String} The formatted representation of the value.
	         */
	        H.formatSingle = function(format, val) {
	            var floatRegex = /f$/,
	                decRegex = /\.([0-9])/,
	                lang = H.defaultOptions.lang,
	                decimals;
	
	            if (floatRegex.test(format)) { // float
	                decimals = format.match(decRegex);
	                decimals = decimals ? decimals[1] : -1;
	                if (val !== null) {
	                    val = H.numberFormat(
	                        val,
	                        decimals,
	                        lang.decimalPoint,
	                        format.indexOf(',') > -1 ? lang.thousandsSep : ''
	                    );
	                }
	            } else {
	                val = H.dateFormat(format, val);
	            }
	            return val;
	        };
	
	        /**
	         * Format a string according to a subset of the rules of Python's String.format
	         * method.
	         *
	         * @function #format
	         * @memberOf Highcharts
	         * @param {String} str The string to format.
	         * @param {Object} ctx The context, a collection of key-value pairs where each
	         *        key is replaced by its value.
	         * @returns {String} The formatted string.
	         *
	         * @example
	         * var s = Highcharts.format(
	         *     'The {color} fox was {len:.2f} feet long',
	         *     { color: 'red', len: Math.PI }
	         * );
	         * // => The red fox was 3.14 feet long
	         */
	        H.format = function(str, ctx) {
	            var splitter = '{',
	                isInside = false,
	                segment,
	                valueAndFormat,
	                path,
	                i,
	                len,
	                ret = [],
	                val,
	                index;
	
	            while (str) {
	                index = str.indexOf(splitter);
	                if (index === -1) {
	                    break;
	                }
	
	                segment = str.slice(0, index);
	                if (isInside) { // we're on the closing bracket looking back
	
	                    valueAndFormat = segment.split(':');
	                    path = valueAndFormat.shift().split('.'); // get first and leave
	                    len = path.length;
	                    val = ctx;
	
	                    // Assign deeper paths
	                    for (i = 0; i < len; i++) {
	                        val = val[path[i]];
	                    }
	
	                    // Format the replacement
	                    if (valueAndFormat.length) {
	                        val = H.formatSingle(valueAndFormat.join(':'), val);
	                    }
	
	                    // Push the result and advance the cursor
	                    ret.push(val);
	
	                } else {
	                    ret.push(segment);
	
	                }
	                str = str.slice(index + 1); // the rest
	                isInside = !isInside; // toggle
	                splitter = isInside ? '}' : '{'; // now look for next matching bracket
	            }
	            ret.push(str);
	            return ret.join('');
	        };
	
	        /**
	         * Get the magnitude of a number.
	         *
	         * @function #getMagnitude
	         * @memberOf Highcharts
	         * @param {Number} number The number.
	         * @returns {Number} The magnitude, where 1-9 are magnitude 1, 10-99 magnitude 2
	         *        etc.
	         */
	        H.getMagnitude = function(num) {
	            return Math.pow(10, Math.floor(Math.log(num) / Math.LN10));
	        };
	
	        /**
	         * Take an interval and normalize it to multiples of round numbers.
	         *
	         * @todo  Move this function to the Axis prototype. It is here only for
	         *        historical reasons.
	         * @function #normalizeTickInterval
	         * @memberOf Highcharts
	         * @param {Number} interval - The raw, un-rounded interval.
	         * @param {Array} [multiples] - Allowed multiples.
	         * @param {Number} [magnitude] - The magnitude of the number.
	         * @param {Boolean} [allowDecimals] - Whether to allow decimals.
	         * @param {Boolean} [hasTickAmount] - If it has tickAmount, avoid landing
	         *        on tick intervals lower than original.
	         * @returns {Number} The normalized interval.
	         */
	        H.normalizeTickInterval = function(interval, multiples, magnitude,
	            allowDecimals, hasTickAmount) {
	            var normalized,
	                i,
	                retInterval = interval;
	
	            // round to a tenfold of 1, 2, 2.5 or 5
	            magnitude = H.pick(magnitude, 1);
	            normalized = interval / magnitude;
	
	            // multiples for a linear scale
	            if (!multiples) {
	                multiples = hasTickAmount ?
	                    // Finer grained ticks when the tick amount is hard set, including
	                    // when alignTicks is true on multiple axes (#4580).
	                    [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] :
	
	                    // Else, let ticks fall on rounder numbers
	                    [1, 2, 2.5, 5, 10];
	
	
	                // the allowDecimals option
	                if (allowDecimals === false) {
	                    if (magnitude === 1) {
	                        multiples = H.grep(multiples, function(num) {
	                            return num % 1 === 0;
	                        });
	                    } else if (magnitude <= 0.1) {
	                        multiples = [1 / magnitude];
	                    }
	                }
	            }
	
	            // normalize the interval to the nearest multiple
	            for (i = 0; i < multiples.length; i++) {
	                retInterval = multiples[i];
	                // only allow tick amounts smaller than natural
	                if ((hasTickAmount && retInterval * magnitude >= interval) ||
	                    (!hasTickAmount && (normalized <= (multiples[i] +
	                        (multiples[i + 1] || multiples[i])) / 2))) {
	                    break;
	                }
	            }
	
	            // Multiply back to the correct magnitude. Correct floats to appropriate 
	            // precision (#6085).
	            retInterval = H.correctFloat(
	                retInterval * magnitude, -Math.round(Math.log(0.001) / Math.LN10)
	            );
	
	            return retInterval;
	        };
	
	
	        /**
	         * Sort an object array and keep the order of equal items. The ECMAScript
	         * standard does not specify the behaviour when items are equal.
	         *
	         * @function #stableSort
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to sort.
	         * @param {Function} sortFunction - The function to sort it with, like with 
	         *        regular Array.prototype.sort.
	         * @returns {void}
	         */
	        H.stableSort = function(arr, sortFunction) {
	            var length = arr.length,
	                sortValue,
	                i;
	
	            // Add index to each item
	            for (i = 0; i < length; i++) {
	                arr[i].safeI = i; // stable sort index
	            }
	
	            arr.sort(function(a, b) {
	                sortValue = sortFunction(a, b);
	                return sortValue === 0 ? a.safeI - b.safeI : sortValue;
	            });
	
	            // Remove index from items
	            for (i = 0; i < length; i++) {
	                delete arr[i].safeI; // stable sort index
	            }
	        };
	
	        /**
	         * Non-recursive method to find the lowest member of an array. `Math.min` raises
	         * a maximum call stack size exceeded error in Chrome when trying to apply more
	         * than 150.000 points. This method is slightly slower, but safe.
	         *
	         * @function #arrayMin
	         * @memberOf  Highcharts
	         * @param {Array} data An array of numbers.
	         * @returns {Number} The lowest number.
	         */
	        H.arrayMin = function(data) {
	            var i = data.length,
	                min = data[0];
	
	            while (i--) {
	                if (data[i] < min) {
	                    min = data[i];
	                }
	            }
	            return min;
	        };
	
	        /**
	         * Non-recursive method to find the lowest member of an array. `Math.max` raises
	         * a maximum call stack size exceeded error in Chrome when trying to apply more
	         * than 150.000 points. This method is slightly slower, but safe.
	         *
	         * @function #arrayMax
	         * @memberOf  Highcharts
	         * @param {Array} data - An array of numbers.
	         * @returns {Number} The highest number.
	         */
	        H.arrayMax = function(data) {
	            var i = data.length,
	                max = data[0];
	
	            while (i--) {
	                if (data[i] > max) {
	                    max = data[i];
	                }
	            }
	            return max;
	        };
	
	        /**
	         * Utility method that destroys any SVGElement instances that are properties on
	         * the given object. It loops all properties and invokes destroy if there is a
	         * destroy method. The property is then delete.
	         *
	         * @function #destroyObjectProperties
	         * @memberOf Highcharts
	         * @param {Object} obj - The object to destroy properties on.
	         * @param {Object} [except] - Exception, do not destroy this property, only
	         *    delete it.
	         * @returns {void}
	         */
	        H.destroyObjectProperties = function(obj, except) {
	            H.objectEach(obj, function(val, n) {
	                // If the object is non-null and destroy is defined
	                if (val && val !== except && val.destroy) {
	                    // Invoke the destroy
	                    val.destroy();
	                }
	
	                // Delete the property from the object.
	                delete obj[n];
	            });
	        };
	
	
	        /**
	         * Discard a HTML element by moving it to the bin and delete.
	         *
	         * @function #discardElement
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} element - The HTML node to discard.
	         * @returns {void}
	         */
	        H.discardElement = function(element) {
	            var garbageBin = H.garbageBin;
	            // create a garbage bin element, not part of the DOM
	            if (!garbageBin) {
	                garbageBin = H.createElement('div');
	            }
	
	            // move the node and empty bin
	            if (element) {
	                garbageBin.appendChild(element);
	            }
	            garbageBin.innerHTML = '';
	        };
	
	        /**
	         * Fix JS round off float errors.
	         *
	         * @function #correctFloat
	         * @memberOf Highcharts
	         * @param {Number} num - A float number to fix.
	         * @param {Number} [prec=14] - The precision.
	         * @returns {Number} The corrected float number.
	         */
	        H.correctFloat = function(num, prec) {
	            return parseFloat(
	                num.toPrecision(prec || 14)
	            );
	        };
	
	        /**
	         * Set the global animation to either a given value, or fall back to the given
	         * chart's animation option.
	         *
	         * @function #setAnimation
	         * @memberOf Highcharts
	         * @param {Boolean|Animation} animation - The animation object.
	         * @param {Object} chart - The chart instance.
	         * @returns {void}
	         * @todo This function always relates to a chart, and sets a property on the
	         *        renderer, so it should be moved to the SVGRenderer.
	         */
	        H.setAnimation = function(animation, chart) {
	            chart.renderer.globalAnimation = H.pick(
	                animation,
	                chart.options.chart.animation,
	                true
	            );
	        };
	
	        /**
	         * Get the animation in object form, where a disabled animation is always
	         * returned as `{ duration: 0 }`.
	         *
	         * @function #animObject
	         * @memberOf Highcharts
	         * @param {Boolean|AnimationOptions} animation - An animation setting. Can be an
	         *        object with duration, complete and easing properties, or a boolean to
	         *        enable or disable.
	         * @returns {AnimationOptions} An object with at least a duration property.
	         */
	        H.animObject = function(animation) {
	            return H.isObject(animation) ?
	                H.merge(animation) : {
	                    duration: animation ? 500 : 0
	                };
	        };
	
	        /**
	         * The time unit lookup
	         */
	        H.timeUnits = {
	            millisecond: 1,
	            second: 1000,
	            minute: 60000,
	            hour: 3600000,
	            day: 24 * 3600000,
	            week: 7 * 24 * 3600000,
	            month: 28 * 24 * 3600000,
	            year: 364 * 24 * 3600000
	        };
	
	        /**
	         * Format a number and return a string based on input settings.
	         *
	         * @function #numberFormat
	         * @memberOf Highcharts
	         * @param {Number} number - The input number to format.
	         * @param {Number} decimals - The amount of decimals. A value of -1 preserves
	         *        the amount in the input number.
	         * @param {String} [decimalPoint] - The decimal point, defaults to the one given
	         *        in the lang options, or a dot.
	         * @param {String} [thousandsSep] - The thousands separator, defaults to the one
	         *        given in the lang options, or a space character.
	         * @returns {String} The formatted number.
	         *
	         * @sample members/highcharts-numberformat/ Custom number format
	         */
	        H.numberFormat = function(number, decimals, decimalPoint, thousandsSep) {
	            number = +number || 0;
	            decimals = +decimals;
	
	            var lang = H.defaultOptions.lang,
	                origDec = (number.toString().split('.')[1] || '').length,
	                strinteger,
	                thousands,
	                ret,
	                roundedNumber;
	
	            if (decimals === -1) {
	                // Preserve decimals. Not huge numbers (#3793).
	                decimals = Math.min(origDec, 20);
	            } else if (!H.isNumber(decimals)) {
	                decimals = 2;
	            }
	
	            // Add another decimal to avoid rounding errors of float numbers. (#4573)
	            // Then use toFixed to handle rounding.
	            roundedNumber = (
	                Math.abs(number) + Math.pow(10, -Math.max(decimals, origDec) - 1)
	            ).toFixed(decimals);
	
	            // A string containing the positive integer component of the number
	            strinteger = String(H.pInt(roundedNumber));
	
	            // Leftover after grouping into thousands. Can be 0, 1 or 3.
	            thousands = strinteger.length > 3 ? strinteger.length % 3 : 0;
	
	            // Language
	            decimalPoint = H.pick(decimalPoint, lang.decimalPoint);
	            thousandsSep = H.pick(thousandsSep, lang.thousandsSep);
	
	            // Start building the return
	            ret = number < 0 ? '-' : '';
	
	            // Add the leftover after grouping into thousands. For example, in the
	            // number 42 000 000, this line adds 42.
	            ret += thousands ? strinteger.substr(0, thousands) + thousandsSep : '';
	
	            // Add the remaining thousands groups, joined by the thousands separator
	            ret += strinteger
	                .substr(thousands)
	                .replace(/(\d{3})(?=\d)/g, '$1' + thousandsSep);
	
	            // Add the decimal point and the decimal component
	            if (decimals) {
	                // Get the decimal component
	                ret += decimalPoint + roundedNumber.slice(-decimals);
	            }
	
	            return ret;
	        };
	
	        /**
	         * Easing definition
	         * @ignore
	         * @param   {Number} pos Current position, ranging from 0 to 1.
	         */
	        Math.easeInOutSine = function(pos) {
	            return -0.5 * (Math.cos(Math.PI * pos) - 1);
	        };
	
	        /**
	         * Get the computed CSS value for given element and property, only for numerical
	         * properties. For width and height, the dimension of the inner box (excluding
	         * padding) is returned. Used for fitting the chart within the container.
	         *
	         * @function #getStyle
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} el - A HTML element.
	         * @param {String} prop - The property name.
	         * @param {Boolean} [toInt=true] - Parse to integer.
	         * @returns {Number} - The numeric value.
	         */
	        H.getStyle = function(el, prop, toInt) {
	
	            var style;
	
	            // For width and height, return the actual inner pixel size (#4913)
	            if (prop === 'width') {
	                return Math.min(el.offsetWidth, el.scrollWidth) -
	                    H.getStyle(el, 'padding-left') -
	                    H.getStyle(el, 'padding-right');
	            } else if (prop === 'height') {
	                return Math.min(el.offsetHeight, el.scrollHeight) -
	                    H.getStyle(el, 'padding-top') -
	                    H.getStyle(el, 'padding-bottom');
	            }
	
	            // Otherwise, get the computed style
	            style = win.getComputedStyle(el, undefined);
	            if (style) {
	                style = style.getPropertyValue(prop);
	                if (H.pick(toInt, true)) {
	                    style = H.pInt(style);
	                }
	            }
	            return style;
	        };
	
	        /**
	         * Search for an item in an array.
	         *
	         * @function #inArray
	         * @memberOf Highcharts
	         * @param {*} item - The item to search for.
	         * @param {arr} arr - The array or node collection to search in.
	         * @returns {Number} - The index within the array, or -1 if not found.
	         */
	        H.inArray = function(item, arr) {
	            return arr.indexOf ? arr.indexOf(item) : [].indexOf.call(arr, item);
	        };
	
	        /**
	         * Filter an array by a callback.
	         *
	         * @function #grep
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to filter.
	         * @param {Function} callback - The callback function. The function receives the
	         *        item as the first argument. Return `true` if the item is to be
	         *        preserved.
	         * @returns {Array} - A new, filtered array.
	         */
	        H.grep = function(arr, callback) {
	            return [].filter.call(arr, callback);
	        };
	
	        /**
	         * Return the value of the first element in the array that satisfies the 
	         * provided testing function.
	         *
	         * @function #find
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to test.
	         * @param {Function} callback - The callback function. The function receives the
	         *        item as the first argument. Return `true` if this item satisfies the
	         *        condition.
	         * @returns {Mixed} - The value of the element.
	         */
	        H.find = function(arr, callback) {
	            return [].find.call(arr, callback);
	        };
	
	        /**
	         * Map an array by a callback.
	         *
	         * @function #map
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to map.
	         * @param {Function} fn - The callback function. Return the new value for the 
	         *        new array.
	         * @returns {Array} - A new array item with modified items.
	         */
	        H.map = function(arr, fn) {
	            var results = [],
	                i = 0,
	                len = arr.length;
	
	            for (; i < len; i++) {
	                results[i] = fn.call(arr[i], arr[i], i, arr);
	            }
	
	            return results;
	        };
	
	        /**
	         * Get the element's offset position, corrected for `overflow: auto`.
	         *
	         * @function #offset
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} el - The HTML element.
	         * @returns {Object} An object containing `left` and `top` properties for the
	         * position in the page.
	         */
	        H.offset = function(el) {
	            var docElem = doc.documentElement,
	                box = el.getBoundingClientRect();
	
	            return {
	                top: box.top + (win.pageYOffset || docElem.scrollTop) -
	                    (docElem.clientTop || 0),
	                left: box.left + (win.pageXOffset || docElem.scrollLeft) -
	                    (docElem.clientLeft || 0)
	            };
	        };
	
	        /**
	         * Stop running animation.
	         *
	         * @todo A possible extension to this would be to stop a single property, when
	         * we want to continue animating others. Then assign the prop to the timer
	         * in the Fx.run method, and check for the prop here. This would be an
	         * improvement in all cases where we stop the animation from .attr. Instead of
	         * stopping everything, we can just stop the actual attributes we're setting.
	         *
	         * @function #stop
	         * @memberOf Highcharts
	         * @param {SVGElement} el - The SVGElement to stop animation on.
	         * @param {string} [prop] - The property to stop animating. If given, the stop
	         *    method will stop a single property from animating, while others continue.
	         * @returns {void}
	         */
	        H.stop = function(el, prop) {
	
	            var i = timers.length;
	
	            // Remove timers related to this element (#4519)
	            while (i--) {
	                if (timers[i].elem === el && (!prop || prop === timers[i].prop)) {
	                    timers[i].stopped = true; // #4667
	                }
	            }
	        };
	
	        /**
	         * Iterate over an array.
	         *
	         * @function #each
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to iterate over.
	         * @param {Function} fn - The iterator callback. It passes three arguments:
	         * * item - The array item.
	         * * index - The item's index in the array.
	         * * arr - The array that each is being applied to.
	         * @param {Object} [ctx] The context.
	         */
	        H.each = function(arr, fn, ctx) { // modern browsers
	            return Array.prototype.forEach.call(arr, fn, ctx);
	        };
	
	        /**
	         * Iterate over object key pairs in an object.
	         *
	         * @function #objectEach
	         * @memberOf Highcharts
	         * @param  {Object}   obj - The object to iterate over.
	         * @param  {Function} fn  - The iterator callback. It passes three arguments:
	         * * value - The property value.
	         * * key - The property key.
	         * * obj - The object that objectEach is being applied to.
	         * @param  {Object}   ctx The context
	         */
	        H.objectEach = function(obj, fn, ctx) {
	            for (var key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    fn.call(ctx, obj[key], key, obj);
	                }
	            }
	        };
	
	        /**
	         * Add an event listener.
	         *
	         * @function #addEvent
	         * @memberOf Highcharts
	         * @param {Object} el - The element or object to add a listener to. It can be a
	         *        {@link HTMLDOMElement}, an {@link SVGElement} or any other object.
	         * @param {String} type - The event type.
	         * @param {Function} fn - The function callback to execute when the event is 
	         *        fired.
	         * @returns {Function} A callback function to remove the added event.
	         */
	        H.addEvent = function(el, type, fn) {
	
	            var events = el.hcEvents = el.hcEvents || {};
	
	            function wrappedFn(e) {
	                e.target = e.srcElement || win; // #2820
	                fn.call(el, e);
	            }
	
	            // Handle DOM events in modern browsers
	            if (el.addEventListener) {
	                el.addEventListener(type, fn, false);
	
	                // Handle old IE implementation
	            } else if (el.attachEvent) {
	
	                if (!el.hcEventsIE) {
	                    el.hcEventsIE = {};
	                }
	
	                // Link wrapped fn with original fn, so we can get this in removeEvent
	                el.hcEventsIE[fn.toString()] = wrappedFn;
	
	                el.attachEvent('on' + type, wrappedFn);
	            }
	
	            if (!events[type]) {
	                events[type] = [];
	            }
	
	            events[type].push(fn);
	
	            // Return a function that can be called to remove this event.
	            return function() {
	                H.removeEvent(el, type, fn);
	            };
	        };
	
	        /**
	         * Remove an event that was added with {@link Highcharts#addEvent}.
	         *
	         * @function #removeEvent
	         * @memberOf Highcharts
	         * @param {Object} el - The element to remove events on.
	         * @param {String} [type] - The type of events to remove. If undefined, all
	         *        events are removed from the element.
	         * @param {Function} [fn] - The specific callback to remove. If undefined, all
	         *        events that match the element and optionally the type are removed.
	         * @returns {void}
	         */
	        H.removeEvent = function(el, type, fn) {
	
	            var events,
	                hcEvents = el.hcEvents,
	                index;
	
	            function removeOneEvent(type, fn) {
	                if (el.removeEventListener) {
	                    el.removeEventListener(type, fn, false);
	                } else if (el.attachEvent) {
	                    fn = el.hcEventsIE[fn.toString()];
	                    el.detachEvent('on' + type, fn);
	                }
	            }
	
	            function removeAllEvents() {
	                var types,
	                    len;
	
	                if (!el.nodeName) {
	                    return; // break on non-DOM events
	                }
	
	                if (type) {
	                    types = {};
	                    types[type] = true;
	                } else {
	                    types = hcEvents;
	                }
	
	                H.objectEach(types, function(val, n) {
	                    if (hcEvents[n]) {
	                        len = hcEvents[n].length;
	                        while (len--) {
	                            removeOneEvent(n, hcEvents[n][len]);
	                        }
	                    }
	                });
	            }
	
	            if (hcEvents) {
	                if (type) {
	                    events = hcEvents[type] || [];
	                    if (fn) {
	                        index = H.inArray(fn, events);
	                        if (index > -1) {
	                            events.splice(index, 1);
	                            hcEvents[type] = events;
	                        }
	                        removeOneEvent(type, fn);
	
	                    } else {
	                        removeAllEvents();
	                        hcEvents[type] = [];
	                    }
	                } else {
	                    removeAllEvents();
	                    el.hcEvents = {};
	                }
	            }
	        };
	
	        /**
	         * Fire an event that was registered with {@link Highcharts#addEvent}.
	         *
	         * @function #fireEvent
	         * @memberOf Highcharts
	         * @param {Object} el - The object to fire the event on. It can be a
	         *        {@link HTMLDOMElement}, an {@link SVGElement} or any other object.
	         * @param {String} type - The type of event.
	         * @param {Object} [eventArguments] - Custom event arguments that are passed on
	         *        as an argument to the event handler.
	         * @param {Function} [defaultFunction] - The default function to execute if the 
	         *        other listeners haven't returned false.
	         * @returns {void}
	         */
	        H.fireEvent = function(el, type, eventArguments, defaultFunction) {
	            var e,
	                hcEvents = el.hcEvents,
	                events,
	                len,
	                i,
	                fn;
	
	            eventArguments = eventArguments || {};
	
	            if (doc.createEvent && (el.dispatchEvent || el.fireEvent)) {
	                e = doc.createEvent('Events');
	                e.initEvent(type, true, true);
	                //e.target = el;
	
	                H.extend(e, eventArguments);
	
	                if (el.dispatchEvent) {
	                    el.dispatchEvent(e);
	                } else {
	                    el.fireEvent(type, e);
	                }
	
	            } else if (hcEvents) {
	
	                events = hcEvents[type] || [];
	                len = events.length;
	
	                if (!eventArguments.target) { // We're running a custom event
	
	                    H.extend(eventArguments, {
	                        // Attach a simple preventDefault function to skip default
	                        // handler if called. The built-in defaultPrevented property is
	                        // not overwritable (#5112)
	                        preventDefault: function() {
	                            eventArguments.defaultPrevented = true;
	                        },
	                        // Setting target to native events fails with clicking the
	                        // zoom-out button in Chrome.
	                        target: el,
	                        // If the type is not set, we're running a custom event (#2297).
	                        // If it is set, we're running a browser event, and setting it
	                        // will cause en error in IE8 (#2465).		
	                        type: type
	                    });
	                }
	
	
	                for (i = 0; i < len; i++) {
	                    fn = events[i];
	
	                    // If the event handler return false, prevent the default handler
	                    // from executing
	                    if (fn && fn.call(el, eventArguments) === false) {
	                        eventArguments.preventDefault();
	                    }
	                }
	            }
	
	            // Run the default if not prevented
	            if (defaultFunction && !eventArguments.defaultPrevented) {
	                defaultFunction(eventArguments);
	            }
	        };
	
	        /**
	         * An animation configuration. Animation configurations can also be defined as
	         * booleans, where `false` turns off animation and `true` defaults to a duration
	         * of 500ms.
	         * @typedef {Object} AnimationOptions
	         * @property {Number} duration - The animation duration in milliseconds.
	         * @property {String} [easing] - The name of an easing function as defined on
	         *     the `Math` object.
	         * @property {Function} [complete] - A callback function to exectute when the
	         *     animation finishes.
	         * @property {Function} [step] - A callback function to execute on each step of
	         *     each attribute or CSS property that's being animated. The first argument
	         *     contains information about the animation and progress.
	         */
	
	
	        /**
	         * The global animate method, which uses Fx to create individual animators.
	         *
	         * @function #animate
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement|SVGElement} el - The element to animate.
	         * @param {Object} params - An object containing key-value pairs of the
	         *        properties to animate. Supports numeric as pixel-based CSS properties
	         *        for HTML objects and attributes for SVGElements.
	         * @param {AnimationOptions} [opt] - Animation options.
	         */
	        H.animate = function(el, params, opt) {
	            var start,
	                unit = '',
	                end,
	                fx,
	                args;
	
	            if (!H.isObject(opt)) { // Number or undefined/null
	                args = arguments;
	                opt = {
	                    duration: args[2],
	                    easing: args[3],
	                    complete: args[4]
	                };
	            }
	            if (!H.isNumber(opt.duration)) {
	                opt.duration = 400;
	            }
	            opt.easing = typeof opt.easing === 'function' ?
	                opt.easing :
	                (Math[opt.easing] || Math.easeInOutSine);
	            opt.curAnim = H.merge(params);
	
	            H.objectEach(params, function(val, prop) {
	                // Stop current running animation of this property
	                H.stop(el, prop);
	
	                fx = new H.Fx(el, opt, prop);
	                end = null;
	
	                if (prop === 'd') {
	                    fx.paths = fx.initPath(
	                        el,
	                        el.d,
	                        params.d
	                    );
	                    fx.toD = params.d;
	                    start = 0;
	                    end = 1;
	                } else if (el.attr) {
	                    start = el.attr(prop);
	                } else {
	                    start = parseFloat(H.getStyle(el, prop)) || 0;
	                    if (prop !== 'opacity') {
	                        unit = 'px';
	                    }
	                }
	
	                if (!end) {
	                    end = val;
	                }
	                if (end && end.match && end.match('px')) {
	                    end = end.replace(/px/g, ''); // #4351
	                }
	                fx.run(start, end, unit);
	            });
	        };
	
	        /**
	         * Factory to create new series prototypes.
	         *
	         * @function #seriesType
	         * @memberOf Highcharts
	         *
	         * @param {String} type - The series type name.
	         * @param {String} parent - The parent series type name. Use `line` to inherit
	         *        from the basic {@link Series} object.
	         * @param {Object} options - The additional default options that is merged with
	         *        the parent's options.
	         * @param {Object} props - The properties (functions and primitives) to set on
	         *        the new prototype.
	         * @param {Object} [pointProps] - Members for a series-specific extension of the
	         *        {@link Point} prototype if needed.
	         * @returns {*} - The newly created prototype as extended from {@link Series}
	         * or its derivatives.
	         */
	        // docs: add to API + extending Highcharts
	        H.seriesType = function(type, parent, options, props, pointProps) {
	            var defaultOptions = H.getOptions(),
	                seriesTypes = H.seriesTypes;
	
	            if (seriesTypes[type]) {
	                return H.error(27); // Series type already defined
	            }
	
	            // Merge the options
	            defaultOptions.plotOptions[type] = H.merge(
	                defaultOptions.plotOptions[parent],
	                options
	            );
	
	            // Create the class
	            seriesTypes[type] = H.extendClass(seriesTypes[parent] ||
	                function() {}, props);
	            seriesTypes[type].prototype.type = type;
	
	            // Create the point class if needed
	            if (pointProps) {
	                seriesTypes[type].prototype.pointClass =
	                    H.extendClass(H.Point, pointProps);
	            }
	
	            return seriesTypes[type];
	        };
	
	        /**
	         * Get a unique key for using in internal element id's and pointers. The key
	         * is composed of a random hash specific to this Highcharts instance, and a 
	         * counter.
	         * @function #uniqueKey
	         * @memberOf Highcharts
	         * @return {string} The key.
	         * @example
	         * var id = H.uniqueKey(); // => 'highcharts-x45f6hp-0'
	         */
	        H.uniqueKey = (function() {
	
	            var uniqueKeyHash = Math.random().toString(36).substring(2, 9),
	                idCounter = 0;
	
	            return function() {
	                return 'highcharts-' + uniqueKeyHash + '-' + idCounter++;
	            };
	        }());
	
	        /**
	         * Register Highcharts as a plugin in jQuery
	         */
	        if (win.jQuery) {
	            win.jQuery.fn.highcharts = function() {
	                var args = [].slice.call(arguments);
	
	                if (this[0]) { // this[0] is the renderTo div
	
	                    // Create the chart
	                    if (args[0]) {
	                        new H[ // eslint-disable-line no-new
	                            // Constructor defaults to Chart
	                            H.isString(args[0]) ? args.shift() : 'Chart'
	                        ](this[0], args[0], args[1]);
	                        return this;
	                    }
	
	                    // When called without parameters or with the return argument,
	                    // return an existing chart
	                    return charts[H.attr(this[0], 'data-highcharts-chart')];
	                }
	            };
	        }
	
	
	        /**
	         * Compatibility section to add support for legacy IE. This can be removed if
	         * old IE support is not needed.
	         */
	        if (doc && !doc.defaultView) {
	            H.getStyle = function(el, prop) {
	                var val,
	                    alias = {
	                        width: 'clientWidth',
	                        height: 'clientHeight'
	                    }[prop];
	
	                if (el.style[prop]) {
	                    return H.pInt(el.style[prop]);
	                }
	                if (prop === 'opacity') {
	                    prop = 'filter';
	                }
	
	                // Getting the rendered width and height
	                if (alias) {
	                    el.style.zoom = 1;
	                    return Math.max(el[alias] - 2 * H.getStyle(el, 'padding'), 0);
	                }
	
	                val = el.currentStyle[prop.replace(/\-(\w)/g, function(a, b) {
	                    return b.toUpperCase();
	                })];
	                if (prop === 'filter') {
	                    val = val.replace(
	                        /alpha\(opacity=([0-9]+)\)/,
	                        function(a, b) {
	                            return b / 100;
	                        }
	                    );
	                }
	
	                return val === '' ? 1 : H.pInt(val);
	            };
	        }
	
	        if (!Array.prototype.forEach) {
	            H.each = function(arr, fn, ctx) { // legacy
	                var i = 0,
	                    len = arr.length;
	                for (; i < len; i++) {
	                    if (fn.call(ctx, arr[i], i, arr) === false) {
	                        return i;
	                    }
	                }
	            };
	        }
	
	        if (!Array.prototype.indexOf) {
	            H.inArray = function(item, arr) {
	                var len,
	                    i = 0;
	
	                if (arr) {
	                    len = arr.length;
	
	                    for (; i < len; i++) {
	                        if (arr[i] === item) {
	                            return i;
	                        }
	                    }
	                }
	
	                return -1;
	            };
	        }
	
	        if (!Array.prototype.filter) {
	            H.grep = function(elements, fn) {
	                var ret = [],
	                    i = 0,
	                    length = elements.length;
	
	                for (; i < length; i++) {
	                    if (fn(elements[i], i)) {
	                        ret.push(elements[i]);
	                    }
	                }
	
	                return ret;
	            };
	        }
	
	        if (!Array.prototype.find) {
	            H.find = function(arr, fn) {
	                var i,
	                    length = arr.length;
	
	                for (i = 0; i < length; i++) {
	                    if (fn(arr[i], i)) {
	                        return arr[i];
	                    }
	                }
	            };
	        }
	
	        //--- End compatibility section ---
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var each = H.each,
	            isNumber = H.isNumber,
	            map = H.map,
	            merge = H.merge,
	            pInt = H.pInt;
	
	        /**
	         * @typedef {string} ColorString
	         * A valid color to be parsed and handled by Highcharts. Highcharts internally 
	         * supports hex colors like `#ffffff`, rgb colors like `rgb(255,255,255)` and
	         * rgba colors like `rgba(255,255,255,1)`. Other colors may be supported by the
	         * browsers and displayed correctly, but Highcharts is not able to process them
	         * and apply concepts like opacity and brightening.
	         */
	        /**
	         * Handle color operations. The object methods are chainable.
	         * @param {String} input The input color in either rbga or hex format
	         */
	        H.Color = function(input) {
	            // Backwards compatibility, allow instanciation without new
	            if (!(this instanceof H.Color)) {
	                return new H.Color(input);
	            }
	            // Initialize
	            this.init(input);
	        };
	        H.Color.prototype = {
	
	            // Collection of parsers. This can be extended from the outside by pushing parsers
	            // to Highcharts.Color.prototype.parsers.
	            parsers: [{
	                // RGBA color
	                regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
	                parse: function(result) {
	                    return [pInt(result[1]), pInt(result[2]), pInt(result[3]), parseFloat(result[4], 10)];
	                }
	            }, {
	                // RGB color
	                regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
	                parse: function(result) {
	                    return [pInt(result[1]), pInt(result[2]), pInt(result[3]), 1];
	                }
	            }],
	
	            // Collection of named colors. Can be extended from the outside by adding
	            // colors to Highcharts.Color.prototype.names.
	            names: {
	                none: 'rgba(255,255,255,0)',
	                white: '#ffffff',
	                black: '#000000'
	            },
	
	            /**
	             * Parse the input color to rgba array
	             * @param {String} input
	             */
	            init: function(input) {
	                var result,
	                    rgba,
	                    i,
	                    parser,
	                    len;
	
	                this.input = input = this.names[
	                    input && input.toLowerCase ?
	                    input.toLowerCase() :
	                    ''
	                ] || input;
	
	                // Gradients
	                if (input && input.stops) {
	                    this.stops = map(input.stops, function(stop) {
	                        return new H.Color(stop[1]);
	                    });
	
	                    // Solid colors
	                } else {
	
	                    // Check if it's possible to do bitmasking instead of regex
	                    if (input && input[0] === '#') {
	
	                        len = input.length;
	                        input = parseInt(input.substr(1), 16);
	
	                        // Handle long-form, e.g. #AABBCC
	                        if (len === 7) {
	
	                            rgba = [
	                                (input & 0xFF0000) >> 16,
	                                (input & 0xFF00) >> 8,
	                                (input & 0xFF),
	                                1
	                            ];
	
	                            // Handle short-form, e.g. #ABC
	                            // In short form, the value is assumed to be the same 
	                            // for both nibbles for each component. e.g. #ABC = #AABBCC
	                        } else if (len === 4) {
	
	                            rgba = [
	                                ((input & 0xF00) >> 4) | (input & 0xF00) >> 8,
	                                ((input & 0xF0) >> 4) | (input & 0xF0),
	                                ((input & 0xF) << 4) | (input & 0xF),
	                                1
	                            ];
	                        }
	                    }
	
	                    // Otherwise, check regex parsers
	                    if (!rgba) {
	                        i = this.parsers.length;
	                        while (i-- && !rgba) {
	                            parser = this.parsers[i];
	                            result = parser.regex.exec(input);
	                            if (result) {
	                                rgba = parser.parse(result);
	                            }
	                        }
	                    }
	                }
	                this.rgba = rgba || [];
	            },
	
	            /**
	             * Return the color a specified format
	             * @param {String} format
	             */
	            get: function(format) {
	                var input = this.input,
	                    rgba = this.rgba,
	                    ret;
	
	                if (this.stops) {
	                    ret = merge(input);
	                    ret.stops = [].concat(ret.stops);
	                    each(this.stops, function(stop, i) {
	                        ret.stops[i] = [ret.stops[i][0], stop.get(format)];
	                    });
	
	                    // it's NaN if gradient colors on a column chart
	                } else if (rgba && isNumber(rgba[0])) {
	                    if (format === 'rgb' || (!format && rgba[3] === 1)) {
	                        ret = 'rgb(' + rgba[0] + ',' + rgba[1] + ',' + rgba[2] + ')';
	                    } else if (format === 'a') {
	                        ret = rgba[3];
	                    } else {
	                        ret = 'rgba(' + rgba.join(',') + ')';
	                    }
	                } else {
	                    ret = input;
	                }
	                return ret;
	            },
	
	            /**
	             * Brighten the color
	             * @param {Number} alpha
	             */
	            brighten: function(alpha) {
	                var i,
	                    rgba = this.rgba;
	
	                if (this.stops) {
	                    each(this.stops, function(stop) {
	                        stop.brighten(alpha);
	                    });
	
	                } else if (isNumber(alpha) && alpha !== 0) {
	                    for (i = 0; i < 3; i++) {
	                        rgba[i] += pInt(alpha * 255);
	
	                        if (rgba[i] < 0) {
	                            rgba[i] = 0;
	                        }
	                        if (rgba[i] > 255) {
	                            rgba[i] = 255;
	                        }
	                    }
	                }
	                return this;
	            },
	
	            /**
	             * Set the color's opacity to a given alpha value
	             * @param {Number} alpha
	             */
	            setOpacity: function(alpha) {
	                this.rgba[3] = alpha;
	                return this;
	            },
	
	            /*
	             * Return an intermediate color between two colors.
	             *
	             * @param  {Highcharts.Color} to
	             *         The color object to tween to.
	             * @param  {Number} pos
	             *         The intermediate position, where 0 is the from color (current
	             *         color item), and 1 is the `to` color.
	             *
	             * @return {String}
	             *         The intermediate color in rgba notation.
	             */
	            tweenTo: function(to, pos) {
	                // Check for has alpha, because rgba colors perform worse due to lack of
	                // support in WebKit.
	                var from = this,
	                    hasAlpha,
	                    ret;
	
	                // Unsupported color, return to-color (#3920)
	                if (!to.rgba.length) {
	                    ret = to.input || 'none';
	
	                    // Interpolate
	                } else {
	                    from = from.rgba;
	                    to = to.rgba;
	                    hasAlpha = (to[3] !== 1 || from[3] !== 1);
	                    ret = (hasAlpha ? 'rgba(' : 'rgb(') +
	                        Math.round(to[0] + (from[0] - to[0]) * (1 - pos)) + ',' +
	                        Math.round(to[1] + (from[1] - to[1]) * (1 - pos)) + ',' +
	                        Math.round(to[2] + (from[2] - to[2]) * (1 - pos)) +
	                        (hasAlpha ?
	                            (',' + (to[3] + (from[3] - to[3]) * (1 - pos))) :
	                            '') + ')';
	                }
	                return ret;
	            }
	        };
	        H.color = function(input) {
	            return new H.Color(input);
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var SVGElement,
	            SVGRenderer,
	
	            addEvent = H.addEvent,
	            animate = H.animate,
	            attr = H.attr,
	            charts = H.charts,
	            color = H.color,
	            css = H.css,
	            createElement = H.createElement,
	            defined = H.defined,
	            deg2rad = H.deg2rad,
	            destroyObjectProperties = H.destroyObjectProperties,
	            doc = H.doc,
	            each = H.each,
	            extend = H.extend,
	            erase = H.erase,
	            grep = H.grep,
	            hasTouch = H.hasTouch,
	            inArray = H.inArray,
	            isArray = H.isArray,
	            isFirefox = H.isFirefox,
	            isMS = H.isMS,
	            isObject = H.isObject,
	            isString = H.isString,
	            isWebKit = H.isWebKit,
	            merge = H.merge,
	            noop = H.noop,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            pInt = H.pInt,
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            stop = H.stop,
	            svg = H.svg,
	            SVG_NS = H.SVG_NS,
	            symbolSizes = H.symbolSizes,
	            win = H.win;
	
	        /**
	         * @typedef {Object} SVGDOMElement - An SVG DOM element.
	         */
	        /**
	         * The SVGElement prototype is a JavaScript wrapper for SVG elements used in the
	         * rendering layer of Highcharts. Combined with the {@link
	         * Highcharts.SVGRenderer} object, these prototypes allow freeform annotation
	         * in the charts or even in HTML pages without instanciating a chart. The
	         * SVGElement can also wrap HTML labels, when `text` or `label` elements are
	         * created with the `useHTML` parameter.
	         *
	         * The SVGElement instances are created through factory functions on the 
	         * {@link Highcharts.SVGRenderer} object, like
	         * [rect]{@link Highcharts.SVGRenderer#rect}, [path]{@link
	         * Highcharts.SVGRenderer#path}, [text]{@link Highcharts.SVGRenderer#text},
	         * [label]{@link Highcharts.SVGRenderer#label}, [g]{@link
	         * Highcharts.SVGRenderer#g} and more.
	         *
	         * @class Highcharts.SVGElement
	         */
	        SVGElement = H.SVGElement = function() {
	            return this;
	        };
	        extend(SVGElement.prototype, /** @lends Highcharts.SVGElement.prototype */ {
	
	            // Default base for animation
	            opacity: 1,
	            SVG_NS: SVG_NS,
	
	            /**
	             * For labels, these CSS properties are applied to the `text` node directly.
	             * @type {Array.<string>}
	             */
	            textProps: ['direction', 'fontSize', 'fontWeight', 'fontFamily',
	                'fontStyle', 'color', 'lineHeight', 'width', 'textAlign',
	                'textDecoration', 'textOverflow', 'textOutline'
	            ],
	
	            /**
	             * Initialize the SVG renderer. This function only exists to make the
	             * initiation process overridable. It should not be called directly.
	             *
	             * @param  {HighchartsSVGRenderer} renderer
	             *         The SVGRenderer instance to initialize to.
	             * @param  {String} nodeName
	             *         The SVG node name.
	             * @returns {void}
	             */
	            init: function(renderer, nodeName) {
	
	                /** 
	                 * The DOM node. Each SVGRenderer instance wraps a main DOM node, but 
	                 * may also represent more nodes.
	                 * @type {SVGDOMNode|HTMLDOMNode}
	                 */
	                this.element = nodeName === 'span' ?
	                    createElement(nodeName) :
	                    doc.createElementNS(this.SVG_NS, nodeName);
	
	                /**
	                 * The renderer that the SVGElement belongs to.
	                 * @type {Highcharts.SVGRenderer}
	                 */
	                this.renderer = renderer;
	            },
	
	            /**
	             * Animate to given attributes or CSS properties.
	             * 
	             * @param {SVGAttributes} params SVG attributes or CSS to animate.
	             * @param {AnimationOptions} [options] Animation options.
	             * @param {Function} [complete] Function to perform at the end of animation.
	             *
	             * @sample highcharts/members/element-on/
	             *         Setting some attributes by animation
	             * 
	             * @returns {Highcharts.SVGElement} Returns the SVGElement for chaining.
	             */
	            animate: function(params, options, complete) {
	                var animOptions = H.animObject(
	                    pick(options, this.renderer.globalAnimation, true)
	                );
	                if (animOptions.duration !== 0) {
	                    if (complete) { // allows using a callback with the global animation without overwriting it
	                        animOptions.complete = complete;
	                    }
	                    animate(this, params, animOptions);
	                } else {
	                    this.attr(params, null, complete);
	                    if (animOptions.step) {
	                        animOptions.step.call(this);
	                    }
	                }
	                return this;
	            },
	
	            /**
	             * @typedef {Object} GradientOptions
	             * @property {Object} linearGradient Holds an object that defines the start
	             *    position and the end position relative to the shape.
	             * @property {Number} linearGradient.x1 Start horizontal position of the
	             *    gradient. Ranges 0-1.
	             * @property {Number} linearGradient.x2 End horizontal position of the
	             *    gradient. Ranges 0-1.
	             * @property {Number} linearGradient.y1 Start vertical position of the
	             *    gradient. Ranges 0-1.
	             * @property {Number} linearGradient.y2 End vertical position of the
	             *    gradient. Ranges 0-1.
	             * @property {Object} radialGradient Holds an object that defines the center
	             *    position and the radius.
	             * @property {Number} radialGradient.cx Center horizontal position relative
	             *    to the shape. Ranges 0-1.
	             * @property {Number} radialGradient.cy Center vertical position relative
	             *    to the shape. Ranges 0-1.
	             * @property {Number} radialGradient.r Radius relative to the shape. Ranges
	             *    0-1.
	             * @property {Array.<Array>} stops The first item in each tuple is the
	             *    position in the gradient, where 0 is the start of the gradient and 1
	             *    is the end of the gradient. Multiple stops can be applied. The second
	             *    item is the color for each stop. This color can also be given in the
	             *    rgba format.
	             *
	             * @example
	             * // Linear gradient used as a color option
	             * color: {
	             *     linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
	             *         stops: [
	             *             [0, '#003399'], // start
	             *             [0.5, '#ffffff'], // middle
	             *             [1, '#3366AA'] // end
	             *         ]
	             *     }
	             * }
	             */
	            /**
	             * Build and apply an SVG gradient out of a common JavaScript configuration
	             * object. This function is called from the attribute setters.
	             *
	             * @private
	             * @param {GradientOptions} color The gradient options structure.
	             * @param {string} prop The property to apply, can either be `fill` or
	             * `stroke`. 
	             * @param {SVGDOMElement} elem SVG DOM element to apply the gradient on.
	             */
	            colorGradient: function(color, prop, elem) {
	                var renderer = this.renderer,
	                    colorObject,
	                    gradName,
	                    gradAttr,
	                    radAttr,
	                    gradients,
	                    gradientObject,
	                    stops,
	                    stopColor,
	                    stopOpacity,
	                    radialReference,
	                    id,
	                    key = [],
	                    value;
	
	                // Apply linear or radial gradients
	                if (color.radialGradient) {
	                    gradName = 'radialGradient';
	                } else if (color.linearGradient) {
	                    gradName = 'linearGradient';
	                }
	
	                if (gradName) {
	                    gradAttr = color[gradName];
	                    gradients = renderer.gradients;
	                    stops = color.stops;
	                    radialReference = elem.radialReference;
	
	                    // Keep < 2.2 kompatibility
	                    if (isArray(gradAttr)) {
	                        color[gradName] = gradAttr = {
	                            x1: gradAttr[0],
	                            y1: gradAttr[1],
	                            x2: gradAttr[2],
	                            y2: gradAttr[3],
	                            gradientUnits: 'userSpaceOnUse'
	                        };
	                    }
	
	                    // Correct the radial gradient for the radial reference system
	                    if (
	                        gradName === 'radialGradient' &&
	                        radialReference &&
	                        !defined(gradAttr.gradientUnits)
	                    ) {
	                        radAttr = gradAttr; // Save the radial attributes for updating
	                        gradAttr = merge(
	                            gradAttr,
	                            renderer.getRadialAttr(radialReference, radAttr), {
	                                gradientUnits: 'userSpaceOnUse'
	                            }
	                        );
	                    }
	
	                    // Build the unique key to detect whether we need to create a new element (#1282)
	                    objectEach(gradAttr, function(val, n) {
	                        if (n !== 'id') {
	                            key.push(n, val);
	                        }
	                    });
	                    objectEach(stops, function(val) {
	                        key.push(val);
	                    });
	                    key = key.join(',');
	
	                    // Check if a gradient object with the same config object is created within this renderer
	                    if (gradients[key]) {
	                        id = gradients[key].attr('id');
	
	                    } else {
	
	                        // Set the id and create the element
	                        gradAttr.id = id = H.uniqueKey();
	                        gradients[key] = gradientObject = renderer.createElement(gradName)
	                            .attr(gradAttr)
	                            .add(renderer.defs);
	
	                        gradientObject.radAttr = radAttr;
	
	                        // The gradient needs to keep a list of stops to be able to destroy them
	                        gradientObject.stops = [];
	                        each(stops, function(stop) {
	                            var stopObject;
	                            if (stop[1].indexOf('rgba') === 0) {
	                                colorObject = H.color(stop[1]);
	                                stopColor = colorObject.get('rgb');
	                                stopOpacity = colorObject.get('a');
	                            } else {
	                                stopColor = stop[1];
	                                stopOpacity = 1;
	                            }
	                            stopObject = renderer.createElement('stop').attr({
	                                offset: stop[0],
	                                'stop-color': stopColor,
	                                'stop-opacity': stopOpacity
	                            }).add(gradientObject);
	
	                            // Add the stop element to the gradient
	                            gradientObject.stops.push(stopObject);
	                        });
	                    }
	
	                    // Set the reference to the gradient object
	                    value = 'url(' + renderer.url + '#' + id + ')';
	                    elem.setAttribute(prop, value);
	                    elem.gradient = key;
	
	                    // Allow the color to be concatenated into tooltips formatters etc. (#2995)
	                    color.toString = function() {
	                        return value;
	                    };
	                }
	            },
	
	            /**
	             * Apply a text outline through a custom CSS property, by copying the text
	             * element and apply stroke to the copy. Used internally. Contrast checks
	             * at http://jsfiddle.net/highcharts/43soe9m1/2/ .
	             *
	             * @private
	             * @param {String} textOutline A custom CSS `text-outline` setting, defined
	             *    by `width color`. 
	             * @example
	             * // Specific color
	             * text.css({
	             *    textOutline: '1px black'
	             * });
	             * // Automatic contrast
	             * text.css({
	             *    color: '#000000', // black text
	             *    textOutline: '1px contrast' // => white outline
	             * });
	             */
	            applyTextOutline: function(textOutline) {
	                var elem = this.element,
	                    tspans,
	                    tspan,
	                    hasContrast = textOutline.indexOf('contrast') !== -1,
	                    styles = {},
	                    color,
	                    strokeWidth,
	                    firstRealChild,
	                    i;
	
	                // When the text shadow is set to contrast, use dark stroke for light
	                // text and vice versa.
	                if (hasContrast) {
	                    styles.textOutline = textOutline = textOutline.replace(
	                        /contrast/g,
	                        this.renderer.getContrast(elem.style.fill)
	                    );
	                }
	
	                // Extract the stroke width and color
	                textOutline = textOutline.split(' ');
	                color = textOutline[textOutline.length - 1];
	                strokeWidth = textOutline[0];
	
	                if (strokeWidth && strokeWidth !== 'none' && H.svg) {
	
	                    this.fakeTS = true; // Fake text shadow
	
	                    tspans = [].slice.call(elem.getElementsByTagName('tspan'));
	
	                    // In order to get the right y position of the clone,
	                    // copy over the y setter
	                    this.ySetter = this.xSetter;
	
	                    // Since the stroke is applied on center of the actual outline, we
	                    // need to double it to get the correct stroke-width outside the 
	                    // glyphs.
	                    strokeWidth = strokeWidth.replace(
	                        /(^[\d\.]+)(.*?)$/g,
	                        function(match, digit, unit) {
	                            return (2 * digit) + unit;
	                        }
	                    );
	
	                    // Remove shadows from previous runs. Iterate from the end to
	                    // support removing items inside the cycle (#6472).
	                    i = tspans.length;
	                    while (i--) {
	                        tspan = tspans[i];
	                        if (tspan.getAttribute('class') === 'highcharts-text-outline') {
	                            // Remove then erase
	                            erase(tspans, elem.removeChild(tspan));
	                        }
	                    }
	
	                    // For each of the tspans, create a stroked copy behind it.
	                    firstRealChild = elem.firstChild;
	                    each(tspans, function(tspan, y) {
	                        var clone;
	
	                        // Let the first line start at the correct X position
	                        if (y === 0) {
	                            tspan.setAttribute('x', elem.getAttribute('x'));
	                            y = elem.getAttribute('y');
	                            tspan.setAttribute('y', y || 0);
	                            if (y === null) {
	                                elem.setAttribute('y', 0);
	                            }
	                        }
	
	                        // Create the clone and apply outline properties
	                        clone = tspan.cloneNode(1);
	                        attr(clone, {
	                            'class': 'highcharts-text-outline',
	                            'fill': color,
	                            'stroke': color,
	                            'stroke-width': strokeWidth,
	                            'stroke-linejoin': 'round'
	                        });
	                        elem.insertBefore(clone, firstRealChild);
	                    });
	                }
	            },
	
	            /**
	             *
	             * @typedef {Object} SVGAttributes An object of key-value pairs for SVG
	             *   attributes. Attributes in Highcharts elements for the most parts
	             *   correspond to SVG, but some are specific to Highcharts, like `zIndex`,
	             *   `rotation`, `translateX`, `translateY`, `scaleX` and `scaleY`. SVG
	             *   attributes containing a hyphen are _not_ camel-cased, they should be
	             *   quoted to preserve the hyphen.
	             * @example
	             * {
	             *     'stroke': '#ff0000', // basic
	             *     'stroke-width': 2, // hyphenated
	             *     'rotation': 45 // custom
	             *     'd': ['M', 10, 10, 'L', 30, 30, 'z'] // path definition, note format
	             * }
	             */
	            /**
	             * Apply native and custom attributes to the SVG elements.
	             * 
	             * In order to set the rotation center for rotation, set x and y to 0 and
	             * use `translateX` and `translateY` attributes to position the element
	             * instead.
	             *
	             * Attributes frequently used in Highcharts are `fill`, `stroke`,
	             * `stroke-width`.
	             *
	             * @param {SVGAttributes|String} hash - The native and custom SVG
	             *    attributes. 
	             * @param {string} [val] - If the type of the first argument is `string`, 
	             *    the second can be a value, which will serve as a single attribute
	             *    setter. If the first argument is a string and the second is undefined,
	             *    the function serves as a getter and the current value of the property
	             *    is returned.
	             * @param {Function} [complete] - A callback function to execute after setting
	             *    the attributes. This makes the function compliant and interchangeable
	             *    with the {@link SVGElement#animate} function.
	             * @param {boolean} [continueAnimation=true] Used internally when `.attr` is
	             *    called as part of an animation step. Otherwise, calling `.attr` for an
	             *    attribute will stop animation for that attribute.
	             *    
	             * @returns {SVGElement|string|number} If used as a setter, it returns the 
	             *    current {@link SVGElement} so the calls can be chained. If used as a 
	             *    getter, the current value of the attribute is returned.
	             *
	             * @sample highcharts/members/renderer-rect/
	             *         Setting some attributes
	             * 
	             * @example
	             * // Set multiple attributes
	             * element.attr({
	             *     stroke: 'red',
	             *     fill: 'blue',
	             *     x: 10,
	             *     y: 10
	             * });
	             *
	             * // Set a single attribute
	             * element.attr('stroke', 'red');
	             *
	             * // Get an attribute
	             * element.attr('stroke'); // => 'red'
	             * 
	             */
	            attr: function(hash, val, complete, continueAnimation) {
	                var key,
	                    element = this.element,
	                    hasSetSymbolSize,
	                    ret = this,
	                    skipAttr,
	                    setter;
	
	                // single key-value pair
	                if (typeof hash === 'string' && val !== undefined) {
	                    key = hash;
	                    hash = {};
	                    hash[key] = val;
	                }
	
	                // used as a getter: first argument is a string, second is undefined
	                if (typeof hash === 'string') {
	                    ret = (this[hash + 'Getter'] || this._defaultGetter).call(this, hash, element);
	
	                    // setter
	                } else {
	
	                    objectEach(hash, function(val, key) {
	                        skipAttr = false;
	
	                        // Unless .attr is from the animator update, stop current
	                        // running animation of this property
	                        if (!continueAnimation) {
	                            stop(this, key);
	                        }
	
	                        // Special handling of symbol attributes
	                        if (
	                            this.symbolName &&
	                            /^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/
	                            .test(key)
	                        ) {
	                            if (!hasSetSymbolSize) {
	                                this.symbolAttr(hash);
	                                hasSetSymbolSize = true;
	                            }
	                            skipAttr = true;
	                        }
	
	                        if (this.rotation && (key === 'x' || key === 'y')) {
	                            this.doTransform = true;
	                        }
	
	                        if (!skipAttr) {
	                            setter = this[key + 'Setter'] || this._defaultSetter;
	                            setter.call(this, val, key, element);
	
	
	                            // Let the shadow follow the main element
	                            if (this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(key)) {
	                                this.updateShadows(key, val, setter);
	                            }
	
	                        }
	                    }, this);
	
	                    this.afterSetters();
	                }
	
	                // In accordance with animate, run a complete callback
	                if (complete) {
	                    complete();
	                }
	
	                return ret;
	            },
	
	            /**
	             * This method is executed in the end of {attr}, after setting all attributes in the hash.
	             * In can be used to efficiently consolidate multiple attributes in one SVG property -- e.g.,
	             * translate, rotate and scale are merged in one "transform" attribute in the SVG node.
	             */
	            afterSetters: function() {
	                // Update transform. Do this outside the loop to prevent redundant updating for batch setting
	                // of attributes.
	                if (this.doTransform) {
	                    this.updateTransform();
	                    this.doTransform = false;
	                }
	            },
	
	
	            /**
	             * Update the shadow elements with new attributes.
	             *
	             * @private
	             * @param {String} key - The attribute name.
	             * @param {String|Number} value - The value of the attribute.
	             * @param {Function} setter - The setter function, inherited from the
	             *   parent wrapper
	             * @returns {void}
	             */
	            updateShadows: function(key, value, setter) {
	                var shadows = this.shadows,
	                    i = shadows.length;
	
	                while (i--) {
	                    setter.call(
	                        shadows[i],
	                        key === 'height' ?
	                        Math.max(value - (shadows[i].cutHeight || 0), 0) :
	                        key === 'd' ? this.d : value,
	                        key,
	                        shadows[i]
	                    );
	                }
	            },
	
	
	            /**
	             * Add a class name to an element.
	             *
	             * @param {string} className - The new class name to add.
	             * @param {boolean} [replace=false] - When true, the existing class name(s)
	             *    will be overwritten with the new one. When false, the new one is
	             *    added.
	             * @returns {Highcharts.SVGElement} Return the SVG element for chainability.
	             */
	            addClass: function(className, replace) {
	                var currentClassName = this.attr('class') || '';
	
	                if (currentClassName.indexOf(className) === -1) {
	                    if (!replace) {
	                        className =
	                            (currentClassName + (currentClassName ? ' ' : '') +
	                                className).replace('  ', ' ');
	                    }
	                    this.attr('class', className);
	                }
	                return this;
	            },
	
	            /**
	             * Check if an element has the given class name.
	             * @param  {string}  className - The class name to check for.
	             * @return {Boolean}
	             */
	            hasClass: function(className) {
	                return attr(this.element, 'class').indexOf(className) !== -1;
	            },
	
	            /**
	             * Remove a class name from the element.
	             * @param  {string} className The class name to remove.
	             * @return {Highcharts.SVGElement} Returns the SVG element for chainability.
	             */
	            removeClass: function(className) {
	                attr(this.element, 'class', (attr(this.element, 'class') || '').replace(className, ''));
	                return this;
	            },
	
	            /**
	             * If one of the symbol size affecting parameters are changed,
	             * check all the others only once for each call to an element's
	             * .attr() method
	             * @param {Object} hash - The attributes to set.
	             * @private
	             */
	            symbolAttr: function(hash) {
	                var wrapper = this;
	
	                each(['x', 'y', 'r', 'start', 'end', 'width', 'height', 'innerR', 'anchorX', 'anchorY'], function(key) {
	                    wrapper[key] = pick(hash[key], wrapper[key]);
	                });
	
	                wrapper.attr({
	                    d: wrapper.renderer.symbols[wrapper.symbolName](
	                        wrapper.x,
	                        wrapper.y,
	                        wrapper.width,
	                        wrapper.height,
	                        wrapper
	                    )
	                });
	            },
	
	            /**
	             * Apply a clipping rectangle to this element.
	             * 
	             * @param {ClipRect} [clipRect] - The clipping rectangle. If skipped, the
	             *    current clip is removed.
	             * @returns {Highcharts.SVGElement} Returns the SVG element to allow chaining.
	             */
	            clip: function(clipRect) {
	                return this.attr(
	                    'clip-path',
	                    clipRect ?
	                    'url(' + this.renderer.url + '#' + clipRect.id + ')' :
	                    'none'
	                );
	            },
	
	            /**
	             * Calculate the coordinates needed for drawing a rectangle crisply and
	             * return the calculated attributes.
	             * 
	             * @param {Object} rect - A rectangle.
	             * @param {number} rect.x - The x position.
	             * @param {number} rect.y - The y position.
	             * @param {number} rect.width - The width.
	             * @param {number} rect.height - The height.
	             * @param {number} [strokeWidth] - The stroke width to consider when
	             *    computing crisp positioning. It can also be set directly on the rect
	             *    parameter.
	             *
	             * @returns {{x: Number, y: Number, width: Number, height: Number}} The
	             *    modified rectangle arguments.
	             */
	            crisp: function(rect, strokeWidth) {
	
	                var wrapper = this,
	                    attribs = {},
	                    normalizer;
	
	                strokeWidth = strokeWidth || rect.strokeWidth || 0;
	                normalizer = Math.round(strokeWidth) % 2 / 2; // Math.round because strokeWidth can sometimes have roundoff errors
	
	                // normalize for crisp edges
	                rect.x = Math.floor(rect.x || wrapper.x || 0) + normalizer;
	                rect.y = Math.floor(rect.y || wrapper.y || 0) + normalizer;
	                rect.width = Math.floor((rect.width || wrapper.width || 0) - 2 * normalizer);
	                rect.height = Math.floor((rect.height || wrapper.height || 0) - 2 * normalizer);
	                if (defined(rect.strokeWidth)) {
	                    rect.strokeWidth = strokeWidth;
	                }
	
	                objectEach(rect, function(val, key) {
	                    if (wrapper[key] !== val) { // only set attribute if changed
	                        wrapper[key] = attribs[key] = val;
	                    }
	                });
	
	                return attribs;
	            },
	
	            /**
	             * Set styles for the element. In addition to CSS styles supported by 
	             * native SVG and HTML elements, there are also some custom made for 
	             * Highcharts, like `width`, `ellipsis` and `textOverflow` for SVG text
	             * elements.
	             * @param {CSSObject} styles The new CSS styles.
	             * @returns {Highcharts.SVGElement} Return the SVG element for chaining.
	             *
	             * @sample highcharts/members/renderer-text-on-chart/
	             *         Styled text
	             */
	            css: function(styles) {
	                var oldStyles = this.styles,
	                    newStyles = {},
	                    elem = this.element,
	                    textWidth,
	                    serializedCss = '',
	                    hyphenate,
	                    hasNew = !oldStyles,
	                    // These CSS properties are interpreted internally by the SVG
	                    // renderer, but are not supported by SVG and should not be added to
	                    // the DOM. In styled mode, no CSS should find its way to the DOM
	                    // whatsoever (#6173, #6474).
	                    svgPseudoProps = ['textOutline', 'textOverflow', 'width'];
	
	                // convert legacy
	                if (styles && styles.color) {
	                    styles.fill = styles.color;
	                }
	
	                // Filter out existing styles to increase performance (#2640)
	                if (oldStyles) {
	                    objectEach(styles, function(style, n) {
	                        if (style !== oldStyles[n]) {
	                            newStyles[n] = style;
	                            hasNew = true;
	                        }
	                    });
	                }
	                if (hasNew) {
	
	                    // Merge the new styles with the old ones
	                    if (oldStyles) {
	                        styles = extend(
	                            oldStyles,
	                            newStyles
	                        );
	                    }
	
	                    // Get the text width from style
	                    textWidth = this.textWidth = (
	                        styles &&
	                        styles.width &&
	                        styles.width !== 'auto' &&
	                        elem.nodeName.toLowerCase() === 'text' &&
	                        pInt(styles.width)
	                    );
	
	                    // store object
	                    this.styles = styles;
	
	                    if (textWidth && (!svg && this.renderer.forExport)) {
	                        delete styles.width;
	                    }
	
	                    // serialize and set style attribute
	                    if (isMS && !svg) {
	                        css(this.element, styles);
	                    } else {
	                        hyphenate = function(a, b) {
	                            return '-' + b.toLowerCase();
	                        };
	                        objectEach(styles, function(style, n) {
	                            if (inArray(n, svgPseudoProps) === -1) {
	                                serializedCss +=
	                                    n.replace(/([A-Z])/g, hyphenate) + ':' +
	                                    style + ';';
	                            }
	                        });
	                        if (serializedCss) {
	                            attr(elem, 'style', serializedCss); // #1881
	                        }
	                    }
	
	
	                    if (this.added) {
	
	                        // Rebuild text after added. Cache mechanisms in the buildText
	                        // will prevent building if there are no significant changes.
	                        if (this.element.nodeName === 'text') {
	                            this.renderer.buildText(this);
	                        }
	
	                        // Apply text outline after added
	                        if (styles && styles.textOutline) {
	                            this.applyTextOutline(styles.textOutline);
	                        }
	                    }
	                }
	
	                return this;
	            },
	
	
	            /**
	             * Get the current stroke width. In classic mode, the setter registers it 
	             * directly on the element.
	             * @returns {number} The stroke width in pixels.
	             * @ignore
	             */
	            strokeWidth: function() {
	                return this['stroke-width'] || 0;
	            },
	
	
	            /**
	             * Add an event listener. This is a simple setter that replaces all other
	             * events of the same type, opposed to the {@link Highcharts#addEvent}
	             * function.
	             * @param {string} eventType - The event type. If the type is `click`, 
	             *    Highcharts will internally translate it to a `touchstart` event on 
	             *    touch devices, to prevent the browser from waiting for a click event
	             *    from firing.
	             * @param {Function} handler - The handler callback.
	             * @returns {Highcharts.SVGElement} The SVGElement for chaining.
	             *
	             * @sample highcharts/members/element-on/
	             *         A clickable rectangle
	             */
	            on: function(eventType, handler) {
	                var svgElement = this,
	                    element = svgElement.element;
	
	                // touch
	                if (hasTouch && eventType === 'click') {
	                    element.ontouchstart = function(e) {
	                        svgElement.touchEventFired = Date.now(); // #2269
	                        e.preventDefault();
	                        handler.call(element, e);
	                    };
	                    element.onclick = function(e) {
	                        if (win.navigator.userAgent.indexOf('Android') === -1 ||
	                            Date.now() - (svgElement.touchEventFired || 0) > 1100) {
	                            handler.call(element, e);
	                        }
	                    };
	                } else {
	                    // simplest possible event model for internal use
	                    element['on' + eventType] = handler;
	                }
	                return this;
	            },
	
	            /**
	             * Set the coordinates needed to draw a consistent radial gradient across
	             * a shape regardless of positioning inside the chart. Used on pie slices
	             * to make all the slices have the same radial reference point.
	             *
	             * @param {Array} coordinates The center reference. The format is
	             *    `[centerX, centerY, diameter]` in pixels.
	             * @returns {Highcharts.SVGElement} Returns the SVGElement for chaining.
	             */
	            setRadialReference: function(coordinates) {
	                var existingGradient = this.renderer.gradients[this.element.gradient];
	
	                this.element.radialReference = coordinates;
	
	                // On redrawing objects with an existing gradient, the gradient needs
	                // to be repositioned (#3801)
	                if (existingGradient && existingGradient.radAttr) {
	                    existingGradient.animate(
	                        this.renderer.getRadialAttr(
	                            coordinates,
	                            existingGradient.radAttr
	                        )
	                    );
	                }
	
	                return this;
	            },
	
	            /**
	             * Move an object and its children by x and y values.
	             * 
	             * @param {number} x - The x value.
	             * @param {number} y - The y value.
	             */
	            translate: function(x, y) {
	                return this.attr({
	                    translateX: x,
	                    translateY: y
	                });
	            },
	
	            /**
	             * Invert a group, rotate and flip. This is used internally on inverted 
	             * charts, where the points and graphs are drawn as if not inverted, then
	             * the series group elements are inverted.
	             *
	             * @param {boolean} inverted - Whether to invert or not. An inverted shape
	             *    can be un-inverted by setting it to false.
	             * @returns {Highcharts.SVGElement} Return the SVGElement for chaining.
	             */
	            invert: function(inverted) {
	                var wrapper = this;
	                wrapper.inverted = inverted;
	                wrapper.updateTransform();
	                return wrapper;
	            },
	
	            /**
	             * Update the transform attribute based on internal properties. Deals with
	             * the custom `translateX`, `translateY`, `rotation`, `scaleX` and `scaleY`
	             * attributes and updates the SVG `transform` attribute.
	             * @private
	             * @returns {void}
	             */
	            updateTransform: function() {
	                var wrapper = this,
	                    translateX = wrapper.translateX || 0,
	                    translateY = wrapper.translateY || 0,
	                    scaleX = wrapper.scaleX,
	                    scaleY = wrapper.scaleY,
	                    inverted = wrapper.inverted,
	                    rotation = wrapper.rotation,
	                    element = wrapper.element,
	                    transform;
	
	                // flipping affects translate as adjustment for flipping around the group's axis
	                if (inverted) {
	                    translateX += wrapper.width;
	                    translateY += wrapper.height;
	                }
	
	                // Apply translate. Nearly all transformed elements have translation, so instead
	                // of checking for translate = 0, do it always (#1767, #1846).
	                transform = ['translate(' + translateX + ',' + translateY + ')'];
	
	                // apply rotation
	                if (inverted) {
	                    transform.push('rotate(90) scale(-1,1)');
	                } else if (rotation) { // text rotation
	                    transform.push('rotate(' + rotation + ' ' + (element.getAttribute('x') || 0) + ' ' + (element.getAttribute('y') || 0) + ')');
	
	                    // Delete bBox memo when the rotation changes
	                    //delete wrapper.bBox;
	                }
	
	                // apply scale
	                if (defined(scaleX) || defined(scaleY)) {
	                    transform.push('scale(' + pick(scaleX, 1) + ' ' + pick(scaleY, 1) + ')');
	                }
	
	                if (transform.length) {
	                    element.setAttribute('transform', transform.join(' '));
	                }
	            },
	
	            /**
	             * Bring the element to the front. Alternatively, a new zIndex can be set.
	             *
	             * @returns {Highcharts.SVGElement} Returns the SVGElement for chaining.
	             *
	             * @sample highcharts/members/element-tofront/
	             *         Click an element to bring it to front
	             */
	            toFront: function() {
	                var element = this.element;
	                element.parentNode.appendChild(element);
	                return this;
	            },
	
	
	            /**
	             * Align the element relative to the chart or another box.
	             * 
	             * @param {Object} [alignOptions] The alignment options. The function can be
	             *   called without this parameter in order to re-align an element after the
	             *   box has been updated.
	             * @param {string} [alignOptions.align=left] Horizontal alignment. Can be
	             *   one of `left`, `center` and `right`.
	             * @param {string} [alignOptions.verticalAlign=top] Vertical alignment. Can
	             *   be one of `top`, `middle` and `bottom`.
	             * @param {number} [alignOptions.x=0] Horizontal pixel offset from
	             *   alignment.
	             * @param {number} [alignOptions.y=0] Vertical pixel offset from alignment.
	             * @param {Boolean} [alignByTranslate=false] Use the `transform` attribute
	             *   with translateX and translateY custom attributes to align this elements
	             *   rather than `x` and `y` attributes.
	             * @param {String|Object} box The box to align to, needs a width and height.
	             *   When the box is a string, it refers to an object in the Renderer. For
	             *   example, when box is `spacingBox`, it refers to `Renderer.spacingBox`
	             *   which holds `width`, `height`, `x` and `y` properties.
	             * @returns {Highcharts.SVGElement} Returns the SVGElement for chaining.
	             */
	            align: function(alignOptions, alignByTranslate, box) {
	                var align,
	                    vAlign,
	                    x,
	                    y,
	                    attribs = {},
	                    alignTo,
	                    renderer = this.renderer,
	                    alignedObjects = renderer.alignedObjects,
	                    alignFactor,
	                    vAlignFactor;
	
	                // First call on instanciate
	                if (alignOptions) {
	                    this.alignOptions = alignOptions;
	                    this.alignByTranslate = alignByTranslate;
	                    if (!box || isString(box)) { // boxes other than renderer handle this internally
	                        this.alignTo = alignTo = box || 'renderer';
	                        erase(alignedObjects, this); // prevent duplicates, like legendGroup after resize
	                        alignedObjects.push(this);
	                        box = null; // reassign it below
	                    }
	
	                    // When called on resize, no arguments are supplied
	                } else {
	                    alignOptions = this.alignOptions;
	                    alignByTranslate = this.alignByTranslate;
	                    alignTo = this.alignTo;
	                }
	
	                box = pick(box, renderer[alignTo], renderer);
	
	                // Assign variables
	                align = alignOptions.align;
	                vAlign = alignOptions.verticalAlign;
	                x = (box.x || 0) + (alignOptions.x || 0); // default: left align
	                y = (box.y || 0) + (alignOptions.y || 0); // default: top align
	
	                // Align
	                if (align === 'right') {
	                    alignFactor = 1;
	                } else if (align === 'center') {
	                    alignFactor = 2;
	                }
	                if (alignFactor) {
	                    x += (box.width - (alignOptions.width || 0)) / alignFactor;
	                }
	                attribs[alignByTranslate ? 'translateX' : 'x'] = Math.round(x);
	
	
	                // Vertical align
	                if (vAlign === 'bottom') {
	                    vAlignFactor = 1;
	                } else if (vAlign === 'middle') {
	                    vAlignFactor = 2;
	                }
	                if (vAlignFactor) {
	                    y += (box.height - (alignOptions.height || 0)) / vAlignFactor;
	                }
	                attribs[alignByTranslate ? 'translateY' : 'y'] = Math.round(y);
	
	                // Animate only if already placed
	                this[this.placed ? 'animate' : 'attr'](attribs);
	                this.placed = true;
	                this.alignAttr = attribs;
	
	                return this;
	            },
	
	            /**
	             * Get the bounding box (width, height, x and y) for the element. Generally
	             * used to get rendered text size. Since this is called a lot in charts,
	             * the results are cached based on text properties, in order to save DOM
	             * traffic. The returned bounding box includes the rotation, so for example
	             * a single text line of rotation 90 will report a greater height, and a
	             * width corresponding to the line-height.
	             *
	             * @param {boolean} [reload] Skip the cache and get the updated DOM bouding
	             *   box.
	             * @param {number} [rot] Override the element's rotation. This is internally
	             *   used on axis labels with a value of 0 to find out what the bounding box
	             *   would be have been if it were not rotated.
	             * @returns {Object} The bounding box with `x`, `y`, `width` and `height`
	             * properties.
	             *
	             * @sample highcharts/members/renderer-on-chart/
	             *         Draw a rectangle based on a text's bounding box
	             */
	            getBBox: function(reload, rot) {
	                var wrapper = this,
	                    bBox, // = wrapper.bBox,
	                    renderer = wrapper.renderer,
	                    width,
	                    height,
	                    rotation,
	                    rad,
	                    element = wrapper.element,
	                    styles = wrapper.styles,
	                    fontSize,
	                    textStr = wrapper.textStr,
	                    toggleTextShadowShim,
	                    cache = renderer.cache,
	                    cacheKeys = renderer.cacheKeys,
	                    cacheKey;
	
	                rotation = pick(rot, wrapper.rotation);
	                rad = rotation * deg2rad;
	
	
	                fontSize = styles && styles.fontSize;
	
	
	                if (textStr !== undefined) {
	
	                    cacheKey = textStr.toString();
	
	                    // Since numbers are monospaced, and numerical labels appear a lot
	                    // in a chart, we assume that a label of n characters has the same
	                    // bounding box as others of the same length. Unless there is inner
	                    // HTML in the label. In that case, leave the numbers as is (#5899).
	                    if (cacheKey.indexOf('<') === -1) {
	                        cacheKey = cacheKey.replace(/[0-9]/g, '0');
	                    }
	
	                    // Properties that affect bounding box
	                    cacheKey += [
	                            '',
	                            rotation || 0,
	                            fontSize,
	                            styles && styles.width,
	                            styles && styles.textOverflow // #5968
	                        ]
	                        .join(',');
	
	                }
	
	                if (cacheKey && !reload) {
	                    bBox = cache[cacheKey];
	                }
	
	                // No cache found
	                if (!bBox) {
	
	                    // SVG elements
	                    if (element.namespaceURI === wrapper.SVG_NS || renderer.forExport) {
	                        try { // Fails in Firefox if the container has display: none.
	
	                            // When the text shadow shim is used, we need to hide the fake shadows
	                            // to get the correct bounding box (#3872)
	                            toggleTextShadowShim = this.fakeTS && function(display) {
	                                each(element.querySelectorAll('.highcharts-text-outline'), function(tspan) {
	                                    tspan.style.display = display;
	                                });
	                            };
	
	                            // Workaround for #3842, Firefox reporting wrong bounding box for shadows
	                            if (toggleTextShadowShim) {
	                                toggleTextShadowShim('none');
	                            }
	
	                            bBox = element.getBBox ?
	                                // SVG: use extend because IE9 is not allowed to change width and height in case
	                                // of rotation (below)
	                                extend({}, element.getBBox()) : {
	
	                                    // Legacy IE in export mode
	                                    width: element.offsetWidth,
	                                    height: element.offsetHeight
	                                };
	
	                            // #3842
	                            if (toggleTextShadowShim) {
	                                toggleTextShadowShim('');
	                            }
	                        } catch (e) {}
	
	                        // If the bBox is not set, the try-catch block above failed. The other condition
	                        // is for Opera that returns a width of -Infinity on hidden elements.
	                        if (!bBox || bBox.width < 0) {
	                            bBox = {
	                                width: 0,
	                                height: 0
	                            };
	                        }
	
	
	                        // VML Renderer or useHTML within SVG
	                    } else {
	
	                        bBox = wrapper.htmlGetBBox();
	
	                    }
	
	                    // True SVG elements as well as HTML elements in modern browsers using the .useHTML option
	                    // need to compensated for rotation
	                    if (renderer.isSVG) {
	                        width = bBox.width;
	                        height = bBox.height;
	
	                        // Workaround for wrong bounding box in IE, Edge and Chrome on
	                        // Windows. With Highcharts' default font, IE and Edge report
	                        // a box height of 16.899 and Chrome rounds it to 17. If this 
	                        // stands uncorrected, it results in more padding added below
	                        // the text than above when adding a label border or background.
	                        // Also vertical positioning is affected.
	                        // http://jsfiddle.net/highcharts/em37nvuj/
	                        // (#1101, #1505, #1669, #2568, #6213).
	                        if (
	                            styles &&
	                            styles.fontSize === '11px' &&
	                            Math.round(height) === 17
	                        ) {
	                            bBox.height = height = 14;
	                        }
	
	                        // Adjust for rotated text
	                        if (rotation) {
	                            bBox.width = Math.abs(height * Math.sin(rad)) + Math.abs(width * Math.cos(rad));
	                            bBox.height = Math.abs(height * Math.cos(rad)) + Math.abs(width * Math.sin(rad));
	                        }
	                    }
	
	                    // Cache it. When loading a chart in a hidden iframe in Firefox and IE/Edge, the
	                    // bounding box height is 0, so don't cache it (#5620).
	                    if (cacheKey && bBox.height > 0) {
	
	                        // Rotate (#4681)
	                        while (cacheKeys.length > 250) {
	                            delete cache[cacheKeys.shift()];
	                        }
	
	                        if (!cache[cacheKey]) {
	                            cacheKeys.push(cacheKey);
	                        }
	                        cache[cacheKey] = bBox;
	                    }
	                }
	                return bBox;
	            },
	
	            /**
	             * Show the element after it has been hidden. 
	             *
	             * @param {boolean} [inherit=false] Set the visibility attribute to
	             * `inherit` rather than `visible`. The difference is that an element with
	             * `visibility="visible"` will be visible even if the parent is hidden.
	             *
	             * @returns {Highcharts.SVGElement} Returns the SVGElement for chaining.
	             */
	            show: function(inherit) {
	                return this.attr({
	                    visibility: inherit ? 'inherit' : 'visible'
	                });
	            },
	
	            /**
	             * Hide the element, equivalent to setting the `visibility` attribute to
	             * `hidden`.
	             *
	             * @returns {Highcharts.SVGElement} Returns the SVGElement for chaining.
	             */
	            hide: function() {
	                return this.attr({
	                    visibility: 'hidden'
	                });
	            },
	
	            /**
	             * Fade out an element by animating its opacity down to 0, and hide it on
	             * complete. Used internally for the tooltip.
	             * 
	             * @param {number} [duration=150] The fade duration in milliseconds.
	             */
	            fadeOut: function(duration) {
	                var elemWrapper = this;
	                elemWrapper.animate({
	                    opacity: 0
	                }, {
	                    duration: duration || 150,
	                    complete: function() {
	                        elemWrapper.attr({
	                            y: -9999
	                        }); // #3088, assuming we're only using this for tooltips
	                    }
	                });
	            },
	
	            /**
	             * Add the element to the DOM. All elements must be added this way.
	             * 
	             * @param {Highcharts.SVGElement|SVGDOMElement} [parent] The parent item to add it to.
	             *   If undefined, the element is added to the {@link
	             *   Highcharts.SVGRenderer.box}.
	             *
	             * @returns {Highcharts.SVGElement} Returns the SVGElement for chaining.
	             *
	             * @sample highcharts/members/renderer-g - Elements added to a group
	             */
	            add: function(parent) {
	
	                var renderer = this.renderer,
	                    element = this.element,
	                    inserted;
	
	                if (parent) {
	                    this.parentGroup = parent;
	                }
	
	                // mark as inverted
	                this.parentInverted = parent && parent.inverted;
	
	                // build formatted text
	                if (this.textStr !== undefined) {
	                    renderer.buildText(this);
	                }
	
	                // Mark as added
	                this.added = true;
	
	                // If we're adding to renderer root, or other elements in the group
	                // have a z index, we need to handle it
	                if (!parent || parent.handleZ || this.zIndex) {
	                    inserted = this.zIndexSetter();
	                }
	
	                // If zIndex is not handled, append at the end
	                if (!inserted) {
	                    (parent ? parent.element : renderer.box).appendChild(element);
	                }
	
	                // fire an event for internal hooks
	                if (this.onAdd) {
	                    this.onAdd();
	                }
	
	                return this;
	            },
	
	            /**
	             * Removes an element from the DOM.
	             *
	             * @private
	             * @param {SVGDOMElement|HTMLDOMElement} element The DOM node to remove.
	             */
	            safeRemoveChild: function(element) {
	                var parentNode = element.parentNode;
	                if (parentNode) {
	                    parentNode.removeChild(element);
	                }
	            },
	
	            /**
	             * Destroy the element and element wrapper and clear up the DOM and event
	             * hooks.
	             *
	             * @returns {void}
	             */
	            destroy: function() {
	                var wrapper = this,
	                    element = wrapper.element || {},
	                    parentToClean =
	                    wrapper.renderer.isSVG &&
	                    element.nodeName === 'SPAN' &&
	                    wrapper.parentGroup,
	                    grandParent,
	                    ownerSVGElement = element.ownerSVGElement,
	                    i;
	
	                // remove events
	                element.onclick = element.onmouseout = element.onmouseover =
	                    element.onmousemove = element.point = null;
	                stop(wrapper); // stop running animations
	
	                if (wrapper.clipPath && ownerSVGElement) {
	                    // Look for existing references to this clipPath and remove them
	                    // before destroying the element (#6196).
	                    each(
	                        ownerSVGElement.querySelectorAll('[clip-path]'),
	                        function(el) {
	                            // Include the closing paranthesis in the test to rule out
	                            // id's from 10 and above (#6550)
	                            if (el.getAttribute('clip-path')
	                                .indexOf(wrapper.clipPath.element.id + ')') > -1) {
	                                el.removeAttribute('clip-path');
	                            }
	                        }
	                    );
	                    wrapper.clipPath = wrapper.clipPath.destroy();
	                }
	
	                // Destroy stops in case this is a gradient object
	                if (wrapper.stops) {
	                    for (i = 0; i < wrapper.stops.length; i++) {
	                        wrapper.stops[i] = wrapper.stops[i].destroy();
	                    }
	                    wrapper.stops = null;
	                }
	
	                // remove element
	                wrapper.safeRemoveChild(element);
	
	
	                wrapper.destroyShadows();
	
	
	                // In case of useHTML, clean up empty containers emulating SVG groups (#1960, #2393, #2697).
	                while (parentToClean && parentToClean.div && parentToClean.div.childNodes.length === 0) {
	                    grandParent = parentToClean.parentGroup;
	                    wrapper.safeRemoveChild(parentToClean.div);
	                    delete parentToClean.div;
	                    parentToClean = grandParent;
	                }
	
	                // remove from alignObjects
	                if (wrapper.alignTo) {
	                    erase(wrapper.renderer.alignedObjects, wrapper);
	                }
	
	                objectEach(wrapper, function(val, key) {
	                    delete wrapper[key];
	                });
	
	                return null;
	            },
	
	
	            /**
	             * @typedef {Object} ShadowOptions
	             * @property {string} [color=#000000] The shadow color.
	             * @property {number} [offsetX=1] The horizontal offset from the element.
	             * @property {number} [offsetY=1] The vertical offset from the element.
	             * @property {number} [opacity=0.15] The shadow opacity.
	             * @property {number} [width=3] The shadow width or distance from the
	             *    element.
	             */
	            /**
	             * Add a shadow to the element. Must be called after the element is added to
	             * the DOM. In styled mode, this method is not used, instead use `defs` and
	             * filters.
	             * 
	             * @param {boolean|ShadowOptions} shadowOptions The shadow options. If
	             *    `true`, the default options are applied. If `false`, the current
	             *    shadow will be removed.
	             * @param {Highcharts.SVGElement} [group] The SVG group element where the shadows will 
	             *    be applied. The default is to add it to the same parent as the current
	             *    element. Internally, this is ised for pie slices, where all the
	             *    shadows are added to an element behind all the slices.
	             * @param {boolean} [cutOff] Used internally for column shadows.
	             *
	             * @returns {Highcharts.SVGElement} Returns the SVGElement for chaining.
	             *
	             * @example
	             * renderer.rect(10, 100, 100, 100)
	             *     .attr({ fill: 'red' })
	             *     .shadow(true);
	             */
	            shadow: function(shadowOptions, group, cutOff) {
	                var shadows = [],
	                    i,
	                    shadow,
	                    element = this.element,
	                    strokeWidth,
	                    shadowWidth,
	                    shadowElementOpacity,
	
	                    // compensate for inverted plot area
	                    transform;
	
	                if (!shadowOptions) {
	                    this.destroyShadows();
	
	                } else if (!this.shadows) {
	                    shadowWidth = pick(shadowOptions.width, 3);
	                    shadowElementOpacity = (shadowOptions.opacity || 0.15) / shadowWidth;
	                    transform = this.parentInverted ?
	                        '(-1,-1)' :
	                        '(' + pick(shadowOptions.offsetX, 1) + ', ' + pick(shadowOptions.offsetY, 1) + ')';
	                    for (i = 1; i <= shadowWidth; i++) {
	                        shadow = element.cloneNode(0);
	                        strokeWidth = (shadowWidth * 2) + 1 - (2 * i);
	                        attr(shadow, {
	                            'isShadow': 'true',
	                            'stroke': shadowOptions.color || '#000000',
	                            'stroke-opacity': shadowElementOpacity * i,
	                            'stroke-width': strokeWidth,
	                            'transform': 'translate' + transform,
	                            'fill': 'none'
	                        });
	                        if (cutOff) {
	                            attr(shadow, 'height', Math.max(attr(shadow, 'height') - strokeWidth, 0));
	                            shadow.cutHeight = strokeWidth;
	                        }
	
	                        if (group) {
	                            group.element.appendChild(shadow);
	                        } else {
	                            element.parentNode.insertBefore(shadow, element);
	                        }
	
	                        shadows.push(shadow);
	                    }
	
	                    this.shadows = shadows;
	                }
	                return this;
	
	            },
	
	            /**
	             * Destroy shadows on the element.
	             * @private
	             */
	            destroyShadows: function() {
	                each(this.shadows || [], function(shadow) {
	                    this.safeRemoveChild(shadow);
	                }, this);
	                this.shadows = undefined;
	            },
	
	
	
	            xGetter: function(key) {
	                if (this.element.nodeName === 'circle') {
	                    if (key === 'x') {
	                        key = 'cx';
	                    } else if (key === 'y') {
	                        key = 'cy';
	                    }
	                }
	                return this._defaultGetter(key);
	            },
	
	            /**
	             * Get the current value of an attribute or pseudo attribute, used mainly
	             * for animation. Called internally from the {@link
	             * Highcharts.SVGRenderer#attr}
	             * function.
	             *
	             * @private
	             */
	            _defaultGetter: function(key) {
	                var ret = pick(this[key], this.element ? this.element.getAttribute(key) : null, 0);
	
	                if (/^[\-0-9\.]+$/.test(ret)) { // is numerical
	                    ret = parseFloat(ret);
	                }
	                return ret;
	            },
	
	
	            dSetter: function(value, key, element) {
	                if (value && value.join) { // join path
	                    value = value.join(' ');
	                }
	                if (/(NaN| {2}|^$)/.test(value)) {
	                    value = 'M 0 0';
	                }
	                element.setAttribute(key, value);
	
	                this[key] = value;
	            },
	
	            dashstyleSetter: function(value) {
	                var i,
	                    strokeWidth = this['stroke-width'];
	
	                // If "inherit", like maps in IE, assume 1 (#4981). With HC5 and the new strokeWidth 
	                // function, we should be able to use that instead.
	                if (strokeWidth === 'inherit') {
	                    strokeWidth = 1;
	                }
	                value = value && value.toLowerCase();
	                if (value) {
	                    value = value
	                        .replace('shortdashdotdot', '3,1,1,1,1,1,')
	                        .replace('shortdashdot', '3,1,1,1')
	                        .replace('shortdot', '1,1,')
	                        .replace('shortdash', '3,1,')
	                        .replace('longdash', '8,3,')
	                        .replace(/dot/g, '1,3,')
	                        .replace('dash', '4,3,')
	                        .replace(/,$/, '')
	                        .split(','); // ending comma
	
	                    i = value.length;
	                    while (i--) {
	                        value[i] = pInt(value[i]) * strokeWidth;
	                    }
	                    value = value.join(',')
	                        .replace(/NaN/g, 'none'); // #3226
	                    this.element.setAttribute('stroke-dasharray', value);
	                }
	            },
	
	            alignSetter: function(value) {
	                var convert = {
	                    left: 'start',
	                    center: 'middle',
	                    right: 'end'
	                };
	                this.element.setAttribute('text-anchor', convert[value]);
	            },
	            opacitySetter: function(value, key, element) {
	                this[key] = value;
	                element.setAttribute(key, value);
	            },
	            titleSetter: function(value) {
	                var titleNode = this.element.getElementsByTagName('title')[0];
	                if (!titleNode) {
	                    titleNode = doc.createElementNS(this.SVG_NS, 'title');
	                    this.element.appendChild(titleNode);
	                }
	
	                // Remove text content if it exists
	                if (titleNode.firstChild) {
	                    titleNode.removeChild(titleNode.firstChild);
	                }
	
	                titleNode.appendChild(
	                    doc.createTextNode(
	                        (String(pick(value), '')).replace(/<[^>]*>/g, '') // #3276, #3895
	                    )
	                );
	            },
	            textSetter: function(value) {
	                if (value !== this.textStr) {
	                    // Delete bBox memo when the text changes
	                    delete this.bBox;
	
	                    this.textStr = value;
	                    if (this.added) {
	                        this.renderer.buildText(this);
	                    }
	                }
	            },
	            fillSetter: function(value, key, element) {
	                if (typeof value === 'string') {
	                    element.setAttribute(key, value);
	                } else if (value) {
	                    this.colorGradient(value, key, element);
	                }
	            },
	            visibilitySetter: function(value, key, element) {
	                // IE9-11 doesn't handle visibilty:inherit well, so we remove the attribute instead (#2881, #3909)
	                if (value === 'inherit') {
	                    element.removeAttribute(key);
	                } else {
	                    element.setAttribute(key, value);
	                }
	            },
	            zIndexSetter: function(value, key) {
	                var renderer = this.renderer,
	                    parentGroup = this.parentGroup,
	                    parentWrapper = parentGroup || renderer,
	                    parentNode = parentWrapper.element || renderer.box,
	                    childNodes,
	                    otherElement,
	                    otherZIndex,
	                    element = this.element,
	                    inserted,
	                    run = this.added,
	                    i;
	
	                if (defined(value)) {
	                    element.zIndex = value; // So we can read it for other elements in the group
	                    value = +value;
	                    if (this[key] === value) { // Only update when needed (#3865)
	                        run = false;
	                    }
	                    this[key] = value;
	                }
	
	                // Insert according to this and other elements' zIndex. Before .add() is called,
	                // nothing is done. Then on add, or by later calls to zIndexSetter, the node
	                // is placed on the right place in the DOM.
	                if (run) {
	                    value = this.zIndex;
	
	                    if (value && parentGroup) {
	                        parentGroup.handleZ = true;
	                    }
	
	                    childNodes = parentNode.childNodes;
	                    for (i = 0; i < childNodes.length && !inserted; i++) {
	                        otherElement = childNodes[i];
	                        otherZIndex = otherElement.zIndex;
	                        if (otherElement !== element && (
	                                // Insert before the first element with a higher zIndex
	                                pInt(otherZIndex) > value ||
	                                // If no zIndex given, insert before the first element with a zIndex
	                                (!defined(value) && defined(otherZIndex)) ||
	                                // Negative zIndex versus no zIndex:
	                                // On all levels except the highest. If the parent is <svg>,
	                                // then we don't want to put items before <desc> or <defs>
	                                (value < 0 && !defined(otherZIndex) && parentNode !== renderer.box)
	
	                            )) {
	                            parentNode.insertBefore(element, otherElement);
	                            inserted = true;
	                        }
	                    }
	                    if (!inserted) {
	                        parentNode.appendChild(element);
	                    }
	                }
	                return inserted;
	            },
	            _defaultSetter: function(value, key, element) {
	                element.setAttribute(key, value);
	            }
	        });
	
	        // Some shared setters and getters
	        SVGElement.prototype.yGetter = SVGElement.prototype.xGetter;
	        SVGElement.prototype.translateXSetter = SVGElement.prototype.translateYSetter =
	            SVGElement.prototype.rotationSetter = SVGElement.prototype.verticalAlignSetter =
	            SVGElement.prototype.scaleXSetter = SVGElement.prototype.scaleYSetter = function(value, key) {
	                this[key] = value;
	                this.doTransform = true;
	            };
	
	
	        // WebKit and Batik have problems with a stroke-width of zero, so in this case we remove the 
	        // stroke attribute altogether. #1270, #1369, #3065, #3072.
	        SVGElement.prototype['stroke-widthSetter'] = SVGElement.prototype.strokeSetter = function(value, key, element) {
	            this[key] = value;
	            // Only apply the stroke attribute if the stroke width is defined and larger than 0
	            if (this.stroke && this['stroke-width']) {
	                SVGElement.prototype.fillSetter.call(this, this.stroke, 'stroke', element); // use prototype as instance may be overridden
	                element.setAttribute('stroke-width', this['stroke-width']);
	                this.hasStroke = true;
	            } else if (key === 'stroke-width' && value === 0 && this.hasStroke) {
	                element.removeAttribute('stroke');
	                this.hasStroke = false;
	            }
	        };
	
	
	        /**
	         * Allows direct access to the Highcharts rendering layer in order to draw
	         * primitive shapes like circles, rectangles, paths or text directly on a chart,
	         * or independent from any chart. The SVGRenderer represents a wrapper object
	         * for SVGin modern browsers and through the VMLRenderer, for VML in IE < 8.
	         *
	         * An existing chart's renderer can be accessed through {@link Chart#renderer}.
	         * The renderer can also be used completely decoupled from a chart.
	         *
	         * @param {HTMLDOMElement} container - Where to put the SVG in the web page.
	         * @param {number} width - The width of the SVG.
	         * @param {number} height - The height of the SVG.
	         * @param {boolean} [forExport=false] - Whether the rendered content is intended
	         *   for export.
	         * @param {boolean} [allowHTML=true] - Whether the renderer is allowed to
	         *   include HTML text, which will be projected on top of the SVG.
	         *
	         * @example
	         * // Use directly without a chart object.
	         * var renderer = new Highcharts.Renderer(parentNode, 600, 400);
	         *
	         * @sample highcharts/members/renderer-on-chart - Annotating a chart programmatically.
	         * @sample highcharts/members/renderer-basic - Independedt SVG drawing.
	         *
	         * @class Highcharts.SVGRenderer
	         */
	        SVGRenderer = H.SVGRenderer = function() {
	            this.init.apply(this, arguments);
	        };
	        extend(SVGRenderer.prototype, /** @lends Highcharts.SVGRenderer.prototype */ {
	            /**
	             * A pointer to the renderer's associated Element class. The VMLRenderer
	             * will have a pointer to VMLElement here.
	             * @type {Highcharts.SVGElement}
	             */
	            Element: SVGElement,
	            SVG_NS: SVG_NS,
	            /**
	             * Initialize the SVGRenderer. Overridable initiator function that takes
	             * the same parameters as the constructor.
	             */
	            init: function(container, width, height, style, forExport, allowHTML) {
	                var renderer = this,
	                    boxWrapper,
	                    element,
	                    desc;
	
	                boxWrapper = renderer.createElement('svg')
	                    .attr({
	                        'version': '1.1',
	                        'class': 'highcharts-root'
	                    })
	
	                    .css(this.getStyle(style));
	                element = boxWrapper.element;
	                container.appendChild(element);
	
	                // For browsers other than IE, add the namespace attribute (#1978)
	                if (container.innerHTML.indexOf('xmlns') === -1) {
	                    attr(element, 'xmlns', this.SVG_NS);
	                }
	
	                // object properties
	                renderer.isSVG = true;
	
	                /** 
	                 * The root `svg` node of the renderer.
	                 * @type {SVGDOMElement}
	                 */
	                this.box = element;
	                /** 
	                 * The wrapper for the root `svg` node of the renderer.
	                 * @type {Highcharts.SVGElement}
	                 */
	                this.boxWrapper = boxWrapper;
	                renderer.alignedObjects = [];
	
	                /**
	                 * Page url used for internal references.
	                 * @type {string}
	                 */
	                // #24, #672, #1070
	                this.url = (isFirefox || isWebKit) && doc.getElementsByTagName('base').length ?
	                    win.location.href
	                    .replace(/#.*?$/, '') // remove the hash
	                    .replace(/<[^>]*>/g, '') // wing cut HTML
	                    .replace(/([\('\)])/g, '\\$1') // escape parantheses and quotes
	                    .replace(/ /g, '%20') : // replace spaces (needed for Safari only)
	                    '';
	
	                // Add description
	                desc = this.createElement('desc').add();
	                desc.element.appendChild(doc.createTextNode('Created with Highcharts 5.0.12'));
	
	
	                renderer.defs = this.createElement('defs').add();
	                renderer.allowHTML = allowHTML;
	                renderer.forExport = forExport;
	                renderer.gradients = {}; // Object where gradient SvgElements are stored
	                renderer.cache = {}; // Cache for numerical bounding boxes
	                renderer.cacheKeys = [];
	                renderer.imgCount = 0;
	
	                renderer.setSize(width, height, false);
	
	
	
	                // Issue 110 workaround:
	                // In Firefox, if a div is positioned by percentage, its pixel position may land
	                // between pixels. The container itself doesn't display this, but an SVG element
	                // inside this container will be drawn at subpixel precision. In order to draw
	                // sharp lines, this must be compensated for. This doesn't seem to work inside
	                // iframes though (like in jsFiddle).
	                var subPixelFix, rect;
	                if (isFirefox && container.getBoundingClientRect) {
	                    subPixelFix = function() {
	                        css(container, {
	                            left: 0,
	                            top: 0
	                        });
	                        rect = container.getBoundingClientRect();
	                        css(container, {
	                            left: (Math.ceil(rect.left) - rect.left) + 'px',
	                            top: (Math.ceil(rect.top) - rect.top) + 'px'
	                        });
	                    };
	
	                    // run the fix now
	                    subPixelFix();
	
	                    // run it on resize
	                    renderer.unSubPixelFix = addEvent(win, 'resize', subPixelFix);
	                }
	            },
	
	
	
	            /**
	             * Get the global style setting for the renderer.
	             * @private
	             * @param  {CSSObject} style - Style settings.
	             * @return {CSSObject} The style settings mixed with defaults.
	             */
	            getStyle: function(style) {
	                this.style = extend({
	
	                    fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', // default font
	                    fontSize: '12px'
	
	                }, style);
	                return this.style;
	            },
	            /**
	             * Apply the global style on the renderer, mixed with the default styles.
	             * @param {CSSObject} style - CSS to apply.
	             */
	            setStyle: function(style) {
	                this.boxWrapper.css(this.getStyle(style));
	            },
	
	
	            /**
	             * Detect whether the renderer is hidden. This happens when one of the
	             * parent elements has display: none. Used internally to detect when we need
	             * to render preliminarily in another div to get the text bounding boxes 
	             * right.
	             *
	             * @returns {boolean} True if it is hidden.
	             */
	            isHidden: function() { // #608
	                return !this.boxWrapper.getBBox().width;
	            },
	
	            /**
	             * Destroys the renderer and its allocated members.
	             */
	            destroy: function() {
	                var renderer = this,
	                    rendererDefs = renderer.defs;
	                renderer.box = null;
	                renderer.boxWrapper = renderer.boxWrapper.destroy();
	
	                // Call destroy on all gradient elements
	                destroyObjectProperties(renderer.gradients || {});
	                renderer.gradients = null;
	
	                // Defs are null in VMLRenderer
	                // Otherwise, destroy them here.
	                if (rendererDefs) {
	                    renderer.defs = rendererDefs.destroy();
	                }
	
	                // Remove sub pixel fix handler (#982)
	                if (renderer.unSubPixelFix) {
	                    renderer.unSubPixelFix();
	                }
	
	                renderer.alignedObjects = null;
	
	                return null;
	            },
	
	            /**
	             * Create a wrapper for an SVG element. Serves as a factory for 
	             * {@link SVGElement}, but this function is itself mostly called from 
	             * primitive factories like {@link SVGRenderer#path}, {@link
	             * SVGRenderer#rect} or {@link SVGRenderer#text}.
	             * 
	             * @param {string} nodeName - The node name, for example `rect`, `g` etc.
	             * @returns {Highcharts.SVGElement} The generated SVGElement.
	             */
	            createElement: function(nodeName) {
	                var wrapper = new this.Element();
	                wrapper.init(this, nodeName);
	                return wrapper;
	            },
	
	            /**
	             * Dummy function for plugins, called every time the renderer is updated.
	             * Prior to Highcharts 5, this was used for the canvg renderer.
	             * @function
	             */
	            draw: noop,
	
	            /**
	             * Get converted radial gradient attributes according to the radial
	             * reference. Used internally from the {@link SVGElement#colorGradient}
	             * function.
	             *
	             * @private
	             */
	            getRadialAttr: function(radialReference, gradAttr) {
	                return {
	                    cx: (radialReference[0] - radialReference[2] / 2) + gradAttr.cx * radialReference[2],
	                    cy: (radialReference[1] - radialReference[2] / 2) + gradAttr.cy * radialReference[2],
	                    r: gradAttr.r * radialReference[2]
	                };
	            },
	
	            getSpanWidth: function(wrapper, tspan) {
	                var renderer = this,
	                    bBox = wrapper.getBBox(true),
	                    actualWidth = bBox.width;
	
	                // Old IE cannot measure the actualWidth for SVG elements (#2314)
	                if (!svg && renderer.forExport) {
	                    actualWidth = renderer.measureSpanWidth(tspan.firstChild.data, wrapper.styles);
	                }
	                return actualWidth;
	            },
	
	            applyEllipsis: function(wrapper, tspan, text, width) {
	                var renderer = this,
	                    actualWidth = renderer.getSpanWidth(wrapper, tspan),
	                    wasTooLong = actualWidth > width,
	                    str = text,
	                    currentIndex,
	                    minIndex = 0,
	                    maxIndex = text.length,
	                    updateTSpan = function(s) {
	                        tspan.removeChild(tspan.firstChild);
	                        if (s) {
	                            tspan.appendChild(doc.createTextNode(s));
	                        }
	                    };
	                if (wasTooLong) {
	                    while (minIndex <= maxIndex) {
	                        currentIndex = Math.ceil((minIndex + maxIndex) / 2);
	                        str = text.substring(0, currentIndex) + '\u2026';
	                        updateTSpan(str);
	                        actualWidth = renderer.getSpanWidth(wrapper, tspan);
	                        if (minIndex === maxIndex) {
	                            // Complete
	                            minIndex = maxIndex + 1;
	                        } else if (actualWidth > width) {
	                            // Too large. Set max index to current.
	                            maxIndex = currentIndex - 1;
	                        } else {
	                            // Within width. Set min index to current.
	                            minIndex = currentIndex;
	                        }
	                    }
	                    // If max index was 0 it means just ellipsis was also to large.
	                    if (maxIndex === 0) {
	                        // Remove ellipses.
	                        updateTSpan('');
	                    }
	                }
	                return wasTooLong;
	            },
	
	            /**
	             * Parse a simple HTML string into SVG tspans. Called internally when text
	             *   is set on an SVGElement. The function supports a subset of HTML tags,
	             *   CSS text features like `width`, `text-overflow`, `white-space`, and
	             *   also attributes like `href` and `style`.
	             * @private
	             * @param {Highcharts.SVGElement} wrapper The parent SVGElement.
	             */
	            buildText: function(wrapper) {
	                var textNode = wrapper.element,
	                    renderer = this,
	                    forExport = renderer.forExport,
	                    textStr = pick(wrapper.textStr, '').toString(),
	                    hasMarkup = textStr.indexOf('<') !== -1,
	                    lines,
	                    childNodes = textNode.childNodes,
	                    clsRegex,
	                    styleRegex,
	                    hrefRegex,
	                    wasTooLong,
	                    parentX = attr(textNode, 'x'),
	                    textStyles = wrapper.styles,
	                    width = wrapper.textWidth,
	                    textLineHeight = textStyles && textStyles.lineHeight,
	                    textOutline = textStyles && textStyles.textOutline,
	                    ellipsis = textStyles && textStyles.textOverflow === 'ellipsis',
	                    noWrap = textStyles && textStyles.whiteSpace === 'nowrap',
	                    fontSize = textStyles && textStyles.fontSize,
	                    textCache,
	                    isSubsequentLine,
	                    i = childNodes.length,
	                    tempParent = width && !wrapper.added && this.box,
	                    getLineHeight = function(tspan) {
	                        var fontSizeStyle;
	
	                        fontSizeStyle = /(px|em)$/.test(tspan && tspan.style.fontSize) ?
	                            tspan.style.fontSize :
	                            (fontSize || renderer.style.fontSize || 12);
	
	
	                        return textLineHeight ?
	                            pInt(textLineHeight) :
	                            renderer.fontMetrics(
	                                fontSizeStyle,
	                                // Get the computed size from parent if not explicit
	                                tspan.getAttribute('style') ? tspan : textNode
	                            ).h;
	                    },
	                    unescapeAngleBrackets = function(inputStr) {
	                        return inputStr.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	                    };
	
	                // The buildText code is quite heavy, so if we're not changing something
	                // that affects the text, skip it (#6113).
	                textCache = [
	                    textStr,
	                    ellipsis,
	                    noWrap,
	                    textLineHeight,
	                    textOutline,
	                    fontSize,
	                    width
	                ].join(',');
	                if (textCache === wrapper.textCache) {
	                    return;
	                }
	                wrapper.textCache = textCache;
	
	                /// remove old text
	                while (i--) {
	                    textNode.removeChild(childNodes[i]);
	                }
	
	                // Skip tspans, add text directly to text node. The forceTSpan is a hook
	                // used in text outline hack.
	                if (!hasMarkup && !textOutline && !ellipsis && !width && textStr.indexOf(' ') === -1) {
	                    textNode.appendChild(doc.createTextNode(unescapeAngleBrackets(textStr)));
	
	                    // Complex strings, add more logic
	                } else {
	
	                    clsRegex = /<.*class="([^"]+)".*>/;
	                    styleRegex = /<.*style="([^"]+)".*>/;
	                    hrefRegex = /<.*href="([^"]+)".*>/;
	
	                    if (tempParent) {
	                        tempParent.appendChild(textNode); // attach it to the DOM to read offset width
	                    }
	
	                    if (hasMarkup) {
	                        lines = textStr
	
	                            .replace(/<(b|strong)>/g, '<span style="font-weight:bold">')
	                            .replace(/<(i|em)>/g, '<span style="font-style:italic">')
	
	                            .replace(/<a/g, '<span')
	                            .replace(/<\/(b|strong|i|em|a)>/g, '</span>')
	                            .split(/<br.*?>/g);
	
	                    } else {
	                        lines = [textStr];
	                    }
	
	
	                    // Trim empty lines (#5261)
	                    lines = grep(lines, function(line) {
	                        return line !== '';
	                    });
	
	
	                    // build the lines
	                    each(lines, function buildTextLines(line, lineNo) {
	                        var spans,
	                            spanNo = 0;
	                        line = line
	                            .replace(/^\s+|\s+$/g, '') // Trim to prevent useless/costly process on the spaces (#5258)
	                            .replace(/<span/g, '|||<span')
	                            .replace(/<\/span>/g, '</span>|||');
	                        spans = line.split('|||');
	
	                        each(spans, function buildTextSpans(span) {
	                            if (span !== '' || spans.length === 1) {
	                                var attributes = {},
	                                    tspan = doc.createElementNS(renderer.SVG_NS, 'tspan'),
	                                    spanCls,
	                                    spanStyle; // #390
	                                if (clsRegex.test(span)) {
	                                    spanCls = span.match(clsRegex)[1];
	                                    attr(tspan, 'class', spanCls);
	                                }
	                                if (styleRegex.test(span)) {
	                                    spanStyle = span.match(styleRegex)[1].replace(/(;| |^)color([ :])/, '$1fill$2');
	                                    attr(tspan, 'style', spanStyle);
	                                }
	                                if (hrefRegex.test(span) && !forExport) { // Not for export - #1529
	                                    attr(tspan, 'onclick', 'location.href=\"' + span.match(hrefRegex)[1] + '\"');
	                                    css(tspan, {
	                                        cursor: 'pointer'
	                                    });
	                                }
	
	                                span = unescapeAngleBrackets(span.replace(/<(.|\n)*?>/g, '') || ' ');
	
	                                // Nested tags aren't supported, and cause crash in Safari (#1596)
	                                if (span !== ' ') {
	
	                                    // add the text node
	                                    tspan.appendChild(doc.createTextNode(span));
	
	                                    if (!spanNo) { // first span in a line, align it to the left
	                                        if (lineNo && parentX !== null) {
	                                            attributes.x = parentX;
	                                        }
	                                    } else {
	                                        attributes.dx = 0; // #16
	                                    }
	
	                                    // add attributes
	                                    attr(tspan, attributes);
	
	                                    // Append it
	                                    textNode.appendChild(tspan);
	
	                                    // first span on subsequent line, add the line height
	                                    if (!spanNo && isSubsequentLine) {
	
	                                        // allow getting the right offset height in exporting in IE
	                                        if (!svg && forExport) {
	                                            css(tspan, {
	                                                display: 'block'
	                                            });
	                                        }
	
	                                        // Set the line height based on the font size of either
	                                        // the text element or the tspan element
	                                        attr(
	                                            tspan,
	                                            'dy',
	                                            getLineHeight(tspan)
	                                        );
	                                    }
	
	                                    /*if (width) {
	                                    	renderer.breakText(wrapper, width);
	                                    }*/
	
	                                    // Check width and apply soft breaks or ellipsis
	                                    if (width) {
	                                        var words = span.replace(/([^\^])-/g, '$1- ').split(' '), // #1273
	                                            hasWhiteSpace = spans.length > 1 || lineNo || (words.length > 1 && !noWrap),
	                                            tooLong,
	                                            rest = [],
	                                            actualWidth,
	                                            dy = getLineHeight(tspan),
	                                            rotation = wrapper.rotation;
	
	                                        if (ellipsis) {
	                                            wasTooLong = renderer.applyEllipsis(wrapper, tspan, span, width);
	                                        }
	
	                                        while (!ellipsis && hasWhiteSpace && (words.length || rest.length)) {
	                                            wrapper.rotation = 0; // discard rotation when computing box
	                                            actualWidth = renderer.getSpanWidth(wrapper, tspan);
	                                            tooLong = actualWidth > width;
	
	                                            // For ellipsis, do a binary search for the correct string length
	                                            if (wasTooLong === undefined) {
	                                                wasTooLong = tooLong; // First time
	                                            }
	
	                                            // Looping down, this is the first word sequence that is not too long,
	                                            // so we can move on to build the next line.
	                                            if (!tooLong || words.length === 1) {
	                                                words = rest;
	                                                rest = [];
	
	                                                if (words.length && !noWrap) {
	                                                    tspan = doc.createElementNS(SVG_NS, 'tspan');
	                                                    attr(tspan, {
	                                                        dy: dy,
	                                                        x: parentX
	                                                    });
	                                                    if (spanStyle) { // #390
	                                                        attr(tspan, 'style', spanStyle);
	                                                    }
	                                                    textNode.appendChild(tspan);
	                                                }
	                                                if (actualWidth > width) { // a single word is pressing it out
	                                                    width = actualWidth;
	                                                }
	                                            } else { // append to existing line tspan
	                                                tspan.removeChild(tspan.firstChild);
	                                                rest.unshift(words.pop());
	                                            }
	                                            if (words.length) {
	                                                tspan.appendChild(doc.createTextNode(words.join(' ').replace(/- /g, '-')));
	                                            }
	                                        }
	                                        wrapper.rotation = rotation;
	                                    }
	
	                                    spanNo++;
	                                }
	                            }
	                        });
	                        // To avoid beginning lines that doesn't add to the textNode (#6144)
	                        isSubsequentLine = isSubsequentLine || textNode.childNodes.length;
	                    });
	
	                    if (wasTooLong) {
	                        wrapper.attr('title', wrapper.textStr);
	                    }
	                    if (tempParent) {
	                        tempParent.removeChild(textNode); // attach it to the DOM to read offset width
	                    }
	
	                    // Apply the text outline
	                    if (textOutline && wrapper.applyTextOutline) {
	                        wrapper.applyTextOutline(textOutline);
	                    }
	                }
	            },
	
	
	
	            /*
	            breakText: function (wrapper, width) {
	            	var bBox = wrapper.getBBox(),
	            		node = wrapper.element,
	            		textLength = node.textContent.length,
	            		pos = Math.round(width * textLength / bBox.width), // try this position first, based on average character width
	            		increment = 0,
	            		finalPos;
	
	            	if (bBox.width > width) {
	            		while (finalPos === undefined) {
	            			textLength = node.getSubStringLength(0, pos);
	
	            			if (textLength <= width) {
	            				if (increment === -1) {
	            					finalPos = pos;
	            				} else {
	            					increment = 1;
	            				}
	            			} else {
	            				if (increment === 1) {
	            					finalPos = pos - 1;
	            				} else {
	            					increment = -1;
	            				}
	            			}
	            			pos += increment;
	            		}
	            	}
	            	console.log('width', width, 'stringWidth', node.getSubStringLength(0, finalPos))
	            },
	            */
	
	            /**
	             * Returns white for dark colors and black for bright colors.
	             *
	             * @param {ColorString} rgba - The color to get the contrast for.
	             * @returns {string} The contrast color, either `#000000` or `#FFFFFF`.
	             */
	            getContrast: function(rgba) {
	                rgba = color(rgba).rgba;
	
	                // The threshold may be discussed. Here's a proposal for adding
	                // different weight to the color channels (#6216)
	                /*
	        rgba[0] *= 1; // red
	        rgba[1] *= 1.2; // green
	        rgba[2] *= 0.7; // blue
	        */
	
	                return rgba[0] + rgba[1] + rgba[2] > 2 * 255 ? '#000000' : '#FFFFFF';
	            },
	
	            /**
	             * Create a button with preset states.
	             * @param {string} text - The text or HTML to draw.
	             * @param {number} x - The x position of the button's left side.
	             * @param {number} y - The y position of the button's top side.
	             * @param {Function} callback - The function to execute on button click or 
	             *    touch.
	             * @param {SVGAttributes} [normalState] - SVG attributes for the normal
	             *    state.
	             * @param {SVGAttributes} [hoverState] - SVG attributes for the hover state.
	             * @param {SVGAttributes} [pressedState] - SVG attributes for the pressed
	             *    state.
	             * @param {SVGAttributes} [disabledState] - SVG attributes for the disabled
	             *    state.
	             * @param {Symbol} [shape=rect] - The shape type.
	             * @returns {SVGRenderer} The button element.
	             */
	            button: function(text, x, y, callback, normalState, hoverState, pressedState, disabledState, shape) {
	                var label = this.label(text, x, y, shape, null, null, null, null, 'button'),
	                    curState = 0;
	
	                // Default, non-stylable attributes
	                label.attr(merge({
	                    'padding': 8,
	                    'r': 2
	                }, normalState));
	
	
	                // Presentational
	                var normalStyle,
	                    hoverStyle,
	                    pressedStyle,
	                    disabledStyle;
	
	                // Normal state - prepare the attributes
	                normalState = merge({
	                    fill: '#f7f7f7',
	                    stroke: '#cccccc',
	                    'stroke-width': 1,
	                    style: {
	                        color: '#333333',
	                        cursor: 'pointer',
	                        fontWeight: 'normal'
	                    }
	                }, normalState);
	                normalStyle = normalState.style;
	                delete normalState.style;
	
	                // Hover state
	                hoverState = merge(normalState, {
	                    fill: '#e6e6e6'
	                }, hoverState);
	                hoverStyle = hoverState.style;
	                delete hoverState.style;
	
	                // Pressed state
	                pressedState = merge(normalState, {
	                    fill: '#e6ebf5',
	                    style: {
	                        color: '#000000',
	                        fontWeight: 'bold'
	                    }
	                }, pressedState);
	                pressedStyle = pressedState.style;
	                delete pressedState.style;
	
	                // Disabled state
	                disabledState = merge(normalState, {
	                    style: {
	                        color: '#cccccc'
	                    }
	                }, disabledState);
	                disabledStyle = disabledState.style;
	                delete disabledState.style;
	
	
	                // Add the events. IE9 and IE10 need mouseover and mouseout to funciton (#667).
	                addEvent(label.element, isMS ? 'mouseover' : 'mouseenter', function() {
	                    if (curState !== 3) {
	                        label.setState(1);
	                    }
	                });
	                addEvent(label.element, isMS ? 'mouseout' : 'mouseleave', function() {
	                    if (curState !== 3) {
	                        label.setState(curState);
	                    }
	                });
	
	                label.setState = function(state) {
	                    // Hover state is temporary, don't record it
	                    if (state !== 1) {
	                        label.state = curState = state;
	                    }
	                    // Update visuals
	                    label.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/)
	                        .addClass('highcharts-button-' + ['normal', 'hover', 'pressed', 'disabled'][state || 0]);
	
	
	                    label.attr([normalState, hoverState, pressedState, disabledState][state || 0])
	                        .css([normalStyle, hoverStyle, pressedStyle, disabledStyle][state || 0]);
	
	                };
	
	
	
	                // Presentational attributes
	                label
	                    .attr(normalState)
	                    .css(extend({
	                        cursor: 'default'
	                    }, normalStyle));
	
	
	                return label
	                    .on('click', function(e) {
	                        if (curState !== 3) {
	                            callback.call(label, e);
	                        }
	                    });
	            },
	
	            /**
	             * Make a straight line crisper by not spilling out to neighbour pixels.
	             * 
	             * @param {Array} points - The original points on the format `['M', 0, 0,
	             *    'L', 100, 0]`.
	             * @param {number} width - The width of the line.
	             * @returns {Array} The original points array, but modified to render
	             * crisply.
	             */
	            crispLine: function(points, width) {
	                // normalize to a crisp line
	                if (points[1] === points[4]) {
	                    // Substract due to #1129. Now bottom and left axis gridlines behave the same.
	                    points[1] = points[4] = Math.round(points[1]) - (width % 2 / 2);
	                }
	                if (points[2] === points[5]) {
	                    points[2] = points[5] = Math.round(points[2]) + (width % 2 / 2);
	                }
	                return points;
	            },
	
	
	            /**
	             * Draw a path, wraps the SVG `path` element.
	             * 
	             * @param {Array} [path] An SVG path definition in array form.
	             * 
	             * @example
	             * var path = renderer.path(['M', 10, 10, 'L', 30, 30, 'z'])
	             *     .attr({ stroke: '#ff00ff' })
	             *     .add();
	             * @returns {Highcharts.SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-path-on-chart/
	             *         Draw a path in a chart
	             * @sample highcharts/members/renderer-path/
	             *         Draw a path independent from a chart
	             *
	             */
	            /**
	             * Draw a path, wraps the SVG `path` element.
	             * 
	             * @param {SVGAttributes} [attribs] The initial attributes.
	             * @returns {Highcharts.SVGElement} The generated wrapper element.
	             */
	            path: function(path) {
	                var attribs = {
	
	                    fill: 'none'
	
	                };
	                if (isArray(path)) {
	                    attribs.d = path;
	                } else if (isObject(path)) { // attributes
	                    extend(attribs, path);
	                }
	                return this.createElement('path').attr(attribs);
	            },
	
	            /**
	             * Draw a circle, wraps the SVG `circle` element.
	             * 
	             * @param {number} [x] The center x position.
	             * @param {number} [y] The center y position.
	             * @param {number} [r] The radius.
	             * @returns {Highcharts.SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-circle/ Drawing a circle
	             */
	            /**
	             * Draw a circle, wraps the SVG `circle` element.
	             * 
	             * @param {SVGAttributes} [attribs] The initial attributes.
	             * @returns {Highcharts.SVGElement} The generated wrapper element.
	             */
	            circle: function(x, y, r) {
	                var attribs = isObject(x) ? x : {
	                        x: x,
	                        y: y,
	                        r: r
	                    },
	                    wrapper = this.createElement('circle');
	
	                // Setting x or y translates to cx and cy
	                wrapper.xSetter = wrapper.ySetter = function(value, key, element) {
	                    element.setAttribute('c' + key, value);
	                };
	
	                return wrapper.attr(attribs);
	            },
	
	            /**
	             * Draw and return an arc.
	             * @param {number} [x=0] Center X position.
	             * @param {number} [y=0] Center Y position.
	             * @param {number} [r=0] The outer radius of the arc.
	             * @param {number} [innerR=0] Inner radius like used in donut charts.
	             * @param {number} [start=0] The starting angle of the arc in radians, where
	             *    0 is to the right and `-Math.PI/2` is up.
	             * @param {number} [end=0] The ending angle of the arc in radians, where 0
	             *    is to the right and `-Math.PI/2` is up.
	             * @returns {Highcharts.SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-arc/
	             *         Drawing an arc
	             */
	            /**
	             * Draw and return an arc. Overloaded function that takes arguments object.
	             * @param {SVGAttributes} attribs Initial SVG attributes.
	             * @returns {Highcharts.SVGElement} The generated wrapper element.
	             */
	            arc: function(x, y, r, innerR, start, end) {
	                var arc,
	                    options;
	
	                if (isObject(x)) {
	                    options = x;
	                    y = options.y;
	                    r = options.r;
	                    innerR = options.innerR;
	                    start = options.start;
	                    end = options.end;
	                    x = options.x;
	                } else {
	                    options = {
	                        innerR: innerR,
	                        start: start,
	                        end: end
	                    };
	                }
	
	                // Arcs are defined as symbols for the ability to set
	                // attributes in attr and animate
	                arc = this.symbol('arc', x, y, r, r, options);
	                arc.r = r; // #959
	                return arc;
	            },
	
	            /**
	             * Draw and return a rectangle.
	             * @param {number} [x] Left position.
	             * @param {number} [y] Top position.
	             * @param {number} [width] Width of the rectangle.
	             * @param {number} [height] Height of the rectangle.
	             * @param {number} [r] Border corner radius.
	             * @param {number} [strokeWidth] A stroke width can be supplied to allow
	             *    crisp drawing.
	             * @returns {Highcharts.SVGElement} The generated wrapper element.
	             */
	            /**
	             * Draw and return a rectangle.
	             * @param  {SVGAttributes} [attributes]
	             *         General SVG attributes for the rectangle.
	             * @return {Highcharts.SVGElement}
	             *         The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-rect-on-chart/
	             *         Draw a rectangle in a chart
	             * @sample highcharts/members/renderer-rect/
	             *         Draw a rectangle independent from a chart
	             */
	            rect: function(x, y, width, height, r, strokeWidth) {
	
	                r = isObject(x) ? x.r : r;
	
	                var wrapper = this.createElement('rect'),
	                    attribs = isObject(x) ? x : x === undefined ? {} : {
	                        x: x,
	                        y: y,
	                        width: Math.max(width, 0),
	                        height: Math.max(height, 0)
	                    };
	
	
	                if (strokeWidth !== undefined) {
	                    attribs.strokeWidth = strokeWidth;
	                    attribs = wrapper.crisp(attribs);
	                }
	                attribs.fill = 'none';
	
	
	                if (r) {
	                    attribs.r = r;
	                }
	
	                wrapper.rSetter = function(value, key, element) {
	                    attr(element, {
	                        rx: value,
	                        ry: value
	                    });
	                };
	
	                return wrapper.attr(attribs);
	            },
	
	            /**
	             * Resize the {@link SVGRenderer#box} and re-align all aligned child
	             * elements.
	             * @param {number} width The new pixel width.
	             * @param {number} height The new pixel height.
	             * @param {boolean} animate Whether to animate.
	             */
	            setSize: function(width, height, animate) {
	                var renderer = this,
	                    alignedObjects = renderer.alignedObjects,
	                    i = alignedObjects.length;
	
	                renderer.width = width;
	                renderer.height = height;
	
	                renderer.boxWrapper.animate({
	                    width: width,
	                    height: height
	                }, {
	                    step: function() {
	                        this.attr({
	                            viewBox: '0 0 ' + this.attr('width') + ' ' + this.attr('height')
	                        });
	                    },
	                    duration: pick(animate, true) ? undefined : 0
	                });
	
	                while (i--) {
	                    alignedObjects[i].align();
	                }
	            },
	
	            /**
	             * Create and return an svg group element. Child {@link Highcharts.SVGElement}
	             * objects are added to the group by using the group as the first parameter
	             * in {@link Highcharts.SVGElement#add|add()}.
	             * 
	             * @param {string} [name] The group will be given a class name of
	             * `highcharts-{name}`. This can be used for styling and scripting.
	             * @returns {Highcharts.SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-g/
	             *         Show and hide grouped objects
	             */
	            g: function(name) {
	                var elem = this.createElement('g');
	                return name ? elem.attr({
	                    'class': 'highcharts-' + name
	                }) : elem;
	            },
	
	            /**
	             * Display an image.
	             * @param {string} src The image source.
	             * @param {number} [x] The X position.
	             * @param {number} [y] The Y position.
	             * @param {number} [width] The image width. If omitted, it defaults to the 
	             *    image file width.
	             * @param {number} [height] The image height. If omitted it defaults to the
	             *    image file height.
	             * @returns {Highcharts.SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-image-on-chart/
	             *         Add an image in a chart
	             * @sample highcharts/members/renderer-image/
	             *         Add an image independent of a chart
	             */
	            image: function(src, x, y, width, height) {
	                var attribs = {
	                        preserveAspectRatio: 'none'
	                    },
	                    elemWrapper;
	
	                // optional properties
	                if (arguments.length > 1) {
	                    extend(attribs, {
	                        x: x,
	                        y: y,
	                        width: width,
	                        height: height
	                    });
	                }
	
	                elemWrapper = this.createElement('image').attr(attribs);
	
	                // set the href in the xlink namespace
	                if (elemWrapper.element.setAttributeNS) {
	                    elemWrapper.element.setAttributeNS('http://www.w3.org/1999/xlink',
	                        'href', src);
	                } else {
	                    // could be exporting in IE
	                    // using href throws "not supported" in ie7 and under, requries regex shim to fix later
	                    elemWrapper.element.setAttribute('hc-svg-href', src);
	                }
	                return elemWrapper;
	            },
	
	            /**
	             * Draw a symbol out of pre-defined shape paths from {@SVGRenderer#symbols}.
	             * It is used in Highcharts for point makers, which cake a `symbol` option,
	             * and label and button backgrounds like in the tooltip and stock flags.
	             *
	             * @param {Symbol} symbol - The symbol name.
	             * @param {number} x - The X coordinate for the top left position.
	             * @param {number} y - The Y coordinate for the top left position.
	             * @param {number} width - The pixel width.
	             * @param {number} height - The pixel height.
	             * @param {Object} [options] - Additional options, depending on the actual
	             *    symbol drawn. 
	             * @param {number} [options.anchorX] - The anchor X position for the
	             *    `callout` symbol. This is where the chevron points to.
	             * @param {number} [options.anchorY] - The anchor Y position for the
	             *    `callout` symbol. This is where the chevron points to.
	             * @param {number} [options.end] - The end angle of an `arc` symbol.
	             * @param {boolean} [options.open] - Whether to draw `arc` symbol open or
	             *    closed.
	             * @param {number} [options.r] - The radius of an `arc` symbol, or the
	             *    border radius for the `callout` symbol.
	             * @param {number} [options.start] - The start angle of an `arc` symbol.
	             */
	            symbol: function(symbol, x, y, width, height, options) {
	
	                var ren = this,
	                    obj,
	                    imageRegex = /^url\((.*?)\)$/,
	                    isImage = imageRegex.test(symbol),
	                    sym = !isImage && (this.symbols[symbol] ? symbol : 'circle'),
	
	
	                    // get the symbol definition function
	                    symbolFn = sym && this.symbols[sym],
	
	                    // check if there's a path defined for this symbol
	                    path = defined(x) && symbolFn && symbolFn.call(
	                        this.symbols,
	                        Math.round(x),
	                        Math.round(y),
	                        width,
	                        height,
	                        options
	                    ),
	                    imageSrc,
	                    centerImage;
	
	                if (symbolFn) {
	                    obj = this.path(path);
	
	
	                    obj.attr('fill', 'none');
	
	
	                    // expando properties for use in animate and attr
	                    extend(obj, {
	                        symbolName: sym,
	                        x: x,
	                        y: y,
	                        width: width,
	                        height: height
	                    });
	                    if (options) {
	                        extend(obj, options);
	                    }
	
	
	                    // Image symbols
	                } else if (isImage) {
	
	
	                    imageSrc = symbol.match(imageRegex)[1];
	
	                    // Create the image synchronously, add attribs async
	                    obj = this.image(imageSrc);
	
	                    // The image width is not always the same as the symbol width. The
	                    // image may be centered within the symbol, as is the case when
	                    // image shapes are used as label backgrounds, for example in flags.
	                    obj.imgwidth = pick(
	                        symbolSizes[imageSrc] && symbolSizes[imageSrc].width,
	                        options && options.width
	                    );
	                    obj.imgheight = pick(
	                        symbolSizes[imageSrc] && symbolSizes[imageSrc].height,
	                        options && options.height
	                    );
	                    /**
	                     * Set the size and position
	                     */
	                    centerImage = function() {
	                        obj.attr({
	                            width: obj.width,
	                            height: obj.height
	                        });
	                    };
	
	                    /**
	                     * Width and height setters that take both the image's physical size
	                     * and the label size into consideration, and translates the image
	                     * to center within the label.
	                     */
	                    each(['width', 'height'], function(key) {
	                        obj[key + 'Setter'] = function(value, key) {
	                            var attribs = {},
	                                imgSize = this['img' + key],
	                                trans = key === 'width' ? 'translateX' : 'translateY';
	                            this[key] = value;
	                            if (defined(imgSize)) {
	                                if (this.element) {
	                                    this.element.setAttribute(key, imgSize);
	                                }
	                                if (!this.alignByTranslate) {
	                                    attribs[trans] = ((this[key] || 0) - imgSize) / 2;
	                                    this.attr(attribs);
	                                }
	                            }
	                        };
	                    });
	
	
	                    if (defined(x)) {
	                        obj.attr({
	                            x: x,
	                            y: y
	                        });
	                    }
	                    obj.isImg = true;
	
	                    if (defined(obj.imgwidth) && defined(obj.imgheight)) {
	                        centerImage();
	                    } else {
	                        // Initialize image to be 0 size so export will still function if there's no cached sizes.
	                        obj.attr({
	                            width: 0,
	                            height: 0
	                        });
	
	                        // Create a dummy JavaScript image to get the width and height. Due to a bug in IE < 8,
	                        // the created element must be assigned to a variable in order to load (#292).
	                        createElement('img', {
	                            onload: function() {
	
	                                var chart = charts[ren.chartIndex];
	
	                                // Special case for SVGs on IE11, the width is not accessible until the image is
	                                // part of the DOM (#2854).
	                                if (this.width === 0) {
	                                    css(this, {
	                                        position: 'absolute',
	                                        top: '-999em'
	                                    });
	                                    doc.body.appendChild(this);
	                                }
	
	                                // Center the image
	                                symbolSizes[imageSrc] = { // Cache for next	
	                                    width: this.width,
	                                    height: this.height
	                                };
	                                obj.imgwidth = this.width;
	                                obj.imgheight = this.height;
	
	                                if (obj.element) {
	                                    centerImage();
	                                }
	
	                                // Clean up after #2854 workaround.
	                                if (this.parentNode) {
	                                    this.parentNode.removeChild(this);
	                                }
	
	                                // Fire the load event when all external images are loaded
	                                ren.imgCount--;
	                                if (!ren.imgCount && chart && chart.onload) {
	                                    chart.onload();
	                                }
	                            },
	                            src: imageSrc
	                        });
	                        this.imgCount++;
	                    }
	                }
	
	                return obj;
	            },
	
	            /**
	             * @typedef {string} Symbol
	             * 
	             * Can be one of `arc`, `callout`, `circle`, `diamond`, `square`,
	             * `triangle`, `triangle-down`. Symbols are used internally for point
	             * markers, button and label borders and backgrounds, or custom shapes.
	             * Extendable by adding to {@link SVGRenderer#symbols}.
	             */
	            /**
	             * An extendable collection of functions for defining symbol paths.
	             */
	            symbols: {
	                'circle': function(x, y, w, h) {
	                    // Return a full arc
	                    return this.arc(x + w / 2, y + h / 2, w / 2, h / 2, {
	                        start: 0,
	                        end: Math.PI * 2,
	                        open: false
	                    });
	                },
	
	                'square': function(x, y, w, h) {
	                    return [
	                        'M', x, y,
	                        'L', x + w, y,
	                        x + w, y + h,
	                        x, y + h,
	                        'Z'
	                    ];
	                },
	
	                'triangle': function(x, y, w, h) {
	                    return [
	                        'M', x + w / 2, y,
	                        'L', x + w, y + h,
	                        x, y + h,
	                        'Z'
	                    ];
	                },
	
	                'triangle-down': function(x, y, w, h) {
	                    return [
	                        'M', x, y,
	                        'L', x + w, y,
	                        x + w / 2, y + h,
	                        'Z'
	                    ];
	                },
	                'diamond': function(x, y, w, h) {
	                    return [
	                        'M', x + w / 2, y,
	                        'L', x + w, y + h / 2,
	                        x + w / 2, y + h,
	                        x, y + h / 2,
	                        'Z'
	                    ];
	                },
	                'arc': function(x, y, w, h, options) {
	                    var start = options.start,
	                        rx = options.r || w,
	                        ry = options.r || h || w,
	                        end = options.end - 0.001, // to prevent cos and sin of start and end from becoming equal on 360 arcs (related: #1561)
	                        innerRadius = options.innerR,
	                        open = options.open,
	                        cosStart = Math.cos(start),
	                        sinStart = Math.sin(start),
	                        cosEnd = Math.cos(end),
	                        sinEnd = Math.sin(end),
	                        longArc = options.end - start < Math.PI ? 0 : 1,
	                        arc;
	
	                    arc = [
	                        'M',
	                        x + rx * cosStart,
	                        y + ry * sinStart,
	                        'A', // arcTo
	                        rx, // x radius
	                        ry, // y radius
	                        0, // slanting
	                        longArc, // long or short arc
	                        1, // clockwise
	                        x + rx * cosEnd,
	                        y + ry * sinEnd
	                    ];
	
	                    if (defined(innerRadius)) {
	                        arc.push(
	                            open ? 'M' : 'L',
	                            x + innerRadius * cosEnd,
	                            y + innerRadius * sinEnd,
	                            'A', // arcTo
	                            innerRadius, // x radius
	                            innerRadius, // y radius
	                            0, // slanting
	                            longArc, // long or short arc
	                            0, // clockwise
	                            x + innerRadius * cosStart,
	                            y + innerRadius * sinStart
	                        );
	                    }
	
	                    arc.push(open ? '' : 'Z'); // close
	                    return arc;
	                },
	
	                /**
	                 * Callout shape used for default tooltips, also used for rounded rectangles in VML
	                 */
	                callout: function(x, y, w, h, options) {
	                    var arrowLength = 6,
	                        halfDistance = 6,
	                        r = Math.min((options && options.r) || 0, w, h),
	                        safeDistance = r + halfDistance,
	                        anchorX = options && options.anchorX,
	                        anchorY = options && options.anchorY,
	                        path;
	
	                    path = [
	                        'M', x + r, y,
	                        'L', x + w - r, y, // top side
	                        'C', x + w, y, x + w, y, x + w, y + r, // top-right corner
	                        'L', x + w, y + h - r, // right side
	                        'C', x + w, y + h, x + w, y + h, x + w - r, y + h, // bottom-right corner
	                        'L', x + r, y + h, // bottom side
	                        'C', x, y + h, x, y + h, x, y + h - r, // bottom-left corner
	                        'L', x, y + r, // left side
	                        'C', x, y, x, y, x + r, y // top-left corner
	                    ];
	
	                    // Anchor on right side
	                    if (anchorX && anchorX > w) {
	
	                        // Chevron
	                        if (anchorY > y + safeDistance && anchorY < y + h - safeDistance) {
	                            path.splice(13, 3,
	                                'L', x + w, anchorY - halfDistance,
	                                x + w + arrowLength, anchorY,
	                                x + w, anchorY + halfDistance,
	                                x + w, y + h - r
	                            );
	
	                            // Simple connector
	                        } else {
	                            path.splice(13, 3,
	                                'L', x + w, h / 2,
	                                anchorX, anchorY,
	                                x + w, h / 2,
	                                x + w, y + h - r
	                            );
	                        }
	
	                        // Anchor on left side
	                    } else if (anchorX && anchorX < 0) {
	
	                        // Chevron
	                        if (anchorY > y + safeDistance && anchorY < y + h - safeDistance) {
	                            path.splice(33, 3,
	                                'L', x, anchorY + halfDistance,
	                                x - arrowLength, anchorY,
	                                x, anchorY - halfDistance,
	                                x, y + r
	                            );
	
	                            // Simple connector
	                        } else {
	                            path.splice(33, 3,
	                                'L', x, h / 2,
	                                anchorX, anchorY,
	                                x, h / 2,
	                                x, y + r
	                            );
	                        }
	
	                    } else if (anchorY && anchorY > h && anchorX > x + safeDistance && anchorX < x + w - safeDistance) { // replace bottom
	                        path.splice(23, 3,
	                            'L', anchorX + halfDistance, y + h,
	                            anchorX, y + h + arrowLength,
	                            anchorX - halfDistance, y + h,
	                            x + r, y + h
	                        );
	                    } else if (anchorY && anchorY < 0 && anchorX > x + safeDistance && anchorX < x + w - safeDistance) { // replace top
	                        path.splice(3, 3,
	                            'L', anchorX - halfDistance, y,
	                            anchorX, y - arrowLength,
	                            anchorX + halfDistance, y,
	                            w - r, y
	                        );
	                    }
	
	                    return path;
	                }
	            },
	
	            /**
	             * @typedef {Highcharts.SVGElement} ClipRect - A clipping rectangle that can be applied
	             * to one or more {@link SVGElement} instances. It is instanciated with the
	             * {@link SVGRenderer#clipRect} function and applied with the {@link 
	             * SVGElement#clip} function.
	             *
	             * @example
	             * var circle = renderer.circle(100, 100, 100)
	             *     .attr({ fill: 'red' })
	             *     .add();
	             * var clipRect = renderer.clipRect(100, 100, 100, 100);
	             *
	             * // Leave only the lower right quarter visible
	             * circle.clip(clipRect);
	             */
	            /**
	             * Define a clipping rectangle
	             * @param {String} id
	             * @param {number} x
	             * @param {number} y
	             * @param {number} width
	             * @param {number} height
	             * @returns {ClipRect} A clipping rectangle.
	             */
	            clipRect: function(x, y, width, height) {
	                var wrapper,
	                    id = H.uniqueKey(),
	
	                    clipPath = this.createElement('clipPath').attr({
	                        id: id
	                    }).add(this.defs);
	
	                wrapper = this.rect(x, y, width, height, 0).add(clipPath);
	                wrapper.id = id;
	                wrapper.clipPath = clipPath;
	                wrapper.count = 0;
	
	                return wrapper;
	            },
	
	
	
	
	
	            /**
	             * Draw text. The text can contain a subset of HTML, like spans and anchors
	             * and some basic text styling of these. For more advanced features like
	             * border and background, use {@link Highcharts.SVGRenderer#label} instead.
	             * To update the text after render, run `text.attr({ text: 'New text' })`.
	             * @param  {String} str
	             *         The text of (subset) HTML to draw.
	             * @param  {number} x
	             *         The x position of the text's lower left corner.
	             * @param  {number} y
	             *         The y position of the text's lower left corner.
	             * @param  {Boolean} [useHTML=false]
	             *         Use HTML to render the text.
	             *
	             * @return {Highcharts.SVGElement} The text object.
	             *
	             * @sample highcharts/members/renderer-text-on-chart/
	             *         Annotate the chart freely
	             * @sample highcharts/members/renderer-on-chart/
	             *         Annotate with a border and in response to the data
	             * @sample highcharts/members/renderer-text/
	             *         Formatted text
	             */
	            text: function(str, x, y, useHTML) {
	
	                // declare variables
	                var renderer = this,
	                    fakeSVG = !svg && renderer.forExport,
	                    wrapper,
	                    attribs = {};
	
	                if (useHTML && (renderer.allowHTML || !renderer.forExport)) {
	                    return renderer.html(str, x, y);
	                }
	
	                attribs.x = Math.round(x || 0); // X is always needed for line-wrap logic
	                if (y) {
	                    attribs.y = Math.round(y);
	                }
	                if (str || str === 0) {
	                    attribs.text = str;
	                }
	
	                wrapper = renderer.createElement('text')
	                    .attr(attribs);
	
	                // Prevent wrapping from creating false offsetWidths in export in legacy IE (#1079, #1063)
	                if (fakeSVG) {
	                    wrapper.css({
	                        position: 'absolute'
	                    });
	                }
	
	                if (!useHTML) {
	                    wrapper.xSetter = function(value, key, element) {
	                        var tspans = element.getElementsByTagName('tspan'),
	                            tspan,
	                            parentVal = element.getAttribute(key),
	                            i;
	                        for (i = 0; i < tspans.length; i++) {
	                            tspan = tspans[i];
	                            // If the x values are equal, the tspan represents a linebreak
	                            if (tspan.getAttribute(key) === parentVal) {
	                                tspan.setAttribute(key, value);
	                            }
	                        }
	                        element.setAttribute(key, value);
	                    };
	                }
	
	                return wrapper;
	            },
	
	            /**
	             * Utility to return the baseline offset and total line height from the font
	             * size.
	             *
	             * @param {?string} fontSize The current font size to inspect. If not given,
	             *   the font size will be found from the DOM element.
	             * @param {SVGElement|SVGDOMElement} [elem] The element to inspect for a
	             *   current font size.
	             * @returns {Object} An object containing `h`: the line height, `b`: the
	             * baseline relative to the top of the box, and `f`: the font size.
	             */
	            fontMetrics: function(fontSize, elem) {
	                var lineHeight,
	                    baseline;
	
	
	                fontSize = fontSize ||
	                    // When the elem is a DOM element (#5932)
	                    (elem && elem.style && elem.style.fontSize) ||
	                    // Fall back on the renderer style default
	                    (this.style && this.style.fontSize);
	
	
	
	                // Handle different units
	                if (/px/.test(fontSize)) {
	                    fontSize = pInt(fontSize);
	                } else if (/em/.test(fontSize)) {
	                    // The em unit depends on parent items
	                    fontSize = parseFloat(fontSize) *
	                        (elem ? this.fontMetrics(null, elem.parentNode).f : 16);
	                } else {
	                    fontSize = 12;
	                }
	
	                // Empirical values found by comparing font size and bounding box
	                // height. Applies to the default font family.
	                // http://jsfiddle.net/highcharts/7xvn7/
	                lineHeight = fontSize < 24 ? fontSize + 3 : Math.round(fontSize * 1.2);
	                baseline = Math.round(lineHeight * 0.8);
	
	                return {
	                    h: lineHeight,
	                    b: baseline,
	                    f: fontSize
	                };
	            },
	
	            /**
	             * Correct X and Y positioning of a label for rotation (#1764)
	             */
	            rotCorr: function(baseline, rotation, alterY) {
	                var y = baseline;
	                if (rotation && alterY) {
	                    y = Math.max(y * Math.cos(rotation * deg2rad), 4);
	                }
	                return {
	                    x: (-baseline / 3) * Math.sin(rotation * deg2rad),
	                    y: y
	                };
	            },
	
	            /**
	             * Draw a label, which is an extended text element with support for border
	             * and background. Highcharts creates a `g` element with a text and a `path`
	             * or `rect` inside, to make it behave somewhat like a HTML div. Border and
	             * background are set through `stroke`, `stroke-width` and `fill` attributes
	             * using the {@link Highcharts.SVGElement#attr|attr} method. To update the
	             * text after render, run `label.attr({ text: 'New text' })`.
	             * 
	             * @param  {string} str
	             *         The initial text string or (subset) HTML to render.
	             * @param  {number} x
	             *         The x position of the label's left side.
	             * @param  {number} y
	             *         The y position of the label's top side or baseline, depending on
	             *         the `baseline` parameter.
	             * @param  {String} shape
	             *         The shape of the label's border/background, if any. Defaults to
	             *         `rect`. Other possible values are `callout` or other shapes
	             *         defined in {@link Highcharts.SVGRenderer#symbols}.
	             * @param  {number} anchorX
	             *         In case the `shape` has a pointer, like a flag, this is the
	             *         coordinates it should be pinned to.
	             * @param  {number} anchorY
	             *         In case the `shape` has a pointer, like a flag, this is the
	             *         coordinates it should be pinned to.
	             * @param  {Boolean} baseline
	             *         Whether to position the label relative to the text baseline,
	             *	       like {@link Highcharts.SVGRenderer#text|renderer.text}, or to the
	             *	       upper border of the rectangle.
	             * @param  {String} className
	             *         Class name for the group.
	             *
	             * @return {Highcharts.SVGElement}
	             *         The generated label.
	             *
	             * @sample highcharts/members/renderer-label-on-chart/
	             *         A label on the chart
	             */
	            label: function(str, x, y, shape, anchorX, anchorY, useHTML, baseline, className) {
	
	                var renderer = this,
	                    wrapper = renderer.g(className !== 'button' && 'label'),
	                    text = wrapper.text = renderer.text('', 0, 0, useHTML)
	                    .attr({
	                        zIndex: 1
	                    }),
	                    box,
	                    bBox,
	                    alignFactor = 0,
	                    padding = 3,
	                    paddingLeft = 0,
	                    width,
	                    height,
	                    wrapperX,
	                    wrapperY,
	                    textAlign,
	                    deferredAttr = {},
	                    strokeWidth,
	                    baselineOffset,
	                    hasBGImage = /^url\((.*?)\)$/.test(shape),
	                    needsBox = hasBGImage,
	                    getCrispAdjust,
	                    updateBoxSize,
	                    updateTextPadding,
	                    boxAttr;
	
	                if (className) {
	                    wrapper.addClass('highcharts-' + className);
	                }
	
	
	                needsBox = hasBGImage;
	                getCrispAdjust = function() {
	                    return (strokeWidth || 0) % 2 / 2;
	                };
	
	
	
	                /**
	                 * This function runs after the label is added to the DOM (when the bounding box is
	                 * available), and after the text of the label is updated to detect the new bounding
	                 * box and reflect it in the border box.
	                 */
	                updateBoxSize = function() {
	                    var style = text.element.style,
	                        crispAdjust,
	                        attribs = {};
	
	                    bBox = (width === undefined || height === undefined || textAlign) && defined(text.textStr) &&
	                        text.getBBox(); //#3295 && 3514 box failure when string equals 0
	                    wrapper.width = (width || bBox.width || 0) + 2 * padding + paddingLeft;
	                    wrapper.height = (height || bBox.height || 0) + 2 * padding;
	
	                    // Update the label-scoped y offset
	                    baselineOffset = padding + renderer.fontMetrics(style && style.fontSize, text).b;
	
	
	                    if (needsBox) {
	
	                        // Create the border box if it is not already present
	                        if (!box) {
	                            wrapper.box = box = renderer.symbols[shape] || hasBGImage ? // Symbol definition exists (#5324)
	                                renderer.symbol(shape) :
	                                renderer.rect();
	
	                            box.addClass(
	                                (className === 'button' ? '' : 'highcharts-label-box') + // Don't use label className for buttons
	                                (className ? ' highcharts-' + className + '-box' : '')
	                            );
	
	                            box.add(wrapper);
	
	                            crispAdjust = getCrispAdjust();
	                            attribs.x = crispAdjust;
	                            attribs.y = (baseline ? -baselineOffset : 0) + crispAdjust;
	                        }
	
	                        // Apply the box attributes
	                        attribs.width = Math.round(wrapper.width);
	                        attribs.height = Math.round(wrapper.height);
	
	                        box.attr(extend(attribs, deferredAttr));
	                        deferredAttr = {};
	                    }
	                };
	
	                /**
	                 * This function runs after setting text or padding, but only if padding is changed
	                 */
	                updateTextPadding = function() {
	                    var textX = paddingLeft + padding,
	                        textY;
	
	                    // determin y based on the baseline
	                    textY = baseline ? 0 : baselineOffset;
	
	                    // compensate for alignment
	                    if (defined(width) && bBox && (textAlign === 'center' || textAlign === 'right')) {
	                        textX += {
	                            center: 0.5,
	                            right: 1
	                        }[textAlign] * (width - bBox.width);
	                    }
	
	                    // update if anything changed
	                    if (textX !== text.x || textY !== text.y) {
	                        text.attr('x', textX);
	                        if (textY !== undefined) {
	                            text.attr('y', textY);
	                        }
	                    }
	
	                    // record current values
	                    text.x = textX;
	                    text.y = textY;
	                };
	
	                /**
	                 * Set a box attribute, or defer it if the box is not yet created
	                 * @param {Object} key
	                 * @param {Object} value
	                 */
	                boxAttr = function(key, value) {
	                    if (box) {
	                        box.attr(key, value);
	                    } else {
	                        deferredAttr[key] = value;
	                    }
	                };
	
	                /**
	                 * After the text element is added, get the desired size of the border box
	                 * and add it before the text in the DOM.
	                 */
	                wrapper.onAdd = function() {
	                    text.add(wrapper);
	                    wrapper.attr({
	                        text: (str || str === 0) ? str : '', // alignment is available now // #3295: 0 not rendered if given as a value
	                        x: x,
	                        y: y
	                    });
	
	                    if (box && defined(anchorX)) {
	                        wrapper.attr({
	                            anchorX: anchorX,
	                            anchorY: anchorY
	                        });
	                    }
	                };
	
	                /*
	                 * Add specific attribute setters.
	                 */
	
	                // only change local variables
	                wrapper.widthSetter = function(value) {
	                    width = H.isNumber(value) ? value : null; // width:auto => null
	                };
	                wrapper.heightSetter = function(value) {
	                    height = value;
	                };
	                wrapper['text-alignSetter'] = function(value) {
	                    textAlign = value;
	                };
	                wrapper.paddingSetter = function(value) {
	                    if (defined(value) && value !== padding) {
	                        padding = wrapper.padding = value;
	                        updateTextPadding();
	                    }
	                };
	                wrapper.paddingLeftSetter = function(value) {
	                    if (defined(value) && value !== paddingLeft) {
	                        paddingLeft = value;
	                        updateTextPadding();
	                    }
	                };
	
	
	                // change local variable and prevent setting attribute on the group
	                wrapper.alignSetter = function(value) {
	                    value = {
	                        left: 0,
	                        center: 0.5,
	                        right: 1
	                    }[value];
	                    if (value !== alignFactor) {
	                        alignFactor = value;
	                        if (bBox) { // Bounding box exists, means we're dynamically changing
	                            wrapper.attr({
	                                x: wrapperX
	                            }); // #5134
	                        }
	                    }
	                };
	
	                // apply these to the box and the text alike
	                wrapper.textSetter = function(value) {
	                    if (value !== undefined) {
	                        text.textSetter(value);
	                    }
	                    updateBoxSize();
	                    updateTextPadding();
	                };
	
	                // apply these to the box but not to the text
	                wrapper['stroke-widthSetter'] = function(value, key) {
	                    if (value) {
	                        needsBox = true;
	                    }
	                    strokeWidth = this['stroke-width'] = value;
	                    boxAttr(key, value);
	                };
	
	                wrapper.strokeSetter = wrapper.fillSetter = wrapper.rSetter = function(value, key) {
	                    if (key === 'fill' && value) {
	                        needsBox = true;
	                    }
	                    boxAttr(key, value);
	                };
	
	                wrapper.anchorXSetter = function(value, key) {
	                    anchorX = wrapper.anchorX = value;
	                    boxAttr(key, Math.round(value) - getCrispAdjust() - wrapperX);
	                };
	                wrapper.anchorYSetter = function(value, key) {
	                    anchorY = wrapper.anchorY = value;
	                    boxAttr(key, value - wrapperY);
	                };
	
	                // rename attributes
	                wrapper.xSetter = function(value) {
	                    wrapper.x = value; // for animation getter
	                    if (alignFactor) {
	                        value -= alignFactor * ((width || bBox.width) + 2 * padding);
	                    }
	                    wrapperX = Math.round(value);
	                    wrapper.attr('translateX', wrapperX);
	                };
	                wrapper.ySetter = function(value) {
	                    wrapperY = wrapper.y = Math.round(value);
	                    wrapper.attr('translateY', wrapperY);
	                };
	
	                // Redirect certain methods to either the box or the text
	                var baseCss = wrapper.css;
	                return extend(wrapper, {
	                    /**
	                     * Pick up some properties and apply them to the text instead of the
	                     * wrapper.
	                     * @ignore
	                     */
	                    css: function(styles) {
	                        if (styles) {
	                            var textStyles = {};
	                            styles = merge(styles); // create a copy to avoid altering the original object (#537)
	                            each(wrapper.textProps, function(prop) {
	                                if (styles[prop] !== undefined) {
	                                    textStyles[prop] = styles[prop];
	                                    delete styles[prop];
	                                }
	                            });
	                            text.css(textStyles);
	                        }
	                        return baseCss.call(wrapper, styles);
	                    },
	                    /**
	                     * Return the bounding box of the box, not the group.
	                     * @ignore
	                     */
	                    getBBox: function() {
	                        return {
	                            width: bBox.width + 2 * padding,
	                            height: bBox.height + 2 * padding,
	                            x: bBox.x - padding,
	                            y: bBox.y - padding
	                        };
	                    },
	
	                    /**
	                     * Apply the shadow to the box.
	                     * @ignore
	                     */
	                    shadow: function(b) {
	                        if (b) {
	                            updateBoxSize();
	                            if (box) {
	                                box.shadow(b);
	                            }
	                        }
	                        return wrapper;
	                    },
	
	                    /**
	                     * Destroy and release memory.
	                     * @ignore
	                     */
	                    destroy: function() {
	
	                        // Added by button implementation
	                        removeEvent(wrapper.element, 'mouseenter');
	                        removeEvent(wrapper.element, 'mouseleave');
	
	                        if (text) {
	                            text = text.destroy();
	                        }
	                        if (box) {
	                            box = box.destroy();
	                        }
	                        // Call base implementation to destroy the rest
	                        SVGElement.prototype.destroy.call(wrapper);
	
	                        // Release local pointers (#1298)
	                        wrapper = renderer = updateBoxSize = updateTextPadding = boxAttr = null;
	                    }
	                });
	            }
	        }); // end SVGRenderer
	
	
	        // general renderer
	        H.Renderer = SVGRenderer;
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var attr = H.attr,
	            createElement = H.createElement,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            isFirefox = H.isFirefox,
	            isMS = H.isMS,
	            isWebKit = H.isWebKit,
	            pInt = H.pInt,
	            SVGElement = H.SVGElement,
	            SVGRenderer = H.SVGRenderer,
	            win = H.win,
	            wrap = H.wrap;
	
	        // Extend SvgElement for useHTML option
	        extend(SVGElement.prototype, /** @lends SVGElement.prototype */ {
	            /**
	             * Apply CSS to HTML elements. This is used in text within SVG rendering and
	             * by the VML renderer
	             */
	            htmlCss: function(styles) {
	                var wrapper = this,
	                    element = wrapper.element,
	                    textWidth = styles && element.tagName === 'SPAN' && styles.width;
	
	                if (textWidth) {
	                    delete styles.width;
	                    wrapper.textWidth = textWidth;
	                    wrapper.updateTransform();
	                }
	                if (styles && styles.textOverflow === 'ellipsis') {
	                    styles.whiteSpace = 'nowrap';
	                    styles.overflow = 'hidden';
	                }
	                wrapper.styles = extend(wrapper.styles, styles);
	                css(wrapper.element, styles);
	
	                return wrapper;
	            },
	
	            /**
	             * VML and useHTML method for calculating the bounding box based on offsets
	             * @param {Boolean} refresh Whether to force a fresh value from the DOM or to
	             * use the cached value
	             *
	             * @return {Object} A hash containing values for x, y, width and height
	             */
	
	            htmlGetBBox: function() {
	                var wrapper = this,
	                    element = wrapper.element;
	
	                // faking getBBox in exported SVG in legacy IE
	                // faking getBBox in exported SVG in legacy IE (is this a duplicate of the fix for #1079?)
	                if (element.nodeName === 'text') {
	                    element.style.position = 'absolute';
	                }
	
	                return {
	                    x: element.offsetLeft,
	                    y: element.offsetTop,
	                    width: element.offsetWidth,
	                    height: element.offsetHeight
	                };
	            },
	
	            /**
	             * VML override private method to update elements based on internal
	             * properties based on SVG transform
	             */
	            htmlUpdateTransform: function() {
	                // aligning non added elements is expensive
	                if (!this.added) {
	                    this.alignOnAdd = true;
	                    return;
	                }
	
	                var wrapper = this,
	                    renderer = wrapper.renderer,
	                    elem = wrapper.element,
	                    translateX = wrapper.translateX || 0,
	                    translateY = wrapper.translateY || 0,
	                    x = wrapper.x || 0,
	                    y = wrapper.y || 0,
	                    align = wrapper.textAlign || 'left',
	                    alignCorrection = {
	                        left: 0,
	                        center: 0.5,
	                        right: 1
	                    }[align],
	                    styles = wrapper.styles;
	
	                // apply translate
	                css(elem, {
	                    marginLeft: translateX,
	                    marginTop: translateY
	                });
	
	
	                if (wrapper.shadows) { // used in labels/tooltip
	                    each(wrapper.shadows, function(shadow) {
	                        css(shadow, {
	                            marginLeft: translateX + 1,
	                            marginTop: translateY + 1
	                        });
	                    });
	                }
	
	
	                // apply inversion
	                if (wrapper.inverted) { // wrapper is a group
	                    each(elem.childNodes, function(child) {
	                        renderer.invertChild(child, elem);
	                    });
	                }
	
	                if (elem.tagName === 'SPAN') {
	
	                    var rotation = wrapper.rotation,
	                        baseline,
	                        textWidth = pInt(wrapper.textWidth),
	                        whiteSpace = styles && styles.whiteSpace,
	                        currentTextTransform = [rotation, align, elem.innerHTML, wrapper.textWidth, wrapper.textAlign].join(',');
	
	                    if (currentTextTransform !== wrapper.cTT) { // do the calculations and DOM access only if properties changed
	
	
	                        baseline = renderer.fontMetrics(elem.style.fontSize).b;
	
	                        // Renderer specific handling of span rotation
	                        if (defined(rotation)) {
	                            wrapper.setSpanRotation(rotation, alignCorrection, baseline);
	                        }
	
	                        // Reset multiline/ellipsis in order to read width (#4928, #5417)
	                        css(elem, {
	                            width: '',
	                            whiteSpace: whiteSpace || 'nowrap'
	                        });
	
	                        // Update textWidth
	                        if (elem.offsetWidth > textWidth && /[ \-]/.test(elem.textContent || elem.innerText)) { // #983, #1254
	                            css(elem, {
	                                width: textWidth + 'px',
	                                display: 'block',
	                                whiteSpace: whiteSpace || 'normal' // #3331
	                            });
	                        }
	
	
	                        wrapper.getSpanCorrection(elem.offsetWidth, baseline, alignCorrection, rotation, align);
	                    }
	
	                    // apply position with correction
	                    css(elem, {
	                        left: (x + (wrapper.xCorr || 0)) + 'px',
	                        top: (y + (wrapper.yCorr || 0)) + 'px'
	                    });
	
	                    // force reflow in webkit to apply the left and top on useHTML element (#1249)
	                    if (isWebKit) {
	                        baseline = elem.offsetHeight; // assigned to baseline for lint purpose
	                    }
	
	                    // record current text transform
	                    wrapper.cTT = currentTextTransform;
	                }
	            },
	
	            /**
	             * Set the rotation of an individual HTML span
	             */
	            setSpanRotation: function(rotation, alignCorrection, baseline) {
	                var rotationStyle = {},
	                    cssTransformKey = isMS ? '-ms-transform' : isWebKit ? '-webkit-transform' : isFirefox ? 'MozTransform' : win.opera ? '-o-transform' : '';
	
	                rotationStyle[cssTransformKey] = rotationStyle.transform = 'rotate(' + rotation + 'deg)';
	                rotationStyle[cssTransformKey + (isFirefox ? 'Origin' : '-origin')] = rotationStyle.transformOrigin = (alignCorrection * 100) + '% ' + baseline + 'px';
	                css(this.element, rotationStyle);
	            },
	
	            /**
	             * Get the correction in X and Y positioning as the element is rotated.
	             */
	            getSpanCorrection: function(width, baseline, alignCorrection) {
	                this.xCorr = -width * alignCorrection;
	                this.yCorr = -baseline;
	            }
	        });
	
	        // Extend SvgRenderer for useHTML option.
	        extend(SVGRenderer.prototype, /** @lends SVGRenderer.prototype */ {
	            /**
	             * Create HTML text node. This is used by the VML renderer as well as the SVG
	             * renderer through the useHTML option.
	             *
	             * @param {String} str
	             * @param {Number} x
	             * @param {Number} y
	             */
	            html: function(str, x, y) {
	                var wrapper = this.createElement('span'),
	                    element = wrapper.element,
	                    renderer = wrapper.renderer,
	                    isSVG = renderer.isSVG,
	                    addSetters = function(element, style) {
	                        // These properties are set as attributes on the SVG group, and as
	                        // identical CSS properties on the div. (#3542)
	                        each(['opacity', 'visibility'], function(prop) {
	                            wrap(element, prop + 'Setter', function(proceed, value, key, elem) {
	                                proceed.call(this, value, key, elem);
	                                style[key] = value;
	                            });
	                        });
	                    };
	
	                // Text setter
	                wrapper.textSetter = function(value) {
	                    if (value !== element.innerHTML) {
	                        delete this.bBox;
	                    }
	                    element.innerHTML = this.textStr = value;
	                    wrapper.htmlUpdateTransform();
	                };
	
	                // Add setters for the element itself (#4938)
	                if (isSVG) { // #4938, only for HTML within SVG
	                    addSetters(wrapper, wrapper.element.style);
	                }
	
	                // Various setters which rely on update transform
	                wrapper.xSetter = wrapper.ySetter = wrapper.alignSetter = wrapper.rotationSetter = function(value, key) {
	                    if (key === 'align') {
	                        key = 'textAlign'; // Do not overwrite the SVGElement.align method. Same as VML.
	                    }
	                    wrapper[key] = value;
	                    wrapper.htmlUpdateTransform();
	                };
	
	                // Set the default attributes
	                wrapper
	                    .attr({
	                        text: str,
	                        x: Math.round(x),
	                        y: Math.round(y)
	                    })
	                    .css({
	
	                        fontFamily: this.style.fontFamily,
	                        fontSize: this.style.fontSize,
	
	                        position: 'absolute'
	                    });
	
	                // Keep the whiteSpace style outside the wrapper.styles collection
	                element.style.whiteSpace = 'nowrap';
	
	                // Use the HTML specific .css method
	                wrapper.css = wrapper.htmlCss;
	
	                // This is specific for HTML within SVG
	                if (isSVG) {
	                    wrapper.add = function(svgGroupWrapper) {
	
	                        var htmlGroup,
	                            container = renderer.box.parentNode,
	                            parentGroup,
	                            parents = [];
	
	                        this.parentGroup = svgGroupWrapper;
	
	                        // Create a mock group to hold the HTML elements
	                        if (svgGroupWrapper) {
	                            htmlGroup = svgGroupWrapper.div;
	                            if (!htmlGroup) {
	
	                                // Read the parent chain into an array and read from top down
	                                parentGroup = svgGroupWrapper;
	                                while (parentGroup) {
	
	                                    parents.push(parentGroup);
	
	                                    // Move up to the next parent group
	                                    parentGroup = parentGroup.parentGroup;
	                                }
	
	                                // Ensure dynamically updating position when any parent is translated
	                                each(parents.reverse(), function(parentGroup) {
	                                    var htmlGroupStyle,
	                                        cls = attr(parentGroup.element, 'class');
	
	                                    if (cls) {
	                                        cls = {
	                                            className: cls
	                                        };
	                                    } // else null
	
	                                    // Create a HTML div and append it to the parent div to emulate
	                                    // the SVG group structure
	                                    htmlGroup = parentGroup.div = parentGroup.div || createElement('div', cls, {
	                                        position: 'absolute',
	                                        left: (parentGroup.translateX || 0) + 'px',
	                                        top: (parentGroup.translateY || 0) + 'px',
	                                        display: parentGroup.display,
	                                        opacity: parentGroup.opacity, // #5075
	                                        pointerEvents: parentGroup.styles && parentGroup.styles.pointerEvents // #5595
	                                    }, htmlGroup || container); // the top group is appended to container
	
	                                    // Shortcut
	                                    htmlGroupStyle = htmlGroup.style;
	
	                                    // Set listeners to update the HTML div's position whenever the SVG group
	                                    // position is changed
	                                    extend(parentGroup, {
	                                        on: function() {
	                                            wrapper.on.apply({
	                                                element: parents[0].div
	                                            }, arguments);
	                                            return parentGroup;
	                                        },
	                                        translateXSetter: function(value, key) {
	                                            htmlGroupStyle.left = value + 'px';
	                                            parentGroup[key] = value;
	                                            parentGroup.doTransform = true;
	                                        },
	                                        translateYSetter: function(value, key) {
	                                            htmlGroupStyle.top = value + 'px';
	                                            parentGroup[key] = value;
	                                            parentGroup.doTransform = true;
	                                        }
	                                    });
	                                    addSetters(parentGroup, htmlGroupStyle);
	                                });
	
	                            }
	                        } else {
	                            htmlGroup = container;
	                        }
	
	                        htmlGroup.appendChild(element);
	
	                        // Shared with VML:
	                        wrapper.added = true;
	                        if (wrapper.alignOnAdd) {
	                            wrapper.htmlUpdateTransform();
	                        }
	
	                        return wrapper;
	                    };
	                }
	                return wrapper;
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var VMLRenderer,
	            VMLRendererExtension,
	            VMLElement,
	
	            createElement = H.createElement,
	            css = H.css,
	            defined = H.defined,
	            deg2rad = H.deg2rad,
	            discardElement = H.discardElement,
	            doc = H.doc,
	            each = H.each,
	            erase = H.erase,
	            extend = H.extend,
	            extendClass = H.extendClass,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            merge = H.merge,
	            noop = H.noop,
	            pick = H.pick,
	            pInt = H.pInt,
	            svg = H.svg,
	            SVGElement = H.SVGElement,
	            SVGRenderer = H.SVGRenderer,
	            win = H.win;
	
	        /* ****************************************************************************
	         *                                                                            *
	         * START OF INTERNET EXPLORER <= 8 SPECIFIC CODE                              *
	         *                                                                            *
	         * For applications and websites that don't need IE support, like platform    *
	         * targeted mobile apps and web apps, this code can be removed.               *
	         *                                                                            *
	         *****************************************************************************/
	
	        /**
	         * @constructor
	         */
	        if (!svg) {
	
	            /**
	             * The VML element wrapper.
	             */
	            VMLElement = {
	
	                docMode8: doc && doc.documentMode === 8,
	
	                /**
	                 * Initialize a new VML element wrapper. It builds the markup as a string
	                 * to minimize DOM traffic.
	                 * @param {Object} renderer
	                 * @param {Object} nodeName
	                 */
	                init: function(renderer, nodeName) {
	                    var wrapper = this,
	                        markup = ['<', nodeName, ' filled="f" stroked="f"'],
	                        style = ['position: ', 'absolute', ';'],
	                        isDiv = nodeName === 'div';
	
	                    // divs and shapes need size
	                    if (nodeName === 'shape' || isDiv) {
	                        style.push('left:0;top:0;width:1px;height:1px;');
	                    }
	                    style.push('visibility: ', isDiv ? 'hidden' : 'visible');
	
	                    markup.push(' style="', style.join(''), '"/>');
	
	                    // create element with default attributes and style
	                    if (nodeName) {
	                        markup = isDiv || nodeName === 'span' || nodeName === 'img' ?
	                            markup.join('') :
	                            renderer.prepVML(markup);
	                        wrapper.element = createElement(markup);
	                    }
	
	                    wrapper.renderer = renderer;
	                },
	
	                /**
	                 * Add the node to the given parent
	                 * @param {Object} parent
	                 */
	                add: function(parent) {
	                    var wrapper = this,
	                        renderer = wrapper.renderer,
	                        element = wrapper.element,
	                        box = renderer.box,
	                        inverted = parent && parent.inverted,
	
	                        // get the parent node
	                        parentNode = parent ?
	                        parent.element || parent :
	                        box;
	
	                    if (parent) {
	                        this.parentGroup = parent;
	                    }
	
	                    // if the parent group is inverted, apply inversion on all children
	                    if (inverted) { // only on groups
	                        renderer.invertChild(element, parentNode);
	                    }
	
	                    // append it
	                    parentNode.appendChild(element);
	
	                    // align text after adding to be able to read offset
	                    wrapper.added = true;
	                    if (wrapper.alignOnAdd && !wrapper.deferUpdateTransform) {
	                        wrapper.updateTransform();
	                    }
	
	                    // fire an event for internal hooks
	                    if (wrapper.onAdd) {
	                        wrapper.onAdd();
	                    }
	
	                    // IE8 Standards can't set the class name before the element is appended
	                    if (this.className) {
	                        this.attr('class', this.className);
	                    }
	
	                    return wrapper;
	                },
	
	                /**
	                 * VML always uses htmlUpdateTransform
	                 */
	                updateTransform: SVGElement.prototype.htmlUpdateTransform,
	
	                /**
	                 * Set the rotation of a span with oldIE's filter
	                 */
	                setSpanRotation: function() {
	                    // Adjust for alignment and rotation. Rotation of useHTML content is not yet implemented
	                    // but it can probably be implemented for Firefox 3.5+ on user request. FF3.5+
	                    // has support for CSS3 transform. The getBBox method also needs to be updated
	                    // to compensate for the rotation, like it currently does for SVG.
	                    // Test case: http://jsfiddle.net/highcharts/Ybt44/
	
	                    var rotation = this.rotation,
	                        costheta = Math.cos(rotation * deg2rad),
	                        sintheta = Math.sin(rotation * deg2rad);
	
	                    css(this.element, {
	                        filter: rotation ? ['progid:DXImageTransform.Microsoft.Matrix(M11=', costheta,
	                            ', M12=', -sintheta, ', M21=', sintheta, ', M22=', costheta,
	                            ', sizingMethod=\'auto expand\')'
	                        ].join('') : 'none'
	                    });
	                },
	
	                /**
	                 * Get the positioning correction for the span after rotating.
	                 */
	                getSpanCorrection: function(width, baseline, alignCorrection, rotation, align) {
	
	                    var costheta = rotation ? Math.cos(rotation * deg2rad) : 1,
	                        sintheta = rotation ? Math.sin(rotation * deg2rad) : 0,
	                        height = pick(this.elemHeight, this.element.offsetHeight),
	                        quad,
	                        nonLeft = align && align !== 'left';
	
	                    // correct x and y
	                    this.xCorr = costheta < 0 && -width;
	                    this.yCorr = sintheta < 0 && -height;
	
	                    // correct for baseline and corners spilling out after rotation
	                    quad = costheta * sintheta < 0;
	                    this.xCorr += sintheta * baseline * (quad ? 1 - alignCorrection : alignCorrection);
	                    this.yCorr -= costheta * baseline * (rotation ? (quad ? alignCorrection : 1 - alignCorrection) : 1);
	                    // correct for the length/height of the text
	                    if (nonLeft) {
	                        this.xCorr -= width * alignCorrection * (costheta < 0 ? -1 : 1);
	                        if (rotation) {
	                            this.yCorr -= height * alignCorrection * (sintheta < 0 ? -1 : 1);
	                        }
	                        css(this.element, {
	                            textAlign: align
	                        });
	                    }
	                },
	
	                /**
	                 * Converts a subset of an SVG path definition to its VML counterpart. Takes an array
	                 * as the parameter and returns a string.
	                 */
	                pathToVML: function(value) {
	                    // convert paths
	                    var i = value.length,
	                        path = [];
	
	                    while (i--) {
	
	                        // Multiply by 10 to allow subpixel precision.
	                        // Substracting half a pixel seems to make the coordinates
	                        // align with SVG, but this hasn't been tested thoroughly
	                        if (isNumber(value[i])) {
	                            path[i] = Math.round(value[i] * 10) - 5;
	                        } else if (value[i] === 'Z') { // close the path
	                            path[i] = 'x';
	                        } else {
	                            path[i] = value[i];
	
	                            // When the start X and end X coordinates of an arc are too close,
	                            // they are rounded to the same value above. In this case, substract or
	                            // add 1 from the end X and Y positions. #186, #760, #1371, #1410.
	                            if (value.isArc && (value[i] === 'wa' || value[i] === 'at')) {
	                                // Start and end X
	                                if (path[i + 5] === path[i + 7]) {
	                                    path[i + 7] += value[i + 7] > value[i + 5] ? 1 : -1;
	                                }
	                                // Start and end Y
	                                if (path[i + 6] === path[i + 8]) {
	                                    path[i + 8] += value[i + 8] > value[i + 6] ? 1 : -1;
	                                }
	                            }
	                        }
	                    }
	
	
	                    // Loop up again to handle path shortcuts (#2132)
	                    /*while (i++ < path.length) {
	                    	if (path[i] === 'H') { // horizontal line to
	                    		path[i] = 'L';
	                    		path.splice(i + 2, 0, path[i - 1]);
	                    	} else if (path[i] === 'V') { // vertical line to
	                    		path[i] = 'L';
	                    		path.splice(i + 1, 0, path[i - 2]);
	                    	}
	                    }*/
	                    return path.join(' ') || 'x';
	                },
	
	                /**
	                 * Set the element's clipping to a predefined rectangle
	                 *
	                 * @param {String} id The id of the clip rectangle
	                 */
	                clip: function(clipRect) {
	                    var wrapper = this,
	                        clipMembers,
	                        cssRet;
	
	                    if (clipRect) {
	                        clipMembers = clipRect.members;
	                        erase(clipMembers, wrapper); // Ensure unique list of elements (#1258)
	                        clipMembers.push(wrapper);
	                        wrapper.destroyClip = function() {
	                            erase(clipMembers, wrapper);
	                        };
	                        cssRet = clipRect.getCSS(wrapper);
	
	                    } else {
	                        if (wrapper.destroyClip) {
	                            wrapper.destroyClip();
	                        }
	                        cssRet = {
	                            clip: wrapper.docMode8 ? 'inherit' : 'rect(auto)'
	                        }; // #1214
	                    }
	
	                    return wrapper.css(cssRet);
	
	                },
	
	                /**
	                 * Set styles for the element
	                 * @param {Object} styles
	                 */
	                css: SVGElement.prototype.htmlCss,
	
	                /**
	                 * Removes a child either by removeChild or move to garbageBin.
	                 * Issue 490; in VML removeChild results in Orphaned nodes according to sIEve, discardElement does not.
	                 */
	                safeRemoveChild: function(element) {
	                    // discardElement will detach the node from its parent before attaching it
	                    // to the garbage bin. Therefore it is important that the node is attached and have parent.
	                    if (element.parentNode) {
	                        discardElement(element);
	                    }
	                },
	
	                /**
	                 * Extend element.destroy by removing it from the clip members array
	                 */
	                destroy: function() {
	                    if (this.destroyClip) {
	                        this.destroyClip();
	                    }
	
	                    return SVGElement.prototype.destroy.apply(this);
	                },
	
	                /**
	                 * Add an event listener. VML override for normalizing event parameters.
	                 * @param {String} eventType
	                 * @param {Function} handler
	                 */
	                on: function(eventType, handler) {
	                    // simplest possible event model for internal use
	                    this.element['on' + eventType] = function() {
	                        var evt = win.event;
	                        evt.target = evt.srcElement;
	                        handler(evt);
	                    };
	                    return this;
	                },
	
	                /**
	                 * In stacked columns, cut off the shadows so that they don't overlap
	                 */
	                cutOffPath: function(path, length) {
	
	                    var len;
	
	                    path = path.split(/[ ,]/); // The extra comma tricks the trailing comma remover in "gulp scripts" task
	                    len = path.length;
	
	                    if (len === 9 || len === 11) {
	                        path[len - 4] = path[len - 2] = pInt(path[len - 2]) - 10 * length;
	                    }
	                    return path.join(' ');
	                },
	
	                /**
	                 * Apply a drop shadow by copying elements and giving them different strokes
	                 * @param {Boolean|Object} shadowOptions
	                 */
	                shadow: function(shadowOptions, group, cutOff) {
	                    var shadows = [],
	                        i,
	                        element = this.element,
	                        renderer = this.renderer,
	                        shadow,
	                        elemStyle = element.style,
	                        markup,
	                        path = element.path,
	                        strokeWidth,
	                        modifiedPath,
	                        shadowWidth,
	                        shadowElementOpacity;
	
	                    // some times empty paths are not strings
	                    if (path && typeof path.value !== 'string') {
	                        path = 'x';
	                    }
	                    modifiedPath = path;
	
	                    if (shadowOptions) {
	                        shadowWidth = pick(shadowOptions.width, 3);
	                        shadowElementOpacity = (shadowOptions.opacity || 0.15) / shadowWidth;
	                        for (i = 1; i <= 3; i++) {
	
	                            strokeWidth = (shadowWidth * 2) + 1 - (2 * i);
	
	                            // Cut off shadows for stacked column items
	                            if (cutOff) {
	                                modifiedPath = this.cutOffPath(path.value, strokeWidth + 0.5);
	                            }
	
	                            markup = ['<shape isShadow="true" strokeweight="', strokeWidth,
	                                '" filled="false" path="', modifiedPath,
	                                '" coordsize="10 10" style="', element.style.cssText, '" />'
	                            ];
	
	                            shadow = createElement(renderer.prepVML(markup),
	                                null, {
	                                    left: pInt(elemStyle.left) + pick(shadowOptions.offsetX, 1),
	                                    top: pInt(elemStyle.top) + pick(shadowOptions.offsetY, 1)
	                                }
	                            );
	                            if (cutOff) {
	                                shadow.cutOff = strokeWidth + 1;
	                            }
	
	                            // apply the opacity
	                            markup = [
	                                '<stroke color="',
	                                shadowOptions.color || '#000000',
	                                '" opacity="', shadowElementOpacity * i, '"/>'
	                            ];
	                            createElement(renderer.prepVML(markup), null, null, shadow);
	
	
	                            // insert it
	                            if (group) {
	                                group.element.appendChild(shadow);
	                            } else {
	                                element.parentNode.insertBefore(shadow, element);
	                            }
	
	                            // record it
	                            shadows.push(shadow);
	
	                        }
	
	                        this.shadows = shadows;
	                    }
	                    return this;
	                },
	                updateShadows: noop, // Used in SVG only
	
	                setAttr: function(key, value) {
	                    if (this.docMode8) { // IE8 setAttribute bug
	                        this.element[key] = value;
	                    } else {
	                        this.element.setAttribute(key, value);
	                    }
	                },
	                classSetter: function(value) {
	                    // IE8 Standards mode has problems retrieving the className unless set like this.
	                    // IE8 Standards can't set the class name before the element is appended.
	                    (this.added ? this.element : this).className = value;
	                },
	                dashstyleSetter: function(value, key, element) {
	                    var strokeElem = element.getElementsByTagName('stroke')[0] ||
	                        createElement(this.renderer.prepVML(['<stroke/>']), null, null, element);
	                    strokeElem[key] = value || 'solid';
	                    this[key] = value;
	                    /* because changing stroke-width will change the dash length
					and cause an epileptic effect */
	                },
	                dSetter: function(value, key, element) {
	                    var i,
	                        shadows = this.shadows;
	                    value = value || [];
	                    this.d = value.join && value.join(' '); // used in getter for animation
	
	                    element.path = value = this.pathToVML(value);
	
	                    // update shadows
	                    if (shadows) {
	                        i = shadows.length;
	                        while (i--) {
	                            shadows[i].path = shadows[i].cutOff ? this.cutOffPath(value, shadows[i].cutOff) : value;
	                        }
	                    }
	                    this.setAttr(key, value);
	                },
	                fillSetter: function(value, key, element) {
	                    var nodeName = element.nodeName;
	                    if (nodeName === 'SPAN') { // text color
	                        element.style.color = value;
	                    } else if (nodeName !== 'IMG') { // #1336
	                        element.filled = value !== 'none';
	                        this.setAttr('fillcolor', this.renderer.color(value, element, key, this));
	                    }
	                },
	                'fill-opacitySetter': function(value, key, element) {
	                    createElement(
	                        this.renderer.prepVML(['<', key.split('-')[0], ' opacity="', value, '"/>']),
	                        null,
	                        null,
	                        element
	                    );
	                },
	                opacitySetter: noop, // Don't bother - animation is too slow and filters introduce artifacts
	                rotationSetter: function(value, key, element) {
	                    var style = element.style;
	                    this[key] = style[key] = value; // style is for #1873
	
	                    // Correction for the 1x1 size of the shape container. Used in gauge needles.
	                    style.left = -Math.round(Math.sin(value * deg2rad) + 1) + 'px';
	                    style.top = Math.round(Math.cos(value * deg2rad)) + 'px';
	                },
	                strokeSetter: function(value, key, element) {
	                    this.setAttr('strokecolor', this.renderer.color(value, element, key, this));
	                },
	                'stroke-widthSetter': function(value, key, element) {
	                    element.stroked = !!value; // VML "stroked" attribute
	                    this[key] = value; // used in getter, issue #113
	                    if (isNumber(value)) {
	                        value += 'px';
	                    }
	                    this.setAttr('strokeweight', value);
	                },
	                titleSetter: function(value, key) {
	                    this.setAttr(key, value);
	                },
	                visibilitySetter: function(value, key, element) {
	
	                    // Handle inherited visibility
	                    if (value === 'inherit') {
	                        value = 'visible';
	                    }
	
	                    // Let the shadow follow the main element
	                    if (this.shadows) {
	                        each(this.shadows, function(shadow) {
	                            shadow.style[key] = value;
	                        });
	                    }
	
	                    // Instead of toggling the visibility CSS property, move the div out of the viewport.
	                    // This works around #61 and #586
	                    if (element.nodeName === 'DIV') {
	                        value = value === 'hidden' ? '-999em' : 0;
	
	                        // In order to redraw, IE7 needs the div to be visible when tucked away
	                        // outside the viewport. So the visibility is actually opposite of
	                        // the expected value. This applies to the tooltip only.
	                        if (!this.docMode8) {
	                            element.style[key] = value ? 'visible' : 'hidden';
	                        }
	                        key = 'top';
	                    }
	                    element.style[key] = value;
	                },
	                xSetter: function(value, key, element) {
	                    this[key] = value; // used in getter
	
	                    if (key === 'x') {
	                        key = 'left';
	                    } else if (key === 'y') {
	                        key = 'top';
	                    }
	                    /* else {
	                    				value = Math.max(0, value); // don't set width or height below zero (#311)
	                    			}*/
	
	                    // clipping rectangle special
	                    if (this.updateClipping) {
	                        this[key] = value; // the key is now 'left' or 'top' for 'x' and 'y'
	                        this.updateClipping();
	                    } else {
	                        // normal
	                        element.style[key] = value;
	                    }
	                },
	                zIndexSetter: function(value, key, element) {
	                    element.style[key] = value;
	                }
	            };
	            VMLElement['stroke-opacitySetter'] = VMLElement['fill-opacitySetter'];
	            H.VMLElement = VMLElement = extendClass(SVGElement, VMLElement);
	
	            // Some shared setters
	            VMLElement.prototype.ySetter =
	                VMLElement.prototype.widthSetter =
	                VMLElement.prototype.heightSetter =
	                VMLElement.prototype.xSetter;
	
	
	            /**
	             * The VML renderer
	             */
	            VMLRendererExtension = { // inherit SVGRenderer
	
	                Element: VMLElement,
	                isIE8: win.navigator.userAgent.indexOf('MSIE 8.0') > -1,
	
	
	                /**
	                 * Initialize the VMLRenderer
	                 * @param {Object} container
	                 * @param {Number} width
	                 * @param {Number} height
	                 */
	                init: function(container, width, height) {
	                    var renderer = this,
	                        boxWrapper,
	                        box,
	                        css;
	
	                    renderer.alignedObjects = [];
	
	                    boxWrapper = renderer.createElement('div')
	                        .css({
	                            position: 'relative'
	                        });
	                    box = boxWrapper.element;
	                    container.appendChild(boxWrapper.element);
	
	
	                    // generate the containing box
	                    renderer.isVML = true;
	                    renderer.box = box;
	                    renderer.boxWrapper = boxWrapper;
	                    renderer.gradients = {};
	                    renderer.cache = {}; // Cache for numerical bounding boxes
	                    renderer.cacheKeys = [];
	                    renderer.imgCount = 0;
	
	
	                    renderer.setSize(width, height, false);
	
	                    // The only way to make IE6 and IE7 print is to use a global namespace. However,
	                    // with IE8 the only way to make the dynamic shapes visible in screen and print mode
	                    // seems to be to add the xmlns attribute and the behaviour style inline.
	                    if (!doc.namespaces.hcv) {
	
	                        doc.namespaces.add('hcv', 'urn:schemas-microsoft-com:vml');
	
	                        // Setup default CSS (#2153, #2368, #2384)
	                        css = 'hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke' +
	                            '{ behavior:url(#default#VML); display: inline-block; } ';
	                        try {
	                            doc.createStyleSheet().cssText = css;
	                        } catch (e) {
	                            doc.styleSheets[0].cssText += css;
	                        }
	
	                    }
	                },
	
	
	                /**
	                 * Detect whether the renderer is hidden. This happens when one of the parent elements
	                 * has display: none
	                 */
	                isHidden: function() {
	                    return !this.box.offsetWidth;
	                },
	
	                /**
	                 * Define a clipping rectangle. In VML it is accomplished by storing the values
	                 * for setting the CSS style to all associated members.
	                 *
	                 * @param {Number} x
	                 * @param {Number} y
	                 * @param {Number} width
	                 * @param {Number} height
	                 */
	                clipRect: function(x, y, width, height) {
	
	                    // create a dummy element
	                    var clipRect = this.createElement(),
	                        isObj = isObject(x);
	
	                    // mimic a rectangle with its style object for automatic updating in attr
	                    return extend(clipRect, {
	                        members: [],
	                        count: 0,
	                        left: (isObj ? x.x : x) + 1,
	                        top: (isObj ? x.y : y) + 1,
	                        width: (isObj ? x.width : width) - 1,
	                        height: (isObj ? x.height : height) - 1,
	                        getCSS: function(wrapper) {
	                            var element = wrapper.element,
	                                nodeName = element.nodeName,
	                                isShape = nodeName === 'shape',
	                                inverted = wrapper.inverted,
	                                rect = this,
	                                top = rect.top - (isShape ? element.offsetTop : 0),
	                                left = rect.left,
	                                right = left + rect.width,
	                                bottom = top + rect.height,
	                                ret = {
	                                    clip: 'rect(' +
	                                        Math.round(inverted ? left : top) + 'px,' +
	                                        Math.round(inverted ? bottom : right) + 'px,' +
	                                        Math.round(inverted ? right : bottom) + 'px,' +
	                                        Math.round(inverted ? top : left) + 'px)'
	                                };
	
	                            // issue 74 workaround
	                            if (!inverted && wrapper.docMode8 && nodeName === 'DIV') {
	                                extend(ret, {
	                                    width: right + 'px',
	                                    height: bottom + 'px'
	                                });
	                            }
	                            return ret;
	                        },
	
	                        // used in attr and animation to update the clipping of all members
	                        updateClipping: function() {
	                            each(clipRect.members, function(member) {
	                                // Member.element is falsy on deleted series, like in
	                                // stock/members/series-remove demo. Should be removed
	                                // from members, but this will do.
	                                if (member.element) {
	                                    member.css(clipRect.getCSS(member));
	                                }
	                            });
	                        }
	                    });
	
	                },
	
	
	                /**
	                 * Take a color and return it if it's a string, make it a gradient if it's a
	                 * gradient configuration object, and apply opacity.
	                 *
	                 * @param {Object} color The color or config object
	                 */
	                color: function(color, elem, prop, wrapper) {
	                    var renderer = this,
	                        colorObject,
	                        regexRgba = /^rgba/,
	                        markup,
	                        fillType,
	                        ret = 'none';
	
	                    // Check for linear or radial gradient
	                    if (color && color.linearGradient) {
	                        fillType = 'gradient';
	                    } else if (color && color.radialGradient) {
	                        fillType = 'pattern';
	                    }
	
	
	                    if (fillType) {
	
	                        var stopColor,
	                            stopOpacity,
	                            gradient = color.linearGradient || color.radialGradient,
	                            x1,
	                            y1,
	                            x2,
	                            y2,
	                            opacity1,
	                            opacity2,
	                            color1,
	                            color2,
	                            fillAttr = '',
	                            stops = color.stops,
	                            firstStop,
	                            lastStop,
	                            colors = [],
	                            addFillNode = function() {
	                                // Add the fill subnode. When colors attribute is used, the meanings of opacity and o:opacity2
	                                // are reversed.
	                                markup = ['<fill colors="' + colors.join(',') +
	                                    '" opacity="', opacity2, '" o:opacity2="',
	                                    opacity1, '" type="', fillType, '" ', fillAttr,
	                                    'focus="100%" method="any" />'
	                                ];
	                                createElement(renderer.prepVML(markup), null, null, elem);
	                            };
	
	                        // Extend from 0 to 1
	                        firstStop = stops[0];
	                        lastStop = stops[stops.length - 1];
	                        if (firstStop[0] > 0) {
	                            stops.unshift([
	                                0,
	                                firstStop[1]
	                            ]);
	                        }
	                        if (lastStop[0] < 1) {
	                            stops.push([
	                                1,
	                                lastStop[1]
	                            ]);
	                        }
	
	                        // Compute the stops
	                        each(stops, function(stop, i) {
	                            if (regexRgba.test(stop[1])) {
	                                colorObject = H.color(stop[1]);
	                                stopColor = colorObject.get('rgb');
	                                stopOpacity = colorObject.get('a');
	                            } else {
	                                stopColor = stop[1];
	                                stopOpacity = 1;
	                            }
	
	                            // Build the color attribute
	                            colors.push((stop[0] * 100) + '% ' + stopColor);
	
	                            // Only start and end opacities are allowed, so we use the first and the last
	                            if (!i) {
	                                opacity1 = stopOpacity;
	                                color2 = stopColor;
	                            } else {
	                                opacity2 = stopOpacity;
	                                color1 = stopColor;
	                            }
	                        });
	
	                        // Apply the gradient to fills only.
	                        if (prop === 'fill') {
	
	                            // Handle linear gradient angle
	                            if (fillType === 'gradient') {
	                                x1 = gradient.x1 || gradient[0] || 0;
	                                y1 = gradient.y1 || gradient[1] || 0;
	                                x2 = gradient.x2 || gradient[2] || 0;
	                                y2 = gradient.y2 || gradient[3] || 0;
	                                fillAttr = 'angle="' + (90 - Math.atan(
	                                    (y2 - y1) / // y vector
	                                    (x2 - x1) // x vector
	                                ) * 180 / Math.PI) + '"';
	
	                                addFillNode();
	
	                                // Radial (circular) gradient
	                            } else {
	
	                                var r = gradient.r,
	                                    sizex = r * 2,
	                                    sizey = r * 2,
	                                    cx = gradient.cx,
	                                    cy = gradient.cy,
	                                    radialReference = elem.radialReference,
	                                    bBox,
	                                    applyRadialGradient = function() {
	                                        if (radialReference) {
	                                            bBox = wrapper.getBBox();
	                                            cx += (radialReference[0] - bBox.x) / bBox.width - 0.5;
	                                            cy += (radialReference[1] - bBox.y) / bBox.height - 0.5;
	                                            sizex *= radialReference[2] / bBox.width;
	                                            sizey *= radialReference[2] / bBox.height;
	                                        }
	                                        fillAttr = 'src="' + H.getOptions().global.VMLRadialGradientURL + '" ' +
	                                            'size="' + sizex + ',' + sizey + '" ' +
	                                            'origin="0.5,0.5" ' +
	                                            'position="' + cx + ',' + cy + '" ' +
	                                            'color2="' + color2 + '" ';
	
	                                        addFillNode();
	                                    };
	
	                                // Apply radial gradient
	                                if (wrapper.added) {
	                                    applyRadialGradient();
	                                } else {
	                                    // We need to know the bounding box to get the size and position right
	                                    wrapper.onAdd = applyRadialGradient;
	                                }
	
	                                // The fill element's color attribute is broken in IE8 standards mode, so we
	                                // need to set the parent shape's fillcolor attribute instead.
	                                ret = color1;
	                            }
	
	                            // Gradients are not supported for VML stroke, return the first color. #722.
	                        } else {
	                            ret = stopColor;
	                        }
	
	                        // If the color is an rgba color, split it and add a fill node
	                        // to hold the opacity component
	                    } else if (regexRgba.test(color) && elem.tagName !== 'IMG') {
	
	                        colorObject = H.color(color);
	
	                        wrapper[prop + '-opacitySetter'](colorObject.get('a'), prop, elem);
	
	                        ret = colorObject.get('rgb');
	
	
	                    } else {
	                        var propNodes = elem.getElementsByTagName(prop); // 'stroke' or 'fill' node
	                        if (propNodes.length) {
	                            propNodes[0].opacity = 1;
	                            propNodes[0].type = 'solid';
	                        }
	                        ret = color;
	                    }
	
	                    return ret;
	                },
	
	                /**
	                 * Take a VML string and prepare it for either IE8 or IE6/IE7.
	                 * @param {Array} markup A string array of the VML markup to prepare
	                 */
	                prepVML: function(markup) {
	                    var vmlStyle = 'display:inline-block;behavior:url(#default#VML);',
	                        isIE8 = this.isIE8;
	
	                    markup = markup.join('');
	
	                    if (isIE8) { // add xmlns and style inline
	                        markup = markup.replace('/>', ' xmlns="urn:schemas-microsoft-com:vml" />');
	                        if (markup.indexOf('style="') === -1) {
	                            markup = markup.replace('/>', ' style="' + vmlStyle + '" />');
	                        } else {
	                            markup = markup.replace('style="', 'style="' + vmlStyle);
	                        }
	
	                    } else { // add namespace
	                        markup = markup.replace('<', '<hcv:');
	                    }
	
	                    return markup;
	                },
	
	                /**
	                 * Create rotated and aligned text
	                 * @param {String} str
	                 * @param {Number} x
	                 * @param {Number} y
	                 */
	                text: SVGRenderer.prototype.html,
	
	                /**
	                 * Create and return a path element
	                 * @param {Array} path
	                 */
	                path: function(path) {
	                    var attr = {
	                        // subpixel precision down to 0.1 (width and height = 1px)
	                        coordsize: '10 10'
	                    };
	                    if (isArray(path)) {
	                        attr.d = path;
	                    } else if (isObject(path)) { // attributes
	                        extend(attr, path);
	                    }
	                    // create the shape
	                    return this.createElement('shape').attr(attr);
	                },
	
	                /**
	                 * Create and return a circle element. In VML circles are implemented as
	                 * shapes, which is faster than v:oval
	                 * @param {Number} x
	                 * @param {Number} y
	                 * @param {Number} r
	                 */
	                circle: function(x, y, r) {
	                    var circle = this.symbol('circle');
	                    if (isObject(x)) {
	                        r = x.r;
	                        y = x.y;
	                        x = x.x;
	                    }
	                    circle.isCircle = true; // Causes x and y to mean center (#1682)
	                    circle.r = r;
	                    return circle.attr({
	                        x: x,
	                        y: y
	                    });
	                },
	
	                /**
	                 * Create a group using an outer div and an inner v:group to allow rotating
	                 * and flipping. A simple v:group would have problems with positioning
	                 * child HTML elements and CSS clip.
	                 *
	                 * @param {String} name The name of the group
	                 */
	                g: function(name) {
	                    var wrapper,
	                        attribs;
	
	                    // set the class name
	                    if (name) {
	                        attribs = {
	                            'className': 'highcharts-' + name,
	                            'class': 'highcharts-' + name
	                        };
	                    }
	
	                    // the div to hold HTML and clipping
	                    wrapper = this.createElement('div').attr(attribs);
	
	                    return wrapper;
	                },
	
	                /**
	                 * VML override to create a regular HTML image
	                 * @param {String} src
	                 * @param {Number} x
	                 * @param {Number} y
	                 * @param {Number} width
	                 * @param {Number} height
	                 */
	                image: function(src, x, y, width, height) {
	                    var obj = this.createElement('img')
	                        .attr({
	                            src: src
	                        });
	
	                    if (arguments.length > 1) {
	                        obj.attr({
	                            x: x,
	                            y: y,
	                            width: width,
	                            height: height
	                        });
	                    }
	                    return obj;
	                },
	
	                /**
	                 * For rectangles, VML uses a shape for rect to overcome bugs and rotation problems
	                 */
	                createElement: function(nodeName) {
	                    return nodeName === 'rect' ?
	                        this.symbol(nodeName) :
	                        SVGRenderer.prototype.createElement.call(this, nodeName);
	                },
	
	                /**
	                 * In the VML renderer, each child of an inverted div (group) is inverted
	                 * @param {Object} element
	                 * @param {Object} parentNode
	                 */
	                invertChild: function(element, parentNode) {
	                    var ren = this,
	                        parentStyle = parentNode.style,
	                        imgStyle = element.tagName === 'IMG' && element.style; // #1111
	
	                    css(element, {
	                        flip: 'x',
	                        left: pInt(parentStyle.width) - (imgStyle ? pInt(imgStyle.top) : 1),
	                        top: pInt(parentStyle.height) - (imgStyle ? pInt(imgStyle.left) : 1),
	                        rotation: -90
	                    });
	
	                    // Recursively invert child elements, needed for nested composite
	                    // shapes like box plots and error bars. #1680, #1806.
	                    each(element.childNodes, function(child) {
	                        ren.invertChild(child, element);
	                    });
	                },
	
	                /**
	                 * Symbol definitions that override the parent SVG renderer's symbols
	                 *
	                 */
	                symbols: {
	                    // VML specific arc function
	                    arc: function(x, y, w, h, options) {
	                        var start = options.start,
	                            end = options.end,
	                            radius = options.r || w || h,
	                            innerRadius = options.innerR,
	                            cosStart = Math.cos(start),
	                            sinStart = Math.sin(start),
	                            cosEnd = Math.cos(end),
	                            sinEnd = Math.sin(end),
	                            ret;
	
	                        if (end - start === 0) { // no angle, don't show it.
	                            return ['x'];
	                        }
	
	                        ret = [
	                            'wa', // clockwise arc to
	                            x - radius, // left
	                            y - radius, // top
	                            x + radius, // right
	                            y + radius, // bottom
	                            x + radius * cosStart, // start x
	                            y + radius * sinStart, // start y
	                            x + radius * cosEnd, // end x
	                            y + radius * sinEnd // end y
	                        ];
	
	                        if (options.open && !innerRadius) {
	                            ret.push(
	                                'e',
	                                'M',
	                                x, // - innerRadius,
	                                y // - innerRadius
	                            );
	                        }
	
	                        ret.push(
	                            'at', // anti clockwise arc to
	                            x - innerRadius, // left
	                            y - innerRadius, // top
	                            x + innerRadius, // right
	                            y + innerRadius, // bottom
	                            x + innerRadius * cosEnd, // start x
	                            y + innerRadius * sinEnd, // start y
	                            x + innerRadius * cosStart, // end x
	                            y + innerRadius * sinStart, // end y
	                            'x', // finish path
	                            'e' // close
	                        );
	
	                        ret.isArc = true;
	                        return ret;
	
	                    },
	                    // Add circle symbol path. This performs significantly faster than v:oval.
	                    circle: function(x, y, w, h, wrapper) {
	
	                        if (wrapper && defined(wrapper.r)) {
	                            w = h = 2 * wrapper.r;
	                        }
	
	                        // Center correction, #1682
	                        if (wrapper && wrapper.isCircle) {
	                            x -= w / 2;
	                            y -= h / 2;
	                        }
	
	                        // Return the path
	                        return [
	                            'wa', // clockwisearcto
	                            x, // left
	                            y, // top
	                            x + w, // right
	                            y + h, // bottom
	                            x + w, // start x
	                            y + h / 2, // start y
	                            x + w, // end x
	                            y + h / 2, // end y
	                            //'x', // finish path
	                            'e' // close
	                        ];
	                    },
	                    /**
	                     * Add rectangle symbol path which eases rotation and omits arcsize problems
	                     * compared to the built-in VML roundrect shape. When borders are not rounded,
	                     * use the simpler square path, else use the callout path without the arrow.
	                     */
	                    rect: function(x, y, w, h, options) {
	                        return SVGRenderer.prototype.symbols[!defined(options) || !options.r ? 'square' : 'callout'].call(0, x, y, w, h, options);
	                    }
	                }
	            };
	            H.VMLRenderer = VMLRenderer = function() {
	                this.init.apply(this, arguments);
	            };
	            VMLRenderer.prototype = merge(SVGRenderer.prototype, VMLRendererExtension);
	
	            // general renderer
	            H.Renderer = VMLRenderer;
	        }
	
	        // This method is used with exporting in old IE, when emulating SVG (see #2314)
	        SVGRenderer.prototype.measureSpanWidth = function(text, styles) {
	            var measuringSpan = doc.createElement('span'),
	                offsetWidth,
	                textNode = doc.createTextNode(text);
	
	            measuringSpan.appendChild(textNode);
	            css(measuringSpan, styles);
	            this.box.appendChild(measuringSpan);
	            offsetWidth = measuringSpan.offsetWidth;
	            discardElement(measuringSpan); // #2463
	            return offsetWidth;
	        };
	
	
	        /* ****************************************************************************
	         *                                                                            *
	         * END OF INTERNET EXPLORER <= 8 SPECIFIC CODE                                *
	         *                                                                            *
	         *****************************************************************************/
	
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var color = H.color,
	            each = H.each,
	            getTZOffset = H.getTZOffset,
	            isTouchDevice = H.isTouchDevice,
	            merge = H.merge,
	            pick = H.pick,
	            svg = H.svg,
	            win = H.win;
	
	        /* ****************************************************************************
	         * Handle the options                                                         *
	         *****************************************************************************/
	        H.defaultOptions = {
	
	            colors: '#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1'.split(' '),
	
	            symbols: ['circle', 'diamond', 'square', 'triangle', 'triangle-down'],
	            lang: {
	                loading: 'Loading...',
	                months: [
	                    'January', 'February', 'March', 'April', 'May', 'June', 'July',
	                    'August', 'September', 'October', 'November', 'December'
	                ],
	                shortMonths: [
	                    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
	                    'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
	                ],
	                weekdays: [
	                    'Sunday', 'Monday', 'Tuesday', 'Wednesday',
	                    'Thursday', 'Friday', 'Saturday'
	                ],
	                // invalidDate: '',
	                decimalPoint: '.',
	                numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'], // SI prefixes used in axis labels
	                resetZoom: 'Reset zoom',
	                resetZoomTitle: 'Reset zoom level 1:1',
	                thousandsSep: ' '
	            },
	            global: {
	                useUTC: true,
	                //timezoneOffset: 0,
	
	                VMLRadialGradientURL: 'http://code.highcharts.com/5.0.12/gfx/vml-radial-gradient.png'
	
	            },
	            chart: {
	                //animation: true,
	                //alignTicks: false,
	                //reflow: true,
	                //className: null,
	                //events: { load, selection },
	                //margin: [null],
	                //marginTop: null,
	                //marginRight: null,
	                //marginBottom: null,
	                //marginLeft: null,
	                borderRadius: 0,
	
	                defaultSeriesType: 'line',
	                ignoreHiddenSeries: true,
	                //inverted: false,
	                spacing: [10, 10, 15, 10],
	                //spacingTop: 10,
	                //spacingRight: 10,
	                //spacingBottom: 15,
	                //spacingLeft: 10,
	                //zoomType: ''
	                resetZoomButton: {
	                    theme: {
	                        zIndex: 20
	                    },
	                    position: {
	                        align: 'right',
	                        x: -10,
	                        //verticalAlign: 'top',
	                        y: 10
	                    }
	                    // relativeTo: 'plot'
	                },
	                width: null,
	                height: null,
	
	
	                borderColor: '#335cad',
	                //borderWidth: 0,
	                //style: {
	                //	fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif', // default font
	                //	fontSize: '12px'
	                //},
	                backgroundColor: '#ffffff',
	                //plotBackgroundColor: null,
	                plotBorderColor: '#cccccc'
	                //plotBorderWidth: 0,
	                //plotShadow: false
	
	            },
	            title: {
	                text: 'Chart title',
	                align: 'center',
	                // floating: false,
	                margin: 15,
	                // x: 0,
	                // verticalAlign: 'top',
	                // y: null,
	                // style: {}, // defined inline
	                widthAdjust: -44
	
	            },
	            subtitle: {
	                text: '',
	                align: 'center',
	                // floating: false
	                // x: 0,
	                // verticalAlign: 'top',
	                // y: null,
	                // style: {}, // defined inline
	                widthAdjust: -44
	            },
	
	            plotOptions: {},
	            labels: {
	                //items: [],
	                style: {
	                    //font: defaultFont,
	                    position: 'absolute',
	                    color: '#333333'
	                }
	            },
	            legend: {
	                enabled: true,
	                align: 'center',
	                //floating: false,
	                layout: 'horizontal',
	                labelFormatter: function() {
	                    return this.name;
	                },
	                //borderWidth: 0,
	                borderColor: '#999999',
	                borderRadius: 0,
	                navigation: {
	
	                    activeColor: '#003399',
	                    inactiveColor: '#cccccc'
	
	                    // animation: true,
	                    // arrowSize: 12
	                    // style: {} // text styles
	                },
	                // margin: 20,
	                // reversed: false,
	                // backgroundColor: null,
	                /*style: {
	                	padding: '5px'
	                },*/
	
	                itemStyle: {
	                    color: '#333333',
	                    fontSize: '12px',
	                    fontWeight: 'bold',
	                    textOverflow: 'ellipsis'
	                },
	                itemHoverStyle: {
	                    //cursor: 'pointer', removed as of #601
	                    color: '#000000'
	                },
	                itemHiddenStyle: {
	                    color: '#cccccc'
	                },
	                shadow: false,
	
	                itemCheckboxStyle: {
	                    position: 'absolute',
	                    width: '13px', // for IE precision
	                    height: '13px'
	                },
	                // itemWidth: undefined,
	                squareSymbol: true,
	                // symbolRadius: 0,
	                // symbolWidth: 16,
	                symbolPadding: 5,
	                verticalAlign: 'bottom',
	                // width: undefined,
	                x: 0,
	                y: 0,
	                title: {
	                    //text: null,
	
	                    style: {
	                        fontWeight: 'bold'
	                    }
	
	                }
	            },
	
	            loading: {
	                // hideDuration: 100,
	                // showDuration: 0,
	
	                labelStyle: {
	                    fontWeight: 'bold',
	                    position: 'relative',
	                    top: '45%'
	                },
	                style: {
	                    position: 'absolute',
	                    backgroundColor: '#ffffff',
	                    opacity: 0.5,
	                    textAlign: 'center'
	                }
	
	            },
	
	            tooltip: {
	                enabled: true,
	                animation: svg,
	                //crosshairs: null,
	                borderRadius: 3,
	                dateTimeLabelFormats: {
	                    millisecond: '%A, %b %e, %H:%M:%S.%L',
	                    second: '%A, %b %e, %H:%M:%S',
	                    minute: '%A, %b %e, %H:%M',
	                    hour: '%A, %b %e, %H:%M',
	                    day: '%A, %b %e, %Y',
	                    week: 'Week from %A, %b %e, %Y',
	                    month: '%B %Y',
	                    year: '%Y'
	                },
	                footerFormat: '',
	                //formatter: defaultFormatter,
	                /* todo: em font-size when finished comparing against HC4
	                headerFormat: '<span style="font-size: 0.85em">{point.key}</span><br/>',
	                */
	                padding: 8,
	
	                //shape: 'callout',
	                //shared: false,
	                snap: isTouchDevice ? 25 : 10,
	
	                backgroundColor: color('#f7f7f7').setOpacity(0.85).get(),
	                borderWidth: 1,
	                headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
	                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
	                shadow: true,
	                style: {
	                    color: '#333333',
	                    cursor: 'default',
	                    fontSize: '12px',
	                    pointerEvents: 'none', // #1686 http://caniuse.com/#feat=pointer-events
	                    whiteSpace: 'nowrap'
	                }
	
	                //xDateFormat: '%A, %b %e, %Y',
	                //valueDecimals: null,
	                //valuePrefix: '',
	                //valueSuffix: ''
	            },
	
	            credits: {
	                enabled: true,
	                href: 'http://www.highcharts.com',
	                position: {
	                    align: 'right',
	                    x: -10,
	                    verticalAlign: 'bottom',
	                    y: -5
	                },
	
	                style: {
	                    cursor: 'pointer',
	                    color: '#999999',
	                    fontSize: '9px'
	                },
	
	                text: 'Highcharts.com'
	            }
	        };
	
	
	
	        /**
	         * Sets the getTimezoneOffset function. If the timezone option is set, a default
	         * getTimezoneOffset function with that timezone is returned. If not, the
	         * specified getTimezoneOffset function is returned. If neither are specified,
	         * undefined is returned.
	         * @return {function} a getTimezoneOffset function or undefined
	         */
	        function getTimezoneOffsetOption() {
	            var globalOptions = H.defaultOptions.global,
	                moment = win.moment;
	
	            if (globalOptions.timezone) {
	                if (!moment) {
	                    // getTimezoneOffset-function stays undefined because it depends on
	                    // Moment.js
	                    H.error(25);
	
	                } else {
	                    return function(timestamp) {
	                        return -moment.tz(
	                            timestamp,
	                            globalOptions.timezone
	                        ).utcOffset();
	                    };
	                }
	            }
	
	            // If not timezone is set, look for the getTimezoneOffset callback
	            return globalOptions.useUTC && globalOptions.getTimezoneOffset;
	        }
	
	        /**
	         * Set the time methods globally based on the useUTC option. Time method can be
	         *   either local time or UTC (default). It is called internally on initiating
	         *   Highcharts and after running `Highcharts.setOptions`.
	         *
	         * @private
	         */
	        function setTimeMethods() {
	            var globalOptions = H.defaultOptions.global,
	                Date,
	                useUTC = globalOptions.useUTC,
	                GET = useUTC ? 'getUTC' : 'get',
	                SET = useUTC ? 'setUTC' : 'set';
	
	            H.Date = Date = globalOptions.Date || win.Date; // Allow using a different Date class
	            Date.hcTimezoneOffset = useUTC && globalOptions.timezoneOffset;
	            Date.hcGetTimezoneOffset = getTimezoneOffsetOption();
	            Date.hcMakeTime = function(year, month, date, hours, minutes, seconds) {
	                var d;
	                if (useUTC) {
	                    d = Date.UTC.apply(0, arguments);
	                    d += getTZOffset(d);
	                } else {
	                    d = new Date(
	                        year,
	                        month,
	                        pick(date, 1),
	                        pick(hours, 0),
	                        pick(minutes, 0),
	                        pick(seconds, 0)
	                    ).getTime();
	                }
	                return d;
	            };
	            each(['Minutes', 'Hours', 'Day', 'Date', 'Month', 'FullYear'], function(s) {
	                Date['hcGet' + s] = GET + s;
	            });
	            each(['Milliseconds', 'Seconds', 'Minutes', 'Hours', 'Date', 'Month', 'FullYear'], function(s) {
	                Date['hcSet' + s] = SET + s;
	            });
	        }
	
	        /**
	         * Merge the default options with custom options and return the new options
	         * structure. Commonly used for defining reusable templates.
	         *
	         * @function #setOptions
	         * @memberOf  Highcharts
	         * @sample highcharts/global/useutc-false Setting a global option
	         * @sample highcharts/members/setoptions Applying a global theme
	         * @param {Object} options The new custom chart options.
	         * @returns {Object} Updated options.
	         */
	        H.setOptions = function(options) {
	
	            // Copy in the default options
	            H.defaultOptions = merge(true, H.defaultOptions, options);
	
	            // Apply UTC
	            setTimeMethods();
	
	            return H.defaultOptions;
	        };
	
	        /**
	         * Get the updated default options. Until 3.0.7, merely exposing defaultOptions for outside modules
	         * wasn't enough because the setOptions method created a new object.
	         */
	        H.getOptions = function() {
	            return H.defaultOptions;
	        };
	
	
	        // Series defaults
	        H.defaultPlotOptions = H.defaultOptions.plotOptions;
	
	        // set the default time methods
	        setTimeMethods();
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var correctFloat = H.correctFloat,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            isNumber = H.isNumber,
	            merge = H.merge,
	            pick = H.pick,
	            deg2rad = H.deg2rad;
	
	        /**
	         * The Tick class
	         */
	        H.Tick = function(axis, pos, type, noLabel) {
	            this.axis = axis;
	            this.pos = pos;
	            this.type = type || '';
	            this.isNew = true;
	            this.isNewLabel = true;
	
	            if (!type && !noLabel) {
	                this.addLabel();
	            }
	        };
	
	        H.Tick.prototype = {
	            /**
	             * Write the tick label
	             */
	            addLabel: function() {
	                var tick = this,
	                    axis = tick.axis,
	                    options = axis.options,
	                    chart = axis.chart,
	                    categories = axis.categories,
	                    names = axis.names,
	                    pos = tick.pos,
	                    labelOptions = options.labels,
	                    str,
	                    tickPositions = axis.tickPositions,
	                    isFirst = pos === tickPositions[0],
	                    isLast = pos === tickPositions[tickPositions.length - 1],
	                    value = categories ?
	                    pick(categories[pos], names[pos], pos) :
	                    pos,
	                    label = tick.label,
	                    tickPositionInfo = tickPositions.info,
	                    dateTimeLabelFormat;
	
	                // Set the datetime label format. If a higher rank is set for this position, use that. If not,
	                // use the general format.
	                if (axis.isDatetimeAxis && tickPositionInfo) {
	                    dateTimeLabelFormat =
	                        options.dateTimeLabelFormats[
	                            tickPositionInfo.higherRanks[pos] || tickPositionInfo.unitName
	                        ];
	                }
	                // set properties for access in render method
	                tick.isFirst = isFirst;
	                tick.isLast = isLast;
	
	                // get the string
	                str = axis.labelFormatter.call({
	                    axis: axis,
	                    chart: chart,
	                    isFirst: isFirst,
	                    isLast: isLast,
	                    dateTimeLabelFormat: dateTimeLabelFormat,
	                    value: axis.isLog ? correctFloat(axis.lin2log(value)) : value
	                });
	
	                // prepare CSS
	                //css = width && { width: Math.max(1, Math.round(width - 2 * (labelOptions.padding || 10))) + 'px' };
	
	                // first call
	                if (!defined(label)) {
	
	                    tick.label = label =
	                        defined(str) && labelOptions.enabled ?
	                        chart.renderer.text(
	                            str,
	                            0,
	                            0,
	                            labelOptions.useHTML
	                        )
	
	                        // without position absolute, IE export sometimes is wrong
	                        .css(merge(labelOptions.style))
	
	                        .add(axis.labelGroup) :
	                        null;
	                    tick.labelLength = label && label.getBBox().width; // Un-rotated length
	                    tick.rotation = 0; // Base value to detect change for new calls to getBBox
	
	                    // update
	                } else if (label) {
	                    label.attr({
	                        text: str
	                    });
	                }
	            },
	
	            /**
	             * Get the offset height or width of the label
	             */
	            getLabelSize: function() {
	                return this.label ?
	                    this.label.getBBox()[this.axis.horiz ? 'height' : 'width'] :
	                    0;
	            },
	
	            /**
	             * Handle the label overflow by adjusting the labels to the left and right edge, or
	             * hide them if they collide into the neighbour label.
	             */
	            handleOverflow: function(xy) {
	                var axis = this.axis,
	                    pxPos = xy.x,
	                    chartWidth = axis.chart.chartWidth,
	                    spacing = axis.chart.spacing,
	                    leftBound = pick(axis.labelLeft, Math.min(axis.pos, spacing[3])),
	                    rightBound = pick(axis.labelRight, Math.max(axis.pos + axis.len, chartWidth - spacing[1])),
	                    label = this.label,
	                    rotation = this.rotation,
	                    factor = {
	                        left: 0,
	                        center: 0.5,
	                        right: 1
	                    }[axis.labelAlign],
	                    labelWidth = label.getBBox().width,
	                    slotWidth = axis.getSlotWidth(),
	                    modifiedSlotWidth = slotWidth,
	                    xCorrection = factor,
	                    goRight = 1,
	                    leftPos,
	                    rightPos,
	                    textWidth,
	                    css = {};
	
	                // Check if the label overshoots the chart spacing box. If it does, move it.
	                // If it now overshoots the slotWidth, add ellipsis.
	                if (!rotation) {
	                    leftPos = pxPos - factor * labelWidth;
	                    rightPos = pxPos + (1 - factor) * labelWidth;
	
	                    if (leftPos < leftBound) {
	                        modifiedSlotWidth = xy.x + modifiedSlotWidth * (1 - factor) - leftBound;
	                    } else if (rightPos > rightBound) {
	                        modifiedSlotWidth = rightBound - xy.x + modifiedSlotWidth * factor;
	                        goRight = -1;
	                    }
	
	                    modifiedSlotWidth = Math.min(slotWidth, modifiedSlotWidth); // #4177
	                    if (modifiedSlotWidth < slotWidth && axis.labelAlign === 'center') {
	                        xy.x += goRight * (slotWidth - modifiedSlotWidth - xCorrection *
	                            (slotWidth - Math.min(labelWidth, modifiedSlotWidth)));
	                    }
	                    // If the label width exceeds the available space, set a text width to be
	                    // picked up below. Also, if a width has been set before, we need to set a new
	                    // one because the reported labelWidth will be limited by the box (#3938).
	                    if (labelWidth > modifiedSlotWidth || (axis.autoRotation && (label.styles || {}).width)) {
	                        textWidth = modifiedSlotWidth;
	                    }
	
	                    // Add ellipsis to prevent rotated labels to be clipped against the edge of the chart
	                } else if (rotation < 0 && pxPos - factor * labelWidth < leftBound) {
	                    textWidth = Math.round(pxPos / Math.cos(rotation * deg2rad) - leftBound);
	                } else if (rotation > 0 && pxPos + factor * labelWidth > rightBound) {
	                    textWidth = Math.round((chartWidth - pxPos) / Math.cos(rotation * deg2rad));
	                }
	
	                if (textWidth) {
	                    css.width = textWidth;
	                    if (!(axis.options.labels.style || {}).textOverflow) {
	                        css.textOverflow = 'ellipsis';
	                    }
	                    label.css(css);
	                }
	            },
	
	            /**
	             * Get the x and y position for ticks and labels
	             */
	            getPosition: function(horiz, pos, tickmarkOffset, old) {
	                var axis = this.axis,
	                    chart = axis.chart,
	                    cHeight = (old && chart.oldChartHeight) || chart.chartHeight;
	
	                return {
	                    x: horiz ?
	                        axis.translate(pos + tickmarkOffset, null, null, old) + axis.transB : axis.left + axis.offset +
	                        (axis.opposite ?
	                            ((old && chart.oldChartWidth) || chart.chartWidth) - axis.right - axis.left :
	                            0
	                        ),
	
	                    y: horiz ?
	                        cHeight - axis.bottom + axis.offset - (axis.opposite ? axis.height : 0) : cHeight - axis.translate(pos + tickmarkOffset, null, null, old) - axis.transB
	                };
	
	            },
	
	            /**
	             * Get the x, y position of the tick label
	             */
	            getLabelPosition: function(x, y, label, horiz, labelOptions, tickmarkOffset, index, step) {
	                var axis = this.axis,
	                    transA = axis.transA,
	                    reversed = axis.reversed,
	                    staggerLines = axis.staggerLines,
	                    rotCorr = axis.tickRotCorr || {
	                        x: 0,
	                        y: 0
	                    },
	                    yOffset = labelOptions.y,
	                    line;
	
	                if (!defined(yOffset)) {
	                    if (axis.side === 0) {
	                        yOffset = label.rotation ? -8 : -label.getBBox().height;
	                    } else if (axis.side === 2) {
	                        yOffset = rotCorr.y + 8;
	                    } else {
	                        // #3140, #3140
	                        yOffset = Math.cos(label.rotation * deg2rad) * (rotCorr.y - label.getBBox(false, 0).height / 2);
	                    }
	                }
	
	                x = x + labelOptions.x + rotCorr.x - (tickmarkOffset && horiz ?
	                    tickmarkOffset * transA * (reversed ? -1 : 1) : 0);
	                y = y + yOffset - (tickmarkOffset && !horiz ?
	                    tickmarkOffset * transA * (reversed ? 1 : -1) : 0);
	
	                // Correct for staggered labels
	                if (staggerLines) {
	                    line = (index / (step || 1) % staggerLines);
	                    if (axis.opposite) {
	                        line = staggerLines - line - 1;
	                    }
	                    y += line * (axis.labelOffset / staggerLines);
	                }
	
	                return {
	                    x: x,
	                    y: Math.round(y)
	                };
	            },
	
	            /**
	             * Extendible method to return the path of the marker
	             */
	            getMarkPath: function(x, y, tickLength, tickWidth, horiz, renderer) {
	                return renderer.crispLine([
	                    'M',
	                    x,
	                    y,
	                    'L',
	                    x + (horiz ? 0 : -tickLength),
	                    y + (horiz ? tickLength : 0)
	                ], tickWidth);
	            },
	
	            /**
	             * Renders the gridLine.
	             * @param  {Boolean} old         Whether or not the tick is old
	             * @param  {number} opacity      The opacity of the grid line
	             * @param  {number} reverseCrisp Modifier for avoiding overlapping 1 or -1
	             * @return {undefined}
	             */
	            renderGridLine: function(old, opacity, reverseCrisp) {
	                var tick = this,
	                    axis = tick.axis,
	                    options = axis.options,
	                    gridLine = tick.gridLine,
	                    gridLinePath,
	                    attribs = {},
	                    pos = tick.pos,
	                    type = tick.type,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    renderer = axis.chart.renderer;
	
	
	                var gridPrefix = type ? type + 'Grid' : 'grid',
	                    gridLineWidth = options[gridPrefix + 'LineWidth'],
	                    gridLineColor = options[gridPrefix + 'LineColor'],
	                    dashStyle = options[gridPrefix + 'LineDashStyle'];
	
	
	                if (!gridLine) {
	
	                    attribs.stroke = gridLineColor;
	                    attribs['stroke-width'] = gridLineWidth;
	                    if (dashStyle) {
	                        attribs.dashstyle = dashStyle;
	                    }
	
	                    if (!type) {
	                        attribs.zIndex = 1;
	                    }
	                    if (old) {
	                        attribs.opacity = 0;
	                    }
	                    tick.gridLine = gridLine = renderer.path()
	                        .attr(attribs)
	                        .addClass(
	                            'highcharts-' + (type ? type + '-' : '') + 'grid-line'
	                        )
	                        .add(axis.gridGroup);
	                }
	
	                // If the parameter 'old' is set, the current call will be followed
	                // by another call, therefore do not do any animations this time
	                if (!old && gridLine) {
	                    gridLinePath = axis.getPlotLinePath(
	                        pos + tickmarkOffset,
	                        gridLine.strokeWidth() * reverseCrisp,
	                        old, true
	                    );
	                    if (gridLinePath) {
	                        gridLine[tick.isNew ? 'attr' : 'animate']({
	                            d: gridLinePath,
	                            opacity: opacity
	                        });
	                    }
	                }
	            },
	
	            /**
	             * Renders the tick mark.
	             * @param  {Object} xy           The position vector of the mark
	             * @param  {number} xy.x         The x position of the mark
	             * @param  {number} xy.y         The y position of the mark
	             * @param  {number} opacity      The opacity of the mark
	             * @param  {number} reverseCrisp Modifier for avoiding overlapping 1 or -1
	             * @return {undefined}
	             */
	            renderMark: function(xy, opacity, reverseCrisp) {
	                var tick = this,
	                    axis = tick.axis,
	                    options = axis.options,
	                    renderer = axis.chart.renderer,
	                    type = tick.type,
	                    tickPrefix = type ? type + 'Tick' : 'tick',
	                    tickSize = axis.tickSize(tickPrefix),
	                    mark = tick.mark,
	                    isNewMark = !mark,
	                    x = xy.x,
	                    y = xy.y;
	
	
	                var tickWidth = pick(
	                        options[tickPrefix + 'Width'], !type && axis.isXAxis ? 1 : 0
	                    ), // X axis defaults to 1
	                    tickColor = options[tickPrefix + 'Color'];
	
	
	                if (tickSize) {
	
	                    // negate the length
	                    if (axis.opposite) {
	                        tickSize[0] = -tickSize[0];
	                    }
	
	                    // First time, create it
	                    if (isNewMark) {
	                        tick.mark = mark = renderer.path()
	                            .addClass('highcharts-' + (type ? type + '-' : '') + 'tick')
	                            .add(axis.axisGroup);
	
	
	                        mark.attr({
	                            stroke: tickColor,
	                            'stroke-width': tickWidth
	                        });
	
	                    }
	                    mark[isNewMark ? 'attr' : 'animate']({
	                        d: tick.getMarkPath(
	                            x,
	                            y,
	                            tickSize[0],
	                            mark.strokeWidth() * reverseCrisp,
	                            axis.horiz,
	                            renderer),
	                        opacity: opacity
	                    });
	
	                }
	            },
	
	            /**
	             * Renders the tick label.
	             * Note: The label should already be created in init(), so it should only
	             * have to be moved into place.
	             * @param  {Object} xy      The position vector of the label
	             * @param  {number} xy.x    The x position of the label
	             * @param  {number} xy.y    The y position of the label
	             * @param  {Boolean} old    Whether or not the tick is old
	             * @param  {number} opacity The opacity of the label
	             * @param  {number} index   The index of the tick
	             * @return {undefined}
	             */
	            renderLabel: function(xy, old, opacity, index) {
	                var tick = this,
	                    axis = tick.axis,
	                    horiz = axis.horiz,
	                    options = axis.options,
	                    label = tick.label,
	                    labelOptions = options.labels,
	                    step = labelOptions.step,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    show = true,
	                    x = xy.x,
	                    y = xy.y;
	                if (label && isNumber(x)) {
	                    label.xy = xy = tick.getLabelPosition(
	                        x,
	                        y,
	                        label,
	                        horiz,
	                        labelOptions,
	                        tickmarkOffset,
	                        index,
	                        step
	                    );
	
	                    // Apply show first and show last. If the tick is both first and
	                    // last, it is a single centered tick, in which case we show the
	                    // label anyway (#2100).
	                    if (
	                        (
	                            tick.isFirst &&
	                            !tick.isLast &&
	                            !pick(options.showFirstLabel, 1)
	                        ) ||
	                        (
	                            tick.isLast &&
	                            !tick.isFirst &&
	                            !pick(options.showLastLabel, 1)
	                        )
	                    ) {
	                        show = false;
	
	                        // Handle label overflow and show or hide accordingly
	                    } else if (horiz && !axis.isRadial && !labelOptions.step &&
	                        !labelOptions.rotation && !old && opacity !== 0) {
	                        tick.handleOverflow(xy);
	                    }
	
	                    // apply step
	                    if (step && index % step) {
	                        // show those indices dividable by step
	                        show = false;
	                    }
	
	                    // Set the new position, and show or hide
	                    if (show && isNumber(xy.y)) {
	                        xy.opacity = opacity;
	                        label[tick.isNewLabel ? 'attr' : 'animate'](xy);
	                        tick.isNewLabel = false;
	                    } else {
	                        label.attr('y', -9999); // #1338
	                        tick.isNewLabel = true;
	                    }
	                    tick.isNew = false;
	                }
	            },
	
	            /**
	             * Put everything in place
	             *
	             * @param index {Number}
	             * @param old {Boolean} Use old coordinates to prepare an animation into new
	             *                      position
	             */
	            render: function(index, old, opacity) {
	                var tick = this,
	                    axis = tick.axis,
	                    horiz = axis.horiz,
	                    pos = tick.pos,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    xy = tick.getPosition(horiz, pos, tickmarkOffset, old),
	                    x = xy.x,
	                    y = xy.y,
	                    reverseCrisp = ((horiz && x === axis.pos + axis.len) ||
	                        (!horiz && y === axis.pos)) ? -1 : 1; // #1480, #1687
	
	                opacity = pick(opacity, 1);
	                this.isActive = true;
	
	                // Create the grid line
	                this.renderGridLine(old, opacity, reverseCrisp);
	
	                // create the tick mark
	                this.renderMark(xy, opacity, reverseCrisp);
	
	                // the label is created on init - now move it into place
	                this.renderLabel(xy, old, opacity, index);
	            },
	
	            /**
	             * Destructor for the tick prototype
	             */
	            destroy: function() {
	                destroyObjectProperties(this, this.axis);
	            }
	        };
	
	    }(Highcharts));
	    var Axis = (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var addEvent = H.addEvent,
	            animObject = H.animObject,
	            arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            color = H.color,
	            correctFloat = H.correctFloat,
	            defaultOptions = H.defaultOptions,
	            defined = H.defined,
	            deg2rad = H.deg2rad,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            format = H.format,
	            getMagnitude = H.getMagnitude,
	            grep = H.grep,
	            inArray = H.inArray,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isString = H.isString,
	            merge = H.merge,
	            normalizeTickInterval = H.normalizeTickInterval,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            syncTimeout = H.syncTimeout,
	            Tick = H.Tick;
	
	        /**
	         * Create a new axis object. Called internally when instanciating a new chart or
	         * adding axes by {@link Highcharts.Chart#addAxis}.
	         *
	         * A chart can have from 0 axes (pie chart) to multiples. In a normal, single
	         * series cartesian chart, there is one X axis and one Y axis.
	         * 
	         * The X axis or axes are referenced by {@link Highcharts.Chart.xAxis}, which is
	         * an array of Axis objects. If there is only one axis, it can be referenced
	         * through `chart.xAxis[0]`, and multiple axes have increasing indices. The same
	         * pattern goes for Y axes.
	         * 
	         * If you need to get the axes from a series object, use the `series.xAxis` and
	         * `series.yAxis` properties. These are not arrays, as one series can only be
	         * associated to one X and one Y axis.
	         * 
	         * A third way to reference the axis programmatically is by `id`. Add an `id` in
	         * the axis configuration options, and get the axis by
	         * {@link Highcharts.Chart#get}.
	         * 
	         * Configuration options for the axes are given in options.xAxis and
	         * options.yAxis.
	         * 
	         * @class Highcharts.Axis
	         * @memberOf Highcharts
	         * @param {Highcharts.Chart} chart - The Chart instance to apply the axis on.
	         * @param {Object} options - Axis options
	         */
	        var Axis = function() {
	            this.init.apply(this, arguments);
	        };
	
	        H.extend(Axis.prototype, /** @lends Highcharts.Axis.prototype */ {
	
	            /**
	             * Default options for the X axis - the Y axis has extended defaults.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultOptions: {
	                // allowDecimals: null,
	                // alternateGridColor: null,
	                // categories: [],
	                dateTimeLabelFormats: {
	                    millisecond: '%H:%M:%S.%L',
	                    second: '%H:%M:%S',
	                    minute: '%H:%M',
	                    hour: '%H:%M',
	                    day: '%e. %b',
	                    week: '%e. %b',
	                    month: '%b \'%y',
	                    year: '%Y'
	                },
	                endOnTick: false,
	                // reversed: false,
	
	                labels: {
	                    enabled: true,
	                    // rotation: 0,
	                    // align: 'center',
	                    // step: null,
	
	                    style: {
	                        color: '#666666',
	                        cursor: 'default',
	                        fontSize: '11px'
	                    },
	
	                    x: 0
	                    //y: undefined
	                    /*formatter: function () {
	                    	return this.value;
	                    },*/
	                },
	                //linkedTo: null,
	                //max: undefined,
	                //min: undefined,
	                minPadding: 0.01,
	                maxPadding: 0.01,
	                //minRange: null,
	                //minorTickInterval: null,
	                minorTickLength: 2,
	                minorTickPosition: 'outside', // inside or outside
	                //opposite: false,
	                //offset: 0,
	                //plotBands: [{
	                //	events: {},
	                //	zIndex: 1,
	                //	labels: { align, x, verticalAlign, y, style, rotation, textAlign }
	                //}],
	                //plotLines: [{
	                //	events: {}
	                //  dashStyle: {}
	                //	zIndex:
	                //	labels: { align, x, verticalAlign, y, style, rotation, textAlign }
	                //}],
	                //reversed: false,
	                // showFirstLabel: true,
	                // showLastLabel: true,
	                startOfWeek: 1,
	                startOnTick: false,
	                //tickInterval: null,
	                tickLength: 10,
	                tickmarkPlacement: 'between', // on or between
	                tickPixelInterval: 100,
	                tickPosition: 'outside',
	                title: {
	                    //text: null,
	                    align: 'middle', // low, middle or high
	                    //margin: 0 for horizontal, 10 for vertical axes,
	                    // reserveSpace: true,
	                    //rotation: 0,
	                    //side: 'outside',
	
	                    style: {
	                        color: '#666666'
	                    }
	
	                    //x: 0,
	                    //y: 0
	                },
	                type: 'linear', // linear, logarithmic or datetime
	                //visible: true
	
	                minorGridLineColor: '#f2f2f2',
	                // minorGridLineDashStyle: null,
	                minorGridLineWidth: 1,
	                minorTickColor: '#999999',
	                //minorTickWidth: 0,
	                lineColor: '#ccd6eb',
	                lineWidth: 1,
	                gridLineColor: '#e6e6e6',
	                // gridLineDashStyle: 'solid',
	                // gridLineWidth: 0,
	                tickColor: '#ccd6eb'
	                // tickWidth: 1
	
	            },
	
	            /**
	             * This options set extends the defaultOptions for Y axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultYAxisOptions: {
	                endOnTick: true,
	                tickPixelInterval: 72,
	                showLastLabel: true,
	                labels: {
	                    x: -8
	                },
	                maxPadding: 0.05,
	                minPadding: 0.05,
	                startOnTick: true,
	                title: {
	                    rotation: 270,
	                    text: 'Values'
	                },
	                stackLabels: {
	                    enabled: false,
	                    //align: dynamic,
	                    //y: dynamic,
	                    //x: dynamic,
	                    //verticalAlign: dynamic,
	                    //textAlign: dynamic,
	                    //rotation: 0,
	                    formatter: function() {
	                        return H.numberFormat(this.total, -1);
	                    },
	
	                    style: {
	                        fontSize: '11px',
	                        fontWeight: 'bold',
	                        color: '#000000',
	                        textOutline: '1px contrast'
	                    }
	
	                },
	
	                gridLineWidth: 1,
	                lineWidth: 0
	                // tickWidth: 0
	
	            },
	
	            /**
	             * These options extend the defaultOptions for left axes.
	             * 
	             * @private
	             * @type {Object}
	             */
	            defaultLeftAxisOptions: {
	                labels: {
	                    x: -15
	                },
	                title: {
	                    rotation: 270
	                }
	            },
	
	            /**
	             * These options extend the defaultOptions for right axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultRightAxisOptions: {
	                labels: {
	                    x: 15
	                },
	                title: {
	                    rotation: 90
	                }
	            },
	
	            /**
	             * These options extend the defaultOptions for bottom axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultBottomAxisOptions: {
	                labels: {
	                    autoRotation: [-45],
	                    x: 0
	                    // overflow: undefined,
	                    // staggerLines: null
	                },
	                title: {
	                    rotation: 0
	                }
	            },
	            /**
	             * These options extend the defaultOptions for top axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultTopAxisOptions: {
	                labels: {
	                    autoRotation: [-45],
	                    x: 0
	                    // overflow: undefined
	                    // staggerLines: null
	                },
	                title: {
	                    rotation: 0
	                }
	            },
	
	            /**
	             * Initialize the axis
	             */
	            init: function(chart, userOptions) {
	
	
	                var isXAxis = userOptions.isX,
	                    axis = this;
	
	                axis.chart = chart;
	
	                // Flag, is the axis horizontal
	                axis.horiz = chart.inverted && !axis.isZAxis ? !isXAxis : isXAxis;
	
	                // Flag, isXAxis
	                axis.isXAxis = isXAxis;
	                axis.coll = axis.coll || (isXAxis ? 'xAxis' : 'yAxis');
	
	                axis.opposite = userOptions.opposite; // needed in setOptions
	                axis.side = userOptions.side || (axis.horiz ?
	                    (axis.opposite ? 0 : 2) : // top : bottom
	                    (axis.opposite ? 1 : 3)); // right : left
	
	                axis.setOptions(userOptions);
	
	
	                var options = this.options,
	                    type = options.type,
	                    isDatetimeAxis = type === 'datetime';
	
	                axis.labelFormatter = options.labels.formatter ||
	                    axis.defaultLabelFormatter; // can be overwritten by dynamic format
	
	
	                // Flag, stagger lines or not
	                axis.userOptions = userOptions;
	
	                //axis.axisTitleMargin = undefined,// = options.title.margin,
	                axis.minPixelPadding = 0;
	
	                axis.reversed = options.reversed;
	                axis.visible = options.visible !== false;
	                axis.zoomEnabled = options.zoomEnabled !== false;
	
	                // Initial categories
	                axis.hasNames = type === 'category' || options.categories === true;
	                axis.categories = options.categories || axis.hasNames;
	                axis.names = axis.names || []; // Preserve on update (#3830)
	
	                // Elements
	                //axis.axisGroup = undefined;
	                //axis.gridGroup = undefined;
	                //axis.axisTitle = undefined;
	                //axis.axisLine = undefined;
	
	                // Placeholder for plotlines and plotbands groups
	                axis.plotLinesAndBandsGroups = {};
	
	                // Shorthand types
	                axis.isLog = type === 'logarithmic';
	                axis.isDatetimeAxis = isDatetimeAxis;
	                axis.positiveValuesOnly = axis.isLog && !axis.allowNegativeLog;
	
	                // Flag, if axis is linked to another axis
	                axis.isLinked = defined(options.linkedTo);
	                // Linked axis.
	                //axis.linkedParent = undefined;
	
	                // Major ticks
	                axis.ticks = {};
	                axis.labelEdge = [];
	                // Minor ticks
	                axis.minorTicks = {};
	
	                // List of plotLines/Bands
	                axis.plotLinesAndBands = [];
	
	                // Alternate bands
	                axis.alternateBands = {};
	
	                // Axis metrics
	                //axis.left = undefined;
	                //axis.top = undefined;
	                //axis.width = undefined;
	                //axis.height = undefined;
	                //axis.bottom = undefined;
	                //axis.right = undefined;
	                //axis.transA = undefined;
	                //axis.transB = undefined;
	                //axis.oldTransA = undefined;
	                axis.len = 0;
	                //axis.oldMin = undefined;
	                //axis.oldMax = undefined;
	                //axis.oldUserMin = undefined;
	                //axis.oldUserMax = undefined;
	                //axis.oldAxisLength = undefined;
	                axis.minRange = axis.userMinRange = options.minRange || options.maxZoom;
	                axis.range = options.range;
	                axis.offset = options.offset || 0;
	
	
	                // Dictionary for stacks
	                axis.stacks = {};
	                axis.oldStacks = {};
	                axis.stacksTouched = 0;
	
	                // Min and max in the data
	                //axis.dataMin = undefined,
	                //axis.dataMax = undefined,
	
	                // The axis range
	                axis.max = null;
	                axis.min = null;
	
	                // User set min and max
	                //axis.userMin = undefined,
	                //axis.userMax = undefined,
	
	                // Crosshair options
	                axis.crosshair = pick(
	                    options.crosshair,
	                    splat(chart.options.tooltip.crosshairs)[isXAxis ? 0 : 1],
	                    false
	                );
	
	                var events = axis.options.events;
	
	                // Register. Don't add it again on Axis.update().
	                if (inArray(axis, chart.axes) === -1) { // 
	                    if (isXAxis) { // #2713
	                        chart.axes.splice(chart.xAxis.length, 0, axis);
	                    } else {
	                        chart.axes.push(axis);
	                    }
	
	                    chart[axis.coll].push(axis);
	                }
	
	                axis.series = axis.series || []; // populated by Series
	
	                // inverted charts have reversed xAxes as default
	                if (chart.inverted && !axis.isZAxis && isXAxis && axis.reversed === undefined) {
	                    axis.reversed = true;
	                }
	
	                // register event listeners
	                objectEach(events, function(event, eventType) {
	                    addEvent(axis, eventType, event);
	                });
	
	                // extend logarithmic axis
	                axis.lin2log = options.linearToLogConverter || axis.lin2log;
	                if (axis.isLog) {
	                    axis.val2lin = axis.log2lin;
	                    axis.lin2val = axis.lin2log;
	                }
	            },
	
	            /**
	             * Merge and set options
	             */
	            setOptions: function(userOptions) {
	                this.options = merge(
	                    this.defaultOptions,
	                    this.coll === 'yAxis' && this.defaultYAxisOptions, [
	                        this.defaultTopAxisOptions,
	                        this.defaultRightAxisOptions,
	                        this.defaultBottomAxisOptions,
	                        this.defaultLeftAxisOptions
	                    ][this.side],
	                    merge(
	                        defaultOptions[this.coll], // if set in setOptions (#1053)
	                        userOptions
	                    )
	                );
	            },
	
	            /**
	             * The default label formatter. The context is a special config object for
	             * the label. In apps, use the {@link
	             * https://api.highcharts.com/highcharts/xAxis.labels.formatter|
	             * labels.formatter} instead except when a modification is needed.
	             *
	             * @private
	             */
	            defaultLabelFormatter: function() {
	                var axis = this.axis,
	                    value = this.value,
	                    categories = axis.categories,
	                    dateTimeLabelFormat = this.dateTimeLabelFormat,
	                    lang = defaultOptions.lang,
	                    numericSymbols = lang.numericSymbols,
	                    numSymMagnitude = lang.numericSymbolMagnitude || 1000,
	                    i = numericSymbols && numericSymbols.length,
	                    multi,
	                    ret,
	                    formatOption = axis.options.labels.format,
	
	                    // make sure the same symbol is added for all labels on a linear
	                    // axis
	                    numericSymbolDetector = axis.isLog ?
	                    Math.abs(value) :
	                    axis.tickInterval;
	
	                if (formatOption) {
	                    ret = format(formatOption, this);
	
	                } else if (categories) {
	                    ret = value;
	
	                } else if (dateTimeLabelFormat) { // datetime axis
	                    ret = H.dateFormat(dateTimeLabelFormat, value);
	
	                } else if (i && numericSymbolDetector >= 1000) {
	                    // Decide whether we should add a numeric symbol like k (thousands)
	                    // or M (millions). If we are to enable this in tooltip or other
	                    // places as well, we can move this logic to the numberFormatter and
	                    // enable it by a parameter.
	                    while (i-- && ret === undefined) {
	                        multi = Math.pow(numSymMagnitude, i + 1);
	                        if (
	                            numericSymbolDetector >= multi &&
	                            (value * 10) % multi === 0 &&
	                            numericSymbols[i] !== null &&
	                            value !== 0
	                        ) { // #5480
	                            ret = H.numberFormat(value / multi, -1) + numericSymbols[i];
	                        }
	                    }
	                }
	
	                if (ret === undefined) {
	                    if (Math.abs(value) >= 10000) { // add thousands separators
	                        ret = H.numberFormat(value, -1);
	                    } else { // small numbers
	                        ret = H.numberFormat(value, -1, undefined, ''); // #2466
	                    }
	                }
	
	                return ret;
	            },
	
	            /**
	             * Get the minimum and maximum for the series of each axis
	             */
	            getSeriesExtremes: function() {
	                var axis = this,
	                    chart = axis.chart;
	                axis.hasVisibleSeries = false;
	
	                // Reset properties in case we're redrawing (#3353)
	                axis.dataMin = axis.dataMax = axis.threshold = null;
	                axis.softThreshold = !axis.isXAxis;
	
	                if (axis.buildStacks) {
	                    axis.buildStacks();
	                }
	
	                // loop through this axis' series
	                each(axis.series, function(series) {
	
	                    if (series.visible || !chart.options.chart.ignoreHiddenSeries) {
	
	                        var seriesOptions = series.options,
	                            xData,
	                            threshold = seriesOptions.threshold,
	                            seriesDataMin,
	                            seriesDataMax;
	
	                        axis.hasVisibleSeries = true;
	
	                        // Validate threshold in logarithmic axes
	                        if (axis.positiveValuesOnly && threshold <= 0) {
	                            threshold = null;
	                        }
	
	                        // Get dataMin and dataMax for X axes
	                        if (axis.isXAxis) {
	                            xData = series.xData;
	                            if (xData.length) {
	                                // If xData contains values which is not numbers, then
	                                // filter them out. To prevent performance hit, we only
	                                // do this after we have already found seriesDataMin
	                                // because in most cases all data is valid. #5234.
	                                seriesDataMin = arrayMin(xData);
	                                if (!isNumber(seriesDataMin) &&
	                                    !(seriesDataMin instanceof Date) // #5010
	                                ) {
	                                    xData = grep(xData, function(x) {
	                                        return isNumber(x);
	                                    });
	                                    seriesDataMin = arrayMin(xData); // Do it again with valid data
	                                }
	
	                                axis.dataMin = Math.min(
	                                    pick(axis.dataMin, xData[0]),
	                                    seriesDataMin
	                                );
	                                axis.dataMax = Math.max(
	                                    pick(axis.dataMax, xData[0]),
	                                    arrayMax(xData)
	                                );
	
	                            }
	
	                            // Get dataMin and dataMax for Y axes, as well as handle
	                            // stacking and processed data
	                        } else {
	
	                            // Get this particular series extremes
	                            series.getExtremes();
	                            seriesDataMax = series.dataMax;
	                            seriesDataMin = series.dataMin;
	
	                            // Get the dataMin and dataMax so far. If percentage is
	                            // used, the min and max are always 0 and 100. If
	                            // seriesDataMin and seriesDataMax is null, then series
	                            // doesn't have active y data, we continue with nulls
	                            if (defined(seriesDataMin) && defined(seriesDataMax)) {
	                                axis.dataMin = Math.min(
	                                    pick(axis.dataMin, seriesDataMin),
	                                    seriesDataMin
	                                );
	                                axis.dataMax = Math.max(
	                                    pick(axis.dataMax, seriesDataMax),
	                                    seriesDataMax
	                                );
	                            }
	
	                            // Adjust to threshold
	                            if (defined(threshold)) {
	                                axis.threshold = threshold;
	                            }
	                            // If any series has a hard threshold, it takes precedence
	                            if (!seriesOptions.softThreshold ||
	                                axis.positiveValuesOnly
	                            ) {
	                                axis.softThreshold = false;
	                            }
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Translate from axis value to pixel position on the chart, or back
	             *
	             */
	            translate: function(val, backwards, cvsCoord, old, handleLog, pointPlacement) {
	                var axis = this.linkedParent || this, // #1417
	                    sign = 1,
	                    cvsOffset = 0,
	                    localA = old ? axis.oldTransA : axis.transA,
	                    localMin = old ? axis.oldMin : axis.min,
	                    returnValue,
	                    minPixelPadding = axis.minPixelPadding,
	                    doPostTranslate = (axis.isOrdinal || axis.isBroken || (axis.isLog && handleLog)) && axis.lin2val;
	
	                if (!localA) {
	                    localA = axis.transA;
	                }
	
	                // In vertical axes, the canvas coordinates start from 0 at the top like in
	                // SVG.
	                if (cvsCoord) {
	                    sign *= -1; // canvas coordinates inverts the value
	                    cvsOffset = axis.len;
	                }
	
	                // Handle reversed axis
	                if (axis.reversed) {
	                    sign *= -1;
	                    cvsOffset -= sign * (axis.sector || axis.len);
	                }
	
	                // From pixels to value
	                if (backwards) { // reverse translation
	
	                    val = val * sign + cvsOffset;
	                    val -= minPixelPadding;
	                    returnValue = val / localA + localMin; // from chart pixel to value
	                    if (doPostTranslate) { // log and ordinal axes
	                        returnValue = axis.lin2val(returnValue);
	                    }
	
	                    // From value to pixels
	                } else {
	                    if (doPostTranslate) { // log and ordinal axes
	                        val = axis.val2lin(val);
	                    }
	                    returnValue = sign * (val - localMin) * localA + cvsOffset +
	                        (sign * minPixelPadding) +
	                        (isNumber(pointPlacement) ? localA * pointPlacement : 0);
	                }
	
	                return returnValue;
	            },
	
	            /**
	             * Translate a value in terms of axis units into pixels within the chart.
	             * 
	             * @param  {Number} value
	             *         A value in terms of axis units.
	             * @param  {Boolean} paneCoordinates
	             *         Whether to return the pixel coordinate relative to the chart or
	             *         just the axis/pane itself.
	             * @return {Number} Pixel position of the value on the chart or axis.
	             */
	            toPixels: function(value, paneCoordinates) {
	                return this.translate(value, false, !this.horiz, null, true) +
	                    (paneCoordinates ? 0 : this.pos);
	            },
	
	            /**
	             * Translate a pixel position along the axis to a value in terms of axis
	             * units.
	             * @param  {Number} pixel
	             *         The pixel value coordinate.
	             * @param  {Boolean} paneCoordiantes
	             *         Whether the input pixel is relative to the chart or just the
	             *         axis/pane itself.
	             * @return {Number} The axis value.
	             */
	            toValue: function(pixel, paneCoordinates) {
	                return this.translate(
	                    pixel - (paneCoordinates ? 0 : this.pos),
	                    true, !this.horiz,
	                    null,
	                    true
	                );
	            },
	
	            /**
	             * Create the path for a plot line that goes from the given value on
	             * this axis, across the plot to the opposite side
	             * @param {Number} value
	             * @param {Number} lineWidth Used for calculation crisp line
	             * @param {Number] old Use old coordinates (for resizing and rescaling)
	             */
	            getPlotLinePath: function(value, lineWidth, old, force, translatedValue) {
	                var axis = this,
	                    chart = axis.chart,
	                    axisLeft = axis.left,
	                    axisTop = axis.top,
	                    x1,
	                    y1,
	                    x2,
	                    y2,
	                    cHeight = (old && chart.oldChartHeight) || chart.chartHeight,
	                    cWidth = (old && chart.oldChartWidth) || chart.chartWidth,
	                    skip,
	                    transB = axis.transB,
	                    /**
	                     * Check if x is between a and b. If not, either move to a/b or skip,
	                     * depending on the force parameter.
	                     */
	                    between = function(x, a, b) {
	                        if (x < a || x > b) {
	                            if (force) {
	                                x = Math.min(Math.max(a, x), b);
	                            } else {
	                                skip = true;
	                            }
	                        }
	                        return x;
	                    };
	
	                translatedValue = pick(translatedValue, axis.translate(value, null, null, old));
	                x1 = x2 = Math.round(translatedValue + transB);
	                y1 = y2 = Math.round(cHeight - translatedValue - transB);
	                if (!isNumber(translatedValue)) { // no min or max
	                    skip = true;
	
	                } else if (axis.horiz) {
	                    y1 = axisTop;
	                    y2 = cHeight - axis.bottom;
	                    x1 = x2 = between(x1, axisLeft, axisLeft + axis.width);
	                } else {
	                    x1 = axisLeft;
	                    x2 = cWidth - axis.right;
	                    y1 = y2 = between(y1, axisTop, axisTop + axis.height);
	                }
	                return skip && !force ?
	                    null :
	                    chart.renderer.crispLine(['M', x1, y1, 'L', x2, y2], lineWidth || 1);
	            },
	
	            /**
	             * Internal function to et the tick positions of a linear axis to round
	             * values like whole tens or every five.
	             *
	             * @param  {Number} tickInterval
	             *         The normalized tick interval
	             * @param  {Number} min
	             *         Axis minimum.
	             * @param  {Number} max
	             *         Axis maximum.
	             *
	             * @return {Array.<Number>}
	             *         An array of numbers where ticks should be placed.
	             */
	            getLinearTickPositions: function(tickInterval, min, max) {
	                var pos,
	                    lastPos,
	                    roundedMin = correctFloat(Math.floor(min / tickInterval) * tickInterval),
	                    roundedMax = correctFloat(Math.ceil(max / tickInterval) * tickInterval),
	                    tickPositions = [];
	
	                // For single points, add a tick regardless of the relative position
	                // (#2662, #6274)
	                if (this.single) {
	                    return [min];
	                }
	
	                // Populate the intermediate values
	                pos = roundedMin;
	                while (pos <= roundedMax) {
	
	                    // Place the tick on the rounded value
	                    tickPositions.push(pos);
	
	                    // Always add the raw tickInterval, not the corrected one.
	                    pos = correctFloat(pos + tickInterval);
	
	                    // If the interval is not big enough in the current min - max range to actually increase
	                    // the loop variable, we need to break out to prevent endless loop. Issue #619
	                    if (pos === lastPos) {
	                        break;
	                    }
	
	                    // Record the last value
	                    lastPos = pos;
	                }
	                return tickPositions;
	            },
	
	            /**
	             * Return the minor tick positions. For logarithmic axes, reuse the same logic
	             * as for major ticks.
	             */
	            getMinorTickPositions: function() {
	                var axis = this,
	                    options = axis.options,
	                    tickPositions = axis.tickPositions,
	                    minorTickInterval = axis.minorTickInterval,
	                    minorTickPositions = [],
	                    pos,
	                    pointRangePadding = axis.pointRangePadding || 0,
	                    min = axis.min - pointRangePadding, // #1498
	                    max = axis.max + pointRangePadding, // #1498
	                    range = max - min;
	
	                // If minor ticks get too dense, they are hard to read, and may cause long running script. So we don't draw them.
	                if (range && range / minorTickInterval < axis.len / 3) { // #3875
	
	                    if (axis.isLog) {
	                        // For each interval in the major ticks, compute the minor ticks
	                        // separately.
	                        each(this.paddedTicks, function(pos, i, paddedTicks) {
	                            if (i) {
	                                minorTickPositions.push.apply(
	                                    minorTickPositions,
	                                    axis.getLogTickPositions(
	                                        minorTickInterval,
	                                        paddedTicks[i - 1],
	                                        paddedTicks[i],
	                                        true
	                                    )
	                                );
	                            }
	                        });
	
	                    } else if (axis.isDatetimeAxis && options.minorTickInterval === 'auto') { // #1314
	                        minorTickPositions = minorTickPositions.concat(
	                            axis.getTimeTicks(
	                                axis.normalizeTimeTickInterval(minorTickInterval),
	                                min,
	                                max,
	                                options.startOfWeek
	                            )
	                        );
	                    } else {
	                        for (
	                            pos = min + (tickPositions[0] - min) % minorTickInterval; pos <= max; pos += minorTickInterval
	                        ) {
	                            // Very, very, tight grid lines (#5771)
	                            if (pos === minorTickPositions[0]) {
	                                break;
	                            }
	                            minorTickPositions.push(pos);
	                        }
	                    }
	                }
	
	                if (minorTickPositions.length !== 0) {
	                    axis.trimTicks(minorTickPositions); // #3652 #3743 #1498 #6330
	                }
	                return minorTickPositions;
	            },
	
	            /**
	             * Adjust the min and max for the minimum range. Keep in mind that the series data is
	             * not yet processed, so we don't have information on data cropping and grouping, or
	             * updated axis.pointRange or series.pointRange. The data can't be processed until
	             * we have finally established min and max.
	             *
	             * @private
	             */
	            adjustForMinRange: function() {
	                var axis = this,
	                    options = axis.options,
	                    min = axis.min,
	                    max = axis.max,
	                    zoomOffset,
	                    spaceAvailable,
	                    closestDataRange,
	                    i,
	                    distance,
	                    xData,
	                    loopLength,
	                    minArgs,
	                    maxArgs,
	                    minRange;
	
	                // Set the automatic minimum range based on the closest point distance
	                if (axis.isXAxis && axis.minRange === undefined && !axis.isLog) {
	
	                    if (defined(options.min) || defined(options.max)) {
	                        axis.minRange = null; // don't do this again
	
	                    } else {
	
	                        // Find the closest distance between raw data points, as opposed to
	                        // closestPointRange that applies to processed points (cropped and grouped)
	                        each(axis.series, function(series) {
	                            xData = series.xData;
	                            loopLength = series.xIncrement ? 1 : xData.length - 1;
	                            for (i = loopLength; i > 0; i--) {
	                                distance = xData[i] - xData[i - 1];
	                                if (closestDataRange === undefined || distance < closestDataRange) {
	                                    closestDataRange = distance;
	                                }
	                            }
	                        });
	                        axis.minRange = Math.min(closestDataRange * 5, axis.dataMax - axis.dataMin);
	                    }
	                }
	
	                // if minRange is exceeded, adjust
	                if (max - min < axis.minRange) {
	
	                    spaceAvailable = axis.dataMax - axis.dataMin >= axis.minRange;
	                    minRange = axis.minRange;
	                    zoomOffset = (minRange - max + min) / 2;
	
	                    // if min and max options have been set, don't go beyond it
	                    minArgs = [min - zoomOffset, pick(options.min, min - zoomOffset)];
	                    if (spaceAvailable) { // if space is available, stay within the data range
	                        minArgs[2] = axis.isLog ? axis.log2lin(axis.dataMin) : axis.dataMin;
	                    }
	                    min = arrayMax(minArgs);
	
	                    maxArgs = [min + minRange, pick(options.max, min + minRange)];
	                    if (spaceAvailable) { // if space is availabe, stay within the data range
	                        maxArgs[2] = axis.isLog ? axis.log2lin(axis.dataMax) : axis.dataMax;
	                    }
	
	                    max = arrayMin(maxArgs);
	
	                    // now if the max is adjusted, adjust the min back
	                    if (max - min < minRange) {
	                        minArgs[0] = max - minRange;
	                        minArgs[1] = pick(options.min, max - minRange);
	                        min = arrayMax(minArgs);
	                    }
	                }
	
	                // Record modified extremes
	                axis.min = min;
	                axis.max = max;
	            },
	
	            /**
	             * Find the closestPointRange across all series.
	             *
	             * @private
	             */
	            getClosest: function() {
	                var ret;
	
	                if (this.categories) {
	                    ret = 1;
	                } else {
	                    each(this.series, function(series) {
	                        var seriesClosest = series.closestPointRange,
	                            visible = series.visible ||
	                            !series.chart.options.chart.ignoreHiddenSeries;
	
	                        if (!series.noSharedTooltip &&
	                            defined(seriesClosest) &&
	                            visible
	                        ) {
	                            ret = defined(ret) ?
	                                Math.min(ret, seriesClosest) :
	                                seriesClosest;
	                        }
	                    });
	                }
	                return ret;
	            },
	
	            /**
	             * When a point name is given and no x, search for the name in the existing categories,
	             * or if categories aren't provided, search names or create a new category (#2522).
	             */
	            nameToX: function(point) {
	                var explicitCategories = isArray(this.categories),
	                    names = explicitCategories ? this.categories : this.names,
	                    nameX = point.options.x,
	                    x;
	
	                point.series.requireSorting = false;
	
	                if (!defined(nameX)) {
	                    nameX = this.options.uniqueNames === false ?
	                        point.series.autoIncrement() :
	                        inArray(point.name, names);
	                }
	                if (nameX === -1) { // The name is not found in currenct categories
	                    if (!explicitCategories) {
	                        x = names.length;
	                    }
	                } else {
	                    x = nameX;
	                }
	
	                // Write the last point's name to the names array
	                if (x !== undefined) {
	                    this.names[x] = point.name;
	                }
	
	                return x;
	            },
	
	            /**
	             * When changes have been done to series data, update the axis.names.
	             */
	            updateNames: function() {
	                var axis = this;
	
	                if (this.names.length > 0) {
	                    this.names.length = 0;
	                    this.minRange = this.userMinRange; // Reset
	                    each(this.series || [], function(series) {
	
	                        // Reset incrementer (#5928)
	                        series.xIncrement = null;
	
	                        // When adding a series, points are not yet generated
	                        if (!series.points || series.isDirtyData) {
	                            series.processData();
	                            series.generatePoints();
	                        }
	
	                        each(series.points, function(point, i) {
	                            var x;
	                            if (point.options) {
	                                x = axis.nameToX(point);
	                                if (x !== undefined && x !== point.x) {
	                                    point.x = x;
	                                    series.xData[i] = x;
	                                }
	                            }
	                        });
	                    });
	                }
	            },
	
	            /**
	             * Update translation information
	             */
	            setAxisTranslation: function(saveOld) {
	                var axis = this,
	                    range = axis.max - axis.min,
	                    pointRange = axis.axisPointRange || 0,
	                    closestPointRange,
	                    minPointOffset = 0,
	                    pointRangePadding = 0,
	                    linkedParent = axis.linkedParent,
	                    ordinalCorrection,
	                    hasCategories = !!axis.categories,
	                    transA = axis.transA,
	                    isXAxis = axis.isXAxis;
	
	                // Adjust translation for padding. Y axis with categories need to go through the same (#1784).
	                if (isXAxis || hasCategories || pointRange) {
	
	                    // Get the closest points
	                    closestPointRange = axis.getClosest();
	
	                    if (linkedParent) {
	                        minPointOffset = linkedParent.minPointOffset;
	                        pointRangePadding = linkedParent.pointRangePadding;
	                    } else {
	                        each(axis.series, function(series) {
	                            var seriesPointRange = hasCategories ?
	                                1 :
	                                (isXAxis ?
	                                    pick(series.options.pointRange, closestPointRange, 0) :
	                                    (axis.axisPointRange || 0)), // #2806
	                                pointPlacement = series.options.pointPlacement;
	
	                            pointRange = Math.max(pointRange, seriesPointRange);
	
	                            if (!axis.single) {
	                                // minPointOffset is the value padding to the left of the axis in order to make
	                                // room for points with a pointRange, typically columns. When the pointPlacement option
	                                // is 'between' or 'on', this padding does not apply.
	                                minPointOffset = Math.max(
	                                    minPointOffset,
	                                    isString(pointPlacement) ? 0 : seriesPointRange / 2
	                                );
	
	                                // Determine the total padding needed to the length of the axis to make room for the
	                                // pointRange. If the series' pointPlacement is 'on', no padding is added.
	                                pointRangePadding = Math.max(
	                                    pointRangePadding,
	                                    pointPlacement === 'on' ? 0 : seriesPointRange
	                                );
	                            }
	                        });
	                    }
	
	                    // Record minPointOffset and pointRangePadding
	                    ordinalCorrection = axis.ordinalSlope && closestPointRange ? axis.ordinalSlope / closestPointRange : 1; // #988, #1853
	                    axis.minPointOffset = minPointOffset = minPointOffset * ordinalCorrection;
	                    axis.pointRangePadding = pointRangePadding = pointRangePadding * ordinalCorrection;
	
	                    // pointRange means the width reserved for each point, like in a column chart
	                    axis.pointRange = Math.min(pointRange, range);
	
	                    // closestPointRange means the closest distance between points. In columns
	                    // it is mostly equal to pointRange, but in lines pointRange is 0 while closestPointRange
	                    // is some other value
	                    if (isXAxis) {
	                        axis.closestPointRange = closestPointRange;
	                    }
	                }
	
	                // Secondary values
	                if (saveOld) {
	                    axis.oldTransA = transA;
	                }
	                axis.translationSlope = axis.transA = transA =
	                    axis.options.staticScale ||
	                    axis.len / ((range + pointRangePadding) || 1);
	                axis.transB = axis.horiz ? axis.left : axis.bottom; // translation addend
	                axis.minPixelPadding = transA * minPointOffset;
	            },
	
	            minFromRange: function() {
	                return this.max - this.range;
	            },
	
	            /**
	             * Set the tick positions to round values and optionally extend the extremes
	             * to the nearest tick
	             */
	            setTickInterval: function(secondPass) {
	                var axis = this,
	                    chart = axis.chart,
	                    options = axis.options,
	                    isLog = axis.isLog,
	                    log2lin = axis.log2lin,
	                    isDatetimeAxis = axis.isDatetimeAxis,
	                    isXAxis = axis.isXAxis,
	                    isLinked = axis.isLinked,
	                    maxPadding = options.maxPadding,
	                    minPadding = options.minPadding,
	                    length,
	                    linkedParentExtremes,
	                    tickIntervalOption = options.tickInterval,
	                    minTickInterval,
	                    tickPixelIntervalOption = options.tickPixelInterval,
	                    categories = axis.categories,
	                    threshold = axis.threshold,
	                    softThreshold = axis.softThreshold,
	                    thresholdMin,
	                    thresholdMax,
	                    hardMin,
	                    hardMax;
	
	                if (!isDatetimeAxis && !categories && !isLinked) {
	                    this.getTickAmount();
	                }
	
	                // Min or max set either by zooming/setExtremes or initial options
	                hardMin = pick(axis.userMin, options.min);
	                hardMax = pick(axis.userMax, options.max);
	
	                // Linked axis gets the extremes from the parent axis
	                if (isLinked) {
	                    axis.linkedParent = chart[axis.coll][options.linkedTo];
	                    linkedParentExtremes = axis.linkedParent.getExtremes();
	                    axis.min = pick(linkedParentExtremes.min, linkedParentExtremes.dataMin);
	                    axis.max = pick(linkedParentExtremes.max, linkedParentExtremes.dataMax);
	                    if (options.type !== axis.linkedParent.options.type) {
	                        H.error(11, 1); // Can't link axes of different type
	                    }
	
	                    // Initial min and max from the extreme data values
	                } else {
	
	                    // Adjust to hard threshold
	                    if (!softThreshold && defined(threshold)) {
	                        if (axis.dataMin >= threshold) {
	                            thresholdMin = threshold;
	                            minPadding = 0;
	                        } else if (axis.dataMax <= threshold) {
	                            thresholdMax = threshold;
	                            maxPadding = 0;
	                        }
	                    }
	
	                    axis.min = pick(hardMin, thresholdMin, axis.dataMin);
	                    axis.max = pick(hardMax, thresholdMax, axis.dataMax);
	
	                }
	
	                if (isLog) {
	                    if (
	                        axis.positiveValuesOnly &&
	                        !secondPass &&
	                        Math.min(axis.min, pick(axis.dataMin, axis.min)) <= 0
	                    ) { // #978
	                        H.error(10, 1); // Can't plot negative values on log axis
	                    }
	                    // The correctFloat cures #934, float errors on full tens. But it
	                    // was too aggressive for #4360 because of conversion back to lin,
	                    // therefore use precision 15.
	                    axis.min = correctFloat(log2lin(axis.min), 15);
	                    axis.max = correctFloat(log2lin(axis.max), 15);
	                }
	
	                // handle zoomed range
	                if (axis.range && defined(axis.max)) {
	                    axis.userMin = axis.min = hardMin = Math.max(axis.min, axis.minFromRange()); // #618
	                    axis.userMax = hardMax = axis.max;
	
	                    axis.range = null; // don't use it when running setExtremes
	                }
	
	                // Hook for Highstock Scroller. Consider combining with beforePadding.
	                fireEvent(axis, 'foundExtremes');
	
	                // Hook for adjusting this.min and this.max. Used by bubble series.
	                if (axis.beforePadding) {
	                    axis.beforePadding();
	                }
	
	                // adjust min and max for the minimum range
	                axis.adjustForMinRange();
	
	                // Pad the values to get clear of the chart's edges. To avoid tickInterval taking the padding
	                // into account, we do this after computing tick interval (#1337).
	                if (!categories && !axis.axisPointRange && !axis.usePercentage && !isLinked && defined(axis.min) && defined(axis.max)) {
	                    length = axis.max - axis.min;
	                    if (length) {
	                        if (!defined(hardMin) && minPadding) {
	                            axis.min -= length * minPadding;
	                        }
	                        if (!defined(hardMax) && maxPadding) {
	                            axis.max += length * maxPadding;
	                        }
	                    }
	                }
	
	                // Handle options for floor, ceiling, softMin and softMax (#6359)
	                if (isNumber(options.softMin)) {
	                    axis.min = Math.min(axis.min, options.softMin);
	                }
	                if (isNumber(options.softMax)) {
	                    axis.max = Math.max(axis.max, options.softMax);
	                }
	                if (isNumber(options.floor)) {
	                    axis.min = Math.max(axis.min, options.floor);
	                }
	                if (isNumber(options.ceiling)) {
	                    axis.max = Math.min(axis.max, options.ceiling);
	                }
	
	
	                // When the threshold is soft, adjust the extreme value only if
	                // the data extreme and the padded extreme land on either side of the threshold. For example,
	                // a series of [0, 1, 2, 3] would make the yAxis add a tick for -1 because of the
	                // default minPadding and startOnTick options. This is prevented by the softThreshold
	                // option.
	                if (softThreshold && defined(axis.dataMin)) {
	                    threshold = threshold || 0;
	                    if (!defined(hardMin) && axis.min < threshold && axis.dataMin >= threshold) {
	                        axis.min = threshold;
	                    } else if (!defined(hardMax) && axis.max > threshold && axis.dataMax <= threshold) {
	                        axis.max = threshold;
	                    }
	                }
	
	
	                // get tickInterval
	                if (axis.min === axis.max || axis.min === undefined || axis.max === undefined) {
	                    axis.tickInterval = 1;
	                } else if (isLinked && !tickIntervalOption &&
	                    tickPixelIntervalOption === axis.linkedParent.options.tickPixelInterval) {
	                    axis.tickInterval = tickIntervalOption = axis.linkedParent.tickInterval;
	                } else {
	                    axis.tickInterval = pick(
	                        tickIntervalOption,
	                        this.tickAmount ? ((axis.max - axis.min) / Math.max(this.tickAmount - 1, 1)) : undefined,
	                        categories ? // for categoried axis, 1 is default, for linear axis use tickPix
	                        1 :
	                        // don't let it be more than the data range
	                        (axis.max - axis.min) * tickPixelIntervalOption / Math.max(axis.len, tickPixelIntervalOption)
	                    );
	                }
	
	                // Now we're finished detecting min and max, crop and group series data. This
	                // is in turn needed in order to find tick positions in ordinal axes.
	                if (isXAxis && !secondPass) {
	                    each(axis.series, function(series) {
	                        series.processData(axis.min !== axis.oldMin || axis.max !== axis.oldMax);
	                    });
	                }
	
	                // set the translation factor used in translate function
	                axis.setAxisTranslation(true);
	
	                // hook for ordinal axes and radial axes
	                if (axis.beforeSetTickPositions) {
	                    axis.beforeSetTickPositions();
	                }
	
	                // hook for extensions, used in Highstock ordinal axes
	                if (axis.postProcessTickInterval) {
	                    axis.tickInterval = axis.postProcessTickInterval(axis.tickInterval);
	                }
	
	                // In column-like charts, don't cramp in more ticks than there are points (#1943, #4184)
	                if (axis.pointRange && !tickIntervalOption) {
	                    axis.tickInterval = Math.max(axis.pointRange, axis.tickInterval);
	                }
	
	                // Before normalizing the tick interval, handle minimum tick interval. This applies only if tickInterval is not defined.
	                minTickInterval = pick(options.minTickInterval, axis.isDatetimeAxis && axis.closestPointRange);
	                if (!tickIntervalOption && axis.tickInterval < minTickInterval) {
	                    axis.tickInterval = minTickInterval;
	                }
	
	                // for linear axes, get magnitude and normalize the interval
	                if (!isDatetimeAxis && !isLog && !tickIntervalOption) {
	                    axis.tickInterval = normalizeTickInterval(
	                        axis.tickInterval,
	                        null,
	                        getMagnitude(axis.tickInterval),
	                        // If the tick interval is between 0.5 and 5 and the axis max is in the order of
	                        // thousands, chances are we are dealing with years. Don't allow decimals. #3363.
	                        pick(options.allowDecimals, !(axis.tickInterval > 0.5 && axis.tickInterval < 5 && axis.max > 1000 && axis.max < 9999)), !!this.tickAmount
	                    );
	                }
	
	                // Prevent ticks from getting so close that we can't draw the labels
	                if (!this.tickAmount) {
	                    axis.tickInterval = axis.unsquish();
	                }
	
	                this.setTickPositions();
	            },
	
	            /**
	             * Now we have computed the normalized tickInterval, get the tick positions
	             */
	            setTickPositions: function() {
	
	                var options = this.options,
	                    tickPositions,
	                    tickPositionsOption = options.tickPositions,
	                    tickPositioner = options.tickPositioner,
	                    startOnTick = options.startOnTick,
	                    endOnTick = options.endOnTick;
	
	                // Set the tickmarkOffset
	                this.tickmarkOffset = (this.categories && options.tickmarkPlacement === 'between' &&
	                    this.tickInterval === 1) ? 0.5 : 0; // #3202
	
	
	                // get minorTickInterval
	                this.minorTickInterval = options.minorTickInterval === 'auto' && this.tickInterval ?
	                    this.tickInterval / 5 : options.minorTickInterval;
	
	                // When there is only one point, or all points have the same value on
	                // this axis, then min and max are equal and tickPositions.length is 0
	                // or 1. In this case, add some padding in order to center the point,
	                // but leave it with one tick. #1337.
	                this.single =
	                    this.min === this.max &&
	                    defined(this.min) &&
	                    !this.tickAmount &&
	                    (
	                        // Data is on integer (#6563)
	                        parseInt(this.min, 10) === this.min ||
	
	                        // Between integers and decimals are not allowed (#6274)
	                        options.allowDecimals !== false
	                    );
	
	                // Find the tick positions
	                this.tickPositions = tickPositions = tickPositionsOption && tickPositionsOption.slice(); // Work on a copy (#1565)
	                if (!tickPositions) {
	
	                    if (this.isDatetimeAxis) {
	                        tickPositions = this.getTimeTicks(
	                            this.normalizeTimeTickInterval(
	                                this.tickInterval,
	                                options.units
	                            ),
	                            this.min,
	                            this.max,
	                            options.startOfWeek,
	                            this.ordinalPositions,
	                            this.closestPointRange,
	                            true
	                        );
	                    } else if (this.isLog) {
	                        tickPositions = this.getLogTickPositions(
	                            this.tickInterval,
	                            this.min,
	                            this.max
	                        );
	                    } else {
	                        tickPositions = this.getLinearTickPositions(
	                            this.tickInterval,
	                            this.min,
	                            this.max
	                        );
	                    }
	
	                    // Too dense ticks, keep only the first and last (#4477)
	                    if (tickPositions.length > this.len) {
	                        tickPositions = [tickPositions[0], tickPositions.pop()];
	                    }
	
	                    this.tickPositions = tickPositions;
	
	                    // Run the tick positioner callback, that allows modifying auto tick positions.
	                    if (tickPositioner) {
	                        tickPositioner = tickPositioner.apply(this, [this.min, this.max]);
	                        if (tickPositioner) {
	                            this.tickPositions = tickPositions = tickPositioner;
	                        }
	                    }
	
	                }
	
	                // Reset min/max or remove extremes based on start/end on tick
	                this.paddedTicks = tickPositions.slice(0); // Used for logarithmic minor
	                this.trimTicks(tickPositions, startOnTick, endOnTick);
	                if (!this.isLinked) {
	
	                    // Substract half a unit (#2619, #2846, #2515, #3390)
	                    if (this.single) {
	                        this.min -= 0.5;
	                        this.max += 0.5;
	                    }
	                    if (!tickPositionsOption && !tickPositioner) {
	                        this.adjustTickAmount();
	                    }
	                }
	            },
	
	            /**
	             * Handle startOnTick and endOnTick by either adapting to padding min/max or rounded min/max
	             */
	            trimTicks: function(tickPositions, startOnTick, endOnTick) {
	                var roundedMin = tickPositions[0],
	                    roundedMax = tickPositions[tickPositions.length - 1],
	                    minPointOffset = this.minPointOffset || 0;
	
	                if (!this.isLinked) {
	                    if (startOnTick && roundedMin !== -Infinity) { // #6502
	                        this.min = roundedMin;
	                    } else {
	                        while (this.min - minPointOffset > tickPositions[0]) {
	                            tickPositions.shift();
	                        }
	                    }
	
	                    if (endOnTick) {
	                        this.max = roundedMax;
	                    } else {
	                        while (this.max + minPointOffset < tickPositions[tickPositions.length - 1]) {
	                            tickPositions.pop();
	                        }
	                    }
	
	                    // If no tick are left, set one tick in the middle (#3195)
	                    if (tickPositions.length === 0 && defined(roundedMin)) {
	                        tickPositions.push((roundedMax + roundedMin) / 2);
	                    }
	                }
	            },
	
	            /**
	             * Check if there are multiple axes in the same pane.
	             *
	             * @private
	             * @return {Boolean}
	             *         True if there are other axes.
	             */
	            alignToOthers: function() {
	                var others = {}, // Whether there is another axis to pair with this one
	                    hasOther,
	                    options = this.options;
	
	                if (
	                    // Only if alignTicks is true
	                    this.chart.options.chart.alignTicks !== false &&
	                    options.alignTicks !== false &&
	
	                    // Don't try to align ticks on a log axis, they are not evenly
	                    // spaced (#6021)
	                    !this.isLog
	                ) {
	                    each(this.chart[this.coll], function(axis) {
	                        var otherOptions = axis.options,
	                            horiz = axis.horiz,
	                            key = [
	                                horiz ? otherOptions.left : otherOptions.top,
	                                otherOptions.width,
	                                otherOptions.height,
	                                otherOptions.pane
	                            ].join(',');
	
	
	                        if (axis.series.length) { // #4442
	                            if (others[key]) {
	                                hasOther = true; // #4201
	                            } else {
	                                others[key] = 1;
	                            }
	                        }
	                    });
	                }
	                return hasOther;
	            },
	
	            /**
	             * Set the max ticks of either the x and y axis collection
	             */
	            getTickAmount: function() {
	                var options = this.options,
	                    tickAmount = options.tickAmount,
	                    tickPixelInterval = options.tickPixelInterval;
	
	                if (!defined(options.tickInterval) && this.len < tickPixelInterval && !this.isRadial &&
	                    !this.isLog && options.startOnTick && options.endOnTick) {
	                    tickAmount = 2;
	                }
	
	                if (!tickAmount && this.alignToOthers()) {
	                    // Add 1 because 4 tick intervals require 5 ticks (including first and last)
	                    tickAmount = Math.ceil(this.len / tickPixelInterval) + 1;
	                }
	
	                // For tick amounts of 2 and 3, compute five ticks and remove the intermediate ones. This
	                // prevents the axis from adding ticks that are too far away from the data extremes.
	                if (tickAmount < 4) {
	                    this.finalTickAmt = tickAmount;
	                    tickAmount = 5;
	                }
	
	                this.tickAmount = tickAmount;
	            },
	
	            /**
	             * When using multiple axes, adjust the number of ticks to match the highest
	             * number of ticks in that group.
	             *
	             * @private
	             */
	            adjustTickAmount: function() {
	                var tickInterval = this.tickInterval,
	                    tickPositions = this.tickPositions,
	                    tickAmount = this.tickAmount,
	                    finalTickAmt = this.finalTickAmt,
	                    currentTickAmount = tickPositions && tickPositions.length,
	                    i,
	                    len;
	
	                if (currentTickAmount < tickAmount) {
	                    while (tickPositions.length < tickAmount) {
	                        tickPositions.push(correctFloat(
	                            tickPositions[tickPositions.length - 1] + tickInterval
	                        ));
	                    }
	                    this.transA *= (currentTickAmount - 1) / (tickAmount - 1);
	                    this.max = tickPositions[tickPositions.length - 1];
	
	                    // We have too many ticks, run second pass to try to reduce ticks
	                } else if (currentTickAmount > tickAmount) {
	                    this.tickInterval *= 2;
	                    this.setTickPositions();
	                }
	
	                // The finalTickAmt property is set in getTickAmount
	                if (defined(finalTickAmt)) {
	                    i = len = tickPositions.length;
	                    while (i--) {
	                        if (
	                            (finalTickAmt === 3 && i % 2 === 1) || // Remove every other tick
	                            (finalTickAmt <= 2 && i > 0 && i < len - 1) // Remove all but first and last
	                        ) {
	                            tickPositions.splice(i, 1);
	                        }
	                    }
	                    this.finalTickAmt = undefined;
	                }
	            },
	
	            /**
	             * Set the scale based on data min and max, user set min and max or options
	             *
	             */
	            setScale: function() {
	                var axis = this,
	                    isDirtyData,
	                    isDirtyAxisLength;
	
	                axis.oldMin = axis.min;
	                axis.oldMax = axis.max;
	                axis.oldAxisLength = axis.len;
	
	                // set the new axisLength
	                axis.setAxisSize();
	                //axisLength = horiz ? axisWidth : axisHeight;
	                isDirtyAxisLength = axis.len !== axis.oldAxisLength;
	
	                // is there new data?
	                each(axis.series, function(series) {
	                    if (series.isDirtyData || series.isDirty ||
	                        series.xAxis.isDirty) { // when x axis is dirty, we need new data extremes for y as well
	                        isDirtyData = true;
	                    }
	                });
	
	                // do we really need to go through all this?
	                if (isDirtyAxisLength || isDirtyData || axis.isLinked || axis.forceRedraw ||
	                    axis.userMin !== axis.oldUserMin || axis.userMax !== axis.oldUserMax || axis.alignToOthers()) {
	
	                    if (axis.resetStacks) {
	                        axis.resetStacks();
	                    }
	
	                    axis.forceRedraw = false;
	
	                    // get data extremes if needed
	                    axis.getSeriesExtremes();
	
	                    // get fixed positions based on tickInterval
	                    axis.setTickInterval();
	
	                    // record old values to decide whether a rescale is necessary later on (#540)
	                    axis.oldUserMin = axis.userMin;
	                    axis.oldUserMax = axis.userMax;
	
	                    // Mark as dirty if it is not already set to dirty and extremes have changed. #595.
	                    if (!axis.isDirty) {
	                        axis.isDirty = isDirtyAxisLength || axis.min !== axis.oldMin || axis.max !== axis.oldMax;
	                    }
	                } else if (axis.cleanStacks) {
	                    axis.cleanStacks();
	                }
	            },
	
	            /**
	             * Set the minimum and maximum of the axes after render time. If the
	             * `startOnTick` and `endOnTick` options are true, the minimum and maximum
	             * values are rounded off to the nearest tick. To prevent this, these
	             * options can be set to false before calling setExtremes. Also, setExtremes
	             * will not allow a range lower than the `minRange` option, which by default
	             * is the range of five points.
	             * 
	             * @param  {Number} [newMin]
	             *         The new minimum value.
	             * @param  {Number} [newMax]
	             *         The new maximum value.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart or wait for an explicit call to 
	             *         {@link Highcharts.Chart#redraw}
	             * @param  {AnimationOptions} [animation=true]
	             *         Enable or modify animations.
	             * @param  {Object} [eventArguments]
	             *         Arguments to be accessed in event handler.
	             *
	             * @sample highcharts/members/axis-setextremes/
	             *         Set extremes from a button
	             * @sample highcharts/members/axis-setextremes-datetime/
	             *         Set extremes on a datetime axis
	             * @sample highcharts/members/axis-setextremes-off-ticks/
	             *         Set extremes off ticks
	             * @sample stock/members/axis-setextremes/
	             *         Set extremes in Highstock
	             * @sample maps/members/axis-setextremes/
	             *         Set extremes in Highmaps
	             */
	            setExtremes: function(newMin, newMax, redraw, animation, eventArguments) {
	                var axis = this,
	                    chart = axis.chart;
	
	                redraw = pick(redraw, true); // defaults to true
	
	                each(axis.series, function(serie) {
	                    delete serie.kdTree;
	                });
	
	                // Extend the arguments with min and max
	                eventArguments = extend(eventArguments, {
	                    min: newMin,
	                    max: newMax
	                });
	
	                // Fire the event
	                fireEvent(axis, 'setExtremes', eventArguments, function() { // the default event handler
	
	                    axis.userMin = newMin;
	                    axis.userMax = newMax;
	                    axis.eventArgs = eventArguments;
	
	                    if (redraw) {
	                        chart.redraw(animation);
	                    }
	                });
	            },
	
	            /**
	             * Overridable method for zooming chart. Pulled out in a separate method to allow overriding
	             * in stock charts.
	             */
	            zoom: function(newMin, newMax) {
	                var dataMin = this.dataMin,
	                    dataMax = this.dataMax,
	                    options = this.options,
	                    min = Math.min(dataMin, pick(options.min, dataMin)),
	                    max = Math.max(dataMax, pick(options.max, dataMax));
	
	                if (newMin !== this.min || newMax !== this.max) { // #5790
	
	                    // Prevent pinch zooming out of range. Check for defined is for #1946. #1734.
	                    if (!this.allowZoomOutside) {
	                        // #6014, sometimes newMax will be smaller than min (or newMin will be larger than max).
	                        if (defined(dataMin)) {
	                            if (newMin < min) {
	                                newMin = min;
	                            }
	                            if (newMin > max) {
	                                newMin = max;
	                            }
	                        }
	                        if (defined(dataMax)) {
	                            if (newMax < min) {
	                                newMax = min;
	                            }
	                            if (newMax > max) {
	                                newMax = max;
	                            }
	                        }
	                    }
	
	                    // In full view, displaying the reset zoom button is not required
	                    this.displayBtn = newMin !== undefined || newMax !== undefined;
	
	                    // Do it
	                    this.setExtremes(
	                        newMin,
	                        newMax,
	                        false,
	                        undefined, {
	                            trigger: 'zoom'
	                        }
	                    );
	                }
	
	                return true;
	            },
	
	            /**
	             * Update the axis metrics
	             */
	            setAxisSize: function() {
	                var chart = this.chart,
	                    options = this.options,
	                    offsets = options.offsets || [0, 0, 0, 0], // top / right / bottom / left
	                    horiz = this.horiz,
	                    width = pick(options.width, chart.plotWidth - offsets[3] + offsets[1]),
	                    height = pick(options.height, chart.plotHeight - offsets[0] + offsets[2]),
	                    top = pick(options.top, chart.plotTop + offsets[0]),
	                    left = pick(options.left, chart.plotLeft + offsets[3]),
	                    percentRegex = /%$/;
	
	                // Check for percentage based input values. Rounding fixes problems with
	                // column overflow and plot line filtering (#4898, #4899)
	                if (percentRegex.test(height)) {
	                    height = Math.round(parseFloat(height) / 100 * chart.plotHeight);
	                }
	                if (percentRegex.test(top)) {
	                    top = Math.round(parseFloat(top) / 100 * chart.plotHeight + chart.plotTop);
	                }
	
	                // Expose basic values to use in Series object and navigator
	                this.left = left;
	                this.top = top;
	                this.width = width;
	                this.height = height;
	                this.bottom = chart.chartHeight - height - top;
	                this.right = chart.chartWidth - width - left;
	
	                // Direction agnostic properties
	                this.len = Math.max(horiz ? width : height, 0); // Math.max fixes #905
	                this.pos = horiz ? left : top; // distance from SVG origin
	            },
	
	            /**
	             * The returned object literal from the {@link Highcharts.Axis#getExtremes}
	             * function. 
	             * @typedef {Object} Extremes
	             * @property {Number} dataMax
	             *         The maximum value of the axis' associated series.
	             * @property {Number} dataMin
	             *         The minimum value of the axis' associated series.
	             * @property {Number} max
	             *         The maximum axis value, either automatic or set manually. If the
	             *         `max` option is not set, `maxPadding` is 0 and `endOnTick` is
	             *         false, this value will be the same as `dataMax`.
	             * @property {Number} min
	             *         The minimum axis value, either automatic or set manually. If the
	             *         `min` option is not set, `minPadding` is 0 and `startOnTick` is
	             *         false, this value will be the same as `dataMin`.
	             */
	            /**
	             * Get the current extremes for the axis.
	             *
	             * @returns {Extremes}
	             * An object containing extremes information.
	             * 
	             * @sample  members/axis-getextremes/
	             *          Report extremes by click on a button
	             * @sample  maps/members/axis-getextremes/
	             *          Get extremes in Highmaps
	             */
	            getExtremes: function() {
	                var axis = this,
	                    isLog = axis.isLog,
	                    lin2log = axis.lin2log;
	
	                return {
	                    min: isLog ? correctFloat(lin2log(axis.min)) : axis.min,
	                    max: isLog ? correctFloat(lin2log(axis.max)) : axis.max,
	                    dataMin: axis.dataMin,
	                    dataMax: axis.dataMax,
	                    userMin: axis.userMin,
	                    userMax: axis.userMax
	                };
	            },
	
	            /**
	             * Get the zero plane either based on zero or on the min or max value.
	             * Used in bar and area plots
	             */
	            getThreshold: function(threshold) {
	                var axis = this,
	                    isLog = axis.isLog,
	                    lin2log = axis.lin2log,
	                    realMin = isLog ? lin2log(axis.min) : axis.min,
	                    realMax = isLog ? lin2log(axis.max) : axis.max;
	
	                if (threshold === null) {
	                    threshold = realMin;
	                } else if (realMin > threshold) {
	                    threshold = realMin;
	                } else if (realMax < threshold) {
	                    threshold = realMax;
	                }
	
	                return axis.translate(threshold, 0, 1, 0, 1);
	            },
	
	            /**
	             * Compute auto alignment for the axis label based on which side the axis is
	             * on and the given rotation for the label.
	             *
	             * @param  {Number} rotation
	             *         The rotation in degrees as set by either the `rotation` or 
	             *         `autoRotation` options.
	             * @private
	             */
	            autoLabelAlign: function(rotation) {
	                var ret,
	                    angle = (pick(rotation, 0) - (this.side * 90) + 720) % 360;
	
	                if (angle > 15 && angle < 165) {
	                    ret = 'right';
	                } else if (angle > 195 && angle < 345) {
	                    ret = 'left';
	                } else {
	                    ret = 'center';
	                }
	                return ret;
	            },
	
	            /**
	             * Get the tick length and width for the axis.
	             * @param   {String} prefix 'tick' or 'minorTick'
	             * @returns {Array}        An array of tickLength and tickWidth
	             */
	            tickSize: function(prefix) {
	                var options = this.options,
	                    tickLength = options[prefix + 'Length'],
	                    tickWidth = pick(options[prefix + 'Width'], prefix === 'tick' && this.isXAxis ? 1 : 0); // X axis defaults to 1
	
	                if (tickWidth && tickLength) {
	                    // Negate the length
	                    if (options[prefix + 'Position'] === 'inside') {
	                        tickLength = -tickLength;
	                    }
	                    return [tickLength, tickWidth];
	                }
	
	            },
	
	            /**
	             * Return the size of the labels
	             */
	            labelMetrics: function() {
	                var index = this.tickPositions && this.tickPositions[0] || 0;
	                return this.chart.renderer.fontMetrics(
	                    this.options.labels.style && this.options.labels.style.fontSize,
	                    this.ticks[index] && this.ticks[index].label
	                );
	            },
	
	            /**
	             * Prevent the ticks from getting so close we can't draw the labels. On a horizontal
	             * axis, this is handled by rotating the labels, removing ticks and adding ellipsis.
	             * On a vertical axis remove ticks and add ellipsis.
	             */
	            unsquish: function() {
	                var labelOptions = this.options.labels,
	                    horiz = this.horiz,
	                    tickInterval = this.tickInterval,
	                    newTickInterval = tickInterval,
	                    slotSize = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / tickInterval),
	                    rotation,
	                    rotationOption = labelOptions.rotation,
	                    labelMetrics = this.labelMetrics(),
	                    step,
	                    bestScore = Number.MAX_VALUE,
	                    autoRotation,
	                    // Return the multiple of tickInterval that is needed to avoid collision
	                    getStep = function(spaceNeeded) {
	                        var step = spaceNeeded / (slotSize || 1);
	                        step = step > 1 ? Math.ceil(step) : 1;
	                        return step * tickInterval;
	                    };
	
	                if (horiz) {
	                    autoRotation = !labelOptions.staggerLines && !labelOptions.step && ( // #3971
	                        defined(rotationOption) ? [rotationOption] :
	                        slotSize < pick(labelOptions.autoRotationLimit, 80) && labelOptions.autoRotation
	                    );
	
	                    if (autoRotation) {
	
	                        // Loop over the given autoRotation options, and determine which gives the best score. The
	                        // best score is that with the lowest number of steps and a rotation closest to horizontal.
	                        each(autoRotation, function(rot) {
	                            var score;
	
	                            if (rot === rotationOption || (rot && rot >= -90 && rot <= 90)) { // #3891
	
	                                step = getStep(Math.abs(labelMetrics.h / Math.sin(deg2rad * rot)));
	
	                                score = step + Math.abs(rot / 360);
	
	                                if (score < bestScore) {
	                                    bestScore = score;
	                                    rotation = rot;
	                                    newTickInterval = step;
	                                }
	                            }
	                        });
	                    }
	
	                } else if (!labelOptions.step) { // #4411
	                    newTickInterval = getStep(labelMetrics.h);
	                }
	
	                this.autoRotation = autoRotation;
	                this.labelRotation = pick(rotation, rotationOption);
	
	                return newTickInterval;
	            },
	
	            /**
	             * Get the general slot width for this axis. This may change between the pre-render (from Axis.getOffset) 
	             * and the final tick rendering and placement (#5086).
	             */
	            getSlotWidth: function() {
	                var chart = this.chart,
	                    horiz = this.horiz,
	                    labelOptions = this.options.labels,
	                    slotCount = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1),
	                    marginLeft = chart.margin[3];
	
	                return (
	                    horiz &&
	                    (labelOptions.step || 0) < 2 &&
	                    !labelOptions.rotation && // #4415
	                    ((this.staggerLines || 1) * this.len) / slotCount
	                ) || (!horiz && (
	                    (marginLeft && (marginLeft - chart.spacing[3])) ||
	                    chart.chartWidth * 0.33
	                )); // #1580, #1931
	
	            },
	
	            /**
	             * Render the axis labels and determine whether ellipsis or rotation need to be applied
	             */
	            renderUnsquish: function() {
	                var chart = this.chart,
	                    renderer = chart.renderer,
	                    tickPositions = this.tickPositions,
	                    ticks = this.ticks,
	                    labelOptions = this.options.labels,
	                    horiz = this.horiz,
	                    slotWidth = this.getSlotWidth(),
	                    innerWidth = Math.max(1, Math.round(slotWidth - 2 * (labelOptions.padding || 5))),
	                    attr = {},
	                    labelMetrics = this.labelMetrics(),
	                    textOverflowOption = labelOptions.style && labelOptions.style.textOverflow,
	                    css,
	                    maxLabelLength = 0,
	                    label,
	                    i,
	                    pos;
	
	                // Set rotation option unless it is "auto", like in gauges
	                if (!isString(labelOptions.rotation)) {
	                    attr.rotation = labelOptions.rotation || 0; // #4443
	                }
	
	                // Get the longest label length
	                each(tickPositions, function(tick) {
	                    tick = ticks[tick];
	                    if (tick && tick.labelLength > maxLabelLength) {
	                        maxLabelLength = tick.labelLength;
	                    }
	                });
	                this.maxLabelLength = maxLabelLength;
	
	
	                // Handle auto rotation on horizontal axis
	                if (this.autoRotation) {
	
	                    // Apply rotation only if the label is too wide for the slot, and
	                    // the label is wider than its height.
	                    if (maxLabelLength > innerWidth && maxLabelLength > labelMetrics.h) {
	                        attr.rotation = this.labelRotation;
	                    } else {
	                        this.labelRotation = 0;
	                    }
	
	                    // Handle word-wrap or ellipsis on vertical axis
	                } else if (slotWidth) {
	                    // For word-wrap or ellipsis
	                    css = {
	                        width: innerWidth + 'px'
	                    };
	
	                    if (!textOverflowOption) {
	                        css.textOverflow = 'clip';
	
	                        // On vertical axis, only allow word wrap if there is room for more lines.
	                        i = tickPositions.length;
	                        while (!horiz && i--) {
	                            pos = tickPositions[i];
	                            label = ticks[pos].label;
	                            if (label) {
	                                // Reset ellipsis in order to get the correct bounding box (#4070)
	                                if (label.styles && label.styles.textOverflow === 'ellipsis') {
	                                    label.css({
	                                        textOverflow: 'clip'
	                                    });
	
	                                    // Set the correct width in order to read the bounding box height (#4678, #5034)
	                                } else if (ticks[pos].labelLength > slotWidth) {
	                                    label.css({
	                                        width: slotWidth + 'px'
	                                    });
	                                }
	
	                                if (label.getBBox().height > this.len / tickPositions.length - (labelMetrics.h - labelMetrics.f)) {
	                                    label.specCss = {
	                                        textOverflow: 'ellipsis'
	                                    };
	                                }
	                            }
	                        }
	                    }
	                }
	
	
	                // Add ellipsis if the label length is significantly longer than ideal
	                if (attr.rotation) {
	                    css = {
	                        width: (maxLabelLength > chart.chartHeight * 0.5 ? chart.chartHeight * 0.33 : chart.chartHeight) + 'px'
	                    };
	                    if (!textOverflowOption) {
	                        css.textOverflow = 'ellipsis';
	                    }
	                }
	
	                // Set the explicit or automatic label alignment
	                this.labelAlign = labelOptions.align || this.autoLabelAlign(this.labelRotation);
	                if (this.labelAlign) {
	                    attr.align = this.labelAlign;
	                }
	
	                // Apply general and specific CSS
	                each(tickPositions, function(pos) {
	                    var tick = ticks[pos],
	                        label = tick && tick.label;
	                    if (label) {
	                        label.attr(attr); // This needs to go before the CSS in old IE (#4502)
	                        if (css) {
	                            label.css(merge(css, label.specCss));
	                        }
	                        delete label.specCss;
	                        tick.rotation = attr.rotation;
	                    }
	                });
	
	                // Note: Why is this not part of getLabelPosition?
	                this.tickRotCorr = renderer.rotCorr(labelMetrics.b, this.labelRotation || 0, this.side !== 0);
	            },
	
	            /**
	             * Return true if the axis has associated data
	             */
	            hasData: function() {
	                return this.hasVisibleSeries || (defined(this.min) && defined(this.max) && !!this.tickPositions);
	            },
	
	            /**
	             * Adds the title defined in axis.options.title.
	             * @param {Boolean} display - whether or not to display the title
	             */
	            addTitle: function(display) {
	                var axis = this,
	                    renderer = axis.chart.renderer,
	                    horiz = axis.horiz,
	                    opposite = axis.opposite,
	                    options = axis.options,
	                    axisTitleOptions = options.title,
	                    textAlign;
	
	                if (!axis.axisTitle) {
	                    textAlign = axisTitleOptions.textAlign;
	                    if (!textAlign) {
	                        textAlign = (horiz ? {
	                            low: 'left',
	                            middle: 'center',
	                            high: 'right'
	                        } : {
	                            low: opposite ? 'right' : 'left',
	                            middle: 'center',
	                            high: opposite ? 'left' : 'right'
	                        })[axisTitleOptions.align];
	                    }
	                    axis.axisTitle = renderer.text(
	                            axisTitleOptions.text,
	                            0,
	                            0,
	                            axisTitleOptions.useHTML
	                        )
	                        .attr({
	                            zIndex: 7,
	                            rotation: axisTitleOptions.rotation || 0,
	                            align: textAlign
	                        })
	                        .addClass('highcharts-axis-title')
	
	                        .css(axisTitleOptions.style)
	
	                        .add(axis.axisGroup);
	                    axis.axisTitle.isNew = true;
	                }
	
	                // hide or show the title depending on whether showEmpty is set
	                axis.axisTitle[display ? 'show' : 'hide'](true);
	            },
	
	            /**
	             * Generates a tick for initial positioning.
	             *
	             * @private
	             * @param  {number} pos
	             *         The tick position in axis values.
	             * @param  {number} i
	             *         The index of the tick in {@link Axis.tickPositions}.
	             */
	            generateTick: function(pos) {
	                var ticks = this.ticks;
	
	                if (!ticks[pos]) {
	                    ticks[pos] = new Tick(this, pos);
	                } else {
	                    ticks[pos].addLabel(); // update labels depending on tick interval
	                }
	            },
	
	            /**
	             * Render the tick labels to a preliminary position to get their sizes
	             */
	            getOffset: function() {
	                var axis = this,
	                    chart = axis.chart,
	                    renderer = chart.renderer,
	                    options = axis.options,
	                    tickPositions = axis.tickPositions,
	                    ticks = axis.ticks,
	                    horiz = axis.horiz,
	                    side = axis.side,
	                    invertedSide = chart.inverted && !axis.isZAxis ? [1, 0, 3, 2][side] : side,
	                    hasData,
	                    showAxis,
	                    titleOffset = 0,
	                    titleOffsetOption,
	                    titleMargin = 0,
	                    axisTitleOptions = options.title,
	                    labelOptions = options.labels,
	                    labelOffset = 0, // reset
	                    labelOffsetPadded,
	                    axisOffset = chart.axisOffset,
	                    clipOffset = chart.clipOffset,
	                    clip,
	                    directionFactor = [-1, 1, 1, -1][side],
	                    className = options.className,
	                    axisParent = axis.axisParent, // Used in color axis
	                    lineHeightCorrection,
	                    tickSize = this.tickSize('tick');
	
	                // For reuse in Axis.render
	                hasData = axis.hasData();
	                axis.showAxis = showAxis = hasData || pick(options.showEmpty, true);
	
	                // Set/reset staggerLines
	                axis.staggerLines = axis.horiz && labelOptions.staggerLines;
	
	                // Create the axisGroup and gridGroup elements on first iteration
	                if (!axis.axisGroup) {
	                    axis.gridGroup = renderer.g('grid')
	                        .attr({
	                            zIndex: options.gridZIndex || 1
	                        })
	                        .addClass('highcharts-' + this.coll.toLowerCase() + '-grid ' + (className || ''))
	                        .add(axisParent);
	                    axis.axisGroup = renderer.g('axis')
	                        .attr({
	                            zIndex: options.zIndex || 2
	                        })
	                        .addClass('highcharts-' + this.coll.toLowerCase() + ' ' + (className || ''))
	                        .add(axisParent);
	                    axis.labelGroup = renderer.g('axis-labels')
	                        .attr({
	                            zIndex: labelOptions.zIndex || 7
	                        })
	                        .addClass('highcharts-' + axis.coll.toLowerCase() + '-labels ' + (className || ''))
	                        .add(axisParent);
	                }
	
	                if (hasData || axis.isLinked) {
	
	                    // Generate ticks
	                    each(tickPositions, function(pos, i) {
	                        // i is not used here, but may be used in overrides
	                        axis.generateTick(pos, i);
	                    });
	
	                    axis.renderUnsquish();
	
	
	                    // Left side must be align: right and right side must have align: left for labels
	                    if (labelOptions.reserveSpace !== false && (side === 0 || side === 2 || {
	                            1: 'left',
	                            3: 'right'
	                        }[side] === axis.labelAlign || axis.labelAlign === 'center')) {
	                        each(tickPositions, function(pos) {
	
	                            // get the highest offset
	                            labelOffset = Math.max(
	                                ticks[pos].getLabelSize(),
	                                labelOffset
	                            );
	                        });
	                    }
	
	                    if (axis.staggerLines) {
	                        labelOffset *= axis.staggerLines;
	                        axis.labelOffset = labelOffset * (axis.opposite ? -1 : 1);
	                    }
	
	
	                } else { // doesn't have data
	                    objectEach(ticks, function(tick, n) {
	                        tick.destroy();
	                        delete ticks[n];
	                    });
	                }
	
	                if (axisTitleOptions && axisTitleOptions.text && axisTitleOptions.enabled !== false) {
	                    axis.addTitle(showAxis);
	
	                    if (showAxis && axisTitleOptions.reserveSpace !== false) {
	                        axis.titleOffset = titleOffset =
	                            axis.axisTitle.getBBox()[horiz ? 'height' : 'width'];
	                        titleOffsetOption = axisTitleOptions.offset;
	                        titleMargin = defined(titleOffsetOption) ? 0 : pick(axisTitleOptions.margin, horiz ? 5 : 10);
	                    }
	                }
	
	                // Render the axis line
	                axis.renderLine();
	
	                // handle automatic or user set offset
	                axis.offset = directionFactor * pick(options.offset, axisOffset[side]);
	
	                axis.tickRotCorr = axis.tickRotCorr || {
	                    x: 0,
	                    y: 0
	                }; // polar
	                if (side === 0) {
	                    lineHeightCorrection = -axis.labelMetrics().h;
	                } else if (side === 2) {
	                    lineHeightCorrection = axis.tickRotCorr.y;
	                } else {
	                    lineHeightCorrection = 0;
	                }
	
	                // Find the padded label offset
	                labelOffsetPadded = Math.abs(labelOffset) + titleMargin;
	                if (labelOffset) {
	                    labelOffsetPadded -= lineHeightCorrection;
	                    labelOffsetPadded += directionFactor * (horiz ? pick(labelOptions.y, axis.tickRotCorr.y + directionFactor * 8) : labelOptions.x);
	                }
	                axis.axisTitleMargin = pick(titleOffsetOption, labelOffsetPadded);
	
	                axisOffset[side] = Math.max(
	                    axisOffset[side],
	                    axis.axisTitleMargin + titleOffset + directionFactor * axis.offset,
	                    labelOffsetPadded, // #3027
	                    hasData && tickPositions.length && tickSize ?
	                    tickSize[0] + directionFactor * axis.offset :
	                    0 // #4866
	                );
	
	                // Decide the clipping needed to keep the graph inside the plot area and
	                // axis lines
	                clip = Math.floor(axis.axisLine.strokeWidth() / 2) * 2; // #4308, #4371
	                if (options.offset > 0) {
	                    clip -= options.offset * 2;
	                }
	                clipOffset[invertedSide] = Math.max(
	                    clipOffset[invertedSide] || clip,
	                    clip
	                );
	            },
	
	            /**
	             * Internal function to get the path for the axis line. Extended for polar
	             * charts.
	             *
	             * @param  {Number} lineWidth
	             *         The line width in pixels.
	             * @return {Array}
	             *         The SVG path definition in array form.
	             */
	            getLinePath: function(lineWidth) {
	                var chart = this.chart,
	                    opposite = this.opposite,
	                    offset = this.offset,
	                    horiz = this.horiz,
	                    lineLeft = this.left + (opposite ? this.width : 0) + offset,
	                    lineTop = chart.chartHeight - this.bottom -
	                    (opposite ? this.height : 0) + offset;
	
	                if (opposite) {
	                    lineWidth *= -1; // crispify the other way - #1480, #1687
	                }
	
	                return chart.renderer
	                    .crispLine([
	                        'M',
	                        horiz ?
	                        this.left :
	                        lineLeft,
	                        horiz ?
	                        lineTop :
	                        this.top,
	                        'L',
	                        horiz ?
	                        chart.chartWidth - this.right :
	                        lineLeft,
	                        horiz ?
	                        lineTop :
	                        chart.chartHeight - this.bottom
	                    ], lineWidth);
	            },
	
	            /**
	             * Render the axis line
	             */
	            renderLine: function() {
	                if (!this.axisLine) {
	                    this.axisLine = this.chart.renderer.path()
	                        .addClass('highcharts-axis-line')
	                        .add(this.axisGroup);
	
	
	                    this.axisLine.attr({
	                        stroke: this.options.lineColor,
	                        'stroke-width': this.options.lineWidth,
	                        zIndex: 7
	                    });
	
	                }
	            },
	
	            /**
	             * Position the title
	             */
	            getTitlePosition: function() {
	                // compute anchor points for each of the title align options
	                var horiz = this.horiz,
	                    axisLeft = this.left,
	                    axisTop = this.top,
	                    axisLength = this.len,
	                    axisTitleOptions = this.options.title,
	                    margin = horiz ? axisLeft : axisTop,
	                    opposite = this.opposite,
	                    offset = this.offset,
	                    xOption = axisTitleOptions.x || 0,
	                    yOption = axisTitleOptions.y || 0,
	                    fontSize = this.chart.renderer.fontMetrics(axisTitleOptions.style && axisTitleOptions.style.fontSize, this.axisTitle).f,
	
	                    // the position in the length direction of the axis
	                    alongAxis = {
	                        low: margin + (horiz ? 0 : axisLength),
	                        middle: margin + axisLength / 2,
	                        high: margin + (horiz ? axisLength : 0)
	                    }[axisTitleOptions.align],
	
	                    // the position in the perpendicular direction of the axis
	                    offAxis = (horiz ? axisTop + this.height : axisLeft) +
	                    (horiz ? 1 : -1) * // horizontal axis reverses the margin
	                    (opposite ? -1 : 1) * // so does opposite axes
	                    this.axisTitleMargin +
	                    (this.side === 2 ? fontSize : 0);
	
	                return {
	                    x: horiz ?
	                        alongAxis + xOption : offAxis + (opposite ? this.width : 0) + offset + xOption,
	                    y: horiz ?
	                        offAxis + yOption - (opposite ? this.height : 0) + offset : alongAxis + yOption
	                };
	            },
	
	            /**
	             * Render a minor tick into the given position. If a minor tick already 
	             * exists in this position, move it.
	             * @param  {number} pos - The position in axis values.
	             */
	            renderMinorTick: function(pos) {
	                var slideInTicks = this.chart.hasRendered && isNumber(this.oldMin),
	                    minorTicks = this.minorTicks;
	
	                if (!minorTicks[pos]) {
	                    minorTicks[pos] = new Tick(this, pos, 'minor');
	                }
	
	                // Render new ticks in old position
	                if (slideInTicks && minorTicks[pos].isNew) {
	                    minorTicks[pos].render(null, true);
	                }
	
	                minorTicks[pos].render(null, false, 1);
	            },
	
	            /**
	             * Render a major tick into the given position. If a tick already exists
	             * in this position, move it.
	             * @param  {number} pos - The position in axis values
	             * @param  {number} i - The tick index
	             */
	            renderTick: function(pos, i) {
	                var isLinked = this.isLinked,
	                    ticks = this.ticks,
	                    slideInTicks = this.chart.hasRendered && isNumber(this.oldMin);
	
	                // Linked axes need an extra check to find out if
	                if (!isLinked || (pos >= this.min && pos <= this.max)) {
	
	                    if (!ticks[pos]) {
	                        ticks[pos] = new Tick(this, pos);
	                    }
	
	                    // render new ticks in old position
	                    if (slideInTicks && ticks[pos].isNew) {
	                        ticks[pos].render(i, true, 0.1);
	                    }
	
	                    ticks[pos].render(i);
	                }
	            },
	
	            /**
	             * Render the axis
	             */
	            render: function() {
	                var axis = this,
	                    chart = axis.chart,
	                    renderer = chart.renderer,
	                    options = axis.options,
	                    isLog = axis.isLog,
	                    lin2log = axis.lin2log,
	                    isLinked = axis.isLinked,
	                    tickPositions = axis.tickPositions,
	                    axisTitle = axis.axisTitle,
	                    ticks = axis.ticks,
	                    minorTicks = axis.minorTicks,
	                    alternateBands = axis.alternateBands,
	                    stackLabelOptions = options.stackLabels,
	                    alternateGridColor = options.alternateGridColor,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    axisLine = axis.axisLine,
	                    showAxis = axis.showAxis,
	                    animation = animObject(renderer.globalAnimation),
	                    from,
	                    to;
	
	                // Reset
	                axis.labelEdge.length = 0;
	                //axis.justifyToPlot = overflow === 'justify';
	                axis.overlap = false;
	
	                // Mark all elements inActive before we go over and mark the active ones
	                each([ticks, minorTicks, alternateBands], function(coll) {
	                    objectEach(coll, function(tick) {
	                        tick.isActive = false;
	                    });
	                });
	
	                // If the series has data draw the ticks. Else only the line and title
	                if (axis.hasData() || isLinked) {
	
	                    // minor ticks
	                    if (axis.minorTickInterval && !axis.categories) {
	                        each(axis.getMinorTickPositions(), function(pos) {
	                            axis.renderMinorTick(pos);
	                        });
	                    }
	
	                    // Major ticks. Pull out the first item and render it last so that
	                    // we can get the position of the neighbour label. #808.
	                    if (tickPositions.length) { // #1300
	                        each(tickPositions, function(pos, i) {
	                            axis.renderTick(pos, i);
	                        });
	                        // In a categorized axis, the tick marks are displayed between labels. So
	                        // we need to add a tick mark and grid line at the left edge of the X axis.
	                        if (tickmarkOffset && (axis.min === 0 || axis.single)) {
	                            if (!ticks[-1]) {
	                                ticks[-1] = new Tick(axis, -1, null, true);
	                            }
	                            ticks[-1].render(-1);
	                        }
	
	                    }
	
	                    // alternate grid color
	                    if (alternateGridColor) {
	                        each(tickPositions, function(pos, i) {
	                            to = tickPositions[i + 1] !== undefined ? tickPositions[i + 1] + tickmarkOffset : axis.max - tickmarkOffset;
	                            if (i % 2 === 0 && pos < axis.max && to <= axis.max + (chart.polar ? -tickmarkOffset : tickmarkOffset)) { // #2248, #4660
	                                if (!alternateBands[pos]) {
	                                    alternateBands[pos] = new H.PlotLineOrBand(axis);
	                                }
	                                from = pos + tickmarkOffset; // #949
	                                alternateBands[pos].options = {
	                                    from: isLog ? lin2log(from) : from,
	                                    to: isLog ? lin2log(to) : to,
	                                    color: alternateGridColor
	                                };
	                                alternateBands[pos].render();
	                                alternateBands[pos].isActive = true;
	                            }
	                        });
	                    }
	
	                    // custom plot lines and bands
	                    if (!axis._addedPlotLB) { // only first time
	                        each((options.plotLines || []).concat(options.plotBands || []), function(plotLineOptions) {
	                            axis.addPlotBandOrLine(plotLineOptions);
	                        });
	                        axis._addedPlotLB = true;
	                    }
	
	                } // end if hasData
	
	                // Remove inactive ticks
	                each([ticks, minorTicks, alternateBands], function(coll) {
	                    var i,
	                        forDestruction = [],
	                        delay = animation.duration,
	                        destroyInactiveItems = function() {
	                            i = forDestruction.length;
	                            while (i--) {
	                                // When resizing rapidly, the same items may be destroyed in different timeouts,
	                                // or the may be reactivated
	                                if (coll[forDestruction[i]] && !coll[forDestruction[i]].isActive) {
	                                    coll[forDestruction[i]].destroy();
	                                    delete coll[forDestruction[i]];
	                                }
	                            }
	
	                        };
	
	                    objectEach(coll, function(tick, pos) {
	                        if (!tick.isActive) {
	                            // Render to zero opacity
	                            tick.render(pos, false, 0);
	                            tick.isActive = false;
	                            forDestruction.push(pos);
	                        }
	                    });
	
	                    // When the objects are finished fading out, destroy them
	                    syncTimeout(
	                        destroyInactiveItems,
	                        coll === alternateBands || !chart.hasRendered || !delay ? 0 : delay
	                    );
	                });
	
	                // Set the axis line path
	                if (axisLine) {
	                    axisLine[axisLine.isPlaced ? 'animate' : 'attr']({
	                        d: this.getLinePath(axisLine.strokeWidth())
	                    });
	                    axisLine.isPlaced = true;
	
	                    // Show or hide the line depending on options.showEmpty
	                    axisLine[showAxis ? 'show' : 'hide'](true);
	                }
	
	                if (axisTitle && showAxis) {
	                    var titleXy = axis.getTitlePosition();
	                    if (isNumber(titleXy.y)) {
	                        axisTitle[axisTitle.isNew ? 'attr' : 'animate'](titleXy);
	                        axisTitle.isNew = false;
	                    } else {
	                        axisTitle.attr('y', -9999);
	                        axisTitle.isNew = true;
	                    }
	                }
	
	                // Stacked totals:
	                if (stackLabelOptions && stackLabelOptions.enabled) {
	                    axis.renderStackTotals();
	                }
	                // End stacked totals
	
	                axis.isDirty = false;
	            },
	
	            /**
	             * Redraw the axis to reflect changes in the data or axis extremes
	             */
	            redraw: function() {
	
	                if (this.visible) {
	                    // render the axis
	                    this.render();
	
	                    // move plot lines and bands
	                    each(this.plotLinesAndBands, function(plotLine) {
	                        plotLine.render();
	                    });
	                }
	
	                // mark associated series as dirty and ready for redraw
	                each(this.series, function(series) {
	                    series.isDirty = true;
	                });
	
	            },
	
	            // Properties to survive after destroy, needed for Axis.update (#4317,
	            // #5773, #5881).
	            keepProps: ['extKey', 'hcEvents', 'names', 'series', 'userMax', 'userMin'],
	
	            /**
	             * Destroys an Axis instance. See {@link Axis#remove} for the API endpoint
	             * to fully remove the axis.
	             *
	             * @private
	             * @param  {Boolean} keepEvents
	             *         Whether to preserve events, used internally in Axis.update.
	             */
	            destroy: function(keepEvents) {
	                var axis = this,
	                    stacks = axis.stacks,
	                    plotLinesAndBands = axis.plotLinesAndBands,
	                    plotGroup,
	                    i;
	
	                // Remove the events
	                if (!keepEvents) {
	                    removeEvent(axis);
	                }
	
	                // Destroy each stack total
	                objectEach(stacks, function(stack, stackKey) {
	                    destroyObjectProperties(stack);
	
	                    stacks[stackKey] = null;
	                });
	
	                // Destroy collections
	                each([axis.ticks, axis.minorTicks, axis.alternateBands], function(coll) {
	                    destroyObjectProperties(coll);
	                });
	                if (plotLinesAndBands) {
	                    i = plotLinesAndBands.length;
	                    while (i--) { // #1975
	                        plotLinesAndBands[i].destroy();
	                    }
	                }
	
	                // Destroy local variables
	                each(['stackTotalGroup', 'axisLine', 'axisTitle', 'axisGroup', 'gridGroup', 'labelGroup', 'cross'], function(prop) {
	                    if (axis[prop]) {
	                        axis[prop] = axis[prop].destroy();
	                    }
	                });
	
	                // Destroy each generated group for plotlines and plotbands
	                for (plotGroup in axis.plotLinesAndBandsGroups) {
	                    axis.plotLinesAndBandsGroups[plotGroup] = axis.plotLinesAndBandsGroups[plotGroup].destroy();
	                }
	
	                // Delete all properties and fall back to the prototype.
	                objectEach(axis, function(val, key) {
	                    if (inArray(key, axis.keepProps) === -1) {
	                        delete axis[key];
	                    }
	                });
	            },
	
	            /**
	             * Internal function to draw a crosshair.
	             *
	             * @param  {PointerEvent} [e]
	             *         The event arguments from the modified pointer event, extended 
	             *         with `chartX` and `chartY`
	             * @param  {Point} [point]
	             *         The Point object if the crosshair snaps to points.
	             */
	            drawCrosshair: function(e, point) {
	
	                var path,
	                    options = this.crosshair,
	                    snap = pick(options.snap, true),
	                    pos,
	                    categorized,
	                    graphic = this.cross;
	
	                // Use last available event when updating non-snapped crosshairs without
	                // mouse interaction (#5287)
	                if (!e) {
	                    e = this.cross && this.cross.e;
	                }
	
	                if (
	                    // Disabled in options
	                    !this.crosshair ||
	                    // Snap
	                    ((defined(point) || !snap) === false)
	                ) {
	                    this.hideCrosshair();
	                } else {
	
	                    // Get the path
	                    if (!snap) {
	                        pos = e && (this.horiz ? e.chartX - this.pos : this.len - e.chartY + this.pos);
	                    } else if (defined(point)) {
	                        pos = this.isXAxis ? point.plotX : this.len - point.plotY; // #3834
	                    }
	
	                    if (defined(pos)) {
	                        path = this.getPlotLinePath(
	                            // First argument, value, only used on radial
	                            point && (this.isXAxis ? point.x : pick(point.stackY, point.y)),
	                            null,
	                            null,
	                            null,
	                            pos // Translated position
	                        ) || null; // #3189
	                    }
	
	                    if (!defined(path)) {
	                        this.hideCrosshair();
	                        return;
	                    }
	
	                    categorized = this.categories && !this.isRadial;
	
	                    // Draw the cross
	                    if (!graphic) {
	                        this.cross = graphic = this.chart.renderer
	                            .path()
	                            .addClass('highcharts-crosshair highcharts-crosshair-' +
	                                (categorized ? 'category ' : 'thin ') + options.className)
	                            .attr({
	                                zIndex: pick(options.zIndex, 2)
	                            })
	                            .add();
	
	
	                        // Presentational attributes
	                        graphic.attr({
	                            'stroke': options.color || (categorized ? color('#ccd6eb').setOpacity(0.25).get() : '#cccccc'),
	                            'stroke-width': pick(options.width, 1)
	                        });
	                        if (options.dashStyle) {
	                            graphic.attr({
	                                dashstyle: options.dashStyle
	                            });
	                        }
	
	
	                    }
	
	                    graphic.show().attr({
	                        d: path
	                    });
	
	                    if (categorized && !options.width) {
	                        graphic.attr({
	                            'stroke-width': this.transA
	                        });
	                    }
	                    this.cross.e = e;
	                }
	            },
	
	            /**
	             *	Hide the crosshair.
	             */
	            hideCrosshair: function() {
	                if (this.cross) {
	                    this.cross.hide();
	                }
	            }
	        }); // end Axis
	
	        H.Axis = Axis;
	        return Axis;
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Axis = H.Axis,
	            Date = H.Date,
	            dateFormat = H.dateFormat,
	            defaultOptions = H.defaultOptions,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            getMagnitude = H.getMagnitude,
	            getTZOffset = H.getTZOffset,
	            normalizeTickInterval = H.normalizeTickInterval,
	            pick = H.pick,
	            timeUnits = H.timeUnits;
	        /**
	         * Set the tick positions to a time unit that makes sense, for example
	         * on the first of each month or on every Monday. Return an array
	         * with the time positions. Used in datetime axes as well as for grouping
	         * data on a datetime axis.
	         *
	         * @param {Object} normalizedInterval The interval in axis values (ms) and the count
	         * @param {Number} min The minimum in axis values
	         * @param {Number} max The maximum in axis values
	         * @param {Number} startOfWeek
	         */
	        Axis.prototype.getTimeTicks = function(normalizedInterval, min, max, startOfWeek) {
	            var tickPositions = [],
	                i,
	                higherRanks = {},
	                useUTC = defaultOptions.global.useUTC,
	                minYear, // used in months and years as a basis for Date.UTC()
	                // When crossing DST, use the max. Resolves #6278.
	                minDate = new Date(min - Math.max(getTZOffset(min), getTZOffset(max))),
	                makeTime = Date.hcMakeTime,
	                interval = normalizedInterval.unitRange,
	                count = normalizedInterval.count,
	                variableDayLength;
	
	            if (defined(min)) { // #1300
	                minDate[Date.hcSetMilliseconds](interval >= timeUnits.second ? 0 : // #3935
	                    count * Math.floor(minDate.getMilliseconds() / count)); // #3652, #3654
	
	                if (interval >= timeUnits.second) { // second
	                    minDate[Date.hcSetSeconds](interval >= timeUnits.minute ? 0 : // #3935
	                        count * Math.floor(minDate.getSeconds() / count));
	                }
	
	                if (interval >= timeUnits.minute) { // minute
	                    minDate[Date.hcSetMinutes](interval >= timeUnits.hour ? 0 :
	                        count * Math.floor(minDate[Date.hcGetMinutes]() / count));
	                }
	
	                if (interval >= timeUnits.hour) { // hour
	                    minDate[Date.hcSetHours](interval >= timeUnits.day ? 0 :
	                        count * Math.floor(minDate[Date.hcGetHours]() / count));
	                }
	
	                if (interval >= timeUnits.day) { // day
	                    minDate[Date.hcSetDate](interval >= timeUnits.month ? 1 :
	                        count * Math.floor(minDate[Date.hcGetDate]() / count));
	                }
	
	                if (interval >= timeUnits.month) { // month
	                    minDate[Date.hcSetMonth](interval >= timeUnits.year ? 0 :
	                        count * Math.floor(minDate[Date.hcGetMonth]() / count));
	                    minYear = minDate[Date.hcGetFullYear]();
	                }
	
	                if (interval >= timeUnits.year) { // year
	                    minYear -= minYear % count;
	                    minDate[Date.hcSetFullYear](minYear);
	                }
	
	                // week is a special case that runs outside the hierarchy
	                if (interval === timeUnits.week) {
	                    // get start of current week, independent of count
	                    minDate[Date.hcSetDate](minDate[Date.hcGetDate]() - minDate[Date.hcGetDay]() +
	                        pick(startOfWeek, 1));
	                }
	
	
	                // Get basics for variable time spans
	                minYear = minDate[Date.hcGetFullYear]();
	                var minMonth = minDate[Date.hcGetMonth](),
	                    minDateDate = minDate[Date.hcGetDate](),
	                    minHours = minDate[Date.hcGetHours]();
	
	
	                // Handle local timezone offset
	                if (Date.hcTimezoneOffset || Date.hcGetTimezoneOffset) {
	
	                    // Detect whether we need to take the DST crossover into
	                    // consideration. If we're crossing over DST, the day length may be
	                    // 23h or 25h and we need to compute the exact clock time for each
	                    // tick instead of just adding hours. This comes at a cost, so first
	                    // we found out if it is needed. #4951.
	                    variableDayLength =
	                        (!useUTC || !!Date.hcGetTimezoneOffset) &&
	                        (
	                            // Long range, assume we're crossing over.
	                            max - min > 4 * timeUnits.month ||
	                            // Short range, check if min and max are in different time 
	                            // zones.
	                            getTZOffset(min) !== getTZOffset(max)
	                        );
	
	                    // Adjust minDate to the offset date
	                    minDate = minDate.getTime();
	                    minDate = new Date(minDate + getTZOffset(minDate));
	                }
	
	
	                // Iterate and add tick positions at appropriate values
	                var time = minDate.getTime();
	                i = 1;
	                while (time < max) {
	                    tickPositions.push(time);
	
	                    // if the interval is years, use Date.UTC to increase years
	                    if (interval === timeUnits.year) {
	                        time = makeTime(minYear + i * count, 0);
	
	                        // if the interval is months, use Date.UTC to increase months
	                    } else if (interval === timeUnits.month) {
	                        time = makeTime(minYear, minMonth + i * count);
	
	                        // if we're using global time, the interval is not fixed as it jumps
	                        // one hour at the DST crossover
	                    } else if (variableDayLength && (interval === timeUnits.day || interval === timeUnits.week)) {
	                        time = makeTime(minYear, minMonth, minDateDate +
	                            i * count * (interval === timeUnits.day ? 1 : 7));
	
	                    } else if (variableDayLength && interval === timeUnits.hour) {
	                        time = makeTime(minYear, minMonth, minDateDate, minHours + i * count);
	
	                        // else, the interval is fixed and we use simple addition
	                    } else {
	                        time += interval * count;
	                    }
	
	                    i++;
	                }
	
	                // push the last time
	                tickPositions.push(time);
	
	
	                // Handle higher ranks. Mark new days if the time is on midnight
	                // (#950, #1649, #1760, #3349). Use a reasonable dropout threshold to 
	                // prevent looping over dense data grouping (#6156).
	                if (interval <= timeUnits.hour && tickPositions.length < 10000) {
	                    each(tickPositions, function(time) {
	                        if (
	                            // Speed optimization, no need to run dateFormat unless
	                            // we're on a full or half hour
	                            time % 1800000 === 0 &&
	                            // Check for local or global midnight
	                            dateFormat('%H%M%S%L', time) === '000000000'
	                        ) {
	                            higherRanks[time] = 'day';
	                        }
	                    });
	                }
	            }
	
	
	            // record information on the chosen unit - for dynamic label formatter
	            tickPositions.info = extend(normalizedInterval, {
	                higherRanks: higherRanks,
	                totalRange: interval * count
	            });
	
	            return tickPositions;
	        };
	
	        /**
	         * Get a normalized tick interval for dates. Returns a configuration object with
	         * unit range (interval), count and name. Used to prepare data for getTimeTicks.
	         * Previously this logic was part of getTimeTicks, but as getTimeTicks now runs
	         * of segments in stock charts, the normalizing logic was extracted in order to
	         * prevent it for running over again for each segment having the same interval.
	         * #662, #697.
	         */
	        Axis.prototype.normalizeTimeTickInterval = function(tickInterval, unitsOption) {
	            var units = unitsOption || [
	                    [
	                        'millisecond', // unit name
	                        [1, 2, 5, 10, 20, 25, 50, 100, 200, 500] // allowed multiples
	                    ],
	                    [
	                        'second', [1, 2, 5, 10, 15, 30]
	                    ],
	                    [
	                        'minute', [1, 2, 5, 10, 15, 30]
	                    ],
	                    [
	                        'hour', [1, 2, 3, 4, 6, 8, 12]
	                    ],
	                    [
	                        'day', [1, 2]
	                    ],
	                    [
	                        'week', [1, 2]
	                    ],
	                    [
	                        'month', [1, 2, 3, 4, 6]
	                    ],
	                    [
	                        'year',
	                        null
	                    ]
	                ],
	                unit = units[units.length - 1], // default unit is years
	                interval = timeUnits[unit[0]],
	                multiples = unit[1],
	                count,
	                i;
	
	            // loop through the units to find the one that best fits the tickInterval
	            for (i = 0; i < units.length; i++) {
	                unit = units[i];
	                interval = timeUnits[unit[0]];
	                multiples = unit[1];
	
	
	                if (units[i + 1]) {
	                    // lessThan is in the middle between the highest multiple and the next unit.
	                    var lessThan = (interval * multiples[multiples.length - 1] +
	                        timeUnits[units[i + 1][0]]) / 2;
	
	                    // break and keep the current unit
	                    if (tickInterval <= lessThan) {
	                        break;
	                    }
	                }
	            }
	
	            // prevent 2.5 years intervals, though 25, 250 etc. are allowed
	            if (interval === timeUnits.year && tickInterval < 5 * interval) {
	                multiples = [1, 2, 5];
	            }
	
	            // get the count
	            count = normalizeTickInterval(
	                tickInterval / interval,
	                multiples,
	                unit[0] === 'year' ? Math.max(getMagnitude(tickInterval / interval), 1) : 1 // #1913, #2360
	            );
	
	            return {
	                unitRange: interval,
	                count: count,
	                unitName: unit[0]
	            };
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Axis = H.Axis,
	            getMagnitude = H.getMagnitude,
	            map = H.map,
	            normalizeTickInterval = H.normalizeTickInterval,
	            pick = H.pick;
	        /**
	         * Methods defined on the Axis prototype
	         */
	
	        /**
	         * Set the tick positions of a logarithmic axis
	         */
	        Axis.prototype.getLogTickPositions = function(interval, min, max, minor) {
	            var axis = this,
	                options = axis.options,
	                axisLength = axis.len,
	                lin2log = axis.lin2log,
	                log2lin = axis.log2lin,
	                // Since we use this method for both major and minor ticks,
	                // use a local variable and return the result
	                positions = [];
	
	            // Reset
	            if (!minor) {
	                axis._minorAutoInterval = null;
	            }
	
	            // First case: All ticks fall on whole logarithms: 1, 10, 100 etc.
	            if (interval >= 0.5) {
	                interval = Math.round(interval);
	                positions = axis.getLinearTickPositions(interval, min, max);
	
	                // Second case: We need intermediary ticks. For example
	                // 1, 2, 4, 6, 8, 10, 20, 40 etc.
	            } else if (interval >= 0.08) {
	                var roundedMin = Math.floor(min),
	                    intermediate,
	                    i,
	                    j,
	                    len,
	                    pos,
	                    lastPos,
	                    break2;
	
	                if (interval > 0.3) {
	                    intermediate = [1, 2, 4];
	                } else if (interval > 0.15) { // 0.2 equals five minor ticks per 1, 10, 100 etc
	                    intermediate = [1, 2, 4, 6, 8];
	                } else { // 0.1 equals ten minor ticks per 1, 10, 100 etc
	                    intermediate = [1, 2, 3, 4, 5, 6, 7, 8, 9];
	                }
	
	                for (i = roundedMin; i < max + 1 && !break2; i++) {
	                    len = intermediate.length;
	                    for (j = 0; j < len && !break2; j++) {
	                        pos = log2lin(lin2log(i) * intermediate[j]);
	                        if (pos > min && (!minor || lastPos <= max) && lastPos !== undefined) { // #1670, lastPos is #3113
	                            positions.push(lastPos);
	                        }
	
	                        if (lastPos > max) {
	                            break2 = true;
	                        }
	                        lastPos = pos;
	                    }
	                }
	
	                // Third case: We are so deep in between whole logarithmic values that
	                // we might as well handle the tick positions like a linear axis. For
	                // example 1.01, 1.02, 1.03, 1.04.
	            } else {
	                var realMin = lin2log(min),
	                    realMax = lin2log(max),
	                    tickIntervalOption = options[minor ? 'minorTickInterval' : 'tickInterval'],
	                    filteredTickIntervalOption = tickIntervalOption === 'auto' ? null : tickIntervalOption,
	                    tickPixelIntervalOption = options.tickPixelInterval / (minor ? 5 : 1),
	                    totalPixelLength = minor ? axisLength / axis.tickPositions.length : axisLength;
	
	                interval = pick(
	                    filteredTickIntervalOption,
	                    axis._minorAutoInterval,
	                    (realMax - realMin) * tickPixelIntervalOption / (totalPixelLength || 1)
	                );
	
	                interval = normalizeTickInterval(
	                    interval,
	                    null,
	                    getMagnitude(interval)
	                );
	
	                positions = map(axis.getLinearTickPositions(
	                    interval,
	                    realMin,
	                    realMax
	                ), log2lin);
	
	                if (!minor) {
	                    axis._minorAutoInterval = interval / 5;
	                }
	            }
	
	            // Set the axis-level tickInterval variable
	            if (!minor) {
	                axis.tickInterval = interval;
	            }
	            return positions;
	        };
	
	        Axis.prototype.log2lin = function(num) {
	            return Math.log(num) / Math.LN10;
	        };
	
	        Axis.prototype.lin2log = function(num) {
	            return Math.pow(10, num);
	        };
	
	    }(Highcharts));
	    (function(H, Axis) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            erase = H.erase,
	            merge = H.merge,
	            pick = H.pick;
	        /*
	         * The object wrapper for plot lines and plot bands
	         * @param {Object} options
	         */
	        H.PlotLineOrBand = function(axis, options) {
	            this.axis = axis;
	
	            if (options) {
	                this.options = options;
	                this.id = options.id;
	            }
	        };
	
	        H.PlotLineOrBand.prototype = {
	
	            /**
	             * Render the plot line or plot band. If it is already existing,
	             * move it.
	             */
	            render: function() {
	                var plotLine = this,
	                    axis = plotLine.axis,
	                    horiz = axis.horiz,
	                    options = plotLine.options,
	                    optionsLabel = options.label,
	                    label = plotLine.label,
	                    to = options.to,
	                    from = options.from,
	                    value = options.value,
	                    isBand = defined(from) && defined(to),
	                    isLine = defined(value),
	                    svgElem = plotLine.svgElem,
	                    isNew = !svgElem,
	                    path = [],
	                    color = options.color,
	                    zIndex = pick(options.zIndex, 0),
	                    events = options.events,
	                    attribs = {
	                        'class': 'highcharts-plot-' + (isBand ? 'band ' : 'line ') + (options.className || '')
	                    },
	                    groupAttribs = {},
	                    renderer = axis.chart.renderer,
	                    groupName = isBand ? 'bands' : 'lines',
	                    group,
	                    log2lin = axis.log2lin;
	
	                // logarithmic conversion
	                if (axis.isLog) {
	                    from = log2lin(from);
	                    to = log2lin(to);
	                    value = log2lin(value);
	                }
	
	
	                // Set the presentational attributes
	                if (isLine) {
	                    attribs = {
	                        stroke: color,
	                        'stroke-width': options.width
	                    };
	                    if (options.dashStyle) {
	                        attribs.dashstyle = options.dashStyle;
	                    }
	
	                } else if (isBand) { // plot band
	                    if (color) {
	                        attribs.fill = color;
	                    }
	                    if (options.borderWidth) {
	                        attribs.stroke = options.borderColor;
	                        attribs['stroke-width'] = options.borderWidth;
	                    }
	                }
	
	
	                // Grouping and zIndex
	                groupAttribs.zIndex = zIndex;
	                groupName += '-' + zIndex;
	
	                group = axis.plotLinesAndBandsGroups[groupName];
	                if (!group) {
	                    axis.plotLinesAndBandsGroups[groupName] = group = renderer.g('plot-' + groupName)
	                        .attr(groupAttribs).add();
	                }
	
	                // Create the path
	                if (isNew) {
	                    plotLine.svgElem = svgElem =
	                        renderer
	                        .path()
	                        .attr(attribs).add(group);
	                }
	
	
	                // Set the path or return
	                if (isLine) {
	                    path = axis.getPlotLinePath(value, svgElem.strokeWidth());
	                } else if (isBand) { // plot band
	                    path = axis.getPlotBandPath(from, to, options);
	                } else {
	                    return;
	                }
	
	
	                // common for lines and bands
	                if (isNew && path && path.length) {
	                    svgElem.attr({
	                        d: path
	                    });
	
	                    // events
	                    if (events) {
	                        H.objectEach(events, function(event, eventType) {
	                            svgElem.on(eventType, function(e) {
	                                events[eventType].apply(plotLine, [e]);
	                            });
	                        });
	                    }
	                } else if (svgElem) {
	                    if (path) {
	                        svgElem.show();
	                        svgElem.animate({
	                            d: path
	                        });
	                    } else {
	                        svgElem.hide();
	                        if (label) {
	                            plotLine.label = label = label.destroy();
	                        }
	                    }
	                }
	
	                // the plot band/line label
	                if (optionsLabel && defined(optionsLabel.text) && path && path.length &&
	                    axis.width > 0 && axis.height > 0 && !path.flat) {
	                    // apply defaults
	                    optionsLabel = merge({
	                        align: horiz && isBand && 'center',
	                        x: horiz ? !isBand && 4 : 10,
	                        verticalAlign: !horiz && isBand && 'middle',
	                        y: horiz ? isBand ? 16 : 10 : isBand ? 6 : -4,
	                        rotation: horiz && !isBand && 90
	                    }, optionsLabel);
	
	                    this.renderLabel(optionsLabel, path, isBand, zIndex);
	
	                } else if (label) { // move out of sight
	                    label.hide();
	                }
	
	                // chainable
	                return plotLine;
	            },
	
	            /**
	             * Render and align label for plot line or band.
	             */
	            renderLabel: function(optionsLabel, path, isBand, zIndex) {
	                var plotLine = this,
	                    label = plotLine.label,
	                    renderer = plotLine.axis.chart.renderer,
	                    attribs,
	                    xs,
	                    ys,
	                    x,
	                    y;
	
	                // add the SVG element
	                if (!label) {
	                    attribs = {
	                        align: optionsLabel.textAlign || optionsLabel.align,
	                        rotation: optionsLabel.rotation,
	                        'class': 'highcharts-plot-' + (isBand ? 'band' : 'line') + '-label ' + (optionsLabel.className || '')
	                    };
	
	                    attribs.zIndex = zIndex;
	
	                    plotLine.label = label = renderer.text(
	                            optionsLabel.text,
	                            0,
	                            0,
	                            optionsLabel.useHTML
	                        )
	                        .attr(attribs)
	                        .add();
	
	
	                    label.css(optionsLabel.style);
	
	                }
	
	                // get the bounding box and align the label
	                // #3000 changed to better handle choice between plotband or plotline
	                xs = [path[1], path[4], (isBand ? path[6] : path[1])];
	                ys = [path[2], path[5], (isBand ? path[7] : path[2])];
	                x = arrayMin(xs);
	                y = arrayMin(ys);
	
	                label.align(optionsLabel, false, {
	                    x: x,
	                    y: y,
	                    width: arrayMax(xs) - x,
	                    height: arrayMax(ys) - y
	                });
	                label.show();
	            },
	
	            /**
	             * Remove the plot line or band
	             */
	            destroy: function() {
	                // remove it from the lookup
	                erase(this.axis.plotLinesAndBands, this);
	
	                delete this.axis;
	                destroyObjectProperties(this);
	            }
	        };
	
	        /**
	         * Object with members for extending the Axis prototype
	         * @todo Extend directly instead of adding object to Highcharts first
	         */
	
	        H.extend(Axis.prototype, /** @lends Highcharts.Axis.prototype */ {
	
	            /**
	             * Create the path for a plot band
	             */
	            getPlotBandPath: function(from, to) {
	                var toPath = this.getPlotLinePath(to, null, null, true),
	                    path = this.getPlotLinePath(from, null, null, true),
	                    // #4964 check if chart is inverted or plotband is on yAxis 
	                    horiz = this.horiz,
	                    plus = 1,
	                    outside =
	                    (from < this.min && to < this.min) ||
	                    (from > this.max && to > this.max);
	
	                if (path && toPath) {
	
	                    // Flat paths don't need labels (#3836)
	                    if (outside) {
	                        path.flat = path.toString() === toPath.toString();
	                        plus = 0;
	                    }
	
	                    // Add 1 pixel, when coordinates are the same
	                    path.push(
	                        horiz && toPath[4] === path[4] ? toPath[4] + plus : toPath[4], !horiz && toPath[5] === path[5] ? toPath[5] + plus : toPath[5],
	                        horiz && toPath[1] === path[1] ? toPath[1] + plus : toPath[1], !horiz && toPath[2] === path[2] ? toPath[2] + plus : toPath[2]
	                    );
	                } else { // outside the axis area
	                    path = null;
	                }
	
	                return path;
	            },
	
	            /**
	             * Add a plot band after render time.
	             *
	             * @param  {AxisPlotBandsOptions} options
	             *         A configuration object for the plot band, as defined in {@link
	             *         https://api.highcharts.com/highcharts/xAxis.plotBands|
	             *         xAxis.plotBands}.
	             * @return {Object}
	             *         The added plot band.
	             * @sample highcharts/members/axis-addplotband/
	             *         Toggle the plot band from a button
	             */
	            addPlotBand: function(options) {
	                return this.addPlotBandOrLine(options, 'plotBands');
	            },
	
	            /**
	             * Add a plot line after render time.
	             * 
	             * @param  {AxisPlotLinesOptions} options
	             *         A configuration object for the plot line, as defined in {@link
	             *         https://api.highcharts.com/highcharts/xAxis.plotLines|
	             *         xAxis.plotLines}.
	             * @return {Object}
	             *         The added plot line.
	             * @sample highcharts/members/axis-addplotline/
	             *         Toggle the plot line from a button
	             */
	            addPlotLine: function(options) {
	                return this.addPlotBandOrLine(options, 'plotLines');
	            },
	
	            /**
	             * Add a plot band or plot line after render time. Called from addPlotBand
	             * and addPlotLine internally.
	             *
	             * @private
	             * @param  options {AxisPlotLinesOptions|AxisPlotBandsOptions}
	             *         The plotBand or plotLine configuration object.
	             */
	            addPlotBandOrLine: function(options, coll) {
	                var obj = new H.PlotLineOrBand(this, options).render(),
	                    userOptions = this.userOptions;
	
	                if (obj) { // #2189
	                    // Add it to the user options for exporting and Axis.update
	                    if (coll) {
	                        userOptions[coll] = userOptions[coll] || [];
	                        userOptions[coll].push(options);
	                    }
	                    this.plotLinesAndBands.push(obj);
	                }
	
	                return obj;
	            },
	
	            /**
	             * Remove a plot band or plot line from the chart by id. Called internally
	             * from `removePlotBand` and `removePlotLine`.
	             *
	             * @private
	             * @param {String} id
	             */
	            removePlotBandOrLine: function(id) {
	                var plotLinesAndBands = this.plotLinesAndBands,
	                    options = this.options,
	                    userOptions = this.userOptions,
	                    i = plotLinesAndBands.length;
	                while (i--) {
	                    if (plotLinesAndBands[i].id === id) {
	                        plotLinesAndBands[i].destroy();
	                    }
	                }
	                each([
	                    options.plotLines || [],
	                    userOptions.plotLines || [],
	                    options.plotBands || [],
	                    userOptions.plotBands || []
	                ], function(arr) {
	                    i = arr.length;
	                    while (i--) {
	                        if (arr[i].id === id) {
	                            erase(arr, arr[i]);
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Remove a plot band by its id.
	             * 
	             * @param  {String} id
	             *         The plot band's `id` as given in the original configuration
	             *         object or in the `addPlotBand` option.
	             * @sample highcharts/members/axis-removeplotband/
	             *         Remove plot band by id
	             * @sample highcharts/members/axis-addplotband/
	             *         Toggle the plot band from a button
	             */
	            removePlotBand: function(id) {
	                this.removePlotBandOrLine(id);
	            },
	
	            /**
	             * Remove a plot line by its id.
	             * @param  {String} id
	             *         The plot line's `id` as given in the original configuration
	             *         object or in the `addPlotLine` option.
	             * @sample highcharts/xaxis/plotlines-id/
	             *         Remove plot line by id
	             * @sample highcharts/members/axis-addplotline/
	             *         Toggle the plot line from a button
	             */
	            removePlotLine: function(id) {
	                this.removePlotBandOrLine(id);
	            }
	        });
	
	    }(Highcharts, Axis));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var dateFormat = H.dateFormat,
	            each = H.each,
	            extend = H.extend,
	            format = H.format,
	            isNumber = H.isNumber,
	            map = H.map,
	            merge = H.merge,
	            pick = H.pick,
	            splat = H.splat,
	            syncTimeout = H.syncTimeout,
	            timeUnits = H.timeUnits;
	        /**
	         * The tooltip object
	         * @param {Object} chart The chart instance
	         * @param {Object} options Tooltip options
	         */
	        H.Tooltip = function() {
	            this.init.apply(this, arguments);
	        };
	
	        H.Tooltip.prototype = {
	
	            init: function(chart, options) {
	
	                // Save the chart and options
	                this.chart = chart;
	                this.options = options;
	
	                // Keep track of the current series
	                //this.currentSeries = undefined;
	
	                // List of crosshairs
	                this.crosshairs = [];
	
	                // Current values of x and y when animating
	                this.now = {
	                    x: 0,
	                    y: 0
	                };
	
	                // The tooltip is initially hidden
	                this.isHidden = true;
	
	
	
	                // Public property for getting the shared state.
	                this.split = options.split && !chart.inverted;
	                this.shared = options.shared || this.split;
	
	            },
	
	            /**
	             * Destroy the single tooltips in a split tooltip.
	             * If the tooltip is active then it is not destroyed, unless forced to.
	             * @param  {boolean} force Force destroy all tooltips.
	             * @return {undefined}
	             */
	            cleanSplit: function(force) {
	                each(this.chart.series, function(series) {
	                    var tt = series && series.tt;
	                    if (tt) {
	                        if (!tt.isActive || force) {
	                            series.tt = tt.destroy();
	                        } else {
	                            tt.isActive = false;
	                        }
	                    }
	                });
	            },
	
	
	
	
	            /**
	             * Create the Tooltip label element if it doesn't exist, then return the
	             * label.
	             */
	            getLabel: function() {
	
	                var renderer = this.chart.renderer,
	                    options = this.options;
	
	                if (!this.label) {
	                    // Create the label
	                    if (this.split) {
	                        this.label = renderer.g('tooltip');
	                    } else {
	                        this.label = renderer.label(
	                                '',
	                                0,
	                                0,
	                                options.shape || 'callout',
	                                null,
	                                null,
	                                options.useHTML,
	                                null,
	                                'tooltip'
	                            )
	                            .attr({
	                                padding: options.padding,
	                                r: options.borderRadius
	                            });
	
	
	                        this.label
	                            .attr({
	                                'fill': options.backgroundColor,
	                                'stroke-width': options.borderWidth
	                            })
	                            // #2301, #2657
	                            .css(options.style)
	                            .shadow(options.shadow);
	
	                    }
	
	
	
	                    this.label
	                        .attr({
	                            zIndex: 8
	                        })
	                        .add();
	                }
	                return this.label;
	            },
	
	            update: function(options) {
	                this.destroy();
	                // Update user options (#6218)
	                merge(true, this.chart.options.tooltip.userOptions, options);
	                this.init(this.chart, merge(true, this.options, options));
	            },
	
	            /**
	             * Destroy the tooltip and its elements.
	             */
	            destroy: function() {
	                // Destroy and clear local variables
	                if (this.label) {
	                    this.label = this.label.destroy();
	                }
	                if (this.split && this.tt) {
	                    this.cleanSplit(this.chart, true);
	                    this.tt = this.tt.destroy();
	                }
	                clearTimeout(this.hideTimer);
	                clearTimeout(this.tooltipTimeout);
	            },
	
	            /**
	             * Provide a soft movement for the tooltip
	             *
	             * @param {Number} x
	             * @param {Number} y
	             * @private
	             */
	            move: function(x, y, anchorX, anchorY) {
	                var tooltip = this,
	                    now = tooltip.now,
	                    animate = tooltip.options.animation !== false && !tooltip.isHidden &&
	                    // When we get close to the target position, abort animation and land on the right place (#3056)
	                    (Math.abs(x - now.x) > 1 || Math.abs(y - now.y) > 1),
	                    skipAnchor = tooltip.followPointer || tooltip.len > 1;
	
	                // Get intermediate values for animation
	                extend(now, {
	                    x: animate ? (2 * now.x + x) / 3 : x,
	                    y: animate ? (now.y + y) / 2 : y,
	                    anchorX: skipAnchor ? undefined : animate ? (2 * now.anchorX + anchorX) / 3 : anchorX,
	                    anchorY: skipAnchor ? undefined : animate ? (now.anchorY + anchorY) / 2 : anchorY
	                });
	
	                // Move to the intermediate value
	                tooltip.getLabel().attr(now);
	
	
	                // Run on next tick of the mouse tracker
	                if (animate) {
	
	                    // Never allow two timeouts
	                    clearTimeout(this.tooltipTimeout);
	
	                    // Set the fixed interval ticking for the smooth tooltip
	                    this.tooltipTimeout = setTimeout(function() {
	                        // The interval function may still be running during destroy,
	                        // so check that the chart is really there before calling.
	                        if (tooltip) {
	                            tooltip.move(x, y, anchorX, anchorY);
	                        }
	                    }, 32);
	
	                }
	            },
	
	            /**
	             * Hide the tooltip
	             */
	            hide: function(delay) {
	                var tooltip = this;
	                clearTimeout(this.hideTimer); // disallow duplicate timers (#1728, #1766)
	                delay = pick(delay, this.options.hideDelay, 500);
	                if (!this.isHidden) {
	                    this.hideTimer = syncTimeout(function() {
	                        tooltip.getLabel()[delay ? 'fadeOut' : 'hide']();
	                        tooltip.isHidden = true;
	                    }, delay);
	                }
	            },
	
	            /**
	             * Extendable method to get the anchor position of the tooltip
	             * from a point or set of points
	             */
	            getAnchor: function(points, mouseEvent) {
	                var ret,
	                    chart = this.chart,
	                    inverted = chart.inverted,
	                    plotTop = chart.plotTop,
	                    plotLeft = chart.plotLeft,
	                    plotX = 0,
	                    plotY = 0,
	                    yAxis,
	                    xAxis;
	
	                points = splat(points);
	
	                // Pie uses a special tooltipPos
	                ret = points[0].tooltipPos;
	
	                // When tooltip follows mouse, relate the position to the mouse
	                if (this.followPointer && mouseEvent) {
	                    if (mouseEvent.chartX === undefined) {
	                        mouseEvent = chart.pointer.normalize(mouseEvent);
	                    }
	                    ret = [
	                        mouseEvent.chartX - chart.plotLeft,
	                        mouseEvent.chartY - plotTop
	                    ];
	                }
	                // When shared, use the average position
	                if (!ret) {
	                    each(points, function(point) {
	                        yAxis = point.series.yAxis;
	                        xAxis = point.series.xAxis;
	                        plotX += point.plotX + (!inverted && xAxis ? xAxis.left - plotLeft : 0);
	                        plotY += (point.plotLow ? (point.plotLow + point.plotHigh) / 2 : point.plotY) +
	                            (!inverted && yAxis ? yAxis.top - plotTop : 0); // #1151
	                    });
	
	                    plotX /= points.length;
	                    plotY /= points.length;
	
	                    ret = [
	                        inverted ? chart.plotWidth - plotY : plotX,
	                        this.shared && !inverted && points.length > 1 && mouseEvent ?
	                        mouseEvent.chartY - plotTop : // place shared tooltip next to the mouse (#424)
	                        inverted ? chart.plotHeight - plotX : plotY
	                    ];
	                }
	
	                return map(ret, Math.round);
	            },
	
	            /**
	             * Place the tooltip in a chart without spilling over
	             * and not covering the point it self.
	             */
	            getPosition: function(boxWidth, boxHeight, point) {
	
	                var chart = this.chart,
	                    distance = this.distance,
	                    ret = {},
	                    h = point.h || 0, // #4117
	                    swapped,
	                    first = ['y', chart.chartHeight, boxHeight,
	                        point.plotY + chart.plotTop, chart.plotTop,
	                        chart.plotTop + chart.plotHeight
	                    ],
	                    second = ['x', chart.chartWidth, boxWidth,
	                        point.plotX + chart.plotLeft, chart.plotLeft,
	                        chart.plotLeft + chart.plotWidth
	                    ],
	                    // The far side is right or bottom
	                    preferFarSide = !this.followPointer && pick(point.ttBelow, !chart.inverted === !!point.negative), // #4984
	                    /**
	                     * Handle the preferred dimension. When the preferred dimension is tooltip
	                     * on top or bottom of the point, it will look for space there.
	                     */
	                    firstDimension = function(dim, outerSize, innerSize, point, min, max) {
	                        var roomLeft = innerSize < point - distance,
	                            roomRight = point + distance + innerSize < outerSize,
	                            alignedLeft = point - distance - innerSize,
	                            alignedRight = point + distance;
	
	                        if (preferFarSide && roomRight) {
	                            ret[dim] = alignedRight;
	                        } else if (!preferFarSide && roomLeft) {
	                            ret[dim] = alignedLeft;
	                        } else if (roomLeft) {
	                            ret[dim] = Math.min(max - innerSize, alignedLeft - h < 0 ? alignedLeft : alignedLeft - h);
	                        } else if (roomRight) {
	                            ret[dim] = Math.max(
	                                min,
	                                alignedRight + h + innerSize > outerSize ?
	                                alignedRight :
	                                alignedRight + h
	                            );
	                        } else {
	                            return false;
	                        }
	                    },
	                    /**
	                     * Handle the secondary dimension. If the preferred dimension is tooltip
	                     * on top or bottom of the point, the second dimension is to align the tooltip
	                     * above the point, trying to align center but allowing left or right
	                     * align within the chart box.
	                     */
	                    secondDimension = function(dim, outerSize, innerSize, point) {
	                        var retVal;
	
	                        // Too close to the edge, return false and swap dimensions
	                        if (point < distance || point > outerSize - distance) {
	                            retVal = false;
	                            // Align left/top
	                        } else if (point < innerSize / 2) {
	                            ret[dim] = 1;
	                            // Align right/bottom
	                        } else if (point > outerSize - innerSize / 2) {
	                            ret[dim] = outerSize - innerSize - 2;
	                            // Align center
	                        } else {
	                            ret[dim] = point - innerSize / 2;
	                        }
	                        return retVal;
	                    },
	                    /**
	                     * Swap the dimensions
	                     */
	                    swap = function(count) {
	                        var temp = first;
	                        first = second;
	                        second = temp;
	                        swapped = count;
	                    },
	                    run = function() {
	                        if (firstDimension.apply(0, first) !== false) {
	                            if (secondDimension.apply(0, second) === false && !swapped) {
	                                swap(true);
	                                run();
	                            }
	                        } else if (!swapped) {
	                            swap(true);
	                            run();
	                        } else {
	                            ret.x = ret.y = 0;
	                        }
	                    };
	
	                // Under these conditions, prefer the tooltip on the side of the point
	                if (chart.inverted || this.len > 1) {
	                    swap();
	                }
	                run();
	
	                return ret;
	
	            },
	
	            /**
	             * In case no user defined formatter is given, this will be used. Note that the context
	             * here is an object holding point, series, x, y etc.
	             *
	             * @returns {String|Array<String>}
	             */
	            defaultFormatter: function(tooltip) {
	                var items = this.points || splat(this),
	                    s;
	
	                // Build the header
	                s = [tooltip.tooltipFooterHeaderFormatter(items[0])];
	
	                // build the values
	                s = s.concat(tooltip.bodyFormatter(items));
	
	                // footer
	                s.push(tooltip.tooltipFooterHeaderFormatter(items[0], true));
	
	                return s;
	            },
	
	            /**
	             * Refresh the tooltip's text and position.
	             * @param {Object|Array} pointOrPoints Rither a point or an array of points
	             */
	            refresh: function(pointOrPoints, mouseEvent) {
	                var tooltip = this,
	                    label,
	                    options = tooltip.options,
	                    x,
	                    y,
	                    point = pointOrPoints,
	                    anchor,
	                    textConfig = {},
	                    text,
	                    pointConfig = [],
	                    formatter = options.formatter || tooltip.defaultFormatter,
	                    shared = tooltip.shared,
	                    currentSeries;
	
	                clearTimeout(this.hideTimer);
	
	                // get the reference point coordinates (pie charts use tooltipPos)
	                tooltip.followPointer = splat(point)[0].series.tooltipOptions.followPointer;
	                anchor = tooltip.getAnchor(point, mouseEvent);
	                x = anchor[0];
	                y = anchor[1];
	
	                // shared tooltip, array is sent over
	                if (shared && !(point.series && point.series.noSharedTooltip)) {
	                    each(point, function(item) {
	                        item.setState('hover');
	
	                        pointConfig.push(item.getLabelConfig());
	                    });
	
	                    textConfig = {
	                        x: point[0].category,
	                        y: point[0].y
	                    };
	                    textConfig.points = pointConfig;
	                    point = point[0];
	
	                    // single point tooltip
	                } else {
	                    textConfig = point.getLabelConfig();
	                }
	                this.len = pointConfig.length; // #6128
	                text = formatter.call(textConfig, tooltip);
	
	                // register the current series
	                currentSeries = point.series;
	                this.distance = pick(currentSeries.tooltipOptions.distance, 16);
	
	                // update the inner HTML
	                if (text === false) {
	                    this.hide();
	                } else {
	
	                    label = tooltip.getLabel();
	
	                    // show it
	                    if (tooltip.isHidden) {
	                        label.attr({
	                            opacity: 1
	                        }).show();
	                    }
	
	                    // update text
	                    if (tooltip.split) {
	                        this.renderSplit(text, pointOrPoints);
	                    } else {
	
	                        // Prevent the tooltip from flowing over the chart box (#6659)
	
	                        if (!options.style.width) {
	
	                            label.css({
	                                width: this.chart.spacingBox.width
	                            });
	
	                        }
	
	
	                        label.attr({
	                            text: text && text.join ? text.join('') : text
	                        });
	
	                        // Set the stroke color of the box to reflect the point
	                        label.removeClass(/highcharts-color-[\d]+/g)
	                            .addClass('highcharts-color-' + pick(point.colorIndex, currentSeries.colorIndex));
	
	
	                        label.attr({
	                            stroke: options.borderColor || point.color || currentSeries.color || '#666666'
	                        });
	
	
	                        tooltip.updatePosition({
	                            plotX: x,
	                            plotY: y,
	                            negative: point.negative,
	                            ttBelow: point.ttBelow,
	                            h: anchor[2] || 0
	                        });
	                    }
	
	                    this.isHidden = false;
	                }
	            },
	
	            /**
	             * Render the split tooltip. Loops over each point's text and adds
	             * a label next to the point, then uses the distribute function to 
	             * find best non-overlapping positions.
	             */
	            renderSplit: function(labels, points) {
	                var tooltip = this,
	                    boxes = [],
	                    chart = this.chart,
	                    ren = chart.renderer,
	                    rightAligned = true,
	                    options = this.options,
	                    headerHeight,
	                    tooltipLabel = this.getLabel();
	
	                // Create the individual labels for header and points, ignore footer
	                each(labels.slice(0, points.length + 1), function(str, i) {
	                    var point = points[i - 1] ||
	                        // Item 0 is the header. Instead of this, we could also use the crosshair label
	                        {
	                            isHeader: true,
	                            plotX: points[0].plotX
	                        },
	                        owner = point.series || tooltip,
	                        tt = owner.tt,
	                        series = point.series || {},
	                        colorClass = 'highcharts-color-' + pick(point.colorIndex, series.colorIndex, 'none'),
	                        target,
	                        x,
	                        bBox,
	                        boxWidth;
	
	                    // Store the tooltip referance on the series
	                    if (!tt) {
	                        owner.tt = tt = ren.label(null, null, null, 'callout')
	                            .addClass('highcharts-tooltip-box ' + colorClass)
	                            .attr({
	                                'padding': options.padding,
	                                'r': options.borderRadius,
	
	                                'fill': options.backgroundColor,
	                                'stroke': point.color || series.color || '#333333',
	                                'stroke-width': options.borderWidth
	
	                            })
	                            .add(tooltipLabel);
	                    }
	
	                    tt.isActive = true;
	                    tt.attr({
	                        text: str
	                    });
	
	                    tt.css(options.style);
	
	
	                    // Get X position now, so we can move all to the other side in case of overflow
	                    bBox = tt.getBBox();
	                    boxWidth = bBox.width + tt.strokeWidth();
	                    if (point.isHeader) {
	                        headerHeight = bBox.height;
	                        x = Math.max(
	                            0, // No left overflow
	                            Math.min(
	                                point.plotX + chart.plotLeft - boxWidth / 2,
	                                chart.chartWidth - boxWidth // No right overflow (#5794)
	                            )
	                        );
	                    } else {
	                        x = point.plotX + chart.plotLeft - pick(options.distance, 16) -
	                            boxWidth;
	                    }
	
	
	                    // If overflow left, we don't use this x in the next loop
	                    if (x < 0) {
	                        rightAligned = false;
	                    }
	
	                    // Prepare for distribution
	                    target = (point.series && point.series.yAxis && point.series.yAxis.pos) + (point.plotY || 0);
	                    target -= chart.plotTop;
	                    boxes.push({
	                        target: point.isHeader ? chart.plotHeight + headerHeight : target,
	                        rank: point.isHeader ? 1 : 0,
	                        size: owner.tt.getBBox().height + 1,
	                        point: point,
	                        x: x,
	                        tt: tt
	                    });
	                });
	
	                // Clean previous run (for missing points)
	                this.cleanSplit();
	
	                // Distribute and put in place
	                H.distribute(boxes, chart.plotHeight + headerHeight);
	                each(boxes, function(box) {
	                    var point = box.point,
	                        series = point.series;
	
	                    // Put the label in place
	                    box.tt.attr({
	                        visibility: box.pos === undefined ? 'hidden' : 'inherit',
	                        x: (rightAligned || point.isHeader ?
	                            box.x :
	                            point.plotX + chart.plotLeft + pick(options.distance, 16)),
	                        y: box.pos + chart.plotTop,
	                        anchorX: point.isHeader ?
	                            point.plotX + chart.plotLeft : point.plotX + series.xAxis.pos,
	                        anchorY: point.isHeader ?
	                            box.pos + chart.plotTop - 15 : point.plotY + series.yAxis.pos
	                    });
	                });
	            },
	
	            /**
	             * Find the new position and perform the move
	             */
	            updatePosition: function(point) {
	                var chart = this.chart,
	                    label = this.getLabel(),
	                    pos = (this.options.positioner || this.getPosition).call(
	                        this,
	                        label.width,
	                        label.height,
	                        point
	                    );
	
	                // do the move
	                this.move(
	                    Math.round(pos.x),
	                    Math.round(pos.y || 0), // can be undefined (#3977) 
	                    point.plotX + chart.plotLeft,
	                    point.plotY + chart.plotTop
	                );
	            },
	
	            /**
	             * Get the optimal date format for a point, based on a range.
	             * @param  {number} range - The time range
	             * @param  {number|Date} date - The date of the point in question
	             * @param  {number} startOfWeek - An integer representing the first day of
	             * the week, where 0 is Sunday
	             * @param  {Object} dateTimeLabelFormats - A map of time units to formats
	             * @return {string} - the optimal date format for a point
	             */
	            getDateFormat: function(range, date, startOfWeek, dateTimeLabelFormats) {
	                var dateStr = dateFormat('%m-%d %H:%M:%S.%L', date),
	                    format,
	                    n,
	                    blank = '01-01 00:00:00.000',
	                    strpos = {
	                        millisecond: 15,
	                        second: 12,
	                        minute: 9,
	                        hour: 6,
	                        day: 3
	                    },
	                    lastN = 'millisecond'; // for sub-millisecond data, #4223
	                for (n in timeUnits) {
	
	                    // If the range is exactly one week and we're looking at a Sunday/Monday, go for the week format
	                    if (range === timeUnits.week && +dateFormat('%w', date) === startOfWeek &&
	                        dateStr.substr(6) === blank.substr(6)) {
	                        n = 'week';
	                        break;
	                    }
	
	                    // The first format that is too great for the range
	                    if (timeUnits[n] > range) {
	                        n = lastN;
	                        break;
	                    }
	
	                    // If the point is placed every day at 23:59, we need to show
	                    // the minutes as well. #2637.
	                    if (strpos[n] && dateStr.substr(strpos[n]) !== blank.substr(strpos[n])) {
	                        break;
	                    }
	
	                    // Weeks are outside the hierarchy, only apply them on Mondays/Sundays like in the first condition
	                    if (n !== 'week') {
	                        lastN = n;
	                    }
	                }
	
	                if (n) {
	                    format = dateTimeLabelFormats[n];
	                }
	
	                return format;
	            },
	
	            /**
	             * Get the best X date format based on the closest point range on the axis.
	             */
	            getXDateFormat: function(point, options, xAxis) {
	                var xDateFormat,
	                    dateTimeLabelFormats = options.dateTimeLabelFormats,
	                    closestPointRange = xAxis && xAxis.closestPointRange;
	
	                if (closestPointRange) {
	                    xDateFormat = this.getDateFormat(
	                        closestPointRange,
	                        point.x,
	                        xAxis.options.startOfWeek,
	                        dateTimeLabelFormats
	                    );
	                } else {
	                    xDateFormat = dateTimeLabelFormats.day;
	                }
	
	                return xDateFormat || dateTimeLabelFormats.year; // #2546, 2581
	            },
	
	            /**
	             * Format the footer/header of the tooltip
	             * #3397: abstraction to enable formatting of footer and header
	             */
	            tooltipFooterHeaderFormatter: function(labelConfig, isFooter) {
	                var footOrHead = isFooter ? 'footer' : 'header',
	                    series = labelConfig.series,
	                    tooltipOptions = series.tooltipOptions,
	                    xDateFormat = tooltipOptions.xDateFormat,
	                    xAxis = series.xAxis,
	                    isDateTime = xAxis && xAxis.options.type === 'datetime' && isNumber(labelConfig.key),
	                    formatString = tooltipOptions[footOrHead + 'Format'];
	
	                // Guess the best date format based on the closest point distance (#568, #3418)
	                if (isDateTime && !xDateFormat) {
	                    xDateFormat = this.getXDateFormat(labelConfig, tooltipOptions, xAxis);
	                }
	
	                // Insert the footer date format if any
	                if (isDateTime && xDateFormat) {
	                    formatString = formatString.replace('{point.key}', '{point.key:' + xDateFormat + '}');
	                }
	
	                return format(formatString, {
	                    point: labelConfig,
	                    series: series
	                });
	            },
	
	            /**
	             * Build the body (lines) of the tooltip by iterating over the items and returning one entry for each item,
	             * abstracting this functionality allows to easily overwrite and extend it.
	             */
	            bodyFormatter: function(items) {
	                return map(items, function(item) {
	                    var tooltipOptions = item.series.tooltipOptions;
	                    return (tooltipOptions.pointFormatter || item.point.tooltipFormatter)
	                        .call(item.point, tooltipOptions.pointFormat);
	                });
	            }
	
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            attr = H.attr,
	            charts = H.charts,
	            color = H.color,
	            css = H.css,
	            defined = H.defined,
	            doc = H.doc,
	            each = H.each,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            offset = H.offset,
	            pick = H.pick,
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            Tooltip = H.Tooltip,
	            win = H.win;
	
	        /**
	         * The mouse tracker object. All methods starting with "on" are primary DOM
	         * event handlers. Subsequent methods should be named differently from what they
	         * are doing.
	         *
	         * @constructor Pointer
	         * @param {Object} chart The Chart instance
	         * @param {Object} options The root options object
	         */
	        H.Pointer = function(chart, options) {
	            this.init(chart, options);
	        };
	
	        H.Pointer.prototype = {
	            /**
	             * Initialize Pointer
	             */
	            init: function(chart, options) {
	
	                // Store references
	                this.options = options;
	                this.chart = chart;
	
	                // Do we need to handle click on a touch device?
	                this.runChartClick = options.chart.events && !!options.chart.events.click;
	
	                this.pinchDown = [];
	                this.lastValidTouch = {};
	
	                if (Tooltip && options.tooltip.enabled) {
	                    chart.tooltip = new Tooltip(chart, options.tooltip);
	                    this.followTouchMove = pick(options.tooltip.followTouchMove, true);
	                }
	
	                this.setDOMEvents();
	            },
	
	            /**
	             * Resolve the zoomType option, this is reset on all touch start and mouse
	             * down events.
	             */
	            zoomOption: function(e) {
	                var chart = this.chart,
	                    options = chart.options.chart,
	                    zoomType = options.zoomType || '',
	                    inverted = chart.inverted,
	                    zoomX,
	                    zoomY;
	
	                // Look for the pinchType option
	                if (/touch/.test(e.type)) {
	                    zoomType = pick(options.pinchType, zoomType);
	                }
	
	                this.zoomX = zoomX = /x/.test(zoomType);
	                this.zoomY = zoomY = /y/.test(zoomType);
	                this.zoomHor = (zoomX && !inverted) || (zoomY && inverted);
	                this.zoomVert = (zoomY && !inverted) || (zoomX && inverted);
	                this.hasZoom = zoomX || zoomY;
	            },
	
	            /**
	             * @typedef  {Object} PointerEvent
	             *           A native browser mouse or touch event, extended with position
	             *           information relative to the {@link Chart.container}.
	             * @property {Number} chartX
	             *           The X coordinate of the pointer interaction relative to the
	             *           chart.
	             * @property {Number} chartY
	             *           The Y coordinate of the pointer interaction relative to the 
	             *           chart.
	             * 
	             */
	            /**
	             * Add crossbrowser support for chartX and chartY.
	             * 
	             * @param  {Object} e
	             *         The event object in standard browsers.
	             *
	             * @return {PointerEvent}
	             *         A browser event with extended properties `chartX` and `chartY`
	             */
	            normalize: function(e, chartPosition) {
	                var chartX,
	                    chartY,
	                    ePos;
	
	                // IE normalizing
	                e = e || win.event;
	                if (!e.target) {
	                    e.target = e.srcElement;
	                }
	
	                // iOS (#2757)
	                ePos = e.touches ? (e.touches.length ? e.touches.item(0) : e.changedTouches[0]) : e;
	
	                // Get mouse position
	                if (!chartPosition) {
	                    this.chartPosition = chartPosition = offset(this.chart.container);
	                }
	
	                // chartX and chartY
	                if (ePos.pageX === undefined) { // IE < 9. #886.
	                    chartX = Math.max(e.x, e.clientX - chartPosition.left); // #2005, #2129: the second case is 
	                    // for IE10 quirks mode within framesets
	                    chartY = e.y;
	                } else {
	                    chartX = ePos.pageX - chartPosition.left;
	                    chartY = ePos.pageY - chartPosition.top;
	                }
	
	                return extend(e, {
	                    chartX: Math.round(chartX),
	                    chartY: Math.round(chartY)
	                });
	            },
	
	            /**
	             * Get the click position in terms of axis values.
	             *
	             * @param {Object} e A pointer event
	             */
	            getCoordinates: function(e) {
	                var coordinates = {
	                    xAxis: [],
	                    yAxis: []
	                };
	
	                each(this.chart.axes, function(axis) {
	                    coordinates[axis.isXAxis ? 'xAxis' : 'yAxis'].push({
	                        axis: axis,
	                        value: axis.toValue(e[axis.horiz ? 'chartX' : 'chartY'])
	                    });
	                });
	                return coordinates;
	            },
	            /**
	             * Collects the points closest to a mouseEvent
	             * @param  {Array} series Array of series to gather points from
	             * @param  {Boolean} shared True if shared tooltip, otherwise false
	             * @param  {Object} e Mouse event which possess a position to compare against
	             * @return {Array} KDPoints sorted by distance
	             */
	            getKDPoints: function(series, shared, e) {
	                var kdpoints = [],
	                    noSharedTooltip,
	                    directTouch,
	                    kdpointT,
	                    i;
	
	                // Find nearest points on all series
	                each(series, function(s) {
	                    // Skip hidden series
	                    noSharedTooltip = s.noSharedTooltip && shared;
	                    directTouch = !shared && s.directTouch;
	                    if (s.visible && !directTouch && pick(s.options.enableMouseTracking, true)) { // #3821
	                        // #3828
	                        kdpointT = s.searchPoint(
	                            e, !noSharedTooltip && s.options.findNearestPointBy.indexOf('y') < 0
	                        );
	                        if (kdpointT && kdpointT.series) { // Point.series becomes null when reset and before redraw (#5197)
	                            kdpoints.push(kdpointT);
	                        }
	                    }
	                });
	
	                // Sort kdpoints by distance to mouse pointer
	                kdpoints.sort(function(p1, p2) {
	                    var isCloserX = p1.distX - p2.distX,
	                        isCloser = p1.dist - p2.dist,
	                        isAbove =
	                        (p2.series.group && p2.series.group.zIndex) -
	                        (p1.series.group && p1.series.group.zIndex),
	                        result;
	
	                    // We have two points which are not in the same place on xAxis and shared tooltip:
	                    if (isCloserX !== 0 && shared) { // #5721
	                        result = isCloserX;
	                        // Points are not exactly in the same place on x/yAxis:
	                    } else if (isCloser !== 0) {
	                        result = isCloser;
	                        // The same xAxis and yAxis position, sort by z-index:
	                    } else if (isAbove !== 0) {
	                        result = isAbove;
	                        // The same zIndex, sort by array index:
	                    } else {
	                        result = p1.series.index > p2.series.index ? -1 : 1;
	                    }
	                    return result;
	                });
	
	                // Remove points with different x-positions, required for shared tooltip and crosshairs (#4645):
	                if (shared && kdpoints[0] && !kdpoints[0].series.noSharedTooltip) {
	                    i = kdpoints.length;
	                    while (i--) {
	                        if (kdpoints[i].x !== kdpoints[0].x || kdpoints[i].series.noSharedTooltip) {
	                            kdpoints.splice(i, 1);
	                        }
	                    }
	                }
	                return kdpoints;
	            },
	            getPointFromEvent: function(e) {
	                var target = e.target,
	                    point;
	
	                while (target && !point) {
	                    point = target.point;
	                    target = target.parentNode;
	                }
	                return point;
	            },
	
	            getChartCoordinatesFromPoint: function(point, inverted) {
	                var series = point.series,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis;
	
	                if (xAxis && yAxis) {
	                    return inverted ? {
	                        chartX: xAxis.len + xAxis.pos - point.clientX,
	                        chartY: yAxis.len + yAxis.pos - point.plotY
	                    } : {
	                        chartX: point.clientX + xAxis.pos,
	                        chartY: point.plotY + yAxis.pos
	                    };
	                }
	            },
	
	            /**
	             * Calculates what is the current hovered point/points and series.
	             *
	             * @private
	             *
	             * @param  {undefined|Point} existingHoverPoint
	             *         The point currrently beeing hovered.
	             * @param  {undefined|Series} existingHoverSeries
	             *         The series currently beeing hovered.
	             * @param  {Array<.Series>} series
	             *         All the series in the chart.
	             * @param  {boolean} isDirectTouch
	             *         Is the pointer directly hovering the point.
	             * @param  {boolean} shared
	             *         Whether it is a shared tooltip or not.
	             * @param  {object} coordinates
	             *         Chart coordinates of the pointer.
	             * @param  {number} coordinates.chartX
	             * @param  {number} coordinates.chartY
	             * 
	             * @return {object}
	             *         Object containing resulting hover data.
	             */
	            getHoverData: function(
	                existingHoverPoint,
	                existingHoverSeries,
	                series,
	                isDirectTouch,
	                shared,
	                coordinates
	            ) {
	                var hoverPoint = existingHoverPoint,
	                    hoverSeries = existingHoverSeries,
	                    searchSeries = shared ? series : [hoverSeries],
	                    useExisting = !!(isDirectTouch && existingHoverPoint),
	                    notSticky = hoverSeries && !hoverSeries.stickyTracking,
	                    isHoverPoint = function(point, i) {
	                        return i === 0;
	                    },
	                    hoverPoints;
	
	                // If there is a hoverPoint and its series requires direct touch (like
	                // columns, #3899), or we're on a noSharedTooltip series among shared
	                // tooltip series (#4546), use the existing hoverPoint.
	                if (useExisting) {
	                    isHoverPoint = function(p) {
	                        return p === existingHoverPoint;
	                    };
	                } else if (notSticky) {
	                    isHoverPoint = function(p) {
	                        return p.series === hoverSeries;
	                    };
	                } else {
	                    // Avoid series with stickyTracking false
	                    searchSeries = H.grep(series, function(s) {
	                        return s.stickyTracking;
	                    });
	                }
	                hoverPoints = (useExisting && !shared) ?
	                    // Non-shared tooltips with directTouch don't use the k-d-tree
	                    [existingHoverPoint] :
	                    this.getKDPoints(searchSeries, shared, coordinates);
	                hoverPoint = H.find(hoverPoints, isHoverPoint);
	                hoverSeries = hoverPoint && hoverPoint.series;
	
	                // In this case we could only look for the hoverPoint in series with
	                // stickyTracking, but we should still include all series in the shared
	                // tooltip.
	                if (!useExisting && !notSticky && shared) {
	                    hoverPoints = this.getKDPoints(series, shared, coordinates);
	                }
	                // Keep the order of series in tooltip
	                // Must be done after assigning of hoverPoint
	                hoverPoints.sort(function(p1, p2) {
	                    return p1.series.index - p2.series.index;
	                });
	
	                return {
	                    hoverPoint: hoverPoint,
	                    hoverSeries: hoverSeries,
	                    hoverPoints: hoverPoints
	                };
	            },
	            /**
	             * With line type charts with a single tracker, get the point closest to the mouse.
	             * Run Point.onMouseOver and display tooltip for the point or points.
	             */
	            runPointActions: function(e, p) {
	                var pointer = this,
	                    chart = pointer.chart,
	                    series = chart.series,
	                    tooltip = chart.tooltip,
	                    shared = tooltip ? tooltip.shared : false,
	                    hoverPoint = p || chart.hoverPoint,
	                    hoverSeries = hoverPoint && hoverPoint.series || chart.hoverSeries,
	                    // onMouseOver or already hovering a series with directTouch
	                    isDirectTouch = !!p || (
	                        (hoverSeries && hoverSeries.directTouch) &&
	                        pointer.isDirectTouch
	                    ),
	                    hoverData = this.getHoverData(
	                        hoverPoint,
	                        hoverSeries,
	                        series,
	                        isDirectTouch,
	                        shared,
	                        e
	                    ),
	                    useSharedTooltip,
	                    followPointer,
	                    anchor,
	                    points;
	                // Update variables from hoverData.
	                hoverPoint = hoverData.hoverPoint;
	                hoverSeries = hoverData.hoverSeries;
	                followPointer = hoverSeries && hoverSeries.tooltipOptions.followPointer;
	                useSharedTooltip = (
	                    shared &&
	                    hoverPoint &&
	                    !hoverPoint.series.noSharedTooltip
	                );
	                points = (useSharedTooltip ?
	                    hoverData.hoverPoints :
	                    (hoverPoint ? [hoverPoint] : [])
	                );
	                // Refresh tooltip for kdpoint if new hover point or tooltip was hidden
	                // #3926, #4200
	                if (
	                    hoverPoint &&
	                    // !(hoverSeries && hoverSeries.directTouch) &&
	                    (hoverPoint !== chart.hoverPoint || (tooltip && tooltip.isHidden))
	                ) {
	                    each(chart.hoverPoints || [], function(p) {
	                        if (H.inArray(p, points) === -1) {
	                            p.setState();
	                        }
	                    });
	                    // Do mouseover on all points (#3919, #3985, #4410, #5622)
	                    each(points || [], function(p) {
	                        p.setState('hover');
	                    });
	                    // set normal state to previous series
	                    if (chart.hoverSeries !== hoverSeries) {
	                        hoverSeries.onMouseOver();
	                    }
	
	                    // If tracking is on series in stead of on each point, 
	                    // fire mouseOver on hover point. // #4448
	                    if (chart.hoverPoint) {
	                        chart.hoverPoint.firePointEvent('mouseOut');
	                    }
	                    hoverPoint.firePointEvent('mouseOver');
	                    chart.hoverPoints = points;
	                    chart.hoverPoint = hoverPoint;
	                    // Draw tooltip if necessary
	                    if (tooltip) {
	                        tooltip.refresh(useSharedTooltip ? points : hoverPoint, e);
	                    }
	                    // Update positions (regardless of kdpoint or hoverPoint)
	                } else if (followPointer && tooltip && !tooltip.isHidden) {
	                    anchor = tooltip.getAnchor([{}], e);
	                    tooltip.updatePosition({
	                        plotX: anchor[0],
	                        plotY: anchor[1]
	                    });
	                }
	
	                // Start the event listener to pick up the tooltip and crosshairs
	                if (!pointer.unDocMouseMove) {
	                    pointer.unDocMouseMove = addEvent(doc, 'mousemove', function(e) {
	                        var chart = charts[H.hoverChartIndex];
	                        if (chart) {
	                            chart.pointer.onDocumentMouseMove(e);
	                        }
	                    });
	                }
	
	                // Issues related to crosshair #4927, #5269 #5066, #5658
	                each(chart.axes, function drawAxisCrosshair(axis) {
	                    var snap = pick(axis.crosshair.snap, true);
	                    if (!snap) {
	                        axis.drawCrosshair(e);
	
	                        // Axis has snapping crosshairs, and one of the hover points belongs
	                        // to axis
	                    } else if (H.find(points, function(p) {
	                            return p.series[axis.coll] === axis;
	                        })) {
	                        axis.drawCrosshair(e, hoverPoint);
	                        // Axis has snapping crosshairs, but no hover point belongs to axis
	                    } else {
	                        axis.hideCrosshair();
	                    }
	                });
	            },
	
	            /**
	             * Reset the tracking by hiding the tooltip, the hover series state and the
	             * hover point
	             *
	             * @param allowMove {Boolean}
	             *        Instead of destroying the tooltip altogether, allow moving it if
	             *        possible
	             */
	            reset: function(allowMove, delay) {
	                var pointer = this,
	                    chart = pointer.chart,
	                    hoverSeries = chart.hoverSeries,
	                    hoverPoint = chart.hoverPoint,
	                    hoverPoints = chart.hoverPoints,
	                    tooltip = chart.tooltip,
	                    tooltipPoints = tooltip && tooltip.shared ? hoverPoints : hoverPoint;
	
	                // Check if the points have moved outside the plot area (#1003, #4736, #5101)
	                if (allowMove && tooltipPoints) {
	                    each(splat(tooltipPoints), function(point) {
	                        if (point.series.isCartesian && point.plotX === undefined) {
	                            allowMove = false;
	                        }
	                    });
	                }
	
	                // Just move the tooltip, #349
	                if (allowMove) {
	                    if (tooltip && tooltipPoints) {
	                        tooltip.refresh(tooltipPoints);
	                        if (hoverPoint) { // #2500
	                            hoverPoint.setState(hoverPoint.state, true);
	                            each(chart.axes, function(axis) {
	                                if (axis.crosshair) {
	                                    axis.drawCrosshair(null, hoverPoint);
	                                }
	                            });
	                        }
	                    }
	
	                    // Full reset
	                } else {
	
	                    if (hoverPoint) {
	                        hoverPoint.onMouseOut();
	                    }
	
	                    if (hoverPoints) {
	                        each(hoverPoints, function(point) {
	                            point.setState();
	                        });
	                    }
	
	                    if (hoverSeries) {
	                        hoverSeries.onMouseOut();
	                    }
	
	                    if (tooltip) {
	                        tooltip.hide(delay);
	                    }
	
	                    if (pointer.unDocMouseMove) {
	                        pointer.unDocMouseMove = pointer.unDocMouseMove();
	                    }
	
	                    // Remove crosshairs
	                    each(chart.axes, function(axis) {
	                        axis.hideCrosshair();
	                    });
	
	                    pointer.hoverX = chart.hoverPoints = chart.hoverPoint = null;
	                }
	            },
	
	            /**
	             * Scale series groups to a certain scale and translation
	             */
	            scaleGroups: function(attribs, clip) {
	
	                var chart = this.chart,
	                    seriesAttribs;
	
	                // Scale each series
	                each(chart.series, function(series) {
	                    seriesAttribs = attribs || series.getPlotBox(); // #1701
	                    if (series.xAxis && series.xAxis.zoomEnabled && series.group) {
	                        series.group.attr(seriesAttribs);
	                        if (series.markerGroup) {
	                            series.markerGroup.attr(seriesAttribs);
	                            series.markerGroup.clip(clip ? chart.clipRect : null);
	                        }
	                        if (series.dataLabelsGroup) {
	                            series.dataLabelsGroup.attr(seriesAttribs);
	                        }
	                    }
	                });
	
	                // Clip
	                chart.clipRect.attr(clip || chart.clipBox);
	            },
	
	            /**
	             * Start a drag operation
	             */
	            dragStart: function(e) {
	                var chart = this.chart;
	
	                // Record the start position
	                chart.mouseIsDown = e.type;
	                chart.cancelClick = false;
	                chart.mouseDownX = this.mouseDownX = e.chartX;
	                chart.mouseDownY = this.mouseDownY = e.chartY;
	            },
	
	            /**
	             * Perform a drag operation in response to a mousemove event while the mouse is down
	             */
	            drag: function(e) {
	
	                var chart = this.chart,
	                    chartOptions = chart.options.chart,
	                    chartX = e.chartX,
	                    chartY = e.chartY,
	                    zoomHor = this.zoomHor,
	                    zoomVert = this.zoomVert,
	                    plotLeft = chart.plotLeft,
	                    plotTop = chart.plotTop,
	                    plotWidth = chart.plotWidth,
	                    plotHeight = chart.plotHeight,
	                    clickedInside,
	                    size,
	                    selectionMarker = this.selectionMarker,
	                    mouseDownX = this.mouseDownX,
	                    mouseDownY = this.mouseDownY,
	                    panKey = chartOptions.panKey && e[chartOptions.panKey + 'Key'];
	
	                // If the device supports both touch and mouse (like IE11), and we are touch-dragging
	                // inside the plot area, don't handle the mouse event. #4339.
	                if (selectionMarker && selectionMarker.touch) {
	                    return;
	                }
	
	                // If the mouse is outside the plot area, adjust to cooordinates
	                // inside to prevent the selection marker from going outside
	                if (chartX < plotLeft) {
	                    chartX = plotLeft;
	                } else if (chartX > plotLeft + plotWidth) {
	                    chartX = plotLeft + plotWidth;
	                }
	
	                if (chartY < plotTop) {
	                    chartY = plotTop;
	                } else if (chartY > plotTop + plotHeight) {
	                    chartY = plotTop + plotHeight;
	                }
	
	                // determine if the mouse has moved more than 10px
	                this.hasDragged = Math.sqrt(
	                    Math.pow(mouseDownX - chartX, 2) +
	                    Math.pow(mouseDownY - chartY, 2)
	                );
	
	                if (this.hasDragged > 10) {
	                    clickedInside = chart.isInsidePlot(mouseDownX - plotLeft, mouseDownY - plotTop);
	
	                    // make a selection
	                    if (chart.hasCartesianSeries && (this.zoomX || this.zoomY) && clickedInside && !panKey) {
	                        if (!selectionMarker) {
	                            this.selectionMarker = selectionMarker = chart.renderer.rect(
	                                    plotLeft,
	                                    plotTop,
	                                    zoomHor ? 1 : plotWidth,
	                                    zoomVert ? 1 : plotHeight,
	                                    0
	                                )
	                                .attr({
	
	                                    fill: chartOptions.selectionMarkerFill || color('#335cad').setOpacity(0.25).get(),
	
	                                    'class': 'highcharts-selection-marker',
	                                    'zIndex': 7
	                                })
	                                .add();
	                        }
	                    }
	
	                    // adjust the width of the selection marker
	                    if (selectionMarker && zoomHor) {
	                        size = chartX - mouseDownX;
	                        selectionMarker.attr({
	                            width: Math.abs(size),
	                            x: (size > 0 ? 0 : size) + mouseDownX
	                        });
	                    }
	                    // adjust the height of the selection marker
	                    if (selectionMarker && zoomVert) {
	                        size = chartY - mouseDownY;
	                        selectionMarker.attr({
	                            height: Math.abs(size),
	                            y: (size > 0 ? 0 : size) + mouseDownY
	                        });
	                    }
	
	                    // panning
	                    if (clickedInside && !selectionMarker && chartOptions.panning) {
	                        chart.pan(e, chartOptions.panning);
	                    }
	                }
	            },
	
	            /**
	             * On mouse up or touch end across the entire document, drop the selection.
	             */
	            drop: function(e) {
	                var pointer = this,
	                    chart = this.chart,
	                    hasPinched = this.hasPinched;
	
	                if (this.selectionMarker) {
	                    var selectionData = {
	                            originalEvent: e, // #4890
	                            xAxis: [],
	                            yAxis: []
	                        },
	                        selectionBox = this.selectionMarker,
	                        selectionLeft = selectionBox.attr ? selectionBox.attr('x') : selectionBox.x,
	                        selectionTop = selectionBox.attr ? selectionBox.attr('y') : selectionBox.y,
	                        selectionWidth = selectionBox.attr ? selectionBox.attr('width') : selectionBox.width,
	                        selectionHeight = selectionBox.attr ? selectionBox.attr('height') : selectionBox.height,
	                        runZoom;
	
	                    // a selection has been made
	                    if (this.hasDragged || hasPinched) {
	
	                        // record each axis' min and max
	                        each(chart.axes, function(axis) {
	                            if (axis.zoomEnabled && defined(axis.min) && (hasPinched || pointer[{
	                                    xAxis: 'zoomX',
	                                    yAxis: 'zoomY'
	                                }[axis.coll]])) { // #859, #3569
	                                var horiz = axis.horiz,
	                                    minPixelPadding = e.type === 'touchend' ? axis.minPixelPadding : 0, // #1207, #3075
	                                    selectionMin = axis.toValue((horiz ? selectionLeft : selectionTop) + minPixelPadding),
	                                    selectionMax = axis.toValue((horiz ? selectionLeft + selectionWidth : selectionTop + selectionHeight) - minPixelPadding);
	
	                                selectionData[axis.coll].push({
	                                    axis: axis,
	                                    min: Math.min(selectionMin, selectionMax), // for reversed axes
	                                    max: Math.max(selectionMin, selectionMax)
	                                });
	                                runZoom = true;
	                            }
	                        });
	                        if (runZoom) {
	                            fireEvent(chart, 'selection', selectionData, function(args) {
	                                chart.zoom(extend(args, hasPinched ? {
	                                    animation: false
	                                } : null));
	                            });
	                        }
	
	                    }
	                    this.selectionMarker = this.selectionMarker.destroy();
	
	                    // Reset scaling preview
	                    if (hasPinched) {
	                        this.scaleGroups();
	                    }
	                }
	
	                // Reset all
	                if (chart) { // it may be destroyed on mouse up - #877
	                    css(chart.container, {
	                        cursor: chart._cursor
	                    });
	                    chart.cancelClick = this.hasDragged > 10; // #370
	                    chart.mouseIsDown = this.hasDragged = this.hasPinched = false;
	                    this.pinchDown = [];
	                }
	            },
	
	            onContainerMouseDown: function(e) {
	
	                e = this.normalize(e);
	
	                this.zoomOption(e);
	
	                // issue #295, dragging not always working in Firefox
	                if (e.preventDefault) {
	                    e.preventDefault();
	                }
	
	                this.dragStart(e);
	            },
	
	
	
	            onDocumentMouseUp: function(e) {
	                if (charts[H.hoverChartIndex]) {
	                    charts[H.hoverChartIndex].pointer.drop(e);
	                }
	            },
	
	            /**
	             * Special handler for mouse move that will hide the tooltip when the mouse leaves the plotarea.
	             * Issue #149 workaround. The mouseleave event does not always fire.
	             */
	            onDocumentMouseMove: function(e) {
	                var chart = this.chart,
	                    chartPosition = this.chartPosition;
	
	                e = this.normalize(e, chartPosition);
	
	                // If we're outside, hide the tooltip
	                if (chartPosition && !this.inClass(e.target, 'highcharts-tracker') &&
	                    !chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) {
	                    this.reset();
	                }
	            },
	
	            /**
	             * When mouse leaves the container, hide the tooltip.
	             */
	            onContainerMouseLeave: function(e) {
	                var chart = charts[H.hoverChartIndex];
	                if (chart && (e.relatedTarget || e.toElement)) { // #4886, MS Touch end fires mouseleave but with no related target
	                    chart.pointer.reset();
	                    chart.pointer.chartPosition = null; // also reset the chart position, used in #149 fix
	                }
	            },
	
	            // The mousemove, touchmove and touchstart event handler
	            onContainerMouseMove: function(e) {
	
	                var chart = this.chart;
	
	                if (!defined(H.hoverChartIndex) || !charts[H.hoverChartIndex] || !charts[H.hoverChartIndex].mouseIsDown) {
	                    H.hoverChartIndex = chart.index;
	                }
	
	                e = this.normalize(e);
	                e.returnValue = false; // #2251, #3224
	
	                if (chart.mouseIsDown === 'mousedown') {
	                    this.drag(e);
	                }
	
	                // Show the tooltip and run mouse over events (#977)
	                if ((this.inClass(e.target, 'highcharts-tracker') ||
	                        chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) && !chart.openMenu) {
	                    this.runPointActions(e);
	                }
	            },
	
	            /**
	             * Utility to detect whether an element has, or has a parent with, a specific
	             * class name. Used on detection of tracker objects and on deciding whether
	             * hovering the tooltip should cause the active series to mouse out.
	             */
	            inClass: function(element, className) {
	                var elemClassName;
	                while (element) {
	                    elemClassName = attr(element, 'class');
	                    if (elemClassName) {
	                        if (elemClassName.indexOf(className) !== -1) {
	                            return true;
	                        }
	                        if (elemClassName.indexOf('highcharts-container') !== -1) {
	                            return false;
	                        }
	                    }
	                    element = element.parentNode;
	                }
	            },
	
	            onTrackerMouseOut: function(e) {
	                var series = this.chart.hoverSeries,
	                    relatedTarget = e.relatedTarget || e.toElement;
	                this.isDirectTouch = false;
	                if (series && relatedTarget && !series.stickyTracking &&
	                    !this.inClass(relatedTarget, 'highcharts-tooltip') &&
	                    (!this.inClass(relatedTarget, 'highcharts-series-' + series.index) || // #2499, #4465
	                        !this.inClass(relatedTarget, 'highcharts-tracker') // #5553
	                    )
	                ) {
	                    series.onMouseOut();
	                }
	            },
	
	            onContainerClick: function(e) {
	                var chart = this.chart,
	                    hoverPoint = chart.hoverPoint,
	                    plotLeft = chart.plotLeft,
	                    plotTop = chart.plotTop;
	
	                e = this.normalize(e);
	
	                if (!chart.cancelClick) {
	
	                    // On tracker click, fire the series and point events. #783, #1583
	                    if (hoverPoint && this.inClass(e.target, 'highcharts-tracker')) {
	
	                        // the series click event
	                        fireEvent(hoverPoint.series, 'click', extend(e, {
	                            point: hoverPoint
	                        }));
	
	                        // the point click event
	                        if (chart.hoverPoint) { // it may be destroyed (#1844)
	                            hoverPoint.firePointEvent('click', e);
	                        }
	
	                        // When clicking outside a tracker, fire a chart event
	                    } else {
	                        extend(e, this.getCoordinates(e));
	
	                        // fire a click event in the chart
	                        if (chart.isInsidePlot(e.chartX - plotLeft, e.chartY - plotTop)) {
	                            fireEvent(chart, 'click', e);
	                        }
	                    }
	
	
	                }
	            },
	
	            /**
	             * Set the JS DOM events on the container and document. This method should contain
	             * a one-to-one assignment between methods and their handlers. Any advanced logic should
	             * be moved to the handler reflecting the event's name.
	             */
	            setDOMEvents: function() {
	
	                var pointer = this,
	                    container = pointer.chart.container;
	
	                container.onmousedown = function(e) {
	                    pointer.onContainerMouseDown(e);
	                };
	                container.onmousemove = function(e) {
	                    pointer.onContainerMouseMove(e);
	                };
	                container.onclick = function(e) {
	                    pointer.onContainerClick(e);
	                };
	                addEvent(container, 'mouseleave', pointer.onContainerMouseLeave);
	                if (H.chartCount === 1) {
	                    addEvent(doc, 'mouseup', pointer.onDocumentMouseUp);
	                }
	                if (H.hasTouch) {
	                    container.ontouchstart = function(e) {
	                        pointer.onContainerTouchStart(e);
	                    };
	                    container.ontouchmove = function(e) {
	                        pointer.onContainerTouchMove(e);
	                    };
	                    if (H.chartCount === 1) {
	                        addEvent(doc, 'touchend', pointer.onDocumentTouchEnd);
	                    }
	                }
	
	            },
	
	            /**
	             * Destroys the Pointer object and disconnects DOM events.
	             */
	            destroy: function() {
	                var pointer = this;
	
	                if (pointer.unDocMouseMove) {
	                    pointer.unDocMouseMove();
	                }
	
	                removeEvent(
	                    pointer.chart.container,
	                    'mouseleave',
	                    pointer.onContainerMouseLeave
	                );
	                if (!H.chartCount) {
	                    removeEvent(doc, 'mouseup', pointer.onDocumentMouseUp);
	                    removeEvent(doc, 'touchend', pointer.onDocumentTouchEnd);
	                }
	
	                // memory and CPU leak
	                clearInterval(pointer.tooltipTimeout);
	
	                H.objectEach(pointer, function(val, prop) {
	                    pointer[prop] = null;
	                });
	            }
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var charts = H.charts,
	            each = H.each,
	            extend = H.extend,
	            map = H.map,
	            noop = H.noop,
	            pick = H.pick,
	            Pointer = H.Pointer;
	
	        /* Support for touch devices */
	        extend(Pointer.prototype, /** @lends Pointer.prototype */ {
	
	            /**
	             * Run translation operations
	             */
	            pinchTranslate: function(pinchDown, touches, transform, selectionMarker, clip, lastValidTouch) {
	                if (this.zoomHor) {
	                    this.pinchTranslateDirection(true, pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	                }
	                if (this.zoomVert) {
	                    this.pinchTranslateDirection(false, pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	                }
	            },
	
	            /**
	             * Run translation operations for each direction (horizontal and vertical) independently
	             */
	            pinchTranslateDirection: function(horiz, pinchDown, touches, transform,
	                selectionMarker, clip, lastValidTouch, forcedScale) {
	                var chart = this.chart,
	                    xy = horiz ? 'x' : 'y',
	                    XY = horiz ? 'X' : 'Y',
	                    sChartXY = 'chart' + XY,
	                    wh = horiz ? 'width' : 'height',
	                    plotLeftTop = chart['plot' + (horiz ? 'Left' : 'Top')],
	                    selectionWH,
	                    selectionXY,
	                    clipXY,
	                    scale = forcedScale || 1,
	                    inverted = chart.inverted,
	                    bounds = chart.bounds[horiz ? 'h' : 'v'],
	                    singleTouch = pinchDown.length === 1,
	                    touch0Start = pinchDown[0][sChartXY],
	                    touch0Now = touches[0][sChartXY],
	                    touch1Start = !singleTouch && pinchDown[1][sChartXY],
	                    touch1Now = !singleTouch && touches[1][sChartXY],
	                    outOfBounds,
	                    transformScale,
	                    scaleKey,
	                    setScale = function() {
	                        // Don't zoom if fingers are too close on this axis
	                        if (!singleTouch && Math.abs(touch0Start - touch1Start) > 20) {
	                            scale = forcedScale || Math.abs(touch0Now - touch1Now) / Math.abs(touch0Start - touch1Start);
	                        }
	
	                        clipXY = ((plotLeftTop - touch0Now) / scale) + touch0Start;
	                        selectionWH = chart['plot' + (horiz ? 'Width' : 'Height')] / scale;
	                    };
	
	                // Set the scale, first pass
	                setScale();
	
	                selectionXY = clipXY; // the clip position (x or y) is altered if out of bounds, the selection position is not
	
	                // Out of bounds
	                if (selectionXY < bounds.min) {
	                    selectionXY = bounds.min;
	                    outOfBounds = true;
	                } else if (selectionXY + selectionWH > bounds.max) {
	                    selectionXY = bounds.max - selectionWH;
	                    outOfBounds = true;
	                }
	
	                // Is the chart dragged off its bounds, determined by dataMin and dataMax?
	                if (outOfBounds) {
	
	                    // Modify the touchNow position in order to create an elastic drag movement. This indicates
	                    // to the user that the chart is responsive but can't be dragged further.
	                    touch0Now -= 0.8 * (touch0Now - lastValidTouch[xy][0]);
	                    if (!singleTouch) {
	                        touch1Now -= 0.8 * (touch1Now - lastValidTouch[xy][1]);
	                    }
	
	                    // Set the scale, second pass to adapt to the modified touchNow positions
	                    setScale();
	
	                } else {
	                    lastValidTouch[xy] = [touch0Now, touch1Now];
	                }
	
	                // Set geometry for clipping, selection and transformation
	                if (!inverted) {
	                    clip[xy] = clipXY - plotLeftTop;
	                    clip[wh] = selectionWH;
	                }
	                scaleKey = inverted ? (horiz ? 'scaleY' : 'scaleX') : 'scale' + XY;
	                transformScale = inverted ? 1 / scale : scale;
	
	                selectionMarker[wh] = selectionWH;
	                selectionMarker[xy] = selectionXY;
	                transform[scaleKey] = scale;
	                transform['translate' + XY] = (transformScale * plotLeftTop) + (touch0Now - (transformScale * touch0Start));
	            },
	
	            /**
	             * Handle touch events with two touches
	             */
	            pinch: function(e) {
	
	                var self = this,
	                    chart = self.chart,
	                    pinchDown = self.pinchDown,
	                    touches = e.touches,
	                    touchesLength = touches.length,
	                    lastValidTouch = self.lastValidTouch,
	                    hasZoom = self.hasZoom,
	                    selectionMarker = self.selectionMarker,
	                    transform = {},
	                    fireClickEvent = touchesLength === 1 && ((self.inClass(e.target, 'highcharts-tracker') &&
	                        chart.runTrackerClick) || self.runChartClick),
	                    clip = {};
	
	                // Don't initiate panning until the user has pinched. This prevents us from
	                // blocking page scrolling as users scroll down a long page (#4210).
	                if (touchesLength > 1) {
	                    self.initiated = true;
	                }
	
	                // On touch devices, only proceed to trigger click if a handler is defined
	                if (hasZoom && self.initiated && !fireClickEvent) {
	                    e.preventDefault();
	                }
	
	                // Normalize each touch
	                map(touches, function(e) {
	                    return self.normalize(e);
	                });
	
	                // Register the touch start position
	                if (e.type === 'touchstart') {
	                    each(touches, function(e, i) {
	                        pinchDown[i] = {
	                            chartX: e.chartX,
	                            chartY: e.chartY
	                        };
	                    });
	                    lastValidTouch.x = [pinchDown[0].chartX, pinchDown[1] && pinchDown[1].chartX];
	                    lastValidTouch.y = [pinchDown[0].chartY, pinchDown[1] && pinchDown[1].chartY];
	
	                    // Identify the data bounds in pixels
	                    each(chart.axes, function(axis) {
	                        if (axis.zoomEnabled) {
	                            var bounds = chart.bounds[axis.horiz ? 'h' : 'v'],
	                                minPixelPadding = axis.minPixelPadding,
	                                min = axis.toPixels(pick(axis.options.min, axis.dataMin)),
	                                max = axis.toPixels(pick(axis.options.max, axis.dataMax)),
	                                absMin = Math.min(min, max),
	                                absMax = Math.max(min, max);
	
	                            // Store the bounds for use in the touchmove handler
	                            bounds.min = Math.min(axis.pos, absMin - minPixelPadding);
	                            bounds.max = Math.max(axis.pos + axis.len, absMax + minPixelPadding);
	                        }
	                    });
	                    self.res = true; // reset on next move
	
	                    // Optionally move the tooltip on touchmove
	                } else if (self.followTouchMove && touchesLength === 1) {
	                    this.runPointActions(self.normalize(e));
	
	                    // Event type is touchmove, handle panning and pinching
	                } else if (pinchDown.length) { // can be 0 when releasing, if touchend fires first
	
	
	                    // Set the marker
	                    if (!selectionMarker) {
	                        self.selectionMarker = selectionMarker = extend({
	                            destroy: noop,
	                            touch: true
	                        }, chart.plotBox);
	                    }
	
	                    self.pinchTranslate(pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	
	                    self.hasPinched = hasZoom;
	
	                    // Scale and translate the groups to provide visual feedback during pinching
	                    self.scaleGroups(transform, clip);
	
	                    if (self.res) {
	                        self.res = false;
	                        this.reset(false, 0);
	                    }
	                }
	            },
	
	            /**
	             * General touch handler shared by touchstart and touchmove.
	             */
	            touch: function(e, start) {
	                var chart = this.chart,
	                    hasMoved,
	                    pinchDown,
	                    isInside;
	
	                if (chart.index !== H.hoverChartIndex) {
	                    this.onContainerMouseLeave({
	                        relatedTarget: true
	                    });
	                }
	                H.hoverChartIndex = chart.index;
	
	                if (e.touches.length === 1) {
	
	                    e = this.normalize(e);
	
	                    isInside = chart.isInsidePlot(
	                        e.chartX - chart.plotLeft,
	                        e.chartY - chart.plotTop
	                    );
	                    if (isInside && !chart.openMenu) {
	
	                        // Run mouse events and display tooltip etc
	                        if (start) {
	                            this.runPointActions(e);
	                        }
	
	                        // Android fires touchmove events after the touchstart even if the
	                        // finger hasn't moved, or moved only a pixel or two. In iOS however,
	                        // the touchmove doesn't fire unless the finger moves more than ~4px.
	                        // So we emulate this behaviour in Android by checking how much it
	                        // moved, and cancelling on small distances. #3450.
	                        if (e.type === 'touchmove') {
	                            pinchDown = this.pinchDown;
	                            hasMoved = pinchDown[0] ? Math.sqrt( // #5266
	                                Math.pow(pinchDown[0].chartX - e.chartX, 2) +
	                                Math.pow(pinchDown[0].chartY - e.chartY, 2)
	                            ) >= 4 : false;
	                        }
	
	                        if (pick(hasMoved, true)) {
	                            this.pinch(e);
	                        }
	
	                    } else if (start) {
	                        // Hide the tooltip on touching outside the plot area (#1203)
	                        this.reset();
	                    }
	
	                } else if (e.touches.length === 2) {
	                    this.pinch(e);
	                }
	            },
	
	            onContainerTouchStart: function(e) {
	                this.zoomOption(e);
	                this.touch(e, true);
	            },
	
	            onContainerTouchMove: function(e) {
	                this.touch(e);
	            },
	
	            onDocumentTouchEnd: function(e) {
	                if (charts[H.hoverChartIndex]) {
	                    charts[H.hoverChartIndex].pointer.drop(e);
	                }
	            }
	
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            charts = H.charts,
	            css = H.css,
	            doc = H.doc,
	            extend = H.extend,
	            hasTouch = H.hasTouch,
	            noop = H.noop,
	            Pointer = H.Pointer,
	            removeEvent = H.removeEvent,
	            win = H.win,
	            wrap = H.wrap;
	
	        if (!hasTouch && (win.PointerEvent || win.MSPointerEvent)) {
	
	            // The touches object keeps track of the points being touched at all times
	            var touches = {},
	                hasPointerEvent = !!win.PointerEvent,
	                getWebkitTouches = function() {
	                    var fake = [];
	                    fake.item = function(i) {
	                        return this[i];
	                    };
	                    H.objectEach(touches, function(touch) {
	                        fake.push({
	                            pageX: touch.pageX,
	                            pageY: touch.pageY,
	                            target: touch.target
	                        });
	                    });
	                    return fake;
	                },
	                translateMSPointer = function(e, method, wktype, func) {
	                    var p;
	                    if ((e.pointerType === 'touch' || e.pointerType === e.MSPOINTER_TYPE_TOUCH) && charts[H.hoverChartIndex]) {
	                        func(e);
	                        p = charts[H.hoverChartIndex].pointer;
	                        p[method]({
	                            type: wktype,
	                            target: e.currentTarget,
	                            preventDefault: noop,
	                            touches: getWebkitTouches()
	                        });
	                    }
	                };
	
	            /**
	             * Extend the Pointer prototype with methods for each event handler and more
	             */
	            extend(Pointer.prototype, /** @lends Pointer.prototype */ {
	                onContainerPointerDown: function(e) {
	                    translateMSPointer(e, 'onContainerTouchStart', 'touchstart', function(e) {
	                        touches[e.pointerId] = {
	                            pageX: e.pageX,
	                            pageY: e.pageY,
	                            target: e.currentTarget
	                        };
	                    });
	                },
	                onContainerPointerMove: function(e) {
	                    translateMSPointer(e, 'onContainerTouchMove', 'touchmove', function(e) {
	                        touches[e.pointerId] = {
	                            pageX: e.pageX,
	                            pageY: e.pageY
	                        };
	                        if (!touches[e.pointerId].target) {
	                            touches[e.pointerId].target = e.currentTarget;
	                        }
	                    });
	                },
	                onDocumentPointerUp: function(e) {
	                    translateMSPointer(e, 'onDocumentTouchEnd', 'touchend', function(e) {
	                        delete touches[e.pointerId];
	                    });
	                },
	
	                /**
	                 * Add or remove the MS Pointer specific events
	                 */
	                batchMSEvents: function(fn) {
	                    fn(this.chart.container, hasPointerEvent ? 'pointerdown' : 'MSPointerDown', this.onContainerPointerDown);
	                    fn(this.chart.container, hasPointerEvent ? 'pointermove' : 'MSPointerMove', this.onContainerPointerMove);
	                    fn(doc, hasPointerEvent ? 'pointerup' : 'MSPointerUp', this.onDocumentPointerUp);
	                }
	            });
	
	            // Disable default IE actions for pinch and such on chart element
	            wrap(Pointer.prototype, 'init', function(proceed, chart, options) {
	                proceed.call(this, chart, options);
	                if (this.hasZoom) { // #4014
	                    css(chart.container, {
	                        '-ms-touch-action': 'none',
	                        'touch-action': 'none'
	                    });
	                }
	            });
	
	            // Add IE specific touch events to chart
	            wrap(Pointer.prototype, 'setDOMEvents', function(proceed) {
	                proceed.apply(this);
	                if (this.hasZoom || this.followTouchMove) {
	                    this.batchMSEvents(addEvent);
	                }
	            });
	            // Destroy MS events also
	            wrap(Pointer.prototype, 'destroy', function(proceed) {
	                this.batchMSEvents(removeEvent);
	                proceed.call(this);
	            });
	        }
	
	    }(Highcharts));
	    (function(Highcharts) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var H = Highcharts,
	
	            addEvent = H.addEvent,
	            css = H.css,
	            discardElement = H.discardElement,
	            defined = H.defined,
	            each = H.each,
	            isFirefox = H.isFirefox,
	            marginNames = H.marginNames,
	            merge = H.merge,
	            pick = H.pick,
	            setAnimation = H.setAnimation,
	            stableSort = H.stableSort,
	            win = H.win,
	            wrap = H.wrap;
	
	        /**
	         * The overview of the chart's series. The legend object is instanciated
	         * internally in the chart constructor, and available from `chart.legend`. Each
	         * chart has only one legend.
	         * 
	         * @class
	         */
	        Highcharts.Legend = function(chart, options) {
	            this.init(chart, options);
	        };
	
	        Highcharts.Legend.prototype = {
	
	            /**
	             * Initialize the legend
	             */
	            init: function(chart, options) {
	
	                this.chart = chart;
	
	                this.setOptions(options);
	
	                if (options.enabled) {
	
	                    // Render it
	                    this.render();
	
	                    // move checkboxes
	                    addEvent(this.chart, 'endResize', function() {
	                        this.legend.positionCheckboxes();
	                    });
	                }
	            },
	
	            setOptions: function(options) {
	
	                var padding = pick(options.padding, 8);
	
	                this.options = options;
	
	
	                this.itemStyle = options.itemStyle;
	                this.itemHiddenStyle = merge(this.itemStyle, options.itemHiddenStyle);
	
	                this.itemMarginTop = options.itemMarginTop || 0;
	                this.padding = padding;
	                this.initialItemY = padding - 5; // 5 is pixels above the text
	                this.maxItemWidth = 0;
	                this.itemHeight = 0;
	                this.symbolWidth = pick(options.symbolWidth, 16);
	                this.pages = [];
	
	            },
	
	            /**
	             * Update the legend with new options. Equivalent to running `chart.update`
	             * with a legend configuration option.
	             * @param  {LegendOptions} options
	             *         Legend options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart.
	             *
	             * @sample highcharts/legend/legend-update/
	             *         Legend update
	             */
	            update: function(options, redraw) {
	                var chart = this.chart;
	
	                this.setOptions(merge(true, this.options, options));
	                this.destroy();
	                chart.isDirtyLegend = chart.isDirtyBox = true;
	                if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Set the colors for the legend item
	             * @param {Object} item A Series or Point instance
	             * @param {Object} visible Dimmed or colored
	             */
	            colorizeItem: function(item, visible) {
	                item.legendGroup[visible ? 'removeClass' : 'addClass'](
	                    'highcharts-legend-item-hidden'
	                );
	
	
	                var legend = this,
	                    options = legend.options,
	                    legendItem = item.legendItem,
	                    legendLine = item.legendLine,
	                    legendSymbol = item.legendSymbol,
	                    hiddenColor = legend.itemHiddenStyle.color,
	                    textColor = visible ? options.itemStyle.color : hiddenColor,
	                    symbolColor = visible ? (item.color || hiddenColor) : hiddenColor,
	                    markerOptions = item.options && item.options.marker,
	                    symbolAttr = {
	                        fill: symbolColor
	                    };
	
	                if (legendItem) {
	                    legendItem.css({
	                        fill: textColor,
	                        color: textColor // #1553, oldIE
	                    });
	                }
	                if (legendLine) {
	                    legendLine.attr({
	                        stroke: symbolColor
	                    });
	                }
	
	                if (legendSymbol) {
	
	                    // Apply marker options
	                    if (markerOptions && legendSymbol.isMarker) { // #585
	                        //symbolAttr.stroke = symbolColor;
	                        symbolAttr = item.pointAttribs();
	                        if (!visible) {
	                            H.objectEach(symbolAttr, function(val, key) {
	                                symbolAttr[key] = hiddenColor;
	                            });
	                        }
	                    }
	
	                    legendSymbol.attr(symbolAttr);
	                }
	
	            },
	
	            /**
	             * Position the legend item
	             * @param {Object} item A Series or Point instance
	             */
	            positionItem: function(item) {
	                var legend = this,
	                    options = legend.options,
	                    symbolPadding = options.symbolPadding,
	                    ltr = !options.rtl,
	                    legendItemPos = item._legendItemPos,
	                    itemX = legendItemPos[0],
	                    itemY = legendItemPos[1],
	                    checkbox = item.checkbox,
	                    legendGroup = item.legendGroup;
	
	                if (legendGroup && legendGroup.element) {
	                    legendGroup.translate(
	                        ltr ?
	                        itemX :
	                        legend.legendWidth - itemX - 2 * symbolPadding - 4,
	                        itemY
	                    );
	                }
	
	                if (checkbox) {
	                    checkbox.x = itemX;
	                    checkbox.y = itemY;
	                }
	            },
	
	            /**
	             * Destroy a single legend item
	             * @param {Object} item The series or point
	             */
	            destroyItem: function(item) {
	                var checkbox = item.checkbox;
	
	                // destroy SVG elements
	                each(
	                    ['legendItem', 'legendLine', 'legendSymbol', 'legendGroup'],
	                    function(key) {
	                        if (item[key]) {
	                            item[key] = item[key].destroy();
	                        }
	                    }
	                );
	
	                if (checkbox) {
	                    discardElement(item.checkbox);
	                }
	            },
	
	            /**
	             * Destroys the legend.
	             */
	            destroy: function() {
	                function destroyItems(key) {
	                    if (this[key]) {
	                        this[key] = this[key].destroy();
	                    }
	                }
	
	                // Destroy items
	                each(this.getAllItems(), function(item) {
	                    each(['legendItem', 'legendGroup'], destroyItems, item);
	                });
	
	                // Destroy legend elements
	                each([
	                    'clipRect',
	                    'up',
	                    'down',
	                    'pager',
	                    'nav',
	                    'box',
	                    'title',
	                    'group'
	                ], destroyItems, this);
	                this.display = null; // Reset in .render on update.
	            },
	
	            /**
	             * Position the checkboxes after the width is determined
	             */
	            positionCheckboxes: function(scrollOffset) {
	                var alignAttr = this.group && this.group.alignAttr,
	                    translateY,
	                    clipHeight = this.clipHeight || this.legendHeight,
	                    titleHeight = this.titleHeight;
	
	                if (alignAttr) {
	                    translateY = alignAttr.translateY;
	                    each(this.allItems, function(item) {
	                        var checkbox = item.checkbox,
	                            top;
	
	                        if (checkbox) {
	                            top = translateY + titleHeight + checkbox.y +
	                                (scrollOffset || 0) + 3;
	                            css(checkbox, {
	                                left: (alignAttr.translateX + item.checkboxOffset +
	                                    checkbox.x - 20) + 'px',
	                                top: top + 'px',
	                                display: top > translateY - 6 && top < translateY +
	                                    clipHeight - 6 ? '' : 'none'
	                            });
	                        }
	                    });
	                }
	            },
	
	            /**
	             * Render the legend title on top of the legend
	             */
	            renderTitle: function() {
	                var options = this.options,
	                    padding = this.padding,
	                    titleOptions = options.title,
	                    titleHeight = 0,
	                    bBox;
	
	                if (titleOptions.text) {
	                    if (!this.title) {
	                        this.title = this.chart.renderer.label(
	                                titleOptions.text,
	                                padding - 3,
	                                padding - 4,
	                                null,
	                                null,
	                                null,
	                                options.useHTML,
	                                null,
	                                'legend-title'
	                            )
	                            .attr({
	                                zIndex: 1
	                            })
	
	                            .css(titleOptions.style)
	
	                            .add(this.group);
	                    }
	                    bBox = this.title.getBBox();
	                    titleHeight = bBox.height;
	                    this.offsetWidth = bBox.width; // #1717
	                    this.contentGroup.attr({
	                        translateY: titleHeight
	                    });
	                }
	                this.titleHeight = titleHeight;
	            },
	
	            /**
	             * Set the legend item text
	             */
	            setText: function(item) {
	                var options = this.options;
	                item.legendItem.attr({
	                    text: options.labelFormat ?
	                        H.format(options.labelFormat, item) : options.labelFormatter.call(item)
	                });
	            },
	
	            /**
	             * Render a single specific legend item
	             * @param {Object} item A series or point
	             */
	            renderItem: function(item) {
	                var legend = this,
	                    chart = legend.chart,
	                    renderer = chart.renderer,
	                    options = legend.options,
	                    horizontal = options.layout === 'horizontal',
	                    symbolWidth = legend.symbolWidth,
	                    symbolPadding = options.symbolPadding,
	
	                    itemStyle = legend.itemStyle,
	                    itemHiddenStyle = legend.itemHiddenStyle,
	
	                    padding = legend.padding,
	                    itemDistance = horizontal ? pick(options.itemDistance, 20) : 0,
	                    ltr = !options.rtl,
	                    itemHeight,
	                    widthOption = options.width,
	                    itemMarginBottom = options.itemMarginBottom || 0,
	                    itemMarginTop = legend.itemMarginTop,
	                    bBox,
	                    itemWidth,
	                    li = item.legendItem,
	                    isSeries = !item.series,
	                    series = !isSeries && item.series.drawLegendSymbol ?
	                    item.series :
	                    item,
	                    seriesOptions = series.options,
	                    showCheckbox = legend.createCheckboxForItem &&
	                    seriesOptions &&
	                    seriesOptions.showCheckbox,
	                    // full width minus text width
	                    itemExtraWidth = symbolWidth + symbolPadding + itemDistance +
	                    (showCheckbox ? 20 : 0),
	                    useHTML = options.useHTML,
	                    fontSize = 12,
	                    itemClassName = item.options.className;
	
	                if (!li) { // generate it once, later move it
	
	                    // Generate the group box, a group to hold the symbol and text. Text
	                    // is to be appended in Legend class.
	                    item.legendGroup = renderer.g('legend-item')
	                        .addClass(
	                            'highcharts-' + series.type + '-series ' +
	                            'highcharts-color-' + item.colorIndex +
	                            (itemClassName ? ' ' + itemClassName : '') +
	                            (isSeries ? ' highcharts-series-' + item.index : '')
	                        )
	                        .attr({
	                            zIndex: 1
	                        })
	                        .add(legend.scrollGroup);
	
	                    // Generate the list item text and add it to the group
	                    item.legendItem = li = renderer.text(
	                            '',
	                            ltr ? symbolWidth + symbolPadding : -symbolPadding,
	                            legend.baseline || 0,
	                            useHTML
	                        )
	
	                        // merge to prevent modifying original (#1021)
	                        .css(merge(item.visible ? itemStyle : itemHiddenStyle))
	
	                        .attr({
	                            align: ltr ? 'left' : 'right',
	                            zIndex: 2
	                        })
	                        .add(item.legendGroup);
	
	                    // Get the baseline for the first item - the font size is equal for
	                    // all
	                    if (!legend.baseline) {
	
	                        fontSize = itemStyle.fontSize;
	
	                        legend.fontMetrics = renderer.fontMetrics(
	                            fontSize,
	                            li
	                        );
	                        legend.baseline = legend.fontMetrics.f + 3 + itemMarginTop;
	                        li.attr('y', legend.baseline);
	                    }
	
	                    // Draw the legend symbol inside the group box
	                    legend.symbolHeight = options.symbolHeight || legend.fontMetrics.f;
	                    series.drawLegendSymbol(legend, item);
	
	                    if (legend.setItemEvents) {
	                        legend.setItemEvents(item, li, useHTML);
	                    }
	
	                    // add the HTML checkbox on top
	                    if (showCheckbox) {
	                        legend.createCheckboxForItem(item);
	                    }
	                }
	
	                // Colorize the items
	                legend.colorizeItem(item, item.visible);
	
	                // Take care of max width and text overflow (#6659)
	
	                if (!itemStyle.width) {
	
	                    li.css({
	                        width: (options.itemWidth || chart.spacingBox.width) -
	                            itemExtraWidth
	                    });
	
	                }
	
	
	                // Always update the text
	                legend.setText(item);
	
	                // calculate the positions for the next line
	                bBox = li.getBBox();
	
	                itemWidth = item.checkboxOffset =
	                    options.itemWidth ||
	                    item.legendItemWidth ||
	                    bBox.width + itemExtraWidth;
	                legend.itemHeight = itemHeight = Math.round(
	                    item.legendItemHeight || bBox.height || legend.symbolHeight
	                );
	
	                // If the item exceeds the width, start a new line
	                if (
	                    horizontal &&
	                    legend.itemX - padding + itemWidth > (
	                        widthOption || (
	                            chart.spacingBox.width - 2 * padding - options.x
	                        )
	                    )
	                ) {
	                    legend.itemX = padding;
	                    legend.itemY += itemMarginTop + legend.lastLineHeight +
	                        itemMarginBottom;
	                    legend.lastLineHeight = 0; // reset for next line (#915, #3976)
	                }
	
	                // If the item exceeds the height, start a new column
	                /*if (!horizontal && legend.itemY + options.y +
	                		itemHeight > chart.chartHeight - spacingTop - spacingBottom) {
	                	legend.itemY = legend.initialItemY;
	                	legend.itemX += legend.maxItemWidth;
	                	legend.maxItemWidth = 0;
	                }*/
	
	                // Set the edge positions
	                legend.maxItemWidth = Math.max(legend.maxItemWidth, itemWidth);
	                legend.lastItemY = itemMarginTop + legend.itemY + itemMarginBottom;
	                legend.lastLineHeight = Math.max( // #915
	                    itemHeight,
	                    legend.lastLineHeight
	                );
	
	                // cache the position of the newly generated or reordered items
	                item._legendItemPos = [legend.itemX, legend.itemY];
	
	                // advance
	                if (horizontal) {
	                    legend.itemX += itemWidth;
	
	                } else {
	                    legend.itemY += itemMarginTop + itemHeight + itemMarginBottom;
	                    legend.lastLineHeight = itemHeight;
	                }
	
	                // the width of the widest item
	                legend.offsetWidth = widthOption || Math.max(
	                    (horizontal ? legend.itemX - padding - itemDistance : itemWidth) +
	                    padding,
	                    legend.offsetWidth
	                );
	            },
	
	            /**
	             * Get all items, which is one item per series for normal series and one
	             * item per point for pie series.
	             */
	            getAllItems: function() {
	                var allItems = [];
	                each(this.chart.series, function(series) {
	                    var seriesOptions = series && series.options;
	
	                    // Handle showInLegend. If the series is linked to another series,
	                    // defaults to false.
	                    if (series && pick(
	                            seriesOptions.showInLegend, !defined(seriesOptions.linkedTo) ? undefined : false, true
	                        )) {
	
	                        // Use points or series for the legend item depending on
	                        // legendType
	                        allItems = allItems.concat(
	                            series.legendItems ||
	                            (
	                                seriesOptions.legendType === 'point' ?
	                                series.data :
	                                series
	                            )
	                        );
	                    }
	                });
	                return allItems;
	            },
	
	            /**
	             * Adjust the chart margins by reserving space for the legend on only one
	             * side of the chart. If the position is set to a corner, top or bottom is
	             * reserved for horizontal legends and left or right for vertical ones.
	             */
	            adjustMargins: function(margin, spacing) {
	                var chart = this.chart,
	                    options = this.options,
	                    // Use the first letter of each alignment option in order to detect
	                    // the side. (#4189 - use charAt(x) notation instead of [x] for IE7)
	                    alignment = options.align.charAt(0) +
	                    options.verticalAlign.charAt(0) +
	                    options.layout.charAt(0);
	
	                if (!options.floating) {
	
	                    each([
	                        /(lth|ct|rth)/,
	                        /(rtv|rm|rbv)/,
	                        /(rbh|cb|lbh)/,
	                        /(lbv|lm|ltv)/
	                    ], function(alignments, side) {
	                        if (alignments.test(alignment) && !defined(margin[side])) {
	                            // Now we have detected on which side of the chart we should
	                            // reserve space for the legend
	                            chart[marginNames[side]] = Math.max(
	                                chart[marginNames[side]],
	                                (
	                                    chart.legend[
	                                        (side + 1) % 2 ? 'legendHeight' : 'legendWidth'
	                                    ] + [1, -1, -1, 1][side] * options[
	                                        (side % 2) ? 'x' : 'y'
	                                    ] +
	                                    pick(options.margin, 12) +
	                                    spacing[side]
	                                )
	                            );
	                        }
	                    });
	                }
	            },
	
	            /**
	             * Render the legend. This method can be called both before and after
	             * chart.render. If called after, it will only rearrange items instead
	             * of creating new ones.
	             */
	            render: function() {
	                var legend = this,
	                    chart = legend.chart,
	                    renderer = chart.renderer,
	                    legendGroup = legend.group,
	                    allItems,
	                    display,
	                    legendWidth,
	                    legendHeight,
	                    box = legend.box,
	                    options = legend.options,
	                    padding = legend.padding;
	
	                legend.itemX = padding;
	                legend.itemY = legend.initialItemY;
	                legend.offsetWidth = 0;
	                legend.lastItemY = 0;
	
	                if (!legendGroup) {
	                    legend.group = legendGroup = renderer.g('legend')
	                        .attr({
	                            zIndex: 7
	                        })
	                        .add();
	                    legend.contentGroup = renderer.g()
	                        .attr({
	                            zIndex: 1
	                        }) // above background
	                        .add(legendGroup);
	                    legend.scrollGroup = renderer.g()
	                        .add(legend.contentGroup);
	                }
	
	                legend.renderTitle();
	
	                // add each series or point
	                allItems = legend.getAllItems();
	
	                // sort by legendIndex
	                stableSort(allItems, function(a, b) {
	                    return ((a.options && a.options.legendIndex) || 0) -
	                        ((b.options && b.options.legendIndex) || 0);
	                });
	
	                // reversed legend
	                if (options.reversed) {
	                    allItems.reverse();
	                }
	
	                legend.allItems = allItems;
	                legend.display = display = !!allItems.length;
	
	                // render the items
	                legend.lastLineHeight = 0;
	                each(allItems, function(item) {
	                    legend.renderItem(item);
	                });
	
	                // Get the box
	                legendWidth = (options.width || legend.offsetWidth) + padding;
	                legendHeight = legend.lastItemY + legend.lastLineHeight +
	                    legend.titleHeight;
	                legendHeight = legend.handleOverflow(legendHeight);
	                legendHeight += padding;
	
	                // Draw the border and/or background
	                if (!box) {
	                    legend.box = box = renderer.rect()
	                        .addClass('highcharts-legend-box')
	                        .attr({
	                            r: options.borderRadius
	                        })
	                        .add(legendGroup);
	                    box.isNew = true;
	                }
	
	
	                // Presentational
	                box
	                    .attr({
	                        stroke: options.borderColor,
	                        'stroke-width': options.borderWidth || 0,
	                        fill: options.backgroundColor || 'none'
	                    })
	                    .shadow(options.shadow);
	
	
	                if (legendWidth > 0 && legendHeight > 0) {
	                    box[box.isNew ? 'attr' : 'animate'](
	                        box.crisp({
	                            x: 0,
	                            y: 0,
	                            width: legendWidth,
	                            height: legendHeight
	                        }, box.strokeWidth())
	                    );
	                    box.isNew = false;
	                }
	
	                // hide the border if no items
	                box[display ? 'show' : 'hide']();
	
	
	
	                legend.legendWidth = legendWidth;
	                legend.legendHeight = legendHeight;
	
	                // Now that the legend width and height are established, put the items
	                // in the final position
	                each(allItems, function(item) {
	                    legend.positionItem(item);
	                });
	
	                // 1.x compatibility: positioning based on style
	                /*var props = ['left', 'right', 'top', 'bottom'],
	                	prop,
	                	i = 4;
	                while (i--) {
	                	prop = props[i];
	                	if (options.style[prop] && options.style[prop] !== 'auto') {
	                		options[i < 2 ? 'align' : 'verticalAlign'] = prop;
	                		options[i < 2 ? 'x' : 'y'] = 
	                			pInt(options.style[prop]) * (i % 2 ? -1 : 1);
	                	}
	                }*/
	
	                if (display) {
	                    legendGroup.align(merge(options, {
	                        width: legendWidth,
	                        height: legendHeight
	                    }), true, 'spacingBox');
	                }
	
	                if (!chart.isResizing) {
	                    this.positionCheckboxes();
	                }
	            },
	
	            /**
	             * Set up the overflow handling by adding navigation with up and down arrows
	             * below the legend.
	             */
	            handleOverflow: function(legendHeight) {
	                var legend = this,
	                    chart = this.chart,
	                    renderer = chart.renderer,
	                    options = this.options,
	                    optionsY = options.y,
	                    alignTop = options.verticalAlign === 'top',
	                    padding = this.padding,
	                    spaceHeight = chart.spacingBox.height +
	                    (alignTop ? -optionsY : optionsY) - padding,
	                    maxHeight = options.maxHeight,
	                    clipHeight,
	                    clipRect = this.clipRect,
	                    navOptions = options.navigation,
	                    animation = pick(navOptions.animation, true),
	                    arrowSize = navOptions.arrowSize || 12,
	                    nav = this.nav,
	                    pages = this.pages,
	                    lastY,
	                    allItems = this.allItems,
	                    clipToHeight = function(height) {
	                        if (typeof height === 'number') {
	                            clipRect.attr({
	                                height: height
	                            });
	                        } else if (clipRect) { // Reset (#5912)
	                            legend.clipRect = clipRect.destroy();
	                            legend.contentGroup.clip();
	                        }
	
	                        // useHTML
	                        if (legend.contentGroup.div) {
	                            legend.contentGroup.div.style.clip = height ?
	                                'rect(' + padding + 'px,9999px,' +
	                                (padding + height) + 'px,0)' :
	                                'auto';
	                        }
	                    };
	
	
	                // Adjust the height
	                if (
	                    options.layout === 'horizontal' &&
	                    options.verticalAlign !== 'middle' &&
	                    !options.floating
	                ) {
	                    spaceHeight /= 2;
	                }
	                if (maxHeight) {
	                    spaceHeight = Math.min(spaceHeight, maxHeight);
	                }
	
	                // Reset the legend height and adjust the clipping rectangle
	                pages.length = 0;
	                if (legendHeight > spaceHeight && navOptions.enabled !== false) {
	
	                    this.clipHeight = clipHeight =
	                        Math.max(spaceHeight - 20 - this.titleHeight - padding, 0);
	                    this.currentPage = pick(this.currentPage, 1);
	                    this.fullHeight = legendHeight;
	
	                    // Fill pages with Y positions so that the top of each a legend item
	                    // defines the scroll top for each page (#2098)
	                    each(allItems, function(item, i) {
	                        var y = item._legendItemPos[1],
	                            h = Math.round(item.legendItem.getBBox().height),
	                            len = pages.length;
	
	                        if (!len || (y - pages[len - 1] > clipHeight &&
	                                (lastY || y) !== pages[len - 1])) {
	                            pages.push(lastY || y);
	                            len++;
	                        }
	
	                        if (i === allItems.length - 1 &&
	                            y + h - pages[len - 1] > clipHeight) {
	                            pages.push(y);
	                        }
	                        if (y !== lastY) {
	                            lastY = y;
	                        }
	                    });
	
	                    // Only apply clipping if needed. Clipping causes blurred legend in
	                    // PDF export (#1787)
	                    if (!clipRect) {
	                        clipRect = legend.clipRect =
	                            renderer.clipRect(0, padding, 9999, 0);
	                        legend.contentGroup.clip(clipRect);
	                    }
	
	                    clipToHeight(clipHeight);
	
	                    // Add navigation elements
	                    if (!nav) {
	                        this.nav = nav = renderer.g()
	                            .attr({
	                                zIndex: 1
	                            })
	                            .add(this.group);
	
	                        this.up = renderer
	                            .symbol(
	                                'triangle',
	                                0,
	                                0,
	                                arrowSize,
	                                arrowSize
	                            )
	                            .on('click', function() {
	                                legend.scroll(-1, animation);
	                            })
	                            .add(nav);
	
	                        this.pager = renderer.text('', 15, 10)
	                            .addClass('highcharts-legend-navigation')
	
	                            .css(navOptions.style)
	
	                            .add(nav);
	
	                        this.down = renderer
	                            .symbol(
	                                'triangle-down',
	                                0,
	                                0,
	                                arrowSize,
	                                arrowSize
	                            )
	                            .on('click', function() {
	                                legend.scroll(1, animation);
	                            })
	                            .add(nav);
	                    }
	
	                    // Set initial position
	                    legend.scroll(0);
	
	                    legendHeight = spaceHeight;
	
	                    // Reset
	                } else if (nav) {
	                    clipToHeight();
	                    this.nav = nav.destroy(); // #6322
	                    this.scrollGroup.attr({
	                        translateY: 1
	                    });
	                    this.clipHeight = 0; // #1379
	                }
	
	                return legendHeight;
	            },
	
	            /**
	             * Scroll the legend by a number of pages
	             * @param {Object} scrollBy
	             * @param {Object} animation
	             */
	            scroll: function(scrollBy, animation) {
	                var pages = this.pages,
	                    pageCount = pages.length,
	                    currentPage = this.currentPage + scrollBy,
	                    clipHeight = this.clipHeight,
	                    navOptions = this.options.navigation,
	                    pager = this.pager,
	                    padding = this.padding,
	                    scrollOffset;
	
	                // When resizing while looking at the last page
	                if (currentPage > pageCount) {
	                    currentPage = pageCount;
	                }
	
	                if (currentPage > 0) {
	
	                    if (animation !== undefined) {
	                        setAnimation(animation, this.chart);
	                    }
	
	                    this.nav.attr({
	                        translateX: padding,
	                        translateY: clipHeight + this.padding + 7 + this.titleHeight,
	                        visibility: 'visible'
	                    });
	                    this.up.attr({
	                        'class': currentPage === 1 ?
	                            'highcharts-legend-nav-inactive' : 'highcharts-legend-nav-active'
	                    });
	                    pager.attr({
	                        text: currentPage + '/' + pageCount
	                    });
	                    this.down.attr({
	                        'x': 18 + this.pager.getBBox().width, // adjust to text width
	                        'class': currentPage === pageCount ?
	                            'highcharts-legend-nav-inactive' : 'highcharts-legend-nav-active'
	                    });
	
	
	                    this.up
	                        .attr({
	                            fill: currentPage === 1 ?
	                                navOptions.inactiveColor : navOptions.activeColor
	                        })
	                        .css({
	                            cursor: currentPage === 1 ? 'default' : 'pointer'
	                        });
	                    this.down
	                        .attr({
	                            fill: currentPage === pageCount ?
	                                navOptions.inactiveColor : navOptions.activeColor
	                        })
	                        .css({
	                            cursor: currentPage === pageCount ? 'default' : 'pointer'
	                        });
	
	
	                    scrollOffset = -pages[currentPage - 1] + this.initialItemY;
	
	                    this.scrollGroup.animate({
	                        translateY: scrollOffset
	                    });
	
	                    this.currentPage = currentPage;
	                    this.positionCheckboxes(scrollOffset);
	                }
	
	            }
	
	        };
	
	        /*
	         * LegendSymbolMixin
	         */
	
	        H.LegendSymbolMixin = {
	
	            /**
	             * Get the series' symbol in the legend
	             *
	             * @param {Object} legend The legend object
	             * @param {Object} item The series (this) or point
	             */
	            drawRectangle: function(legend, item) {
	                var options = legend.options,
	                    symbolHeight = legend.symbolHeight,
	                    square = options.squareSymbol,
	                    symbolWidth = square ? symbolHeight : legend.symbolWidth;
	
	                item.legendSymbol = this.chart.renderer.rect(
	                        square ? (legend.symbolWidth - symbolHeight) / 2 : 0,
	                        legend.baseline - symbolHeight + 1, // #3988
	                        symbolWidth,
	                        symbolHeight,
	                        pick(legend.options.symbolRadius, symbolHeight / 2)
	                    )
	                    .addClass('highcharts-point')
	                    .attr({
	                        zIndex: 3
	                    }).add(item.legendGroup);
	
	            },
	
	            /**
	             * Get the series' symbol in the legend. This method should be overridable
	             * to create custom symbols through
	             * Highcharts.seriesTypes[type].prototype.drawLegendSymbols.
	             *
	             * @param {Object} legend The legend object
	             */
	            drawLineMarker: function(legend) {
	
	                var options = this.options,
	                    markerOptions = options.marker,
	                    radius,
	                    legendSymbol,
	                    symbolWidth = legend.symbolWidth,
	                    symbolHeight = legend.symbolHeight,
	                    generalRadius = symbolHeight / 2,
	                    renderer = this.chart.renderer,
	                    legendItemGroup = this.legendGroup,
	                    verticalCenter = legend.baseline -
	                    Math.round(legend.fontMetrics.b * 0.3),
	                    attr = {};
	
	                // Draw the line
	
	                attr = {
	                    'stroke-width': options.lineWidth || 0
	                };
	                if (options.dashStyle) {
	                    attr.dashstyle = options.dashStyle;
	                }
	
	
	                this.legendLine = renderer.path([
	                        'M',
	                        0,
	                        verticalCenter,
	                        'L',
	                        symbolWidth,
	                        verticalCenter
	                    ])
	                    .addClass('highcharts-graph')
	                    .attr(attr)
	                    .add(legendItemGroup);
	
	                // Draw the marker
	                if (markerOptions && markerOptions.enabled !== false) {
	
	                    // Do not allow the marker to be larger than the symbolHeight
	                    radius = Math.min(
	                        pick(markerOptions.radius, generalRadius),
	                        generalRadius
	                    );
	
	                    // Restrict symbol markers size
	                    if (this.symbol.indexOf('url') === 0) {
	                        markerOptions = merge(markerOptions, {
	                            width: symbolHeight,
	                            height: symbolHeight
	                        });
	                        radius = 0;
	                    }
	
	                    this.legendSymbol = legendSymbol = renderer.symbol(
	                            this.symbol,
	                            (symbolWidth / 2) - radius,
	                            verticalCenter - radius,
	                            2 * radius,
	                            2 * radius,
	                            markerOptions
	                        )
	                        .addClass('highcharts-point')
	                        .add(legendItemGroup);
	                    legendSymbol.isMarker = true;
	                }
	            }
	        };
	
	        // Workaround for #2030, horizontal legend items not displaying in IE11 Preview,
	        // and for #2580, a similar drawing flaw in Firefox 26.
	        // Explore if there's a general cause for this. The problem may be related
	        // to nested group elements, as the legend item texts are within 4 group
	        // elements.
	        if (/Trident\/7\.0/.test(win.navigator.userAgent) || isFirefox) {
	            wrap(Highcharts.Legend.prototype, 'positionItem', function(proceed, item) {
	                var legend = this,
	                    // If chart destroyed in sync, this is undefined (#2030)
	                    runPositionItem = function() {
	                        if (item._legendItemPos) {
	                            proceed.call(legend, item);
	                        }
	                    };
	
	                // Do it now, for export and to get checkbox placement
	                runPositionItem();
	
	                // Do it after to work around the core issue
	                setTimeout(runPositionItem);
	            });
	        }
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            animate = H.animate,
	            animObject = H.animObject,
	            attr = H.attr,
	            doc = H.doc,
	            Axis = H.Axis, // @todo add as requirement
	            createElement = H.createElement,
	            defaultOptions = H.defaultOptions,
	            discardElement = H.discardElement,
	            charts = H.charts,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            find = H.find,
	            fireEvent = H.fireEvent,
	            getStyle = H.getStyle,
	            grep = H.grep,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            isString = H.isString,
	            Legend = H.Legend, // @todo add as requirement
	            marginNames = H.marginNames,
	            merge = H.merge,
	            objectEach = H.objectEach,
	            Pointer = H.Pointer, // @todo add as requirement
	            pick = H.pick,
	            pInt = H.pInt,
	            removeEvent = H.removeEvent,
	            seriesTypes = H.seriesTypes,
	            splat = H.splat,
	            svg = H.svg,
	            syncTimeout = H.syncTimeout,
	            win = H.win,
	            Renderer = H.Renderer;
	        /**
	         * The Chart class. The recommended constructor is {@link Highcharts#chart}.
	         * @class Highcharts.Chart
	         * @param  {String|HTMLDOMElement} renderTo
	         *         The DOM element to render to, or its id.
	         * @param  {Options} options
	         *         The chart options structure.
	         * @param  {Function} [callback]
	         *         Function to run when the chart has loaded and and all external images
	         *         are loaded. Defining a {@link
	         *         https://api.highcharts.com/highcharts/chart.events.load|chart.event.load}
	         *         handler is equivalent.
	         *
	         * @example
	         * var chart = new Highcharts.Chart('container', {
	         * 	   title: {
	         * 	   	   text: 'My chart'
	         * 	   },
	         * 	   series: [{
	         * 	       data: [1, 3, 2, 4]
	         * 	   }]
	         * })
	         */
	        var Chart = H.Chart = function() {
	            this.getArgs.apply(this, arguments);
	        };
	
	        /**
	         * Factory function for basic charts. 
	         *
	         * @function #chart
	         * @memberOf Highcharts
	         * @param  {String|HTMLDOMElement} renderTo - The DOM element to render to, or
	         * its id.
	         * @param  {Options} options - The chart options structure.
	         * @param  {Function} [callback] - Function to run when the chart has loaded and
	         * and all external images are loaded. Defining a {@link
	         * https://api.highcharts.com/highcharts/chart.events.load|chart.event.load}
	         * handler is equivalent.
	         * @return {Highcharts.Chart} - Returns the Chart object.
	         *
	         * @example
	         * // Render a chart in to div#container
	         * var chart = Highcharts.chart('container', {
	         *     title: {
	         *         text: 'My chart'
	         *     },
	         *     series: [{
	         *         data: [1, 3, 2, 4]
	         *     }]
	         * });
	         */
	        H.chart = function(a, b, c) {
	            return new Chart(a, b, c);
	        };
	
	        extend(Chart.prototype, /** @lends Highcharts.Chart.prototype */ {
	
	            /**
	             * Hook for modules
	             */
	            callbacks: [],
	
	            /**
	             * Handle the arguments passed to the constructor
	             * @returns {Array} Arguments without renderTo
	             */
	            getArgs: function() {
	                var args = [].slice.call(arguments);
	
	                // Remove the optional first argument, renderTo, and
	                // set it on this.
	                if (isString(args[0]) || args[0].nodeName) {
	                    this.renderTo = args.shift();
	                }
	                this.init(args[0], args[1]);
	            },
	
	            /**
	             * Initialize the chart
	             */
	            init: function(userOptions, callback) {
	
	                // Handle regular options
	                var options,
	                    type,
	                    seriesOptions = userOptions.series, // skip merging data points to increase performance
	                    userPlotOptions = userOptions.plotOptions || {};
	
	                userOptions.series = null;
	                options = merge(defaultOptions, userOptions); // do the merge
	
	                // Override (by copy of user options) or clear tooltip options
	                // in chart.options.plotOptions (#6218)
	                for (type in options.plotOptions) {
	                    options.plotOptions[type].tooltip = (
	                        userPlotOptions[type] &&
	                        merge(userPlotOptions[type].tooltip) // override by copy
	                    ) || undefined; // or clear
	                }
	                // User options have higher priority than default options (#6218).
	                // In case of exporting: path is changed
	                options.tooltip.userOptions = (userOptions.chart &&
	                        userOptions.chart.forExport && userOptions.tooltip.userOptions) ||
	                    userOptions.tooltip;
	
	                options.series = userOptions.series = seriesOptions; // set back the series data
	                this.userOptions = userOptions;
	
	                var optionsChart = options.chart;
	
	                var chartEvents = optionsChart.events;
	
	                this.margin = [];
	                this.spacing = [];
	
	                //this.runChartClick = chartEvents && !!chartEvents.click;
	                this.bounds = {
	                    h: {},
	                    v: {}
	                }; // Pixel data bounds for touch zoom
	
	                this.callback = callback;
	                this.isResizing = 0;
	
	                /**
	                 * The options structure for the chart. It contains members for the sub
	                 * elements like series, legend, tooltip etc.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name options
	                 * @type {Options}
	                 */
	                this.options = options;
	                /**
	                 * All the axes in the chart.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name axes
	                 * @see  Highcharts.Chart.xAxis
	                 * @see  Highcharts.Chart.yAxis
	                 * @type {Array.<Highcharts.Axis>}
	                 */
	                this.axes = [];
	
	                /**
	                 * All the current series in the chart.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name series
	                 * @type {Array.<Highcharts.Series>}
	                 */
	                this.series = [];
	
	                /**
	                 * The chart title. The title has an `update` method that allows
	                 * modifying the options directly or indirectly via `chart.update`.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name title
	                 * @type Object
	                 *
	                 * @sample highcharts/members/title-update/
	                 *         Updating titles
	                 */
	
	                /**
	                 * The chart subtitle. The subtitle has an `update` method that allows
	                 * modifying the options directly or indirectly via `chart.update`.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name subtitle
	                 * @type Object
	                 */
	
	
	
	                this.hasCartesianSeries = optionsChart.showAxes;
	                //this.axisOffset = undefined;
	                //this.inverted = undefined;
	                //this.loadingShown = undefined;
	                //this.container = undefined;
	                //this.chartWidth = undefined;
	                //this.chartHeight = undefined;
	                //this.marginRight = undefined;
	                //this.marginBottom = undefined;
	                //this.containerWidth = undefined;
	                //this.containerHeight = undefined;
	                //this.oldChartWidth = undefined;
	                //this.oldChartHeight = undefined;
	
	                //this.renderTo = undefined;
	
	                //this.spacingBox = undefined
	
	                //this.legend = undefined;
	
	                // Elements
	                //this.chartBackground = undefined;
	                //this.plotBackground = undefined;
	                //this.plotBGImage = undefined;
	                //this.plotBorder = undefined;
	                //this.loadingDiv = undefined;
	                //this.loadingSpan = undefined;
	
	                var chart = this;
	
	                // Add the chart to the global lookup
	                chart.index = charts.length;
	
	                charts.push(chart);
	                H.chartCount++;
	
	                // Chart event handlers
	                if (chartEvents) {
	                    objectEach(chartEvents, function(event, eventType) {
	                        addEvent(chart, eventType, event);
	                    });
	                }
	
	                /**
	                 * A collection of the X axes in the chart.
	                 * @type {Array.<Highcharts.Axis>}
	                 * @name xAxis
	                 * @memberOf Highcharts.Chart
	                 */
	                chart.xAxis = [];
	                /**
	                 * A collection of the Y axes in the chart.
	                 * @type {Array.<Highcharts.Axis>}
	                 * @name yAxis
	                 * @memberOf Highcharts.Chart
	                 */
	                chart.yAxis = [];
	
	                chart.pointCount = chart.colorCounter = chart.symbolCounter = 0;
	
	                chart.firstRender();
	            },
	
	            /**
	             * Initialize an individual series, called internally before render time
	             */
	            initSeries: function(options) {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    type = options.type || optionsChart.type || optionsChart.defaultSeriesType,
	                    series,
	                    Constr = seriesTypes[type];
	
	                // No such series type
	                if (!Constr) {
	                    H.error(17, true);
	                }
	
	                series = new Constr();
	                series.init(this, options);
	                return series;
	            },
	
	            /**
	             * Order all series above a given index. When series are added and ordered
	             * by configuration, only the last series is handled (#248, #1123, #2456,
	             * #6112). This function is called on series initialization and destroy.
	             *
	             * @param {number} fromIndex - If this is given, only the series above this
	             *	 index are handled.
	             */
	            orderSeries: function(fromIndex) {
	                var series = this.series,
	                    i = fromIndex || 0;
	                for (; i < series.length; i++) {
	                    if (series[i]) {
	                        series[i].index = i;
	                        series[i].name = series[i].name ||
	                            'Series ' + (series[i].index + 1);
	                    }
	                }
	            },
	
	            /**
	             * Check whether a given point is within the plot area
	             *
	             * @param {Number} plotX Pixel x relative to the plot area
	             * @param {Number} plotY Pixel y relative to the plot area
	             * @param {Boolean} inverted Whether the chart is inverted
	             */
	            isInsidePlot: function(plotX, plotY, inverted) {
	                var x = inverted ? plotY : plotX,
	                    y = inverted ? plotX : plotY;
	
	                return x >= 0 &&
	                    x <= this.plotWidth &&
	                    y >= 0 &&
	                    y <= this.plotHeight;
	            },
	
	            /**
	             * Redraw the chart after changes have been done to the data, axis extremes
	             * chart size or chart elements. All methods for updating axes, series or
	             * points have a parameter for redrawing the chart. This is `true` by
	             * default. But in many cases you want to do more than one operation on the
	             * chart before redrawing, for example add a number of points. In those
	             * cases it is a waste of resources to redraw the chart for each new point
	             * added. So you add the points and call `chart.redraw()` after.
	             *
	             * @param  {AnimationOptions} animation
	             *         If or how to apply animation to the redraw.
	             */
	            redraw: function(animation) {
	                var chart = this,
	                    axes = chart.axes,
	                    series = chart.series,
	                    pointer = chart.pointer,
	                    legend = chart.legend,
	                    redrawLegend = chart.isDirtyLegend,
	                    hasStackedSeries,
	                    hasDirtyStacks,
	                    hasCartesianSeries = chart.hasCartesianSeries,
	                    isDirtyBox = chart.isDirtyBox,
	                    i,
	                    serie,
	                    renderer = chart.renderer,
	                    isHiddenChart = renderer.isHidden(),
	                    afterRedraw = [];
	
	                // Handle responsive rules, not only on resize (#6130)
	                if (chart.setResponsive) {
	                    chart.setResponsive(false);
	                }
	
	                H.setAnimation(animation, chart);
	
	                if (isHiddenChart) {
	                    chart.temporaryDisplay();
	                }
	
	                // Adjust title layout (reflow multiline text)
	                chart.layOutTitles();
	
	                // link stacked series
	                i = series.length;
	                while (i--) {
	                    serie = series[i];
	
	                    if (serie.options.stacking) {
	                        hasStackedSeries = true;
	
	                        if (serie.isDirty) {
	                            hasDirtyStacks = true;
	                            break;
	                        }
	                    }
	                }
	                if (hasDirtyStacks) { // mark others as dirty
	                    i = series.length;
	                    while (i--) {
	                        serie = series[i];
	                        if (serie.options.stacking) {
	                            serie.isDirty = true;
	                        }
	                    }
	                }
	
	                // Handle updated data in the series
	                each(series, function(serie) {
	                    if (serie.isDirty) {
	                        if (serie.options.legendType === 'point') {
	                            if (serie.updateTotals) {
	                                serie.updateTotals();
	                            }
	                            redrawLegend = true;
	                        }
	                    }
	                    if (serie.isDirtyData) {
	                        fireEvent(serie, 'updatedData');
	                    }
	                });
	
	                // handle added or removed series
	                if (redrawLegend && legend.options.enabled) { // series or pie points are added or removed
	                    // draw legend graphics
	                    legend.render();
	
	                    chart.isDirtyLegend = false;
	                }
	
	                // reset stacks
	                if (hasStackedSeries) {
	                    chart.getStacks();
	                }
	
	
	                if (hasCartesianSeries) {
	                    // set axes scales
	                    each(axes, function(axis) {
	                        axis.updateNames();
	                        axis.setScale();
	                    });
	                }
	
	                chart.getMargins(); // #3098
	
	                if (hasCartesianSeries) {
	                    // If one axis is dirty, all axes must be redrawn (#792, #2169)
	                    each(axes, function(axis) {
	                        if (axis.isDirty) {
	                            isDirtyBox = true;
	                        }
	                    });
	
	                    // redraw axes
	                    each(axes, function(axis) {
	
	                        // Fire 'afterSetExtremes' only if extremes are set
	                        var key = axis.min + ',' + axis.max;
	                        if (axis.extKey !== key) { // #821, #4452
	                            axis.extKey = key;
	                            afterRedraw.push(function() { // prevent a recursive call to chart.redraw() (#1119)
	                                fireEvent(axis, 'afterSetExtremes', extend(axis.eventArgs, axis.getExtremes())); // #747, #751
	                                delete axis.eventArgs;
	                            });
	                        }
	                        if (isDirtyBox || hasStackedSeries) {
	                            axis.redraw();
	                        }
	                    });
	                }
	
	                // the plot areas size has changed
	                if (isDirtyBox) {
	                    chart.drawChartBox();
	                }
	
	                // Fire an event before redrawing series, used by the boost module to
	                // clear previous series renderings.
	                fireEvent(chart, 'predraw');
	
	                // redraw affected series
	                each(series, function(serie) {
	                    if ((isDirtyBox || serie.isDirty) && serie.visible) {
	                        serie.redraw();
	                    }
	                    // Set it here, otherwise we will have unlimited 'updatedData' calls
	                    // for a hidden series after setData(). Fixes #6012
	                    serie.isDirtyData = false;
	                });
	
	                // move tooltip or reset
	                if (pointer) {
	                    pointer.reset(true);
	                }
	
	                // redraw if canvas
	                renderer.draw();
	
	                // Fire the events
	                fireEvent(chart, 'redraw');
	                fireEvent(chart, 'render');
	
	                if (isHiddenChart) {
	                    chart.temporaryDisplay(true);
	                }
	
	                // Fire callbacks that are put on hold until after the redraw
	                each(afterRedraw, function(callback) {
	                    callback.call();
	                });
	            },
	
	            /**
	             * Get an axis, series or point object by `id` as given in the configuration
	             * options. Returns `undefined` if no item is found.
	             * @param id {String} The id as given in the configuration options.
	             * @return {Highcharts.Axis|Highcharts.Series|Highcharts.Point|undefined}
	             *         The retrieved item.
	             * @sample highcharts/plotoptions/series-id/
	             *         Get series by id
	             */
	            get: function(id) {
	
	                var ret,
	                    series = this.series,
	                    i;
	
	                function itemById(item) {
	                    return item.id === id || (item.options && item.options.id === id);
	                }
	
	                ret =
	                    // Search axes
	                    find(this.axes, itemById) ||
	
	                    // Search series
	                    find(this.series, itemById);
	
	                // Search points
	                for (i = 0; !ret && i < series.length; i++) {
	                    ret = find(series[i].points || [], itemById);
	                }
	
	                return ret;
	            },
	
	            /**
	             * Create the Axis instances based on the config options
	             */
	            getAxes: function() {
	                var chart = this,
	                    options = this.options,
	                    xAxisOptions = options.xAxis = splat(options.xAxis || {}),
	                    yAxisOptions = options.yAxis = splat(options.yAxis || {}),
	                    optionsArray;
	
	                // make sure the options are arrays and add some members
	                each(xAxisOptions, function(axis, i) {
	                    axis.index = i;
	                    axis.isX = true;
	                });
	
	                each(yAxisOptions, function(axis, i) {
	                    axis.index = i;
	                });
	
	                // concatenate all axis options into one array
	                optionsArray = xAxisOptions.concat(yAxisOptions);
	
	                each(optionsArray, function(axisOptions) {
	                    new Axis(chart, axisOptions); // eslint-disable-line no-new
	                });
	            },
	
	
	            /**
	             * Returns an array of all currently selected points in the chart. Points
	             * can be selected by clicking or programmatically by the {@link
	             * Highcharts.Point#select} function.
	             *
	             * @return {Array.<Highcharts.Point>}
	             *         The currently selected points.
	             *
	             * @sample highcharts/plotoptions/series-allowpointselect-line/
	             *         Get selected points
	             */
	            getSelectedPoints: function() {
	                var points = [];
	                each(this.series, function(serie) {
	                    // series.data - for points outside of viewed range (#6445)
	                    points = points.concat(grep(serie.data || [], function(point) {
	                        return point.selected;
	                    }));
	                });
	                return points;
	            },
	
	            /**
	             * Returns an array of all currently selected series in the chart. Series
	             * can be selected either programmatically by the {@link
	             * Highcharts.Series#select} function or by checking the checkbox next to
	             * the legend item if {@link
	             * https://api.highcharts.com/highcharts/plotOptions.series.showCheckbox|
	             * series.showCheckBox} is true.
	             * 
	             * @return {Array.<Highcharts.Series>}
	             *         The currently selected series.
	             *
	             * @sample highcharts/members/chart-getselectedseries/
	             *         Get selected series
	             */
	            getSelectedSeries: function() {
	                return grep(this.series, function(serie) {
	                    return serie.selected;
	                });
	            },
	
	            /**
	             * Set a new title or subtitle for the chart.
	             *
	             * @param  titleOptions {TitleOptions}
	             *         New title options.
	             * @param  subtitleOptions {SubtitleOptions}
	             *         New subtitle options.
	             * @param  redraw {Boolean}
	             *         Whether to redraw the chart or wait for a later call to 
	             *         `chart.redraw()`.
	             *
	             * @sample highcharts/members/chart-settitle/ Set title text and styles
	             *
	             */
	            setTitle: function(titleOptions, subtitleOptions, redraw) {
	                var chart = this,
	                    options = chart.options,
	                    chartTitleOptions,
	                    chartSubtitleOptions;
	
	                chartTitleOptions = options.title = merge(
	
	                    // Default styles
	                    {
	                        style: {
	                            color: '#333333',
	                            fontSize: options.isStock ? '16px' : '18px' // #2944
	                        }
	                    },
	
	                    options.title,
	                    titleOptions
	                );
	                chartSubtitleOptions = options.subtitle = merge(
	
	                    // Default styles
	                    {
	                        style: {
	                            color: '#666666'
	                        }
	                    },
	
	                    options.subtitle,
	                    subtitleOptions
	                );
	
	                // add title and subtitle
	                each([
	                    ['title', titleOptions, chartTitleOptions],
	                    ['subtitle', subtitleOptions, chartSubtitleOptions]
	                ], function(arr, i) {
	                    var name = arr[0],
	                        title = chart[name],
	                        titleOptions = arr[1],
	                        chartTitleOptions = arr[2];
	
	                    if (title && titleOptions) {
	                        chart[name] = title = title.destroy(); // remove old
	                    }
	
	                    if (chartTitleOptions && chartTitleOptions.text && !title) {
	                        chart[name] = chart.renderer.text(
	                                chartTitleOptions.text,
	                                0,
	                                0,
	                                chartTitleOptions.useHTML
	                            )
	                            .attr({
	                                align: chartTitleOptions.align,
	                                'class': 'highcharts-' + name,
	                                zIndex: chartTitleOptions.zIndex || 4
	                            })
	                            .add();
	
	                        // Update methods, shortcut to Chart.setTitle
	                        chart[name].update = function(o) {
	                            chart.setTitle(!i && o, i && o);
	                        };
	
	
	                        // Presentational
	                        chart[name].css(chartTitleOptions.style);
	
	
	                    }
	                });
	                chart.layOutTitles(redraw);
	            },
	
	            /**
	             * Lay out the chart titles and cache the full offset height for use
	             * in getMargins
	             */
	            layOutTitles: function(redraw) {
	                var titleOffset = 0,
	                    requiresDirtyBox,
	                    renderer = this.renderer,
	                    spacingBox = this.spacingBox;
	
	                // Lay out the title and the subtitle respectively
	                each(['title', 'subtitle'], function(key) {
	                    var title = this[key],
	                        titleOptions = this.options[key],
	                        offset = key === 'title' ? -3 :
	                        // Floating subtitle (#6574)
	                        titleOptions.verticalAlign ? 0 : titleOffset + 2,
	                        titleSize;
	
	                    if (title) {
	
	                        titleSize = titleOptions.style.fontSize;
	
	                        titleSize = renderer.fontMetrics(titleSize, title).b;
	
	                        title
	                            .css({
	                                width: (titleOptions.width ||
	                                    spacingBox.width + titleOptions.widthAdjust) + 'px'
	                            })
	                            .align(extend({
	                                y: offset + titleSize
	                            }, titleOptions), false, 'spacingBox');
	
	                        if (!titleOptions.floating && !titleOptions.verticalAlign) {
	                            titleOffset = Math.ceil(
	                                titleOffset +
	                                // Skip the cache for HTML (#3481)
	                                title.getBBox(titleOptions.useHTML).height
	                            );
	                        }
	                    }
	                }, this);
	
	                requiresDirtyBox = this.titleOffset !== titleOffset;
	                this.titleOffset = titleOffset; // used in getMargins
	
	                if (!this.isDirtyBox && requiresDirtyBox) {
	                    this.isDirtyBox = requiresDirtyBox;
	                    // Redraw if necessary (#2719, #2744)
	                    if (this.hasRendered && pick(redraw, true) && this.isDirtyBox) {
	                        this.redraw();
	                    }
	                }
	            },
	
	            /**
	             * Get chart width and height according to options and container size
	             */
	            getChartSize: function() {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    widthOption = optionsChart.width,
	                    heightOption = optionsChart.height,
	                    renderTo = chart.renderTo;
	
	                // Get inner width and height
	                if (!defined(widthOption)) {
	                    chart.containerWidth = getStyle(renderTo, 'width');
	                }
	                if (!defined(heightOption)) {
	                    chart.containerHeight = getStyle(renderTo, 'height');
	                }
	
	                chart.chartWidth = Math.max( // #1393
	                    0,
	                    widthOption || chart.containerWidth || 600 // #1460
	                );
	                chart.chartHeight = Math.max(
	                    0,
	                    H.relativeLength(
	                        heightOption,
	                        chart.chartWidth
	                    ) || chart.containerHeight || 400
	                );
	            },
	
	            /**
	             * If the renderTo element has no offsetWidth, most likely one or more of
	             * its parents are hidden. Loop up the DOM tree to temporarily display the
	             * parents, then save the original display properties, and when the true
	             * size is retrieved, reset them. Used on first render and on redraws.
	             *
	             * @param {Boolean} revert - Revert to the saved original styles.
	             */
	            temporaryDisplay: function(revert) {
	                var node = this.renderTo,
	                    tempStyle;
	                if (!revert) {
	                    while (node && node.style) {
	                        if (getStyle(node, 'display', false) === 'none') {
	                            node.hcOrigStyle = {
	                                display: node.style.display,
	                                height: node.style.height,
	                                overflow: node.style.overflow
	                            };
	                            tempStyle = {
	                                display: 'block',
	                                overflow: 'hidden'
	                            };
	                            if (node !== this.renderTo) {
	                                tempStyle.height = 0;
	                            }
	
	                            H.css(node, tempStyle);
	                            if (node.style.setProperty) { // #2631
	                                node.style.setProperty('display', 'block', 'important');
	                            }
	                        }
	                        node = node.parentNode;
	                    }
	                } else {
	                    while (node && node.style) {
	                        if (node.hcOrigStyle) {
	                            H.css(node, node.hcOrigStyle);
	                            delete node.hcOrigStyle;
	                        }
	                        node = node.parentNode;
	                    }
	                }
	            },
	
	            /**
	             * Setter for the chart class name
	             */
	            setClassName: function(className) {
	                this.container.className = 'highcharts-container ' + (className || '');
	            },
	
	            /**
	             * Get the containing element, determine the size and create the inner
	             * container div to hold the chart
	             */
	            getContainer: function() {
	                var chart = this,
	                    container,
	                    options = chart.options,
	                    optionsChart = options.chart,
	                    chartWidth,
	                    chartHeight,
	                    renderTo = chart.renderTo,
	                    indexAttrName = 'data-highcharts-chart',
	                    oldChartIndex,
	                    Ren,
	                    containerId = H.uniqueKey(),
	                    containerStyle,
	                    key;
	
	                if (!renderTo) {
	                    chart.renderTo = renderTo = optionsChart.renderTo;
	                }
	
	                if (isString(renderTo)) {
	                    chart.renderTo = renderTo = doc.getElementById(renderTo);
	                }
	
	                // Display an error if the renderTo is wrong
	                if (!renderTo) {
	                    H.error(13, true);
	                }
	
	                // If the container already holds a chart, destroy it. The check for
	                // hasRendered is there because web pages that are saved to disk from
	                // the browser, will preserve the data-highcharts-chart attribute and
	                // the SVG contents, but not an interactive chart. So in this case,
	                // charts[oldChartIndex] will point to the wrong chart if any (#2609).
	                oldChartIndex = pInt(attr(renderTo, indexAttrName));
	                if (
	                    isNumber(oldChartIndex) &&
	                    charts[oldChartIndex] &&
	                    charts[oldChartIndex].hasRendered
	                ) {
	                    charts[oldChartIndex].destroy();
	                }
	
	                // Make a reference to the chart from the div
	                attr(renderTo, indexAttrName, chart.index);
	
	                // remove previous chart
	                renderTo.innerHTML = '';
	
	                // If the container doesn't have an offsetWidth, it has or is a child of
	                // a node that has display:none. We need to temporarily move it out to a
	                // visible state to determine the size, else the legend and tooltips
	                // won't render properly. The skipClone option is used in sparklines as
	                // a micro optimization, saving about 1-2 ms each chart.
	                if (!optionsChart.skipClone && !renderTo.offsetWidth) {
	                    chart.temporaryDisplay();
	                }
	
	                // get the width and height
	                chart.getChartSize();
	                chartWidth = chart.chartWidth;
	                chartHeight = chart.chartHeight;
	
	                // Create the inner container
	
	                containerStyle = extend({
	                    position: 'relative',
	                    overflow: 'hidden', // needed for context menu (avoid scrollbars)
	                    // and content overflow in IE
	                    width: chartWidth + 'px',
	                    height: chartHeight + 'px',
	                    textAlign: 'left',
	                    lineHeight: 'normal', // #427
	                    zIndex: 0, // #1072
	                    '-webkit-tap-highlight-color': 'rgba(0,0,0,0)'
	                }, optionsChart.style);
	
	
	                /**
	                 * The containing HTML element of the chart. The container is
	                 * dynamically inserted into the element given as the `renderTo`
	                 * parameterin the {@link Highcharts#chart} constructor.
	                 *
	                 * @memberOf Highcharts.Chart
	                 * @type {HTMLDOMElement}
	                 */
	                container = createElement(
	                    'div', {
	                        id: containerId
	                    },
	                    containerStyle,
	                    renderTo
	                );
	                chart.container = container;
	
	                // cache the cursor (#1650)
	                chart._cursor = container.style.cursor;
	
	                // Initialize the renderer
	                Ren = H[optionsChart.renderer] || Renderer;
	                chart.renderer = new Ren(
	                    container,
	                    chartWidth,
	                    chartHeight,
	                    null,
	                    optionsChart.forExport,
	                    options.exporting && options.exporting.allowHTML
	                );
	
	
	                chart.setClassName(optionsChart.className);
	
	                chart.renderer.setStyle(optionsChart.style);
	
	
	                // Add a reference to the charts index
	                chart.renderer.chartIndex = chart.index;
	            },
	
	            /**
	             * Calculate margins by rendering axis labels in a preliminary position.
	             * Title, subtitle and legend have already been rendered at this stage, but
	             * will be moved into their final positions
	             */
	            getMargins: function(skipAxes) {
	                var chart = this,
	                    spacing = chart.spacing,
	                    margin = chart.margin,
	                    titleOffset = chart.titleOffset;
	
	                chart.resetMargins();
	
	                // Adjust for title and subtitle
	                if (titleOffset && !defined(margin[0])) {
	                    chart.plotTop = Math.max(
	                        chart.plotTop,
	                        titleOffset + chart.options.title.margin + spacing[0]
	                    );
	                }
	
	                // Adjust for legend
	                if (chart.legend.display) {
	                    chart.legend.adjustMargins(margin, spacing);
	                }
	
	                // adjust for scroller
	                if (chart.extraMargin) {
	                    chart[chart.extraMargin.type] =
	                        (chart[chart.extraMargin.type] || 0) + chart.extraMargin.value;
	                }
	                if (chart.extraTopMargin) {
	                    chart.plotTop += chart.extraTopMargin;
	                }
	                if (!skipAxes) {
	                    this.getAxisMargins();
	                }
	            },
	
	            getAxisMargins: function() {
	
	                var chart = this,
	                    // [top, right, bottom, left]
	                    axisOffset = chart.axisOffset = [0, 0, 0, 0],
	                    margin = chart.margin;
	
	                // pre-render axes to get labels offset width
	                if (chart.hasCartesianSeries) {
	                    each(chart.axes, function(axis) {
	                        if (axis.visible) {
	                            axis.getOffset();
	                        }
	                    });
	                }
	
	                // Add the axis offsets
	                each(marginNames, function(m, side) {
	                    if (!defined(margin[side])) {
	                        chart[m] += axisOffset[side];
	                    }
	                });
	
	                chart.setChartSize();
	
	            },
	
	            /**
	             * Reflows the chart to its container. By default, the chart reflows
	             * automatically to its container following a `window.resize` event, as per
	             * the {@link https://api.highcharts/highcharts/chart.reflow|chart.reflow}
	             * option. However, there are no reliable events for div resize, so if the
	             * container is resized without a window resize event, this must be called
	             * explicitly.
	             *
	             * @param  {Object} e
	             *         Event arguments. Used primarily when the function is called
	             *         internally as a response to window resize.
	             *
	             * @sample highcharts/members/chart-reflow/
	             *         Resize div and reflow
	             * @sample highcharts/chart/events-container/
	             *         Pop up and reflow
	             */
	            reflow: function(e) {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    renderTo = chart.renderTo,
	                    hasUserWidth = defined(optionsChart.width),
	                    width = optionsChart.width || getStyle(renderTo, 'width'),
	                    height = optionsChart.height || getStyle(renderTo, 'height'),
	                    target = e ? e.target : win;
	
	                // Width and height checks for display:none. Target is doc in IE8 and
	                // Opera, win in Firefox, Chrome and IE9.
	                if (!hasUserWidth &&
	                    !chart.isPrinting &&
	                    width &&
	                    height &&
	                    (target === win || target === doc)
	                ) {
	                    if (
	                        width !== chart.containerWidth ||
	                        height !== chart.containerHeight
	                    ) {
	                        clearTimeout(chart.reflowTimeout);
	                        // When called from window.resize, e is set, else it's called
	                        // directly (#2224)
	                        chart.reflowTimeout = syncTimeout(function() {
	                            // Set size, it may have been destroyed in the meantime
	                            // (#1257)
	                            if (chart.container) {
	                                chart.setSize(undefined, undefined, false);
	                            }
	                        }, e ? 100 : 0);
	                    }
	                    chart.containerWidth = width;
	                    chart.containerHeight = height;
	                }
	            },
	
	            /**
	             * Add the event handlers necessary for auto resizing
	             */
	            initReflow: function() {
	                var chart = this,
	                    unbind;
	
	                unbind = addEvent(win, 'resize', function(e) {
	                    chart.reflow(e);
	                });
	                addEvent(chart, 'destroy', unbind);
	
	                // The following will add listeners to re-fit the chart before and after
	                // printing (#2284). However it only works in WebKit. Should have worked
	                // in Firefox, but not supported in IE.
	                /*
	                if (win.matchMedia) {
	                	win.matchMedia('print').addListener(function reflow() {
	                		chart.reflow();
	                	});
	                }
	                */
	            },
	
	            /**
	             * Resize the chart to a given width and height. In order to set the width
	             * only, the height argument may be skipped. To set the height only, pass
	             * `undefined for the width.
	             * @param  {Number|undefined|null} [width]
	             *         The new pixel width of the chart. Since v4.2.6, the argument can
	             *         be `undefined` in order to preserve the current value (when
	             *         setting height only), or `null` to adapt to the width of the
	             *         containing element.
	             * @param  {Number|undefined|null} [height]
	             *         The new pixel height of the chart. Since v4.2.6, the argument can
	             *         be `undefined` in order to preserve the current value, or `null`
	             *         in order to adapt to the height of the containing element.
	             * @param  {AnimationOptions} [animation=true]
	             *         Whether and how to apply animation.
	             *
	             * @sample highcharts/members/chart-setsize-button/
	             *         Test resizing from buttons
	             * @sample highcharts/members/chart-setsize-jquery-resizable/
	             *         Add a jQuery UI resizable
	             * @sample stock/members/chart-setsize/
	             *         Highstock with UI resizable
	             */
	            setSize: function(width, height, animation) {
	                var chart = this,
	                    renderer = chart.renderer,
	                    globalAnimation;
	
	                // Handle the isResizing counter
	                chart.isResizing += 1;
	
	                // set the animation for the current process
	                H.setAnimation(animation, chart);
	
	                chart.oldChartHeight = chart.chartHeight;
	                chart.oldChartWidth = chart.chartWidth;
	                if (width !== undefined) {
	                    chart.options.chart.width = width;
	                }
	                if (height !== undefined) {
	                    chart.options.chart.height = height;
	                }
	                chart.getChartSize();
	
	                // Resize the container with the global animation applied if enabled
	                // (#2503)
	
	                globalAnimation = renderer.globalAnimation;
	                (globalAnimation ? animate : css)(chart.container, {
	                    width: chart.chartWidth + 'px',
	                    height: chart.chartHeight + 'px'
	                }, globalAnimation);
	
	
	                chart.setChartSize(true);
	                renderer.setSize(chart.chartWidth, chart.chartHeight, animation);
	
	                // handle axes
	                each(chart.axes, function(axis) {
	                    axis.isDirty = true;
	                    axis.setScale();
	                });
	
	                chart.isDirtyLegend = true; // force legend redraw
	                chart.isDirtyBox = true; // force redraw of plot and chart border
	
	                chart.layOutTitles(); // #2857
	                chart.getMargins();
	
	                chart.redraw(animation);
	
	
	                chart.oldChartHeight = null;
	                fireEvent(chart, 'resize');
	
	                // Fire endResize and set isResizing back. If animation is disabled,
	                // fire without delay
	                syncTimeout(function() {
	                    if (chart) {
	                        fireEvent(chart, 'endResize', null, function() {
	                            chart.isResizing -= 1;
	                        });
	                    }
	                }, animObject(globalAnimation).duration);
	            },
	
	            /**
	             * Set the public chart properties. This is done before and after the
	             * pre-render to determine margin sizes
	             */
	            setChartSize: function(skipAxes) {
	                var chart = this,
	                    inverted = chart.inverted,
	                    renderer = chart.renderer,
	                    chartWidth = chart.chartWidth,
	                    chartHeight = chart.chartHeight,
	                    optionsChart = chart.options.chart,
	                    spacing = chart.spacing,
	                    clipOffset = chart.clipOffset,
	                    clipX,
	                    clipY,
	                    plotLeft,
	                    plotTop,
	                    plotWidth,
	                    plotHeight,
	                    plotBorderWidth;
	
	                function clipOffsetSide(side) {
	                    var offset = clipOffset[side] || 0;
	                    return Math.max(plotBorderWidth || offset, offset) / 2;
	                }
	
	                chart.plotLeft = plotLeft = Math.round(chart.plotLeft);
	                chart.plotTop = plotTop = Math.round(chart.plotTop);
	                chart.plotWidth = plotWidth = Math.max(
	                    0,
	                    Math.round(chartWidth - plotLeft - chart.marginRight)
	                );
	                chart.plotHeight = plotHeight = Math.max(
	                    0,
	                    Math.round(chartHeight - plotTop - chart.marginBottom)
	                );
	
	                chart.plotSizeX = inverted ? plotHeight : plotWidth;
	                chart.plotSizeY = inverted ? plotWidth : plotHeight;
	
	                chart.plotBorderWidth = optionsChart.plotBorderWidth || 0;
	
	                // Set boxes used for alignment
	                chart.spacingBox = renderer.spacingBox = {
	                    x: spacing[3],
	                    y: spacing[0],
	                    width: chartWidth - spacing[3] - spacing[1],
	                    height: chartHeight - spacing[0] - spacing[2]
	                };
	                chart.plotBox = renderer.plotBox = {
	                    x: plotLeft,
	                    y: plotTop,
	                    width: plotWidth,
	                    height: plotHeight
	                };
	
	                plotBorderWidth = 2 * Math.floor(chart.plotBorderWidth / 2);
	                clipX = Math.ceil(clipOffsetSide(3));
	                clipY = Math.ceil(clipOffsetSide(0));
	                chart.clipBox = {
	                    x: clipX,
	                    y: clipY,
	                    width: Math.floor(
	                        chart.plotSizeX -
	                        clipOffsetSide(1) -
	                        clipX
	                    ),
	                    height: Math.max(
	                        0,
	                        Math.floor(
	                            chart.plotSizeY -
	                            clipOffsetSide(2) -
	                            clipY
	                        )
	                    )
	                };
	
	                if (!skipAxes) {
	                    each(chart.axes, function(axis) {
	                        axis.setAxisSize();
	                        axis.setAxisTranslation();
	                    });
	                }
	            },
	
	            /**
	             * Initial margins before auto size margins are applied
	             */
	            resetMargins: function() {
	                var chart = this,
	                    chartOptions = chart.options.chart;
	
	                // Create margin and spacing array
	                each(['margin', 'spacing'], function splashArrays(target) {
	                    var value = chartOptions[target],
	                        values = isObject(value) ? value : [value, value, value, value];
	
	                    each(['Top', 'Right', 'Bottom', 'Left'], function(sideName, side) {
	                        chart[target][side] = pick(
	                            chartOptions[target + sideName],
	                            values[side]
	                        );
	                    });
	                });
	
	                // Set margin names like chart.plotTop, chart.plotLeft,
	                // chart.marginRight, chart.marginBottom.
	                each(marginNames, function(m, side) {
	                    chart[m] = pick(chart.margin[side], chart.spacing[side]);
	                });
	                chart.axisOffset = [0, 0, 0, 0]; // top, right, bottom, left
	                chart.clipOffset = [];
	            },
	
	            /**
	             * Draw the borders and backgrounds for chart and plot area
	             */
	            drawChartBox: function() {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    renderer = chart.renderer,
	                    chartWidth = chart.chartWidth,
	                    chartHeight = chart.chartHeight,
	                    chartBackground = chart.chartBackground,
	                    plotBackground = chart.plotBackground,
	                    plotBorder = chart.plotBorder,
	                    chartBorderWidth,
	
	                    plotBGImage = chart.plotBGImage,
	                    chartBackgroundColor = optionsChart.backgroundColor,
	                    plotBackgroundColor = optionsChart.plotBackgroundColor,
	                    plotBackgroundImage = optionsChart.plotBackgroundImage,
	
	                    mgn,
	                    bgAttr,
	                    plotLeft = chart.plotLeft,
	                    plotTop = chart.plotTop,
	                    plotWidth = chart.plotWidth,
	                    plotHeight = chart.plotHeight,
	                    plotBox = chart.plotBox,
	                    clipRect = chart.clipRect,
	                    clipBox = chart.clipBox,
	                    verb = 'animate';
	
	                // Chart area
	                if (!chartBackground) {
	                    chart.chartBackground = chartBackground = renderer.rect()
	                        .addClass('highcharts-background')
	                        .add();
	                    verb = 'attr';
	                }
	
	
	                // Presentational
	                chartBorderWidth = optionsChart.borderWidth || 0;
	                mgn = chartBorderWidth + (optionsChart.shadow ? 8 : 0);
	
	                bgAttr = {
	                    fill: chartBackgroundColor || 'none'
	                };
	
	                if (chartBorderWidth || chartBackground['stroke-width']) { // #980
	                    bgAttr.stroke = optionsChart.borderColor;
	                    bgAttr['stroke-width'] = chartBorderWidth;
	                }
	                chartBackground
	                    .attr(bgAttr)
	                    .shadow(optionsChart.shadow);
	
	                chartBackground[verb]({
	                    x: mgn / 2,
	                    y: mgn / 2,
	                    width: chartWidth - mgn - chartBorderWidth % 2,
	                    height: chartHeight - mgn - chartBorderWidth % 2,
	                    r: optionsChart.borderRadius
	                });
	
	                // Plot background
	                verb = 'animate';
	                if (!plotBackground) {
	                    verb = 'attr';
	                    chart.plotBackground = plotBackground = renderer.rect()
	                        .addClass('highcharts-plot-background')
	                        .add();
	                }
	                plotBackground[verb](plotBox);
	
	
	                // Presentational attributes for the background
	                plotBackground
	                    .attr({
	                        fill: plotBackgroundColor || 'none'
	                    })
	                    .shadow(optionsChart.plotShadow);
	
	                // Create the background image
	                if (plotBackgroundImage) {
	                    if (!plotBGImage) {
	                        chart.plotBGImage = renderer.image(
	                            plotBackgroundImage,
	                            plotLeft,
	                            plotTop,
	                            plotWidth,
	                            plotHeight
	                        ).add();
	                    } else {
	                        plotBGImage.animate(plotBox);
	                    }
	                }
	
	
	                // Plot clip
	                if (!clipRect) {
	                    chart.clipRect = renderer.clipRect(clipBox);
	                } else {
	                    clipRect.animate({
	                        width: clipBox.width,
	                        height: clipBox.height
	                    });
	                }
	
	                // Plot area border
	                verb = 'animate';
	                if (!plotBorder) {
	                    verb = 'attr';
	                    chart.plotBorder = plotBorder = renderer.rect()
	                        .addClass('highcharts-plot-border')
	                        .attr({
	                            zIndex: 1 // Above the grid
	                        })
	                        .add();
	                }
	
	
	                // Presentational
	                plotBorder.attr({
	                    stroke: optionsChart.plotBorderColor,
	                    'stroke-width': optionsChart.plotBorderWidth || 0,
	                    fill: 'none'
	                });
	
	
	                plotBorder[verb](plotBorder.crisp({
	                    x: plotLeft,
	                    y: plotTop,
	                    width: plotWidth,
	                    height: plotHeight
	                }, -plotBorder.strokeWidth())); //#3282 plotBorder should be negative;
	
	                // reset
	                chart.isDirtyBox = false;
	            },
	
	            /**
	             * Detect whether a certain chart property is needed based on inspecting its
	             * options and series. This mainly applies to the chart.inverted property,
	             * and in extensions to the chart.angular and chart.polar properties.
	             */
	            propFromSeries: function() {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    klass,
	                    seriesOptions = chart.options.series,
	                    i,
	                    value;
	
	
	                each(['inverted', 'angular', 'polar'], function(key) {
	
	                    // The default series type's class
	                    klass = seriesTypes[optionsChart.type ||
	                        optionsChart.defaultSeriesType];
	
	                    // Get the value from available chart-wide properties
	                    value =
	                        optionsChart[key] || // It is set in the options
	                        (klass && klass.prototype[key]); // The default series class
	                    // requires it
	
	                    // 4. Check if any the chart's series require it
	                    i = seriesOptions && seriesOptions.length;
	                    while (!value && i--) {
	                        klass = seriesTypes[seriesOptions[i].type];
	                        if (klass && klass.prototype[key]) {
	                            value = true;
	                        }
	                    }
	
	                    // Set the chart property
	                    chart[key] = value;
	                });
	
	            },
	
	            /**
	             * Link two or more series together. This is done initially from
	             * Chart.render, and after Chart.addSeries and Series.remove.
	             */
	            linkSeries: function() {
	                var chart = this,
	                    chartSeries = chart.series;
	
	                // Reset links
	                each(chartSeries, function(series) {
	                    series.linkedSeries.length = 0;
	                });
	
	                // Apply new links
	                each(chartSeries, function(series) {
	                    var linkedTo = series.options.linkedTo;
	                    if (isString(linkedTo)) {
	                        if (linkedTo === ':previous') {
	                            linkedTo = chart.series[series.index - 1];
	                        } else {
	                            linkedTo = chart.get(linkedTo);
	                        }
	                        // #3341 avoid mutual linking
	                        if (linkedTo && linkedTo.linkedParent !== series) {
	                            linkedTo.linkedSeries.push(series);
	                            series.linkedParent = linkedTo;
	                            series.visible = pick(
	                                series.options.visible,
	                                linkedTo.options.visible,
	                                series.visible
	                            ); // #3879
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Render series for the chart
	             */
	            renderSeries: function() {
	                each(this.series, function(serie) {
	                    serie.translate();
	                    serie.render();
	                });
	            },
	
	            /**
	             * Render labels for the chart
	             */
	            renderLabels: function() {
	                var chart = this,
	                    labels = chart.options.labels;
	                if (labels.items) {
	                    each(labels.items, function(label) {
	                        var style = extend(labels.style, label.style),
	                            x = pInt(style.left) + chart.plotLeft,
	                            y = pInt(style.top) + chart.plotTop + 12;
	
	                        // delete to prevent rewriting in IE
	                        delete style.left;
	                        delete style.top;
	
	                        chart.renderer.text(
	                                label.html,
	                                x,
	                                y
	                            )
	                            .attr({
	                                zIndex: 2
	                            })
	                            .css(style)
	                            .add();
	
	                    });
	                }
	            },
	
	            /**
	             * Render all graphics for the chart
	             */
	            render: function() {
	                var chart = this,
	                    axes = chart.axes,
	                    renderer = chart.renderer,
	                    options = chart.options,
	                    tempWidth,
	                    tempHeight,
	                    redoHorizontal,
	                    redoVertical;
	
	                // Title
	                chart.setTitle();
	
	
	                // Legend
	                chart.legend = new Legend(chart, options.legend);
	
	                // Get stacks
	                if (chart.getStacks) {
	                    chart.getStacks();
	                }
	
	                // Get chart margins
	                chart.getMargins(true);
	                chart.setChartSize();
	
	                // Record preliminary dimensions for later comparison
	                tempWidth = chart.plotWidth;
	                tempHeight = chart.plotHeight = chart.plotHeight - 21; // 21 is the most common correction for X axis labels
	
	                // Get margins by pre-rendering axes
	                each(axes, function(axis) {
	                    axis.setScale();
	                });
	                chart.getAxisMargins();
	
	                // If the plot area size has changed significantly, calculate tick positions again
	                redoHorizontal = tempWidth / chart.plotWidth > 1.1;
	                redoVertical = tempHeight / chart.plotHeight > 1.05; // Height is more sensitive
	
	                if (redoHorizontal || redoVertical) {
	
	                    each(axes, function(axis) {
	                        if ((axis.horiz && redoHorizontal) || (!axis.horiz && redoVertical)) {
	                            axis.setTickInterval(true); // update to reflect the new margins
	                        }
	                    });
	                    chart.getMargins(); // second pass to check for new labels
	                }
	
	                // Draw the borders and backgrounds
	                chart.drawChartBox();
	
	
	                // Axes
	                if (chart.hasCartesianSeries) {
	                    each(axes, function(axis) {
	                        if (axis.visible) {
	                            axis.render();
	                        }
	                    });
	                }
	
	                // The series
	                if (!chart.seriesGroup) {
	                    chart.seriesGroup = renderer.g('series-group')
	                        .attr({
	                            zIndex: 3
	                        })
	                        .add();
	                }
	                chart.renderSeries();
	
	                // Labels
	                chart.renderLabels();
	
	                // Credits
	                chart.addCredits();
	
	                // Handle responsiveness
	                if (chart.setResponsive) {
	                    chart.setResponsive();
	                }
	
	                // Set flag
	                chart.hasRendered = true;
	
	            },
	
	            /**
	             * Set a new credits label for the chart.
	             *
	             * @param  {CreditOptions} options
	             *         A configuration object for the new credits.
	             * @sample highcharts/credits/credits-update/ Add and update credits
	             */
	            addCredits: function(credits) {
	                var chart = this;
	
	                credits = merge(true, this.options.credits, credits);
	                if (credits.enabled && !this.credits) {
	
	                    /**
	                     * The chart's credits label. The label has an `update` method that
	                     * allows setting new options as per the {@link
	                     * https://api.highcharts.com/highcharts/credits|
	                     * credits options set}.
	                     *
	                     * @memberof Highcharts.Chart
	                     * @name credits
	                     * @type {Highcharts.SVGElement}
	                     */
	                    this.credits = this.renderer.text(
	                            credits.text + (this.mapCredits || ''),
	                            0,
	                            0
	                        )
	                        .addClass('highcharts-credits')
	                        .on('click', function() {
	                            if (credits.href) {
	                                win.location.href = credits.href;
	                            }
	                        })
	                        .attr({
	                            align: credits.position.align,
	                            zIndex: 8
	                        })
	
	                        .css(credits.style)
	
	                        .add()
	                        .align(credits.position);
	
	                    // Dynamically update
	                    this.credits.update = function(options) {
	                        chart.credits = chart.credits.destroy();
	                        chart.addCredits(options);
	                    };
	                }
	            },
	
	            /**
	             * Remove the chart and purge memory. This method is called internally
	             * before adding a second chart into the same container, as well as on
	             * window unload to prevent leaks.
	             *
	             * @sample highcharts/members/chart-destroy/
	             *         Destroy the chart from a button
	             * @sample stock/members/chart-destroy/
	             *         Destroy with Highstock
	             */
	            destroy: function() {
	                var chart = this,
	                    axes = chart.axes,
	                    series = chart.series,
	                    container = chart.container,
	                    i,
	                    parentNode = container && container.parentNode;
	
	                // fire the chart.destoy event
	                fireEvent(chart, 'destroy');
	
	                // Delete the chart from charts lookup array
	                if (chart.renderer.forExport) {
	                    H.erase(charts, chart); // #6569
	                } else {
	                    charts[chart.index] = undefined;
	                }
	                H.chartCount--;
	                chart.renderTo.removeAttribute('data-highcharts-chart');
	
	                // remove events
	                removeEvent(chart);
	
	                // ==== Destroy collections:
	                // Destroy axes
	                i = axes.length;
	                while (i--) {
	                    axes[i] = axes[i].destroy();
	                }
	
	                // Destroy scroller & scroller series before destroying base series
	                if (this.scroller && this.scroller.destroy) {
	                    this.scroller.destroy();
	                }
	
	                // Destroy each series
	                i = series.length;
	                while (i--) {
	                    series[i] = series[i].destroy();
	                }
	
	                // ==== Destroy chart properties:
	                each([
	                    'title', 'subtitle', 'chartBackground', 'plotBackground',
	                    'plotBGImage', 'plotBorder', 'seriesGroup', 'clipRect', 'credits',
	                    'pointer', 'rangeSelector', 'legend', 'resetZoomButton', 'tooltip',
	                    'renderer'
	                ], function(name) {
	                    var prop = chart[name];
	
	                    if (prop && prop.destroy) {
	                        chart[name] = prop.destroy();
	                    }
	                });
	
	                // remove container and all SVG
	                if (container) { // can break in IE when destroyed before finished loading
	                    container.innerHTML = '';
	                    removeEvent(container);
	                    if (parentNode) {
	                        discardElement(container);
	                    }
	
	                }
	
	                // clean it all up
	                objectEach(chart, function(val, key) {
	                    delete chart[key];
	                });
	
	            },
	
	
	            /**
	             * VML namespaces can't be added until after complete. Listening
	             * for Perini's doScroll hack is not enough.
	             */
	            isReadyToRender: function() {
	                var chart = this;
	
	                // Note: win == win.top is required
	                if ((!svg && (win == win.top && doc.readyState !== 'complete'))) { // eslint-disable-line eqeqeq
	                    doc.attachEvent('onreadystatechange', function() {
	                        doc.detachEvent('onreadystatechange', chart.firstRender);
	                        if (doc.readyState === 'complete') {
	                            chart.firstRender();
	                        }
	                    });
	                    return false;
	                }
	                return true;
	            },
	
	            /**
	             * Prepare for first rendering after all data are loaded
	             */
	            firstRender: function() {
	                var chart = this,
	                    options = chart.options;
	
	                // Check whether the chart is ready to render
	                if (!chart.isReadyToRender()) {
	                    return;
	                }
	
	                // Create the container
	                chart.getContainer();
	
	                // Run an early event after the container and renderer are established
	                fireEvent(chart, 'init');
	
	
	                chart.resetMargins();
	                chart.setChartSize();
	
	                // Set the common chart properties (mainly invert) from the given series
	                chart.propFromSeries();
	
	                // get axes
	                chart.getAxes();
	
	                // Initialize the series
	                each(options.series || [], function(serieOptions) {
	                    chart.initSeries(serieOptions);
	                });
	
	                chart.linkSeries();
	
	                // Run an event after axes and series are initialized, but before render. At this stage,
	                // the series data is indexed and cached in the xData and yData arrays, so we can access
	                // those before rendering. Used in Highstock.
	                fireEvent(chart, 'beforeRender');
	
	                // depends on inverted and on margins being set
	                if (Pointer) {
	                    chart.pointer = new Pointer(chart, options);
	                }
	
	                chart.render();
	
	                // Fire the load event if there are no external images
	                if (!chart.renderer.imgCount && chart.onload) {
	                    chart.onload();
	                }
	
	                // If the chart was rendered outside the top container, put it back in (#3679)
	                chart.temporaryDisplay(true);
	
	            },
	
	            /** 
	             * On chart load
	             */
	            onload: function() {
	
	                // Run callbacks
	                each([this.callback].concat(this.callbacks), function(fn) {
	                    if (fn && this.index !== undefined) { // Chart destroyed in its own callback (#3600)
	                        fn.apply(this, [this]);
	                    }
	                }, this);
	
	                fireEvent(this, 'load');
	                fireEvent(this, 'render');
	
	
	                // Set up auto resize, check for not destroyed (#6068)
	                if (defined(this.index) && this.options.chart.reflow !== false) {
	                    this.initReflow();
	                }
	
	                // Don't run again
	                this.onload = null;
	            }
	
	        }); // end Chart
	
	    }(Highcharts));
	    (function(Highcharts) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Point,
	            H = Highcharts,
	
	            each = H.each,
	            extend = H.extend,
	            erase = H.erase,
	            fireEvent = H.fireEvent,
	            format = H.format,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            pick = H.pick,
	            removeEvent = H.removeEvent;
	
	        /**
	         * The Point object. The point objects are generated from the `series.data` 
	         * configuration objects or raw numbers. They can be accessed from the
	         * `Series.points` array. Other ways to instaniate points are through {@link
	         * Highcharts.Series#addPoint} or {@link Highcharts.Series#setData}.
	         *
	         * @class
	         */
	
	        Highcharts.Point = Point = function() {};
	        Highcharts.Point.prototype = {
	
	            /**
	             * Initialize the point. Called internally based on the series.data option.
	             * @param {Object} series The series object containing this point.
	             * @param {Object} options The data in either number, array or object
	             *        format.
	             * @param {Number} x Optionally, the X value of the.
	             * @returns {Object} The Point instance.
	             */
	            init: function(series, options, x) {
	
	                var point = this,
	                    colors,
	                    colorCount = series.chart.options.chart.colorCount,
	                    colorIndex;
	
	                /**
	                 * The series object associated with the point.
	                 *
	                 * @name series
	                 * @memberof Highcharts.Point
	                 * @type Highcharts.Series
	                 */
	                point.series = series;
	
	
	                /**
	                 * The point's current color.
	                 * @name color
	                 * @memberof Highcharts.Point
	                 * @type {Color}
	                 */
	                point.color = series.color; // #3445
	
	                point.applyOptions(options, x);
	
	                if (series.options.colorByPoint) {
	
	                    colors = series.options.colors || series.chart.options.colors;
	                    point.color = point.color || colors[series.colorCounter];
	                    colorCount = colors.length;
	
	                    colorIndex = series.colorCounter;
	                    series.colorCounter++;
	                    // loop back to zero
	                    if (series.colorCounter === colorCount) {
	                        series.colorCounter = 0;
	                    }
	                } else {
	                    colorIndex = series.colorIndex;
	                }
	                point.colorIndex = pick(point.colorIndex, colorIndex);
	
	                series.chart.pointCount++;
	                return point;
	            },
	            /**
	             * Apply the options containing the x and y data and possible some extra
	             * properties. Called on point init or from point.update.
	             *
	             * @param {Object} options The point options as defined in series.data.
	             * @param {Number} x Optionally, the X value.
	             * @returns {Object} The Point instance.
	             */
	            applyOptions: function(options, x) {
	                var point = this,
	                    series = point.series,
	                    pointValKey = series.options.pointValKey || series.pointValKey;
	
	                options = Point.prototype.optionsToObject.call(this, options);
	
	                // copy options directly to point
	                extend(point, options);
	                point.options = point.options ? extend(point.options, options) : options;
	
	                // Since options are copied into the Point instance, some accidental options must be shielded (#5681)
	                if (options.group) {
	                    delete point.group;
	                }
	
	                // For higher dimension series types. For instance, for ranges, point.y is mapped to point.low.
	                if (pointValKey) {
	                    point.y = point[pointValKey];
	                }
	                point.isNull = pick(
	                    point.isValid && !point.isValid(),
	                    point.x === null || !isNumber(point.y, true)
	                ); // #3571, check for NaN
	
	                // The point is initially selected by options (#5777)
	                if (point.selected) {
	                    point.state = 'select';
	                }
	
	                // If no x is set by now, get auto incremented value. All points must have an
	                // x value, however the y value can be null to create a gap in the series
	                if ('name' in point && x === undefined && series.xAxis && series.xAxis.hasNames) {
	                    point.x = series.xAxis.nameToX(point);
	                }
	                if (point.x === undefined && series) {
	                    if (x === undefined) {
	                        point.x = series.autoIncrement(point);
	                    } else {
	                        point.x = x;
	                    }
	                }
	
	                return point;
	            },
	
	            /**
	             * Transform number or array configs into objects
	             */
	            optionsToObject: function(options) {
	                var ret = {},
	                    series = this.series,
	                    keys = series.options.keys,
	                    pointArrayMap = keys || series.pointArrayMap || ['y'],
	                    valueCount = pointArrayMap.length,
	                    firstItemType,
	                    i = 0,
	                    j = 0;
	
	                if (isNumber(options) || options === null) {
	                    ret[pointArrayMap[0]] = options;
	
	                } else if (isArray(options)) {
	                    // with leading x value
	                    if (!keys && options.length > valueCount) {
	                        firstItemType = typeof options[0];
	                        if (firstItemType === 'string') {
	                            ret.name = options[0];
	                        } else if (firstItemType === 'number') {
	                            ret.x = options[0];
	                        }
	                        i++;
	                    }
	                    while (j < valueCount) {
	                        if (!keys || options[i] !== undefined) { // Skip undefined positions for keys
	                            ret[pointArrayMap[j]] = options[i];
	                        }
	                        i++;
	                        j++;
	                    }
	                } else if (typeof options === 'object') {
	                    ret = options;
	
	                    // This is the fastest way to detect if there are individual point dataLabels that need
	                    // to be considered in drawDataLabels. These can only occur in object configs.
	                    if (options.dataLabels) {
	                        series._hasPointLabels = true;
	                    }
	
	                    // Same approach as above for markers
	                    if (options.marker) {
	                        series._hasPointMarkers = true;
	                    }
	                }
	                return ret;
	            },
	
	            /**
	             * Get the CSS class names for individual points
	             * @returns {String} The class name
	             */
	            getClassName: function() {
	                return 'highcharts-point' +
	                    (this.selected ? ' highcharts-point-select' : '') +
	                    (this.negative ? ' highcharts-negative' : '') +
	                    (this.isNull ? ' highcharts-null-point' : '') +
	                    (this.colorIndex !== undefined ? ' highcharts-color-' +
	                        this.colorIndex : '') +
	                    (this.options.className ? ' ' + this.options.className : '') +
	                    (this.zone && this.zone.className ? ' ' +
	                        this.zone.className.replace('highcharts-negative', '') : '');
	            },
	
	            /**
	             * Return the zone that the point belongs to
	             */
	            getZone: function() {
	                var series = this.series,
	                    zones = series.zones,
	                    zoneAxis = series.zoneAxis || 'y',
	                    i = 0,
	                    zone;
	
	                zone = zones[i];
	                while (this[zoneAxis] >= zone.value) {
	                    zone = zones[++i];
	                }
	
	                if (zone && zone.color && !this.options.color) {
	                    this.color = zone.color;
	                }
	
	                return zone;
	            },
	
	            /**
	             * Destroy a point to clear memory. Its reference still stays in series.data.
	             */
	            destroy: function() {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart,
	                    hoverPoints = chart.hoverPoints,
	                    prop;
	
	                chart.pointCount--;
	
	                if (hoverPoints) {
	                    point.setState();
	                    erase(hoverPoints, point);
	                    if (!hoverPoints.length) {
	                        chart.hoverPoints = null;
	                    }
	
	                }
	                if (point === chart.hoverPoint) {
	                    point.onMouseOut();
	                }
	
	                // remove all events
	                if (point.graphic || point.dataLabel) { // removeEvent and destroyElements are performance expensive
	                    removeEvent(point);
	                    point.destroyElements();
	                }
	
	                if (point.legendItem) { // pies have legend items
	                    chart.legend.destroyItem(point);
	                }
	
	                for (prop in point) {
	                    point[prop] = null;
	                }
	
	
	            },
	
	            /**
	             * Destroy SVG elements associated with the point
	             */
	            destroyElements: function() {
	                var point = this,
	                    props = ['graphic', 'dataLabel', 'dataLabelUpper', 'connector', 'shadowGroup'],
	                    prop,
	                    i = 6;
	                while (i--) {
	                    prop = props[i];
	                    if (point[prop]) {
	                        point[prop] = point[prop].destroy();
	                    }
	                }
	            },
	
	            /**
	             * Return the configuration hash needed for the data label and tooltip formatters
	             */
	            getLabelConfig: function() {
	                return {
	                    x: this.category,
	                    y: this.y,
	                    color: this.color,
	                    colorIndex: this.colorIndex,
	                    key: this.name || this.category,
	                    series: this.series,
	                    point: this,
	                    percentage: this.percentage,
	                    total: this.total || this.stackTotal
	                };
	            },
	
	            /**
	             * Extendable method for formatting each point's tooltip line
	             *
	             * @return {String} A string to be concatenated in to the common tooltip text
	             */
	            tooltipFormatter: function(pointFormat) {
	
	                // Insert options for valueDecimals, valuePrefix, and valueSuffix
	                var series = this.series,
	                    seriesTooltipOptions = series.tooltipOptions,
	                    valueDecimals = pick(seriesTooltipOptions.valueDecimals, ''),
	                    valuePrefix = seriesTooltipOptions.valuePrefix || '',
	                    valueSuffix = seriesTooltipOptions.valueSuffix || '';
	
	                // Loop over the point array map and replace unformatted values with sprintf formatting markup
	                each(series.pointArrayMap || ['y'], function(key) {
	                    key = '{point.' + key; // without the closing bracket
	                    if (valuePrefix || valueSuffix) {
	                        pointFormat = pointFormat.replace(key + '}', valuePrefix + key + '}' + valueSuffix);
	                    }
	                    pointFormat = pointFormat.replace(key + '}', key + ':,.' + valueDecimals + 'f}');
	                });
	
	                return format(pointFormat, {
	                    point: this,
	                    series: this.series
	                });
	            },
	
	            /**
	             * Fire an event on the Point object.
	             * @param {String} eventType
	             * @param {Object} eventArgs Additional event arguments
	             * @param {Function} defaultFunction Default event handler
	             */
	            firePointEvent: function(eventType, eventArgs, defaultFunction) {
	                var point = this,
	                    series = this.series,
	                    seriesOptions = series.options;
	
	                // load event handlers on demand to save time on mouseover/out
	                if (seriesOptions.point.events[eventType] || (point.options && point.options.events && point.options.events[eventType])) {
	                    this.importEvents();
	                }
	
	                // add default handler if in selection mode
	                if (eventType === 'click' && seriesOptions.allowPointSelect) {
	                    defaultFunction = function(event) {
	                        // Control key is for Windows, meta (= Cmd key) for Mac, Shift for Opera
	                        if (point.select) { // Could be destroyed by prior event handlers (#2911)
	                            point.select(null, event.ctrlKey || event.metaKey || event.shiftKey);
	                        }
	                    };
	                }
	
	                fireEvent(this, eventType, eventArgs, defaultFunction);
	            },
	
	            /**
	             * For certain series types, like pie charts, where individual points can
	             * be shown or hidden. 
	             *
	             * @name visible
	             * @memberOf Highcharts.Point
	             * @type {Boolean}
	             */
	            visible: true
	        };
	
	        /**
	         * For categorized axes this property holds the category name for the 
	         * point. For other axes it holds the X value.
	         *
	         * @name category
	         * @memberOf Highcharts.Point
	         * @type {String|Number}
	         */
	
	        /**
	         * The percentage for points in a stacked series or pies.
	         *
	         * @name percentage
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	        /**
	         * The total of values in either a stack for stacked series, or a pie in a pie
	         * series.
	         *
	         * @name total
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	        /**
	         * The x value of the point.
	         *
	         * @name x
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	        /**
	         * The y value of the point.
	         *
	         * @name y
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            animObject = H.animObject,
	            arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            correctFloat = H.correctFloat,
	            Date = H.Date,
	            defaultOptions = H.defaultOptions,
	            defaultPlotOptions = H.defaultPlotOptions,
	            defined = H.defined,
	            each = H.each,
	            erase = H.erase,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            grep = H.grep,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isString = H.isString,
	            LegendSymbolMixin = H.LegendSymbolMixin, // @todo add as a requirement
	            merge = H.merge,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            Point = H.Point, // @todo  add as a requirement
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            SVGElement = H.SVGElement,
	            syncTimeout = H.syncTimeout,
	            win = H.win;
	
	        /**
	         * This is the base series prototype that all other series types inherit from.
	         * A new series is initiated either through the {@link https://api.highcharts.com/highcharts/series|
	         * series} option structure, or after the chart is initiated, through {@link
	         * Highcharts.Chart#addSeries}.
	         *
	         * The object can be accessed in a number of ways. All series and point event
	         * handlers give a reference to the `series` object. The chart object has a
	         * {@link Highcharts.Chart.series|series} property that is a collection of all
	         * the chart's series. The point objects and axis objects also have the same
	         * reference.
	         * 
	         * Another way to reference the series programmatically is by `id`. Add an id
	         * in the series configuration options, and get the series object by {@link
	         * Highcharts.Chart#get}.
	         *
	         * Configuration options for the series are given in three levels. Options for
	         * all series in a chart are given in the {@link https://api.highcharts.com/highcharts/plotOptions.series|
	         * plotOptions.series} object. Then options for all series of a specific type
	         * are given in the plotOptions of that type, for example `plotOptions.line`.
	         * Next, options for one single series are given in the series array, or as
	         * arguements to `chart.addSeries`. 
	         * 
	         * The data in the series is stored in various arrays.
	         *
	         * - First, `series.options.data` contains all the original config options for
	         * each point whether added by options or methods like `series.addPoint`.
	         * - Next, `series.data` contains those values converted to points, but in case
	         * the series data length exceeds the `cropThreshold`, or if the data is grouped,
	         * `series.data` doesn't contain all the points. It only contains the points that
	         * have been created on demand.
	         * - Then there's `series.points` that contains all currently visible point
	         * objects. In case of cropping, the cropped-away points are not part of this
	         * array. The `series.points` array starts at `series.cropStart` compared to
	         * `series.data` and `series.options.data`. If however the series data is grouped,
	         * these can't be correlated one to one.
	         * - `series.xData` and `series.processedXData` contain clean x values, equivalent
	         * to `series.data` and `series.points`.
	         * - `series.yData` and `series.processedYData` contain clean y values, equivalent
	         * to `series.data` and `series.points`.
	         *
	         * @class Highcharts.Series
	         * @param  {Highcharts.Chart} chart
	         *         The chart instance.
	         * @param  {Object} options
	         *         The series options.
	         */
	        H.Series = H.seriesType('line', null, { // base series options
	
	            //cursor: 'default',
	            //dashStyle: null,
	            //linecap: 'round',
	            lineWidth: 2,
	            //shadow: false,
	
	            allowPointSelect: false,
	            showCheckbox: false,
	            animation: {
	                duration: 1000
	            },
	            //clip: true,
	            //connectNulls: false,
	            //enableMouseTracking: true,
	            events: {},
	            //legendIndex: 0,
	            // stacking: null,
	            marker: {
	
	                lineWidth: 0,
	                lineColor: '#ffffff',
	                //fillColor: null,
	
	                //enabled: true,
	                //symbol: null,
	                radius: 4,
	                states: { // states for a single point
	                    hover: {
	                        animation: {
	                            duration: 50
	                        },
	                        enabled: true,
	                        radiusPlus: 2,
	
	                        lineWidthPlus: 1
	
	                    },
	
	                    select: {
	                        fillColor: '#cccccc',
	                        lineColor: '#000000',
	                        lineWidth: 2
	                    }
	
	                }
	            },
	            point: {
	                events: {}
	            },
	            dataLabels: {
	                align: 'center',
	                // defer: true,
	                // enabled: false,
	                formatter: function() {
	                    return this.y === null ? '' : H.numberFormat(this.y, -1);
	                },
	
	                style: {
	                    fontSize: '11px',
	                    fontWeight: 'bold',
	                    color: 'contrast',
	                    textOutline: '1px contrast'
	                },
	                // backgroundColor: undefined,
	                // borderColor: undefined,
	                // borderWidth: undefined,
	                // shadow: false
	
	                verticalAlign: 'bottom', // above singular point
	                x: 0,
	                y: 0,
	                // borderRadius: undefined,
	                padding: 5
	            },
	            // draw points outside the plot area when the number of points is less than
	            // this
	            cropThreshold: 300,
	            pointRange: 0,
	            //pointStart: 0,
	            //pointInterval: 1,
	            //showInLegend: null, // auto = false for linked series
	            softThreshold: true,
	            states: { // states for the entire series
	                hover: {
	                    //enabled: false,
	                    animation: {
	                        duration: 50
	                    },
	                    lineWidthPlus: 1,
	                    marker: {
	                        // lineWidth: base + 1,
	                        // radius: base + 1
	                    },
	                    halo: {
	                        size: 10,
	
	                        opacity: 0.25
	
	                    }
	                },
	                select: {
	                    marker: {}
	                }
	            },
	            stickyTracking: true,
	            //tooltip: {
	            //pointFormat: '<span style="color:{point.color}">\u25CF</span>' +
	            // '{series.name}: <b>{point.y}</b>'
	            //valueDecimals: null,
	            //xDateFormat: '%A, %b %e, %Y',
	            //valuePrefix: '',
	            //ySuffix: ''
	            //}
	            turboThreshold: 1000,
	            // zIndex: null
	            findNearestPointBy: 'x'
	
	        }, /** @lends Highcharts.Series.prototype */ {
	            isCartesian: true,
	            pointClass: Point,
	            sorted: true, // requires the data to be sorted
	            requireSorting: true,
	            directTouch: false,
	            axisTypes: ['xAxis', 'yAxis'],
	            colorCounter: 0,
	            // each point's x and y values are stored in this.xData and this.yData
	            parallelArrays: ['x', 'y'],
	            coll: 'series',
	            init: function(chart, options) {
	                var series = this,
	                    events,
	                    chartSeries = chart.series,
	                    lastSeries;
	
	                /**
	                 * Read only. The chart that the series belongs to.
	                 *
	                 * @name chart
	                 * @memberOf Series
	                 * @type {Chart}
	                 */
	                series.chart = chart;
	
	                /**
	                 * Read only. The series' type, like "line", "area", "column" etc. The
	                 * type in the series options anc can be altered using {@link
	                 * Series#update}.
	                 *
	                 * @name type
	                 * @memberOf Series
	                 * @type String
	                 */
	
	                /**
	                 * Read only. The series' current options. To update, use {@link
	                 * Series#update}.
	                 *
	                 * @name options
	                 * @memberOf Series
	                 * @type SeriesOptions
	                 */
	                series.options = options = series.setOptions(options);
	                series.linkedSeries = [];
	
	                // bind the axes
	                series.bindAxes();
	
	                // set some variables
	                extend(series, {
	                    /**
	                     * The series name as given in the options. Defaults to
	                     * "Series {n}".
	                     *
	                     * @name name
	                     * @memberOf Series
	                     * @type {String}
	                     */
	                    name: options.name,
	                    state: '',
	                    /**
	                     * Read only. The series' visibility state as set by {@link
	                     * Series#show}, {@link Series#hide}, or in the initial
	                     * configuration.
	                     *
	                     * @name visible
	                     * @memberOf Series
	                     * @type {Boolean}
	                     */
	                    visible: options.visible !== false, // true by default
	                    /**
	                     * Read only. The series' selected state as set by {@link
	                     * Highcharts.Series#select}.
	                     * 
	                     * @name selected
	                     * @memberOf Series
	                     * @type {Boolean}
	                     */
	                    selected: options.selected === true // false by default
	                });
	
	                // register event listeners
	                events = options.events;
	
	                objectEach(events, function(event, eventType) {
	                    addEvent(series, eventType, event);
	                });
	                if (
	                    (events && events.click) ||
	                    (
	                        options.point &&
	                        options.point.events &&
	                        options.point.events.click
	                    ) ||
	                    options.allowPointSelect
	                ) {
	                    chart.runTrackerClick = true;
	                }
	
	                series.getColor();
	                series.getSymbol();
	
	                // Set the data
	                each(series.parallelArrays, function(key) {
	                    series[key + 'Data'] = [];
	                });
	                series.setData(options.data, false);
	
	                // Mark cartesian
	                if (series.isCartesian) {
	                    chart.hasCartesianSeries = true;
	                }
	
	                // Get the index and register the series in the chart. The index is one
	                // more than the current latest series index (#5960).
	                if (chartSeries.length) {
	                    lastSeries = chartSeries[chartSeries.length - 1];
	                }
	                series._i = pick(lastSeries && lastSeries._i, -1) + 1;
	
	                // Insert the series and re-order all series above the insertion point.
	                chart.orderSeries(this.insert(chartSeries));
	            },
	
	            /**
	             * Insert the series in a collection with other series, either the chart
	             * series or yAxis series, in the correct order according to the index 
	             * option.
	             * @param  {Array} collection A collection of series.
	             * @returns {Number} The index of the series in the collection.
	             */
	            insert: function(collection) {
	                var indexOption = this.options.index,
	                    i;
	
	                // Insert by index option
	                if (isNumber(indexOption)) {
	                    i = collection.length;
	                    while (i--) {
	                        // Loop down until the interted element has higher index
	                        if (indexOption >=
	                            pick(collection[i].options.index, collection[i]._i)) {
	                            collection.splice(i + 1, 0, this);
	                            break;
	                        }
	                    }
	                    if (i === -1) {
	                        collection.unshift(this);
	                    }
	                    i = i + 1;
	
	                    // Or just push it to the end
	                } else {
	                    collection.push(this);
	                }
	                return pick(i, collection.length - 1);
	            },
	
	            /**
	             * Set the xAxis and yAxis properties of cartesian series, and register the
	             * series in the `axis.series` array.
	             *
	             * @function #bindAxes
	             * @memberOf Series
	             * @returns {void}
	             */
	            bindAxes: function() {
	                var series = this,
	                    seriesOptions = series.options,
	                    chart = series.chart,
	                    axisOptions;
	
	                // repeat for xAxis and yAxis
	                each(series.axisTypes || [], function(AXIS) {
	
	                    // loop through the chart's axis objects
	                    each(chart[AXIS], function(axis) {
	                        axisOptions = axis.options;
	
	                        // apply if the series xAxis or yAxis option mathches the number
	                        // of the axis, or if undefined, use the first axis
	                        if (
	                            seriesOptions[AXIS] === axisOptions.index ||
	                            (
	                                seriesOptions[AXIS] !== undefined &&
	                                seriesOptions[AXIS] === axisOptions.id
	                            ) ||
	                            (
	                                seriesOptions[AXIS] === undefined &&
	                                axisOptions.index === 0
	                            )
	                        ) {
	
	                            // register this series in the axis.series lookup
	                            series.insert(axis.series);
	
	                            // set this series.xAxis or series.yAxis reference
	                            /**
	                             * Read only. The unique xAxis object associated with the
	                             * series.
	                             *
	                             * @name xAxis
	                             * @memberOf Series
	                             * @type Axis
	                             */
	                            /**
	                             * Read only. The unique yAxis object associated with the
	                             * series.
	                             *
	                             * @name yAxis
	                             * @memberOf Series
	                             * @type Axis
	                             */
	                            series[AXIS] = axis;
	
	                            // mark dirty for redraw
	                            axis.isDirty = true;
	                        }
	                    });
	
	                    // The series needs an X and an Y axis
	                    if (!series[AXIS] && series.optionalAxis !== AXIS) {
	                        H.error(18, true);
	                    }
	
	                });
	            },
	
	            /**
	             * For simple series types like line and column, the data values are held in
	             * arrays like xData and yData for quick lookup to find extremes and more.
	             * For multidimensional series like bubble and map, this can be extended
	             * with arrays like zData and valueData by adding to the
	             * series.parallelArrays array.
	             */
	            updateParallelArrays: function(point, i) {
	                var series = point.series,
	                    args = arguments,
	                    fn = isNumber(i) ?
	                    // Insert the value in the given position
	                    function(key) {
	                        var val = key === 'y' && series.toYData ?
	                            series.toYData(point) :
	                            point[key];
	                        series[key + 'Data'][i] = val;
	                    } :
	                    // Apply the method specified in i with the following arguments
	                    // as arguments
	                    function(key) {
	                        Array.prototype[i].apply(
	                            series[key + 'Data'],
	                            Array.prototype.slice.call(args, 2)
	                        );
	                    };
	
	                each(series.parallelArrays, fn);
	            },
	
	            /**
	             * Return an auto incremented x value based on the pointStart and
	             * pointInterval options. This is only used if an x value is not given for
	             * the point that calls autoIncrement.
	             */
	            autoIncrement: function() {
	
	                var options = this.options,
	                    xIncrement = this.xIncrement,
	                    date,
	                    pointInterval,
	                    pointIntervalUnit = options.pointIntervalUnit;
	
	                xIncrement = pick(xIncrement, options.pointStart, 0);
	
	                this.pointInterval = pointInterval = pick(
	                    this.pointInterval,
	                    options.pointInterval,
	                    1
	                );
	
	                // Added code for pointInterval strings
	                if (pointIntervalUnit) {
	                    date = new Date(xIncrement);
	
	                    if (pointIntervalUnit === 'day') {
	                        date = +date[Date.hcSetDate](
	                            date[Date.hcGetDate]() + pointInterval
	                        );
	                    } else if (pointIntervalUnit === 'month') {
	                        date = +date[Date.hcSetMonth](
	                            date[Date.hcGetMonth]() + pointInterval
	                        );
	                    } else if (pointIntervalUnit === 'year') {
	                        date = +date[Date.hcSetFullYear](
	                            date[Date.hcGetFullYear]() + pointInterval
	                        );
	                    }
	                    pointInterval = date - xIncrement;
	
	                }
	
	                this.xIncrement = xIncrement + pointInterval;
	                return xIncrement;
	            },
	
	            /**
	             * Set the series options by merging from the options tree
	             * @param {Object} itemOptions
	             */
	            setOptions: function(itemOptions) {
	                var chart = this.chart,
	                    chartOptions = chart.options,
	                    plotOptions = chartOptions.plotOptions,
	                    userOptions = chart.userOptions || {},
	                    userPlotOptions = userOptions.plotOptions || {},
	                    typeOptions = plotOptions[this.type],
	                    options,
	                    zones;
	
	                this.userOptions = itemOptions;
	
	                // General series options take precedence over type options because
	                // otherwise, default type options like column.animation would be
	                // overwritten by the general option. But issues have been raised here
	                // (#3881), and the solution may be to distinguish between default
	                // option and userOptions like in the tooltip below.
	                options = merge(
	                    typeOptions,
	                    plotOptions.series,
	                    itemOptions
	                );
	
	                // The tooltip options are merged between global and series specific
	                // options. Importance order asscendingly:
	                // globals: (1)tooltip, (2)plotOptions.series, (3)plotOptions[this.type]
	                // init userOptions with possible later updates: 4-6 like 1-3 and
	                // (7)this series options
	                this.tooltipOptions = merge(
	                    defaultOptions.tooltip, // 1
	                    defaultOptions.plotOptions.series &&
	                    defaultOptions.plotOptions.series.tooltip, // 2
	                    defaultOptions.plotOptions[this.type].tooltip, // 3
	                    chartOptions.tooltip.userOptions, // 4
	                    plotOptions.series && plotOptions.series.tooltip, // 5
	                    plotOptions[this.type].tooltip, // 6
	                    itemOptions.tooltip // 7
	                );
	
	                // When shared tooltip, stickyTracking is true by default,
	                // unless user says otherwise.
	                this.stickyTracking = pick(
	                    itemOptions.stickyTracking,
	                    userPlotOptions[this.type] &&
	                    userPlotOptions[this.type].stickyTracking,
	                    userPlotOptions.series && userPlotOptions.series.stickyTracking,
	                    (
	                        this.tooltipOptions.shared && !this.noSharedTooltip ?
	                        true :
	                        options.stickyTracking
	                    )
	                );
	
	                // Delete marker object if not allowed (#1125)
	                if (typeOptions.marker === null) {
	                    delete options.marker;
	                }
	
	                // Handle color zones
	                this.zoneAxis = options.zoneAxis;
	                zones = this.zones = (options.zones || []).slice();
	                if (
	                    (options.negativeColor || options.negativeFillColor) &&
	                    !options.zones
	                ) {
	                    zones.push({
	                        value: options[this.zoneAxis + 'Threshold'] ||
	                            options.threshold ||
	                            0,
	                        className: 'highcharts-negative',
	
	                        color: options.negativeColor,
	                        fillColor: options.negativeFillColor
	
	                    });
	                }
	                if (zones.length) { // Push one extra zone for the rest
	                    if (defined(zones[zones.length - 1].value)) {
	                        zones.push({
	
	                            color: this.color,
	                            fillColor: this.fillColor
	
	                        });
	                    }
	                }
	                return options;
	            },
	
	            getCyclic: function(prop, value, defaults) {
	                var i,
	                    chart = this.chart,
	                    userOptions = this.userOptions,
	                    indexName = prop + 'Index',
	                    counterName = prop + 'Counter',
	                    len = defaults ? defaults.length : pick(
	                        chart.options.chart[prop + 'Count'],
	                        chart[prop + 'Count']
	                    ),
	                    setting;
	
	                if (!value) {
	                    // Pick up either the colorIndex option, or the _colorIndex after
	                    // Series.update()
	                    setting = pick(
	                        userOptions[indexName],
	                        userOptions['_' + indexName]
	                    );
	                    if (defined(setting)) { // after Series.update()
	                        i = setting;
	                    } else {
	                        // #6138
	                        if (!chart.series.length) {
	                            chart[counterName] = 0;
	                        }
	                        userOptions['_' + indexName] = i = chart[counterName] % len;
	                        chart[counterName] += 1;
	                    }
	                    if (defaults) {
	                        value = defaults[i];
	                    }
	                }
	                // Set the colorIndex
	                if (i !== undefined) {
	                    this[indexName] = i;
	                }
	                this[prop] = value;
	            },
	
	            /**
	             * Get the series' color
	             */
	
	            getColor: function() {
	                if (this.options.colorByPoint) {
	                    // #4359, selected slice got series.color even when colorByPoint was
	                    // set.
	                    this.options.color = null;
	                } else {
	                    this.getCyclic(
	                        'color',
	                        this.options.color || defaultPlotOptions[this.type].color,
	                        this.chart.options.colors
	                    );
	                }
	            },
	
	            /**
	             * Get the series' symbol
	             */
	            getSymbol: function() {
	                var seriesMarkerOption = this.options.marker;
	
	                this.getCyclic(
	                    'symbol',
	                    seriesMarkerOption.symbol,
	                    this.chart.options.symbols
	                );
	            },
	
	            drawLegendSymbol: LegendSymbolMixin.drawLineMarker,
	
	            /**
	             * Apply a new set of data to the series and optionally redraw it. The new
	             * data array is passed by reference (except in case of `updatePoints`), and
	             * may later be mutated when updating the chart data.
	             * 
	             * Note the difference in behaviour when setting the same amount of points,
	             * or a different amount of points, as handled by the `updatePoints`
	             * parameter. 
	             * 
	             * @param  {SeriesDataOptions} data
	             *         Takes an array of data in the same format as described under
	             *         `series<type>data` for the given series type.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the series is altered. If doing
	             *         more operations on the chart, it is a good idea to set redraw to
	             *         false and call {@link Chart#redraw} after.
	             * @param  {AnimationOptions} [animation]
	             *         When the updated data is the same length as the existing data,
	             *         points will be updated by default, and animation visualizes how
	             *         the points are changed. Set false to disable animation, or a
	             *         configuration object to set duration or easing.
	             * @param  {Boolean} [updatePoints=true]
	             *         When the updated data is the same length as the existing data,
	             *         points will be updated instead of replaced. This allows updating
	             *         with animation and performs better. In this case, the original
	             *         array is not passed by reference. Set false to prevent.
	             *
	             * @sample highcharts/members/series-setdata/
	             *         Set new data from a button
	             * @sample highcharts/members/series-setdata-pie/
	             *         Set data in a pie
	             * @sample stock/members/series-setdata/
	             *         Set new data in Highstock
	             * @sample maps/members/series-setdata/
	             *         Set new data in Highmaps
	             */
	            setData: function(data, redraw, animation, updatePoints) {
	                var series = this,
	                    oldData = series.points,
	                    oldDataLength = (oldData && oldData.length) || 0,
	                    dataLength,
	                    options = series.options,
	                    chart = series.chart,
	                    firstPoint = null,
	                    xAxis = series.xAxis,
	                    i,
	                    turboThreshold = options.turboThreshold,
	                    pt,
	                    xData = this.xData,
	                    yData = this.yData,
	                    pointArrayMap = series.pointArrayMap,
	                    valueCount = pointArrayMap && pointArrayMap.length;
	
	                data = data || [];
	                dataLength = data.length;
	                redraw = pick(redraw, true);
	
	                // If the point count is the same as is was, just run Point.update which
	                // is cheaper, allows animation, and keeps references to points.
	                if (
	                    updatePoints !== false &&
	                    dataLength &&
	                    oldDataLength === dataLength &&
	                    !series.cropped &&
	                    !series.hasGroupedData &&
	                    series.visible
	                ) {
	                    each(data, function(point, i) {
	                        // .update doesn't exist on a linked, hidden series (#3709)
	                        if (oldData[i].update && point !== options.data[i]) {
	                            oldData[i].update(point, false, null, false);
	                        }
	                    });
	
	                } else {
	
	                    // Reset properties
	                    series.xIncrement = null;
	
	                    series.colorCounter = 0; // for series with colorByPoint (#1547)
	
	                    // Update parallel arrays
	                    each(this.parallelArrays, function(key) {
	                        series[key + 'Data'].length = 0;
	                    });
	
	                    // In turbo mode, only one- or twodimensional arrays of numbers are
	                    // allowed. The first value is tested, and we assume that all the
	                    // rest are defined the same way. Although the 'for' loops are
	                    // similar, they are repeated inside each if-else conditional for
	                    // max performance.
	                    if (turboThreshold && dataLength > turboThreshold) {
	
	                        // find the first non-null point
	                        i = 0;
	                        while (firstPoint === null && i < dataLength) {
	                            firstPoint = data[i];
	                            i++;
	                        }
	
	
	                        if (isNumber(firstPoint)) { // assume all points are numbers
	                            for (i = 0; i < dataLength; i++) {
	                                xData[i] = this.autoIncrement();
	                                yData[i] = data[i];
	                            }
	
	                            // Assume all points are arrays when first point is
	                        } else if (isArray(firstPoint)) {
	                            if (valueCount) { // [x, low, high] or [x, o, h, l, c]
	                                for (i = 0; i < dataLength; i++) {
	                                    pt = data[i];
	                                    xData[i] = pt[0];
	                                    yData[i] = pt.slice(1, valueCount + 1);
	                                }
	                            } else { // [x, y]
	                                for (i = 0; i < dataLength; i++) {
	                                    pt = data[i];
	                                    xData[i] = pt[0];
	                                    yData[i] = pt[1];
	                                }
	                            }
	                        } else {
	                            // Highcharts expects configs to be numbers or arrays in
	                            // turbo mode
	                            H.error(12);
	                        }
	                    } else {
	                        for (i = 0; i < dataLength; i++) {
	                            if (data[i] !== undefined) { // stray commas in oldIE
	                                pt = {
	                                    series: series
	                                };
	                                series.pointClass.prototype.applyOptions.apply(
	                                    pt, [data[i]]
	                                );
	                                series.updateParallelArrays(pt, i);
	                            }
	                        }
	                    }
	
	                    // Forgetting to cast strings to numbers is a common caveat when
	                    // handling CSV or JSON
	                    if (isString(yData[0])) {
	                        H.error(14, true);
	                    }
	
	                    /**
	                     * Read only. An array containing the series' data point objects. To
	                     * modify the data, use {@link Highcharts.Series#setData} or {@link
	                     * Highcharts.Point#update}.
	                     *
	                     * @name data
	                     * @memberOf Highcharts.Series
	                     * @type {Array.<Highcharts.Point>}
	                     */
	                    series.data = [];
	                    series.options.data = series.userOptions.data = data;
	
	                    // destroy old points
	                    i = oldDataLength;
	                    while (i--) {
	                        if (oldData[i] && oldData[i].destroy) {
	                            oldData[i].destroy();
	                        }
	                    }
	
	                    // reset minRange (#878)
	                    if (xAxis) {
	                        xAxis.minRange = xAxis.userMinRange;
	                    }
	
	                    // redraw
	                    series.isDirty = chart.isDirtyBox = true;
	                    series.isDirtyData = !!oldData;
	                    animation = false;
	                }
	
	                // Typically for pie series, points need to be processed and generated
	                // prior to rendering the legend
	                if (options.legendType === 'point') {
	                    this.processData();
	                    this.generatePoints();
	                }
	
	                if (redraw) {
	                    chart.redraw(animation);
	                }
	            },
	
	            /**
	             * Process the data by cropping away unused data points if the series is
	             * longer than the crop threshold. This saves computing time for large
	             * series.
	             */
	            processData: function(force) {
	                var series = this,
	                    processedXData = series.xData, // copied during slice operation
	                    processedYData = series.yData,
	                    dataLength = processedXData.length,
	                    croppedData,
	                    cropStart = 0,
	                    cropped,
	                    distance,
	                    closestPointRange,
	                    xAxis = series.xAxis,
	                    i, // loop variable
	                    options = series.options,
	                    cropThreshold = options.cropThreshold,
	                    getExtremesFromAll =
	                    series.getExtremesFromAll ||
	                    options.getExtremesFromAll, // #4599
	                    isCartesian = series.isCartesian,
	                    xExtremes,
	                    val2lin = xAxis && xAxis.val2lin,
	                    isLog = xAxis && xAxis.isLog,
	                    min,
	                    max;
	
	                // If the series data or axes haven't changed, don't go through this.
	                // Return false to pass the message on to override methods like in data
	                // grouping.
	                if (
	                    isCartesian &&
	                    !series.isDirty &&
	                    !xAxis.isDirty &&
	                    !series.yAxis.isDirty &&
	                    !force
	                ) {
	                    return false;
	                }
	
	                if (xAxis) {
	                    xExtremes = xAxis.getExtremes(); // corrected for log axis (#3053)
	                    min = xExtremes.min;
	                    max = xExtremes.max;
	                }
	
	                // optionally filter out points outside the plot area
	                if (
	                    isCartesian &&
	                    series.sorted &&
	                    !getExtremesFromAll &&
	                    (!cropThreshold || dataLength > cropThreshold || series.forceCrop)
	                ) {
	
	                    // it's outside current extremes
	                    if (
	                        processedXData[dataLength - 1] < min ||
	                        processedXData[0] > max
	                    ) {
	                        processedXData = [];
	                        processedYData = [];
	
	                        // only crop if it's actually spilling out
	                    } else if (
	                        processedXData[0] < min ||
	                        processedXData[dataLength - 1] > max
	                    ) {
	                        croppedData = this.cropData(
	                            series.xData,
	                            series.yData,
	                            min,
	                            max
	                        );
	                        processedXData = croppedData.xData;
	                        processedYData = croppedData.yData;
	                        cropStart = croppedData.start;
	                        cropped = true;
	                    }
	                }
	
	
	                // Find the closest distance between processed points
	                i = processedXData.length || 1;
	                while (--i) {
	                    distance = isLog ?
	                        val2lin(processedXData[i]) - val2lin(processedXData[i - 1]) :
	                        processedXData[i] - processedXData[i - 1];
	
	                    if (
	                        distance > 0 &&
	                        (
	                            closestPointRange === undefined ||
	                            distance < closestPointRange
	                        )
	                    ) {
	                        closestPointRange = distance;
	
	                        // Unsorted data is not supported by the line tooltip, as well as
	                        // data grouping and navigation in Stock charts (#725) and width
	                        // calculation of columns (#1900)
	                    } else if (distance < 0 && series.requireSorting) {
	                        H.error(15);
	                    }
	                }
	
	                // Record the properties
	                series.cropped = cropped; // undefined or true
	                series.cropStart = cropStart;
	                series.processedXData = processedXData;
	                series.processedYData = processedYData;
	
	                series.closestPointRange = closestPointRange;
	
	            },
	
	            /**
	             * Iterate over xData and crop values between min and max. Returns object
	             * containing crop start/end cropped xData with corresponding part of yData,
	             * dataMin and dataMax within the cropped range
	             */
	            cropData: function(xData, yData, min, max) {
	                var dataLength = xData.length,
	                    cropStart = 0,
	                    cropEnd = dataLength,
	                    // line-type series need one point outside
	                    cropShoulder = pick(this.cropShoulder, 1),
	                    i,
	                    j;
	
	                // iterate up to find slice start
	                for (i = 0; i < dataLength; i++) {
	                    if (xData[i] >= min) {
	                        cropStart = Math.max(0, i - cropShoulder);
	                        break;
	                    }
	                }
	
	                // proceed to find slice end
	                for (j = i; j < dataLength; j++) {
	                    if (xData[j] > max) {
	                        cropEnd = j + cropShoulder;
	                        break;
	                    }
	                }
	
	                return {
	                    xData: xData.slice(cropStart, cropEnd),
	                    yData: yData.slice(cropStart, cropEnd),
	                    start: cropStart,
	                    end: cropEnd
	                };
	            },
	
	
	            /**
	             * Generate the data point after the data has been processed by cropping
	             * away unused points and optionally grouped in Highcharts Stock.
	             */
	            generatePoints: function() {
	                var series = this,
	                    options = series.options,
	                    dataOptions = options.data,
	                    data = series.data,
	                    dataLength,
	                    processedXData = series.processedXData,
	                    processedYData = series.processedYData,
	                    PointClass = series.pointClass,
	                    processedDataLength = processedXData.length,
	                    cropStart = series.cropStart || 0,
	                    cursor,
	                    hasGroupedData = series.hasGroupedData,
	                    keys = options.keys,
	                    point,
	                    points = [],
	                    i;
	
	                if (!data && !hasGroupedData) {
	                    var arr = [];
	                    arr.length = dataOptions.length;
	                    data = series.data = arr;
	                }
	
	                if (keys && hasGroupedData) {
	                    // grouped data has already applied keys (#6590)
	                    series.options.keys = false;
	                }
	
	                for (i = 0; i < processedDataLength; i++) {
	                    cursor = cropStart + i;
	                    if (!hasGroupedData) {
	                        point = data[cursor];
	                        if (!point && dataOptions[cursor] !== undefined) { // #970
	                            data[cursor] = point = (new PointClass()).init(
	                                series,
	                                dataOptions[cursor],
	                                processedXData[i]
	                            );
	                        }
	                    } else {
	                        // splat the y data in case of ohlc data array
	                        point = (new PointClass()).init(
	                            series, [processedXData[i]].concat(splat(processedYData[i]))
	                        );
	
	                        /**
	                         * Highstock only. If a point object is created by data
	                         * grouping, it doesn't reflect actual points in the raw data.
	                         * In this case, the `dataGroup` property holds information
	                         * that points back to the raw data.
	                         *
	                         * - `dataGroup.start` is the index of the first raw data point
	                         * in the group.
	                         * - `dataGroup.length` is the amount of points in the group.
	                         *
	                         * @name dataGroup
	                         * @memberOf Point
	                         * @type {Object}
	                         * 
	                         */
	                        point.dataGroup = series.groupMap[i];
	                    }
	                    if (point) { // #6279
	                        point.index = cursor; // For faster access in Point.update
	                        points[i] = point;
	                    }
	                }
	
	                // restore keys options (#6590)
	                series.options.keys = keys;
	
	                // Hide cropped-away points - this only runs when the number of points
	                // is above cropThreshold, or when swithching view from non-grouped
	                // data to grouped data (#637)
	                if (
	                    data &&
	                    (
	                        processedDataLength !== (dataLength = data.length) ||
	                        hasGroupedData
	                    )
	                ) {
	                    for (i = 0; i < dataLength; i++) {
	                        // when has grouped data, clear all points
	                        if (i === cropStart && !hasGroupedData) {
	                            i += processedDataLength;
	                        }
	                        if (data[i]) {
	                            data[i].destroyElements();
	                            data[i].plotX = undefined; // #1003
	                        }
	                    }
	                }
	
	                series.data = data;
	                series.points = points;
	            },
	
	            /**
	             * Calculate Y extremes for visible data
	             */
	            getExtremes: function(yData) {
	                var xAxis = this.xAxis,
	                    yAxis = this.yAxis,
	                    xData = this.processedXData,
	                    yDataLength,
	                    activeYData = [],
	                    activeCounter = 0,
	                    // #2117, need to compensate for log X axis
	                    xExtremes = xAxis.getExtremes(),
	                    xMin = xExtremes.min,
	                    xMax = xExtremes.max,
	                    validValue,
	                    withinRange,
	                    x,
	                    y,
	                    i,
	                    j;
	
	                yData = yData || this.stackedYData || this.processedYData || [];
	                yDataLength = yData.length;
	
	                for (i = 0; i < yDataLength; i++) {
	
	                    x = xData[i];
	                    y = yData[i];
	
	                    // For points within the visible range, including the first point
	                    // outside the visible range, consider y extremes
	                    validValue =
	                        (isNumber(y, true) || isArray(y)) &&
	                        (!yAxis.positiveValuesOnly || (y.length || y > 0));
	                    withinRange =
	                        this.getExtremesFromAll ||
	                        this.options.getExtremesFromAll ||
	                        this.cropped ||
	                        ((xData[i] || x) >= xMin && (xData[i] || x) <= xMax);
	
	                    if (validValue && withinRange) {
	
	                        j = y.length;
	                        if (j) { // array, like ohlc or range data
	                            while (j--) {
	                                if (y[j] !== null) {
	                                    activeYData[activeCounter++] = y[j];
	                                }
	                            }
	                        } else {
	                            activeYData[activeCounter++] = y;
	                        }
	                    }
	                }
	
	                this.dataMin = arrayMin(activeYData);
	                this.dataMax = arrayMax(activeYData);
	            },
	
	            /**
	             * Translate data points from raw data values to chart specific positioning
	             * data needed later in drawPoints, drawGraph and drawTracker.
	             *
	             * @function #translate
	             * @memberOf Series
	             * @returns {void}
	             */
	            translate: function() {
	                if (!this.processedXData) { // hidden series
	                    this.processData();
	                }
	                this.generatePoints();
	                var series = this,
	                    options = series.options,
	                    stacking = options.stacking,
	                    xAxis = series.xAxis,
	                    categories = xAxis.categories,
	                    yAxis = series.yAxis,
	                    points = series.points,
	                    dataLength = points.length,
	                    hasModifyValue = !!series.modifyValue,
	                    i,
	                    pointPlacement = options.pointPlacement,
	                    dynamicallyPlaced =
	                    pointPlacement === 'between' ||
	                    isNumber(pointPlacement),
	                    threshold = options.threshold,
	                    stackThreshold = options.startFromThreshold ? threshold : 0,
	                    plotX,
	                    plotY,
	                    lastPlotX,
	                    stackIndicator,
	                    closestPointRangePx = Number.MAX_VALUE;
	
	                // Point placement is relative to each series pointRange (#5889)
	                if (pointPlacement === 'between') {
	                    pointPlacement = 0.5;
	                }
	                if (isNumber(pointPlacement)) {
	                    pointPlacement *= pick(options.pointRange || xAxis.pointRange);
	                }
	
	                // Translate each point
	                for (i = 0; i < dataLength; i++) {
	                    var point = points[i],
	                        xValue = point.x,
	                        yValue = point.y,
	                        yBottom = point.low,
	                        stack = stacking && yAxis.stacks[(
	                            series.negStacks &&
	                            yValue < (stackThreshold ? 0 : threshold) ? '-' : ''
	                        ) + series.stackKey],
	                        pointStack,
	                        stackValues;
	
	                    // Discard disallowed y values for log axes (#3434)
	                    if (yAxis.positiveValuesOnly && yValue !== null && yValue <= 0) {
	                        point.isNull = true;
	                    }
	
	                    // Get the plotX translation
	                    point.plotX = plotX = correctFloat( // #5236
	                        Math.min(Math.max(-1e5, xAxis.translate(
	                            xValue,
	                            0,
	                            0,
	                            0,
	                            1,
	                            pointPlacement,
	                            this.type === 'flags'
	                        )), 1e5) // #3923
	                    );
	
	                    // Calculate the bottom y value for stacked series
	                    if (
	                        stacking &&
	                        series.visible &&
	                        !point.isNull &&
	                        stack &&
	                        stack[xValue]
	                    ) {
	                        stackIndicator = series.getStackIndicator(
	                            stackIndicator,
	                            xValue,
	                            series.index
	                        );
	                        pointStack = stack[xValue];
	                        stackValues = pointStack.points[stackIndicator.key];
	                        yBottom = stackValues[0];
	                        yValue = stackValues[1];
	
	                        if (
	                            yBottom === stackThreshold &&
	                            stackIndicator.key === stack[xValue].base
	                        ) {
	                            yBottom = pick(threshold, yAxis.min);
	                        }
	                        if (yAxis.positiveValuesOnly && yBottom <= 0) { // #1200, #1232
	                            yBottom = null;
	                        }
	
	                        point.total = point.stackTotal = pointStack.total;
	                        point.percentage =
	                            pointStack.total &&
	                            (point.y / pointStack.total * 100);
	                        point.stackY = yValue;
	
	                        // Place the stack label
	                        pointStack.setOffset(
	                            series.pointXOffset || 0,
	                            series.barW || 0
	                        );
	
	                    }
	
	                    // Set translated yBottom or remove it
	                    point.yBottom = defined(yBottom) ?
	                        yAxis.translate(yBottom, 0, 1, 0, 1) :
	                        null;
	
	                    // general hook, used for Highstock compare mode
	                    if (hasModifyValue) {
	                        yValue = series.modifyValue(yValue, point);
	                    }
	
	                    // Set the the plotY value, reset it for redraws
	                    point.plotY = plotY =
	                        (typeof yValue === 'number' && yValue !== Infinity) ?
	                        Math.min(Math.max(-1e5,
	                            yAxis.translate(yValue, 0, 1, 0, 1)), 1e5) : // #3201
	                        undefined;
	
	                    point.isInside =
	                        plotY !== undefined &&
	                        plotY >= 0 &&
	                        plotY <= yAxis.len && // #3519
	                        plotX >= 0 &&
	                        plotX <= xAxis.len;
	
	
	                    // Set client related positions for mouse tracking
	                    point.clientX = dynamicallyPlaced ?
	                        correctFloat(
	                            xAxis.translate(xValue, 0, 0, 0, 1, pointPlacement)
	                        ) :
	                        plotX; // #1514, #5383, #5518
	
	                    point.negative = point.y < (threshold || 0);
	
	                    // some API data
	                    point.category = categories && categories[point.x] !== undefined ?
	                        categories[point.x] : point.x;
	
	                    // Determine auto enabling of markers (#3635, #5099)
	                    if (!point.isNull) {
	                        if (lastPlotX !== undefined) {
	                            closestPointRangePx = Math.min(
	                                closestPointRangePx,
	                                Math.abs(plotX - lastPlotX)
	                            );
	                        }
	                        lastPlotX = plotX;
	                    }
	
	                    // Find point zone
	                    point.zone = this.zones.length && point.getZone();
	                }
	                series.closestPointRangePx = closestPointRangePx;
	            },
	
	            /**
	             * Return the series points with null points filtered out
	             */
	            getValidPoints: function(points, insideOnly) {
	                var chart = this.chart;
	                // #3916, #5029, #5085
	                return grep(points || this.points || [], function isValidPoint(point) {
	                    if (insideOnly && !chart.isInsidePlot(
	                            point.plotX,
	                            point.plotY,
	                            chart.inverted
	                        )) {
	                        return false;
	                    }
	                    return !point.isNull;
	                });
	            },
	
	            /**
	             * Set the clipping for the series. For animated series it is called twice,
	             * first to initiate animating the clip then the second time without the
	             * animation to set the final clip.
	             */
	            setClip: function(animation) {
	                var chart = this.chart,
	                    options = this.options,
	                    renderer = chart.renderer,
	                    inverted = chart.inverted,
	                    seriesClipBox = this.clipBox,
	                    clipBox = seriesClipBox || chart.clipBox,
	                    sharedClipKey =
	                    this.sharedClipKey || [
	                        '_sharedClip',
	                        animation && animation.duration,
	                        animation && animation.easing,
	                        clipBox.height,
	                        options.xAxis,
	                        options.yAxis
	                    ].join(','), // #4526
	                    clipRect = chart[sharedClipKey],
	                    markerClipRect = chart[sharedClipKey + 'm'];
	
	                // If a clipping rectangle with the same properties is currently present
	                // in the chart, use that.
	                if (!clipRect) {
	
	                    // When animation is set, prepare the initial positions
	                    if (animation) {
	                        clipBox.width = 0;
	
	                        chart[sharedClipKey + 'm'] = markerClipRect = renderer.clipRect(-99, // include the width of the first marker
	                            inverted ? -chart.plotLeft : -chart.plotTop,
	                            99,
	                            inverted ? chart.chartWidth : chart.chartHeight
	                        );
	                    }
	                    chart[sharedClipKey] = clipRect = renderer.clipRect(clipBox);
	                    // Create hashmap for series indexes
	                    clipRect.count = {
	                        length: 0
	                    };
	
	                }
	                if (animation) {
	                    if (!clipRect.count[this.index]) {
	                        clipRect.count[this.index] = true;
	                        clipRect.count.length += 1;
	                    }
	                }
	
	                if (options.clip !== false) {
	                    this.group.clip(animation || seriesClipBox ? clipRect : chart.clipRect);
	                    this.markerGroup.clip(markerClipRect);
	                    this.sharedClipKey = sharedClipKey;
	                }
	
	                // Remove the shared clipping rectangle when all series are shown
	                if (!animation) {
	                    if (clipRect.count[this.index]) {
	                        delete clipRect.count[this.index];
	                        clipRect.count.length -= 1;
	                    }
	
	                    if (clipRect.count.length === 0 && sharedClipKey && chart[sharedClipKey]) {
	                        if (!seriesClipBox) {
	                            chart[sharedClipKey] = chart[sharedClipKey].destroy();
	                        }
	                        if (chart[sharedClipKey + 'm']) {
	                            chart[sharedClipKey + 'm'] = chart[sharedClipKey + 'm'].destroy();
	                        }
	                    }
	                }
	            },
	
	            /**
	             * Animate in the series
	             */
	            animate: function(init) {
	                var series = this,
	                    chart = series.chart,
	                    clipRect,
	                    animation = animObject(series.options.animation),
	                    sharedClipKey;
	
	                // Initialize the animation. Set up the clipping rectangle.
	                if (init) {
	
	                    series.setClip(animation);
	
	                    // Run the animation
	                } else {
	                    sharedClipKey = this.sharedClipKey;
	                    clipRect = chart[sharedClipKey];
	                    if (clipRect) {
	                        clipRect.animate({
	                            width: chart.plotSizeX
	                        }, animation);
	                    }
	                    if (chart[sharedClipKey + 'm']) {
	                        chart[sharedClipKey + 'm'].animate({
	                            width: chart.plotSizeX + 99
	                        }, animation);
	                    }
	
	                    // Delete this function to allow it only once
	                    series.animate = null;
	
	                }
	            },
	
	            /**
	             * This runs after animation to land on the final plot clipping
	             */
	            afterAnimate: function() {
	                this.setClip();
	                fireEvent(this, 'afterAnimate');
	            },
	
	            /**
	             * Draw the markers.
	             *
	             * @function #drawPoints
	             * @memberOf Series
	             * @returns {void}
	             */
	            drawPoints: function() {
	                var series = this,
	                    points = series.points,
	                    chart = series.chart,
	                    plotY,
	                    i,
	                    point,
	                    symbol,
	                    graphic,
	                    options = series.options,
	                    seriesMarkerOptions = options.marker,
	                    pointMarkerOptions,
	                    hasPointMarker,
	                    enabled,
	                    isInside,
	                    markerGroup = series[series.specialGroup] || series.markerGroup,
	                    xAxis = series.xAxis,
	                    markerAttribs,
	                    globallyEnabled = pick(
	                        seriesMarkerOptions.enabled,
	                        xAxis.isRadial ? true : null,
	                        // Use larger or equal as radius is null in bubbles (#6321)
	                        series.closestPointRangePx >= 2 * seriesMarkerOptions.radius
	                    );
	
	                if (seriesMarkerOptions.enabled !== false || series._hasPointMarkers) {
	
	                    for (i = 0; i < points.length; i++) {
	                        point = points[i];
	                        plotY = point.plotY;
	                        graphic = point.graphic;
	                        pointMarkerOptions = point.marker || {};
	                        hasPointMarker = !!point.marker;
	                        enabled = (globallyEnabled && pointMarkerOptions.enabled === undefined) || pointMarkerOptions.enabled;
	                        isInside = point.isInside;
	
	                        // only draw the point if y is defined
	                        if (enabled && isNumber(plotY) && point.y !== null) {
	
	                            // Shortcuts
	                            symbol = pick(pointMarkerOptions.symbol, series.symbol);
	                            point.hasImage = symbol.indexOf('url') === 0;
	
	                            markerAttribs = series.markerAttribs(
	                                point,
	                                point.selected && 'select'
	                            );
	
	                            if (graphic) { // update
	                                graphic[isInside ? 'show' : 'hide'](true) // Since the marker group isn't clipped, each individual marker must be toggled
	                                    .animate(markerAttribs);
	                            } else if (isInside && (markerAttribs.width > 0 || point.hasImage)) {
	                                point.graphic = graphic = chart.renderer.symbol(
	                                        symbol,
	                                        markerAttribs.x,
	                                        markerAttribs.y,
	                                        markerAttribs.width,
	                                        markerAttribs.height,
	                                        hasPointMarker ? pointMarkerOptions : seriesMarkerOptions
	                                    )
	                                    .add(markerGroup);
	                            }
	
	
	                            // Presentational attributes
	                            if (graphic) {
	                                graphic.attr(series.pointAttribs(point, point.selected && 'select'));
	                            }
	
	
	                            if (graphic) {
	                                graphic.addClass(point.getClassName(), true);
	                            }
	
	                        } else if (graphic) {
	                            point.graphic = graphic.destroy(); // #1269
	                        }
	                    }
	                }
	
	            },
	
	            /**
	             * Get non-presentational attributes for the point.
	             */
	            markerAttribs: function(point, state) {
	                var seriesMarkerOptions = this.options.marker,
	                    seriesStateOptions,
	                    pointMarkerOptions = point.marker || {},
	                    pointStateOptions,
	                    radius = pick(
	                        pointMarkerOptions.radius,
	                        seriesMarkerOptions.radius
	                    ),
	                    attribs;
	
	                // Handle hover and select states
	                if (state) {
	                    seriesStateOptions = seriesMarkerOptions.states[state];
	                    pointStateOptions = pointMarkerOptions.states &&
	                        pointMarkerOptions.states[state];
	
	                    radius = pick(
	                        pointStateOptions && pointStateOptions.radius,
	                        seriesStateOptions && seriesStateOptions.radius,
	                        radius + (seriesStateOptions && seriesStateOptions.radiusPlus || 0)
	                    );
	                }
	
	                if (point.hasImage) {
	                    radius = 0; // and subsequently width and height is not set
	                }
	
	                attribs = {
	                    x: Math.floor(point.plotX) - radius, // Math.floor for #1843
	                    y: point.plotY - radius
	                };
	
	                if (radius) {
	                    attribs.width = attribs.height = 2 * radius;
	                }
	
	                return attribs;
	
	            },
	
	
	            /**
	             * Get presentational attributes for marker-based series (line, spline, scatter, bubble, mappoint...)
	             */
	            pointAttribs: function(point, state) {
	                var seriesMarkerOptions = this.options.marker,
	                    seriesStateOptions,
	                    pointOptions = point && point.options,
	                    pointMarkerOptions = (pointOptions && pointOptions.marker) || {},
	                    pointStateOptions,
	                    color = this.color,
	                    pointColorOption = pointOptions && pointOptions.color,
	                    pointColor = point && point.color,
	                    strokeWidth = pick(
	                        pointMarkerOptions.lineWidth,
	                        seriesMarkerOptions.lineWidth
	                    ),
	                    zoneColor = point && point.zone && point.zone.color,
	                    fill,
	                    stroke;
	
	                color = pointColorOption || zoneColor || pointColor || color;
	                fill = pointMarkerOptions.fillColor || seriesMarkerOptions.fillColor || color;
	                stroke = pointMarkerOptions.lineColor || seriesMarkerOptions.lineColor || color;
	
	                // Handle hover and select states
	                if (state) {
	                    seriesStateOptions = seriesMarkerOptions.states[state];
	                    pointStateOptions = (pointMarkerOptions.states && pointMarkerOptions.states[state]) || {};
	                    strokeWidth = pick(
	                        pointStateOptions.lineWidth,
	                        seriesStateOptions.lineWidth,
	                        strokeWidth + pick(
	                            pointStateOptions.lineWidthPlus,
	                            seriesStateOptions.lineWidthPlus,
	                            0
	                        )
	                    );
	                    fill = pointStateOptions.fillColor || seriesStateOptions.fillColor || fill;
	                    stroke = pointStateOptions.lineColor || seriesStateOptions.lineColor || stroke;
	                }
	
	                return {
	                    'stroke': stroke,
	                    'stroke-width': strokeWidth,
	                    'fill': fill
	                };
	            },
	
	            /**
	             * Clear DOM objects and free up memory
	             */
	            destroy: function() {
	                var series = this,
	                    chart = series.chart,
	                    issue134 = /AppleWebKit\/533/.test(win.navigator.userAgent),
	                    destroy,
	                    i,
	                    data = series.data || [],
	                    point,
	                    axis;
	
	                // add event hook
	                fireEvent(series, 'destroy');
	
	                // remove all events
	                removeEvent(series);
	
	                // erase from axes
	                each(series.axisTypes || [], function(AXIS) {
	                    axis = series[AXIS];
	                    if (axis && axis.series) {
	                        erase(axis.series, series);
	                        axis.isDirty = axis.forceRedraw = true;
	                    }
	                });
	
	                // remove legend items
	                if (series.legendItem) {
	                    series.chart.legend.destroyItem(series);
	                }
	
	                // destroy all points with their elements
	                i = data.length;
	                while (i--) {
	                    point = data[i];
	                    if (point && point.destroy) {
	                        point.destroy();
	                    }
	                }
	                series.points = null;
	
	                // Clear the animation timeout if we are destroying the series during initial animation
	                clearTimeout(series.animationTimeout);
	
	                // Destroy all SVGElements associated to the series
	                objectEach(series, function(val, prop) {
	                    if (val instanceof SVGElement && !val.survive) { // Survive provides a hook for not destroying
	
	                        // issue 134 workaround
	                        destroy = issue134 && prop === 'group' ?
	                            'hide' :
	                            'destroy';
	
	                        val[destroy]();
	                    }
	                });
	
	                // remove from hoverSeries
	                if (chart.hoverSeries === series) {
	                    chart.hoverSeries = null;
	                }
	                erase(chart.series, series);
	                chart.orderSeries();
	
	                // clear all members
	                objectEach(series, function(val, prop) {
	                    delete series[prop];
	                });
	            },
	
	            /**
	             * Get the graph path
	             */
	            getGraphPath: function(points, nullsAsZeroes, connectCliffs) {
	                var series = this,
	                    options = series.options,
	                    step = options.step,
	                    reversed,
	                    graphPath = [],
	                    xMap = [],
	                    gap;
	
	                points = points || series.points;
	
	                // Bottom of a stack is reversed
	                reversed = points.reversed;
	                if (reversed) {
	                    points.reverse();
	                }
	                // Reverse the steps (#5004)
	                step = {
	                    right: 1,
	                    center: 2
	                }[step] || (step && 3);
	                if (step && reversed) {
	                    step = 4 - step;
	                }
	
	                // Remove invalid points, especially in spline (#5015)
	                if (options.connectNulls && !nullsAsZeroes && !connectCliffs) {
	                    points = this.getValidPoints(points);
	                }
	
	                // Build the line
	                each(points, function(point, i) {
	
	                    var plotX = point.plotX,
	                        plotY = point.plotY,
	                        lastPoint = points[i - 1],
	                        pathToPoint; // the path to this point from the previous
	
	                    if ((point.leftCliff || (lastPoint && lastPoint.rightCliff)) && !connectCliffs) {
	                        gap = true; // ... and continue
	                    }
	
	                    // Line series, nullsAsZeroes is not handled
	                    if (point.isNull && !defined(nullsAsZeroes) && i > 0) {
	                        gap = !options.connectNulls;
	
	                        // Area series, nullsAsZeroes is set
	                    } else if (point.isNull && !nullsAsZeroes) {
	                        gap = true;
	
	                    } else {
	
	                        if (i === 0 || gap) {
	                            pathToPoint = ['M', point.plotX, point.plotY];
	
	                        } else if (series.getPointSpline) { // generate the spline as defined in the SplineSeries object
	
	                            pathToPoint = series.getPointSpline(points, point, i);
	
	                        } else if (step) {
	
	                            if (step === 1) { // right
	                                pathToPoint = [
	                                    'L',
	                                    lastPoint.plotX,
	                                    plotY
	                                ];
	
	                            } else if (step === 2) { // center
	                                pathToPoint = [
	                                    'L',
	                                    (lastPoint.plotX + plotX) / 2,
	                                    lastPoint.plotY,
	                                    'L',
	                                    (lastPoint.plotX + plotX) / 2,
	                                    plotY
	                                ];
	
	                            } else {
	                                pathToPoint = [
	                                    'L',
	                                    plotX,
	                                    lastPoint.plotY
	                                ];
	                            }
	                            pathToPoint.push('L', plotX, plotY);
	
	                        } else {
	                            // normal line to next point
	                            pathToPoint = [
	                                'L',
	                                plotX,
	                                plotY
	                            ];
	                        }
	
	                        // Prepare for animation. When step is enabled, there are two path nodes for each x value.
	                        xMap.push(point.x);
	                        if (step) {
	                            xMap.push(point.x);
	                        }
	
	                        graphPath.push.apply(graphPath, pathToPoint);
	                        gap = false;
	                    }
	                });
	
	                graphPath.xMap = xMap;
	                series.graphPath = graphPath;
	
	                return graphPath;
	
	            },
	
	            /**
	             * Draw the actual graph
	             */
	            drawGraph: function() {
	                var series = this,
	                    options = this.options,
	                    graphPath = (this.gappedPath || this.getGraphPath).call(this),
	                    props = [
	                        [
	                            'graph',
	                            'highcharts-graph',
	
	                            options.lineColor || this.color,
	                            options.dashStyle
	
	                        ]
	                    ];
	
	                // Add the zone properties if any
	                each(this.zones, function(zone, i) {
	                    props.push([
	                        'zone-graph-' + i,
	                        'highcharts-graph highcharts-zone-graph-' + i + ' ' + (zone.className || ''),
	
	                        zone.color || series.color,
	                        zone.dashStyle || options.dashStyle
	
	                    ]);
	                });
	
	                // Draw the graph
	                each(props, function(prop, i) {
	                    var graphKey = prop[0],
	                        graph = series[graphKey],
	                        attribs;
	
	                    if (graph) {
	                        graph.endX = graphPath.xMap;
	                        graph.animate({
	                            d: graphPath
	                        });
	
	                    } else if (graphPath.length) { // #1487
	
	                        series[graphKey] = series.chart.renderer.path(graphPath)
	                            .addClass(prop[1])
	                            .attr({
	                                zIndex: 1
	                            }) // #1069
	                            .add(series.group);
	
	
	                        attribs = {
	                            'stroke': prop[2],
	                            'stroke-width': options.lineWidth,
	                            'fill': (series.fillGraph && series.color) || 'none' // Polygon series use filled graph
	                        };
	
	                        if (prop[3]) {
	                            attribs.dashstyle = prop[3];
	                        } else if (options.linecap !== 'square') {
	                            attribs['stroke-linecap'] = attribs['stroke-linejoin'] = 'round';
	                        }
	
	                        graph = series[graphKey]
	                            .attr(attribs)
	                            .shadow((i < 2) && options.shadow); // add shadow to normal series (0) or to first zone (1) #3932
	
	                    }
	
	                    // Helpers for animation
	                    if (graph) {
	                        graph.startX = graphPath.xMap;
	                        //graph.shiftUnit = options.step ? 2 : 1;
	                        graph.isArea = graphPath.isArea; // For arearange animation
	                    }
	                });
	            },
	
	            /**
	             * Clip the graphs into the positive and negative coloured graphs
	             */
	            applyZones: function() {
	                var series = this,
	                    chart = this.chart,
	                    renderer = chart.renderer,
	                    zones = this.zones,
	                    translatedFrom,
	                    translatedTo,
	                    clips = this.clips || [],
	                    clipAttr,
	                    graph = this.graph,
	                    area = this.area,
	                    chartSizeMax = Math.max(chart.chartWidth, chart.chartHeight),
	                    axis = this[(this.zoneAxis || 'y') + 'Axis'],
	                    extremes,
	                    reversed,
	                    inverted = chart.inverted,
	                    horiz,
	                    pxRange,
	                    pxPosMin,
	                    pxPosMax,
	                    ignoreZones = false;
	
	                if (zones.length && (graph || area) && axis && axis.min !== undefined) {
	                    reversed = axis.reversed;
	                    horiz = axis.horiz;
	                    // The use of the Color Threshold assumes there are no gaps
	                    // so it is safe to hide the original graph and area
	                    if (graph) {
	                        graph.hide();
	                    }
	                    if (area) {
	                        area.hide();
	                    }
	
	                    // Create the clips
	                    extremes = axis.getExtremes();
	                    each(zones, function(threshold, i) {
	
	                        translatedFrom = reversed ?
	                            (horiz ? chart.plotWidth : 0) :
	                            (horiz ? 0 : axis.toPixels(extremes.min));
	                        translatedFrom = Math.min(Math.max(pick(translatedTo, translatedFrom), 0), chartSizeMax);
	                        translatedTo = Math.min(Math.max(Math.round(axis.toPixels(pick(threshold.value, extremes.max), true)), 0), chartSizeMax);
	
	                        if (ignoreZones) {
	                            translatedFrom = translatedTo = axis.toPixels(extremes.max);
	                        }
	
	                        pxRange = Math.abs(translatedFrom - translatedTo);
	                        pxPosMin = Math.min(translatedFrom, translatedTo);
	                        pxPosMax = Math.max(translatedFrom, translatedTo);
	                        if (axis.isXAxis) {
	                            clipAttr = {
	                                x: inverted ? pxPosMax : pxPosMin,
	                                y: 0,
	                                width: pxRange,
	                                height: chartSizeMax
	                            };
	                            if (!horiz) {
	                                clipAttr.x = chart.plotHeight - clipAttr.x;
	                            }
	                        } else {
	                            clipAttr = {
	                                x: 0,
	                                y: inverted ? pxPosMax : pxPosMin,
	                                width: chartSizeMax,
	                                height: pxRange
	                            };
	                            if (horiz) {
	                                clipAttr.y = chart.plotWidth - clipAttr.y;
	                            }
	                        }
	
	
	                        /// VML SUPPPORT
	                        if (inverted && renderer.isVML) {
	                            if (axis.isXAxis) {
	                                clipAttr = {
	                                    x: 0,
	                                    y: reversed ? pxPosMin : pxPosMax,
	                                    height: clipAttr.width,
	                                    width: chart.chartWidth
	                                };
	                            } else {
	                                clipAttr = {
	                                    x: clipAttr.y - chart.plotLeft - chart.spacingBox.x,
	                                    y: 0,
	                                    width: clipAttr.height,
	                                    height: chart.chartHeight
	                                };
	                            }
	                        }
	                        /// END OF VML SUPPORT
	
	
	                        if (clips[i]) {
	                            clips[i].animate(clipAttr);
	                        } else {
	                            clips[i] = renderer.clipRect(clipAttr);
	
	                            if (graph) {
	                                series['zone-graph-' + i].clip(clips[i]);
	                            }
	
	                            if (area) {
	                                series['zone-area-' + i].clip(clips[i]);
	                            }
	                        }
	                        // if this zone extends out of the axis, ignore the others
	                        ignoreZones = threshold.value > extremes.max;
	                    });
	                    this.clips = clips;
	                }
	            },
	
	            /**
	             * Initialize and perform group inversion on series.group and series.markerGroup
	             */
	            invertGroups: function(inverted) {
	                var series = this,
	                    chart = series.chart,
	                    remover;
	
	                function setInvert() {
	                    each(['group', 'markerGroup'], function(groupName) {
	                        if (series[groupName]) {
	
	                            // VML/HTML needs explicit attributes for flipping
	                            if (chart.renderer.isVML) {
	                                series[groupName].attr({
	                                    width: series.yAxis.len,
	                                    height: series.xAxis.len
	                                });
	                            }
	
	                            series[groupName].width = series.yAxis.len;
	                            series[groupName].height = series.xAxis.len;
	                            series[groupName].invert(inverted);
	                        }
	                    });
	                }
	
	                // Pie, go away (#1736)
	                if (!series.xAxis) {
	                    return;
	                }
	
	                // A fixed size is needed for inversion to work
	                remover = addEvent(chart, 'resize', setInvert);
	                addEvent(series, 'destroy', remover);
	
	                // Do it now
	                setInvert(inverted); // do it now
	
	                // On subsequent render and redraw, just do setInvert without setting up events again
	                series.invertGroups = setInvert;
	            },
	
	            /**
	             * General abstraction for creating plot groups like series.group,
	             * series.dataLabelsGroup and series.markerGroup. On subsequent calls, the
	             * group will only be adjusted to the updated plot size.
	             */
	            plotGroup: function(prop, name, visibility, zIndex, parent) {
	                var group = this[prop],
	                    isNew = !group;
	
	                // Generate it on first call
	                if (isNew) {
	                    this[prop] = group = this.chart.renderer.g()
	                        .attr({
	                            zIndex: zIndex || 0.1 // IE8 and pointer logic use this
	                        })
	                        .add(parent);
	
	                }
	
	                // Add the class names, and replace existing ones as response to
	                // Series.update (#6660)
	                group.addClass(
	                    (
	                        'highcharts-' + name +
	                        ' highcharts-series-' + this.index +
	                        ' highcharts-' + this.type + '-series ' +
	                        'highcharts-color-' + this.colorIndex + ' ' +
	                        (this.options.className || '')
	                    ),
	                    true
	                );
	
	                // Place it on first and subsequent (redraw) calls
	                group.attr({
	                    visibility: visibility
	                })[isNew ? 'attr' : 'animate'](
	                    this.getPlotBox()
	                );
	                return group;
	            },
	
	            /**
	             * Get the translation and scale for the plot area of this series
	             */
	            getPlotBox: function() {
	                var chart = this.chart,
	                    xAxis = this.xAxis,
	                    yAxis = this.yAxis;
	
	                // Swap axes for inverted (#2339)
	                if (chart.inverted) {
	                    xAxis = yAxis;
	                    yAxis = this.xAxis;
	                }
	                return {
	                    translateX: xAxis ? xAxis.left : chart.plotLeft,
	                    translateY: yAxis ? yAxis.top : chart.plotTop,
	                    scaleX: 1, // #1623
	                    scaleY: 1
	                };
	            },
	
	            /**
	             * Render the graph and markers
	             */
	            render: function() {
	                var series = this,
	                    chart = series.chart,
	                    group,
	                    options = series.options,
	                    // Animation doesn't work in IE8 quirks when the group div is
	                    // hidden, and looks bad in other oldIE
	                    animDuration = (!!series.animate &&
	                        chart.renderer.isSVG &&
	                        animObject(options.animation).duration
	                    ),
	                    visibility = series.visible ? 'inherit' : 'hidden', // #2597
	                    zIndex = options.zIndex,
	                    hasRendered = series.hasRendered,
	                    chartSeriesGroup = chart.seriesGroup,
	                    inverted = chart.inverted;
	
	                // the group
	                group = series.plotGroup(
	                    'group',
	                    'series',
	                    visibility,
	                    zIndex,
	                    chartSeriesGroup
	                );
	
	                series.markerGroup = series.plotGroup(
	                    'markerGroup',
	                    'markers',
	                    visibility,
	                    zIndex,
	                    chartSeriesGroup
	                );
	
	                // initiate the animation
	                if (animDuration) {
	                    series.animate(true);
	                }
	
	                // SVGRenderer needs to know this before drawing elements (#1089, #1795)
	                group.inverted = series.isCartesian ? inverted : false;
	
	                // draw the graph if any
	                if (series.drawGraph) {
	                    series.drawGraph();
	                    series.applyZones();
	                }
	
	                /*		each(series.points, function (point) {
	                			if (point.redraw) {
	                				point.redraw();
	                			}
	                		});*/
	
	                // draw the data labels (inn pies they go before the points)
	                if (series.drawDataLabels) {
	                    series.drawDataLabels();
	                }
	
	                // draw the points
	                if (series.visible) {
	                    series.drawPoints();
	                }
	
	
	                // draw the mouse tracking area
	                if (
	                    series.drawTracker &&
	                    series.options.enableMouseTracking !== false
	                ) {
	                    series.drawTracker();
	                }
	
	                // Handle inverted series and tracker groups
	                series.invertGroups(inverted);
	
	                // Initial clipping, must be defined after inverting groups for VML.
	                // Applies to columns etc. (#3839).
	                if (options.clip !== false && !series.sharedClipKey && !hasRendered) {
	                    group.clip(chart.clipRect);
	                }
	
	                // Run the animation
	                if (animDuration) {
	                    series.animate();
	                }
	
	                // Call the afterAnimate function on animation complete (but don't
	                // overwrite the animation.complete option which should be available to
	                // the user).
	                if (!hasRendered) {
	                    series.animationTimeout = syncTimeout(function() {
	                        series.afterAnimate();
	                    }, animDuration);
	                }
	
	                series.isDirty = false; // means data is in accordance with what you see
	                // (See #322) series.isDirty = series.isDirtyData = false; // means
	                // data is in accordance with what you see
	                series.hasRendered = true;
	            },
	
	            /**
	             * Redraw the series after an update in the axes.
	             */
	            redraw: function() {
	                var series = this,
	                    chart = series.chart,
	                    // cache it here as it is set to false in render, but used after
	                    wasDirty = series.isDirty || series.isDirtyData,
	                    group = series.group,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis;
	
	                // reposition on resize
	                if (group) {
	                    if (chart.inverted) {
	                        group.attr({
	                            width: chart.plotWidth,
	                            height: chart.plotHeight
	                        });
	                    }
	
	                    group.animate({
	                        translateX: pick(xAxis && xAxis.left, chart.plotLeft),
	                        translateY: pick(yAxis && yAxis.top, chart.plotTop)
	                    });
	                }
	
	                series.translate();
	                series.render();
	                if (wasDirty) { // #3868, #3945
	                    delete this.kdTree;
	                }
	            },
	
	            /**
	             * KD Tree && PointSearching Implementation
	             */
	
	            kdAxisArray: ['clientX', 'plotY'],
	
	            searchPoint: function(e, compareX) {
	                var series = this,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis,
	                    inverted = series.chart.inverted;
	
	                return this.searchKDTree({
	                    clientX: inverted ?
	                        xAxis.len - e.chartY + xAxis.pos : e.chartX - xAxis.pos,
	                    plotY: inverted ?
	                        yAxis.len - e.chartX + yAxis.pos : e.chartY - yAxis.pos
	                }, compareX);
	            },
	
	            /**
	             * Build the k-d-tree that is used by mouse and touch interaction to get the
	             * closest point. Line-like series typically have a one-dimensional tree 
	             * where points are searched along the X axis, while scatter-like series
	             * typically search in two dimensions, X and Y.
	             */
	            buildKDTree: function() {
	
	                // Prevent multiple k-d-trees from being built simultaneously (#6235)
	                this.buildingKdTree = true;
	
	                var series = this,
	                    dimensions = series.options.findNearestPointBy.indexOf('y') > -1 ?
	                    2 : 1;
	
	                // Internal function
	                function _kdtree(points, depth, dimensions) {
	                    var axis,
	                        median,
	                        length = points && points.length;
	
	                    if (length) {
	
	                        // alternate between the axis
	                        axis = series.kdAxisArray[depth % dimensions];
	
	                        // sort point array
	                        points.sort(function(a, b) {
	                            return a[axis] - b[axis];
	                        });
	
	                        median = Math.floor(length / 2);
	
	                        // build and return nod
	                        return {
	                            point: points[median],
	                            left: _kdtree(
	                                points.slice(0, median), depth + 1, dimensions
	                            ),
	                            right: _kdtree(
	                                points.slice(median + 1), depth + 1, dimensions
	                            )
	                        };
	
	                    }
	                }
	
	                // Start the recursive build process with a clone of the points array
	                // and null points filtered out (#3873)
	                function startRecursive() {
	                    series.kdTree = _kdtree(
	                        series.getValidPoints(
	                            null,
	                            // For line-type series restrict to plot area, but
	                            // column-type series not (#3916, #4511)
	                            !series.directTouch
	                        ),
	                        dimensions,
	                        dimensions
	                    );
	                    series.buildingKdTree = false;
	                }
	                delete series.kdTree;
	
	                // For testing tooltips, don't build async
	                syncTimeout(startRecursive, series.options.kdNow ? 0 : 1);
	            },
	
	            searchKDTree: function(point, compareX) {
	                var series = this,
	                    kdX = this.kdAxisArray[0],
	                    kdY = this.kdAxisArray[1],
	                    kdComparer = compareX ? 'distX' : 'dist',
	                    kdDimensions = series.options.findNearestPointBy.indexOf('y') > -1 ?
	                    2 : 1;
	
	                // Set the one and two dimensional distance on the point object
	                function setDistance(p1, p2) {
	                    var x = (defined(p1[kdX]) && defined(p2[kdX])) ?
	                        Math.pow(p1[kdX] - p2[kdX], 2) :
	                        null,
	                        y = (defined(p1[kdY]) && defined(p2[kdY])) ?
	                        Math.pow(p1[kdY] - p2[kdY], 2) :
	                        null,
	                        r = (x || 0) + (y || 0);
	
	                    p2.dist = defined(r) ? Math.sqrt(r) : Number.MAX_VALUE;
	                    p2.distX = defined(x) ? Math.sqrt(x) : Number.MAX_VALUE;
	                }
	
	                function _search(search, tree, depth, dimensions) {
	                    var point = tree.point,
	                        axis = series.kdAxisArray[depth % dimensions],
	                        tdist,
	                        sideA,
	                        sideB,
	                        ret = point,
	                        nPoint1,
	                        nPoint2;
	
	                    setDistance(search, point);
	
	                    // Pick side based on distance to splitting point
	                    tdist = search[axis] - point[axis];
	                    sideA = tdist < 0 ? 'left' : 'right';
	                    sideB = tdist < 0 ? 'right' : 'left';
	
	                    // End of tree
	                    if (tree[sideA]) {
	                        nPoint1 = _search(search, tree[sideA], depth + 1, dimensions);
	
	                        ret = (nPoint1[kdComparer] < ret[kdComparer] ? nPoint1 : point);
	                    }
	                    if (tree[sideB]) {
	                        // compare distance to current best to splitting point to decide
	                        // wether to check side B or not
	                        if (Math.sqrt(tdist * tdist) < ret[kdComparer]) {
	                            nPoint2 = _search(
	                                search,
	                                tree[sideB],
	                                depth + 1,
	                                dimensions
	                            );
	                            ret = nPoint2[kdComparer] < ret[kdComparer] ?
	                                nPoint2 :
	                                ret;
	                        }
	                    }
	
	                    return ret;
	                }
	
	                if (!this.kdTree && !this.buildingKdTree) {
	                    this.buildKDTree();
	                }
	
	                if (this.kdTree) {
	                    return _search(point, this.kdTree, kdDimensions, kdDimensions);
	                }
	            }
	
	        }); // end Series prototype
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Axis = H.Axis,
	            Chart = H.Chart,
	            correctFloat = H.correctFloat,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            format = H.format,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            Series = H.Series;
	
	        /**
	         * The class for stacks. Each stack, on a specific X value and either negative
	         * or positive, has its own stack item.
	         *
	         * @class
	         */
	        function StackItem(axis, options, isNegative, x, stackOption) {
	
	            var inverted = axis.chart.inverted;
	
	            this.axis = axis;
	
	            // Tells if the stack is negative
	            this.isNegative = isNegative;
	
	            // Save the options to be able to style the label
	            this.options = options;
	
	            // Save the x value to be able to position the label later
	            this.x = x;
	
	            // Initialize total value
	            this.total = null;
	
	            // This will keep each points' extremes stored by series.index and point 
	            // index
	            this.points = {};
	
	            // Save the stack option on the series configuration object, and whether to 
	            // treat it as percent
	            this.stack = stackOption;
	            this.leftCliff = 0;
	            this.rightCliff = 0;
	
	            // The align options and text align varies on whether the stack is negative 
	            // and if the chart is inverted or not.
	            // First test the user supplied value, then use the dynamic.
	            this.alignOptions = {
	                align: options.align ||
	                    (inverted ? (isNegative ? 'left' : 'right') : 'center'),
	                verticalAlign: options.verticalAlign ||
	                    (inverted ? 'middle' : (isNegative ? 'bottom' : 'top')),
	                y: pick(options.y, inverted ? 4 : (isNegative ? 14 : -6)),
	                x: pick(options.x, inverted ? (isNegative ? -6 : 6) : 0)
	            };
	
	            this.textAlign = options.textAlign ||
	                (inverted ? (isNegative ? 'right' : 'left') : 'center');
	        }
	
	        StackItem.prototype = {
	            destroy: function() {
	                destroyObjectProperties(this, this.axis);
	            },
	
	            /**
	             * Renders the stack total label and adds it to the stack label group.
	             */
	            render: function(group) {
	                var options = this.options,
	                    formatOption = options.format,
	                    str = formatOption ?
	                    format(formatOption, this) :
	                    options.formatter.call(this); // format the text in the label
	
	                // Change the text to reflect the new total and set visibility to hidden
	                // in case the serie is hidden
	                if (this.label) {
	                    this.label.attr({
	                        text: str,
	                        visibility: 'hidden'
	                    });
	                    // Create new label
	                } else {
	                    this.label =
	                        this.axis.chart.renderer.text(str, null, null, options.useHTML)
	                        .css(options.style)
	                        .attr({
	                            align: this.textAlign,
	                            rotation: options.rotation,
	                            visibility: 'hidden' // hidden until setOffset is called
	                        })
	                        .add(group); // add to the labels-group
	                }
	            },
	
	            /**
	             * Sets the offset that the stack has from the x value and repositions the
	             * label.
	             */
	            setOffset: function(xOffset, xWidth) {
	                var stackItem = this,
	                    axis = stackItem.axis,
	                    chart = axis.chart,
	                    inverted = chart.inverted,
	                    reversed = axis.reversed,
	                    neg = (this.isNegative && !reversed) ||
	                    (!this.isNegative && reversed), // #4056
	                    // stack value translated mapped to chart coordinates
	                    y = axis.translate(
	                        axis.usePercentage ? 100 : this.total,
	                        0,
	                        0,
	                        0,
	                        1
	                    ),
	                    yZero = axis.translate(0), // stack origin
	                    h = Math.abs(y - yZero), // stack height
	                    x = chart.xAxis[0].translate(this.x) + xOffset, // stack x position
	                    plotHeight = chart.plotHeight,
	                    stackBox = { // this is the box for the complete stack
	                        x: inverted ? (neg ? y : y - h) : x,
	                        y: inverted ?
	                            plotHeight - x - xWidth : (neg ? (plotHeight - y - h) :
	                                plotHeight - y),
	                        width: inverted ? h : xWidth,
	                        height: inverted ? xWidth : h
	                    },
	                    label = this.label,
	                    alignAttr;
	
	                if (label) {
	                    // Align the label to the box
	                    label.align(this.alignOptions, null, stackBox);
	
	                    // Set visibility (#678)
	                    alignAttr = label.alignAttr;
	                    label[
	                        this.options.crop === false || chart.isInsidePlot(
	                            alignAttr.x,
	                            alignAttr.y
	                        ) ? 'show' : 'hide'](true);
	                }
	            }
	        };
	
	        /**
	         * Generate stacks for each series and calculate stacks total values
	         */
	        Chart.prototype.getStacks = function() {
	            var chart = this;
	
	            // reset stacks for each yAxis
	            each(chart.yAxis, function(axis) {
	                if (axis.stacks && axis.hasVisibleSeries) {
	                    axis.oldStacks = axis.stacks;
	                }
	            });
	
	            each(chart.series, function(series) {
	                if (series.options.stacking && (series.visible === true ||
	                        chart.options.chart.ignoreHiddenSeries === false)) {
	                    series.stackKey = series.type + pick(series.options.stack, '');
	                }
	            });
	        };
	
	
	        // Stacking methods defined on the Axis prototype
	
	        /**
	         * Build the stacks from top down
	         */
	        Axis.prototype.buildStacks = function() {
	            var axisSeries = this.series,
	                series,
	                reversedStacks = pick(this.options.reversedStacks, true),
	                len = axisSeries.length,
	                i;
	            if (!this.isXAxis) {
	                this.usePercentage = false;
	                i = len;
	                while (i--) {
	                    axisSeries[reversedStacks ? i : len - i - 1].setStackedPoints();
	                }
	
	                i = len;
	                while (i--) {
	                    series = axisSeries[reversedStacks ? i : len - i - 1];
	                    if (series.setStackCliffs) {
	                        series.setStackCliffs();
	                    }
	                }
	                // Loop up again to compute percent stack
	                if (this.usePercentage) {
	                    for (i = 0; i < len; i++) {
	                        axisSeries[i].setPercentStacks();
	                    }
	                }
	            }
	        };
	
	        Axis.prototype.renderStackTotals = function() {
	            var axis = this,
	                chart = axis.chart,
	                renderer = chart.renderer,
	                stacks = axis.stacks,
	                stackTotalGroup = axis.stackTotalGroup;
	
	            // Create a separate group for the stack total labels
	            if (!stackTotalGroup) {
	                axis.stackTotalGroup = stackTotalGroup =
	                    renderer.g('stack-labels')
	                    .attr({
	                        visibility: 'visible',
	                        zIndex: 6
	                    })
	                    .add();
	            }
	
	            // plotLeft/Top will change when y axis gets wider so we need to translate
	            // the stackTotalGroup at every render call. See bug #506 and #516
	            stackTotalGroup.translate(chart.plotLeft, chart.plotTop);
	
	            // Render each stack total
	            objectEach(stacks, function(type) {
	                objectEach(type, function(stack) {
	                    stack.render(stackTotalGroup);
	                });
	            });
	        };
	
	        /**
	         * Set all the stacks to initial states and destroy unused ones.
	         */
	        Axis.prototype.resetStacks = function() {
	            var axis = this,
	                stacks = axis.stacks;
	            if (!axis.isXAxis) {
	                objectEach(stacks, function(type) {
	                    objectEach(type, function(stack, key) {
	                        // Clean up memory after point deletion (#1044, #4320)
	                        if (stack.touched < axis.stacksTouched) {
	                            stack.destroy();
	                            delete type[key];
	
	                            // Reset stacks
	                        } else {
	                            stack.total = null;
	                            stack.cum = null;
	                        }
	                    });
	                });
	            }
	        };
	
	        Axis.prototype.cleanStacks = function() {
	            var stacks;
	
	            if (!this.isXAxis) {
	                if (this.oldStacks) {
	                    stacks = this.stacks = this.oldStacks;
	                }
	
	                // reset stacks
	                objectEach(stacks, function(type) {
	                    objectEach(type, function(stack) {
	                        stack.cum = stack.total;
	                    });
	                });
	            }
	        };
	
	
	        // Stacking methods defnied for Series prototype
	
	        /**
	         * Adds series' points value to corresponding stack
	         */
	        Series.prototype.setStackedPoints = function() {
	            if (!this.options.stacking || (this.visible !== true &&
	                    this.chart.options.chart.ignoreHiddenSeries !== false)) {
	                return;
	            }
	
	            var series = this,
	                xData = series.processedXData,
	                yData = series.processedYData,
	                stackedYData = [],
	                yDataLength = yData.length,
	                seriesOptions = series.options,
	                threshold = seriesOptions.threshold,
	                stackThreshold = seriesOptions.startFromThreshold ? threshold : 0,
	                stackOption = seriesOptions.stack,
	                stacking = seriesOptions.stacking,
	                stackKey = series.stackKey,
	                negKey = '-' + stackKey,
	                negStacks = series.negStacks,
	                yAxis = series.yAxis,
	                stacks = yAxis.stacks,
	                oldStacks = yAxis.oldStacks,
	                stackIndicator,
	                isNegative,
	                stack,
	                other,
	                key,
	                pointKey,
	                i,
	                x,
	                y;
	
	
	            yAxis.stacksTouched += 1;
	
	            // loop over the non-null y values and read them into a local array
	            for (i = 0; i < yDataLength; i++) {
	                x = xData[i];
	                y = yData[i];
	                stackIndicator = series.getStackIndicator(
	                    stackIndicator,
	                    x,
	                    series.index
	                );
	                pointKey = stackIndicator.key;
	                // Read stacked values into a stack based on the x value,
	                // the sign of y and the stack key. Stacking is also handled for null
	                // values (#739)
	                isNegative = negStacks && y < (stackThreshold ? 0 : threshold);
	                key = isNegative ? negKey : stackKey;
	
	                // Create empty object for this stack if it doesn't exist yet
	                if (!stacks[key]) {
	                    stacks[key] = {};
	                }
	
	                // Initialize StackItem for this x
	                if (!stacks[key][x]) {
	                    if (oldStacks[key] && oldStacks[key][x]) {
	                        stacks[key][x] = oldStacks[key][x];
	                        stacks[key][x].total = null;
	                    } else {
	                        stacks[key][x] = new StackItem(
	                            yAxis,
	                            yAxis.options.stackLabels,
	                            isNegative,
	                            x,
	                            stackOption
	                        );
	                    }
	                }
	
	                // If the StackItem doesn't exist, create it first
	                stack = stacks[key][x];
	                if (y !== null) {
	                    stack.points[pointKey] = stack.points[series.index] = [pick(stack.cum, stackThreshold)];
	
	                    // Record the base of the stack
	                    if (!defined(stack.cum)) {
	                        stack.base = pointKey;
	                    }
	                    stack.touched = yAxis.stacksTouched;
	
	
	                    // In area charts, if there are multiple points on the same X value,
	                    // let the area fill the full span of those points
	                    if (stackIndicator.index > 0 && series.singleStacks === false) {
	                        stack.points[pointKey][0] =
	                            stack.points[series.index + ',' + x + ',0'][0];
	                    }
	                }
	
	                // Add value to the stack total
	                if (stacking === 'percent') {
	
	                    // Percent stacked column, totals are the same for the positive and
	                    // negative stacks
	                    other = isNegative ? stackKey : negKey;
	                    if (negStacks && stacks[other] && stacks[other][x]) {
	                        other = stacks[other][x];
	                        stack.total = other.total =
	                            Math.max(other.total, stack.total) + Math.abs(y) || 0;
	
	                        // Percent stacked areas
	                    } else {
	                        stack.total = correctFloat(stack.total + (Math.abs(y) || 0));
	                    }
	                } else {
	                    stack.total = correctFloat(stack.total + (y || 0));
	                }
	
	                stack.cum = pick(stack.cum, stackThreshold) + (y || 0);
	
	                if (y !== null) {
	                    stack.points[pointKey].push(stack.cum);
	                    stackedYData[i] = stack.cum;
	                }
	
	            }
	
	            if (stacking === 'percent') {
	                yAxis.usePercentage = true;
	            }
	
	            this.stackedYData = stackedYData; // To be used in getExtremes
	
	            // Reset old stacks
	            yAxis.oldStacks = {};
	        };
	
	        /**
	         * Iterate over all stacks and compute the absolute values to percent
	         */
	        Series.prototype.setPercentStacks = function() {
	            var series = this,
	                stackKey = series.stackKey,
	                stacks = series.yAxis.stacks,
	                processedXData = series.processedXData,
	                stackIndicator;
	
	            each([stackKey, '-' + stackKey], function(key) {
	                var i = processedXData.length,
	                    x,
	                    stack,
	                    pointExtremes,
	                    totalFactor;
	
	                while (i--) {
	                    x = processedXData[i];
	                    stackIndicator = series.getStackIndicator(
	                        stackIndicator,
	                        x,
	                        series.index,
	                        key
	                    );
	                    stack = stacks[key] && stacks[key][x];
	                    pointExtremes = stack && stack.points[stackIndicator.key];
	                    if (pointExtremes) {
	                        totalFactor = stack.total ? 100 / stack.total : 0;
	                        // Y bottom value
	                        pointExtremes[0] = correctFloat(pointExtremes[0] * totalFactor);
	                        // Y value
	                        pointExtremes[1] = correctFloat(pointExtremes[1] * totalFactor);
	                        series.stackedYData[i] = pointExtremes[1];
	                    }
	                }
	            });
	        };
	
	        /**
	         * Get stack indicator, according to it's x-value, to determine points with the
	         * same x-value
	         */
	        Series.prototype.getStackIndicator = function(stackIndicator, x, index, key) {
	            // Update stack indicator, when:
	            // first point in a stack || x changed || stack type (negative vs positive)
	            // changed:
	            if (!defined(stackIndicator) || stackIndicator.x !== x ||
	                (key && stackIndicator.key !== key)) {
	                stackIndicator = {
	                    x: x,
	                    index: 0,
	                    key: key
	                };
	            } else {
	                stackIndicator.index++;
	            }
	
	            stackIndicator.key = [index, x, stackIndicator.index].join(',');
	
	            return stackIndicator;
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            animate = H.animate,
	            Axis = H.Axis,
	            Chart = H.Chart,
	            createElement = H.createElement,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            erase = H.erase,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            inArray = H.inArray,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            isArray = H.isArray,
	            merge = H.merge,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            setAnimation = H.setAnimation,
	            splat = H.splat;
	
	        // Extend the Chart prototype for dynamic methods
	        extend(Chart.prototype, /** @lends Highcharts.Chart.prototype */ {
	
	            /**
	             * Add a series to the chart after render time. Note that this method should
	             * never be used when adding data synchronously at chart render time, as it
	             * adds expense to the calculations and rendering. When adding data at the
	             * same time as the chart is initiated, add the series as a configuration
	             * option instead. With multiple axes, the `offset` is dynamically adjusted.
	             *
	             * @param  {SeriesOptions} options
	             *         The config options for the series.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after adding.
	             * @param  {AnimationOptions} animation
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @return {Highcharts.Series}
	             *         The newly created series object.
	             *
	             * @sample highcharts/members/chart-addseries/
	             *         Add a series from a button
	             * @sample stock/members/chart-addseries/
	             *         Add a series in Highstock
	             */
	            addSeries: function(options, redraw, animation) {
	                var series,
	                    chart = this;
	
	                if (options) {
	                    redraw = pick(redraw, true); // defaults to true
	
	                    fireEvent(chart, 'addSeries', {
	                        options: options
	                    }, function() {
	                        series = chart.initSeries(options);
	
	                        chart.isDirtyLegend = true; // the series array is out of sync with the display
	                        chart.linkSeries();
	                        if (redraw) {
	                            chart.redraw(animation);
	                        }
	                    });
	                }
	
	                return series;
	            },
	
	            /**
	             * Add an axis to the chart after render time. Note that this method should
	             * never be used when adding data synchronously at chart render time, as it
	             * adds expense to the calculations and rendering. When adding data at the
	             * same time as the chart is initiated, add the axis as a configuration
	             * option instead.
	             * @param  {AxisOptions} options
	             *         The axis options.
	             * @param  {Boolean} [isX=false]
	             *         Whether it is an X axis or a value axis.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after adding.
	             * @param  {AnimationOptions} [animation=true]
	             *         Whether and how to apply animation in the redraw.
	             *
	             * @sample highcharts/members/chart-addaxis/ Add and remove axes
	             */
	            addAxis: function(options, isX, redraw, animation) {
	                var key = isX ? 'xAxis' : 'yAxis',
	                    chartOptions = this.options,
	                    userOptions = merge(options, {
	                        index: this[key].length,
	                        isX: isX
	                    });
	
	                new Axis(this, userOptions); // eslint-disable-line no-new
	
	                // Push the new axis options to the chart options
	                chartOptions[key] = splat(chartOptions[key] || {});
	                chartOptions[key].push(userOptions);
	
	                if (pick(redraw, true)) {
	                    this.redraw(animation);
	                }
	            },
	
	            /**
	             * Dim the chart and show a loading text or symbol. Options for the loading
	             * screen are defined in {@link
	             * https://api.highcharts.com/highcharts/loading|the loading options}.
	             * 
	             * @param  {String} str
	             *         An optional text to show in the loading label instead of the
	             *         default one. The default text is set in {@link
	             *         http://api.highcharts.com/highcharts/lang.loading|lang.loading}.
	             *
	             * @sample highcharts/members/chart-hideloading/
	             *         Show and hide loading from a button
	             * @sample highcharts/members/chart-showloading/
	             *         Apply different text labels
	             * @sample stock/members/chart-show-hide-loading/
	             *         Toggle loading in Highstock
	             */
	            showLoading: function(str) {
	                var chart = this,
	                    options = chart.options,
	                    loadingDiv = chart.loadingDiv,
	                    loadingOptions = options.loading,
	                    setLoadingSize = function() {
	                        if (loadingDiv) {
	                            css(loadingDiv, {
	                                left: chart.plotLeft + 'px',
	                                top: chart.plotTop + 'px',
	                                width: chart.plotWidth + 'px',
	                                height: chart.plotHeight + 'px'
	                            });
	                        }
	                    };
	
	                // create the layer at the first call
	                if (!loadingDiv) {
	                    chart.loadingDiv = loadingDiv = createElement('div', {
	                        className: 'highcharts-loading highcharts-loading-hidden'
	                    }, null, chart.container);
	
	                    chart.loadingSpan = createElement(
	                        'span', {
	                            className: 'highcharts-loading-inner'
	                        },
	                        null,
	                        loadingDiv
	                    );
	                    addEvent(chart, 'redraw', setLoadingSize); // #1080
	                }
	
	                loadingDiv.className = 'highcharts-loading';
	
	                // Update text
	                chart.loadingSpan.innerHTML = str || options.lang.loading;
	
	
	                // Update visuals
	                css(loadingDiv, extend(loadingOptions.style, {
	                    zIndex: 10
	                }));
	                css(chart.loadingSpan, loadingOptions.labelStyle);
	
	                // Show it
	                if (!chart.loadingShown) {
	                    css(loadingDiv, {
	                        opacity: 0,
	                        display: ''
	                    });
	                    animate(loadingDiv, {
	                        opacity: loadingOptions.style.opacity || 0.5
	                    }, {
	                        duration: loadingOptions.showDuration || 0
	                    });
	                }
	
	
	                chart.loadingShown = true;
	                setLoadingSize();
	            },
	
	            /**
	             * Hide the loading layer.
	             *
	             * @see    Highcharts.Chart#showLoading
	             * @sample highcharts/members/chart-hideloading/
	             *         Show and hide loading from a button
	             * @sample stock/members/chart-show-hide-loading/
	             *         Toggle loading in Highstock
	             */
	            hideLoading: function() {
	                var options = this.options,
	                    loadingDiv = this.loadingDiv;
	
	                if (loadingDiv) {
	                    loadingDiv.className = 'highcharts-loading highcharts-loading-hidden';
	
	                    animate(loadingDiv, {
	                        opacity: 0
	                    }, {
	                        duration: options.loading.hideDuration || 100,
	                        complete: function() {
	                            css(loadingDiv, {
	                                display: 'none'
	                            });
	                        }
	                    });
	
	                }
	                this.loadingShown = false;
	            },
	
	            /** 
	             * These properties cause isDirtyBox to be set to true when updating. Can be extended from plugins.
	             */
	            propsRequireDirtyBox: ['backgroundColor', 'borderColor', 'borderWidth', 'margin', 'marginTop', 'marginRight',
	                'marginBottom', 'marginLeft', 'spacing', 'spacingTop', 'spacingRight', 'spacingBottom', 'spacingLeft',
	                'borderRadius', 'plotBackgroundColor', 'plotBackgroundImage', 'plotBorderColor', 'plotBorderWidth',
	                'plotShadow', 'shadow'
	            ],
	
	            /** 
	             * These properties cause all series to be updated when updating. Can be
	             * extended from plugins.
	             */
	            propsRequireUpdateSeries: ['chart.inverted', 'chart.polar',
	                'chart.ignoreHiddenSeries', 'chart.type', 'colors', 'plotOptions',
	                'tooltip'
	            ],
	
	            /**
	             * A generic function to update any element of the chart. Elements can be
	             * enabled and disabled, moved, re-styled, re-formatted etc.
	             *
	             * A special case is configuration objects that take arrays, for example
	             * {@link https://api.highcharts.com/highcharts/xAxis|xAxis}, 
	             * {@link https://api.highcharts.com/highcharts/yAxis|yAxis} or 
	             * {@link https://api.highcharts.com/highcharts/series|series}. For these
	             * collections, an `id` option is used to map the new option set to an
	             * existing object. If an existing object of the same id is not found, the
	             * corresponding item is updated. So for example, running `chart.update`
	             * with a series item without an id, will cause the existing chart's series
	             * with the same index in the series array to be updated.
	             *
	             * See also the {@link https://api.highcharts.com/highcharts/responsive|
	             * responsive option set}. Switching between `responsive.rules` basically
	             * runs `chart.update` under the hood.
	             *
	             * @param  {Options} options
	             *         A configuration object for the new chart options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart.
	             *
	             * @sample highcharts/members/chart-update/
	             *         Update chart geometry 
	             */
	            update: function(options, redraw) {
	                var chart = this,
	                    adders = {
	                        credits: 'addCredits',
	                        title: 'setTitle',
	                        subtitle: 'setSubtitle'
	                    },
	                    optionsChart = options.chart,
	                    updateAllAxes,
	                    updateAllSeries,
	                    newWidth,
	                    newHeight;
	
	                // If the top-level chart option is present, some special updates are required		
	                if (optionsChart) {
	                    merge(true, chart.options.chart, optionsChart);
	
	                    // Setter function
	                    if ('className' in optionsChart) {
	                        chart.setClassName(optionsChart.className);
	                    }
	
	                    if ('inverted' in optionsChart || 'polar' in optionsChart) {
	                        // Parse options.chart.inverted and options.chart.polar together
	                        // with the available series.
	                        chart.propFromSeries();
	                        updateAllAxes = true;
	                    }
	
	                    if ('alignTicks' in optionsChart) { // #6452
	                        updateAllAxes = true;
	                    }
	
	                    objectEach(optionsChart, function(val, key) {
	                        if (inArray('chart.' + key, chart.propsRequireUpdateSeries) !== -1) {
	                            updateAllSeries = true;
	                        }
	                        // Only dirty box
	                        if (inArray(key, chart.propsRequireDirtyBox) !== -1) {
	                            chart.isDirtyBox = true;
	                        }
	                    });
	
	
	                    if ('style' in optionsChart) {
	                        chart.renderer.setStyle(optionsChart.style);
	                    }
	
	                }
	
	                // Moved up, because tooltip needs updated plotOptions (#6218)
	
	                if (options.colors) {
	                    this.options.colors = options.colors;
	                }
	
	
	                if (options.plotOptions) {
	                    merge(true, this.options.plotOptions, options.plotOptions);
	                }
	
	                // Some option stuctures correspond one-to-one to chart objects that
	                // have update methods, for example
	                // options.credits => chart.credits
	                // options.legend => chart.legend
	                // options.title => chart.title
	                // options.tooltip => chart.tooltip
	                // options.subtitle => chart.subtitle
	                // options.mapNavigation => chart.mapNavigation
	                // options.navigator => chart.navigator
	                // options.scrollbar => chart.scrollbar
	                objectEach(options, function(val, key) {
	                    if (chart[key] && typeof chart[key].update === 'function') {
	                        chart[key].update(val, false);
	
	                        // If a one-to-one object does not exist, look for an adder function
	                    } else if (typeof chart[adders[key]] === 'function') {
	                        chart[adders[key]](val);
	                    }
	
	                    if (
	                        key !== 'chart' &&
	                        inArray(key, chart.propsRequireUpdateSeries) !== -1
	                    ) {
	                        updateAllSeries = true;
	                    }
	                });
	
	                // Setters for collections. For axes and series, each item is referred
	                // by an id. If the id is not found, it defaults to the corresponding
	                // item in the collection, so setting one series without an id, will
	                // update the first series in the chart. Setting two series without
	                // an id will update the first and the second respectively (#6019)
	                // chart.update and responsive.
	                each([
	                    'xAxis',
	                    'yAxis',
	                    'zAxis',
	                    'series',
	                    'colorAxis',
	                    'pane'
	                ], function(coll) {
	                    if (options[coll]) {
	                        each(splat(options[coll]), function(newOptions, i) {
	                            var item = (
	                                defined(newOptions.id) &&
	                                chart.get(newOptions.id)
	                            ) || chart[coll][i];
	                            if (item && item.coll === coll) {
	                                item.update(newOptions, false);
	                            }
	                        });
	                    }
	                });
	
	                if (updateAllAxes) {
	                    each(chart.axes, function(axis) {
	                        axis.update({}, false);
	                    });
	                }
	
	                // Certain options require the whole series structure to be thrown away
	                // and rebuilt
	                if (updateAllSeries) {
	                    each(chart.series, function(series) {
	                        series.update({}, false);
	                    });
	                }
	
	                // For loading, just update the options, do not redraw
	                if (options.loading) {
	                    merge(true, chart.options.loading, options.loading);
	                }
	
	                // Update size. Redraw is forced.
	                newWidth = optionsChart && optionsChart.width;
	                newHeight = optionsChart && optionsChart.height;
	                if ((isNumber(newWidth) && newWidth !== chart.chartWidth) ||
	                    (isNumber(newHeight) && newHeight !== chart.chartHeight)) {
	                    chart.setSize(newWidth, newHeight);
	                } else if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Setter function to allow use from chart.update
	             */
	            setSubtitle: function(options) {
	                this.setTitle(undefined, options);
	            }
	
	
	        });
	
	        // extend the Point prototype for dynamic methods
	        extend(Point.prototype, /** @lends Highcharts.Point.prototype */ {
	            /**
	             * Update point with new options (typically x/y data) and optionally redraw
	             * the series.
	             *
	             * @param  {Object} options
	             *         The point options. Point options are handled as described under
	             *         the `series<type>.data` item for each series type. For example
	             *         for a line series, if options is a single number, the point will
	             *         be given that number as the main y value. If it is an array, it
	             *         will be interpreted as x and y values respectively. If it is an
	             *         object, advanced options are applied. 
	             * @param  {Boolean} [redraw=true]
	             *          Whether to redraw the chart after the point is updated. If doing
	             *          more operations on the chart, it is best practice to set
	             *          `redraw` to false and call `chart.redraw()` after.
	             * @param  {AnimationOptions} [animation=true]
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @sample highcharts/members/point-update-column/
	             *         Update column value
	             * @sample highcharts/members/point-update-pie/
	             *         Update pie slice
	             * @sample maps/members/point-update/
	             *         Update map area value in Highmaps
	             */
	            update: function(options, redraw, animation, runEvent) {
	                var point = this,
	                    series = point.series,
	                    graphic = point.graphic,
	                    i,
	                    chart = series.chart,
	                    seriesOptions = series.options;
	
	                redraw = pick(redraw, true);
	
	                function update() {
	
	                    point.applyOptions(options);
	
	                    // Update visuals
	                    if (point.y === null && graphic) { // #4146
	                        point.graphic = graphic.destroy();
	                    }
	                    if (isObject(options, true)) {
	                        // Destroy so we can get new elements
	                        if (graphic && graphic.element) {
	                            if (options && options.marker && options.marker.symbol) {
	                                point.graphic = graphic.destroy();
	                            }
	                        }
	                        if (options && options.dataLabels && point.dataLabel) { // #2468
	                            point.dataLabel = point.dataLabel.destroy();
	                        }
	                    }
	
	                    // record changes in the parallel arrays
	                    i = point.index;
	                    series.updateParallelArrays(point, i);
	
	                    // Record the options to options.data. If the old or the new config
	                    // is an object, use point options, otherwise use raw options
	                    // (#4701, #4916).
	                    seriesOptions.data[i] = (
	                            isObject(seriesOptions.data[i], true) ||
	                            isObject(options, true)
	                        ) ?
	                        point.options :
	                        options;
	
	                    // redraw
	                    series.isDirty = series.isDirtyData = true;
	                    if (!series.fixedBox && series.hasCartesianSeries) { // #1906, #2320
	                        chart.isDirtyBox = true;
	                    }
	
	                    if (seriesOptions.legendType === 'point') { // #1831, #1885
	                        chart.isDirtyLegend = true;
	                    }
	                    if (redraw) {
	                        chart.redraw(animation);
	                    }
	                }
	
	                // Fire the event with a default handler of doing the update
	                if (runEvent === false) { // When called from setData
	                    update();
	                } else {
	                    point.firePointEvent('update', {
	                        options: options
	                    }, update);
	                }
	            },
	
	            /**
	             * Remove a point and optionally redraw the series and if necessary the axes
	             * @param  {Boolean} redraw
	             *         Whether to redraw the chart or wait for an explicit call. When
	             *         doing more operations on the chart, for example running
	             *         `point.remove()` in a loop, it is best practice to set `redraw`
	             *         to false and call `chart.redraw()` after.         
	             * @param  {AnimationOptions} [animation=false]
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @sample highcharts/plotoptions/series-point-events-remove/
	             *         Remove point and confirm
	             * @sample highcharts/members/point-remove/
	             *         Remove pie slice
	             * @sample maps/members/point-remove/
	             *         Remove selected points in Highmaps
	             */
	            remove: function(redraw, animation) {
	                this.series.removePoint(inArray(this, this.series.data), redraw, animation);
	            }
	        });
	
	        // Extend the series prototype for dynamic methods
	        extend(Series.prototype, /** @lends Series.prototype */ {
	            /**
	             * Add a point to the series after render time. The point can be added at
	             * the end, or by giving it an X value, to the start or in the middle of the
	             * series.
	             * 
	             * @param  {Number|Array|Object} options
	             *         The point options. If options is a single number, a point with
	             *         that y value is appended to the series.If it is an array, it will
	             *         be interpreted as x and y values respectively. If it is an
	             *         object, advanced options as outlined under `series.data` are
	             *         applied.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the point is added. When adding
	             *         more than one point, it is highly recommended that the redraw
	             *         option be set to false, and instead {@link Chart#redraw}
	             *         is explicitly called after the adding of points is finished.
	             *         Otherwise, the chart will redraw after adding each point.
	             * @param  {Boolean} [shift=false]
	             *         If true, a point is shifted off the start of the series as one is
	             *         appended to the end.
	             * @param  {AnimationOptions} [animation]
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @sample highcharts/members/series-addpoint-append/
	             *         Append point
	             * @sample highcharts/members/series-addpoint-append-and-shift/
	             *         Append and shift
	             * @sample highcharts/members/series-addpoint-x-and-y/
	             *         Both X and Y values given
	             * @sample highcharts/members/series-addpoint-pie/
	             *         Append pie slice
	             * @sample stock/members/series-addpoint/
	             *         Append 100 points in Highstock
	             * @sample stock/members/series-addpoint-shift/
	             *         Append and shift in Highstock
	             * @sample maps/members/series-addpoint/
	             *         Add a point in Highmaps
	             */
	            addPoint: function(options, redraw, shift, animation) {
	                var series = this,
	                    seriesOptions = series.options,
	                    data = series.data,
	                    chart = series.chart,
	                    xAxis = series.xAxis,
	                    names = xAxis && xAxis.hasNames && xAxis.names,
	                    dataOptions = seriesOptions.data,
	                    point,
	                    isInTheMiddle,
	                    xData = series.xData,
	                    i,
	                    x;
	
	                // Optional redraw, defaults to true
	                redraw = pick(redraw, true);
	
	                // Get options and push the point to xData, yData and series.options. In series.generatePoints
	                // the Point instance will be created on demand and pushed to the series.data array.
	                point = {
	                    series: series
	                };
	                series.pointClass.prototype.applyOptions.apply(point, [options]);
	                x = point.x;
	
	                // Get the insertion point
	                i = xData.length;
	                if (series.requireSorting && x < xData[i - 1]) {
	                    isInTheMiddle = true;
	                    while (i && xData[i - 1] > x) {
	                        i--;
	                    }
	                }
	
	                series.updateParallelArrays(point, 'splice', i, 0, 0); // insert undefined item
	                series.updateParallelArrays(point, i); // update it
	
	                if (names && point.name) {
	                    names[x] = point.name;
	                }
	                dataOptions.splice(i, 0, options);
	
	                if (isInTheMiddle) {
	                    series.data.splice(i, 0, null);
	                    series.processData();
	                }
	
	                // Generate points to be added to the legend (#1329)
	                if (seriesOptions.legendType === 'point') {
	                    series.generatePoints();
	                }
	
	                // Shift the first point off the parallel arrays
	                if (shift) {
	                    if (data[0] && data[0].remove) {
	                        data[0].remove(false);
	                    } else {
	                        data.shift();
	                        series.updateParallelArrays(point, 'shift');
	
	                        dataOptions.shift();
	                    }
	                }
	
	                // redraw
	                series.isDirty = true;
	                series.isDirtyData = true;
	
	                if (redraw) {
	                    chart.redraw(animation); // Animation is set anyway on redraw, #5665
	                }
	            },
	
	            /**
	             * Remove a point from the series. Unlike the {@link Highcharts.Point#remove}
	             * method, this can also be done on a point that is not instanciated because
	             * it is outside the view or subject to Highstock data grouping.
	             *
	             * @param  {Number} i
	             *         The index of the point in the {@link Highcharts.Series.data|data}
	             *         array.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the point is added. When 
	             *         removing more than one point, it is highly recommended that the
	             *         `redraw` option be set to `false`, and instead {@link
	             *         Highcharts.Chart#redraw} is explicitly called after the adding of
	             *         points is finished.
	             * @param  {AnimationOptions} [animation]
	             *         Whether and optionally how the series should be animated.
	             *
	             * @sample highcharts/members/series-removepoint/
	             *         Remove cropped point
	             */
	            removePoint: function(i, redraw, animation) {
	
	                var series = this,
	                    data = series.data,
	                    point = data[i],
	                    points = series.points,
	                    chart = series.chart,
	                    remove = function() {
	
	                        if (points && points.length === data.length) { // #4935
	                            points.splice(i, 1);
	                        }
	                        data.splice(i, 1);
	                        series.options.data.splice(i, 1);
	                        series.updateParallelArrays(point || {
	                            series: series
	                        }, 'splice', i, 1);
	
	                        if (point) {
	                            point.destroy();
	                        }
	
	                        // redraw
	                        series.isDirty = true;
	                        series.isDirtyData = true;
	                        if (redraw) {
	                            chart.redraw();
	                        }
	                    };
	
	                setAnimation(animation, chart);
	                redraw = pick(redraw, true);
	
	                // Fire the event with a default handler of removing the point
	                if (point) {
	                    point.firePointEvent('remove', null, remove);
	                } else {
	                    remove();
	                }
	            },
	
	            /**
	             * Remove a series and optionally redraw the chart.
	             *
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart or wait for an explicit call to
	             *         {@link Highcharts.Chart#redraw}.
	             * @param  {AnimationOptions} [animation]
	             *         Whether to apply animation, and optionally animation
	             *         configuration
	             * @param  {Boolean} [withEvent=true]
	             *         Used internally, whether to fire the series `remove` event.
	             *
	             * @sample highcharts/members/series-remove/
	             *         Remove first series from a button
	             */
	            remove: function(redraw, animation, withEvent) {
	                var series = this,
	                    chart = series.chart;
	
	                function remove() {
	
	                    // Destroy elements
	                    series.destroy();
	
	                    // Redraw
	                    chart.isDirtyLegend = chart.isDirtyBox = true;
	                    chart.linkSeries();
	
	                    if (pick(redraw, true)) {
	                        chart.redraw(animation);
	                    }
	                }
	
	                // Fire the event with a default handler of removing the point
	                if (withEvent !== false) {
	                    fireEvent(series, 'remove', null, remove);
	                } else {
	                    remove();
	                }
	            },
	
	            /**
	             * Update the series with a new set of options. For a clean and precise
	             * handling of new options, all methods and elements from the series are
	             * removed, and it is initiated from scratch. Therefore, this method is more
	             * performance expensive than some other utility methods like {@link
	             * Series#setData} or {@link Series#setVisible}.
	             *
	             * @param  {SeriesOptions} options
	             *         New options that will be merged with the series' existing
	             *         options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the series is altered. If doing
	             *         more operations on the chart, it is a good idea to set redraw to
	             *         false and call {@link Chart#redraw} after.
	             *
	             * @sample highcharts/members/series-update/
	             *         Updating series options
	             * @sample maps/members/series-update/
	             *         Update series options in Highmaps
	             */
	            update: function(newOptions, redraw) {
	                var series = this,
	                    chart = series.chart,
	                    // must use user options when changing type because series.options
	                    // is merged in with type specific plotOptions
	                    oldOptions = series.userOptions,
	                    oldType = series.oldType || series.type,
	                    newType = newOptions.type || oldOptions.type || chart.options.chart.type,
	                    proto = seriesTypes[oldType].prototype,
	                    preserve = ['group', 'markerGroup', 'dataLabelsGroup'],
	                    n;
	
	                // Running Series.update to update the data only is an intuitive usage,
	                // so we want to make sure that when used like this, we run the
	                // cheaper setData function and allow animation instead of completely
	                // recreating the series instance.
	                if (Object.keys && Object.keys(newOptions).toString() === 'data') {
	                    return this.setData(newOptions.data, redraw);
	                }
	
	                // If we're changing type or zIndex, create new groups (#3380, #3404)
	                if ((newType && newType !== oldType) || newOptions.zIndex !== undefined) {
	                    preserve.length = 0;
	                }
	
	                // Make sure groups are not destroyed (#3094)
	                each(preserve, function(prop) {
	                    preserve[prop] = series[prop];
	                    delete series[prop];
	                });
	
	                // Do the merge, with some forced options
	                newOptions = merge(oldOptions, {
	                    animation: false,
	                    index: series.index,
	                    pointStart: series.xData[0] // when updating after addPoint
	                }, {
	                    data: series.options.data
	                }, newOptions);
	
	                // Destroy the series and delete all properties. Reinsert all methods
	                // and properties from the new type prototype (#2270, #3719)
	                series.remove(false, null, false);
	                for (n in proto) {
	                    series[n] = undefined;
	                }
	                extend(series, seriesTypes[newType || oldType].prototype);
	
	                // Re-register groups (#3094)
	                each(preserve, function(prop) {
	                    series[prop] = preserve[prop];
	                });
	
	                series.init(chart, newOptions);
	                series.oldType = oldType;
	                chart.linkSeries(); // Links are lost in series.remove (#3028)
	                if (pick(redraw, true)) {
	                    chart.redraw(false);
	                }
	            }
	        });
	
	        // Extend the Axis.prototype for dynamic methods
	        extend(Axis.prototype, /** @lends Highcharts.Axis.prototype */ {
	
	            /**
	             * Update an axis object with a new set of options. The options are merged
	             * with the existing options, so only new or altered options need to be
	             * specified.
	             *
	             * @param  {Object} options
	             *         The new options that will be merged in with existing options on
	             *         the axis.
	             * @sample highcharts/members/axis-update/ Axis update demo
	             */
	            update: function(options, redraw) {
	                var chart = this.chart;
	
	                options = chart.options[this.coll][this.options.index] =
	                    merge(this.userOptions, options);
	
	                this.destroy(true);
	
	                this.init(chart, extend(options, {
	                    events: undefined
	                }));
	
	                chart.isDirtyBox = true;
	                if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Remove the axis from the chart.
	             *
	             * @param {Boolean} [redraw=true] Whether to redraw the chart following the
	             * remove.
	             *
	             * @sample highcharts/members/chart-addaxis/ Add and remove axes
	             */
	            remove: function(redraw) {
	                var chart = this.chart,
	                    key = this.coll, // xAxis or yAxis
	                    axisSeries = this.series,
	                    i = axisSeries.length;
	
	                // Remove associated series (#2687)
	                while (i--) {
	                    if (axisSeries[i]) {
	                        axisSeries[i].remove(false);
	                    }
	                }
	
	                // Remove the axis
	                erase(chart.axes, this);
	                erase(chart[key], this);
	
	                if (isArray(chart.options[key])) {
	                    chart.options[key].splice(this.options.index, 1);
	                } else { // color axis, #6488
	                    delete chart.options[key];
	                }
	
	                each(chart[key], function(axis, i) { // Re-index, #1706
	                    axis.options.index = i;
	                });
	                this.destroy();
	                chart.isDirtyBox = true;
	
	                if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Update the axis title by options after render time.
	             *
	             * @param  {TitleOptions} titleOptions
	             *         The additional title options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after setting the title.
	             * @sample highcharts/members/axis-settitle/ Set a new Y axis title
	             */
	            setTitle: function(titleOptions, redraw) {
	                this.update({
	                    title: titleOptions
	                }, redraw);
	            },
	
	            /**
	             * Set new axis categories and optionally redraw.
	             * @param {Array.<String>} categories - The new categories.
	             * @param {Boolean} [redraw=true] - Whether to redraw the chart.
	             * @sample highcharts/members/axis-setcategories/ Set categories by click on
	             * a button
	             */
	            setCategories: function(categories, redraw) {
	                this.update({
	                    categories: categories
	                }, redraw);
	            }
	
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var color = H.color,
	            each = H.each,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            map = H.map,
	            pick = H.pick,
	            Series = H.Series,
	            seriesType = H.seriesType;
	
	        /**
	         * Area series type.
	         * @constructor seriesTypes.area
	         * @extends {Series}
	         */
	        seriesType('area', 'line', {
	            softThreshold: false,
	            threshold: 0
	            // trackByArea: false,
	            // lineColor: null, // overrides color, but lets fillColor be unaltered
	            // fillOpacity: 0.75,
	            // fillColor: null
	        }, /** @lends seriesTypes.area.prototype */ {
	            singleStacks: false,
	            /** 
	             * Return an array of stacked points, where null and missing points are replaced by 
	             * dummy points in order for gaps to be drawn correctly in stacks.
	             */
	            getStackPoints: function() {
	                var series = this,
	                    segment = [],
	                    keys = [],
	                    xAxis = this.xAxis,
	                    yAxis = this.yAxis,
	                    stack = yAxis.stacks[this.stackKey],
	                    pointMap = {},
	                    points = this.points,
	                    seriesIndex = series.index,
	                    yAxisSeries = yAxis.series,
	                    seriesLength = yAxisSeries.length,
	                    visibleSeries,
	                    upOrDown = pick(yAxis.options.reversedStacks, true) ? 1 : -1,
	                    i;
	
	                if (this.options.stacking) {
	                    // Create a map where we can quickly look up the points by their X value.
	                    for (i = 0; i < points.length; i++) {
	                        pointMap[points[i].x] = points[i];
	                    }
	
	                    // Sort the keys (#1651)
	                    H.objectEach(stack, function(stackX, x) {
	                        if (stackX.total !== null) { // nulled after switching between grouping and not (#1651, #2336)
	                            keys.push(x);
	                        }
	                    });
	                    keys.sort(function(a, b) {
	                        return a - b;
	                    });
	
	                    visibleSeries = map(yAxisSeries, function() {
	                        return this.visible;
	                    });
	
	                    each(keys, function(x, idx) {
	                        var y = 0,
	                            stackPoint,
	                            stackedValues;
	
	                        if (pointMap[x] && !pointMap[x].isNull) {
	                            segment.push(pointMap[x]);
	
	                            // Find left and right cliff. -1 goes left, 1 goes right.
	                            each([-1, 1], function(direction) {
	                                var nullName = direction === 1 ? 'rightNull' : 'leftNull',
	                                    cliffName = direction === 1 ? 'rightCliff' : 'leftCliff',
	                                    cliff = 0,
	                                    otherStack = stack[keys[idx + direction]];
	
	                                // If there is a stack next to this one, to the left or to the right...
	                                if (otherStack) {
	                                    i = seriesIndex;
	                                    while (i >= 0 && i < seriesLength) { // Can go either up or down, depending on reversedStacks
	                                        stackPoint = otherStack.points[i];
	                                        if (!stackPoint) {
	                                            // If the next point in this series is missing, mark the point
	                                            // with point.leftNull or point.rightNull = true.
	                                            if (i === seriesIndex) {
	                                                pointMap[x][nullName] = true;
	
	                                                // If there are missing points in the next stack in any of the 
	                                                // series below this one, we need to substract the missing values
	                                                // and add a hiatus to the left or right.
	                                            } else if (visibleSeries[i]) {
	                                                stackedValues = stack[x].points[i];
	                                                if (stackedValues) {
	                                                    cliff -= stackedValues[1] - stackedValues[0];
	                                                }
	                                            }
	                                        }
	                                        // When reversedStacks is true, loop up, else loop down
	                                        i += upOrDown;
	                                    }
	                                }
	                                pointMap[x][cliffName] = cliff;
	                            });
	
	
	                            // There is no point for this X value in this series, so we 
	                            // insert a dummy point in order for the areas to be drawn
	                            // correctly.
	                        } else {
	
	                            // Loop down the stack to find the series below this one that has
	                            // a value (#1991)
	                            i = seriesIndex;
	                            while (i >= 0 && i < seriesLength) {
	                                stackPoint = stack[x].points[i];
	                                if (stackPoint) {
	                                    y = stackPoint[1];
	                                    break;
	                                }
	                                // When reversedStacks is true, loop up, else loop down
	                                i += upOrDown;
	                            }
	                            y = yAxis.translate(y, 0, 1, 0, 1); // #6272
	                            segment.push({
	                                isNull: true,
	                                plotX: xAxis.translate(x, 0, 0, 0, 1), // #6272
	                                x: x,
	                                plotY: y,
	                                yBottom: y
	                            });
	                        }
	                    });
	
	                }
	
	                return segment;
	            },
	
	            getGraphPath: function(points) {
	                var getGraphPath = Series.prototype.getGraphPath,
	                    graphPath,
	                    options = this.options,
	                    stacking = options.stacking,
	                    yAxis = this.yAxis,
	                    topPath,
	                    //topPoints = [],
	                    bottomPath,
	                    bottomPoints = [],
	                    graphPoints = [],
	                    seriesIndex = this.index,
	                    i,
	                    areaPath,
	                    plotX,
	                    stacks = yAxis.stacks[this.stackKey],
	                    threshold = options.threshold,
	                    translatedThreshold = yAxis.getThreshold(options.threshold),
	                    isNull,
	                    yBottom,
	                    connectNulls = options.connectNulls || stacking === 'percent',
	                    /**
	                     * To display null points in underlying stacked series, this series graph must be 
	                     * broken, and the area also fall down to fill the gap left by the null point. #2069
	                     */
	                    addDummyPoints = function(i, otherI, side) {
	                        var point = points[i],
	                            stackedValues = stacking && stacks[point.x].points[seriesIndex],
	                            nullVal = point[side + 'Null'] || 0,
	                            cliffVal = point[side + 'Cliff'] || 0,
	                            top,
	                            bottom,
	                            isNull = true;
	
	                        if (cliffVal || nullVal) {
	
	                            top = (nullVal ? stackedValues[0] : stackedValues[1]) + cliffVal;
	                            bottom = stackedValues[0] + cliffVal;
	                            isNull = !!nullVal;
	
	                        } else if (!stacking && points[otherI] && points[otherI].isNull) {
	                            top = bottom = threshold;
	                        }
	
	                        // Add to the top and bottom line of the area
	                        if (top !== undefined) {
	                            graphPoints.push({
	                                plotX: plotX,
	                                plotY: top === null ? translatedThreshold : yAxis.getThreshold(top),
	                                isNull: isNull,
	                                isCliff: true
	                            });
	                            bottomPoints.push({
	                                plotX: plotX,
	                                plotY: bottom === null ? translatedThreshold : yAxis.getThreshold(bottom),
	                                doCurve: false // #1041, gaps in areaspline areas
	                            });
	                        }
	                    };
	
	                // Find what points to use
	                points = points || this.points;
	
	                // Fill in missing points
	                if (stacking) {
	                    points = this.getStackPoints();
	                }
	
	                for (i = 0; i < points.length; i++) {
	                    isNull = points[i].isNull;
	                    plotX = pick(points[i].rectPlotX, points[i].plotX);
	                    yBottom = pick(points[i].yBottom, translatedThreshold);
	
	                    if (!isNull || connectNulls) {
	
	                        if (!connectNulls) {
	                            addDummyPoints(i, i - 1, 'left');
	                        }
	
	                        if (!(isNull && !stacking && connectNulls)) { // Skip null point when stacking is false and connectNulls true
	                            graphPoints.push(points[i]);
	                            bottomPoints.push({
	                                x: i,
	                                plotX: plotX,
	                                plotY: yBottom
	                            });
	                        }
	
	                        if (!connectNulls) {
	                            addDummyPoints(i, i + 1, 'right');
	                        }
	                    }
	                }
	
	                topPath = getGraphPath.call(this, graphPoints, true, true);
	
	                bottomPoints.reversed = true;
	                bottomPath = getGraphPath.call(this, bottomPoints, true, true);
	                if (bottomPath.length) {
	                    bottomPath[0] = 'L';
	                }
	
	                areaPath = topPath.concat(bottomPath);
	                graphPath = getGraphPath.call(this, graphPoints, false, connectNulls); // TODO: don't set leftCliff and rightCliff when connectNulls?
	
	                areaPath.xMap = topPath.xMap;
	                this.areaPath = areaPath;
	
	                return graphPath;
	            },
	
	            /**
	             * Draw the graph and the underlying area. This method calls the Series base
	             * function and adds the area. The areaPath is calculated in the getSegmentPath
	             * method called from Series.prototype.drawGraph.
	             */
	            drawGraph: function() {
	
	                // Define or reset areaPath
	                this.areaPath = [];
	
	                // Call the base method
	                Series.prototype.drawGraph.apply(this);
	
	                // Define local variables
	                var series = this,
	                    areaPath = this.areaPath,
	                    options = this.options,
	                    zones = this.zones,
	                    props = [
	                        [
	                            'area',
	                            'highcharts-area',
	
	                            this.color,
	                            options.fillColor
	
	                        ]
	                    ]; // area name, main color, fill color
	
	                each(zones, function(zone, i) {
	                    props.push([
	                        'zone-area-' + i,
	                        'highcharts-area highcharts-zone-area-' + i + ' ' + zone.className,
	
	                        zone.color || series.color,
	                        zone.fillColor || options.fillColor
	
	                    ]);
	                });
	
	                each(props, function(prop) {
	                    var areaKey = prop[0],
	                        area = series[areaKey];
	
	                    // Create or update the area
	                    if (area) { // update
	                        area.endX = areaPath.xMap;
	                        area.animate({
	                            d: areaPath
	                        });
	
	                    } else { // create
	                        area = series[areaKey] = series.chart.renderer.path(areaPath)
	                            .addClass(prop[1])
	                            .attr({
	
	                                fill: pick(
	                                    prop[3],
	                                    color(prop[2]).setOpacity(pick(options.fillOpacity, 0.75)).get()
	                                ),
	
	                                zIndex: 0 // #1069
	                            }).add(series.group);
	                        area.isArea = true;
	                    }
	                    area.startX = areaPath.xMap;
	                    area.shiftUnit = options.step ? 2 : 1;
	                });
	            },
	
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var pick = H.pick,
	            seriesType = H.seriesType;
	
	        /**
	         * Spline series type.
	         * @constructor seriesTypes.spline
	         * @extends {Series}
	         */
	        seriesType('spline', 'line', {}, /** @lends seriesTypes.spline.prototype */ {
	            /**
	             * Get the spline segment from a given point's previous neighbour to the given point
	             */
	            getPointSpline: function(points, point, i) {
	                var smoothing = 1.5, // 1 means control points midway between points, 2 means 1/3 from the point, 3 is 1/4 etc
	                    denom = smoothing + 1,
	                    plotX = point.plotX,
	                    plotY = point.plotY,
	                    lastPoint = points[i - 1],
	                    nextPoint = points[i + 1],
	                    leftContX,
	                    leftContY,
	                    rightContX,
	                    rightContY,
	                    ret;
	
	                function doCurve(otherPoint) {
	                    return otherPoint &&
	                        !otherPoint.isNull &&
	                        otherPoint.doCurve !== false &&
	                        !point.isCliff; // #6387, area splines next to null
	                }
	
	                // Find control points
	                if (doCurve(lastPoint) && doCurve(nextPoint)) {
	                    var lastX = lastPoint.plotX,
	                        lastY = lastPoint.plotY,
	                        nextX = nextPoint.plotX,
	                        nextY = nextPoint.plotY,
	                        correction = 0;
	
	                    leftContX = (smoothing * plotX + lastX) / denom;
	                    leftContY = (smoothing * plotY + lastY) / denom;
	                    rightContX = (smoothing * plotX + nextX) / denom;
	                    rightContY = (smoothing * plotY + nextY) / denom;
	
	                    // Have the two control points make a straight line through main point
	                    if (rightContX !== leftContX) { // #5016, division by zero
	                        correction = ((rightContY - leftContY) * (rightContX - plotX)) /
	                            (rightContX - leftContX) + plotY - rightContY;
	                    }
	
	                    leftContY += correction;
	                    rightContY += correction;
	
	                    // to prevent false extremes, check that control points are between
	                    // neighbouring points' y values
	                    if (leftContY > lastY && leftContY > plotY) {
	                        leftContY = Math.max(lastY, plotY);
	                        rightContY = 2 * plotY - leftContY; // mirror of left control point
	                    } else if (leftContY < lastY && leftContY < plotY) {
	                        leftContY = Math.min(lastY, plotY);
	                        rightContY = 2 * plotY - leftContY;
	                    }
	                    if (rightContY > nextY && rightContY > plotY) {
	                        rightContY = Math.max(nextY, plotY);
	                        leftContY = 2 * plotY - rightContY;
	                    } else if (rightContY < nextY && rightContY < plotY) {
	                        rightContY = Math.min(nextY, plotY);
	                        leftContY = 2 * plotY - rightContY;
	                    }
	
	                    // record for drawing in next point
	                    point.rightContX = rightContX;
	                    point.rightContY = rightContY;
	
	
	                }
	
	                // Visualize control points for debugging
	                /*
	                if (leftContX) {
	                	this.chart.renderer.circle(leftContX + this.chart.plotLeft, leftContY + this.chart.plotTop, 2)
	                		.attr({
	                			stroke: 'red',
	                			'stroke-width': 2,
	                			fill: 'none',
	                			zIndex: 9
	                		})
	                		.add();
	                	this.chart.renderer.path(['M', leftContX + this.chart.plotLeft, leftContY + this.chart.plotTop,
	                		'L', plotX + this.chart.plotLeft, plotY + this.chart.plotTop])
	                		.attr({
	                			stroke: 'red',
	                			'stroke-width': 2,
	                			zIndex: 9
	                		})
	                		.add();
	                }
	                if (rightContX) {
	                	this.chart.renderer.circle(rightContX + this.chart.plotLeft, rightContY + this.chart.plotTop, 2)
	                		.attr({
	                			stroke: 'green',
	                			'stroke-width': 2,
	                			fill: 'none',
	                			zIndex: 9
	                		})
	                		.add();
	                	this.chart.renderer.path(['M', rightContX + this.chart.plotLeft, rightContY + this.chart.plotTop,
	                		'L', plotX + this.chart.plotLeft, plotY + this.chart.plotTop])
	                		.attr({
	                			stroke: 'green',
	                			'stroke-width': 2,
	                			zIndex: 9
	                		})
	                		.add();
	                }
	                // */
	                ret = [
	                    'C',
	                    pick(lastPoint.rightContX, lastPoint.plotX),
	                    pick(lastPoint.rightContY, lastPoint.plotY),
	                    pick(leftContX, plotX),
	                    pick(leftContY, plotY),
	                    plotX,
	                    plotY
	                ];
	                lastPoint.rightContX = lastPoint.rightContY = null; // reset for updating series later
	                return ret;
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var areaProto = H.seriesTypes.area.prototype,
	            defaultPlotOptions = H.defaultPlotOptions,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            seriesType = H.seriesType;
	        /**
	         * AreaSplineSeries object
	         */
	        seriesType('areaspline', 'spline', defaultPlotOptions.area, {
	            getStackPoints: areaProto.getStackPoints,
	            getGraphPath: areaProto.getGraphPath,
	            setStackCliffs: areaProto.setStackCliffs,
	            drawGraph: areaProto.drawGraph,
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var animObject = H.animObject,
	            color = H.color,
	            each = H.each,
	            extend = H.extend,
	            isNumber = H.isNumber,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            merge = H.merge,
	            noop = H.noop,
	            pick = H.pick,
	            Series = H.Series,
	            seriesType = H.seriesType,
	            svg = H.svg;
	        /**
	         * The column series type.
	         *
	         * @constructor seriesTypes.column
	         * @augments Series
	         */
	        seriesType('column', 'line', {
	            borderRadius: 0,
	            //colorByPoint: undefined,
	            crisp: true,
	            groupPadding: 0.2,
	            //grouping: true,
	            marker: null, // point options are specified in the base options
	            pointPadding: 0.1,
	            //pointWidth: null,
	            minPointLength: 0,
	            cropThreshold: 50, // when there are more points, they will not animate out of the chart on xAxis.setExtremes
	            pointRange: null, // null means auto, meaning 1 in a categorized axis and least distance between points if not categories
	            states: {
	                hover: {
	                    halo: false,
	
	                    brightness: 0.1,
	                    shadow: false
	
	                },
	
	                select: {
	                    color: '#cccccc',
	                    borderColor: '#000000',
	                    shadow: false
	                }
	
	            },
	            dataLabels: {
	                align: null, // auto
	                verticalAlign: null, // auto
	                y: null
	            },
	            softThreshold: false,
	            startFromThreshold: true, // false doesn't work well: http://jsfiddle.net/highcharts/hz8fopan/14/
	            stickyTracking: false,
	            tooltip: {
	                distance: 6
	            },
	            threshold: 0,
	
	            borderColor: '#ffffff'
	            // borderWidth: 1
	
	
	        }, /** @lends seriesTypes.column.prototype */ {
	            cropShoulder: 0,
	            directTouch: true, // When tooltip is not shared, this series (and derivatives) requires direct touch/hover. KD-tree does not apply.
	            trackerGroups: ['group', 'dataLabelsGroup'],
	            negStacks: true, // use separate negative stacks, unlike area stacks where a negative
	            // point is substracted from previous (#1910)
	
	            /**
	             * Initialize the series. Extends the basic Series.init method by
	             * marking other series of the same type as dirty.
	             *
	             * @function #init
	             * @memberOf seriesTypes.column
	             * @returns {void}
	             */
	            init: function() {
	                Series.prototype.init.apply(this, arguments);
	
	                var series = this,
	                    chart = series.chart;
	
	                // if the series is added dynamically, force redraw of other
	                // series affected by a new column
	                if (chart.hasRendered) {
	                    each(chart.series, function(otherSeries) {
	                        if (otherSeries.type === series.type) {
	                            otherSeries.isDirty = true;
	                        }
	                    });
	                }
	            },
	
	            /**
	             * Return the width and x offset of the columns adjusted for grouping, groupPadding, pointPadding,
	             * pointWidth etc.
	             */
	            getColumnMetrics: function() {
	
	                var series = this,
	                    options = series.options,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis,
	                    reversedXAxis = xAxis.reversed,
	                    stackKey,
	                    stackGroups = {},
	                    columnCount = 0;
	
	                // Get the total number of column type series.
	                // This is called on every series. Consider moving this logic to a
	                // chart.orderStacks() function and call it on init, addSeries and removeSeries
	                if (options.grouping === false) {
	                    columnCount = 1;
	                } else {
	                    each(series.chart.series, function(otherSeries) {
	                        var otherOptions = otherSeries.options,
	                            otherYAxis = otherSeries.yAxis,
	                            columnIndex;
	                        if (
	                            otherSeries.type === series.type &&
	                            (
	                                otherSeries.visible ||
	                                !series.chart.options.chart.ignoreHiddenSeries
	                            ) &&
	                            yAxis.len === otherYAxis.len &&
	                            yAxis.pos === otherYAxis.pos
	                        ) { // #642, #2086
	                            if (otherOptions.stacking) {
	                                stackKey = otherSeries.stackKey;
	                                if (stackGroups[stackKey] === undefined) {
	                                    stackGroups[stackKey] = columnCount++;
	                                }
	                                columnIndex = stackGroups[stackKey];
	                            } else if (otherOptions.grouping !== false) { // #1162
	                                columnIndex = columnCount++;
	                            }
	                            otherSeries.columnIndex = columnIndex;
	                        }
	                    });
	                }
	
	                var categoryWidth = Math.min(
	                        Math.abs(xAxis.transA) * (xAxis.ordinalSlope || options.pointRange || xAxis.closestPointRange || xAxis.tickInterval || 1), // #2610
	                        xAxis.len // #1535
	                    ),
	                    groupPadding = categoryWidth * options.groupPadding,
	                    groupWidth = categoryWidth - 2 * groupPadding,
	                    pointOffsetWidth = groupWidth / (columnCount || 1),
	                    pointWidth = Math.min(
	                        options.maxPointWidth || xAxis.len,
	                        pick(options.pointWidth, pointOffsetWidth * (1 - 2 * options.pointPadding))
	                    ),
	                    pointPadding = (pointOffsetWidth - pointWidth) / 2,
	                    colIndex = (series.columnIndex || 0) + (reversedXAxis ? 1 : 0), // #1251, #3737
	                    pointXOffset = pointPadding + (groupPadding + colIndex *
	                        pointOffsetWidth - (categoryWidth / 2)) *
	                    (reversedXAxis ? -1 : 1);
	
	                // Save it for reading in linked series (Error bars particularly)
	                series.columnMetrics = {
	                    width: pointWidth,
	                    offset: pointXOffset
	                };
	                return series.columnMetrics;
	
	            },
	
	            /**
	             * Make the columns crisp. The edges are rounded to the nearest full pixel.
	             */
	            crispCol: function(x, y, w, h) {
	                var chart = this.chart,
	                    borderWidth = this.borderWidth,
	                    xCrisp = -(borderWidth % 2 ? 0.5 : 0),
	                    yCrisp = borderWidth % 2 ? 0.5 : 1,
	                    right,
	                    bottom,
	                    fromTop;
	
	                if (chart.inverted && chart.renderer.isVML) {
	                    yCrisp += 1;
	                }
	
	                // Horizontal. We need to first compute the exact right edge, then round it
	                // and compute the width from there.
	                if (this.options.crisp) {
	                    right = Math.round(x + w) + xCrisp;
	                    x = Math.round(x) + xCrisp;
	                    w = right - x;
	                }
	
	                // Vertical
	                bottom = Math.round(y + h) + yCrisp;
	                fromTop = Math.abs(y) <= 0.5 && bottom > 0.5; // #4504, #4656
	                y = Math.round(y) + yCrisp;
	                h = bottom - y;
	
	                // Top edges are exceptions
	                if (fromTop && h) { // #5146
	                    y -= 1;
	                    h += 1;
	                }
	
	                return {
	                    x: x,
	                    y: y,
	                    width: w,
	                    height: h
	                };
	            },
	
	            /**
	             * Translate each point to the plot area coordinate system and find shape positions
	             */
	            translate: function() {
	                var series = this,
	                    chart = series.chart,
	                    options = series.options,
	                    dense = series.dense = series.closestPointRange * series.xAxis.transA < 2,
	                    borderWidth = series.borderWidth = pick(
	                        options.borderWidth,
	                        dense ? 0 : 1 // #3635
	                    ),
	                    yAxis = series.yAxis,
	                    threshold = options.threshold,
	                    translatedThreshold = series.translatedThreshold = yAxis.getThreshold(threshold),
	                    minPointLength = pick(options.minPointLength, 5),
	                    metrics = series.getColumnMetrics(),
	                    pointWidth = metrics.width,
	                    seriesBarW = series.barW = Math.max(pointWidth, 1 + 2 * borderWidth), // postprocessed for border width
	                    pointXOffset = series.pointXOffset = metrics.offset;
	
	                if (chart.inverted) {
	                    translatedThreshold -= 0.5; // #3355
	                }
	
	                // When the pointPadding is 0, we want the columns to be packed tightly, so we allow individual
	                // columns to have individual sizes. When pointPadding is greater, we strive for equal-width
	                // columns (#2694).
	                if (options.pointPadding) {
	                    seriesBarW = Math.ceil(seriesBarW);
	                }
	
	                Series.prototype.translate.apply(series);
	
	                // Record the new values
	                each(series.points, function(point) {
	                    var yBottom = pick(point.yBottom, translatedThreshold),
	                        safeDistance = 999 + Math.abs(yBottom),
	                        plotY = Math.min(Math.max(-safeDistance, point.plotY), yAxis.len + safeDistance), // Don't draw too far outside plot area (#1303, #2241, #4264)
	                        barX = point.plotX + pointXOffset,
	                        barW = seriesBarW,
	                        barY = Math.min(plotY, yBottom),
	                        up,
	                        barH = Math.max(plotY, yBottom) - barY;
	
	                    // Handle options.minPointLength
	                    if (Math.abs(barH) < minPointLength) {
	                        if (minPointLength) {
	                            barH = minPointLength;
	                            up = (!yAxis.reversed && !point.negative) || (yAxis.reversed && point.negative);
	                            barY = Math.abs(barY - translatedThreshold) > minPointLength ? // stacked
	                                yBottom - minPointLength : // keep position
	                                translatedThreshold - (up ? minPointLength : 0); // #1485, #4051
	                        }
	                    }
	
	                    // Cache for access in polar
	                    point.barX = barX;
	                    point.pointWidth = pointWidth;
	
	                    // Fix the tooltip on center of grouped columns (#1216, #424, #3648)
	                    point.tooltipPos = chart.inverted ? [yAxis.len + yAxis.pos - chart.plotLeft - plotY, series.xAxis.len - barX - barW / 2, barH] : [barX + barW / 2, plotY + yAxis.pos - chart.plotTop, barH];
	
	                    // Register shape type and arguments to be used in drawPoints
	                    point.shapeType = 'rect';
	                    point.shapeArgs = series.crispCol.apply(
	                        series,
	                        point.isNull ?
	                        // #3169, drilldown from null must have a position to work from
	                        // #6585, dataLabel should be placed on xAxis, not floating in the middle of the chart
	                        [barX, translatedThreshold, barW, 0] : [barX, barY, barW, barH]
	                    );
	                });
	
	            },
	
	            getSymbol: noop,
	
	            /**
	             * Use a solid rectangle like the area series types
	             */
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle,
	
	
	            /**
	             * Columns have no graph
	             */
	            drawGraph: function() {
	                this.group[this.dense ? 'addClass' : 'removeClass']('highcharts-dense-data');
	            },
	
	
	            /**
	             * Get presentational attributes
	             */
	            pointAttribs: function(point, state) {
	                var options = this.options,
	                    stateOptions,
	                    ret,
	                    p2o = this.pointAttrToOptions || {},
	                    strokeOption = p2o.stroke || 'borderColor',
	                    strokeWidthOption = p2o['stroke-width'] || 'borderWidth',
	                    fill = (point && point.color) || this.color,
	                    stroke = point[strokeOption] || options[strokeOption] ||
	                    this.color || fill, // set to fill when borderColor null
	                    strokeWidth = point[strokeWidthOption] ||
	                    options[strokeWidthOption] || this[strokeWidthOption] || 0,
	                    dashstyle = options.dashStyle,
	                    zone,
	                    brightness;
	
	                // Handle zone colors
	                if (point && this.zones.length) {
	                    zone = point.getZone();
	                    fill = point.options.color || (zone && zone.color) || this.color; // When zones are present, don't use point.color (#4267). Changed order (#6527)
	                }
	
	                // Select or hover states
	                if (state) {
	                    stateOptions = merge(
	                        options.states[state],
	                        point.options.states && point.options.states[state] || {} // #6401
	                    );
	                    brightness = stateOptions.brightness;
	                    fill = stateOptions.color ||
	                        (brightness !== undefined && color(fill).brighten(stateOptions.brightness).get()) ||
	                        fill;
	                    stroke = stateOptions[strokeOption] || stroke;
	                    strokeWidth = stateOptions[strokeWidthOption] || strokeWidth;
	                    dashstyle = stateOptions.dashStyle || dashstyle;
	                }
	
	                ret = {
	                    'fill': fill,
	                    'stroke': stroke,
	                    'stroke-width': strokeWidth
	                };
	                if (options.borderRadius) {
	                    ret.r = options.borderRadius;
	                }
	
	                if (dashstyle) {
	                    ret.dashstyle = dashstyle;
	                }
	
	                return ret;
	            },
	
	
	            /**
	             * Draw the columns. For bars, the series.group is rotated, so the same coordinates
	             * apply for columns and bars. This method is inherited by scatter series.
	             *
	             */
	            drawPoints: function() {
	                var series = this,
	                    chart = this.chart,
	                    options = series.options,
	                    renderer = chart.renderer,
	                    animationLimit = options.animationLimit || 250,
	                    shapeArgs;
	
	                // draw the columns
	                each(series.points, function(point) {
	                    var plotY = point.plotY,
	                        graphic = point.graphic;
	
	                    if (isNumber(plotY) && point.y !== null) {
	                        shapeArgs = point.shapeArgs;
	
	                        if (graphic) { // update
	                            graphic[chart.pointCount < animationLimit ? 'animate' : 'attr'](
	                                merge(shapeArgs)
	                            );
	
	                        } else {
	                            point.graphic = graphic = renderer[point.shapeType](shapeArgs)
	                                .add(point.group || series.group);
	                        }
	
	
	                        // Presentational
	                        graphic
	                            .attr(series.pointAttribs(point, point.selected && 'select'))
	                            .shadow(options.shadow, null, options.stacking && !options.borderRadius);
	
	
	                        graphic.addClass(point.getClassName(), true);
	
	
	                    } else if (graphic) {
	                        point.graphic = graphic.destroy(); // #1269
	                    }
	                });
	            },
	
	            /**
	             * Animate the column heights one by one from zero
	             * @param {Boolean} init Whether to initialize the animation or run it
	             */
	            animate: function(init) {
	                var series = this,
	                    yAxis = this.yAxis,
	                    options = series.options,
	                    inverted = this.chart.inverted,
	                    attr = {},
	                    translatedThreshold;
	
	                if (svg) { // VML is too slow anyway
	                    if (init) {
	                        attr.scaleY = 0.001;
	                        translatedThreshold = Math.min(yAxis.pos + yAxis.len, Math.max(yAxis.pos, yAxis.toPixels(options.threshold)));
	                        if (inverted) {
	                            attr.translateX = translatedThreshold - yAxis.len;
	                        } else {
	                            attr.translateY = translatedThreshold;
	                        }
	                        series.group.attr(attr);
	
	                    } else { // run the animation
	
	                        attr[inverted ? 'translateX' : 'translateY'] = yAxis.pos;
	                        series.group.animate(attr, extend(animObject(series.options.animation), {
	                            // Do the scale synchronously to ensure smooth updating (#5030)
	                            step: function(val, fx) {
	                                series.group.attr({
	                                    scaleY: Math.max(0.001, fx.pos) // #5250
	                                });
	                            }
	                        }));
	
	                        // delete this function to allow it only once
	                        series.animate = null;
	                    }
	                }
	            },
	
	            /**
	             * Remove this series from the chart
	             */
	            remove: function() {
	                var series = this,
	                    chart = series.chart;
	
	                // column and bar series affects other series of the same type
	                // as they are either stacked or grouped
	                if (chart.hasRendered) {
	                    each(chart.series, function(otherSeries) {
	                        if (otherSeries.type === series.type) {
	                            otherSeries.isDirty = true;
	                        }
	                    });
	                }
	
	                Series.prototype.remove.apply(series, arguments);
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var seriesType = H.seriesType;
	
	        /**
	         * The Bar series class
	         */
	        seriesType('bar', 'column', null, {
	            inverted: true
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Series = H.Series,
	            seriesType = H.seriesType;
	        /**
	         * The scatter series type
	         */
	        seriesType('scatter', 'line', {
	            lineWidth: 0,
	            findNearestPointBy: 'xy',
	            marker: {
	                enabled: true // Overrides auto-enabling in line series (#3647)
	            },
	            tooltip: {
	
	                headerFormat: '<span style="color:{point.color}">\u25CF</span> ' +
	                    '<span style="font-size: 0.85em"> {series.name}</span><br/>',
	
	                pointFormat: 'x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>'
	            }
	
	            // Prototype members
	        }, {
	            sorted: false,
	            requireSorting: false,
	            noSharedTooltip: true,
	            trackerGroups: ['group', 'markerGroup', 'dataLabelsGroup'],
	            takeOrdinalPosition: false, // #2342
	            drawGraph: function() {
	                if (this.options.lineWidth) {
	                    Series.prototype.drawGraph.call(this);
	                }
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var pick = H.pick,
	            relativeLength = H.relativeLength;
	
	        H.CenteredSeriesMixin = {
	            /**
	             * Get the center of the pie based on the size and center options relative to the
	             * plot area. Borrowed by the polar and gauge series types.
	             */
	            getCenter: function() {
	
	                var options = this.options,
	                    chart = this.chart,
	                    slicingRoom = 2 * (options.slicedOffset || 0),
	                    handleSlicingRoom,
	                    plotWidth = chart.plotWidth - 2 * slicingRoom,
	                    plotHeight = chart.plotHeight - 2 * slicingRoom,
	                    centerOption = options.center,
	                    positions = [pick(centerOption[0], '50%'), pick(centerOption[1], '50%'), options.size || '100%', options.innerSize || 0],
	                    smallestSize = Math.min(plotWidth, plotHeight),
	                    i,
	                    value;
	
	                for (i = 0; i < 4; ++i) {
	                    value = positions[i];
	                    handleSlicingRoom = i < 2 || (i === 2 && /%$/.test(value));
	
	                    // i == 0: centerX, relative to width
	                    // i == 1: centerY, relative to height
	                    // i == 2: size, relative to smallestSize
	                    // i == 3: innerSize, relative to size
	                    positions[i] = relativeLength(value, [plotWidth, plotHeight, smallestSize, positions[2]][i]) +
	                        (handleSlicingRoom ? slicingRoom : 0);
	
	                }
	                // innerSize cannot be larger than size (#3632)
	                if (positions[3] > positions[2]) {
	                    positions[3] = positions[2];
	                }
	                return positions;
	            }
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            CenteredSeriesMixin = H.CenteredSeriesMixin,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            inArray = H.inArray,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            noop = H.noop,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            seriesType = H.seriesType,
	            seriesTypes = H.seriesTypes,
	            setAnimation = H.setAnimation;
	
	        /**
	         * The pie series type.
	         *
	         * @constructor seriesTypes.pie
	         * @augments Series
	         */
	        seriesType('pie', 'line', {
	            center: [null, null],
	            clip: false,
	            colorByPoint: true, // always true for pies
	            dataLabels: {
	                // align: null,
	                // connectorWidth: 1,
	                // connectorColor: point.color,
	                // connectorPadding: 5,
	                distance: 30,
	                enabled: true,
	                formatter: function() { // #2945
	                    return this.point.isNull ? undefined : this.point.name;
	                },
	                // softConnector: true,
	                x: 0
	                // y: 0
	            },
	            ignoreHiddenPoint: true,
	            //innerSize: 0,
	            legendType: 'point',
	            marker: null, // point options are specified in the base options
	            size: null,
	            showInLegend: false,
	            slicedOffset: 10,
	            stickyTracking: false,
	            tooltip: {
	                followPointer: true
	            },
	
	            borderColor: '#ffffff',
	            borderWidth: 1,
	            states: {
	                hover: {
	                    brightness: 0.1,
	                    shadow: false
	                }
	            }
	
	
	        }, /** @lends seriesTypes.pie.prototype */ {
	            isCartesian: false,
	            requireSorting: false,
	            directTouch: true,
	            noSharedTooltip: true,
	            trackerGroups: ['group', 'dataLabelsGroup'],
	            axisTypes: [],
	            pointAttribs: seriesTypes.column.prototype.pointAttribs,
	            /**
	             * Animate the pies in
	             */
	            animate: function(init) {
	                var series = this,
	                    points = series.points,
	                    startAngleRad = series.startAngleRad;
	
	                if (!init) {
	                    each(points, function(point) {
	                        var graphic = point.graphic,
	                            args = point.shapeArgs;
	
	                        if (graphic) {
	                            // start values
	                            graphic.attr({
	                                r: point.startR || (series.center[3] / 2), // animate from inner radius (#779)
	                                start: startAngleRad,
	                                end: startAngleRad
	                            });
	
	                            // animate
	                            graphic.animate({
	                                r: args.r,
	                                start: args.start,
	                                end: args.end
	                            }, series.options.animation);
	                        }
	                    });
	
	                    // delete this function to allow it only once
	                    series.animate = null;
	                }
	            },
	
	            /**
	             * Recompute total chart sum and update percentages of points.
	             */
	            updateTotals: function() {
	                var i,
	                    total = 0,
	                    points = this.points,
	                    len = points.length,
	                    point,
	                    ignoreHiddenPoint = this.options.ignoreHiddenPoint;
	
	                // Get the total sum
	                for (i = 0; i < len; i++) {
	                    point = points[i];
	                    total += (ignoreHiddenPoint && !point.visible) ?
	                        0 :
	                        point.isNull ? 0 : point.y;
	                }
	                this.total = total;
	
	                // Set each point's properties
	                for (i = 0; i < len; i++) {
	                    point = points[i];
	                    point.percentage = (total > 0 && (point.visible || !ignoreHiddenPoint)) ? point.y / total * 100 : 0;
	                    point.total = total;
	                }
	            },
	
	            /**
	             * Extend the generatePoints method by adding total and percentage properties to each point
	             */
	            generatePoints: function() {
	                Series.prototype.generatePoints.call(this);
	                this.updateTotals();
	            },
	
	            /**
	             * Do translation for pie slices
	             */
	            translate: function(positions) {
	                this.generatePoints();
	
	                var series = this,
	                    cumulative = 0,
	                    precision = 1000, // issue #172
	                    options = series.options,
	                    slicedOffset = options.slicedOffset,
	                    connectorOffset = slicedOffset + (options.borderWidth || 0),
	                    finalConnectorOffset,
	                    start,
	                    end,
	                    angle,
	                    startAngle = options.startAngle || 0,
	                    startAngleRad = series.startAngleRad = Math.PI / 180 * (startAngle - 90),
	                    endAngleRad = series.endAngleRad = Math.PI / 180 * ((pick(options.endAngle, startAngle + 360)) - 90),
	                    circ = endAngleRad - startAngleRad, //2 * Math.PI,
	                    points = series.points,
	                    radiusX, // the x component of the radius vector for a given point
	                    radiusY,
	                    labelDistance = options.dataLabels.distance,
	                    ignoreHiddenPoint = options.ignoreHiddenPoint,
	                    i,
	                    len = points.length,
	                    point;
	
	                // Get positions - either an integer or a percentage string must be given.
	                // If positions are passed as a parameter, we're in a recursive loop for adjusting
	                // space for data labels.
	                if (!positions) {
	                    series.center = positions = series.getCenter();
	                }
	
	                // Utility for getting the x value from a given y, used for anticollision
	                // logic in data labels.
	                // Added point for using specific points' label distance.
	                series.getX = function(y, left, point) {
	                    angle = Math.asin(Math.min((y - positions[1]) / (positions[2] / 2 + point.labelDistance), 1));
	                    return positions[0] +
	                        (left ? -1 : 1) *
	                        (Math.cos(angle) * (positions[2] / 2 + point.labelDistance));
	                };
	
	                // Calculate the geometry for each point
	                for (i = 0; i < len; i++) {
	
	                    point = points[i];
	
	                    // Used for distance calculation for specific point.
	                    point.labelDistance = pick(
	                        point.options.dataLabels && point.options.dataLabels.distance,
	                        labelDistance
	                    );
	
	                    // Saved for later dataLabels distance calculation.
	                    series.maxLabelDistance = Math.max(series.maxLabelDistance || 0, point.labelDistance);
	
	                    // set start and end angle
	                    start = startAngleRad + (cumulative * circ);
	                    if (!ignoreHiddenPoint || point.visible) {
	                        cumulative += point.percentage / 100;
	                    }
	                    end = startAngleRad + (cumulative * circ);
	
	                    // set the shape
	                    point.shapeType = 'arc';
	                    point.shapeArgs = {
	                        x: positions[0],
	                        y: positions[1],
	                        r: positions[2] / 2,
	                        innerR: positions[3] / 2,
	                        start: Math.round(start * precision) / precision,
	                        end: Math.round(end * precision) / precision
	                    };
	
	                    // The angle must stay within -90 and 270 (#2645)
	                    angle = (end + start) / 2;
	                    if (angle > 1.5 * Math.PI) {
	                        angle -= 2 * Math.PI;
	                    } else if (angle < -Math.PI / 2) {
	                        angle += 2 * Math.PI;
	                    }
	
	                    // Center for the sliced out slice
	                    point.slicedTranslation = {
	                        translateX: Math.round(Math.cos(angle) * slicedOffset),
	                        translateY: Math.round(Math.sin(angle) * slicedOffset)
	                    };
	
	                    // set the anchor point for tooltips
	                    radiusX = Math.cos(angle) * positions[2] / 2;
	                    radiusY = Math.sin(angle) * positions[2] / 2;
	                    point.tooltipPos = [
	                        positions[0] + radiusX * 0.7,
	                        positions[1] + radiusY * 0.7
	                    ];
	
	                    point.half = angle < -Math.PI / 2 || angle > Math.PI / 2 ? 1 : 0;
	                    point.angle = angle;
	
	                    // Set the anchor point for data labels. Use point.labelDistance 
	                    // instead of labelDistance // #1174
	                    // finalConnectorOffset - not override connectorOffset value.
	                    finalConnectorOffset = Math.min(connectorOffset, point.labelDistance / 5); // #1678
	                    point.labelPos = [
	                        positions[0] + radiusX + Math.cos(angle) * point.labelDistance, // first break of connector
	                        positions[1] + radiusY + Math.sin(angle) * point.labelDistance, // a/a
	                        positions[0] + radiusX + Math.cos(angle) * finalConnectorOffset, // second break, right outside pie
	                        positions[1] + radiusY + Math.sin(angle) * finalConnectorOffset, // a/a
	                        positions[0] + radiusX, // landing point for connector
	                        positions[1] + radiusY, // a/a
	                        point.labelDistance < 0 ? // alignment
	                        'center' :
	                        point.half ? 'right' : 'left', // alignment
	                        angle // center angle
	                    ];
	
	                }
	            },
	
	            drawGraph: null,
	
	            /**
	             * Draw the data points
	             */
	            drawPoints: function() {
	                var series = this,
	                    chart = series.chart,
	                    renderer = chart.renderer,
	                    groupTranslation,
	                    //center,
	                    graphic,
	                    //group,
	                    pointAttr,
	                    shapeArgs;
	
	
	                var shadow = series.options.shadow;
	                if (shadow && !series.shadowGroup) {
	                    series.shadowGroup = renderer.g('shadow')
	                        .add(series.group);
	                }
	
	
	                // draw the slices
	                each(series.points, function(point) {
	                    if (!point.isNull) {
	                        graphic = point.graphic;
	                        shapeArgs = point.shapeArgs;
	
	
	                        // If the point is sliced, use special translation, else use
	                        // plot area traslation
	                        groupTranslation = point.getTranslate();
	
	
	                        // Put the shadow behind all points
	                        var shadowGroup = point.shadowGroup;
	                        if (shadow && !shadowGroup) {
	                            shadowGroup = point.shadowGroup = renderer.g('shadow')
	                                .add(series.shadowGroup);
	                        }
	
	                        if (shadowGroup) {
	                            shadowGroup.attr(groupTranslation);
	                        }
	                        pointAttr = series.pointAttribs(point, point.selected && 'select');
	
	
	                        // Draw the slice
	                        if (graphic) {
	                            graphic
	                                .setRadialReference(series.center)
	
	                                .attr(pointAttr)
	
	                                .animate(extend(shapeArgs, groupTranslation));
	                        } else {
	
	                            point.graphic = graphic = renderer[point.shapeType](shapeArgs)
	                                .setRadialReference(series.center)
	                                .attr(groupTranslation)
	                                .add(series.group);
	
	                            if (!point.visible) {
	                                graphic.attr({
	                                    visibility: 'hidden'
	                                });
	                            }
	
	
	                            graphic
	                                .attr(pointAttr)
	                                .attr({
	                                    'stroke-linejoin': 'round'
	                                })
	                                .shadow(shadow, shadowGroup);
	
	                        }
	
	                        graphic.addClass(point.getClassName());
	
	                    }
	                });
	
	            },
	
	
	            searchPoint: noop,
	
	            /**
	             * Utility for sorting data labels
	             */
	            sortByAngle: function(points, sign) {
	                points.sort(function(a, b) {
	                    return a.angle !== undefined && (b.angle - a.angle) * sign;
	                });
	            },
	
	            /**
	             * Use a simple symbol from LegendSymbolMixin
	             */
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle,
	
	            /**
	             * Use the getCenter method from drawLegendSymbol
	             */
	            getCenter: CenteredSeriesMixin.getCenter,
	
	            /**
	             * Pies don't have point marker symbols
	             */
	            getSymbol: noop
	
	
	            /**
	             * @constructor seriesTypes.pie.prototype.pointClass
	             * @extends {Point}
	             */
	        }, /** @lends seriesTypes.pie.prototype.pointClass.prototype */ {
	            /**
	             * Initiate the pie slice
	             */
	            init: function() {
	
	                Point.prototype.init.apply(this, arguments);
	
	                var point = this,
	                    toggleSlice;
	
	                point.name = pick(point.name, 'Slice');
	
	                // add event listener for select
	                toggleSlice = function(e) {
	                    point.slice(e.type === 'select');
	                };
	                addEvent(point, 'select', toggleSlice);
	                addEvent(point, 'unselect', toggleSlice);
	
	                return point;
	            },
	
	            /**
	             * Negative points are not valid (#1530, #3623, #5322)
	             */
	            isValid: function() {
	                return H.isNumber(this.y, true) && this.y >= 0;
	            },
	
	            /**
	             * Toggle the visibility of the pie slice
	             * @param {Boolean} vis Whether to show the slice or not. If undefined, the
	             *    visibility is toggled
	             */
	            setVisible: function(vis, redraw) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart,
	                    ignoreHiddenPoint = series.options.ignoreHiddenPoint;
	
	                redraw = pick(redraw, ignoreHiddenPoint);
	
	                if (vis !== point.visible) {
	
	                    // If called without an argument, toggle visibility
	                    point.visible = point.options.visible = vis = vis === undefined ? !point.visible : vis;
	                    series.options.data[inArray(point, series.data)] = point.options; // update userOptions.data
	
	                    // Show and hide associated elements. This is performed regardless of redraw or not,
	                    // because chart.redraw only handles full series.
	                    each(['graphic', 'dataLabel', 'connector', 'shadowGroup'], function(key) {
	                        if (point[key]) {
	                            point[key][vis ? 'show' : 'hide'](true);
	                        }
	                    });
	
	                    if (point.legendItem) {
	                        chart.legend.colorizeItem(point, vis);
	                    }
	
	                    // #4170, hide halo after hiding point
	                    if (!vis && point.state === 'hover') {
	                        point.setState('');
	                    }
	
	                    // Handle ignore hidden slices
	                    if (ignoreHiddenPoint) {
	                        series.isDirty = true;
	                    }
	
	                    if (redraw) {
	                        chart.redraw();
	                    }
	                }
	            },
	
	            /**
	             * Set or toggle whether the slice is cut out from the pie
	             * @param {Boolean} sliced When undefined, the slice state is toggled
	             * @param {Boolean} redraw Whether to redraw the chart. True by default.
	             */
	            slice: function(sliced, redraw, animation) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart;
	
	                setAnimation(animation, chart);
	
	                // redraw is true by default
	                redraw = pick(redraw, true);
	
	                // if called without an argument, toggle
	                point.sliced = point.options.sliced = sliced = defined(sliced) ? sliced : !point.sliced;
	                series.options.data[inArray(point, series.data)] = point.options; // update userOptions.data
	
	                point.graphic.animate(this.getTranslate());
	
	
	                if (point.shadowGroup) {
	                    point.shadowGroup.animate(this.getTranslate());
	                }
	
	            },
	
	            getTranslate: function() {
	                return this.sliced ? this.slicedTranslation : {
	                    translateX: 0,
	                    translateY: 0
	                };
	            },
	
	            haloPath: function(size) {
	                var shapeArgs = this.shapeArgs;
	
	                return this.sliced || !this.visible ? [] :
	                    this.series.chart.renderer.symbols.arc(
	                        shapeArgs.x,
	                        shapeArgs.y,
	                        shapeArgs.r + size,
	                        shapeArgs.r + size, {
	                            innerR: this.shapeArgs.r,
	                            start: shapeArgs.start,
	                            end: shapeArgs.end
	                        }
	                    );
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            arrayMax = H.arrayMax,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            format = H.format,
	            map = H.map,
	            merge = H.merge,
	            noop = H.noop,
	            pick = H.pick,
	            relativeLength = H.relativeLength,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            stableSort = H.stableSort;
	
	
	        /**
	         * Generatl distribution algorithm for distributing labels of differing size along a
	         * confined length in two dimensions. The algorithm takes an array of objects containing
	         * a size, a target and a rank. It will place the labels as close as possible to their 
	         * targets, skipping the lowest ranked labels if necessary.
	         */
	        H.distribute = function(boxes, len) {
	
	            var i,
	                overlapping = true,
	                origBoxes = boxes, // Original array will be altered with added .pos
	                restBoxes = [], // The outranked overshoot
	                box,
	                target,
	                total = 0;
	
	            function sortByTarget(a, b) {
	                return a.target - b.target;
	            }
	
	            // If the total size exceeds the len, remove those boxes with the lowest rank
	            i = boxes.length;
	            while (i--) {
	                total += boxes[i].size;
	            }
	
	            // Sort by rank, then slice away overshoot
	            if (total > len) {
	                stableSort(boxes, function(a, b) {
	                    return (b.rank || 0) - (a.rank || 0);
	                });
	                i = 0;
	                total = 0;
	                while (total <= len) {
	                    total += boxes[i].size;
	                    i++;
	                }
	                restBoxes = boxes.splice(i - 1, boxes.length);
	            }
	
	            // Order by target
	            stableSort(boxes, sortByTarget);
	
	
	            // So far we have been mutating the original array. Now
	            // create a copy with target arrays
	            boxes = map(boxes, function(box) {
	                return {
	                    size: box.size,
	                    targets: [box.target]
	                };
	            });
	
	            while (overlapping) {
	                // Initial positions: target centered in box
	                i = boxes.length;
	                while (i--) {
	                    box = boxes[i];
	                    // Composite box, average of targets
	                    target = (Math.min.apply(0, box.targets) + Math.max.apply(0, box.targets)) / 2;
	                    box.pos = Math.min(Math.max(0, target - box.size / 2), len - box.size);
	                }
	
	                // Detect overlap and join boxes
	                i = boxes.length;
	                overlapping = false;
	                while (i--) {
	                    if (i > 0 && boxes[i - 1].pos + boxes[i - 1].size > boxes[i].pos) { // Overlap
	                        boxes[i - 1].size += boxes[i].size; // Add this size to the previous box
	                        boxes[i - 1].targets = boxes[i - 1].targets.concat(boxes[i].targets);
	
	                        // Overlapping right, push left
	                        if (boxes[i - 1].pos + boxes[i - 1].size > len) {
	                            boxes[i - 1].pos = len - boxes[i - 1].size;
	                        }
	                        boxes.splice(i, 1); // Remove this item
	                        overlapping = true;
	                    }
	                }
	            }
	
	            // Now the composite boxes are placed, we need to put the original boxes within them
	            i = 0;
	            each(boxes, function(box) {
	                var posInCompositeBox = 0;
	                each(box.targets, function() {
	                    origBoxes[i].pos = box.pos + posInCompositeBox;
	                    posInCompositeBox += origBoxes[i].size;
	                    i++;
	                });
	            });
	
	            // Add the rest (hidden) boxes and sort by target
	            origBoxes.push.apply(origBoxes, restBoxes);
	            stableSort(origBoxes, sortByTarget);
	        };
	
	
	        /**
	         * Draw the data labels
	         */
	        Series.prototype.drawDataLabels = function() {
	            var series = this,
	                seriesOptions = series.options,
	                options = seriesOptions.dataLabels,
	                points = series.points,
	                pointOptions,
	                generalOptions,
	                hasRendered = series.hasRendered || 0,
	                str,
	                dataLabelsGroup,
	                defer = pick(options.defer, !!seriesOptions.animation),
	                renderer = series.chart.renderer;
	
	            if (options.enabled || series._hasPointLabels) {
	
	                // Process default alignment of data labels for columns
	                if (series.dlProcessOptions) {
	                    series.dlProcessOptions(options);
	                }
	
	                // Create a separate group for the data labels to avoid rotation
	                dataLabelsGroup = series.plotGroup(
	                    'dataLabelsGroup',
	                    'data-labels',
	                    defer && !hasRendered ? 'hidden' : 'visible', // #5133
	                    options.zIndex || 6
	                );
	
	                if (defer) {
	                    dataLabelsGroup.attr({
	                        opacity: +hasRendered
	                    }); // #3300
	                    if (!hasRendered) {
	                        addEvent(series, 'afterAnimate', function() {
	                            if (series.visible) { // #2597, #3023, #3024
	                                dataLabelsGroup.show(true);
	                            }
	                            dataLabelsGroup[seriesOptions.animation ? 'animate' : 'attr']({
	                                opacity: 1
	                            }, {
	                                duration: 200
	                            });
	                        });
	                    }
	                }
	
	                // Make the labels for each point
	                generalOptions = options;
	                each(points, function(point) {
	                    var enabled,
	                        dataLabel = point.dataLabel,
	                        labelConfig,
	                        attr,
	                        rotation,
	                        connector = point.connector,
	                        isNew = !dataLabel,
	                        style;
	                    // Determine if each data label is enabled
	                    // @note dataLabelAttribs (like pointAttribs) would eradicate
	                    // the need for dlOptions, and simplify the section below.
	                    pointOptions = point.dlOptions || (point.options && point.options.dataLabels); // dlOptions is used in treemaps
	                    enabled = pick(pointOptions && pointOptions.enabled, generalOptions.enabled) && point.y !== null; // #2282, #4641
	                    if (enabled) {
	                        // Create individual options structure that can be extended without
	                        // affecting others
	                        options = merge(generalOptions, pointOptions);
	                        labelConfig = point.getLabelConfig();
	                        str = options.format ?
	                            format(options.format, labelConfig) :
	                            options.formatter.call(labelConfig, options);
	                        style = options.style;
	                        rotation = options.rotation;
	
	                        // Determine the color
	                        style.color = pick(options.color, style.color, series.color, '#000000');
	                        // Get automated contrast color
	                        if (style.color === 'contrast') {
	                            point.contrastColor = renderer.getContrast(point.color || series.color);
	                            style.color = options.inside || pick(point.labelDistance, options.distance) < 0 ||
	                                !!seriesOptions.stacking ? point.contrastColor : '#000000';
	                        }
	                        if (seriesOptions.cursor) {
	                            style.cursor = seriesOptions.cursor;
	                        }
	
	
	                        attr = {
	                            //align: align,
	
	                            fill: options.backgroundColor,
	                            stroke: options.borderColor,
	                            'stroke-width': options.borderWidth,
	
	                            r: options.borderRadius || 0,
	                            rotation: rotation,
	                            padding: options.padding,
	                            zIndex: 1
	                        };
	
	                        // Remove unused attributes (#947)
	                        H.objectEach(attr, function(val, name) {
	                            if (val === undefined) {
	                                delete attr[name];
	                            }
	                        });
	                    }
	                    // If the point is outside the plot area, destroy it. #678, #820
	                    if (dataLabel && (!enabled || !defined(str))) {
	                        point.dataLabel = dataLabel = dataLabel.destroy();
	                        if (connector) {
	                            point.connector = connector.destroy();
	                        }
	                        // Individual labels are disabled if the are explicitly disabled
	                        // in the point options, or if they fall outside the plot area.
	                    } else if (enabled && defined(str)) {
	                        // create new label
	                        if (!dataLabel) {
	                            dataLabel = point.dataLabel = renderer[rotation ? 'text' : 'label']( // labels don't support rotation
	                                str,
	                                0, -9999,
	                                options.shape,
	                                null,
	                                null,
	                                options.useHTML,
	                                null,
	                                'data-label'
	                            );
	                            dataLabel.addClass(
	                                'highcharts-data-label-color-' + point.colorIndex +
	                                ' ' + (options.className || '') +
	                                (options.useHTML ? 'highcharts-tracker' : '') // #3398
	                            );
	                        } else {
	                            attr.text = str;
	                        }
	                        dataLabel.attr(attr);
	
	                        // Styles must be applied before add in order to read text bounding box
	                        dataLabel.css(style).shadow(options.shadow);
	
	
	                        if (!dataLabel.added) {
	                            dataLabel.add(dataLabelsGroup);
	                        }
	                        // Now the data label is created and placed at 0,0, so we need to align it
	                        series.alignDataLabel(point, dataLabel, options, null, isNew);
	                    }
	                });
	            }
	        };
	
	        /**
	         * Align each individual data label
	         */
	        Series.prototype.alignDataLabel = function(point, dataLabel, options, alignTo, isNew) {
	            var chart = this.chart,
	                inverted = chart.inverted,
	                plotX = pick(point.plotX, -9999),
	                plotY = pick(point.plotY, -9999),
	                bBox = dataLabel.getBBox(),
	                fontSize,
	                baseline,
	                rotation = options.rotation,
	                normRotation,
	                negRotation,
	                align = options.align,
	                rotCorr, // rotation correction
	                // Math.round for rounding errors (#2683), alignTo to allow column labels (#2700)
	                visible =
	                this.visible &&
	                (
	                    point.series.forceDL ||
	                    chart.isInsidePlot(plotX, Math.round(plotY), inverted) ||
	                    (
	                        alignTo && chart.isInsidePlot(
	                            plotX,
	                            inverted ? alignTo.x + 1 : alignTo.y + alignTo.height - 1,
	                            inverted
	                        )
	                    )
	                ),
	                alignAttr, // the final position;
	                justify = pick(options.overflow, 'justify') === 'justify';
	
	            if (visible) {
	
	
	                fontSize = options.style.fontSize;
	
	
	                baseline = chart.renderer.fontMetrics(fontSize, dataLabel).b;
	
	                // The alignment box is a singular point
	                alignTo = extend({
	                    x: inverted ? chart.plotWidth - plotY : plotX,
	                    y: Math.round(inverted ? chart.plotHeight - plotX : plotY),
	                    width: 0,
	                    height: 0
	                }, alignTo);
	
	                // Add the text size for alignment calculation
	                extend(options, {
	                    width: bBox.width,
	                    height: bBox.height
	                });
	
	                // Allow a hook for changing alignment in the last moment, then do the alignment
	                if (rotation) {
	                    justify = false; // Not supported for rotated text
	                    rotCorr = chart.renderer.rotCorr(baseline, rotation); // #3723
	                    alignAttr = {
	                        x: alignTo.x + options.x + alignTo.width / 2 + rotCorr.x,
	                        y: alignTo.y + options.y + {
	                            top: 0,
	                            middle: 0.5,
	                            bottom: 1
	                        }[options.verticalAlign] * alignTo.height
	                    };
	                    dataLabel[isNew ? 'attr' : 'animate'](alignAttr)
	                        .attr({ // #3003
	                            align: align
	                        });
	
	                    // Compensate for the rotated label sticking out on the sides
	                    normRotation = (rotation + 720) % 360;
	                    negRotation = normRotation > 180 && normRotation < 360;
	
	                    if (align === 'left') {
	                        alignAttr.y -= negRotation ? bBox.height : 0;
	                    } else if (align === 'center') {
	                        alignAttr.x -= bBox.width / 2;
	                        alignAttr.y -= bBox.height / 2;
	                    } else if (align === 'right') {
	                        alignAttr.x -= bBox.width;
	                        alignAttr.y -= negRotation ? 0 : bBox.height;
	                    }
	
	
	                } else {
	                    dataLabel.align(options, null, alignTo);
	                    alignAttr = dataLabel.alignAttr;
	                }
	
	                // Handle justify or crop
	                if (justify) {
	                    point.isLabelJustified = this.justifyDataLabel(
	                        dataLabel,
	                        options,
	                        alignAttr,
	                        bBox,
	                        alignTo,
	                        isNew
	                    );
	
	                    // Now check that the data label is within the plot area
	                } else if (pick(options.crop, true)) {
	                    visible = chart.isInsidePlot(alignAttr.x, alignAttr.y) && chart.isInsidePlot(alignAttr.x + bBox.width, alignAttr.y + bBox.height);
	                }
	
	                // When we're using a shape, make it possible with a connector or an arrow pointing to thie point
	                if (options.shape && !rotation) {
	                    dataLabel[isNew ? 'attr' : 'animate']({
	                        anchorX: inverted ? chart.plotWidth - point.plotY : point.plotX,
	                        anchorY: inverted ? chart.plotHeight - point.plotX : point.plotY
	                    });
	                }
	            }
	
	            // Show or hide based on the final aligned position
	            if (!visible) {
	                dataLabel.attr({
	                    y: -9999
	                });
	                dataLabel.placed = false; // don't animate back in
	            }
	
	        };
	
	        /**
	         * If data labels fall partly outside the plot area, align them back in, in a way that
	         * doesn't hide the point.
	         */
	        Series.prototype.justifyDataLabel = function(dataLabel, options, alignAttr, bBox, alignTo, isNew) {
	            var chart = this.chart,
	                align = options.align,
	                verticalAlign = options.verticalAlign,
	                off,
	                justified,
	                padding = dataLabel.box ? 0 : (dataLabel.padding || 0);
	
	            // Off left
	            off = alignAttr.x + padding;
	            if (off < 0) {
	                if (align === 'right') {
	                    options.align = 'left';
	                } else {
	                    options.x = -off;
	                }
	                justified = true;
	            }
	
	            // Off right
	            off = alignAttr.x + bBox.width - padding;
	            if (off > chart.plotWidth) {
	                if (align === 'left') {
	                    options.align = 'right';
	                } else {
	                    options.x = chart.plotWidth - off;
	                }
	                justified = true;
	            }
	
	            // Off top
	            off = alignAttr.y + padding;
	            if (off < 0) {
	                if (verticalAlign === 'bottom') {
	                    options.verticalAlign = 'top';
	                } else {
	                    options.y = -off;
	                }
	                justified = true;
	            }
	
	            // Off bottom
	            off = alignAttr.y + bBox.height - padding;
	            if (off > chart.plotHeight) {
	                if (verticalAlign === 'top') {
	                    options.verticalAlign = 'bottom';
	                } else {
	                    options.y = chart.plotHeight - off;
	                }
	                justified = true;
	            }
	
	            if (justified) {
	                dataLabel.placed = !isNew;
	                dataLabel.align(options, null, alignTo);
	            }
	
	            return justified;
	        };
	
	        /**
	         * Override the base drawDataLabels method by pie specific functionality
	         */
	        if (seriesTypes.pie) {
	            seriesTypes.pie.prototype.drawDataLabels = function() {
	                var series = this,
	                    data = series.data,
	                    point,
	                    chart = series.chart,
	                    options = series.options.dataLabels,
	                    connectorPadding = pick(options.connectorPadding, 10),
	                    connectorWidth = pick(options.connectorWidth, 1),
	                    plotWidth = chart.plotWidth,
	                    plotHeight = chart.plotHeight,
	                    connector,
	                    seriesCenter = series.center,
	                    radius = seriesCenter[2] / 2,
	                    centerY = seriesCenter[1],
	                    dataLabel,
	                    dataLabelWidth,
	                    labelPos,
	                    labelHeight,
	                    halves = [ // divide the points into right and left halves for anti collision
	                        [], // right
	                        [] // left
	                    ],
	                    x,
	                    y,
	                    visibility,
	                    j,
	                    overflow = [0, 0, 0, 0]; // top, right, bottom, left
	
	                // get out if not enabled
	                if (!series.visible || (!options.enabled && !series._hasPointLabels)) {
	                    return;
	                }
	
	                // Reset all labels that have been shortened
	                each(data, function(point) {
	                    if (point.dataLabel && point.visible && point.dataLabel.shortened) {
	                        point.dataLabel
	                            .attr({
	                                width: 'auto'
	                            }).css({
	                                width: 'auto',
	                                textOverflow: 'clip'
	                            });
	                        point.dataLabel.shortened = false;
	                    }
	                });
	
	
	                // run parent method
	                Series.prototype.drawDataLabels.apply(series);
	
	                each(data, function(point) {
	                    if (point.dataLabel && point.visible) { // #407, #2510
	
	                        // Arrange points for detection collision
	                        halves[point.half].push(point);
	
	                        // Reset positions (#4905)
	                        point.dataLabel._pos = null;
	                    }
	                });
	
	                /* Loop over the points in each half, starting from the top and bottom
	                 * of the pie to detect overlapping labels.
	                 */
	                each(halves, function(points, i) {
	
	                    var top,
	                        bottom,
	                        length = points.length,
	                        positions = [],
	                        naturalY,
	                        sideOverflow,
	                        positionsIndex, // Point index in positions array.
	                        size;
	
	                    if (!length) {
	                        return;
	                    }
	
	                    // Sort by angle
	                    series.sortByAngle(points, i - 0.5);
	                    // Only do anti-collision when we have dataLabels outside the pie 
	                    // and have connectors. (#856)
	                    if (series.maxLabelDistance > 0) {
	                        top = Math.max(
	                            0,
	                            centerY - radius - series.maxLabelDistance
	                        );
	                        bottom = Math.min(
	                            centerY + radius + series.maxLabelDistance,
	                            chart.plotHeight
	                        );
	                        each(points, function(point) {
	                            // check if specific points' label is outside the pie
	                            if (point.labelDistance > 0 && point.dataLabel) {
	                                // point.top depends on point.labelDistance value
	                                // Used for calculation of y value in getX method 
	                                point.top = Math.max(
	                                    0,
	                                    centerY - radius - point.labelDistance
	                                );
	                                point.bottom = Math.min(
	                                    centerY + radius + point.labelDistance,
	                                    chart.plotHeight
	                                );
	                                size = point.dataLabel.getBBox().height || 21;
	
	                                // point.positionsIndex is needed for getting index of 
	                                // parameter related to specific point inside positions 
	                                // array - not every point is in positions array.
	                                point.positionsIndex = positions.push({
	                                    target: point.labelPos[1] - point.top + size / 2,
	                                    size: size,
	                                    rank: point.y
	                                }) - 1;
	                            }
	                        });
	                        H.distribute(positions, bottom + size - top);
	                    }
	
	                    // Now the used slots are sorted, fill them up sequentially
	                    for (j = 0; j < length; j++) {
	
	                        point = points[j];
	                        positionsIndex = point.positionsIndex;
	                        labelPos = point.labelPos;
	                        dataLabel = point.dataLabel;
	                        visibility = point.visible === false ? 'hidden' : 'inherit';
	                        naturalY = labelPos[1];
	
	                        if (positions && defined(positions[positionsIndex])) {
	                            if (positions[positionsIndex].pos === undefined) {
	                                visibility = 'hidden';
	                            } else {
	                                labelHeight = positions[positionsIndex].size;
	                                y = point.top + positions[positionsIndex].pos;
	                            }
	
	                        } else {
	                            y = naturalY;
	                        }
	
	                        // It is needed to delete point.positionIndex for 
	                        // dynamically added points etc.
	
	                        delete point.positionIndex;
	
	                        // get the x - use the natural x position for labels near the 
	                        // top and bottom, to prevent the top and botton slice connectors 
	                        // from touching each other on either side
	                        if (options.justify) {
	                            x = seriesCenter[0] + (i ? -1 : 1) * (radius + point.labelDistance);
	                        } else {
	                            x = series.getX(y < point.top + 2 || y > point.bottom - 2 ? naturalY : y, i, point);
	                        }
	
	
	                        // Record the placement and visibility
	                        dataLabel._attr = {
	                            visibility: visibility,
	                            align: labelPos[6]
	                        };
	                        dataLabel._pos = {
	                            x: x + options.x +
	                                ({
	                                    left: connectorPadding,
	                                    right: -connectorPadding
	                                }[labelPos[6]] || 0),
	                            y: y + options.y - 10 // 10 is for the baseline (label vs text)
	                        };
	                        labelPos.x = x;
	                        labelPos.y = y;
	
	
	                        // Detect overflowing data labels
	                        dataLabelWidth = dataLabel.getBBox().width;
	
	                        sideOverflow = null;
	                        // Overflow left
	                        if (x - dataLabelWidth < connectorPadding) {
	                            sideOverflow = Math.round(
	                                dataLabelWidth - x + connectorPadding
	                            );
	                            overflow[3] = Math.max(sideOverflow, overflow[3]);
	
	                            // Overflow right
	                        } else if (x + dataLabelWidth > plotWidth - connectorPadding) {
	                            sideOverflow = Math.round(
	                                x + dataLabelWidth - plotWidth + connectorPadding
	                            );
	                            overflow[1] = Math.max(sideOverflow, overflow[1]);
	                        }
	
	                        // Overflow top
	                        if (y - labelHeight / 2 < 0) {
	                            overflow[0] = Math.max(
	                                Math.round(-y + labelHeight / 2),
	                                overflow[0]
	                            );
	
	                            // Overflow left
	                        } else if (y + labelHeight / 2 > plotHeight) {
	                            overflow[2] = Math.max(
	                                Math.round(y + labelHeight / 2 - plotHeight),
	                                overflow[2]
	                            );
	                        }
	                        dataLabel.sideOverflow = sideOverflow;
	                    } // for each point
	                }); // for each half
	
	                // Do not apply the final placement and draw the connectors until we have verified
	                // that labels are not spilling over.
	                if (arrayMax(overflow) === 0 || this.verifyDataLabelOverflow(overflow)) {
	
	                    // Place the labels in the final position
	                    this.placeDataLabels();
	
	                    // Draw the connectors
	                    if (connectorWidth) {
	                        each(this.points, function(point) {
	                            var isNew;
	
	                            connector = point.connector;
	                            dataLabel = point.dataLabel;
	
	                            if (
	                                dataLabel &&
	                                dataLabel._pos &&
	                                point.visible &&
	                                point.labelDistance > 0
	                            ) {
	                                visibility = dataLabel._attr.visibility;
	
	                                isNew = !connector;
	
	                                if (isNew) {
	                                    point.connector = connector = chart.renderer.path()
	                                        .addClass('highcharts-data-label-connector highcharts-color-' + point.colorIndex)
	                                        .add(series.dataLabelsGroup);
	
	
	                                    connector.attr({
	                                        'stroke-width': connectorWidth,
	                                        'stroke': options.connectorColor || point.color || '#666666'
	                                    });
	
	                                }
	                                connector[isNew ? 'attr' : 'animate']({
	                                    d: series.connectorPath(point.labelPos)
	                                });
	                                connector.attr('visibility', visibility);
	
	                            } else if (connector) {
	                                point.connector = connector.destroy();
	                            }
	                        });
	                    }
	                }
	            };
	
	            /**
	             * Extendable method for getting the path of the connector between the data label
	             * and the pie slice.
	             */
	            seriesTypes.pie.prototype.connectorPath = function(labelPos) {
	                var x = labelPos.x,
	                    y = labelPos.y;
	                return pick(this.options.dataLabels.softConnector, true) ? [
	                    'M',
	                    x + (labelPos[6] === 'left' ? 5 : -5), y, // end of the string at the label
	                    'C',
	                    x, y, // first break, next to the label
	                    2 * labelPos[2] - labelPos[4], 2 * labelPos[3] - labelPos[5],
	                    labelPos[2], labelPos[3], // second break
	                    'L',
	                    labelPos[4], labelPos[5] // base
	                ] : [
	                    'M',
	                    x + (labelPos[6] === 'left' ? 5 : -5), y, // end of the string at the label
	                    'L',
	                    labelPos[2], labelPos[3], // second break
	                    'L',
	                    labelPos[4], labelPos[5] // base
	                ];
	            };
	
	            /**
	             * Perform the final placement of the data labels after we have verified that they
	             * fall within the plot area.
	             */
	            seriesTypes.pie.prototype.placeDataLabels = function() {
	                each(this.points, function(point) {
	                    var dataLabel = point.dataLabel,
	                        _pos;
	                    if (dataLabel && point.visible) {
	                        _pos = dataLabel._pos;
	                        if (_pos) {
	
	                            // Shorten data labels with ellipsis if they still overflow
	                            // after the pie has reached minSize (#223).
	                            if (dataLabel.sideOverflow) {
	                                dataLabel._attr.width =
	                                    dataLabel.getBBox().width - dataLabel.sideOverflow;
	                                dataLabel.css({
	                                    width: dataLabel._attr.width + 'px',
	                                    textOverflow: 'ellipsis'
	                                });
	                                dataLabel.shortened = true;
	                            }
	
	                            dataLabel.attr(dataLabel._attr);
	                            dataLabel[dataLabel.moved ? 'animate' : 'attr'](_pos);
	                            dataLabel.moved = true;
	                        } else if (dataLabel) {
	                            dataLabel.attr({
	                                y: -9999
	                            });
	                        }
	                    }
	                }, this);
	            };
	
	            seriesTypes.pie.prototype.alignDataLabel = noop;
	
	            /**
	             * Verify whether the data labels are allowed to draw, or we should run more translation and data
	             * label positioning to keep them inside the plot area. Returns true when data labels are ready
	             * to draw.
	             */
	            seriesTypes.pie.prototype.verifyDataLabelOverflow = function(overflow) {
	
	                var center = this.center,
	                    options = this.options,
	                    centerOption = options.center,
	                    minSize = options.minSize || 80,
	                    newSize = minSize,
	                    // If a size is set, return true and don't try to shrink the pie
	                    // to fit the labels.
	                    ret = options.size !== null;
	
	                if (!ret) {
	                    // Handle horizontal size and center
	                    if (centerOption[0] !== null) { // Fixed center
	                        newSize = Math.max(center[2] -
	                            Math.max(overflow[1], overflow[3]), minSize);
	
	                    } else { // Auto center
	                        newSize = Math.max(
	                            // horizontal overflow
	                            center[2] - overflow[1] - overflow[3],
	                            minSize
	                        );
	                        // horizontal center
	                        center[0] += (overflow[3] - overflow[1]) / 2;
	                    }
	
	                    // Handle vertical size and center
	                    if (centerOption[1] !== null) { // Fixed center
	                        newSize = Math.max(Math.min(newSize, center[2] -
	                            Math.max(overflow[0], overflow[2])), minSize);
	
	                    } else { // Auto center
	                        newSize = Math.max(
	                            Math.min(
	                                newSize,
	                                // vertical overflow
	                                center[2] - overflow[0] - overflow[2]
	                            ),
	                            minSize
	                        );
	                        // vertical center
	                        center[1] += (overflow[0] - overflow[2]) / 2;
	                    }
	
	                    // If the size must be decreased, we need to run translate and
	                    // drawDataLabels again
	                    if (newSize < center[2]) {
	                        center[2] = newSize;
	                        center[3] = Math.min( // #3632
	                            relativeLength(options.innerSize || 0, newSize),
	                            newSize
	                        );
	                        this.translate(center);
	
	                        if (this.drawDataLabels) {
	                            this.drawDataLabels();
	                        }
	                        // Else, return true to indicate that the pie and its labels is
	                        // within the plot area
	                    } else {
	                        ret = true;
	                    }
	                }
	                return ret;
	            };
	        }
	
	        if (seriesTypes.column) {
	
	            /**
	             * Override the basic data label alignment by adjusting for the position of the column
	             */
	            seriesTypes.column.prototype.alignDataLabel = function(point, dataLabel, options, alignTo, isNew) {
	                var inverted = this.chart.inverted,
	                    series = point.series,
	                    dlBox = point.dlBox || point.shapeArgs, // data label box for alignment
	                    below = pick(point.below, point.plotY > pick(this.translatedThreshold, series.yAxis.len)), // point.below is used in range series
	                    inside = pick(options.inside, !!this.options.stacking), // draw it inside the box?
	                    overshoot;
	
	                // Align to the column itself, or the top of it
	                if (dlBox) { // Area range uses this method but not alignTo
	                    alignTo = merge(dlBox);
	
	                    if (alignTo.y < 0) {
	                        alignTo.height += alignTo.y;
	                        alignTo.y = 0;
	                    }
	                    overshoot = alignTo.y + alignTo.height - series.yAxis.len;
	                    if (overshoot > 0) {
	                        alignTo.height -= overshoot;
	                    }
	
	                    if (inverted) {
	                        alignTo = {
	                            x: series.yAxis.len - alignTo.y - alignTo.height,
	                            y: series.xAxis.len - alignTo.x - alignTo.width,
	                            width: alignTo.height,
	                            height: alignTo.width
	                        };
	                    }
	
	                    // Compute the alignment box
	                    if (!inside) {
	                        if (inverted) {
	                            alignTo.x += below ? 0 : alignTo.width;
	                            alignTo.width = 0;
	                        } else {
	                            alignTo.y += below ? alignTo.height : 0;
	                            alignTo.height = 0;
	                        }
	                    }
	                }
	
	
	                // When alignment is undefined (typically columns and bars), display the individual
	                // point below or above the point depending on the threshold
	                options.align = pick(
	                    options.align, !inverted || inside ? 'center' : below ? 'right' : 'left'
	                );
	                options.verticalAlign = pick(
	                    options.verticalAlign,
	                    inverted || inside ? 'middle' : below ? 'top' : 'bottom'
	                );
	
	                // Call the parent method
	                Series.prototype.alignDataLabel.call(this, point, dataLabel, options, alignTo, isNew);
	
	                // If label was justified and we have contrast, set it:
	                if (point.isLabelJustified && point.contrastColor) {
	                    point.dataLabel.css({
	                        color: point.contrastColor
	                    });
	                }
	            };
	        }
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2009-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /**
	         * Highcharts module to hide overlapping data labels. This module is included in
	         * Highcharts.
	         */
	        var Chart = H.Chart,
	            each = H.each,
	            pick = H.pick,
	            addEvent = H.addEvent;
	
	        // Collect potensial overlapping data labels. Stack labels probably don't need
	        // to be considered because they are usually accompanied by data labels that lie
	        // inside the columns.
	        Chart.prototype.callbacks.push(function(chart) {
	            function collectAndHide() {
	                var labels = [];
	
	                each(chart.series || [], function(series) {
	                    var dlOptions = series.options.dataLabels,
	                        // Range series have two collections
	                        collections = series.dataLabelCollections || ['dataLabel'];
	
	                    if (
	                        (dlOptions.enabled || series._hasPointLabels) &&
	                        !dlOptions.allowOverlap &&
	                        series.visible
	                    ) { // #3866
	                        each(collections, function(coll) {
	                            each(series.points, function(point) {
	                                if (point[coll]) {
	                                    point[coll].labelrank = pick(
	                                        point.labelrank,
	                                        point.shapeArgs && point.shapeArgs.height
	                                    ); // #4118
	                                    labels.push(point[coll]);
	                                }
	                            });
	                        });
	                    }
	                });
	                chart.hideOverlappingLabels(labels);
	            }
	
	            // Do it now ...
	            collectAndHide();
	
	            // ... and after each chart redraw
	            addEvent(chart, 'redraw', collectAndHide);
	
	        });
	
	        /**
	         * Hide overlapping labels. Labels are moved and faded in and out on zoom to
	         * provide a smooth visual imression.
	         */
	        Chart.prototype.hideOverlappingLabels = function(labels) {
	
	            var len = labels.length,
	                label,
	                i,
	                j,
	                label1,
	                label2,
	                isIntersecting,
	                pos1,
	                pos2,
	                parent1,
	                parent2,
	                padding,
	                intersectRect = function(x1, y1, w1, h1, x2, y2, w2, h2) {
	                    return !(
	                        x2 > x1 + w1 ||
	                        x2 + w2 < x1 ||
	                        y2 > y1 + h1 ||
	                        y2 + h2 < y1
	                    );
	                };
	
	            // Mark with initial opacity
	            for (i = 0; i < len; i++) {
	                label = labels[i];
	                if (label) {
	                    label.oldOpacity = label.opacity;
	                    label.newOpacity = 1;
	                }
	            }
	
	            // Prevent a situation in a gradually rising slope, that each label will
	            // hide the previous one because the previous one always has lower rank.
	            labels.sort(function(a, b) {
	                return (b.labelrank || 0) - (a.labelrank || 0);
	            });
	
	            // Detect overlapping labels
	            for (i = 0; i < len; i++) {
	                label1 = labels[i];
	
	                for (j = i + 1; j < len; ++j) {
	                    label2 = labels[j];
	                    if (
	                        label1 && label2 &&
	                        label1 !== label2 && // #6465, polar chart with connectEnds
	                        label1.placed && label2.placed &&
	                        label1.newOpacity !== 0 && label2.newOpacity !== 0
	                    ) {
	                        pos1 = label1.alignAttr;
	                        pos2 = label2.alignAttr;
	                        // Different panes have different positions
	                        parent1 = label1.parentGroup;
	                        parent2 = label2.parentGroup;
	                        // Substract the padding if no background or border (#4333)
	                        padding = 2 * (label1.box ? 0 : label1.padding);
	                        isIntersecting = intersectRect(
	                            pos1.x + parent1.translateX,
	                            pos1.y + parent1.translateY,
	                            label1.width - padding,
	                            label1.height - padding,
	                            pos2.x + parent2.translateX,
	                            pos2.y + parent2.translateY,
	                            label2.width - padding,
	                            label2.height - padding
	                        );
	
	                        if (isIntersecting) {
	                            (label1.labelrank < label2.labelrank ? label1 : label2)
	                            .newOpacity = 0;
	                        }
	                    }
	                }
	            }
	
	            // Hide or show
	            each(labels, function(label) {
	                var complete,
	                    newOpacity;
	
	                if (label) {
	                    newOpacity = label.newOpacity;
	
	                    if (label.oldOpacity !== newOpacity && label.placed) {
	
	                        // Make sure the label is completely hidden to avoid catching
	                        // clicks (#4362)
	                        if (newOpacity) {
	                            label.show(true);
	                        } else {
	                            complete = function() {
	                                label.hide();
	                            };
	                        }
	
	                        // Animate or set the opacity					
	                        label.alignAttr.opacity = newOpacity;
	                        label[label.isOld ? 'animate' : 'attr'](
	                            label.alignAttr,
	                            null,
	                            complete
	                        );
	
	                    }
	                    label.isOld = true;
	                }
	            });
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            Chart = H.Chart,
	            createElement = H.createElement,
	            css = H.css,
	            defaultOptions = H.defaultOptions,
	            defaultPlotOptions = H.defaultPlotOptions,
	            each = H.each,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            hasTouch = H.hasTouch,
	            inArray = H.inArray,
	            isObject = H.isObject,
	            Legend = H.Legend,
	            merge = H.merge,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            svg = H.svg,
	            TrackerMixin;
	
	        /**
	         * TrackerMixin for points and graphs.
	         *
	         * @mixin
	         */
	        TrackerMixin = H.TrackerMixin = {
	
	            /**
	             * Draw the tracker for a point.
	             */
	            drawTrackerPoint: function() {
	                var series = this,
	                    chart = series.chart,
	                    pointer = chart.pointer,
	                    onMouseOver = function(e) {
	                        var point = pointer.getPointFromEvent(e);
	                        // undefined on graph in scatterchart
	                        if (point !== undefined) {
	                            pointer.isDirectTouch = true;
	                            point.onMouseOver(e);
	                        }
	                    };
	
	                // Add reference to the point
	                each(series.points, function(point) {
	                    if (point.graphic) {
	                        point.graphic.element.point = point;
	                    }
	                    if (point.dataLabel) {
	                        if (point.dataLabel.div) {
	                            point.dataLabel.div.point = point;
	                        } else {
	                            point.dataLabel.element.point = point;
	                        }
	                    }
	                });
	
	                // Add the event listeners, we need to do this only once
	                if (!series._hasTracking) {
	                    each(series.trackerGroups, function(key) {
	                        if (series[key]) { // we don't always have dataLabelsGroup
	                            series[key]
	                                .addClass('highcharts-tracker')
	                                .on('mouseover', onMouseOver)
	                                .on('mouseout', function(e) {
	                                    pointer.onTrackerMouseOut(e);
	                                });
	                            if (hasTouch) {
	                                series[key].on('touchstart', onMouseOver);
	                            }
	
	
	                            if (series.options.cursor) {
	                                series[key]
	                                    .css(css)
	                                    .css({
	                                        cursor: series.options.cursor
	                                    });
	                            }
	
	                        }
	                    });
	                    series._hasTracking = true;
	                }
	            },
	
	            /**
	             * Draw the tracker object that sits above all data labels and markers to
	             * track mouse events on the graph or points. For the line type charts
	             * the tracker uses the same graphPath, but with a greater stroke width
	             * for better control.
	             */
	            drawTrackerGraph: function() {
	                var series = this,
	                    options = series.options,
	                    trackByArea = options.trackByArea,
	                    trackerPath = [].concat(trackByArea ? series.areaPath : series.graphPath),
	                    trackerPathLength = trackerPath.length,
	                    chart = series.chart,
	                    pointer = chart.pointer,
	                    renderer = chart.renderer,
	                    snap = chart.options.tooltip.snap,
	                    tracker = series.tracker,
	                    i,
	                    onMouseOver = function() {
	                        if (chart.hoverSeries !== series) {
	                            series.onMouseOver();
	                        }
	                    },
	                    /*
	                     * Empirical lowest possible opacities for TRACKER_FILL for an element to stay invisible but clickable
	                     * IE6: 0.002
	                     * IE7: 0.002
	                     * IE8: 0.002
	                     * IE9: 0.00000000001 (unlimited)
	                     * IE10: 0.0001 (exporting only)
	                     * FF: 0.00000000001 (unlimited)
	                     * Chrome: 0.000001
	                     * Safari: 0.000001
	                     * Opera: 0.00000000001 (unlimited)
	                     */
	                    TRACKER_FILL = 'rgba(192,192,192,' + (svg ? 0.0001 : 0.002) + ')';
	
	                // Extend end points. A better way would be to use round linecaps,
	                // but those are not clickable in VML.
	                if (trackerPathLength && !trackByArea) {
	                    i = trackerPathLength + 1;
	                    while (i--) {
	                        if (trackerPath[i] === 'M') { // extend left side
	                            trackerPath.splice(i + 1, 0, trackerPath[i + 1] - snap, trackerPath[i + 2], 'L');
	                        }
	                        if ((i && trackerPath[i] === 'M') || i === trackerPathLength) { // extend right side
	                            trackerPath.splice(i, 0, 'L', trackerPath[i - 2] + snap, trackerPath[i - 1]);
	                        }
	                    }
	                }
	
	                // handle single points
	                /*for (i = 0; i < singlePoints.length; i++) {
	                	singlePoint = singlePoints[i];
	                	trackerPath.push(M, singlePoint.plotX - snap, singlePoint.plotY,
	                	L, singlePoint.plotX + snap, singlePoint.plotY);
	                }*/
	
	                // draw the tracker
	                if (tracker) {
	                    tracker.attr({
	                        d: trackerPath
	                    });
	                } else if (series.graph) { // create
	
	                    series.tracker = renderer.path(trackerPath)
	                        .attr({
	                            'stroke-linejoin': 'round', // #1225
	                            visibility: series.visible ? 'visible' : 'hidden',
	                            stroke: TRACKER_FILL,
	                            fill: trackByArea ? TRACKER_FILL : 'none',
	                            'stroke-width': series.graph.strokeWidth() + (trackByArea ? 0 : 2 * snap),
	                            zIndex: 2
	                        })
	                        .add(series.group);
	
	                    // The tracker is added to the series group, which is clipped, but is covered
	                    // by the marker group. So the marker group also needs to capture events.
	                    each([series.tracker, series.markerGroup], function(tracker) {
	                        tracker.addClass('highcharts-tracker')
	                            .on('mouseover', onMouseOver)
	                            .on('mouseout', function(e) {
	                                pointer.onTrackerMouseOut(e);
	                            });
	
	
	                        if (options.cursor) {
	                            tracker.css({
	                                cursor: options.cursor
	                            });
	                        }
	
	
	                        if (hasTouch) {
	                            tracker.on('touchstart', onMouseOver);
	                        }
	                    });
	                }
	            }
	        };
	        /* End TrackerMixin */
	
	
	        /**
	         * Add tracking event listener to the series group, so the point graphics
	         * themselves act as trackers
	         */
	
	        if (seriesTypes.column) {
	            seriesTypes.column.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	        }
	
	        if (seriesTypes.pie) {
	            seriesTypes.pie.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	        }
	
	        if (seriesTypes.scatter) {
	            seriesTypes.scatter.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	        }
	
	        /*
	         * Extend Legend for item events
	         */
	        extend(Legend.prototype, {
	
	            setItemEvents: function(item, legendItem, useHTML) {
	                var legend = this,
	                    boxWrapper = legend.chart.renderer.boxWrapper,
	                    activeClass = 'highcharts-legend-' + (item.series ? 'point' : 'series') + '-active';
	
	                // Set the events on the item group, or in case of useHTML, the item itself (#1249)
	                (useHTML ? legendItem : item.legendGroup).on('mouseover', function() {
	                        item.setState('hover');
	
	                        // A CSS class to dim or hide other than the hovered series
	                        boxWrapper.addClass(activeClass);
	
	
	                        legendItem.css(legend.options.itemHoverStyle);
	
	                    })
	                    .on('mouseout', function() {
	
	                        legendItem.css(merge(item.visible ? legend.itemStyle : legend.itemHiddenStyle));
	
	
	                        // A CSS class to dim or hide other than the hovered series
	                        boxWrapper.removeClass(activeClass);
	
	                        item.setState();
	                    })
	                    .on('click', function(event) {
	                        var strLegendItemClick = 'legendItemClick',
	                            fnLegendItemClick = function() {
	                                if (item.setVisible) {
	                                    item.setVisible();
	                                }
	                            };
	
	                        // Pass over the click/touch event. #4.
	                        event = {
	                            browserEvent: event
	                        };
	
	                        // click the name or symbol
	                        if (item.firePointEvent) { // point
	                            item.firePointEvent(strLegendItemClick, event, fnLegendItemClick);
	                        } else {
	                            fireEvent(item, strLegendItemClick, event, fnLegendItemClick);
	                        }
	                    });
	            },
	
	            createCheckboxForItem: function(item) {
	                var legend = this;
	
	                item.checkbox = createElement('input', {
	                    type: 'checkbox',
	                    checked: item.selected,
	                    defaultChecked: item.selected // required by IE7
	                }, legend.options.itemCheckboxStyle, legend.chart.container);
	
	                addEvent(item.checkbox, 'click', function(event) {
	                    var target = event.target;
	                    fireEvent(
	                        item.series || item,
	                        'checkboxClick', { // #3712
	                            checked: target.checked,
	                            item: item
	                        },
	                        function() {
	                            item.select();
	                        }
	                    );
	                });
	            }
	        });
	
	
	
	        // Add pointer cursor to legend itemstyle in defaultOptions
	        defaultOptions.legend.itemStyle.cursor = 'pointer';
	
	
	
	        /*
	         * Extend the Chart object with interaction
	         */
	
	        extend(Chart.prototype, /** @lends Chart.prototype */ {
	            /**
	             * Display the zoom button
	             */
	            showResetZoom: function() {
	                var chart = this,
	                    lang = defaultOptions.lang,
	                    btnOptions = chart.options.chart.resetZoomButton,
	                    theme = btnOptions.theme,
	                    states = theme.states,
	                    alignTo = btnOptions.relativeTo === 'chart' ? null : 'plotBox';
	
	                function zoomOut() {
	                    chart.zoomOut();
	                }
	
	                this.resetZoomButton = chart.renderer.button(lang.resetZoom, null, null, zoomOut, theme, states && states.hover)
	                    .attr({
	                        align: btnOptions.position.align,
	                        title: lang.resetZoomTitle
	                    })
	                    .addClass('highcharts-reset-zoom')
	                    .add()
	                    .align(btnOptions.position, false, alignTo);
	
	            },
	
	            /**
	             * Zoom out to 1:1
	             */
	            zoomOut: function() {
	                var chart = this;
	                fireEvent(chart, 'selection', {
	                    resetSelection: true
	                }, function() {
	                    chart.zoom();
	                });
	            },
	
	            /**
	             * Zoom into a given portion of the chart given by axis coordinates
	             * @param {Object} event
	             */
	            zoom: function(event) {
	                var chart = this,
	                    hasZoomed,
	                    pointer = chart.pointer,
	                    displayButton = false,
	                    resetZoomButton;
	
	                // If zoom is called with no arguments, reset the axes
	                if (!event || event.resetSelection) {
	                    each(chart.axes, function(axis) {
	                        hasZoomed = axis.zoom();
	                    });
	                } else { // else, zoom in on all axes
	                    each(event.xAxis.concat(event.yAxis), function(axisData) {
	                        var axis = axisData.axis,
	                            isXAxis = axis.isXAxis;
	
	                        // don't zoom more than minRange
	                        if (pointer[isXAxis ? 'zoomX' : 'zoomY']) {
	                            hasZoomed = axis.zoom(axisData.min, axisData.max);
	                            if (axis.displayBtn) {
	                                displayButton = true;
	                            }
	                        }
	                    });
	                }
	
	                // Show or hide the Reset zoom button
	                resetZoomButton = chart.resetZoomButton;
	                if (displayButton && !resetZoomButton) {
	                    chart.showResetZoom();
	                } else if (!displayButton && isObject(resetZoomButton)) {
	                    chart.resetZoomButton = resetZoomButton.destroy();
	                }
	
	
	                // Redraw
	                if (hasZoomed) {
	                    chart.redraw(
	                        pick(chart.options.chart.animation, event && event.animation, chart.pointCount < 100) // animation
	                    );
	                }
	            },
	
	            /**
	             * Pan the chart by dragging the mouse across the pane. This function is called
	             * on mouse move, and the distance to pan is computed from chartX compared to
	             * the first chartX position in the dragging operation.
	             */
	            pan: function(e, panning) {
	
	                var chart = this,
	                    hoverPoints = chart.hoverPoints,
	                    doRedraw;
	
	                // remove active points for shared tooltip
	                if (hoverPoints) {
	                    each(hoverPoints, function(point) {
	                        point.setState();
	                    });
	                }
	
	                each(panning === 'xy' ? [1, 0] : [1], function(isX) { // xy is used in maps
	                    var axis = chart[isX ? 'xAxis' : 'yAxis'][0],
	                        horiz = axis.horiz,
	                        mousePos = e[horiz ? 'chartX' : 'chartY'],
	                        mouseDown = horiz ? 'mouseDownX' : 'mouseDownY',
	                        startPos = chart[mouseDown],
	                        halfPointRange = (axis.pointRange || 0) / 2,
	                        extremes = axis.getExtremes(),
	                        panMin = axis.toValue(startPos - mousePos, true) +
	                        halfPointRange,
	                        panMax = axis.toValue(startPos + axis.len - mousePos, true) -
	                        halfPointRange,
	                        flipped = panMax < panMin,
	                        newMin = flipped ? panMax : panMin,
	                        newMax = flipped ? panMin : panMax,
	                        paddedMin = Math.min(
	                            extremes.dataMin,
	                            axis.toValue(
	                                axis.toPixels(extremes.min) - axis.minPixelPadding
	                            )
	                        ),
	                        paddedMax = Math.max(
	                            extremes.dataMax,
	                            axis.toValue(
	                                axis.toPixels(extremes.max) + axis.minPixelPadding
	                            )
	                        ),
	                        spill;
	
	                    // If the new range spills over, either to the min or max, adjust
	                    // the new range.
	                    spill = paddedMin - newMin;
	                    if (spill > 0) {
	                        newMax += spill;
	                        newMin = paddedMin;
	                    }
	                    spill = newMax - paddedMax;
	                    if (spill > 0) {
	                        newMax = paddedMax;
	                        newMin -= spill;
	                    }
	
	                    // Set new extremes if they are actually new
	                    if (axis.series.length && newMin !== extremes.min && newMax !== extremes.max) {
	                        axis.setExtremes(
	                            newMin,
	                            newMax,
	                            false,
	                            false, {
	                                trigger: 'pan'
	                            }
	                        );
	                        doRedraw = true;
	                    }
	
	                    chart[mouseDown] = mousePos; // set new reference for next run
	                });
	
	                if (doRedraw) {
	                    chart.redraw(false);
	                }
	                css(chart.container, {
	                    cursor: 'move'
	                });
	            }
	        });
	
	        /*
	         * Extend the Point object with interaction
	         */
	        extend(Point.prototype, /** @lends Highcharts.Point.prototype */ {
	            /**
	             * Toggle the selection status of a point.
	             * @param  {Boolean} [selected]
	             *         When `true`, the point is selected. When `false`, the point is
	             *         unselected. When `null` or `undefined`, the selection state is
	             *         toggled.
	             * @param  {Boolean} [accumulate=false]
	             *         When `true`, the selection is added to other selected points.
	             *         When `false`, other selected points are deselected. Internally in
	             *         Highcharts, when {@link http://api.highcharts.com/highcharts/plotOptions.series.allowPointSelect|allowPointSelect}
	             *         is `true`, selected points are accumulated on Control, Shift or
	             *         Cmd clicking the point.
	             *
	             * @see    Highcharts.Chart#getSelectedPoints
	             *
	             * @sample highcharts/members/point-select/
	             *         Select a point from a button
	             * @sample highcharts/chart/events-selection-points/
	             *         Select a range of points through a drag selection
	             * @sample maps/series/data-id/
	             *         Select a point in Highmaps
	             */
	            select: function(selected, accumulate) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart;
	
	                selected = pick(selected, !point.selected);
	
	                // fire the event with the default handler
	                point.firePointEvent(selected ? 'select' : 'unselect', {
	                    accumulate: accumulate
	                }, function() {
	
	                    /**
	                     * Whether the point is selected or not. 
	                     * @see Highcharts.Point#select
	                     * @memberof Highcharts.Point
	                     * @name selected
	                     * @type {Boolean}
	                     */
	                    point.selected = point.options.selected = selected;
	                    series.options.data[inArray(point, series.data)] = point.options;
	
	                    point.setState(selected && 'select');
	
	                    // unselect all other points unless Ctrl or Cmd + click
	                    if (!accumulate) {
	                        each(chart.getSelectedPoints(), function(loopPoint) {
	                            if (loopPoint.selected && loopPoint !== point) {
	                                loopPoint.selected = loopPoint.options.selected = false;
	                                series.options.data[inArray(loopPoint, series.data)] = loopPoint.options;
	                                loopPoint.setState('');
	                                loopPoint.firePointEvent('unselect');
	                            }
	                        });
	                    }
	                });
	            },
	
	            /**
	             * Runs on mouse over the point
	             * 
	             * @param {Object} e The event arguments
	             */
	            onMouseOver: function(e) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart,
	                    pointer = chart.pointer;
	                e = e ?
	                    pointer.normalize(e) :
	                    // In cases where onMouseOver is called directly without an event
	                    pointer.getChartCoordinatesFromPoint(point, chart.inverted);
	                pointer.runPointActions(e, point);
	            },
	
	            /**
	             * Runs on mouse out from the point
	             */
	            onMouseOut: function() {
	                var point = this,
	                    chart = point.series.chart;
	                point.firePointEvent('mouseOut');
	                each(chart.hoverPoints || [], function(p) {
	                    p.setState();
	                });
	                chart.hoverPoints = chart.hoverPoint = null;
	            },
	
	            /**
	             * Import events from the series' and point's options. Only do it on
	             * demand, to save processing time on hovering.
	             */
	            importEvents: function() {
	                if (!this.hasImportedEvents) {
	                    var point = this,
	                        options = merge(point.series.options.point, point.options),
	                        events = options.events;
	
	                    point.events = events;
	
	                    H.objectEach(events, function(event, eventType) {
	                        addEvent(point, eventType, event);
	                    });
	                    this.hasImportedEvents = true;
	
	                }
	            },
	
	            /**
	             * Set the point's state
	             * @param {String} state
	             */
	            setState: function(state, move) {
	                var point = this,
	                    plotX = Math.floor(point.plotX), // #4586
	                    plotY = point.plotY,
	                    series = point.series,
	                    stateOptions = series.options.states[state] || {},
	                    markerOptions = defaultPlotOptions[series.type].marker &&
	                    series.options.marker,
	                    normalDisabled = markerOptions && markerOptions.enabled === false,
	                    markerStateOptions = (markerOptions && markerOptions.states &&
	                        markerOptions.states[state]) || {},
	                    stateDisabled = markerStateOptions.enabled === false,
	                    stateMarkerGraphic = series.stateMarkerGraphic,
	                    pointMarker = point.marker || {},
	                    chart = series.chart,
	                    halo = series.halo,
	                    haloOptions,
	                    markerAttribs,
	                    hasMarkers = markerOptions && series.markerAttribs,
	                    newSymbol;
	
	                state = state || ''; // empty string
	
	                if (
	                    // already has this state
	                    (state === point.state && !move) ||
	                    // selected points don't respond to hover
	                    (point.selected && state !== 'select') ||
	                    // series' state options is disabled
	                    (stateOptions.enabled === false) ||
	                    // general point marker's state options is disabled
	                    (state && (stateDisabled || (normalDisabled && markerStateOptions.enabled === false))) ||
	                    // individual point marker's state options is disabled
	                    (state && pointMarker.states && pointMarker.states[state] && pointMarker.states[state].enabled === false) // #1610
	
	                ) {
	                    return;
	                }
	
	                if (hasMarkers) {
	                    markerAttribs = series.markerAttribs(point, state);
	                }
	
	                // Apply hover styles to the existing point
	                if (point.graphic) {
	
	                    if (point.state) {
	                        point.graphic.removeClass('highcharts-point-' + point.state);
	                    }
	                    if (state) {
	                        point.graphic.addClass('highcharts-point-' + state);
	                    }
	
	                    /*attribs = radius ? { // new symbol attributes (#507, #612)
	                    	x: plotX - radius,
	                    	y: plotY - radius,
	                    	width: 2 * radius,
	                    	height: 2 * radius
	                    } : {};*/
	
	
	                    //attribs = merge(series.pointAttribs(point, state), attribs);
	                    point.graphic.attr(series.pointAttribs(point, state));
	
	
	                    if (markerAttribs) {
	                        point.graphic.animate(
	                            markerAttribs,
	                            pick(
	                                chart.options.chart.animation, // Turn off globally
	                                markerStateOptions.animation,
	                                markerOptions.animation
	                            )
	                        );
	                    }
	
	                    // Zooming in from a range with no markers to a range with markers
	                    if (stateMarkerGraphic) {
	                        stateMarkerGraphic.hide();
	                    }
	                } else {
	                    // if a graphic is not applied to each point in the normal state, create a shared
	                    // graphic for the hover state
	                    if (state && markerStateOptions) {
	                        newSymbol = pointMarker.symbol || series.symbol;
	
	                        // If the point has another symbol than the previous one, throw away the
	                        // state marker graphic and force a new one (#1459)
	                        if (stateMarkerGraphic && stateMarkerGraphic.currentSymbol !== newSymbol) {
	                            stateMarkerGraphic = stateMarkerGraphic.destroy();
	                        }
	
	                        // Add a new state marker graphic
	                        if (!stateMarkerGraphic) {
	                            if (newSymbol) {
	                                series.stateMarkerGraphic = stateMarkerGraphic = chart.renderer.symbol(
	                                        newSymbol,
	                                        markerAttribs.x,
	                                        markerAttribs.y,
	                                        markerAttribs.width,
	                                        markerAttribs.height
	                                    )
	                                    .add(series.markerGroup);
	                                stateMarkerGraphic.currentSymbol = newSymbol;
	                            }
	
	                            // Move the existing graphic
	                        } else {
	                            stateMarkerGraphic[move ? 'animate' : 'attr']({ // #1054
	                                x: markerAttribs.x,
	                                y: markerAttribs.y
	                            });
	                        }
	
	                        if (stateMarkerGraphic) {
	                            stateMarkerGraphic.attr(series.pointAttribs(point, state));
	                        }
	
	                    }
	
	                    if (stateMarkerGraphic) {
	                        stateMarkerGraphic[state && chart.isInsidePlot(plotX, plotY, chart.inverted) ? 'show' : 'hide'](); // #2450
	                        stateMarkerGraphic.element.point = point; // #4310
	                    }
	                }
	
	                // Show me your halo
	                haloOptions = stateOptions.halo;
	                if (haloOptions && haloOptions.size) {
	                    if (!halo) {
	                        series.halo = halo = chart.renderer.path()
	                            // #5818, #5903, #6705
	                            .add((point.graphic || stateMarkerGraphic).parentGroup);
	                    }
	                    halo[move ? 'animate' : 'attr']({
	                        d: point.haloPath(haloOptions.size)
	                    });
	                    halo.attr({
	                        'class': 'highcharts-halo highcharts-color-' +
	                            pick(point.colorIndex, series.colorIndex)
	                    });
	                    halo.point = point; // #6055
	
	
	                    halo.attr(extend({
	                        'fill': point.color || series.color,
	                        'fill-opacity': haloOptions.opacity,
	                        'zIndex': -1 // #4929, IE8 added halo above everything
	                    }, haloOptions.attributes));
	
	
	                } else if (halo && halo.point && halo.point.haloPath) {
	                    // Animate back to 0 on the current halo point (#6055)
	                    halo.animate({
	                        d: halo.point.haloPath(0)
	                    });
	                }
	
	                point.state = state;
	            },
	
	            /**
	             * Get the circular path definition for the halo
	             * @param  {Number} size The radius of the circular halo.
	             * @returns {Array} The path definition
	             */
	            haloPath: function(size) {
	                var series = this.series,
	                    chart = series.chart;
	
	                return chart.renderer.symbols.circle(
	                    Math.floor(this.plotX) - size,
	                    this.plotY - size,
	                    size * 2,
	                    size * 2
	                );
	            }
	        });
	
	        /*
	         * Extend the Series object with interaction
	         */
	
	        extend(Series.prototype, /** @lends Highcharts.Series.prototype */ {
	            /**
	             * Series mouse over handler
	             */
	            onMouseOver: function() {
	                var series = this,
	                    chart = series.chart,
	                    hoverSeries = chart.hoverSeries;
	
	                // set normal state to previous series
	                if (hoverSeries && hoverSeries !== series) {
	                    hoverSeries.onMouseOut();
	                }
	
	                // trigger the event, but to save processing time,
	                // only if defined
	                if (series.options.events.mouseOver) {
	                    fireEvent(series, 'mouseOver');
	                }
	
	                // hover this
	                series.setState('hover');
	                chart.hoverSeries = series;
	            },
	
	            /**
	             * Series mouse out handler
	             */
	            onMouseOut: function() {
	                // trigger the event only if listeners exist
	                var series = this,
	                    options = series.options,
	                    chart = series.chart,
	                    tooltip = chart.tooltip,
	                    hoverPoint = chart.hoverPoint;
	
	                chart.hoverSeries = null; // #182, set to null before the mouseOut event fires
	
	                // trigger mouse out on the point, which must be in this series
	                if (hoverPoint) {
	                    hoverPoint.onMouseOut();
	                }
	
	                // fire the mouse out event
	                if (series && options.events.mouseOut) {
	                    fireEvent(series, 'mouseOut');
	                }
	
	
	                // hide the tooltip
	                if (tooltip && !series.stickyTracking && (!tooltip.shared || series.noSharedTooltip)) {
	                    tooltip.hide();
	                }
	
	                // set normal state
	                series.setState();
	            },
	
	            /**
	             * Set the state of the graph
	             */
	            setState: function(state) {
	                var series = this,
	                    options = series.options,
	                    graph = series.graph,
	                    stateOptions = options.states,
	                    lineWidth = options.lineWidth,
	                    attribs,
	                    i = 0;
	
	                state = state || '';
	
	                if (series.state !== state) {
	
	                    // Toggle class names
	                    each([
	                        series.group,
	                        series.markerGroup,
	                        series.dataLabelsGroup
	                    ], function(group) {
	                        if (group) {
	                            // Old state
	                            if (series.state) {
	                                group.removeClass('highcharts-series-' + series.state);
	                            }
	                            // New state
	                            if (state) {
	                                group.addClass('highcharts-series-' + state);
	                            }
	                        }
	                    });
	
	                    series.state = state;
	
	
	
	                    if (stateOptions[state] && stateOptions[state].enabled === false) {
	                        return;
	                    }
	
	                    if (state) {
	                        lineWidth = stateOptions[state].lineWidth || lineWidth + (stateOptions[state].lineWidthPlus || 0); // #4035
	                    }
	
	                    if (graph && !graph.dashstyle) { // hover is turned off for dashed lines in VML
	                        attribs = {
	                            'stroke-width': lineWidth
	                        };
	
	                        // Animate the graph stroke-width. By default a quick animation
	                        // to hover, slower to un-hover.
	                        graph.animate(
	                            attribs,
	                            pick(
	                                series.chart.options.chart.animation,
	                                stateOptions[state] && stateOptions[state].animation
	                            )
	                        );
	                        while (series['zone-graph-' + i]) {
	                            series['zone-graph-' + i].attr(attribs);
	                            i = i + 1;
	                        }
	                    }
	
	                }
	            },
	
	            /**
	             * Show or hide the series.
	             *
	             * @param  {Boolean} [visible]
	             *         True to show the series, false to hide. If undefined, the
	             *         visibility is toggled.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the series is altered. If doing
	             *         more operations on the chart, it is a good idea to set redraw to
	             *         false and call {@link Chart#redraw|chart.redraw()} after.
	             */
	            setVisible: function(vis, redraw) {
	                var series = this,
	                    chart = series.chart,
	                    legendItem = series.legendItem,
	                    showOrHide,
	                    ignoreHiddenSeries = chart.options.chart.ignoreHiddenSeries,
	                    oldVisibility = series.visible;
	
	                // if called without an argument, toggle visibility
	                series.visible = vis = series.options.visible = series.userOptions.visible = vis === undefined ? !oldVisibility : vis; // #5618
	                showOrHide = vis ? 'show' : 'hide';
	
	                // show or hide elements
	                each(['group', 'dataLabelsGroup', 'markerGroup', 'tracker', 'tt'], function(key) {
	                    if (series[key]) {
	                        series[key][showOrHide]();
	                    }
	                });
	
	
	                // hide tooltip (#1361)
	                if (chart.hoverSeries === series || (chart.hoverPoint && chart.hoverPoint.series) === series) {
	                    series.onMouseOut();
	                }
	
	
	                if (legendItem) {
	                    chart.legend.colorizeItem(series, vis);
	                }
	
	
	                // rescale or adapt to resized chart
	                series.isDirty = true;
	                // in a stack, all other series are affected
	                if (series.options.stacking) {
	                    each(chart.series, function(otherSeries) {
	                        if (otherSeries.options.stacking && otherSeries.visible) {
	                            otherSeries.isDirty = true;
	                        }
	                    });
	                }
	
	                // show or hide linked series
	                each(series.linkedSeries, function(otherSeries) {
	                    otherSeries.setVisible(vis, false);
	                });
	
	                if (ignoreHiddenSeries) {
	                    chart.isDirtyBox = true;
	                }
	                if (redraw !== false) {
	                    chart.redraw();
	                }
	
	                fireEvent(series, showOrHide);
	            },
	
	            /**
	             * Show the series if hidden.
	             *
	             * @sample highcharts/members/series-hide/
	             *         Toggle visibility from a button
	             */
	            show: function() {
	                this.setVisible(true);
	            },
	
	            /**
	             * Hide the series if visible. If the {@link
	             * https://api.highcharts.com/highcharts/chart.ignoreHiddenSeries|
	             * chart.ignoreHiddenSeries} option is true, the chart is redrawn without
	             * this series.
	             *
	             * @sample highcharts/members/series-hide/
	             *         Toggle visibility from a button
	             */
	            hide: function() {
	                this.setVisible(false);
	            },
	
	
	            /**
	             * Select or unselect the series. This means its {@link
	             * Highcharts.Series.selected|selected} property is set, the checkbox in the
	             * legend is toggled and when selected, the series is returned by the
	             * {@link Highcharts.Chart#getSelectedSeries} function.
	             *
	             * @param  {Boolean} [selected]
	             *         True to select the series, false to unselect. If	undefined, the
	             *         selection state is toggled.
	             *
	             * @sample highcharts/members/series-select/
	             *         Select a series from a button
	             */
	            select: function(selected) {
	                var series = this;
	
	                series.selected = selected = (selected === undefined) ?
	                    !series.selected :
	                    selected;
	
	                if (series.checkbox) {
	                    series.checkbox.checked = selected;
	                }
	
	                fireEvent(series, selected ? 'select' : 'unselect');
	            },
	
	            drawTracker: TrackerMixin.drawTrackerGraph
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Chart = H.Chart,
	            each = H.each,
	            inArray = H.inArray,
	            isArray = H.isArray,
	            isObject = H.isObject,
	            pick = H.pick,
	            splat = H.splat;
	
	        /**
	         * Update the chart based on the current chart/document size and options for
	         * responsiveness.
	         */
	        Chart.prototype.setResponsive = function(redraw) {
	            var options = this.options.responsive,
	                ruleIds = [],
	                currentResponsive = this.currentResponsive,
	                currentRuleIds;
	
	            if (options && options.rules) {
	                each(options.rules, function(rule) {
	                    if (rule._id === undefined) {
	                        rule._id = H.uniqueKey();
	                    }
	
	                    this.matchResponsiveRule(rule, ruleIds, redraw);
	                }, this);
	            }
	
	            // Merge matching rules
	            var mergedOptions = H.merge.apply(0, H.map(ruleIds, function(ruleId) {
	                return H.find(options.rules, function(rule) {
	                    return rule._id === ruleId;
	                }).chartOptions;
	            }));
	
	            // Stringified key for the rules that currently apply.
	            ruleIds = ruleIds.toString() || undefined;
	            currentRuleIds = currentResponsive && currentResponsive.ruleIds;
	
	
	            // Changes in what rules apply
	            if (ruleIds !== currentRuleIds) {
	
	                // Undo previous rules. Before we apply a new set of rules, we need to
	                // roll back completely to base options (#6291).
	                if (currentResponsive) {
	                    this.update(currentResponsive.undoOptions, redraw);
	                }
	
	                if (ruleIds) {
	                    // Get undo-options for matching rules
	                    this.currentResponsive = {
	                        ruleIds: ruleIds,
	                        mergedOptions: mergedOptions,
	                        undoOptions: this.currentOptions(mergedOptions)
	                    };
	
	                    this.update(mergedOptions, redraw);
	
	                } else {
	                    this.currentResponsive = undefined;
	                }
	            }
	        };
	
	        /**
	         * Handle a single responsiveness rule
	         */
	        Chart.prototype.matchResponsiveRule = function(rule, matches) {
	            var condition = rule.condition,
	                fn = condition.callback || function() {
	                    return this.chartWidth <= pick(condition.maxWidth, Number.MAX_VALUE) &&
	                        this.chartHeight <= pick(condition.maxHeight, Number.MAX_VALUE) &&
	                        this.chartWidth >= pick(condition.minWidth, 0) &&
	                        this.chartHeight >= pick(condition.minHeight, 0);
	                };
	
	            if (fn.call(this)) {
	                matches.push(rule._id);
	            }
	
	        };
	
	        /**
	         * Get the current values for a given set of options. Used before we update
	         * the chart with a new responsiveness rule.
	         * TODO: Restore axis options (by id?)
	         */
	        Chart.prototype.currentOptions = function(options) {
	
	            var ret = {};
	
	            /**
	             * Recurse over a set of options and its current values,
	             * and store the current values in the ret object.
	             */
	            function getCurrent(options, curr, ret, depth) {
	                var i;
	                H.objectEach(options, function(val, key) {
	                    if (!depth && inArray(key, ['series', 'xAxis', 'yAxis']) > -1) {
	                        options[key] = splat(options[key]);
	
	                        ret[key] = [];
	
	                        // Iterate over collections like series, xAxis or yAxis and map
	                        // the items by index.
	                        for (i = 0; i < options[key].length; i++) {
	                            if (curr[key][i]) { // Item exists in current data (#6347)
	                                ret[key][i] = {};
	                                getCurrent(
	                                    val[i],
	                                    curr[key][i],
	                                    ret[key][i],
	                                    depth + 1
	                                );
	                            }
	                        }
	                    } else if (isObject(val)) {
	                        ret[key] = isArray(val) ? [] : {};
	                        getCurrent(val, curr[key] || {}, ret[key], depth + 1);
	                    } else {
	                        ret[key] = curr[key] || null;
	                    }
	                });
	            }
	
	            getCurrent(options, this.options, ret, 0);
	            return ret;
	        };
	
	    }(Highcharts));
	    return Highcharts
	}));


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite;
	
	/**
	 * Checks if `value` is a finite primitive number.
	 *
	 * **Note:** This method is based on
	 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a finite number,
	 *  else `false`.
	 * @example
	 *
	 * _.isFinite(3);
	 * // => true
	 *
	 * _.isFinite(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isFinite(Infinity);
	 * // => false
	 *
	 * _.isFinite('3');
	 * // => false
	 */
	function isFinite(value) {
	  return typeof value == 'number' && nativeIsFinite(value);
	}
	
	module.exports = isFinite;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
	function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
	function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
	function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
	function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
	O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
	function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
	W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
	function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
	X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
	ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
	d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
	function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
	var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
	Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
	function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
	g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// custom-data-chart-wsj-0.8.18.min.js